import React, { useState, useEffect, useRef, useCallback } from 'react';
import { GeoCoordinate, AthenaeumConstants, Utility, ServiceProvider, FileModel, StringUtility, BoolUtility, NumberUtility, GeoLocation, TypeConverter, HashCodeUtility, SortDirection } from '@renta-apps/athenaeum-toolkit';
import { BaseComponentLocalizer, BaseComponent, AlertType, BaseInputType, ReactUtility, InputValidationRule, Justify, PageRouteProvider, ch, BaseAsyncComponent, DocumentPreviewModel, DocumentPreviewSize, Align, DescriptionModel, MessageBoxButtons, MessageBoxIcon, DialogResult, PageRoute, StylesUtility, ArrayScope, ActionType, TextAlign, VerticalAlign, DataStorageType, UserInteractionDataStorage, TabBadgeShape, WebApplicationType, SwipeDirection, LinkTarget, PasswordValidationRule } from '@renta-apps/athenaeum-react-common';
import ReactDOM from 'react-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination as Pagination$1 } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import { Dictionary } from 'typescript-collections';
import * as DatePickerLibrary from 'react-datepicker';
import DatePickerLibrary__default, { registerLocale, setDefaultLocale } from 'react-datepicker';
import fi from 'date-fns/locale/fi';
import en from 'date-fns/locale/en-GB';
import pl from 'date-fns/locale/pl';
import sv from 'date-fns/locale/sv';
import nb from 'date-fns/locale/nb';
import da from 'date-fns/locale/da';
import SliderComponent, { createSliderWithTooltip, Range as Range$1 } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { Badge as Badge$1, OverlayTrigger, Tooltip as Tooltip$1 } from 'react-bootstrap';
import queryString from 'query-string';
import 'react-datepicker/dist/react-datepicker.css';
import { QrScanner } from '@yudiel/react-qr-scanner';
import SignatureCanvas from 'react-signature-canvas';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import _ from 'lodash';
import interact from 'interactjs';
import moment from 'moment';
import { Grid as Grid$1 } from 'react-virtualized';
import Cropper from 'react-cropper';
import CropperJs from 'cropperjs';
import 'cropperjs/dist/cropper.css';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var fails$p = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$o = fails$p;

var functionBindNative = !fails$o(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$k = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$3 && FunctionPrototype$2.bind.bind(call$k, call$k);

var functionUncurryThis = NATIVE_BIND$3 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$k.apply(fn, arguments);
  };
};

var uncurryThis$r = functionUncurryThis;

var toString$f = uncurryThis$r({}.toString);
var stringSlice$8 = uncurryThis$r(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$8(toString$f(it), 8, -1);
};

var uncurryThis$q = functionUncurryThis;
var fails$n = fails$p;
var classof$8 = classofRaw$2;

var $Object$4 = Object;
var split = uncurryThis$q(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$n(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$8(it) === 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$7 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$6 = isNullOrUndefined$7;

var $TypeError$f = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$a = function (it) {
  if (isNullOrUndefined$6(it)) throw new $TypeError$f("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$9 = requireObjectCoercible$a;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$9(it));
};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$p =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var shared$4 = {exports: {}};

var global$o = global$p;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$7 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$7(global$o, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$o[key] = value;
  } return value;
};

var global$n = global$p;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$n[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.35.1',
  mode: 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.35.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$8 = requireObjectCoercible$a;

var $Object$3 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$5 = function (argument) {
  return $Object$3(requireObjectCoercible$8(argument));
};

var uncurryThis$p = functionUncurryThis;
var toObject$4 = toObject$5;

var hasOwnProperty = uncurryThis$p({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$4(it), key);
};

var uncurryThis$o = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$e = uncurryThis$o(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$e(++id + postfix, 36);
};

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$m = global$p;
var userAgent$5 = engineUserAgent;

var process$3 = global$m.process;
var Deno$1 = global$m.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$5) {
  match = userAgent$5.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$5.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION$1 = engineV8Version;
var fails$m = fails$p;
var global$l = global$p;

var $String$5 = global$l.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$m(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$2 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$k = global$p;
var shared$3 = shared$4.exports;
var hasOwn$c = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var Symbol$2 = global$k.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$2['for'] || Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$j = function (name) {
  if (!hasOwn$c(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL$1 && hasOwn$c(Symbol$2, name)
      ? Symbol$2[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$n = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$m = isCallable$n;

var isObject$b = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$m(it);
};

var isObject$a = isObject$b;

var $String$4 = String;
var $TypeError$e = TypeError;

// `Assert: Type(argument) is Object`
var anObject$g = function (argument) {
  if (isObject$a(argument)) return argument;
  throw new $TypeError$e($String$4(argument) + ' is not an object');
};

var objectDefineProperties = {};

var fails$l = fails$p;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$l(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var DESCRIPTORS$d = descriptors;
var fails$k = fails$p;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$d && fails$k(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var objectDefineProperty = {};

var global$j = global$p;
var isObject$9 = isObject$b;

var document$3 = global$j.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$9(document$3) && isObject$9(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$c = descriptors;
var fails$j = fails$p;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$c && !fails$j(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var NATIVE_BIND$2 = functionBindNative;

var call$j = Function.prototype.call;

var functionCall = NATIVE_BIND$2 ? call$j.bind(call$j) : function () {
  return call$j.apply(call$j, arguments);
};

var global$i = global$p;
var isCallable$l = isCallable$n;

var aFunction = function (argument) {
  return isCallable$l(argument) ? argument : undefined;
};

var getBuiltIn$7 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$i[namespace]) : global$i[namespace] && global$i[namespace][method];
};

var uncurryThis$n = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$n({}.isPrototypeOf);

var getBuiltIn$6 = getBuiltIn$7;
var isCallable$k = isCallable$n;
var isPrototypeOf$5 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var $Object$2 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$6('Symbol');
  return isCallable$k($Symbol) && isPrototypeOf$5($Symbol.prototype, $Object$2(it));
};

var $String$3 = String;

var tryToString$5 = function (argument) {
  try {
    return $String$3(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$j = isCallable$n;
var tryToString$4 = tryToString$5;

var $TypeError$d = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$9 = function (argument) {
  if (isCallable$j(argument)) return argument;
  throw new $TypeError$d(tryToString$4(argument) + ' is not a function');
};

var aCallable$8 = aCallable$9;
var isNullOrUndefined$5 = isNullOrUndefined$7;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$6 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$5(func) ? undefined : aCallable$8(func);
};

var call$i = functionCall;
var isCallable$i = isCallable$n;
var isObject$8 = isObject$b;

var $TypeError$c = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$i(fn = input.toString) && !isObject$8(val = call$i(fn, input))) return val;
  if (isCallable$i(fn = input.valueOf) && !isObject$8(val = call$i(fn, input))) return val;
  if (pref !== 'string' && isCallable$i(fn = input.toString) && !isObject$8(val = call$i(fn, input))) return val;
  throw new $TypeError$c("Can't convert object to primitive value");
};

var call$h = functionCall;
var isObject$7 = isObject$b;
var isSymbol$1 = isSymbol$2;
var getMethod$5 = getMethod$6;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$i = wellKnownSymbol$j;

var $TypeError$b = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$i('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$7(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$5(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$h(exoticToPrim, input, pref);
    if (!isObject$7(result) || isSymbol$1(result)) return result;
    throw new $TypeError$b("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var DESCRIPTORS$b = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$f = anObject$g;
var toPropertyKey$1 = toPropertyKey$2;

var $TypeError$a = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$b ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$f(O);
  P = toPropertyKey$1(P);
  anObject$f(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$f(O);
  P = toPropertyKey$1(P);
  anObject$f(Attributes);
  if (IE8_DOM_DEFINE$1) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$a('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var ceil = Math.ceil;
var floor$2 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$2 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$4 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$4;

var max$1 = Math.max;
var min$4 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$3(index);
  return integer < 0 ? max$1(integer + length, 0) : min$4(integer, length);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$4;

var min$3 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$5 = function (argument) {
  var len = toIntegerOrInfinity$2(argument);
  return len > 0 ? min$3(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$4 = toLength$5;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$3 = function (obj) {
  return toLength$4(obj.length);
};

var toIndexedObject$4 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$2 = lengthOfArrayLike$3;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$4($this);
    var length = lengthOfArrayLike$2(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var hiddenKeys$4 = {};

var uncurryThis$m = functionUncurryThis;
var hasOwn$b = hasOwnProperty_1;
var toIndexedObject$3 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$3 = hiddenKeys$4;

var push$2 = uncurryThis$m([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$3(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$b(hiddenKeys$3, key) && hasOwn$b(O, key) && push$2(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$b(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$2(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys$1(O, enumBugKeys$2);
};

var DESCRIPTORS$a = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$3 = objectDefineProperty;
var anObject$e = anObject$g;
var toIndexedObject$2 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$a && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$e(O);
  var props = toIndexedObject$2(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$3.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$5 = getBuiltIn$7;

var html$2 = getBuiltIn$5('document', 'documentElement');

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys$1 = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys$1[key] || (keys$1[key] = uid(key));
};

/* global ActiveXObject -- old IE, WSH */
var anObject$d = anObject$g;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys$1 = enumBugKeys$3;
var hiddenKeys$2 = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$2 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$2('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys$1.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys$1[length]];
  return NullProtoObject();
};

hiddenKeys$2[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$d(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$h = wellKnownSymbol$j;
var create$3 = objectCreate;
var defineProperty$6 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$h('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] === undefined) {
  defineProperty$6(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$3(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var global$h = global$p;
var isCallable$h = isCallable$n;

var WeakMap$1 = global$h.WeakMap;

var weakMapBasicDetection = isCallable$h(WeakMap$1) && /native code/.test(String(WeakMap$1));

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var DESCRIPTORS$9 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;

var createNonEnumerableProperty$6 = DESCRIPTORS$9 ? function (object, key, value) {
  return definePropertyModule$2.f(object, key, createPropertyDescriptor$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$g = global$p;
var isObject$6 = isObject$b;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$6;
var hasOwn$a = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$1 = sharedKey$3;
var hiddenKeys$1 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = global$g.TypeError;
var WeakMap = global$g.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$6(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store$1 = shared$1.state || (shared$1.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store$1.get = store$1.get;
  store$1.has = store$1.has;
  store$1.set = store$1.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$1 = function (it, metadata) {
    if (store$1.has(it)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store$1.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store$1.get(it) || {};
  };
  has = function (it) {
    return store$1.has(it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$1[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$a(it, STATE)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$5(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$a(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$a(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var objectGetOwnPropertyDescriptor = {};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$4 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$4 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$4(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var DESCRIPTORS$8 = descriptors;
var call$g = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;
var toIndexedObject$1 = toIndexedObject$5;
var toPropertyKey = toPropertyKey$2;
var hasOwn$9 = hasOwnProperty_1;
var IE8_DOM_DEFINE = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$8 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$1(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$9(O, P)) return createPropertyDescriptor$1(!call$g(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$7 = descriptors;
var hasOwn$8 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$7 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$8(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$7 || (DESCRIPTORS$7 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$l = functionUncurryThis;
var isCallable$g = isCallable$n;
var store = sharedStore;

var functionToString = uncurryThis$l(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$g(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$3 = store.inspectSource;

var uncurryThis$k = functionUncurryThis;
var fails$i = fails$p;
var isCallable$f = isCallable$n;
var hasOwn$7 = hasOwnProperty_1;
var DESCRIPTORS$6 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$2 = internalState;

var enforceInternalState$1 = InternalStateModule$2.enforce;
var getInternalState$2 = InternalStateModule$2.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;
var stringSlice$7 = uncurryThis$k(''.slice);
var replace$5 = uncurryThis$k(''.replace);
var join = uncurryThis$k([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$6 && !fails$i(function () {
  return defineProperty$5(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$7($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$5($String$2(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$7(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$6) defineProperty$5(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$7(options, 'arity') && value.length !== options.arity) {
    defineProperty$5(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$7(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$6) defineProperty$5(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState$1(value);
  if (!hasOwn$7(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$f(this) && getInternalState$2(this).source || inspectSource$2(this);
}, 'toString');

var isCallable$e = isCallable$n;
var definePropertyModule$1 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$8 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$e(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$1.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$3;

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$4 = getBuiltIn$7;
var uncurryThis$j = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$c = anObject$g;

var concat$2 = uncurryThis$j([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$4('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$c(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$6 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$6(target, key) && !(exceptions && hasOwn$6(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$h = fails$p;
var isCallable$d = isCallable$n;

var replacement = /#|\.prototype\./;

var isForced$3 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$d(detection) ? fails$h(detection)
    : !!detection;
};

var normalize = isForced$3.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$3.data = {};
var NATIVE = isForced$3.NATIVE = 'N';
var POLYFILL = isForced$3.POLYFILL = 'P';

var isForced_1 = isForced$3;

var global$f = global$p;
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$6;
var defineBuiltIn$7 = defineBuiltIn$8;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$2 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$f;
  } else if (STATIC) {
    target = global$f[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = global$f[TARGET] && global$f[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$3(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$2(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$4(sourceProperty, 'sham', true);
    }
    defineBuiltIn$7(target, key, sourceProperty, options);
  }
};

var fails$g = fails$p;

var correctPrototypeGetter = !fails$g(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$5 = hasOwnProperty_1;
var isCallable$c = isCallable$n;
var toObject$3 = toObject$5;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject$3(O);
  if (hasOwn$5(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$c(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$f = fails$p;
var isCallable$b = isCallable$n;
var isObject$5 = isObject$b;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$6 = defineBuiltIn$8;
var wellKnownSymbol$g = wellKnownSymbol$j;

var ITERATOR$6 = wellKnownSymbol$g('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$5(IteratorPrototype$2) || fails$f(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$6].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$b(IteratorPrototype$2[ITERATOR$6])) {
  defineBuiltIn$6(IteratorPrototype$2, ITERATOR$6, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$4 = objectDefineProperty.f;
var hasOwn$4 = hasOwnProperty_1;
var wellKnownSymbol$f = wellKnownSymbol$j;

var TO_STRING_TAG$2 = wellKnownSymbol$f('toStringTag');

var setToStringTag$4 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$4(target, TO_STRING_TAG$2)) {
    defineProperty$4(target, TO_STRING_TAG$2, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$2 = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$3 = setToStringTag$4;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$2(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$3(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis$i = functionUncurryThis;
var aCallable$7 = aCallable$9;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$i(aCallable$7(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isObject$4 = isObject$b;

var isPossiblePrototype$1 = function (argument) {
  return isObject$4(argument) || argument === null;
};

var isPossiblePrototype = isPossiblePrototype$1;

var $String$1 = String;
var $TypeError$9 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$9("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var anObject$b = anObject$g;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$b(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$h = _export;
var call$f = functionCall;
var FunctionName = functionName;
var isCallable$a = isCallable$n;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$2 = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$4;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$6;
var defineBuiltIn$5 = defineBuiltIn$8;
var wellKnownSymbol$e = wellKnownSymbol$j;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$2 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$5 = wellKnownSymbol$e('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$5]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$2) {
          setPrototypeOf$2(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$a(CurrentIteratorPrototype[ITERATOR$5])) {
          defineBuiltIn$5(CurrentIteratorPrototype, ITERATOR$5, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$2(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$2 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$3(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$f(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$5(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$h({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$5] !== defaultIterator) {
    defineBuiltIn$5(IterablePrototype, ITERATOR$5, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators$2 = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$3 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS$5 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$5 && values.name !== 'values') try {
  defineProperty$3(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$e = global$p;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$6;
var setToStringTag$1 = setToStringTag$4;
var wellKnownSymbol$d = wellKnownSymbol$j;

var ITERATOR$4 = wellKnownSymbol$d('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$4] !== ArrayValues) try {
      createNonEnumerableProperty$2(CollectionPrototype, ITERATOR$4, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$4] = ArrayValues;
    }
    setToStringTag$1(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$2(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$e[COLLECTION_NAME] && global$e[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

class AthenaeumComponentsConstants extends AthenaeumConstants {}
AthenaeumComponentsConstants.applicationName = "Athenaeum";
// 10 MB
AthenaeumComponentsConstants.maxFileUploadSizeInBytes = 10 * 1024 * 1024;
// 50 MB
AthenaeumComponentsConstants.maxImageRequestSizeInBytes = 50 * 1024 * 1024;
AthenaeumComponentsConstants.imageFileTypes = ["image/gif", "image/jpeg", "image/png"];
AthenaeumComponentsConstants.alertCloseDelay = 5000;
AthenaeumComponentsConstants.alertAnimationDelay = 500;
AthenaeumComponentsConstants.defaultLocation = new GeoCoordinate(60.192059, 24.945831);
// "If user has been signed in more than 15 hours straight throw user out"
AthenaeumComponentsConstants.signOutExpirationTimeOut = 15;
// 255
AthenaeumComponentsConstants.maxTitleDescriptionLength = 255;

//Autogenerated
class AlertLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Initializer
  }
}
//Singleton
var AlertLocalizer$1 = new AlertLocalizer();

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1h = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-alert-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-alert-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-alert-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-alert-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-alert-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-alert-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-alert-alert {\n  padding: 0 !important;\n  width: 100%;\n  display: flex;\n  max-height: calc(100% + 1px);\n  opacity: 1;\n  margin-top: 15px;\n}\n.athenaeum-alert-alert .athenaeum-alert-message {\n  width: 100%;\n  margin: 0.75rem 1.25rem;\n}\n.athenaeum-alert-alert .athenaeum-alert-message .athenaeum-alert-close {\n  float: right;\n  display: inline;\n  vertical-align: top;\n  cursor: pointer;\n  position: relative;\n  width: 21px;\n  height: 21px;\n  margin-right: -10px;\n  opacity: 0.5;\n}\n.athenaeum-alert-alert .athenaeum-alert-message .athenaeum-alert-close:hover {\n  opacity: 1;\n}\n.athenaeum-alert-alert .athenaeum-alert-message .athenaeum-alert-close > span {\n  position: absolute;\n  line-height: 0;\n  font-size: 24px;\n  top: 9px;\n  left: 5px;\n}\n.athenaeum-alert-alert.athenaeum-alert-flyout {\n  position: fixed;\n  top: 46px;\n  border-radius: 0;\n  right: 1px;\n  width: 350px;\n  display: flex;\n  align-items: center;\n  transition: right 0.2s ease-in-out;\n  z-index: 1001;\n  margin: 0 !important;\n}\n.athenaeum-alert-alert.athenaeum-alert-flyout.athenaeum-alert-fadeOut {\n  right: -351px;\n}\n\n.athenaeum-alert-dashboardAlert {\n  max-width: 628px;\n  margin-top: 0;\n  margin-bottom: 4px;\n  text-align: center;\n  background: rgba(234, 60, 0, 0.9);\n  border: none;\n  cursor: default;\n  color: white;\n  border-radius: 5px;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-alert-dashboardAlert {\n    margin: 0 6px 8px 6px;\n  }\n}";
var styles$18 = {"font-renta":"athenaeum-alert-font-renta","color-schema-renta_black":"athenaeum-alert-color-schema-renta_black","color-schema-renta_white":"athenaeum-alert-color-schema-renta_white","color-schema-renta_orange":"athenaeum-alert-color-schema-renta_orange","color-schema-renta_green":"athenaeum-alert-color-schema-renta_green","color-schema-renta_blue":"athenaeum-alert-color-schema-renta_blue","alert":"athenaeum-alert-alert","message":"athenaeum-alert-message","close":"athenaeum-alert-close","flyout":"athenaeum-alert-flyout","fadeOut":"athenaeum-alert-fadeOut","dashboardAlert":"athenaeum-alert-dashboardAlert"};
styleInject(css_248z$1h);

class Alert extends BaseComponent {
  closeAlertAsync(userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onClose) {
        yield this.props.onClose(this, userInteraction);
      }
    });
  }
  closeWithDelayAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield Utility.wait(AthenaeumComponentsConstants.alertCloseDelay);
      this.fadeOut();
      yield this.closeAlertAsync(false);
    });
  }
  fadeOut() {
    const alertNode = this.getNode();
    alertNode.addClass(styles$18.fadeOut);
  }
  getAlertType() {
    switch (this.model.alertType) {
      case AlertType.Success:
        return "alert-success";
      case AlertType.Warning:
        return "alert-warning";
      case AlertType.Danger:
        return "alert-danger";
      case AlertType.Primary:
        return "alert-primary";
      case AlertType.Secondary:
        return "alert-secondary";
      case AlertType.Light:
        return "alert-light";
      case AlertType.Dark:
        return "alert-dark";
      default:
        return "alert-info";
    }
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      if (this.model.autoClose) {
        yield this.closeWithDelayAsync();
      }
    });
  }
  get model() {
    return this.props.model;
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(this.model.flyout && styles$18.flyout, styles$18.alert, "alert", this.getAlertType(), this.props.className)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$18.message
    }, this.model.dismissible && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$18.close),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.closeAlertAsync(true);
      })
    }, /*#__PURE__*/React.createElement("span", null, "\u00D7"))), this.toMultiLines(AlertLocalizer$1.get(this.model.message, ...(this.model.messageParams || [])))));
  }
}

var DESCRIPTORS$4 = descriptors;
var uncurryThis$h = functionUncurryThis;
var call$e = functionCall;
var fails$e = fails$p;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$5;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$2 = Object.defineProperty;
var concat$1 = uncurryThis$h([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$e(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$4 && $assign({ b: 1 }, $assign(defineProperty$2({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$2(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$4 || call$e(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$g = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$g({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

var $$f = _export;
var $includes = arrayIncludes.includes;
var fails$d = fails$p;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$d(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$f({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var isObject$3 = isObject$b;
var classof$7 = classofRaw$2;
var wellKnownSymbol$c = wellKnownSymbol$j;

var MATCH$2 = wellKnownSymbol$c('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$3(it) && ((isRegExp = it[MATCH$2]) !== undefined ? !!isRegExp : classof$7(it) === 'RegExp');
};

var isRegExp$1 = isRegexp;

var $TypeError$8 = TypeError;

var notARegexp = function (it) {
  if (isRegExp$1(it)) {
    throw new $TypeError$8("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$b = wellKnownSymbol$j;

var TO_STRING_TAG$1 = wellKnownSymbol$b('toStringTag');
var test$2 = {};

test$2[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test$2) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$9 = isCallable$n;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$a = wellKnownSymbol$j;

var TO_STRING_TAG = wellKnownSymbol$a('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$6 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) === 'Object' && isCallable$9(O.callee) ? 'Arguments' : result;
};

var classof$5 = classof$6;

var $String = String;

var toString$d = function (argument) {
  if (classof$5(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var wellKnownSymbol$9 = wellKnownSymbol$j;

var MATCH$1 = wellKnownSymbol$9('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$e = _export;
var uncurryThis$g = functionUncurryThis;
var notARegExp$2 = notARegexp;
var requireObjectCoercible$7 = requireObjectCoercible$a;
var toString$c = toString$d;
var correctIsRegExpLogic$2 = correctIsRegexpLogic;

var stringIndexOf$2 = uncurryThis$g(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$e({ target: 'String', proto: true, forced: !correctIsRegExpLogic$2('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$2(
      toString$c(requireObjectCoercible$7(this)),
      toString$c(notARegExp$2(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

var classofRaw = classofRaw$2;
var uncurryThis$f = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$f(fn);
};

var $$d = _export;
var uncurryThis$e = functionUncurryThisClause;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var toLength$3 = toLength$5;
var toString$b = toString$d;
var notARegExp$1 = notARegexp;
var requireObjectCoercible$6 = requireObjectCoercible$a;
var correctIsRegExpLogic$1 = correctIsRegexpLogic;

var stringSlice$6 = uncurryThis$e(''.slice);
var min$2 = Math.min;

var CORRECT_IS_REGEXP_LOGIC$1 = correctIsRegExpLogic$1('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG$1 = !CORRECT_IS_REGEXP_LOGIC$1 && !!function () {
  var descriptor = getOwnPropertyDescriptor$2(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$$d({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG$1 && !CORRECT_IS_REGEXP_LOGIC$1 }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString$b(requireObjectCoercible$6(this));
    notARegExp$1(searchString);
    var index = toLength$3(min$2(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString$b(searchString);
    return stringSlice$6(that, index, index + search.length) === search;
  }
});

// a string of all valid unicode whitespaces
var whitespaces$3 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$d = functionUncurryThis;
var requireObjectCoercible$5 = requireObjectCoercible$a;
var toString$a = toString$d;
var whitespaces$2 = whitespaces$3;

var replace$4 = uncurryThis$d(''.replace);
var ltrim = RegExp('^[' + whitespaces$2 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$2 + '])[' + whitespaces$2 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$1 = function (TYPE) {
  return function ($this) {
    var string = toString$a(requireObjectCoercible$5($this));
    if (TYPE & 1) string = replace$4(string, ltrim, '');
    if (TYPE & 2) string = replace$4(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$1(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$1(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$1(3)
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var fails$c = fails$p;
var whitespaces$1 = whitespaces$3;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$c(function () {
    return !!whitespaces$1[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME$1 && whitespaces$1[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$c = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$c({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

var global$d = global$p;
var classof$4 = classofRaw$2;

var engineIsNode = classof$4(global$d.process) === 'process';

var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty$1 = objectDefineProperty;

var defineBuiltInAccessor$2 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty$1.f(target, name, descriptor);
};

var getBuiltIn$3 = getBuiltIn$7;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$2;
var wellKnownSymbol$8 = wellKnownSymbol$j;
var DESCRIPTORS$3 = descriptors;

var SPECIES$3 = wellKnownSymbol$8('species');

var setSpecies$2 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$3(CONSTRUCTOR_NAME);

  if (DESCRIPTORS$3 && Constructor && !Constructor[SPECIES$3]) {
    defineBuiltInAccessor$1(Constructor, SPECIES$3, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var isPrototypeOf$4 = objectIsPrototypeOf;

var $TypeError$7 = TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf$4(Prototype, it)) return it;
  throw new $TypeError$7('Incorrect invocation');
};

var uncurryThis$c = functionUncurryThis;
var fails$b = fails$p;
var isCallable$8 = isCallable$n;
var classof$3 = classof$6;
var getBuiltIn$2 = getBuiltIn$7;
var inspectSource$1 = inspectSource$3;

var noop = function () { /* empty */ };
var construct = getBuiltIn$2('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$3 = uncurryThis$c(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$8(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$8(argument)) return false;
  switch (classof$3(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$3(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$b(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor = isConstructor$1;
var tryToString$3 = tryToString$5;

var $TypeError$6 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError$6(tryToString$3(argument) + ' is not a constructor');
};

var anObject$a = anObject$g;
var aConstructor = aConstructor$1;
var isNullOrUndefined$4 = isNullOrUndefined$7;
var wellKnownSymbol$7 = wellKnownSymbol$j;

var SPECIES$2 = wellKnownSymbol$7('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$a(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$4(S = anObject$a(C)[SPECIES$2]) ? defaultConstructor : aConstructor(S);
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$2 = FunctionPrototype.apply;
var call$d = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$d.bind(apply$2) : function () {
  return call$d.apply(apply$2, arguments);
});

var uncurryThis$b = functionUncurryThisClause;
var aCallable$6 = aCallable$9;
var NATIVE_BIND = functionBindNative;

var bind$4 = uncurryThis$b(uncurryThis$b.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$6(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$4(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var uncurryThis$a = functionUncurryThis;

var arraySlice$2 = uncurryThis$a([].slice);

var $TypeError$5 = TypeError;

var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw new $TypeError$5('Not enough arguments');
  return passed;
};

var userAgent$4 = engineUserAgent;

// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$4);

var global$c = global$p;
var apply$1 = functionApply;
var bind$3 = functionBindContext;
var isCallable$7 = isCallable$n;
var hasOwn$3 = hasOwnProperty_1;
var fails$a = fails$p;
var html = html$2;
var arraySlice$1 = arraySlice$2;
var createElement = documentCreateElement$2;
var validateArgumentsLength = validateArgumentsLength$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var set = global$c.setImmediate;
var clear = global$c.clearImmediate;
var process$2 = global$c.process;
var Dispatch = global$c.Dispatch;
var Function$1 = global$c.Function;
var MessageChannel = global$c.MessageChannel;
var String$1 = global$c.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails$a(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global$c.location;
});

var run = function (id) {
  if (hasOwn$3(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global$c.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable$7(handler) ? handler : Function$1(handler);
    var args = arraySlice$1(arguments, 1);
    queue$2[++counter] = function () {
      apply$1(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$2[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind$3(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$c.addEventListener &&
    isCallable$7(global$c.postMessage) &&
    !global$c.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails$a(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global$c.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var global$b = global$p;
var DESCRIPTORS$2 = descriptors;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn$1 = function (name) {
  if (!DESCRIPTORS$2) return global$b[name];
  var descriptor = getOwnPropertyDescriptor$1(global$b, name);
  return descriptor && descriptor.value;
};

var Queue$2 = function () {
  this.head = null;
  this.tail = null;
};

Queue$2.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

var queue$1 = Queue$2;

var userAgent$3 = engineUserAgent;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$3) && typeof Pebble != 'undefined';

var userAgent$2 = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent$2);

var global$a = global$p;
var safeGetBuiltIn = safeGetBuiltIn$1;
var bind$2 = functionBindContext;
var macrotask = task$1.set;
var Queue$1 = queue$1;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver$1 = global$a.MutationObserver || global$a.WebKitMutationObserver;
var document$2 = global$a.document;
var process$1 = global$a.process;
var Promise$1 = global$a.Promise;
var microtask$1 = safeGetBuiltIn('queueMicrotask');
var notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask$1) {
  var queue = new Queue$1();

  var flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$1.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify$1();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver$1 && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver$1(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$2(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind$2(macrotask, global$a);
    notify$1 = function () {
      macrotask(flush);
    };
  }

  microtask$1 = function (fn) {
    if (!queue.head) notify$1();
    queue.add(fn);
  };
}

var microtask_1 = microtask$1;

var hostReportErrors$1 = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

var perform$3 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var global$9 = global$p;

var promiseNativeConstructor = global$9.Promise;

/* global Deno -- Deno case */
var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var IS_DENO$1 = engineIsDeno;
var IS_NODE$1 = engineIsNode;

var engineIsBrowser = !IS_DENO$1 && !IS_NODE$1
  && typeof window == 'object'
  && typeof document == 'object';

var global$8 = global$p;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$6 = isCallable$n;
var isForced$1 = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$6 = wellKnownSymbol$j;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION = engineV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES$1 = wellKnownSymbol$6('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$6(global$8.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced$1('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES$1] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$5 = aCallable$9;

var $TypeError$4 = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError$4('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$5(resolve);
  this.reject = aCallable$5(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$b = _export;
var IS_NODE = engineIsNode;
var global$7 = global$p;
var call$c = functionCall;
var defineBuiltIn$4 = defineBuiltIn$8;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag = setToStringTag$4;
var setSpecies$1 = setSpecies$2;
var aCallable$4 = aCallable$9;
var isCallable$5 = isCallable$n;
var isObject$2 = isObject$b;
var anInstance = anInstance$1;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue$1;
var InternalStateModule = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$1 = global$7.TypeError;
var document$1 = global$7.document;
var process = global$7.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$7.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$2(it) && isCallable$5(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError$1('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$c(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$7.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$7['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$c(task, global$7, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$c(task, global$7, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$1 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$c(then, value,
            bind$1(internalResolve, wrapper, state),
            bind$1(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable$4(executor);
    call$c(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$1(internalResolve, state), bind$1(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$4(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$5(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$5(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$1(internalResolve, state);
    this.reject = bind$1(internalReject, state);
  };

  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$5(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$4(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$c(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf$1) {
      setPrototypeOf$1(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

$$b({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies$1(PROMISE);

var wellKnownSymbol$5 = wellKnownSymbol$j;
var Iterators$1 = iterators;

var ITERATOR$3 = wellKnownSymbol$5('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$3] === it);
};

var classof$2 = classof$6;
var getMethod$4 = getMethod$6;
var isNullOrUndefined$3 = isNullOrUndefined$7;
var Iterators = iterators;
var wellKnownSymbol$4 = wellKnownSymbol$j;

var ITERATOR$2 = wellKnownSymbol$4('iterator');

var getIteratorMethod$2 = function (it) {
  if (!isNullOrUndefined$3(it)) return getMethod$4(it, ITERATOR$2)
    || getMethod$4(it, '@@iterator')
    || Iterators[classof$2(it)];
};

var call$b = functionCall;
var aCallable$3 = aCallable$9;
var anObject$9 = anObject$g;
var tryToString$2 = tryToString$5;
var getIteratorMethod$1 = getIteratorMethod$2;

var $TypeError$3 = TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable$3(iteratorMethod)) return anObject$9(call$b(iteratorMethod, argument));
  throw new $TypeError$3(tryToString$2(argument) + ' is not iterable');
};

var call$a = functionCall;
var anObject$8 = anObject$g;
var getMethod$3 = getMethod$6;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$8(iterator);
  try {
    innerResult = getMethod$3(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$a(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$8(innerResult);
  return value;
};

var bind = functionBindContext;
var call$9 = functionCall;
var anObject$7 = anObject$g;
var tryToString$1 = tryToString$5;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike$1 = lengthOfArrayLike$3;
var isPrototypeOf$3 = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var iteratorClose = iteratorClose$1;

var $TypeError$2 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$2 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$7(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError$2(tryToString$1(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$1(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$3(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$9(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$3(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$3 = wellKnownSymbol$j;

var ITERATOR$1 = wellKnownSymbol$3('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$1] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$1] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$a = _export;
var call$8 = functionCall;
var aCallable$2 = aCallable$9;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$1 = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$a({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$2(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$8($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$9 = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$1 = getBuiltIn$7;
var isCallable$4 = isCallable$n;
var defineBuiltIn$3 = defineBuiltIn$8;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$9({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$4(NativePromiseConstructor)) {
  var method = getBuiltIn$1('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn$3(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$8 = _export;
var call$7 = functionCall;
var aCallable$1 = aCallable$9;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$8({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      iterate(iterable, function (promise) {
        call$7($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$7 = _export;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$7({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});

var anObject$6 = anObject$g;
var isObject$1 = isObject$b;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$6(C);
  if (isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$6 = _export;
var getBuiltIn = getBuiltIn$7;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$6({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

var isCallable$3 = isCallable$n;
var isObject = isObject$b;
var setPrototypeOf = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable$3(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var anObject$5 = anObject$g;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$5(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var call$6 = functionCall;
var hasOwn$2 = hasOwnProperty_1;
var isPrototypeOf$2 = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$3 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$3) && !hasOwn$2(R, 'flags') && isPrototypeOf$2(RegExpPrototype$3, R)
    ? call$6(regExpFlags, R) : flags;
};

var fails$9 = fails$p;
var global$6 = global$p;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$6.RegExp;

var UNSUPPORTED_Y$2 = fails$9(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY$1 = UNSUPPORTED_Y$2 || fails$9(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$2 || fails$9(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY$1,
  UNSUPPORTED_Y: UNSUPPORTED_Y$2
};

var defineProperty = objectDefineProperty.f;

var proxyAccessor$1 = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

var fails$8 = fails$p;
var global$5 = global$p;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$5.RegExp;

var regexpUnsupportedDotAll = fails$8(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

var fails$7 = fails$p;
var global$4 = global$p;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$4.RegExp;

var regexpUnsupportedNcg = fails$7(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

var DESCRIPTORS$1 = descriptors;
var global$3 = global$p;
var uncurryThis$9 = functionUncurryThis;
var isForced = isForced_1;
var inheritIfRequired = inheritIfRequired$1;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$6;
var create$1 = objectCreate;
var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var isPrototypeOf$1 = objectIsPrototypeOf;
var isRegExp = isRegexp;
var toString$9 = toString$d;
var getRegExpFlags$1 = regexpGetFlags;
var stickyHelpers$1 = regexpStickyHelpers;
var proxyAccessor = proxyAccessor$1;
var defineBuiltIn$2 = defineBuiltIn$8;
var fails$6 = fails$p;
var hasOwn$1 = hasOwnProperty_1;
var enforceInternalState = internalState.enforce;
var setSpecies = setSpecies$2;
var wellKnownSymbol$2 = wellKnownSymbol$j;
var UNSUPPORTED_DOT_ALL$1 = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG$1 = regexpUnsupportedNcg;

var MATCH = wellKnownSymbol$2('match');
var NativeRegExp = global$3.RegExp;
var RegExpPrototype$2 = NativeRegExp.prototype;
var SyntaxError = global$3.SyntaxError;
var exec$2 = uncurryThis$9(RegExpPrototype$2.exec);
var charAt$4 = uncurryThis$9(''.charAt);
var replace$3 = uncurryThis$9(''.replace);
var stringIndexOf$1 = uncurryThis$9(''.indexOf);
var stringSlice$5 = uncurryThis$9(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers$1.MISSED_STICKY;
var UNSUPPORTED_Y$1 = stickyHelpers$1.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS$1 &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL$1 || UNSUPPORTED_NCG$1 || fails$6(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt$4(string, index);
    if (chr === '\\') {
      result += chr + charAt$4(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = create$1(null);
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt$4(string, index);
    if (chr === '\\') {
      chr += charAt$4(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec$2(IS_NCG, stringSlice$5(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn$1(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf$1(RegExpPrototype$2, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf$1(RegExpPrototype$2, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = getRegExpFlags$1(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString$9(pattern);
    flags = flags === undefined ? '' : toString$9(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL$1 && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf$1(flags, 's') > -1;
      if (dotAll) flags = replace$3(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf$1(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y$1) flags = replace$3(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG$1) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype$2, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty$1(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
  }

  RegExpPrototype$2.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype$2;
  defineBuiltIn$2(global$3, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$5 = functionCall;
var uncurryThis$8 = functionUncurryThis;
var toString$8 = toString$d;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4.exports;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$3 = uncurryThis$8(''.charAt);
var indexOf = uncurryThis$8(''.indexOf);
var replace$2 = uncurryThis$8(''.replace);
var stringSlice$4 = uncurryThis$8(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$5(nativeExec, re1, 'a');
  call$5(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$8(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$5(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$5(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$2(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$4(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$3(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$5(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$4(match.input, charsAdded);
        match[0] = stringSlice$4(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$5(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$5 = _export;
var exec$1 = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$5({ target: 'RegExp', proto: true, forced: /./.exec !== exec$1 }, {
  exec: exec$1
});

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn$1 = defineBuiltIn$8;
var anObject$4 = anObject$g;
var $toString = toString$d;
var fails$5 = fails$p;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails$5(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$1(RegExpPrototype$1, TO_STRING, function toString() {
    var R = anObject$4(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

// TODO: Remove from `core-js@4` since it's moved to entry points

var call$4 = functionCall;
var defineBuiltIn = defineBuiltIn$8;
var regexpExec$1 = regexpExec$2;
var fails$4 = fails$p;
var wellKnownSymbol$1 = wellKnownSymbol$j;
var createNonEnumerableProperty = createNonEnumerableProperty$6;

var SPECIES = wellKnownSymbol$1('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$1(KEY);

  var DELEGATES_TO_SYMBOL = !fails$4(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$4(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: call$4(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call$4(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var uncurryThis$7 = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$4;
var toString$7 = toString$d;
var requireObjectCoercible$4 = requireObjectCoercible$a;

var charAt$2 = uncurryThis$7(''.charAt);
var charCodeAt = uncurryThis$7(''.charCodeAt);
var stringSlice$3 = uncurryThis$7(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$7(requireObjectCoercible$4($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$2(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$3(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$2 = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var call$3 = functionCall;
var anObject$3 = anObject$g;
var isCallable$2 = isCallable$n;
var classof$1 = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError$1 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$2(exec)) {
    var result = call$3(exec, R, S);
    if (result !== null) anObject$3(result);
    return result;
  }
  if (classof$1(R) === 'RegExp') return call$3(regexpExec, R, S);
  throw new $TypeError$1('RegExp#exec called on incompatible receiver');
};

var call$2 = functionCall;
var fixRegExpWellKnownSymbolLogic$2 = fixRegexpWellKnownSymbolLogic;
var anObject$2 = anObject$g;
var isNullOrUndefined$2 = isNullOrUndefined$7;
var toLength$2 = toLength$5;
var toString$6 = toString$d;
var requireObjectCoercible$3 = requireObjectCoercible$a;
var getMethod$2 = getMethod$6;
var advanceStringIndex$1 = advanceStringIndex$2;
var regExpExec$2 = regexpExecAbstract;

// @@match logic
fixRegExpWellKnownSymbolLogic$2('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible$3(this);
      var matcher = isNullOrUndefined$2(regexp) ? undefined : getMethod$2(regexp, MATCH);
      return matcher ? call$2(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString$6(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject$2(this);
      var S = toString$6(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec$2(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec$2(rx, S)) !== null) {
        var matchStr = toString$6(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex$1(S, toLength$2(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

var uncurryThis$6 = functionUncurryThis;
var toObject$1 = toObject$5;

var floor$1 = Math.floor;
var charAt = uncurryThis$6(''.charAt);
var replace$1 = uncurryThis$6(''.replace);
var stringSlice$2 = uncurryThis$6(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$1(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$1(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$2(str, 0, position);
      case "'": return stringSlice$2(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$2(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor$1(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var apply = functionApply;
var call$1 = functionCall;
var uncurryThis$5 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var fails$3 = fails$p;
var anObject$1 = anObject$g;
var isCallable$1 = isCallable$n;
var isNullOrUndefined$1 = isNullOrUndefined$7;
var toIntegerOrInfinity = toIntegerOrInfinity$4;
var toLength$1 = toLength$5;
var toString$5 = toString$d;
var requireObjectCoercible$2 = requireObjectCoercible$a;
var advanceStringIndex = advanceStringIndex$2;
var getMethod$1 = getMethod$6;
var getSubstitution = getSubstitution$1;
var regExpExec$1 = regexpExecAbstract;
var wellKnownSymbol = wellKnownSymbol$j;

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min$1 = Math.min;
var concat = uncurryThis$5([].concat);
var push$1 = uncurryThis$5([].push);
var stringIndexOf = uncurryThis$5(''.indexOf);
var stringSlice$1 = uncurryThis$5(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$3(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic$1('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$2(this);
      var replacer = isNullOrUndefined$1(searchValue) ? undefined : getMethod$1(searchValue, REPLACE);
      return replacer
        ? call$1(replacer, searchValue, O, replaceValue)
        : call$1(nativeReplace, toString$5(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$1(this);
      var S = toString$5(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$1(replaceValue);
      if (!functionalReplace) replaceValue = toString$5(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec$1(rx, S);
        if (result === null) break;

        push$1(results, result);
        if (!global) break;

        var matchStr = toString$5(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength$1(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$5(result[0]);
        var position = max(min$1(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$1(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push$1(replacerArgs, namedCaptures);
          replacement = toString$5(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$1(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice$1(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var $$4 = _export;
var DESCRIPTORS = descriptors;
var global$2 = global$p;
var uncurryThis$4 = functionUncurryThis;
var hasOwn = hasOwnProperty_1;
var isCallable = isCallable$n;
var isPrototypeOf = objectIsPrototypeOf;
var toString$4 = toString$d;
var defineBuiltInAccessor = defineBuiltInAccessor$2;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$2.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$4(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis$4(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis$4(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis$4(''.replace);
  var stringSlice = uncurryThis$4(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$4({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

var css_248z$1g = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-live-validator-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-live-validator-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-live-validator-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-live-validator-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-live-validator-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-live-validator-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-live-validator-liveValidator {\n  margin-top: 16px;\n  color: #008000;\n}\n.athenaeum-live-validator-liveValidator tr > td {\n  padding-right: 4px;\n}\n.athenaeum-live-validator-liveValidator tr.athenaeum-live-validator-invalid {\n  color: #a94442;\n}";
var styles$17 = {"font-renta":"athenaeum-live-validator-font-renta","color-schema-renta_black":"athenaeum-live-validator-color-schema-renta_black","color-schema-renta_white":"athenaeum-live-validator-color-schema-renta_white","color-schema-renta_orange":"athenaeum-live-validator-color-schema-renta_orange","color-schema-renta_green":"athenaeum-live-validator-color-schema-renta_green","color-schema-renta_blue":"athenaeum-live-validator-color-schema-renta_blue","liveValidator":"athenaeum-live-validator-liveValidator","invalid":"athenaeum-live-validator-invalid"};
styleInject(css_248z$1g);

//Autogenerated
class PasswordInputLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.helpTextLengthLanguageItemName = `HelpText.Length`;
    //Initializer
    this.set(this.helpTextLengthLanguageItemName, {
      language: `en`,
      value: `at least 8 characters long`
    }, {
      language: `uk`,
      value: `Не менше 8 символів`
    }, {
      language: `sv`,
      value: `åtminstone 8 tecken`
    }, {
      language: `ru`,
      value: `не менее 8 символов`
    }, {
      language: `pl`,
      value: `Co najmniej 8 znaków`
    }, {
      language: `nb`,
      value: `Minst 8 tegn`
    }, {
      language: `fi`,
      value: `vähintään 8 merkkiä`
    }, {
      language: `da`,
      value: `Mindst 8 tegn lang`
    });
  }
  /**
  /* "HelpText.Length" (at least 8 characters long)
  */
  get helpTextLength() {
    return this.get(this.helpTextLengthLanguageItemName);
  }
}
//Singleton
var PasswordInputLocalizer$1 = new PasswordInputLocalizer();

class ValidationRow {
  constructor(regex, description, isValid = false) {
    this.regex = regex;
    this.description = description;
    this.isValid = isValid;
  }
}
class LiveValidator extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      validationRows: this.validationRows,
      isLengthValid: !this.props.validLength
    };
  }
  get validationRows() {
    return this.props.validationRows;
  }
  validateAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      const validationRows = this.state.validationRows.map(row => {
        if (new RegExp(row.regex).test(value)) {
          return Object.assign(Object.assign({}, row), {
            isValid: true
          });
        }
        return Object.assign(Object.assign({}, row), {
          isValid: false
        });
      });
      let isLengthValid = true;
      if (this.props.validLength) {
        isLengthValid = value.length >= this.props.validLength;
      }
      yield this.setState({
        validationRows,
        isLengthValid
      });
    });
  }
  get isValid() {
    return this.state.validationRows.every(row => row.isValid) && this.state.isLengthValid;
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    return __awaiter(this, void 0, void 0, function* () {
      if (nextProps.value !== this.props.value) {
        yield this.validateAsync(nextProps.value);
      }
      if (nextProps.validationRows !== this.props.validationRows) {
        yield this.setState({
          validationRows: nextProps.validationRows
        });
      }
    });
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      yield this.validateAsync(this.props.value);
    });
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$17.liveValidator
    }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, this.state.validationRows.map(validationRow => ( /*#__PURE__*/React.createElement("tr", {
      key: validationRow.regex,
      className: this.css(validationRow.isValid ? styles$17.valid : styles$17.invalid)
    }, /*#__PURE__*/React.createElement("td", null, validationRow.isValid ? /*#__PURE__*/React.createElement("i", {
      className: "fa fa-check"
    }) : /*#__PURE__*/React.createElement("i", {
      className: "fa fa-times"
    })), /*#__PURE__*/React.createElement("td", null, validationRow.description)))), this.props.validLength && ( /*#__PURE__*/React.createElement("tr", {
      className: this.css(this.state.isLengthValid ? styles$17.valid : styles$17.invalid)
    }, /*#__PURE__*/React.createElement("td", null, this.state.isLengthValid ? /*#__PURE__*/React.createElement("i", {
      className: "fa fa-check"
    }) : /*#__PURE__*/React.createElement("i", {
      className: "fa fa-times"
    })), /*#__PURE__*/React.createElement("td", null, PasswordInputLocalizer$1.helpTextLength))))));
  }
}

//Autogenerated
class BaseInputLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.validatorsRequiredLanguageItemName = `Validators.Required`;
    this.validatorsLengthLanguageItemName = `Validators.Length`;
    this.validatorsNumberRangeLanguageItemName = `Validators.NumberRange`;
    this.validatorsDocumentTypeNotSupportedLanguageItemName = `Validators.DocumentTypeNotSupported`;
    this.validatorsDocumentTooBigLanguageItemName = `Validators.DocumentTooBig`;
    this.validatorsTotalSizeTooBigLanguageItemName = `Validators.TotalSizeTooBig`;
    //Initializer
    this.set(this.validatorsRequiredLanguageItemName, {
      language: `en`,
      value: `{0} is required`
    }, {
      language: `uk`,
      value: `Потрібно {0}`
    }, {
      language: `sv`,
      value: `{0} krävs`
    }, {
      language: `ru`,
      value: `Требуется {0}`
    }, {
      language: `pl`,
      value: `{0} jest wymagany`
    }, {
      language: `nb`,
      value: `{0} er påkrevd`
    }, {
      language: `fi`,
      value: `{0} on pakollinen`
    }, {
      language: `da`,
      value: `{0} er påkrævet`
    });
    this.set(this.validatorsLengthLanguageItemName, {
      language: `en`,
      value: `Text is too short`
    }, {
      language: `uk`,
      value: `Текст надто короткий`
    }, {
      language: `sv`,
      value: `Text för kort`
    }, {
      language: `ru`,
      value: `Текст слишком короткий`
    }, {
      language: `pl`,
      value: `Tekst za krótki`
    }, {
      language: `nb`,
      value: `Teksten er for kort`
    }, {
      language: `fi`,
      value: `Teksti on liian lyhyt`
    }, {
      language: `da`,
      value: `Teksten er for kort`
    });
    this.set(this.validatorsNumberRangeLanguageItemName, {
      language: `en`,
      value: `Value must be in range {0} - {1}`
    }, {
      language: `uk`,
      value: `Значення має бути в діапазоні {0} - {1}`
    }, {
      language: `sv`,
      value: `Värde måste vara inom intervallet {0} - {1}`
    }, {
      language: `ru`,
      value: `Значение должно быть в диапазоне {0} - {1}`
    }, {
      language: `pl`,
      value: `Liczba musi się zawierać w przedziale {0} - {1}`
    }, {
      language: `nb`,
      value: `Verdien må være mellom {0} - {1}`
    }, {
      language: `fi`,
      value: `Arvon pitää olla väliltä {0} - {1}`
    }, {
      language: `da`,
      value: `Værdien skal være i området {0} - {1}`
    });
    this.set(this.validatorsDocumentTypeNotSupportedLanguageItemName, {
      language: `en`,
      value: `Document type is not supported, choose file with extension {0}`
    }, {
      language: `uk`,
      value: `Тип документа не підтримується, виберіть файл з розширенням {0}`
    }, {
      language: `sv`,
      value: `Dokumenttyp stöds inte. Välj dokument som är {0}.`
    }, {
      language: `ru`,
      value: `Тип документа не поддерживается, выберите файл с расширением {0}`
    }, {
      language: `pl`,
      value: `Format dokumentu nieprawidłowy. Wybierz dokument {0}`
    }, {
      language: `nb`,
      value: `Dokumenttype støttes ikke. Velg fil med filtypen {0}`
    }, {
      language: `fi`,
      value: `Dokumentin tyyppi ei ole tuettu. Valitse tiedosto, joka on {0}`
    }, {
      language: `da`,
      value: `Dokumenttype understøttes ikke. Vælg fil med udvidelse {0}`
    });
    this.set(this.validatorsDocumentTooBigLanguageItemName, {
      language: `en`,
      value: `Document file is too big`
    }, {
      language: `uk`,
      value: `Файл документа занадто великий`
    }, {
      language: `sv`,
      value: `Dokument filen är för stor`
    }, {
      language: `ru`,
      value: `Файл документа слишком большой`
    }, {
      language: `pl`,
      value: `Dokument jest za duży`
    }, {
      language: `nb`,
      value: `Dokumentfilen er for stor`
    }, {
      language: `fi`,
      value: `Dokumentti-tiedoston koko on liian suuri`
    }, {
      language: `da`,
      value: `Dokumentfilen er for stor`
    });
    this.set(this.validatorsTotalSizeTooBigLanguageItemName, {
      language: `en`,
      value: `Total size of documents is too big`
    }, {
      language: `uk`,
      value: `Загальний розмір документів занадто великий`
    }, {
      language: `sv`,
      value: `Dokumentens totala storlek är för stor`
    }, {
      language: `ru`,
      value: `Общий размер документов слишком велик`
    }, {
      language: `pl`,
      value: `Rozmiar pliku za duży`
    }, {
      language: `nb`,
      value: `Dokumentets totale størrelse er for stor`
    }, {
      language: `fi`,
      value: `Dokumenttien kokonaiskoko on liian suuri`
    }, {
      language: `da`,
      value: `Den samlede størrelse af dokumenter er for stor`
    });
  }
  /**
  /* "Validators.Required" ({0} is required)
  */
  get validatorsRequired() {
    return this.get(this.validatorsRequiredLanguageItemName);
  }
  /**
  /* "Validators.Length" (Text is too short)
  */
  get validatorsLength() {
    return this.get(this.validatorsLengthLanguageItemName);
  }
  /**
  /* "Validators.NumberRange" (Value must be in range {0} - {1})
  */
  get validatorsNumberRange() {
    return this.get(this.validatorsNumberRangeLanguageItemName);
  }
  /**
  /* "Validators.DocumentTypeNotSupported" (Document type is not supported, choose file with extension {0})
  */
  get validatorsDocumentTypeNotSupported() {
    return this.get(this.validatorsDocumentTypeNotSupportedLanguageItemName);
  }
  /**
  /* "Validators.DocumentTooBig" (Document file is too big)
  */
  get validatorsDocumentTooBig() {
    return this.get(this.validatorsDocumentTooBigLanguageItemName);
  }
  /**
  /* "Validators.TotalSizeTooBig" (Total size of documents is too big)
  */
  get validatorsTotalSizeTooBig() {
    return this.get(this.validatorsTotalSizeTooBigLanguageItemName);
  }
}
//Singleton
var BaseInputLocalizer$1 = new BaseInputLocalizer();

var css_248z$1f = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-form-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-form-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-form-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-form-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-form-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-form-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-form-numberInput, .athenaeum-form-inputContainer .athenaeum-form-number, .athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-number {\n  position: relative;\n}\n.athenaeum-form-numberInput input[type=number]::-webkit-inner-spin-button, .athenaeum-form-inputContainer .athenaeum-form-number input[type=number]::-webkit-inner-spin-button, .athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-number input[type=number]::-webkit-inner-spin-button, .athenaeum-form-numberInput input[type=number]::-webkit-outer-spin-button, .athenaeum-form-inputContainer .athenaeum-form-number input[type=number]::-webkit-outer-spin-button, .athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-number input[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.athenaeum-form-numberInput .athenaeum-form-numberInputArrow, .athenaeum-form-inputContainer .athenaeum-form-number .athenaeum-form-numberInputArrow, .athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-number .athenaeum-form-numberInputArrow {\n  position: absolute;\n  width: 20px;\n  border-left: 1px solid #d4d4d4;\n  border-right: 1px solid transparent;\n  color: #d4d4d4;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-form-numberInput .athenaeum-form-increaseArrow, .athenaeum-form-inputContainer .athenaeum-form-number .athenaeum-form-increaseArrow, .athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-number .athenaeum-form-increaseArrow {\n  right: 0;\n  top: 0;\n  bottom: unset;\n  height: 50%;\n}\n.athenaeum-form-numberInput .athenaeum-form-decreaseArrow, .athenaeum-form-inputContainer .athenaeum-form-number .athenaeum-form-decreaseArrow, .athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-number .athenaeum-form-decreaseArrow {\n  top: unset;\n  right: 0;\n  bottom: 0;\n  height: 50%;\n}\n.athenaeum-form-numberInput .athenaeum-form-disabled, .athenaeum-form-inputContainer .athenaeum-form-number .athenaeum-form-disabled, .athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-number .athenaeum-form-disabled {\n  cursor: default;\n}\n\n.athenaeum-form-form {\n  width: 100%;\n}\n.athenaeum-form-form.athenaeum-form-inline {\n  width: auto;\n}\n.athenaeum-form-form .athenaeum-form-errorList {\n  padding-left: 17px;\n  margin-bottom: 8px;\n  color: #a94442;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup {\n  width: 100%;\n  margin-bottom: 15px !important;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup label {\n  display: block;\n  margin-bottom: 5px;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-inputContainer {\n  width: 100%;\n  position: relative;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-inputContainer input {\n  min-width: 70px;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-inputContainer span.athenaeum-form-value {\n  height: calc(1.5em + 0.75rem + 2px);\n  display: flex;\n  align-items: center;\n  cursor: text;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-inputContainer.athenaeum-form-validationError input {\n  border-color: #a94442;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-inputContainer.athenaeum-form-validationError textarea {\n  border-color: #a94442;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-validationError {\n  color: #a94442;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-validationError.athenaeum-form-append {\n  border-color: #a94442;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-validationError.athenaeum-form-prepend {\n  border-color: #a94442;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-required {\n  margin-left: 2px;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-prepend {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: 0;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-prepend > input {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-append {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-left: 0;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-append > input {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-focused {\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  border-radius: 0.25rem;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-file .athenaeum-form-dropZone {\n  height: 200px;\n  background-color: aliceblue;\n  border: 2px dashed #ccc;\n  border-radius: 5px;\n  margin-bottom: 15px;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-file .athenaeum-form-dropZone label {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: copy;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-file .athenaeum-form-dropZone label .athenaeum-form-preview {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-file .athenaeum-form-dropZone label .athenaeum-form-preview .athenaeum-form-image {\n  height: 85%;\n  width: 85%;\n  margin: 0 auto;\n  background-position: center !important;\n  background-repeat: no-repeat !important;\n  background-size: contain !important;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-file .athenaeum-form-selectedFile {\n  font-size: 1.5em;\n}\n.athenaeum-form-form .athenaeum-form-inputGroup .athenaeum-form-file .athenaeum-form-selectedFile i {\n  color: #a94442;\n  margin-left: 8px;\n  cursor: pointer;\n}\n.athenaeum-form-inlineInputGroup .athenaeum-form-inputGroup, .athenaeum-form-inlineInputGroup.athenaeum-form-inputGroup {\n  margin-bottom: 0 !important;\n}\n.athenaeum-form-inlineInputGroup .athenaeum-form-label label {\n  margin-bottom: 0;\n  padding-right: 0.25rem !important;\n}\n\n.athenaeum-form-inputContainer {\n  width: 100%;\n}\n.athenaeum-form-inputContainer input {\n  min-width: 70px;\n}\n.athenaeum-form-inputContainer span.athenaeum-form-value {\n  height: calc(1.5em + 0.75rem + 2px);\n  display: flex;\n  align-items: center;\n  cursor: text;\n}\n.athenaeum-form-inputContainer .athenaeum-form-slider {\n  width: 100%;\n}";
var styles$16 = {"font-renta":"athenaeum-form-font-renta","color-schema-renta_black":"athenaeum-form-color-schema-renta_black","color-schema-renta_white":"athenaeum-form-color-schema-renta_white","color-schema-renta_orange":"athenaeum-form-color-schema-renta_orange","color-schema-renta_green":"athenaeum-form-color-schema-renta_green","color-schema-renta_blue":"athenaeum-form-color-schema-renta_blue","numberInput":"athenaeum-form-numberInput","inputContainer":"athenaeum-form-inputContainer","number":"athenaeum-form-number","form":"athenaeum-form-form","inputGroup":"athenaeum-form-inputGroup","numberInputArrow":"athenaeum-form-numberInputArrow","increaseArrow":"athenaeum-form-increaseArrow","decreaseArrow":"athenaeum-form-decreaseArrow","disabled":"athenaeum-form-disabled","inline":"athenaeum-form-inline","errorList":"athenaeum-form-errorList","value":"athenaeum-form-value","validationError":"athenaeum-form-validationError","append":"athenaeum-form-append","prepend":"athenaeum-form-prepend","required":"athenaeum-form-required","focused":"athenaeum-form-focused","file":"athenaeum-form-file","dropZone":"athenaeum-form-dropZone","preview":"athenaeum-form-preview","image":"athenaeum-form-image","selectedFile":"athenaeum-form-selectedFile","inlineInputGroup":"athenaeum-form-inlineInputGroup","label":"athenaeum-form-label","slider":"athenaeum-form-slider"};
styleInject(css_248z$1f);

class BaseValidator {
  static toString(value, format = null) {
    if (value != null) {
      if (typeof value === "string") {
        return value;
      }
      if (value instanceof FileModel || value.isFileModel) {
        return value.src;
      }
      if (typeof value === "number") {
        //return (value as number).toString();
        return Utility.formatValue(value, format);
      }
      if (typeof value === "boolean") {
        //return (value as boolean).toString();
        return Utility.formatValue(value, format);
      }
      if (value instanceof Date) {
        //return (value as Date).toDateString();
        return Utility.formatValue(value, format || "D");
      }
    }
    return null;
  }
}
class BaseFileValidator {
  static getSize(file) {
    return file != null ? file instanceof Array ? Utility.sum(file, item => this.getSize(item)) : file.size : null;
  }
  static getMimeType(file) {
    return file != null ? file.type.toLowerCase() : null;
  }
  static getFileExtension(file) {
    return file != null ? Utility.getFileExtension(file.name) : null;
  }
}
var BaseRegexValidatorErrorMessage;
(function (BaseRegexValidatorErrorMessage) {
  BaseRegexValidatorErrorMessage["validatorsEmailLanguageItemName"] = "Validators.Email";
  BaseRegexValidatorErrorMessage["validatorsUrlLanguageItemName"] = "Validators.Url";
  BaseRegexValidatorErrorMessage["validatorsPasswordLanguageItemName"] = "Validators.Password";
  BaseRegexValidatorErrorMessage["validatorsPhoneLanguageItemName"] = "Validators.Phone";
})(BaseRegexValidatorErrorMessage || (BaseRegexValidatorErrorMessage = {}));
class BaseRegexValidator extends BaseValidator {
  constructor(regex, errorMessage, flags) {
    super();
    this.regex = new RegExp(regex, flags);
    this.errorMessage = BaseInputLocalizer$1.get(errorMessage);
  }
  validate(value) {
    if (value) {
      const str = value;
      if (str != null) {
        if (!str.match(this.regex)) {
          return this.errorMessage;
        }
      }
    }
    return null;
  }
}
class RegexValidator extends BaseRegexValidator {
  static validator(regex, errorMessage) {
    const instance = new RegexValidator(regex, errorMessage);
    return value => instance.validate(value);
  }
}
class EmailValidator extends BaseRegexValidator {
  constructor() {
    super(InputValidationRule.Email, BaseRegexValidatorErrorMessage.validatorsEmailLanguageItemName, "i");
  }
}
EmailValidator.instance = new EmailValidator();
EmailValidator.validator = value => EmailValidator.instance.validate(value);
class UrlValidator extends BaseRegexValidator {
  constructor() {
    super(InputValidationRule.Url, BaseRegexValidatorErrorMessage.validatorsUrlLanguageItemName);
  }
}
UrlValidator.instance = new UrlValidator();
UrlValidator.validator = value => UrlValidator.instance.validate(value);
class PasswordValidator extends BaseRegexValidator {
  constructor() {
    super(InputValidationRule.Password, BaseRegexValidatorErrorMessage.validatorsPasswordLanguageItemName);
  }
}
PasswordValidator.instance = new PasswordValidator();
PasswordValidator.validator = value => PasswordValidator.instance.validate(value);
class PhoneValidator extends BaseRegexValidator {
  constructor() {
    super(InputValidationRule.Phone, BaseRegexValidatorErrorMessage.validatorsPhoneLanguageItemName);
  }
}
PhoneValidator.instance = new PhoneValidator();
PhoneValidator.validator = value => PhoneValidator.instance.validate(value);
class RequiredValidator extends BaseValidator {
  constructor(message) {
    super();
    this._message = message;
  }
  getMessage() {
    return this._message || BaseInputLocalizer$1.validatorsRequiredLanguageItemName;
  }
  validate(value) {
    if (value != null && Array.isArray(value)) {
      return value.length === 0 ? this.getMessage() : null;
    }
    const str = BaseValidator.toString(value);
    if (str == null || str.length === 0) {
      return this.getMessage();
    }
    return null;
  }
  static customValidator(message) {
    return value => new RequiredValidator(message).validate(value);
  }
}
RequiredValidator.instance = new RequiredValidator();
RequiredValidator.validator = value => RequiredValidator.instance.validate(value);
class LengthValidator extends BaseValidator {
  constructor(minLength = 0) {
    super();
    this.minLength = minLength;
  }
  validate(value) {
    const str = BaseValidator.toString(value);
    if (this.minLength > 0 && (str == null || str.length < this.minLength)) {
      return BaseInputLocalizer$1.validatorsLength;
    }
    return null;
  }
  static validator(minLength = 0) {
    return value => new LengthValidator(minLength).validate(value);
  }
}
LengthValidator.instance = new LengthValidator();
class NumberRangeValidator extends BaseValidator {
  constructor(min = Number.NEGATIVE_INFINITY, max = Number.POSITIVE_INFINITY) {
    super();
    this.min = min;
    this.max = max;
  }
  validate(value) {
    if (value == null || value < this.min || value > this.max) {
      return Utility.format(BaseInputLocalizer$1.validatorsNumberRange, this.min, this.max);
    }
    return null;
  }
  static validator(min = Number.NEGATIVE_INFINITY, max = Number.POSITIVE_INFINITY) {
    return value => new NumberRangeValidator(min, max).validate(value);
  }
}
NumberRangeValidator.instance = new NumberRangeValidator();
class FileSizeValidator extends BaseFileValidator {
  constructor(maxSize = AthenaeumComponentsConstants.maxFileUploadSizeInBytes) {
    super();
    this.maxSize = maxSize;
  }
  validate(value) {
    if (value != null && this.maxSize > 0) {
      const files = value instanceof Array ? value : [value];
      const fileSizes = files.map(file => BaseFileValidator.getSize(file) || 0);
      if (fileSizes.some(fileSize => fileSize > this.maxSize)) {
        return BaseInputLocalizer$1.validatorsDocumentTooBig;
      }
    }
    return null;
  }
  static validator(maxSize = AthenaeumComponentsConstants.maxFileUploadSizeInBytes) {
    return value => new FileSizeValidator(maxSize).validate(value);
  }
}
FileSizeValidator.instance = new FileSizeValidator();
class FilesSizeValidator extends BaseFileValidator {
  constructor(maxSize = AthenaeumComponentsConstants.maxFileUploadSizeInBytes) {
    super();
    this.maxSize = maxSize;
  }
  validate(value) {
    if (value != null && this.maxSize > 0) {
      const files = value instanceof Array ? value : [value];
      const totalSize = BaseFileValidator.getSize(files) || 0;
      if (totalSize > this.maxSize) {
        return BaseInputLocalizer$1.validatorsTotalSizeTooBig;
      }
    }
    return null;
  }
  static validator(maxSize = AthenaeumComponentsConstants.maxFileUploadSizeInBytes) {
    return value => new FilesSizeValidator(maxSize).validate(value);
  }
}
FilesSizeValidator.instance = new FilesSizeValidator();
class FileTypeValidator extends BaseFileValidator {
  constructor(fileTypes = AthenaeumComponentsConstants.imageFileTypes) {
    super();
    this.fileTypes = fileTypes;
  }
  validate(value) {
    if (value != null && this.fileTypes.length > 0) {
      const files = value instanceof Array ? value : [value];
      const fileMimeTypes = files.map(file => BaseFileValidator.getMimeType(file) || "");
      const fileExtensions = files.map(file => BaseFileValidator.getFileExtension(file) || "");
      const validateByFileExtension = this.fileTypes.every(mimeType => mimeType.startsWith("."));
      //  if user gives fileTypes list of file extensions like [".img", ".jpg"]
      if (validateByFileExtension) {
        const areValidFileExtensions = fileExtensions.every(fileExtension => this.fileTypes.includes(fileExtension));
        if (areValidFileExtensions) {
          return null;
        }
        const allowedFileExtensionsToDisplay = this.fileTypes.map(fileExtensionWithDot => fileExtensionWithDot.replace(".", "")).join();
        return Utility.format(BaseInputLocalizer$1.validatorsDocumentTypeNotSupported, allowedFileExtensionsToDisplay);
      }
      //  if user gives fileTypes list of file extensions like ["images/jpg"]
      if (fileMimeTypes.length !== 0 && !fileMimeTypes.every(fileType => this.fileTypes.includes(fileType))) {
        return Utility.format(BaseInputLocalizer$1.validatorsDocumentTypeNotSupported, Utility.getExtensionsFromMimeTypes(this.fileTypes));
      }
    }
    return null;
  }
  static validator(fileTypes = AthenaeumComponentsConstants.imageFileTypes) {
    return value => new FileTypeValidator(fileTypes).validate(value);
  }
}
FileTypeValidator.instance = new FileTypeValidator();
class BaseInput extends BaseComponent {
  onInputContainerClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.clickToEdit) {
        yield this.showEditAsync();
      }
    });
  }
  setEditAsync(edit) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.clickToEdit && this.state.edit !== edit) {
        yield this.setState({
          edit: edit
        });
        if (edit) {
          yield this.onShowEditAsync();
        } else {
          yield this.onHideEditAsync();
        }
      }
    });
  }
  onLabelClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      // do nothing
    });
  }
  onShowEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      // do nothing
    });
  }
  onHideEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      // do nothing
    });
  }
  onValuePropsChanged() {
    // do nothing
  }
  parse(str) {
    return str;
  }
  getFormattedStr() {
    return Utility.formatValue(this.value, this.format);
  }
  ignoreValueProps() {
    return this.props.model != null;
  }
  get format() {
    return this.props.format || "";
  }
  static getCurrentLocalizerLanguage() {
    var _a, _b;
    return (_b = (_a = ServiceProvider.findLocalizer()) === null || _a === void 0 ? void 0 : _a.language) !== null && _b !== void 0 ? _b : "";
  }
  get inputElement() {
    if (this._inputContainerRef.current) {
      return this._inputContainerRef.current.querySelector("input") || this._inputContainerRef.current.querySelector("textarea") || null;
    }
    return null;
  }
  constructor(props) {
    var _a;
    super(props);
    this._inputContainerRef = /*#__PURE__*/React.createRef();
    this._liveValidatorRef = /*#__PURE__*/React.createRef();
    this._localizerLanguage = BaseInput.getCurrentLocalizerLanguage();
    const varProps = props;
    const model = (_a = props.model) !== null && _a !== void 0 ? _a : {
      value: null
    };
    if (props.value != null) {
      model.value = props.value;
    }
    const readonly = varProps.readonly || varProps.disabled || false;
    this.state = {
      model: model,
      edit: !this.props.clickToEdit,
      validationError: null,
      generation: 0,
      readonly: readonly
    };
  }
  getName() {
    return this.props.name || this.id;
  }
  getValue() {
    return this.value;
  }
  get inline() {
    return !!this.props.inline;
  }
  get value() {
    return this.state.model.value;
  }
  get str() {
    return BaseValidator.toString(this.value) || "";
  }
  isValid() {
    if (this.props.liveValidator) {
      return !this.state.validationError && this._liveValidatorRef.current.isValid;
    }
    return !this.state.validationError;
  }
  focus() {
    if (this.inputElement) {
      this.inputElement.focus();
    }
  }
  get noValidate() {
    return !!this.props.noValidate || this.readonly;
  }
  get readonly() {
    return this.state.readonly;
  }
  setReadonlyAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (value != this.state.readonly) {
        yield this.setState({
          readonly: value
        });
      }
    });
  }
  hideEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setEditAsync(false);
    });
  }
  showEditAsync(select) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setEditAsync(true);
      if (this.inputElement) {
        this.inputElement.focus();
        if (select) {
          this.inputElement.select();
        }
      }
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.clickToEdit) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id);
        if (outside) {
          yield this.hideEditAsync();
        }
      }
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const varProps = this.props;
      const varNewProps = nextProps;
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (this.isMounted) {
        const model = this.state.model;
        const nextModel = nextProps.model;
        const value = model.value;
        const nextValue = nextProps.value;
        const newReadonly = varProps.disabled != varNewProps.disabled || varProps.readonly != varNewProps.readonly;
        //Ensure validation localizations change when localizer language changes
        let resetValidator = !nextProps.required && !this.isValid();
        const currentLanguage = BaseInput.getCurrentLocalizerLanguage();
        if (currentLanguage !== this._localizerLanguage) {
          if (!this.isValid()) {
            resetValidator = true;
          }
          this._localizerLanguage = currentLanguage;
        }
        if (nextModel && nextModel.value !== model.value) {
          this.onValuePropsChanged();
          const _value = nextModel.value != null ? nextModel.value : null;
          yield this.updateValueAsync(_value, false);
        } else if (!this.ignoreValueProps() && value !== nextValue) {
          this.onValuePropsChanged();
          const _value2 = nextValue != null ? nextValue : null;
          yield this.updateValueAsync(_value2, false);
        } else if (resetValidator) {
          yield this.validateAsync();
        }
        if (newReadonly) {
          const readonly = varNewProps.readonly || varNewProps.disabled || false;
          yield this.setReadonlyAsync(readonly);
        }
      }
    });
  }
  valueChangeHandlerAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      const str = event.currentTarget.value;
      const value = this.parse(str);
      yield this.updateValueAsync(value);
    });
  }
  updateValueAsync(value, validate = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const state = this.state;
      const model = state.model;
      if (model.value !== value) {
        model.value = value;
        if (validate) {
          this.validate();
        } else {
          state.validationError = null;
        }
        if (this.isMounted) {
          yield this.setState(state);
        }
      }
    });
  }
  valueBlurHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.validateAsync();
    });
  }
  validate() {
    var _a;
    if (this.noValidate) {
      return;
    }
    const value = this.value;
    const validators = [];
    if (this.props.required) {
      validators.push(RequiredValidator.customValidator(((_a = this.getCustomRequiredValidationError) === null || _a === void 0 ? void 0 : _a.call(this)) || BaseInputLocalizer$1.validatorsRequiredLanguageItemName));
    }
    validators.push(...this.getValidators());
    if (this.props.validators != null) {
      validators.push(...this.props.validators);
    }
    let error = null;
    validators.forEach(validator => {
      if (!error) {
        let validationError = validator(value);
        if (validationError) {
          if (this.props.onValidationError) {
            validationError = this.props.onValidationError(validator, value);
          }
          error = validationError;
        }
      }
    });
    error = error ? error : null;
    const state = this.state;
    state.validationError = error;
  }
  isInput() {
    return true;
  }
  getValidators() {
    return [];
  }
  validateAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const error = this.state.validationError;
      this.validate();
      if (this.state.validationError !== error) {
        yield this.setState(this.state);
      }
    });
  }
  getInputId() {
    return `input_${this.id}`;
  }
  getType() {
    return BaseInputType.Text;
  }
  getContainerClassName() {
    return "";
  }
  renderValue() {
    const formattedStr = this.getFormattedStr();
    return /*#__PURE__*/React.createElement("span", {
      className: styles$16.value,
      title: this.props.title || formattedStr
    }, formattedStr);
  }
  renderPrepend() {
    const prepend = typeof this.props.prepend === "function" ? this.props.prepend(this) : typeof this.props.prepend === "boolean" ? "" : this.props.prepend;
    const icon = typeof prepend === "string" && (prepend.startsWith("fa-") || prepend.includes(" fa-"));
    return /*#__PURE__*/React.createElement("div", {
      className: "input-group-prepend"
    }, icon ? ( /*#__PURE__*/React.createElement("i", {
      className: prepend
    })) : ( /*#__PURE__*/React.createElement("span", {
      className: this.css("input-group-text", styles$16.prepend)
    }, prepend)));
  }
  renderAppend() {
    const append = typeof this.props.append === "function" ? this.props.append(this) : typeof this.props.append === "boolean" ? "" : this.props.append;
    const icon = typeof append === "string" && (append.startsWith("fa-") || append.includes(" fa-"));
    return /*#__PURE__*/React.createElement("div", {
      className: "input-group-append"
    }, icon ? ( /*#__PURE__*/React.createElement("i", {
      className: append
    })) : ( /*#__PURE__*/React.createElement("span", {
      className: this.css("input-group-text", styles$16.append)
    }, append)));
  }
  render() {
    let inputBorderRadius = "";
    const label = this.props.label;
    const validationError = this.state.validationError;
    const labelText = label ? validationError ? BaseInputLocalizer$1.get(validationError, BaseInputLocalizer$1.get(label)) : BaseInputLocalizer$1.get(label) : "";
    if (this.props.prepend) {
      inputBorderRadius = styles$16.prepend;
    }
    if (this.props.append) {
      inputBorderRadius = styles$16.append;
    }
    if (this.props.prepend && this.props.append) {
      inputBorderRadius = this.css(styles$16.append, styles$16.prepend);
    }
    const inlineStyle = this.inline && "d-flex flex-row align-items-center " + styles$16.inlineInputGroup;
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(styles$16.inputGroup, inlineStyle, this.getContainerClassName(), this.props.className),
      hidden: this.props.hidden
    }, this.props.label && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$16.label, "d-flex", "base-input-label", this.state.validationError && styles$16.validationError)
    }, /*#__PURE__*/React.createElement("label", {
      className: this.css(validationError && "validation-error"),
      htmlFor: this.getInputId(),
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onLabelClick(e);
      })
    }, ReactUtility.toMultiLines(labelText)), this.props.required && !this.noValidate && !this.state.validationError && (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-literals -- used as icon, not localizable
    React.createElement("span", {
      className: styles$16.required
    }, "*")))), /*#__PURE__*/React.createElement("div", {
      className: "d-flex h-100"
    }, this.props.prepend && this.renderPrepend(), /*#__PURE__*/React.createElement("div", {
      ref: this._inputContainerRef,
      className: this.css(styles$16.inputContainer, inputBorderRadius, this.state.validationError && styles$16.validationError),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onInputContainerClickAsync();
      })
    }, this.state.edit ? this.renderInput() : this.renderValue()), this.props.append && this.renderAppend()), this.props.liveValidator && this.value && ( /*#__PURE__*/React.createElement(LiveValidator, {
      ref: this._liveValidatorRef,
      validationRows: this.props.liveValidator,
      value: this.value || "",
      validLength: this.props.validLength
    })));
  }
}

var css_248z$1e = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-text-area-input-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-text-area-input-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-text-area-input-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-text-area-input-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-text-area-input-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-text-area-input-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-text-area-input-textAreaInput {\n  position: relative;\n}\n.athenaeum-text-area-input-textAreaInput .athenaeum-text-area-input-progressBar {\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  right: 1px;\n  overflow: hidden;\n}\n.athenaeum-text-area-input-textAreaInput .athenaeum-text-area-input-progressBar > div {\n  width: 0;\n  height: 3px;\n  background-color: #337ab7;\n  opacity: 0.5;\n  overflow: hidden;\n}\n.athenaeum-text-area-input-textAreaInput .athenaeum-text-area-input-usedCharacters {\n  position: absolute;\n  bottom: 1px;\n  right: 1px;\n}\n.athenaeum-text-area-input-textAreaInput .athenaeum-text-area-input-usedCharacters > span {\n  opacity: 0.5;\n}\n.athenaeum-text-area-input-textAreaInput .athenaeum-text-area-input-full {\n  color: red;\n}\n.athenaeum-text-area-input-textAreaInput .athenaeum-text-area-input-almostFull {\n  color: #c18901;\n}";
var styles$15 = {"font-renta":"athenaeum-text-area-input-font-renta","color-schema-renta_black":"athenaeum-text-area-input-color-schema-renta_black","color-schema-renta_white":"athenaeum-text-area-input-color-schema-renta_white","color-schema-renta_orange":"athenaeum-text-area-input-color-schema-renta_orange","color-schema-renta_green":"athenaeum-text-area-input-color-schema-renta_green","color-schema-renta_blue":"athenaeum-text-area-input-color-schema-renta_blue","textAreaInput":"athenaeum-text-area-input-textAreaInput","progressBar":"athenaeum-text-area-input-progressBar","usedCharacters":"athenaeum-text-area-input-usedCharacters","full":"athenaeum-text-area-input-full","almostFull":"athenaeum-text-area-input-almostFull"};
styleInject(css_248z$1e);

class TextAreaInput extends BaseInput {
  constructor() {
    super(...arguments);
    this._inputRef = /*#__PURE__*/React.createRef();
    this.state = {
      model: this.props.model || {
        value: this.props.value || ""
      },
      edit: true,
      readonly: this.props.readonly || false,
      validationError: ""
    };
  }
  progress() {
    const length = this.length;
    const maxLength = this.maxLength;
    return 100 - (maxLength - length) / maxLength * 100;
  }
  progressBar() {
    return this.progress() + "%";
  }
  used() {
    const length = this.length;
    const maxLength = this.maxLength;
    return `${length}/${maxLength}`;
  }
  valueBlurHandlerAsync() {
    const _super = Object.create(null, {
      validateAsync: {
        get: () => super.validateAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.validateAsync.call(this);
      if (this.props.onBlur) {
        yield this.props.onBlur(this);
      }
    });
  }
  valueChangeHandlerAsync(event) {
    const _super = Object.create(null, {
      valueChangeHandlerAsync: {
        get: () => super.valueChangeHandlerAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.valueChangeHandlerAsync.call(this, event);
      if (this.props.onChange) {
        yield this.props.onChange(this, this.value);
      }
    });
  }
  getType() {
    return BaseInputType.TextArea;
  }
  getValidators() {
    return this.props.minLength ? [LengthValidator.validator(this.props.minLength)] : [];
  }
  get value() {
    return this.state.model.value || "";
  }
  focus() {
    if (this._inputRef.current) {
      this._inputRef.current.focus();
    }
  }
  get maxLength() {
    return this.props.maxLength || 1000;
  }
  get length() {
    return this.str.length;
  }
  get noRemaining() {
    return this.props.noRemaining === true;
  }
  get showRemainingAmount() {
    return !this.noRemaining && this.props.showRemainingAmount === true;
  }
  get remainingStyle() {
    if (this.progress() === 100) {
      return styles$15.full;
    }
    if (this.length / this.maxLength * 100 > 75) {
      return styles$15.almostFull;
    }
    return "";
  }
  renderInput() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$15.textAreaInput
    }, /*#__PURE__*/React.createElement("textarea", {
      id: this.getInputId(),
      ref: this._inputRef,
      className: "form-control",
      value: this.str,
      required: this.props.required,
      readOnly: this.readonly,
      rows: this.props.rows || 4,
      cols: this.props.cols,
      maxLength: this.maxLength,
      autoFocus: this.props.autoFocus,
      placeholder: this.props.placeholder,
      onChange: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.valueChangeHandlerAsync(e);
      }),
      onBlur: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.valueBlurHandlerAsync();
      })
    }), !this.noRemaining && /*#__PURE__*/React.createElement("div", {
      className: styles$15.progressBar
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: this.progressBar()
      }
    })), this.showRemainingAmount && /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$15.usedCharacters, this.remainingStyle)
    }, /*#__PURE__*/React.createElement("span", null, this.used())));
  }
}

//Autogenerated
class ConfirmationDialogLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.areYouSureLanguageItemName = `AreYouSure`;
    this.confirmButtonLanguageItemName = `ConfirmButton`;
    this.closeButtonLanguageItemName = `CloseButton`;
    this.commentLanguageItemName = `Comment`;
    //Initializer
    this.set(this.areYouSureLanguageItemName, {
      language: `en`,
      value: `Are you sure?`
    }, {
      language: `uk`,
      value: `Ви впевнені?`
    }, {
      language: `sv`,
      value: `Är du säker?`
    }, {
      language: `ru`,
      value: `Вы уверены?`
    }, {
      language: `pl`,
      value: `Czy jesteś pewien?`
    }, {
      language: `nb`,
      value: `Er du sikker?`
    }, {
      language: `fi`,
      value: `Oletko varma?`
    }, {
      language: `da`,
      value: `Er du sikker?`
    });
    this.set(this.confirmButtonLanguageItemName, {
      language: `en`,
      value: `Confirm`
    }, {
      language: `uk`,
      value: `Підтвердети`
    }, {
      language: `sv`,
      value: `Bekräfta`
    }, {
      language: `ru`,
      value: `Подтвердить`
    }, {
      language: `pl`,
      value: `Potwierdź`
    }, {
      language: `nb`,
      value: `Bekreft`
    }, {
      language: `fi`,
      value: `Kyllä`
    }, {
      language: `da`,
      value: `Bekræft`
    });
    this.set(this.closeButtonLanguageItemName, {
      language: `en`,
      value: `Close`
    }, {
      language: `uk`,
      value: `Закрити`
    }, {
      language: `sv`,
      value: `Stäng`
    }, {
      language: `ru`,
      value: `Отмена`
    }, {
      language: `pl`,
      value: `Zamknij`
    }, {
      language: `nb`,
      value: `Lukk`
    }, {
      language: `fi`,
      value: `Ei`
    }, {
      language: `da`,
      value: `Luk`
    });
    this.set(this.commentLanguageItemName, {
      language: `en`,
      value: `Please leave a comment`
    }, {
      language: `uk`,
      value: `Будьласка, залиште коментар`
    }, {
      language: `sv`,
      value: `Var vänlig och lämna en kommentar`
    }, {
      language: `ru`,
      value: `Пожалуйста, оставьте комментарий`
    }, {
      language: `pl`,
      value: `Dodaj komentarz`
    }, {
      language: `nb`,
      value: `Vennligst legg igjen en kommentar`
    }, {
      language: `fi`,
      value: `Ole hyvä ja kommentoi`
    }, {
      language: `da`,
      value: `Efterlad en kommentar`
    });
  }
  /**
  /* "AreYouSure" (Are you sure?)
  */
  get areYouSure() {
    return this.get(this.areYouSureLanguageItemName);
  }
  /**
  /* "ConfirmButton" (Confirm)
  */
  get confirmButton() {
    return this.get(this.confirmButtonLanguageItemName);
  }
  /**
  /* "CloseButton" (Close)
  */
  get closeButton() {
    return this.get(this.closeButtonLanguageItemName);
  }
  /**
  /* "Comment" (Please leave a comment)
  */
  get comment() {
    return this.get(this.commentLanguageItemName);
  }
}
//Singleton
var ConfirmationDialogLocalizer$1 = new ConfirmationDialogLocalizer();

var css_248z$1d = ".athenaeum-confirmation-dialog-confirmDialog {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1150;\n  display: none;\n}\n.athenaeum-confirmation-dialog-confirmDialog.athenaeum-confirmation-dialog-opened {\n  display: block;\n}\n.athenaeum-confirmation-dialog-confirmDialog.athenaeum-confirmation-dialog-processing {\n  cursor: wait;\n}\n.athenaeum-confirmation-dialog-confirmDialog.athenaeum-confirmation-dialog-processing textarea {\n  cursor: wait;\n}\n.athenaeum-confirmation-dialog-confirmDialog .athenaeum-confirmation-dialog-dialogOverlay {\n  width: 100%;\n  height: 100%;\n  background-color: black;\n  opacity: 0.5;\n  position: absolute;\n}\n.athenaeum-confirmation-dialog-confirmDialog .athenaeum-confirmation-dialog-dialogContent {\n  width: 300px;\n  background-color: white;\n  position: relative;\n  top: 40%;\n  margin: auto;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  text-align: center;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n  border-radius: 6px;\n}\n.athenaeum-confirmation-dialog-confirmDialog .athenaeum-confirmation-dialog-dialogContent > h5 {\n  white-space: normal;\n}\n.athenaeum-confirmation-dialog-confirmDialog .athenaeum-confirmation-dialog-commentInput {\n  margin-bottom: 0.5rem;\n}";
var styles$14 = {"confirmDialog":"athenaeum-confirmation-dialog-confirmDialog","opened":"athenaeum-confirmation-dialog-opened","processing":"athenaeum-confirmation-dialog-processing","dialogOverlay":"athenaeum-confirmation-dialog-dialogOverlay","dialogContent":"athenaeum-confirmation-dialog-dialogContent","commentInput":"athenaeum-confirmation-dialog-commentInput"};
styleInject(css_248z$1d);

class ConfirmationDialog extends BaseComponent {
  constructor() {
    super(...arguments);
    this._model = null;
    this.state = {
      isOpened: false,
      comment: "",
      processing: false
    };
    this._commentRef = /*#__PURE__*/React.createRef();
    this._resolver = null;
  }
  toModel(title) {
    let model = {};
    let data = title;
    if (data) {
      if (typeof data === "function") {
        data = data();
      }
      if (typeof data === "string") {
        model.title = data;
      } else {
        model = data;
      }
    }
    if (!model.title) {
      model.title = ConfirmationDialogLocalizer$1.areYouSure;
    }
    return model;
  }
  get model() {
    return this._model || (this._model = this.toModel(this.props.title));
  }
  get hasComment() {
    return this.state.isOpened ? !!this.model.comment : false;
  }
  get minLength() {
    return this.state.isOpened ? this.props.minLength || this.model.minLength || 0 : 0;
  }
  get canConfirm() {
    return !this.hasComment || this.state.comment.length > this.minLength;
  }
  get processing() {
    return this.state.processing;
  }
  setCommentAsync(comment) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        comment
      });
    });
  }
  setDialogAsync(isOpened, nestedCheck = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted && this.state.isOpened != isOpened) {
        if (nestedCheck) {
          if (isOpened && ConfirmationDialog._current) {
            yield ConfirmationDialog._current.setDialogAsync(false, false);
            ConfirmationDialog._previous = ConfirmationDialog._current;
          }
        }
        yield this.setState({
          isOpened
        });
        if (nestedCheck) {
          ConfirmationDialog._current = isOpened ? this : null;
          if (!isOpened && ConfirmationDialog._previous) {
            yield ConfirmationDialog._previous.setDialogAsync(true, false);
            ConfirmationDialog._previous = null;
          }
        }
      }
    });
  }
  setProcessingAsync(processing) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        yield this.setState({
          processing
        });
      }
    });
  }
  invokeCloseAsync(confirm = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (confirm) {
        if (this.props.callback) {
          if (!this.processing) {
            try {
              yield this.setProcessingAsync(true);
              yield this.props.callback(this, this.state.comment);
            } finally {
              yield this.setProcessingAsync(false);
            }
          }
        }
      } else if (this.props.onDecline) {
        if (!this.processing) {
          try {
            yield this.setProcessingAsync(true);
            yield this.props.onDecline(this);
          } finally {
            yield this.setProcessingAsync(false);
          }
        }
      }
      if (this._resolver) {
        this._resolver(confirm);
        this._resolver = null;
      }
      yield this.setDialogAsync(false);
    });
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.isOpened) {
        yield this.invokeCloseAsync();
      } else {
        yield this.openAsync();
      }
    });
  }
  openAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setDialogAsync(true);
      if (this._commentRef.current) {
        this._commentRef.current.focus();
      }
    });
  }
  closeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeCloseAsync();
    });
  }
  confirmAsync(title) {
    return __awaiter(this, void 0, void 0, function* () {
      this._model = this.toModel(title);
      yield this.openAsync();
      return new Promise(resolve => {
        this._resolver = resolve;
      });
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const targetNode = e.target;
      const outside = Utility.clickedOutside(targetNode, `confirmationContent-${this.id}`);
      if (outside) {
        yield this.invokeCloseAsync();
      }
    });
  }
  onGlobalKeydown(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasComment) {
        yield this.invokeCloseAsync();
      } else {
        if (e.keyCode === 27) {
          yield this.invokeCloseAsync();
        }
      }
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this._model = null;
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  renderDialog() {
    const openedStyle = this.state.isOpened && styles$14.opened;
    const processingStyle = this.processing && styles$14.processing;
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(styles$14.confirmDialog, openedStyle, processingStyle)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$14.dialogOverlay
    }), /*#__PURE__*/React.createElement("div", {
      id: `confirmationContent-${this.id}`,
      className: this.css(styles$14.dialogContent, this.props.dialogContentClassName)
    }, /*#__PURE__*/React.createElement("h5", null, this.toMultiLines(ConfirmationDialogLocalizer$1.get(this.model.title))), this.hasComment && ( /*#__PURE__*/React.createElement(TextAreaInput, {
      ref: this._commentRef,
      required: true,
      noValidate: true,
      rows: 3,
      placeholder: this.model.placeholder || ConfirmationDialogLocalizer$1.comment,
      className: styles$14.commentInput,
      value: this.state.comment,
      readonly: this.processing,
      onChange: (sender, value) => __awaiter(this, void 0, void 0, function* () {
        return yield this.setCommentAsync(value);
      })
    })), /*#__PURE__*/React.createElement(Button, {
      block: true,
      id: "confirmation-dialog-confirm-" + this.id,
      label: this.props.confirmButtonLabel || ConfirmationDialogLocalizer$1.confirmButton,
      type: ButtonType.Orange,
      disabled: this.processing || !this.canConfirm,
      onClick: () => this.invokeCloseAsync(true)
    }), /*#__PURE__*/React.createElement(Button, {
      block: true,
      id: "confirmation-dialog-cancel-" + this.id,
      label: this.props.declineButtonLabel || ConfirmationDialogLocalizer$1.closeButton,
      type: ButtonType.Default,
      disabled: this.processing,
      onClick: () => this.invokeCloseAsync()
    })));
  }
  render() {
    return /*#__PURE__*/ReactDOM.createPortal(this.renderDialog(), document.body);
  }
}
ConfirmationDialog._current = null;
ConfirmationDialog._previous = null;

//Autogenerated
class IconLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Initializer
  }
}
//Singleton
var IconLocalizer$1 = new IconLocalizer();

var css_248z$1c = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-icon-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-icon-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-icon-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-icon-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-icon-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-icon-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-icon-actions {\n  position: absolute;\n  min-width: calc(100% + 10px);\n  border-radius: 0.25rem;\n  border: 1px solid #ccc !important;\n  top: calc(100% + 1px);\n  right: 0;\n  text-align: left;\n  z-index: 10;\n  font-family: \"DINProMedium\", Arial, sans-serif;\n  font-size: 14px;\n}\n.athenaeum-icon-actions.athenaeum-icon-color_grey {\n  background-color: white !important;\n  color: #333 !important;\n}\n.athenaeum-icon-actions.athenaeum-icon-color_grey .athenaeum-icon-action:hover {\n  background-color: #e3e3e3 !important;\n}\n.athenaeum-icon-actions.athenaeum-icon-color_orange {\n  background-color: rgb(254, 80, 0) !important;\n  color: white !important;\n}\n.athenaeum-icon-actions.athenaeum-icon-color_orange .athenaeum-icon-action:hover {\n  background-color: rgba(240, 80, 0, 0.8) !important;\n}\n.athenaeum-icon-actions.athenaeum-icon-color_unset {\n  color: #000000 !important;\n  background-color: #ffffff !important;\n  border-color: black;\n}\n.athenaeum-icon-actions.athenaeum-icon-color_unset .athenaeum-icon-action:hover {\n  background-color: rgba(140, 140, 140, 0.8) !important;\n}\n.athenaeum-icon-actions .athenaeum-icon-action {\n  line-height: 1.5;\n  padding: 6px 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-icon-actions .athenaeum-icon-action span {\n  flex: 1;\n}\n.athenaeum-icon-actions .athenaeum-icon-action i:last-child {\n  padding-right: 0;\n}\n.athenaeum-icon-actions .athenaeum-icon-action > i {\n  padding-right: 12px;\n}\n.athenaeum-icon-actions .athenaeum-icon-action:hover {\n  filter: alpha(opacity=60);\n}";
var styles$13 = {"font-renta":"athenaeum-icon-font-renta","color-schema-renta_black":"athenaeum-icon-color-schema-renta_black","color-schema-renta_white":"athenaeum-icon-color-schema-renta_white","color-schema-renta_orange":"athenaeum-icon-color-schema-renta_orange","color-schema-renta_green":"athenaeum-icon-color-schema-renta_green","color-schema-renta_blue":"athenaeum-icon-color-schema-renta_blue","actions":"athenaeum-icon-actions","color_grey":"athenaeum-icon-color_grey","action":"athenaeum-icon-action","color_orange":"athenaeum-icon-color_orange","color_unset":"athenaeum-icon-color_unset"};
styleInject(css_248z$1c);

class IconAction extends BaseComponent {
  get hasIcon() {
    return !!this.props.icon;
  }
  get hasIconPosition() {
    return !!this.props.iconPosition;
  }
  get isIconPositionLeft() {
    return this.hasIcon && !this.hasIconPosition;
  }
  get isIconPositionRight() {
    return this.hasIcon && this.hasIconPosition && this.props.iconPosition == Justify.Right;
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$13.action,
      onClick: () => this.props.onClick()
    }, this.isIconPositionLeft && /*#__PURE__*/React.createElement(Icon, Object.assign({}, this.props.icon)), /*#__PURE__*/React.createElement("span", null, IconLocalizer$1.get(this.props.title)), this.isIconPositionRight && /*#__PURE__*/React.createElement(Icon, Object.assign({}, this.props.icon)));
  }
}

var IconSize;
(function (IconSize) {
  IconSize[IconSize["Normal"] = 0] = "Normal";
  IconSize[IconSize["ExtraSmall"] = 1] = "ExtraSmall";
  IconSize[IconSize["Small"] = 2] = "Small";
  IconSize[IconSize["Large"] = 3] = "Large";
  IconSize[IconSize["X2"] = 4] = "X2";
  IconSize[IconSize["X3"] = 5] = "X3";
  IconSize[IconSize["X4"] = 6] = "X4";
  IconSize[IconSize["X5"] = 7] = "X5";
  IconSize[IconSize["X7"] = 8] = "X7";
  IconSize[IconSize["X10"] = 9] = "X10";
})(IconSize || (IconSize = {}));
var IconStyle;
(function (IconStyle) {
  IconStyle[IconStyle["Solid"] = 0] = "Solid";
  IconStyle[IconStyle["Regular"] = 1] = "Regular";
  IconStyle[IconStyle["Light"] = 2] = "Light";
  IconStyle[IconStyle["Brands"] = 3] = "Brands";
  IconStyle[IconStyle["Duotone"] = 4] = "Duotone";
})(IconStyle || (IconStyle = {}));
class Icon extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isOpen: false
    };
    this._confirmDialogRef = /*#__PURE__*/React.createRef();
    this._actionLoading = false;
    this._onClickInvoking = false;
  }
  static get Action() {
    return IconAction;
  }
  static add(lowerClassName, className, style, asPrefix = false) {
    const includes = asPrefix ? lowerClassName.startsWith(style + " ") : lowerClassName.includes(style);
    if (!includes) {
      className += " " + style;
    }
    return className;
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      if (this.hasActions) {
        yield this.reRenderAsync();
      }
    });
  }
  get actionsId() {
    return `${this.id}_actions`;
  }
  closeActions() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isOpen: false
      });
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      const outside = Utility.clickedOutside(target, this.id);
      if (outside && this.state.isOpen) {
        yield this.closeActions();
      }
    });
  }
  static addSize(lowerClassName, className, size) {
    if (size != null) {
      switch (size) {
        case IconSize.ExtraSmall:
          className = Icon.add(lowerClassName, className, "fa-xs");
          break;
        case IconSize.Small:
          className = Icon.add(lowerClassName, className, "fa-sm");
          break;
        case IconSize.Large:
          className = Icon.add(lowerClassName, className, "fa-lg");
          break;
        case IconSize.X2:
          className = Icon.add(lowerClassName, className, "fa-2x");
          break;
        case IconSize.X3:
          className = Icon.add(lowerClassName, className, "fa-3x");
          break;
        case IconSize.X4:
          className = Icon.add(lowerClassName, className, "fa-4x");
          break;
        case IconSize.X5:
          className = Icon.add(lowerClassName, className, "fa-5x");
          break;
        case IconSize.X7:
          className = Icon.add(lowerClassName, className, "fa-7x");
          break;
        case IconSize.X10:
          className = Icon.add(lowerClassName, className, "fa-10x");
          break;
      }
    }
    return className;
  }
  static addStyle(lowerClassName, className, style) {
    if (style != null) {
      switch (style) {
        case IconStyle.Solid:
          return Icon.add(lowerClassName, className, "fas");
        case IconStyle.Regular:
          return Icon.add(lowerClassName, className, "far");
        case IconStyle.Light:
          return Icon.add(lowerClassName, className, "fal");
        case IconStyle.Brands:
          return Icon.add(lowerClassName, className, "fab");
        case IconStyle.Duotone:
          return Icon.add(lowerClassName, className, "fad");
      }
    }
    return Icon.add(lowerClassName, className, "fa", true);
  }
  static getClassStyle(lowerName) {
    let classStyle = undefined;
    if (lowerName.startsWith("fas ")) {
      classStyle = IconStyle.Solid;
    } else if (lowerName.startsWith("far ")) {
      classStyle = IconStyle.Regular;
    } else if (lowerName.startsWith("fal ")) {
      classStyle = IconStyle.Light;
    } else if (lowerName.startsWith("fab ")) {
      classStyle = IconStyle.Brands;
    } else if (lowerName.startsWith("fad ")) {
      classStyle = IconStyle.Duotone;
    }
    return classStyle;
  }
  // overriding children's onClick
  extendChildProps(element) {
    return {
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        yield this.onActionClickAsync(element.props);
      })
    };
  }
  onActionClickAsync(actionProps) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._actionLoading) {
        return;
      }
      this._actionLoading = true;
      yield this.reRenderAsync();
      try {
        yield actionProps.onClick();
      } finally {
        this._actionLoading = false;
        yield this.reRenderAsync();
      }
    });
  }
  getClassName() {
    let name = this.props.name;
    let className = this.props.className || "";
    const lowerClassName = className.toLowerCase();
    const lowerName = name.toLowerCase();
    const classStyle = Icon.getClassStyle(lowerName);
    if (classStyle != null) {
      name = name.substr(4);
    }
    if (!lowerName.startsWith("fa-") && !lowerName.includes(" fa-")) {
      className += " fa-";
    } else {
      className += " ";
    }
    className += name;
    className = Icon.addSize(lowerClassName, className, this.props.size);
    className = Icon.addStyle(lowerClassName, className, this.props.style || classStyle);
    className = className.trim();
    return className;
  }
  get disabledStyle() {
    return {
      opacity: 0.5,
      pointerEvents: "none"
    };
  }
  get dataTarget() {
    return this.props.dataTarget || "";
  }
  get dataModal() {
    return this.props.dataModal || "";
  }
  get dataToggleModal() {
    return this.props.toggleModal ? "modal" : "";
  }
  get dataDismissModal() {
    return this.props.dismissModal ? "modal" : "";
  }
  get hasActions() {
    return !!this.props.children;
  }
  toggleActionsAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isOpen: !this.state.isOpen
      });
    });
  }
  get showActions() {
    return this.hasActions && this.state.isOpen;
  }
  invokeOnClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._onClickInvoking) {
        try {
          this._onClickInvoking = true;
          if (this.props.onClick) {
            yield this.props.onClick(this);
          }
        } finally {
          this._onClickInvoking = false;
        }
      }
    });
  }
  onClickAsync(confirmed, e = null) {
    return __awaiter(this, void 0, void 0, function* () {
      if (e != null && this.props.stopPropagation === true) {
        e.stopPropagation();
      }
      if (this.hasActions) {
        return yield this.toggleActionsAsync();
      }
      const confirmNeeded = !!this.props.confirm && !confirmed;
      if (confirmNeeded) {
        yield this._confirmDialogRef.current.openAsync();
      } else {
        yield this.invokeOnClickAsync();
      }
    });
  }
  static isIconName(name) {
    const lowerName = name.toLowerCase().trim();
    return lowerName.startsWith("fa-") || lowerName.includes(" fa-") || Icon.getClassStyle(lowerName) != null;
  }
  static renderIcon(icon, className, size = IconSize.X2, onClick) {
    if (typeof icon === "string") {
      const isIcon = Icon.isIconName(icon);
      if (isIcon) {
        return /*#__PURE__*/React.createElement(Icon, {
          name: icon,
          size: size,
          className: className || undefined,
          onClick: onClick
        });
      }
      return /*#__PURE__*/React.createElement("img", {
        src: icon,
        alt: "",
        className: Utility.css(styles$13.element, styles$13.icon),
        onClick: onClick
      });
    }
    const isFileModel = icon instanceof FileModel || icon.isFileModel;
    if (isFileModel) {
      const fileModel = icon;
      return /*#__PURE__*/React.createElement("img", {
        src: fileModel.src,
        alt: fileModel.name,
        className: Utility.css(styles$13.element, styles$13.icon),
        onClick: onClick
      });
    }
    return /*#__PURE__*/React.createElement(Icon, Object.assign({}, icon, {
      size: size,
      className: Utility.css(styles$13.element, styles$13.icon),
      onClick: onClick
    }));
  }
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
      id: this.id,
      style: this.props.customStyle ? this.props.customStyle : this.props.disabled ? this.disabledStyle : this.hasActions ? {
        position: "relative"
      } : {},
      className: this.getClassName(),
      title: IconLocalizer$1.get(this.props.tooltip),
      "data-target": `#${this.dataTarget}`,
      "data-toggle": this.dataToggleModal,
      "data-dismiss": this.dataDismissModal,
      "data-modal": this.dataModal,
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onClickAsync(false, e);
      })
    }, this.children.length > 0 && ( /*#__PURE__*/React.createElement("div", {
      id: this.actionsId,
      className: this.css(styles$13.actions, styles$13.color_grey, "actions-container", !this.showActions && "invisible")
    }, " ", this.children))), this.props.confirm && ( /*#__PURE__*/React.createElement(ConfirmationDialog, {
      ref: this._confirmDialogRef,
      title: this.props.confirm,
      callback: () => this.onClickAsync(true)
    })));
  }
}

var css_248z$1b = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-button-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-button-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-button-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-button-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-button-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-button-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-button-button {\n  border-color: #ccc !important;\n  font-size: 14px !important;\n  white-space: nowrap;\n  position: relative;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  min-width: 35px;\n  min-height: 35px;\n}\n.athenaeum-button-button:focus {\n  box-shadow: none !important;\n}\n.athenaeum-button-button.athenaeum-button-hover:hover {\n  color: #333 !important;\n  background-color: rgb(227, 227, 227) !important;\n  border-color: #adadad;\n}\n.athenaeum-button-button i {\n  padding-right: 0;\n}\n.athenaeum-button-button.athenaeum-button-labelPadding i {\n  padding-right: 8px;\n}\n.athenaeum-button-button.athenaeum-button-small {\n  font-size: 0.8rem !important;\n  padding: 0.375rem;\n  height: auto;\n  min-width: 33px;\n  min-height: 33px;\n}\n.athenaeum-button-button.athenaeum-button-small.athenaeum-button-iconPadding.athenaeum-button-labelPadding {\n  padding-right: 0.7rem;\n}\n.athenaeum-button-button.athenaeum-button-disabled {\n  pointer-events: none;\n}\n.athenaeum-button-button.athenaeum-button-color_grey {\n  background-color: white;\n  color: #333;\n}\n.athenaeum-button-button.athenaeum-button-color_orange {\n  background-color: rgb(254, 80, 0);\n  color: white;\n}\n.athenaeum-button-button.athenaeum-button-color_unset {\n  color: #000000;\n  background-color: #8c8c8c;\n  border-color: black;\n}\n.athenaeum-button-button.athenaeum-button-text {\n  padding: 0;\n  border: 0;\n  color: rgb(254, 80, 0);\n}\n.athenaeum-button-button.athenaeum-button-text:hover {\n  background-color: inherit !important;\n  color: inherit !important;\n}\n.athenaeum-button-button.athenaeum-button-withActions {\n  padding-right: 24px;\n}\n.athenaeum-button-button.athenaeum-button-withActions .athenaeum-button-icon {\n  position: absolute;\n  top: 10px;\n  right: 0;\n}\n.athenaeum-button-button.athenaeum-button-withActions span {\n  flex-grow: 1;\n}\n\n.athenaeum-button-actions {\n  position: absolute;\n  min-width: calc(100% + 2px);\n  border-radius: 0.25rem;\n  border: 1px solid #ccc !important;\n  top: 33px;\n  left: -1px;\n  text-align: left;\n  z-index: 10;\n}\n.athenaeum-button-actions.athenaeum-button-color_grey {\n  background-color: white !important;\n  color: #333 !important;\n}\n.athenaeum-button-actions.athenaeum-button-color_grey .athenaeum-button-action:hover {\n  background-color: #e3e3e3 !important;\n}\n.athenaeum-button-actions.athenaeum-button-color_orange {\n  background-color: rgb(254, 80, 0) !important;\n  color: white !important;\n}\n.athenaeum-button-actions.athenaeum-button-color_orange .athenaeum-button-action:hover {\n  background-color: rgba(240, 80, 0, 0.8) !important;\n}\n.athenaeum-button-actions.athenaeum-button-color_unset {\n  color: #000000 !important;\n  background-color: #8c8c8c !important;\n  border-color: black;\n}\n.athenaeum-button-actions.athenaeum-button-color_unset .athenaeum-button-action:hover {\n  background-color: rgba(140, 140, 140, 0.8) !important;\n}\n.athenaeum-button-actions .athenaeum-button-action {\n  padding: 6px 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-button-actions .athenaeum-button-action span {\n  flex: 1;\n}\n.athenaeum-button-actions .athenaeum-button-action i:last-child {\n  padding-right: 0;\n}\n.athenaeum-button-actions .athenaeum-button-action > i {\n  padding-right: 12px;\n}\n.athenaeum-button-actions .athenaeum-button-action:hover {\n  filter: alpha(opacity=60);\n}\n\n.athenaeum-button-hidden {\n  display: none;\n}";
var styles$12 = {"font-renta":"athenaeum-button-font-renta","color-schema-renta_black":"athenaeum-button-color-schema-renta_black","color-schema-renta_white":"athenaeum-button-color-schema-renta_white","color-schema-renta_orange":"athenaeum-button-color-schema-renta_orange","color-schema-renta_green":"athenaeum-button-color-schema-renta_green","color-schema-renta_blue":"athenaeum-button-color-schema-renta_blue","button":"athenaeum-button-button","hover":"athenaeum-button-hover","labelPadding":"athenaeum-button-labelPadding","small":"athenaeum-button-small","iconPadding":"athenaeum-button-iconPadding","disabled":"athenaeum-button-disabled","color_grey":"athenaeum-button-color_grey","color_orange":"athenaeum-button-color_orange","color_unset":"athenaeum-button-color_unset","text":"athenaeum-button-text","withActions":"athenaeum-button-withActions","icon":"athenaeum-button-icon","actions":"athenaeum-button-actions","action":"athenaeum-button-action","hidden":"athenaeum-button-hidden"};
styleInject(css_248z$1b);

class ButtonAction extends BaseComponent {
  get hasIcon() {
    return !!this.props.icon;
  }
  get hasIconPosition() {
    return !!this.props.iconPosition;
  }
  get isIconPositionLeft() {
    return this.hasIcon && !this.hasIconPosition;
  }
  get isIconPositionRight() {
    return this.hasIcon && this.hasIconPosition && this.props.iconPosition == Justify.Right;
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$12.action,
      onClick: () => this.props.onClick()
    }, this.isIconPositionLeft && /*#__PURE__*/React.createElement(Icon, Object.assign({}, this.props.icon)), /*#__PURE__*/React.createElement("span", null, this.props.title), this.isIconPositionRight && /*#__PURE__*/React.createElement(Icon, Object.assign({}, this.props.icon)));
  }
}

//Autogenerated
class ButtonLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Initializer
  }
}
//Singleton
var ButtonLocalizer$1 = new ButtonLocalizer();

var ButtonType;
(function (ButtonType) {
  ButtonType[ButtonType["Default"] = 0] = "Default";
  ButtonType[ButtonType["Orange"] = 1] = "Orange";
  ButtonType[ButtonType["Blue"] = 2] = "Blue";
  ButtonType[ButtonType["Primary"] = 3] = "Primary";
  ButtonType[ButtonType["Secondary"] = 4] = "Secondary";
  ButtonType[ButtonType["Success"] = 5] = "Success";
  ButtonType[ButtonType["Danger"] = 6] = "Danger";
  ButtonType[ButtonType["Warning"] = 7] = "Warning";
  ButtonType[ButtonType["Info"] = 8] = "Info";
  ButtonType[ButtonType["Light"] = 9] = "Light";
  ButtonType[ButtonType["Dark"] = 10] = "Dark";
  ButtonType[ButtonType["Link"] = 11] = "Link";
  ButtonType[ButtonType["Unset"] = 12] = "Unset";
  ButtonType[ButtonType["Text"] = 13] = "Text";
})(ButtonType || (ButtonType = {}));
class Button extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isOpen: false
    };
    this._confirmDialogRef = /*#__PURE__*/React.createRef();
    this._forcedWidth = null;
    this._actionLoading = false;
    this._actionProps = null;
    this._onClickInvoking = false;
  }
  static get Action() {
    return ButtonAction;
  }
  isButton() {
    return true;
  }
  getStyleColor() {
    switch (this.props.type) {
      case ButtonType.Orange:
        return styles$12.color_orange;
      case ButtonType.Blue:
      case ButtonType.Primary:
        return "btn-primary";
      case ButtonType.Secondary:
        return "btn-secondary";
      case ButtonType.Success:
        return "btn-success";
      case ButtonType.Danger:
        return "btn-danger";
      case ButtonType.Warning:
        return "btn-warning";
      case ButtonType.Info:
        return "btn-info";
      case ButtonType.Light:
        return "btn-light";
      case ButtonType.Dark:
        return "btn-dark";
      case ButtonType.Link:
        return "btn-link";
      case ButtonType.Unset:
        return styles$12.color_unset;
      case ButtonType.Text:
        return styles$12.text;
      default:
        return styles$12.color_grey;
    }
  }
  invokeOnClickAsync(data = null) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._onClickInvoking) {
        try {
          this._onClickInvoking = true;
          if (this.props.route) {
            yield PageRouteProvider.redirectAsync(this.props.route);
          }
          if (this.props.onClick) {
            yield this.props.onClick(this, data);
          }
        } finally {
          this._onClickInvoking = false;
        }
      }
    });
  }
  onClickAsync(event = null, confirmed = true, data = null) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.hasActions) {
        return yield this.toggleActionsAsync();
      }
      if (event && this.props.stopPropagation) {
        event.stopPropagation();
      }
      const confirmNeeded = !!this.props.confirm && !confirmed;
      if (confirmNeeded) {
        yield this._confirmDialogRef.current.openAsync();
      } else {
        yield this.invokeOnClickAsync(data);
      }
    });
  }
  toggleActionsAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isOpen: !this.state.isOpen
      });
    });
  }
  closeActionsAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isOpen: false
      });
    });
  }
  get actionsId() {
    return `${this.id}_actions`;
  }
  get dataTarget() {
    return this.props.dataTarget || "";
  }
  get dataModal() {
    return this.props.dataModal || "";
  }
  get dataToggleModal() {
    return this.props.toggleModal ? "modal" : "";
  }
  get dataDismissModal() {
    return this.props.dismissModal ? "modal" : "";
  }
  get hasActions() {
    return !!this.props.children;
  }
  get showCaret() {
    var _a;
    return this.hasActions && !this.rightSideIcon && !((_a = this._actionProps) === null || _a === void 0 ? void 0 : _a.title);
  }
  get showActions() {
    return this.hasActions && this.state.isOpen;
  }
  get leftSideIcon() {
    if (this._actionProps && this._actionProps.title && this._actionProps.icon && this._actionProps.iconPosition !== Justify.Right) {
      return this._actionProps.icon;
    }
    if (this._actionProps && this._actionProps.title) {
      return null;
    }
    if (this.props.icon) {
      return this.props.icon;
    }
    return null;
  }
  get rightSideIcon() {
    if (this._actionProps && this._actionProps.icon && this._actionProps.iconPosition === Justify.Right) {
      return this._actionProps.icon;
    }
    if (this._actionProps && this._actionProps.icon) {
      return null;
    }
    return null;
  }
  get label() {
    var _a;
    return ((_a = this._actionProps) === null || _a === void 0 ? void 0 : _a.title) || this.props.label;
  }
  // overriding children's onClick
  extendChildProps(element) {
    return {
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        yield this.onActionClickAsync(element.props);
      })
    };
  }
  onActionClickAsync(actionProps) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._actionLoading) {
        return;
      }
      this._actionProps = actionProps;
      this._actionLoading = true;
      yield this.reRenderAsync();
      try {
        yield actionProps.onClick();
      } finally {
        this._actionProps = null;
        this._actionLoading = false;
        yield this.reRenderAsync();
      }
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      const outside = Utility.clickedOutside(target, this.id);
      if (outside && this.state.isOpen) {
        yield this.closeActionsAsync();
      }
    });
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      if (this.hasActions) {
        const actionsDiv = this.JQuery(`#${this.actionsId}`);
        const buttonWidth = this.outerWidth();
        const actionsWidth = actionsDiv.outerWidth() || 0;
        if (actionsWidth >= buttonWidth) {
          this._forcedWidth = actionsWidth;
        } else {
          this._forcedWidth = buttonWidth;
        }
        yield this.reRenderAsync();
      }
    });
  }
  render() {
    const blockStyle = this.props.block && "btn-block";
    const smallStyle = this.props.small && styles$12.small;
    const iconPaddingStyle = this.props.icon && styles$12.iconPadding;
    const labelPaddingStyle = this.props.label && styles$12.labelPadding;
    const hoverStyle = this.desktop && styles$12.hover;
    const inlineStyles = this.props.style || {};
    if (this._forcedWidth) {
      inlineStyles.minWidth = this._forcedWidth;
    }
    if (this.props.minWidth) {
      inlineStyles.minWidth = this.props.minWidth;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      id: this.id,
      type: this.props.submit ? "submit" : "button",
      disabled: this.props.disabled,
      title: ButtonLocalizer$1.get(this.props.title),
      className: this.css("btn btn-default", this.getStyleColor(), blockStyle, smallStyle, iconPaddingStyle, labelPaddingStyle, hoverStyle, styles$12.button, this.props.disabled && styles$12.disabled, this.props.className, this.hasActions && styles$12.withActions),
      style: inlineStyles,
      "data-target": `#${this.dataTarget}`,
      "data-modal": this.dataModal,
      "data-toggle": this.dataToggleModal,
      "data-dismiss": this.dataDismissModal,
      onClick: event => this.onClickAsync(event, false)
    }, this.leftSideIcon && /*#__PURE__*/React.createElement(Icon, Object.assign({}, this.leftSideIcon, {
      tooltip: ButtonLocalizer$1.get(this.props.title)
    })), /*#__PURE__*/React.createElement("span", null, this.label), this.rightSideIcon && /*#__PURE__*/React.createElement(Icon, Object.assign({}, this.rightSideIcon, {
      tooltip: ButtonLocalizer$1.get(this.props.title)
    })), this.showCaret && ( /*#__PURE__*/React.createElement(Icon, {
      className: this.css(styles$12.icon, "actions-icon"),
      name: "fa-caret-down",
      style: IconStyle.Solid
    })), this.children.length > 0 && /*#__PURE__*/React.createElement("div", {
      id: this.actionsId,
      className: this.css(styles$12.actions, this.getStyleColor(), "actions-container", !this.showActions && "invisible")
    }, " ", this.children)), this.props.confirm && ( /*#__PURE__*/React.createElement(ConfirmationDialog, {
      ref: this._confirmDialogRef,
      title: this.props.confirm,
      callback: (_, data) => this.onClickAsync(null, true, data)
    })));
  }
}

var css_248z$1a = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-button-container-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-button-container-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-button-container-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-button-container-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-button-container-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-button-container-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-button-container-buttonContainer {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.athenaeum-button-container-buttonContainer .athenaeum-button-container-left {\n  padding-right: 0;\n  margin: 0 !important;\n}\n.athenaeum-button-container-buttonContainer .athenaeum-button-container-left button {\n  margin-right: 8px;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-button-container-buttonContainer .athenaeum-button-container-left {\n    padding-right: 15px;\n  }\n  .athenaeum-button-container-buttonContainer .athenaeum-button-container-left button {\n    display: block;\n    width: 100%;\n    margin-bottom: 8px;\n  }\n}\n.athenaeum-button-container-buttonContainer .athenaeum-button-container-right {\n  display: flex;\n  justify-content: flex-end;\n  padding-left: 0;\n  margin: 0 !important;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-button-container-buttonContainer .athenaeum-button-container-right {\n    padding-left: 15px;\n  }\n  .athenaeum-button-container-buttonContainer .athenaeum-button-container-right button {\n    display: block;\n    width: 100%;\n    margin-bottom: 8px;\n  }\n  .athenaeum-button-container-buttonContainer .athenaeum-button-container-right button:last-of-type {\n    margin-bottom: 0px;\n  }\n}";
var styles$11 = {"font-renta":"athenaeum-button-container-font-renta","color-schema-renta_black":"athenaeum-button-container-color-schema-renta_black","color-schema-renta_white":"athenaeum-button-container-color-schema-renta_white","color-schema-renta_orange":"athenaeum-button-container-color-schema-renta_orange","color-schema-renta_green":"athenaeum-button-container-color-schema-renta_green","color-schema-renta_blue":"athenaeum-button-container-color-schema-renta_blue","buttonContainer":"athenaeum-button-container-buttonContainer","left":"athenaeum-button-container-left","right":"athenaeum-button-container-right"};
styleInject(css_248z$1a);

class ButtonContainer extends BaseComponent {
  get buttons() {
    const buttons = React.Children.map(this.props.children, item => {
      return item;
    }) || [];
    return buttons;
  }
  get left() {
    const buttons = this.buttons;
    const leftButtons = this.buttons.filter(item => item.props.right !== true);
    return leftButtons.length != buttons.length ? leftButtons : buttons.length > 1 ? buttons.slice(0, buttons.length - 1) : [];
  }
  get right() {
    const buttons = this.buttons;
    const rightButtons = this.buttons.filter(item => item.props.right === true);
    return rightButtons.length > 0 ? rightButtons : buttons.length > 1 ? buttons.slice(buttons.length - 1) : buttons;
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$11.buttonContainer, this.props.className)
    }, /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$11.left, "col-md-6")
    }, this.left), /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$11.right, "col-md-6")
    }, this.right));
  }
}

/**
 * Wrapper component to disable swipe navigation on specific component
 */
class NoSwipeNavigation extends BaseComponent {
  get className() {
    var _a;
    return (_a = this.props.className) !== null && _a !== void 0 ? _a : "";
  }
  get style() {
    return this.props.style;
  }
  get ref() {
    return this.props.innerRef;
  }
  get delay() {
    return this.props.delay;
  }
  static handleSwiperEnter() {
    return ch.preventSwipeNavigation();
  }
  /**
   * @param delay Time in milliseconds to wait before restoring swipe navigation on page, default 200ms.
   * Increase this to give the child component more time complete it's actions before navigation is re-enabled
   */
  static handleSwiperExit(delay = 200) {
    setTimeout(() => {
      return ch.restoreSwipeNavigation();
    }, delay);
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.className,
      style: this.style,
      ref: this.ref,
      onTouchStart: () => {
        NoSwipeNavigation.handleSwiperEnter();
      },
      onTouchEnd: () => {
        NoSwipeNavigation.handleSwiperExit(this.delay);
      },
      onClick: event => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        return yield (_b = (_a = this.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
      })
    }, this.props.children);
  }
}

var css_248z$19 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-carousel-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-carousel-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-carousel-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-carousel-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-carousel-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-carousel-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-carousel-carousel {\n  position: relative;\n}\n.athenaeum-carousel-carousel.athenaeum-carousel-paginationBottomOutside .swiper {\n  padding-bottom: 25px;\n}\n.athenaeum-carousel-carousel.athenaeum-carousel-paginationBottomOutside .swiper .swiper-pagination {\n  bottom: 1px;\n}\n.athenaeum-carousel-carousel.athenaeum-carousel-navigationOutside {\n  padding: 0 42px;\n}\n@media screen and (max-width: 640px) {\n  .athenaeum-carousel-carousel.athenaeum-carousel-navigationOutside {\n    padding: 0;\n  }\n}\n.athenaeum-carousel-carousel .swiper-pagination-bullet {\n  background-color: black;\n  opacity: 0.25;\n}\n.athenaeum-carousel-carousel .swiper-pagination-bullet:hover {\n  opacity: 0.5;\n}\n.athenaeum-carousel-carousel .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  opacity: 0.6;\n}\n.athenaeum-carousel-carousel .swiper-pagination-bullet.swiper-pagination-bullet-active:hover {\n  opacity: 0.8;\n}\n.athenaeum-carousel-carousel .athenaeum-carousel-navigation {\n  position: absolute;\n  top: 50%;\n  margin-top: calc(0px - 42px / 2);\n  display: flex;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  color: black;\n  opacity: 0.6;\n  z-index: 1;\n  cursor: pointer;\n}\n.athenaeum-carousel-carousel .athenaeum-carousel-navigation:hover {\n  opacity: 0.8;\n}\n.athenaeum-carousel-carousel .athenaeum-carousel-navigation.athenaeum-carousel-next {\n  right: 0;\n}\n.athenaeum-carousel-carousel .athenaeum-carousel-navigation.athenaeum-carousel-previous {\n  left: 0;\n}\n.athenaeum-carousel-carousel .athenaeum-carousel-navigation.swiper-button-disabled {\n  opacity: 0.25;\n  cursor: initial;\n}\n@media screen and (max-width: 640px) {\n  .athenaeum-carousel-carousel .athenaeum-carousel-navigation {\n    display: none;\n  }\n}";
var styles$10 = {"font-renta":"athenaeum-carousel-font-renta","color-schema-renta_black":"athenaeum-carousel-color-schema-renta_black","color-schema-renta_white":"athenaeum-carousel-color-schema-renta_white","color-schema-renta_orange":"athenaeum-carousel-color-schema-renta_orange","color-schema-renta_green":"athenaeum-carousel-color-schema-renta_green","color-schema-renta_blue":"athenaeum-carousel-color-schema-renta_blue","carousel":"athenaeum-carousel-carousel","paginationBottomOutside":"athenaeum-carousel-paginationBottomOutside","navigationOutside":"athenaeum-carousel-navigationOutside","navigation":"athenaeum-carousel-navigation","next":"athenaeum-carousel-next","previous":"athenaeum-carousel-previous"};
styleInject(css_248z$19);

// TODO: If a child-elements width changes, Swipers slide width/snapping grid won't be updated.
//       Using Swipers in-built observer functionality does not help, as it does not notice changes in childrens width.
var CarouselNavigation;
(function (CarouselNavigation) {
  CarouselNavigation[CarouselNavigation["None"] = 0] = "None";
  CarouselNavigation[CarouselNavigation["Inside"] = 1] = "Inside";
  CarouselNavigation[CarouselNavigation["Outside"] = 2] = "Outside";
})(CarouselNavigation || (CarouselNavigation = {}));
var CarouselPagination;
(function (CarouselPagination) {
  CarouselPagination[CarouselPagination["None"] = 0] = "None";
  CarouselPagination[CarouselPagination["BottomInside"] = 1] = "BottomInside";
  CarouselPagination[CarouselPagination["BottomOutside"] = 2] = "BottomOutside";
})(CarouselPagination || (CarouselPagination = {}));
class Carousel extends BaseComponent {
  constructor() {
    // Inherited
    super(...arguments);
    this.state = {
      swiper: null
    };
    // Fields
    this._navigationNextId = "carousel_next" + ch.getId().toString();
    this._navigationPreviousId = "carousel_previous" + ch.getId().toString();
  }
  get children() {
    return this.props.children;
  }
  // Getters
  get className() {
    const navigationClass = this.navigation === CarouselNavigation.Outside ? styles$10.navigationOutside : null;
    const paginationClass = this.pagination === CarouselPagination.BottomOutside ? styles$10.paginationBottomOutside : null;
    return this.css(this.props.className, styles$10.carousel, navigationClass, paginationClass);
  }
  get initialSlideIndex() {
    return typeof this.props.initialSlideIndex === "number" ? this.props.initialSlideIndex : 0;
  }
  get loop() {
    return this.props.loop === true;
  }
  get navigation() {
    return Carousel.toNavigation(this.props.navigation);
  }
  get navigationOptions() {
    return this.navigation ? {
      nextEl: `#${this._navigationNextId}`,
      prevEl: `#${this._navigationPreviousId}`
    } : false;
  }
  get pagination() {
    return Carousel.toPagination(this.props.pagination);
  }
  get paginationOptions() {
    return this.pagination ? {
      clickable: true
    } : false;
  }
  get slidesPerView() {
    const slidesPerView = this.props.slidesPerView;
    return slidesPerView === "auto" || typeof slidesPerView === "number" && slidesPerView > 0 ? slidesPerView : 1;
  }
  get spaceBetweenSlides() {
    return typeof this.props.spaceBetweenSlides === "number" ? this.props.spaceBetweenSlides : 0;
  }
  get speed() {
    return typeof this.props.speed === "number" ? this.props.speed : 300;
  }
  get swiper() {
    return this.state.swiper;
  }
  // Sync-methods
  getSwiperSlideStyle(child) {
    // If slidesPerView has first been set to a number and then to "auto", the swiper-slide elements widths remain unchanged, and must be reset manually.
    var _a, _b;
    return this.slidesPerView === "auto" ? ((_b = (_a = child.props) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.width) ? {
      width: child.props.style.width
    } : {
      width: "auto"
    } : {};
  }
  // Async-methods
  onSwiperInitAsync(swiper) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        swiper
      });
      swiper.slideTo(this.initialSlideIndex, 0);
    });
  }
  // Public
  /**
   * Index of the currently active slide.
   */
  get currentSlideIndex() {
    return this.swiper.realIndex;
  }
  /**
   * Slide to a slide in the given index with the given speed.
   *
   * @param index Index of the slide to slide to.
   * @param speed Speed to slide with. Default is 300.
   */
  slideToAsync(index, speed = 300) {
    return __awaiter(this, void 0, void 0, function* () {
      this.swiper.slideTo(index, speed);
    });
  }
  /**
   * Convert any value to a {@link CarouselNavigation} value.
   */
  static toNavigation(value) {
    switch (value) {
      case CarouselNavigation.Inside:
        return CarouselNavigation.Inside;
      case CarouselNavigation.Outside:
        return CarouselNavigation.Outside;
      default:
        return CarouselNavigation.None;
    }
  }
  /**
   * Convert any value to a {@link CarouselPagination} value.
   */
  static toPagination(value) {
    switch (value) {
      case CarouselPagination.BottomInside:
        return CarouselPagination.BottomInside;
      case CarouselPagination.BottomOutside:
        return CarouselPagination.BottomOutside;
      default:
        return CarouselPagination.None;
    }
  }
  // Renders
  render() {
    return /*#__PURE__*/React.createElement(NoSwipeNavigation, {
      className: this.className,
      onClick: event => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        return yield (_b = (_a = this.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
      })
    }, /*#__PURE__*/React.createElement(Swiper, {
      modules: [Navigation, Pagination$1],
      navigation: this.navigationOptions,
      pagination: this.paginationOptions,
      loop: this.loop,
      speed: this.speed,
      slidesPerView: this.slidesPerView,
      spaceBetween: this.spaceBetweenSlides,
      onInit: swiper => __awaiter(this, void 0, void 0, function* () {
        return yield this.onSwiperInitAsync(swiper);
      }),
      onRealIndexChange: swiper => __awaiter(this, void 0, void 0, function* () {
        var _c, _d;
        yield (_d = (_c = this.props).onSlideChange) === null || _d === void 0 ? void 0 : _d.call(_c, swiper.realIndex);
      })
    }, this.children.map(child => {
      return /*#__PURE__*/React.createElement(SwiperSlide, {
        key: child.key,
        style: this.getSwiperSlideStyle(child)
      }, child);
    })), this.navigationOptions && this.children.length > 1 && ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
      id: this._navigationPreviousId,
      className: this.css("fa fa-angle-left fa-3x", styles$10.navigation, styles$10.previous)
    }), /*#__PURE__*/React.createElement("i", {
      id: this._navigationNextId,
      className: this.css("fa fa-angle-right fa-3x", styles$10.navigation, styles$10.next)
    }))));
  }
}

var css_248z$18 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-cookie-consent-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-cookie-consent-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-cookie-consent-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-cookie-consent-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-cookie-consent-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-cookie-consent-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-cookie-consent-cookieConsentBanner {\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.athenaeum-cookie-consent-bottom {\n  bottom: 0;\n}\n\n.athenaeum-cookie-consent-cookieConsentBannerInner {\n  max-width: 335px;\n  padding-top: 1.75rem;\n}\n\n.athenaeum-cookie-consent-cookieConsentBannerCopy {\n  margin-bottom: 1rem;\n}\n\n.athenaeum-cookie-consent-cookieConsentBannerHeader {\n  margin-bottom: 1rem;\n  font-weight: 700;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.athenaeum-cookie-consent-cookieConsentBannerTitle {\n  border-bottom: 3px solid rgb(254, 80, 0);\n  display: inline-block;\n}\n\n.athenaeum-cookie-consent-cookieConsentBannerDescription {\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.athenaeum-cookie-consent-cookieConsentBannerButtons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  font-weight: 500;\n}\n\n.athenaeum-cookie-consent-cookieConsentModal {\n  pointer-events: none;\n}\n.athenaeum-cookie-consent-cookieConsentModal .athenaeum-cookie-consent-modal-dialog {\n  pointer-events: all;\n}";
var styles$$ = {"font-renta":"athenaeum-cookie-consent-font-renta","color-schema-renta_black":"athenaeum-cookie-consent-color-schema-renta_black","color-schema-renta_white":"athenaeum-cookie-consent-color-schema-renta_white","color-schema-renta_orange":"athenaeum-cookie-consent-color-schema-renta_orange","color-schema-renta_green":"athenaeum-cookie-consent-color-schema-renta_green","color-schema-renta_blue":"athenaeum-cookie-consent-color-schema-renta_blue","cookieConsentBanner":"athenaeum-cookie-consent-cookieConsentBanner","bottom":"athenaeum-cookie-consent-bottom","cookieConsentBannerInner":"athenaeum-cookie-consent-cookieConsentBannerInner","cookieConsentBannerCopy":"athenaeum-cookie-consent-cookieConsentBannerCopy","cookieConsentBannerHeader":"athenaeum-cookie-consent-cookieConsentBannerHeader","cookieConsentBannerTitle":"athenaeum-cookie-consent-cookieConsentBannerTitle","cookieConsentBannerDescription":"athenaeum-cookie-consent-cookieConsentBannerDescription","cookieConsentBannerButtons":"athenaeum-cookie-consent-cookieConsentBannerButtons","cookieConsentModal":"athenaeum-cookie-consent-cookieConsentModal","modal-dialog":"athenaeum-cookie-consent-modal-dialog"};
styleInject(css_248z$18);

var css_248z$17 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-page-container-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-page-container-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-page-container-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-page-container-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-page-container-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-page-container-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-page-container-page {\n  height: 100%;\n}\n.athenaeum-page-container-page[data-haswideheader=false] {\n  padding: 15px 8px;\n}\n.athenaeum-page-container-page[data-haswideheader=true] {\n  background: white;\n}\n.athenaeum-page-container-page .athenaeum-page-container-container {\n  padding: 15px;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 6px;\n}\n.athenaeum-page-container-page .athenaeum-page-container-container.athenaeum-page-container-fullHeight {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.athenaeum-page-container-page .athenaeum-page-container-container.athenaeum-page-container-fullWidth {\n  max-width: unset !important;\n  min-width: 100% !important;\n}\n.athenaeum-page-container-page.athenaeum-page-container-scale {\n  padding: 0;\n}\n.athenaeum-page-container-page.athenaeum-page-container-scale .athenaeum-page-container-container {\n  max-width: unset !important;\n  min-width: 100% !important;\n  height: 100%;\n  border-radius: 0;\n  padding-bottom: 0;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n.athenaeum-page-container-page.athenaeum-page-container-scale .athenaeum-page-container-container > div {\n  margin-top: 0 !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.athenaeum-page-container-page .athenaeum-page-container-row {\n  flex-grow: 2;\n  margin: 15px 15px 25px;\n}\n.athenaeum-page-container-page .athenaeum-page-container-row:last-of-type {\n  margin-bottom: 15px;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-page-container-page .athenaeum-page-container-row {\n    margin: 0 -15px 15px !important;\n  }\n  .athenaeum-page-container-page .athenaeum-page-container-row:last-of-type {\n    margin-bottom: 0 !important;\n  }\n}\n.athenaeum-page-container-page .athenaeum-page-container-pageRow {\n  margin-bottom: 0;\n  flex-grow: 0;\n}\n.athenaeum-page-container-page .athenaeum-page-container-pageRow.athenaeum-page-container-alertRow {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header {\n  flex-grow: 0;\n  margin-bottom: 16px;\n  padding: 0 15px;\n  overflow: unset;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header[data-wideheader=false] {\n  padding: 0 15px;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header[data-wideheader=true] {\n  background-position: center;\n  background-size: cover;\n  color: white;\n  margin: 0;\n  max-height: 25vh;\n  min-height: 10vh;\n  height: 225px;\n  margin-bottom: 1rem;\n  display: flex;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header[data-wideheader=true] .athenaeum-page-container-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header[data-wideheader=true] .athenaeum-page-container-content h1 {\n  font-size: clamp(1.2rem, 5vw, 2rem);\n  font-weight: bold;\n  text-align: center;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header[data-wideheader=true] .athenaeum-page-container-content h2 {\n  font-size: 24px;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header .athenaeum-page-container-content {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header .athenaeum-page-container-content h1 {\n  font-size: 18px;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header .athenaeum-page-container-content h2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-family: Arial, sans-serif;\n  margin-bottom: 8px;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header .athenaeum-page-container-content.athenaeum-page-container-noMargin {\n  margin-bottom: 0;\n}\n.athenaeum-page-container-page .athenaeum-page-container-header hr {\n  border: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  margin: 8px 0 0 0;\n  width: 100%;\n}";
var styles$_ = {"font-renta":"athenaeum-page-container-font-renta","color-schema-renta_black":"athenaeum-page-container-color-schema-renta_black","color-schema-renta_white":"athenaeum-page-container-color-schema-renta_white","color-schema-renta_orange":"athenaeum-page-container-color-schema-renta_orange","color-schema-renta_green":"athenaeum-page-container-color-schema-renta_green","color-schema-renta_blue":"athenaeum-page-container-color-schema-renta_blue","page":"athenaeum-page-container-page","container":"athenaeum-page-container-container","fullHeight":"athenaeum-page-container-fullHeight","fullWidth":"athenaeum-page-container-fullWidth","scale":"athenaeum-page-container-scale","row":"athenaeum-page-container-row","pageRow":"athenaeum-page-container-pageRow","alertRow":"athenaeum-page-container-alertRow","header":"athenaeum-page-container-header","content":"athenaeum-page-container-content","noMargin":"athenaeum-page-container-noMargin"};
styleInject(css_248z$17);

class PageHeader extends BaseComponent {
  constructor() {
    super(...arguments);
    // To override minifier renaming.
    this.typeName = "PageHeader";
  }
  onClickAsync() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
      yield (_b = (_a = this.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, this);
    });
  }
  renderTitle() {
    const title = this.props.title;
    return typeof title === "function" ? title(this) : ( /*#__PURE__*/React.createElement(React.Fragment, null, this.toMultiLines(title)));
  }
  render() {
    const style = this.props.wideHeader && this.props.wideHeaderBackgroundImage ? {
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${this.props.wideHeaderBackgroundImage})`
    } : {};
    const subtitleClassname = this.props.withTabs ? styles$_.noMargin : "";
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$_.header, styles$_.row, !this.props.wideHeader && "row", this.props.className),
      "data-wideheader": String(this.props.wideHeader),
      style: style
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$_.content
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
      onClick: this.onClickAsync.bind(this)
    }, this.renderTitle()), this.props.subtitle && ( /*#__PURE__*/React.createElement("h2", {
      className: subtitleClassname
    }, this.props.subtitle))), this.props.children), !this.props.wideHeader && !this.props.withTabs && ( /*#__PURE__*/React.createElement("hr", null)));
  }
}
PageHeader.typeName = "PageHeader";

class PageRow extends BaseComponent {
  minimize(duration = undefined) {
    const node = this.getNode();
    const properties = {
      opacity: 0,
      height: 0,
      marginTop: 0,
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0
    };
    if (duration) {
      node.animate(properties, duration);
    } else {
      node.animate(properties);
    }
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(styles$_.row, "row", this.props.className)
    }, this.props.children);
  }
}

var css_248z$16 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-spinner-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-spinner-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-spinner-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-spinner-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-spinner-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-spinner-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-spinner-spinner {\n  cursor: wait;\n  display: flex;\n  justify-content: center;\n}\n.athenaeum-spinner-spinner .athenaeum-spinner-overlay {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: black;\n  opacity: 0;\n  z-index: 1000;\n}\n.athenaeum-spinner-spinner .athenaeum-spinner-overlay.athenaeum-spinner-local {\n  z-index: 100;\n  position: absolute;\n}\n.athenaeum-spinner-spinner .athenaeum-spinner-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n  display: none;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.athenaeum-spinner-spinner .athenaeum-spinner-container .athenaeum-spinner-background {\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  border: 2px solid white;\n  border-radius: 50%;\n}\n.athenaeum-spinner-spinner .athenaeum-spinner-container .athenaeum-spinner-circle {\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  border: 2px solid rgb(254, 80, 0);\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: athenaeum-spinner-spin 4s infinite linear;\n}\n@keyframes athenaeum-spinner-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}";
var styles$Z = {"font-renta":"athenaeum-spinner-font-renta","color-schema-renta_black":"athenaeum-spinner-color-schema-renta_black","color-schema-renta_white":"athenaeum-spinner-color-schema-renta_white","color-schema-renta_orange":"athenaeum-spinner-color-schema-renta_orange","color-schema-renta_green":"athenaeum-spinner-color-schema-renta_green","color-schema-renta_blue":"athenaeum-spinner-color-schema-renta_blue","spinner":"athenaeum-spinner-spinner","overlay":"athenaeum-spinner-overlay","local":"athenaeum-spinner-local","container":"athenaeum-spinner-container","background":"athenaeum-spinner-background","circle":"athenaeum-spinner-circle","spin":"athenaeum-spinner-spin"};
styleInject(css_248z$16);

const SPINNER_CURSOR_DELAY = 150;
const SPINNER_BACKGROUND_DELAY = 1000;
class Spinner extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      showCursor: false,
      showSpinner: false
    };
  }
  get opacity() {
    return this.props.noShading ? 0.00 : this.props.global ? 0.30 : 0.15;
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      yield this.showSpinnerDelayAsync();
    });
  }
  showSpinnerDelayAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield Utility.wait(this.props.delay || SPINNER_CURSOR_DELAY);
      if (this.isMounted) {
        yield this.setState({
          showCursor: true
        });
        yield Utility.wait(this.props.delay || SPINNER_BACKGROUND_DELAY);
      }
      if (this.isMounted) {
        yield this.setState({
          showSpinner: true
        });
        if (this.props.onDelay) {
          yield this.props.onDelay();
        }
      }
    });
  }
  render() {
    if (this.state.showCursor) {
      const localStyle = !this.props.global && styles$Z.local;
      const overlayStyle = {};
      const containerStyle = {};
      if (this.state.showSpinner) {
        overlayStyle.opacity = this.opacity;
        containerStyle.display = "flex";
      }
      return /*#__PURE__*/React.createElement("div", {
        className: styles$Z.spinner
      }, /*#__PURE__*/React.createElement("div", {
        className: this.css(styles$Z.overlay, localStyle),
        style: overlayStyle
      }), /*#__PURE__*/React.createElement("div", {
        className: styles$Z.container,
        style: containerStyle
      }, /*#__PURE__*/React.createElement("span", {
        className: styles$Z.background
      }), /*#__PURE__*/React.createElement("span", {
        className: styles$Z.circle
      })));
    }
    return null;
  }
}

//Autogenerated
class DocumentPreviewModalLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.previewLanguageItemName = `Preview`;
    this.downloadLanguageItemName = `Download`;
    //Initializer
    this.set(this.previewLanguageItemName, {
      language: `en`,
      value: `Preview`
    }, {
      language: `uk`,
      value: `Переглянути`
    }, {
      language: `sv`,
      value: `Förhandsvisning`
    }, {
      language: `ru`,
      value: `Предпросмотр`
    }, {
      language: `pl`,
      value: `Podgląd`
    }, {
      language: `nb`,
      value: `Forhåndsvisning`
    }, {
      language: `fi`,
      value: `Esikatselu`
    }, {
      language: `da`,
      value: `Eksempel`
    });
    this.set(this.downloadLanguageItemName, {
      language: `en`,
      value: `Download`
    }, {
      language: `uk`,
      value: `Завантажити`
    }, {
      language: `sv`,
      value: `Ladda ner`
    }, {
      language: `ru`,
      value: `Загрузить`
    }, {
      language: `pl`,
      value: `Pobierz`
    }, {
      language: `nb`,
      value: `Last ned`
    }, {
      language: `fi`,
      value: `Lataa`
    }, {
      language: `da`,
      value: `Download`
    });
  }
  /**
  /* "Preview" (Preview)
  */
  get preview() {
    return this.get(this.previewLanguageItemName);
  }
  /**
  /* "Download" (Download)
  */
  get download() {
    return this.get(this.downloadLanguageItemName);
  }
}
//Singleton
var DocumentPreviewModalLocalizer$1 = new DocumentPreviewModalLocalizer();

var css_248z$15 = ".athenaeum-document-preview-modal-documentPreviewModal > div .athenaeum-document-preview-modal-body {\n  display: flex;\n}\n.athenaeum-document-preview-modal-documentPreviewModal > div .athenaeum-document-preview-modal-body .athenaeum-document-preview-modal-contentA4 {\n  background-color: #525659;\n  margin: auto;\n}\n.athenaeum-document-preview-modal-documentPreviewModal > div .athenaeum-document-preview-modal-body iframe {\n  border: none;\n  overflow: hidden;\n}";
var styles$Y = {"documentPreviewModal":"athenaeum-document-preview-modal-documentPreviewModal","body":"athenaeum-document-preview-modal-body","contentA4":"athenaeum-document-preview-modal-contentA4"};
styleInject(css_248z$15);

const A4 = {
  width: 595,
  height: 842
};
class DocumentSize {
  constructor(width = A4.width, height = A4.height, zoom = 100) {
    this.width = width;
    this.height = height;
    this.zoom = zoom;
  }
  getSrc(data) {
    return data && data.src ? this.zoom > 0
    // ? `${data.src}#zoom=${this.zoom}`
    ? `${Utility.toObjectUrl(data)}#zoom=${this.zoom}` : Utility.toObjectUrl(data) : "";
  }
  static getDocumentSize(width, height, size) {
    const toolbarHeight = 43;
    const deltaX = 32;
    const deltaY = ch.desktop ? 86 + 16 + toolbarHeight : 45 + 86 + 16 + toolbarHeight;
    width = width > deltaX ? width - deltaX : 0;
    height = height > deltaY ? height - deltaY : 0;
    const k1 = width / A4.width;
    const k2 = height / A4.height;
    const scaleHeight = k1 >= k2;
    const zoomK = ch.desktop ? 0.72 : scaleHeight ? 0.71 : 0.72;
    const modalK = size == DocumentPreviewSize.Medium ? 0.82 : 0.99;
    let zoom;
    if (scaleHeight) {
      const k = modalK * k2;
      width = k * A4.width;
      height = modalK * height + toolbarHeight;
      zoom = zoomK * k * 100;
    } else {
      const k = modalK * k1;
      height = k * A4.height + toolbarHeight;
      width = modalK * width;
      zoom = zoomK * k * 100;
    }
    return new DocumentSize(width, height, zoom);
  }
}
class DocumentPreviewModal extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isLoading: false,
      data: null,
      model: new DocumentPreviewModel(),
      url: null
    };
    this._modalRef = /*#__PURE__*/React.createRef();
  }
  onToggleAsync(isOpen) {
    return __awaiter(this, void 0, void 0, function* () {
      if (isOpen) {
        this.state.data = yield this.fetchDataAsync();
        yield this.reRenderAsync();
      } else {
        yield this.setState({
          data: null
        });
      }
    });
  }
  geDocumentSize() {
    const node = this.getNode();
    const width = node.width() || 0;
    const height = node.height() || 0;
    return DocumentSize.getDocumentSize(width, height, this.model.size);
  }
  download() {
    if (this.state.url) {
      return ch.getLayout().downloadUrl(this.state.url);
    }
    const document = this.state.data;
    if (document) {
      return ch.getLayout().download(document);
    }
  }
  renderToolbar() {
    return /*#__PURE__*/React.createElement(Icon, {
      name: "fa-download",
      className: "download",
      style: IconStyle.Solid,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.download();
      }),
      tooltip: DocumentPreviewModalLocalizer$1.download
    });
  }
  fetchDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (typeof this.model.document === "function") {
        const callback = this.model.document;
        return yield callback(this);
      }
      return this.model.document;
    });
  }
  getEndpoint() {
    return "";
  }
  isAsync() {
    return true;
  }
  openAsync(model) {
    return __awaiter(this, void 0, void 0, function* () {
      if (typeof model === "string") {
        yield this.setState({
          url: model
        });
        yield this._modalRef.current.toggleAsync();
        return;
      }
      yield this.setState({
        model
      });
      yield this._modalRef.current.toggleAsync();
    });
  }
  get isOpen() {
    return !!this._modalRef.current && this._modalRef.current.isOpen;
  }
  get model() {
    return this.state.model;
  }
  get modal() {
    return this._modalRef.current;
  }
  get title() {
    return this.model.title || "Document preview";
  }
  get subtitle() {
    return this.model.subtitle ? this.model.subtitle : this.state.data ? this.state.data.name : null;
  }
  canReload() {
    return this.isOpen;
  }
  hasSpinner() {
    return true;
  }
  render() {
    var _a, _b;
    const documentSize = this.geDocumentSize();
    return /*#__PURE__*/React.createElement(Modal, {
      id: this.id,
      ref: this._modalRef,
      className: styles$Y.documentPreviewModal,
      bodyClassName: styles$Y.body,
      title: this.title || DocumentPreviewModalLocalizer$1.preview,
      subtitle: this.subtitle || "...",
      info: true,
      size: ModalSize.Auto,
      toolbar: () => this.renderToolbar(),
      onToggle: (sender, isOpen) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onToggleAsync(isOpen);
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$Y.contentA4
    }, this.state.url && ( /*#__PURE__*/React.createElement("object", {
      data: this.state.url,
      width: documentSize.width,
      height: documentSize.height
    }, (_a = this.state.data) === null || _a === void 0 ? void 0 : _a.name)), !this.state.url && ( /*#__PURE__*/React.createElement("object", {
      data: documentSize.getSrc(this.state.data),
      width: documentSize.width,
      height: documentSize.height
    }, (_b = this.state.data) === null || _b === void 0 ? void 0 : _b.name)), this.isSpinning() && ( /*#__PURE__*/React.createElement(Spinner, {
      noShading: true
    }))));
  }
}

var JustifyContent;
(function (JustifyContent) {
  JustifyContent[JustifyContent["Start"] = 0] = "Start";
  JustifyContent[JustifyContent["Center"] = 1] = "Center";
  JustifyContent[JustifyContent["End"] = 2] = "End";
  JustifyContent[JustifyContent["SpaceBetween"] = 3] = "SpaceBetween";
})(JustifyContent || (JustifyContent = {}));
class Inline extends BaseComponent {
  getPaddingStyle(index, length) {
    return length > 0 ? length === 1 ? "p-1-except-left p-1-except-right" : index === 0 ? "p-1-except-left" : index === this.children.length - 1 ? "p-1-except-right" : "p-1" : "";
  }
  renderItem(item, index, length) {
    const paddingStyle = this.getPaddingStyle(index, length);
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: this.css(paddingStyle)
    }, item);
  }
  get justify() {
    return this.props.justify || JustifyContent.Start;
  }
  get justifyContentStyles() {
    switch (this.justify) {
      case JustifyContent.Center:
        return "justify-content-center";
      case JustifyContent.End:
        return "justify-content-end";
      case JustifyContent.SpaceBetween:
        return "justify-content-between";
      default:
        return "justify-content-start";
    }
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.css("flex-row align-items-center", this.mobile ? "" : "d-flex", this.justifyContentStyles, this.props.className)
    }, this.props.children && this.children.length > 0 && this.children.map((item, index) => this.renderItem(item, index, this.children.length)));
  }
}

//Autogenerated
class FormLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Initializer
  }
}
//Singleton
var FormLocalizer$1 = new FormLocalizer();

class Form extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      validationErrors: []
    };
    this._onClickInvoking = false;
  }
  handleKeydownAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = event.target;
      const preventSubmit = event.keyCode === 13 && !this.props.submitOnEnter && target.tagName != 'TEXTAREA';
      if (preventSubmit) {
        event.preventDefault();
      }
    });
  }
  invokeHandleSubmitAsync(data, isValid) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._onClickInvoking) {
        try {
          this._onClickInvoking = true;
          if (this.props.onSubmit && (this.props.noValidate || isValid)) {
            yield this.props.onSubmit(this, data);
          }
        } finally {
          this._onClickInvoking = false;
        }
      }
    });
  }
  handleSubmitAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      const inputs = this.inputs;
      let isValid = true;
      const data = new Dictionary();
      yield Utility.forEachAsync(inputs, input => __awaiter(this, void 0, void 0, function* () {
        yield input.validateAsync();
        isValid = isValid && input.isValid();
        data.setValue(input.getName(), input.getValue());
      }));
      yield this.invokeHandleSubmitAsync(data, isValid);
      return false;
    });
  }
  setReadonlyAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      const inputs = this.inputs;
      inputs.forEach(input => input.setReadonlyAsync(value));
    });
  }
  getInputs(component) {
    const inputs = [];
    const input = component;
    if (input.isInput && input.isInput()) {
      inputs.push(input);
    }
    component.childComponents.forEach(childComponent => {
      const childInputs = this.getInputs(childComponent);
      inputs.push(...childInputs);
    });
    return inputs;
  }
  get inputs() {
    return this.getInputs(this);
  }
  validateAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      let isValid = true;
      yield Utility.forEachAsync(this.inputs, input => __awaiter(this, void 0, void 0, function* () {
        yield input.validateAsync();
        isValid = isValid && input.isValid();
      }));
      return isValid;
    });
  }
  setValidationErrorsAsync(...validationErrors) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        validationErrors: validationErrors
      });
    });
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.initializeAsync.call(this);
      if (this.props.readonly) {
        yield this.setReadonlyAsync(true);
      }
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const newReadonly = nextProps.readonly != null && nextProps.readonly !== this.props.readonly;
      if (newReadonly) {
        const readonly = nextProps.readonly || false;
        yield this.setReadonlyAsync(readonly);
      }
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  render() {
    const inlineStyle = this.props.inline && styles$16.inline;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/forbid-elements -- Form component is a wrapper for the form element.
      React.createElement("form", {
        className: this.css(styles$16.form, inlineStyle, this.props.className),
        onKeyDown: e => __awaiter(this, void 0, void 0, function* () {
          return yield this.handleKeydownAsync(e);
        }),
        onSubmit: e => __awaiter(this, void 0, void 0, function* () {
          return yield this.handleSubmitAsync(e);
        })
      }, this.state.validationErrors.length > 0 && /*#__PURE__*/React.createElement("ul", {
        className: styles$16.errorList
      }, this.state.validationErrors.map(error => ( /*#__PURE__*/React.createElement("li", {
        key: error
      }, /*#__PURE__*/React.createElement("span", null, FormLocalizer$1.get(error)))))), this.props.inline ? /*#__PURE__*/React.createElement(Inline, null, this.children) : this.children)
    );
  }
}
Form.defaultProps = {
  submitOnEnter: true
};

var css_248z$14 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-popover-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-popover-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-popover-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-popover-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-popover-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-popover-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-popover-popover {\n  position: relative;\n  display: none;\n}\n.athenaeum-popover-popover.athenaeum-popover-centered {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  width: 500px;\n}\n.athenaeum-popover-popover.athenaeum-popover-open {\n  display: block;\n}\n.athenaeum-popover-popover .athenaeum-popover-content {\n  position: absolute;\n  min-width: 200px;\n  background-color: white;\n  border-radius: 6px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  padding: 8px;\n  z-index: 1000;\n}\n.athenaeum-popover-popover .athenaeum-popover-content.athenaeum-popover-left {\n  right: 0;\n}\n.athenaeum-popover-popover .athenaeum-popover-content.athenaeum-popover-right {\n  left: 0;\n}\n.athenaeum-popover-popover .athenaeum-popover-content.athenaeum-popover-top {\n  bottom: 26px;\n}\n.athenaeum-popover-popover .athenaeum-popover-content.athenaeum-popover-bottom {\n  top: 0px;\n}\n.athenaeum-popover-popover .athenaeum-popover-content.athenaeum-popover-centered {\n  width: 500px;\n  margin: auto;\n  top: 50%;\n}\n.athenaeum-popover-popover .athenaeum-popover-content.athenaeum-popover-controls {\n  padding: 0.5rem;\n}";
var styles$X = {"font-renta":"athenaeum-popover-font-renta","color-schema-renta_black":"athenaeum-popover-color-schema-renta_black","color-schema-renta_white":"athenaeum-popover-color-schema-renta_white","color-schema-renta_orange":"athenaeum-popover-color-schema-renta_orange","color-schema-renta_green":"athenaeum-popover-color-schema-renta_green","color-schema-renta_blue":"athenaeum-popover-color-schema-renta_blue","popover":"athenaeum-popover-popover","centered":"athenaeum-popover-centered","open":"athenaeum-popover-open","content":"athenaeum-popover-content","left":"athenaeum-popover-left","right":"athenaeum-popover-right","top":"athenaeum-popover-top","bottom":"athenaeum-popover-bottom","controls":"athenaeum-popover-controls"};
styleInject(css_248z$14);

class Popover extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isOpen: false,
      containerId: null
    };
  }
  toggleAsync(containerId = null) {
    return __awaiter(this, void 0, void 0, function* () {
      if (containerId) {
        const state = this.state;
        state.containerId = containerId;
      }
      if (this.state.isOpen) {
        yield this.closeAsync();
      } else {
        yield this.openAsync();
      }
    });
  }
  openAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isOpen: true
      });
      if (this.props.onToggle) {
        yield this.props.onToggle(this, true);
      }
    });
  }
  closeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isOpen: false
      });
      if (this.props.onToggle) {
        yield this.props.onToggle(this, false);
      }
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const targetNode = e.target;
      const outside = Utility.clickedOutside(targetNode, this.id, this.state.containerId, "span");
      if (outside) {
        yield this.closeAsync();
      }
    });
  }
  onGlobalKeydown(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (e.keyCode === 27) {
        yield this.closeAsync();
      }
    });
  }
  get positionStyles() {
    let positionStyles = "";
    if (this.props.align === Align.Top) {
      positionStyles += `${styles$X.top}`;
    } else {
      positionStyles += `${styles$X.bottom}`;
    }
    if (this.props.justify === Justify.Right) {
      positionStyles += ` ${styles$X.right}`;
    } else {
      positionStyles += ` ${styles$X.left}`;
    }
    if (this.props.center) {
      positionStyles += ` ${styles$X.centered}`;
    }
    return positionStyles;
  }
  renderPopover() {
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(styles$X.popover, this.state.isOpen && styles$X.open, this.props.center && styles$X.centered, this.props.className)
    }, /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$X.content, this.positionStyles, this.props.controls && styles$X.controls)
    }, this.props.children));
  }
  get isOpen() {
    return this.state.isOpen;
  }
  render() {
    const containerElement = this.state.containerId ? document.getElementById(this.state.containerId) : null;
    if (containerElement && this.state.isOpen) {
      return /*#__PURE__*/ReactDOM.createPortal(this.renderPopover(), containerElement);
    }
    return null;
  }
}
Popover.defaultProps = {
  align: Align.Bottom,
  justify: Justify.Left
};

var css_248z$13 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-description-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-description-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-description-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-description-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-description-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-description-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}";
var styles$W = {"font-renta":"athenaeum-description-font-renta","color-schema-renta_black":"athenaeum-description-color-schema-renta_black","color-schema-renta_white":"athenaeum-description-color-schema-renta_white","color-schema-renta_orange":"athenaeum-description-color-schema-renta_orange","color-schema-renta_green":"athenaeum-description-color-schema-renta_green","color-schema-renta_blue":"athenaeum-description-color-schema-renta_blue"};
styleInject(css_248z$13);

class Description extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      model: this.props.model || new DescriptionModel()
    };
    this._popoverRef = /*#__PURE__*/React.createRef();
  }
  onChangeAsync(data) {
    return __awaiter(this, void 0, void 0, function* () {
      const description = data.getValue("description") || "";
      yield this.closeAsync();
      if (description != this.model.description) {
        this.model.description = description;
        yield this.setState({
          model: this.model
        });
        if (this.model.onChange) {
          yield this.model.onChange(description);
        }
      }
    });
  }
  get popover() {
    return this._popoverRef.current;
  }
  toggleAsync(containerId, model) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        model
      });
      yield this.popover.toggleAsync(containerId);
    });
  }
  openAsync(containerId, model) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.toggleAsync(containerId, model);
    });
  }
  closeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.popover.closeAsync();
    });
  }
  get model() {
    return this.state.model;
  }
  render() {
    var _a;
    return /*#__PURE__*/React.createElement(Popover, {
      ref: this._popoverRef,
      className: this.css(styles$W.description, this.model.className),
      justify: this.model.justify,
      align: this.model.align
    }, /*#__PURE__*/React.createElement(Form, {
      onSubmit: (sender, data) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onChangeAsync(data);
      })
    }, /*#__PURE__*/React.createElement(TextAreaInput, {
      autoFocus: true,
      id: "description",
      className: "mb-2",
      cols: 50,
      rows: 4,
      maxLength: (_a = this.model.maxLength) !== null && _a !== void 0 ? _a : 255,
      readonly: this.model.readonly,
      value: this.model.description
    }), !this.model.readonly && ( /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
      submit: true,
      icon: {
        name: "fa fa-check",
        size: IconSize.Large
      },
      type: ButtonType.Success
    })))));
  }
}

//Autogenerated
class MessageBoxLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.okLanguageItemName = `Ok`;
    this.areYouSureLanguageItemName = `AreYouSure`;
    this.commentLanguageItemName = `Comment`;
    this.yesLanguageItemName = `Yes`;
    this.noLanguageItemName = `No`;
    this.abortLanguageItemName = `Abort`;
    this.retryLanguageItemName = `Retry`;
    this.ignoreLanguageItemName = `Ignore`;
    this.cancelLanguageItemName = `Cancel`;
    //Initializer
    this.set(this.okLanguageItemName, {
      language: `en`,
      value: `Ok`
    }, {
      language: `uk`,
      value: `Ok`
    }, {
      language: `sv`,
      value: `Ok`
    }, {
      language: `ru`,
      value: `Ок`
    }, {
      language: `pl`,
      value: `Ok`
    }, {
      language: `nb`,
      value: `Ok`
    }, {
      language: `fi`,
      value: `Ok`
    }, {
      language: `da`,
      value: `Ok`
    });
    this.set(this.areYouSureLanguageItemName, {
      language: `en`,
      value: `Are you sure?`
    }, {
      language: `uk`,
      value: `Ви впевнені?`
    }, {
      language: `sv`,
      value: `Är du säker?`
    }, {
      language: `ru`,
      value: `Вы уверены?`
    }, {
      language: `pl`,
      value: `Czy jesteś pewien?`
    }, {
      language: `nb`,
      value: `Er du sikker?`
    }, {
      language: `fi`,
      value: `Oletko varma?`
    }, {
      language: `da`,
      value: `Er du sikker?`
    });
    this.set(this.commentLanguageItemName, {
      language: `en`,
      value: `Please leave a comment`
    }, {
      language: `uk`,
      value: `Будьласка, залиште коментар`
    }, {
      language: `sv`,
      value: `Var vänlig och lämna en kommentar`
    }, {
      language: `ru`,
      value: `Пожалуйста, оставьте комментарий`
    }, {
      language: `pl`,
      value: `Dodaj komentarz`
    }, {
      language: `nb`,
      value: `Vennligst legg igjen en kommentar`
    }, {
      language: `fi`,
      value: `Ole hyvä ja kommentoi`
    }, {
      language: `da`,
      value: `Efterlad en kommentar`
    });
    this.set(this.yesLanguageItemName, {
      language: `en`,
      value: `Yes`
    }, {
      language: `uk`,
      value: `Так`
    }, {
      language: `sv`,
      value: `Ja`
    }, {
      language: `ru`,
      value: `Да`
    }, {
      language: `pl`,
      value: `Tak`
    }, {
      language: `nb`,
      value: `NB: Yes`
    }, {
      language: `fi`,
      value: `Kyllä`
    }, {
      language: `da`,
      value: `Ja`
    });
    this.set(this.noLanguageItemName, {
      language: `en`,
      value: `No`
    }, {
      language: `uk`,
      value: `Ні`
    }, {
      language: `sv`,
      value: `Nej`
    }, {
      language: `ru`,
      value: `Нет`
    }, {
      language: `pl`,
      value: `Nie`
    }, {
      language: `nb`,
      value: `NB: No`
    }, {
      language: `fi`,
      value: `Ei`
    }, {
      language: `da`,
      value: `Nej`
    });
    this.set(this.abortLanguageItemName, {
      language: `en`,
      value: `Abort`
    }, {
      language: `uk`,
      value: `Перервати`
    }, {
      language: `sv`,
      value: `Avbryt`
    }, {
      language: `ru`,
      value: `Прервать`
    }, {
      language: `pl`,
      value: `Anulować`
    }, {
      language: `nb`,
      value: `NB: Abort`
    }, {
      language: `fi`,
      value: `Keskeytä`
    }, {
      language: `da`,
      value: `Afbryd`
    });
    this.set(this.retryLanguageItemName, {
      language: `en`,
      value: `Retry`
    }, {
      language: `uk`,
      value: `Повторити`
    }, {
      language: `sv`,
      value: `Försök igen`
    }, {
      language: `ru`,
      value: `Повторить`
    }, {
      language: `pl`,
      value: `Spróbuj ponownie`
    }, {
      language: `nb`,
      value: `NB: Retry`
    }, {
      language: `fi`,
      value: `Yritä uudelleen`
    }, {
      language: `da`,
      value: `Prøv igen`
    });
    this.set(this.ignoreLanguageItemName, {
      language: `en`,
      value: `Ignore`
    }, {
      language: `uk`,
      value: `Нехтувати`
    }, {
      language: `sv`,
      value: `Ignorera`
    }, {
      language: `ru`,
      value: `Игнорировать`
    }, {
      language: `pl`,
      value: `Ignoruj`
    }, {
      language: `nb`,
      value: `NB: Ignore`
    }, {
      language: `fi`,
      value: `Ohita`
    }, {
      language: `da`,
      value: `Ignorer`
    });
    this.set(this.cancelLanguageItemName, {
      language: `en`,
      value: `Cancel`
    }, {
      language: `uk`,
      value: `Перервати`
    }, {
      language: `sv`,
      value: `Avbryt`
    }, {
      language: `ru`,
      value: `Отмена`
    }, {
      language: `pl`,
      value: `Anuluj`
    }, {
      language: `nb`,
      value: `NB: Cancel`
    }, {
      language: `fi`,
      value: `Peruuta`
    }, {
      language: `da`,
      value: `Annuller`
    });
  }
  /**
  /* "Ok" (Ok)
  */
  get ok() {
    return this.get(this.okLanguageItemName);
  }
  /**
  /* "AreYouSure" (Are you sure?)
  */
  get areYouSure() {
    return this.get(this.areYouSureLanguageItemName);
  }
  /**
  /* "Comment" (Please leave a comment)
  */
  get comment() {
    return this.get(this.commentLanguageItemName);
  }
  /**
  /* "Yes" (Yes)
  */
  get yes() {
    return this.get(this.yesLanguageItemName);
  }
  /**
  /* "No" (No)
  */
  get no() {
    return this.get(this.noLanguageItemName);
  }
  /**
  /* "Abort" (Abort)
  */
  get abort() {
    return this.get(this.abortLanguageItemName);
  }
  /**
  /* "Retry" (Retry)
  */
  get retry() {
    return this.get(this.retryLanguageItemName);
  }
  /**
  /* "Ignore" (Ignore)
  */
  get ignore() {
    return this.get(this.ignoreLanguageItemName);
  }
  /**
  /* "Cancel" (Cancel)
  */
  get cancel() {
    return this.get(this.cancelLanguageItemName);
  }
}
//Singleton
var MessageBoxLocalizer$1 = new MessageBoxLocalizer();

var css_248z$12 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-message-box-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-message-box-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-message-box-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-message-box-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-message-box-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-message-box-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-message-box-messageBox {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1150;\n  display: none;\n}\n.athenaeum-message-box-messageBox.athenaeum-message-box-opened {\n  display: block;\n}\n.athenaeum-message-box-messageBox.athenaeum-message-box-processing {\n  cursor: wait;\n}\n.athenaeum-message-box-messageBox.athenaeum-message-box-processing textarea {\n  cursor: wait;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-overlay {\n  width: 100%;\n  height: 100%;\n  background-color: black;\n  opacity: 0.5;\n  position: absolute;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-content {\n  width: 300px;\n  background-color: white;\n  position: relative;\n  top: 40%;\n  margin: auto;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  text-align: center;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n  border-radius: 6px;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-content .athenaeum-message-box-caption {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-content .athenaeum-message-box-caption > i {\n  padding: 8px;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-content .athenaeum-message-box-caption > i.athenaeum-message-box-danger {\n  color: #a94442;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-content .athenaeum-message-box-caption > h5 {\n  white-space: normal;\n}\n.athenaeum-message-box-messageBox .athenaeum-message-box-commentInput {\n  margin-bottom: 0.5rem;\n}";
var styles$V = {"font-renta":"athenaeum-message-box-font-renta","color-schema-renta_black":"athenaeum-message-box-color-schema-renta_black","color-schema-renta_white":"athenaeum-message-box-color-schema-renta_white","color-schema-renta_orange":"athenaeum-message-box-color-schema-renta_orange","color-schema-renta_green":"athenaeum-message-box-color-schema-renta_green","color-schema-renta_blue":"athenaeum-message-box-color-schema-renta_blue","messageBox":"athenaeum-message-box-messageBox","opened":"athenaeum-message-box-opened","processing":"athenaeum-message-box-processing","overlay":"athenaeum-message-box-overlay","content":"athenaeum-message-box-content","caption":"athenaeum-message-box-caption","danger":"athenaeum-message-box-danger","commentInput":"athenaeum-message-box-commentInput"};
styleInject(css_248z$12);

class MessageBox extends BaseComponent {
  constructor() {
    super(...arguments);
    this._model = null;
    this.state = {
      isOpened: false,
      comment: "",
      processing: false,
      model: null
    };
    this._commentRef = /*#__PURE__*/React.createRef();
    this._resolver = null;
  }
  toModel(titleOrModel, caption, buttons, icon) {
    let model = {};
    let data = titleOrModel;
    if (data) {
      if (typeof data === "function") {
        data = data();
      }
      if (typeof data === "string") {
        model.title = data;
      } else {
        model = data;
      }
    }
    model.title = model.title || MessageBoxLocalizer$1.areYouSure;
    model.caption = caption || model.caption;
    model.icon = icon || model.icon;
    if (buttons) {
      if (typeof buttons === "object") {
        const initialized = !!buttons.okButton || !!buttons.cancelButton || !!buttons.abortButton || !!buttons.retryButton || !!buttons.ignoreButton || !!buttons.yesButton || !!buttons.noButton;
        if (initialized) {
          model.buttons = MessageBoxButtons.Custom;
          model.okButton = buttons.okButton;
          model.cancelButton = buttons.cancelButton;
          model.abortButton = buttons.abortButton;
          model.retryButton = buttons.retryButton;
          model.ignoreButton = buttons.ignoreButton;
          model.yesButton = buttons.yesButton;
          model.noButton = buttons.noButton;
        }
      } else {
        model.buttons = buttons;
      }
    }
    return model;
  }
  getButtonLabel(button, defaultLabel) {
    return button && typeof button === "string" ? button : defaultLabel;
  }
  getIconName(icon) {
    if (icon) {
      if (typeof icon === "string") {
        return icon;
      }
      switch (icon) {
        case MessageBoxIcon.Hand:
          return "far hand-paper";
        case MessageBoxIcon.Stop:
          return "far stop-circle";
        case MessageBoxIcon.Error:
          return "far times-circle";
        case MessageBoxIcon.Question:
          return "question";
        case MessageBoxIcon.Exclamation:
          return "exclamation";
        case MessageBoxIcon.Warning:
          return "warning";
        case MessageBoxIcon.Asterisk:
          return "asterisk";
        case MessageBoxIcon.Information:
          return "information";
      }
    }
    return null;
  }
  getIconClassName(icon) {
    switch (icon) {
      case MessageBoxIcon.Error:
        return styles$V.danger;
    }
    return null;
  }
  get model() {
    var _a;
    return (_a = this._model) !== null && _a !== void 0 ? _a : this._model = this.toModel(this.props.title);
  }
  get buttons() {
    var _a;
    return (_a = this.model.buttons) !== null && _a !== void 0 ? _a : MessageBoxButtons.OK;
  }
  get hasOkButton() {
    return !!this.model.okButton || this.buttons == MessageBoxButtons.OK || this.buttons == MessageBoxButtons.OKCancel;
  }
  get hasCancelButton() {
    return !!this.model.cancelButton || this.buttons == MessageBoxButtons.OKCancel || this.buttons == MessageBoxButtons.YesNoCancel || this.buttons == MessageBoxButtons.RetryCancel;
  }
  get hasYesButton() {
    return !!this.model.yesButton || this.buttons == MessageBoxButtons.YesNo || this.buttons == MessageBoxButtons.YesNoCancel;
  }
  get hasNoButton() {
    return !!this.model.noButton || this.buttons == MessageBoxButtons.YesNo || this.buttons == MessageBoxButtons.YesNoCancel;
  }
  get hasAbortButton() {
    return !!this.model.abortButton || this.buttons == MessageBoxButtons.AbortRetryIgnore;
  }
  get hasRetryButton() {
    return !!this.model.retryButton || this.buttons == MessageBoxButtons.AbortRetryIgnore || this.buttons == MessageBoxButtons.RetryCancel;
  }
  get hasIgnoreButton() {
    return !!this.model.ignoreButton || this.buttons == MessageBoxButtons.AbortRetryIgnore;
  }
  get hasComment() {
    return this.state.isOpened ? !!this.model.comment : false;
  }
  get minLength() {
    return this.state.isOpened ? this.props.minLength || this.model.minLength || 0 : 0;
  }
  get canAccept() {
    return !this.hasComment || this.state.comment.length > this.minLength;
  }
  get processing() {
    return this.state.processing;
  }
  setCommentAsync(comment) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        comment
      });
    });
  }
  setDialogAsync(isOpened, nestedCheck = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted && this.state.isOpened != isOpened) {
        if (nestedCheck) {
          if (isOpened && MessageBox._current) {
            yield MessageBox._current.setDialogAsync(false, false);
            MessageBox._previous = MessageBox._current;
          }
        }
        yield this.setState({
          isOpened
        });
        if (nestedCheck) {
          MessageBox._current = isOpened ? this : null;
          if (!isOpened && MessageBox._previous) {
            yield MessageBox._previous.setDialogAsync(true, false);
            MessageBox._previous = null;
          }
        }
      }
    });
  }
  setProcessingAsync(processing) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        yield this.setState({
          processing
        });
      }
    });
  }
  invokeCloseAsync(dialogResult) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.callback) {
        if (!this.processing) {
          try {
            yield this.setProcessingAsync(true);
            yield this.props.callback(this, dialogResult, this.state.comment);
          } finally {
            yield this.setProcessingAsync(false);
          }
        }
      }
      if (this._resolver) {
        this._resolver(dialogResult);
        this._resolver = null;
      }
      yield this.setDialogAsync(false);
    });
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.isOpened) {
        yield this.invokeCloseAsync(DialogResult.None);
      } else {
        yield this.openAsync();
      }
    });
  }
  openAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setDialogAsync(true);
      if (this._commentRef.current) {
        this._commentRef.current.focus();
      }
    });
  }
  closeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeCloseAsync(DialogResult.None);
    });
  }
  showAsync(titleOrModel, caption, buttons, icon) {
    return __awaiter(this, void 0, void 0, function* () {
      this._model = this.toModel(titleOrModel, caption, buttons, icon);
      yield this.openAsync();
      return new Promise(resolve => {
        this._resolver = resolve;
      });
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const targetNode = e.target;
      const outside = Utility.clickedOutside(targetNode, `messageBox-content-${this.id}`);
      if (outside) {
        yield this.invokeCloseAsync(DialogResult.None);
      }
    });
  }
  onGlobalKeydown(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasComment) {
        yield this.invokeCloseAsync(DialogResult.None);
      } else {
        if (e.keyCode === 27) {
          yield this.invokeCloseAsync(DialogResult.None);
        }
      }
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const newProps = this.props.title != nextProps.title || this.props.minLength != nextProps.minLength;
      if (newProps) {
        this._model = null;
      }
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  renderDialog() {
    const openedStyle = this.state.isOpened && styles$V.opened;
    const processingStyle = this.processing && styles$V.processing;
    const icon = this.getIconName(this.model.icon);
    const iconStyle = this.getIconClassName(this.model.icon);
    return /*#__PURE__*/React.createElement("div", {
      id: "messageBox-" + this.id,
      className: this.css(styles$V.messageBox, openedStyle, processingStyle)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$V.overlay
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$V.content,
      id: `messageBox-content-${this.id}`
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$V.caption
    }, icon && /*#__PURE__*/React.createElement(Icon, {
      name: icon,
      className: iconStyle || undefined,
      size: IconSize.X3
    }), /*#__PURE__*/React.createElement("h5", null, this.toMultiLines(this.model.title))), this.hasComment && ( /*#__PURE__*/React.createElement(TextAreaInput, {
      ref: this._commentRef,
      required: true,
      noValidate: true,
      rows: 3,
      placeholder: this.model.placeholder || MessageBoxLocalizer$1.comment,
      className: styles$V.commentInput,
      value: this.state.comment,
      readonly: this.processing,
      onChange: (sender, value) => __awaiter(this, void 0, void 0, function* () {
        return yield this.setCommentAsync(value);
      })
    })), this.hasOkButton && ( /*#__PURE__*/React.createElement(Button, {
      block: true,
      id: "message-box-ok" + this.id,
      label: this.getButtonLabel(this.model.okButton, MessageBoxLocalizer$1.okLanguageItemName),
      type: ButtonType.Orange,
      disabled: this.processing || !this.canAccept,
      onClick: () => this.invokeCloseAsync(DialogResult.OK)
    })), this.hasYesButton && ( /*#__PURE__*/React.createElement(Button, {
      block: true,
      id: "message-box-yes" + this.id,
      label: this.getButtonLabel(this.model.yesButton, MessageBoxLocalizer$1.yesLanguageItemName),
      type: ButtonType.Orange,
      disabled: this.processing || !this.canAccept,
      onClick: () => this.invokeCloseAsync(DialogResult.Yes)
    })), this.hasAbortButton && ( /*#__PURE__*/React.createElement(Button, {
      block: true,
      id: "message-box-abort" + this.id,
      label: this.getButtonLabel(this.model.abortButton, MessageBoxLocalizer$1.abortLanguageItemName),
      type: ButtonType.Orange,
      disabled: this.processing,
      onClick: () => this.invokeCloseAsync(DialogResult.Abort)
    })), this.hasRetryButton && ( /*#__PURE__*/React.createElement(Button, {
      block: true,
      id: "message-box-retry" + this.id,
      label: this.getButtonLabel(this.model.retryButton, MessageBoxLocalizer$1.retryLanguageItemName),
      type: ButtonType.Orange,
      disabled: this.processing || !this.canAccept,
      onClick: () => this.invokeCloseAsync(DialogResult.Retry)
    })), this.hasIgnoreButton && ( /*#__PURE__*/React.createElement(Button, {
      block: true,
      id: "message-box-ignore" + this.id,
      label: this.getButtonLabel(this.model.ignoreButton, MessageBoxLocalizer$1.ignoreLanguageItemName),
      type: ButtonType.Blue,
      disabled: this.processing,
      onClick: () => this.invokeCloseAsync(DialogResult.Ignore)
    })), this.hasNoButton && ( /*#__PURE__*/React.createElement(Button, {
      block: true,
      id: "message-box-no" + this.id,
      label: this.getButtonLabel(this.model.noButton, MessageBoxLocalizer$1.noLanguageItemName),
      type: ButtonType.Blue,
      disabled: this.processing,
      onClick: () => this.invokeCloseAsync(DialogResult.No)
    })), this.hasCancelButton && ( /*#__PURE__*/React.createElement(Button, {
      block: true,
      id: "message-box-cancel" + this.id,
      label: this.getButtonLabel(this.model.cancelButton, MessageBoxLocalizer$1.cancelLanguageItemName),
      type: ButtonType.Default,
      disabled: this.processing,
      onClick: () => this.invokeCloseAsync(DialogResult.Cancel)
    }))));
  }
  render() {
    return /*#__PURE__*/ReactDOM.createPortal(this.renderDialog(), document.body);
  }
}
MessageBox._current = null;
MessageBox._previous = null;

//Autogenerated
class PageContainerLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.pageHelpLanguageItemName = `PageHelp`;
    //Initializer
    this.set(this.pageHelpLanguageItemName, {
      language: `en`,
      value: `Page help`
    }, {
      language: `uk`,
      value: `Довідка`
    }, {
      language: `sv`,
      value: `Sidhjälp`
    }, {
      language: `ru`,
      value: `Справка`
    }, {
      language: `pl`,
      value: `Pomoc strony`
    }, {
      language: `nb`,
      value: `Sidehjelp`
    }, {
      language: `fi`,
      value: `Sivun ohje`
    }, {
      language: `da`,
      value: `Hjælp til sider`
    });
  }
  /**
  /* "PageHelp" (Page help)
  */
  get pageHelp() {
    return this.get(this.pageHelpLanguageItemName);
  }
}
//Singleton
var PageContainerLocalizer$1 = new PageContainerLocalizer();

class PageContainer extends BaseAsyncComponent {
  constructor() {
    // Fields
    super(...arguments);
    this.state = {
      data: null,
      isLoading: false,
      alert: null,
      alertClassName: this.props.alertClassName || null
    };
    this._alertContainerRef = /*#__PURE__*/React.createRef();
    this._documentPreviewModalRef = /*#__PURE__*/React.createRef();
    this._descriptionRef = /*#__PURE__*/React.createRef();
    this._confirmationDialogRef = /*#__PURE__*/React.createRef();
    this._messageBoxRef = /*#__PURE__*/React.createRef();
    this._height = 0;
  }
  // Properties
  get manual() {
    const page = ch.findPage();
    return page ? page.getManualProps() : {};
  }
  get alert() {
    return this.state.alert;
  }
  // Methods
  toggleVerticalScroll() {
    if (!this.mobile && this.props.scale) {
      this.JQuery("html").addClass("vertical-scroll");
    } else {
      this.JQuery("html").removeClass("vertical-scroll");
    }
  }
  onAlertCloseAsync(sender, userInteraction = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const animation = sender.model.autoClose && !userInteraction;
      yield this.invokeHideAlertAsync(animation);
    });
  }
  invokeHideAlertAsync(animation) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.alert) {
        if (animation && this._alertContainerRef.current) {
          this._alertContainerRef.current.minimize(AthenaeumComponentsConstants.alertAnimationDelay);
          yield Utility.wait(AthenaeumComponentsConstants.alertAnimationDelay);
        }
        if (this.isMounted) {
          yield this.setState({
            alert: null
          });
        } else {
          this.state.alert = null;
        }
      }
      // force rerender the currently open Modal to make it hide the alert
      yield (_a = Modal.openInstance) === null || _a === void 0 ? void 0 : _a.reRenderAsync();
    });
  }
  getEndpoint() {
    return this.props.endpoint || "";
  }
  isAsync() {
    return this.getEndpoint().length > 0;
  }
  height() {
    if (this._height === 0) {
      const node = this.getNode();
      this._height = node.children().first().height() || 0;
    }
    const alertHeight = this._alertContainerRef.current ? this._alertContainerRef.current.outerHeight(true) : 0;
    return this._height - alertHeight;
  }
  onGlobalResize(e) {
    return __awaiter(this, void 0, void 0, function* () {
      this._height = 0;
    });
  }
  alertAsync(alert) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        alert: alert
      });
      // force rerender the currently open Modal to make it display the alert
      yield (_a = Modal.openInstance) === null || _a === void 0 ? void 0 : _a.reRenderAsync();
    });
  }
  hideAlertAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeHideAlertAsync(false);
    });
  }
  /**
   * @inheritDoc
   * @see ConfirmationDialog.confirmAsync
   */
  confirmAsync(title) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._confirmationDialogRef.current.confirmAsync(title);
    });
  }
  messageBoxAsync(titleOrModel, caption, buttons, icon) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._messageBoxRef.current.showAsync(titleOrModel, caption, buttons, icon);
    });
  }
  documentPreviewAsync(model) {
    return __awaiter(this, void 0, void 0, function* () {
      const documentPreviewModal = this._documentPreviewModalRef.current;
      yield documentPreviewModal.openAsync(model);
    });
  }
  descriptionAsync(containerId, model) {
    return __awaiter(this, void 0, void 0, function* () {
      const description = this._descriptionRef.current;
      yield description.toggleAsync(containerId, model);
    });
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this.toggleVerticalScroll();
      PageContainer.instance = this;
      yield _super.componentDidMount.call(this);
    });
  }
  componentWillUnmount() {
    const _super = Object.create(null, {
      componentWillUnmount: {
        get: () => super.componentWillUnmount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      PageContainer.instance = null;
      yield _super.componentWillUnmount.call(this);
    });
  }
  render() {
    var _a;
    const pageHeaderChildren = [];
    const nonPageHeaderChildren = [];
    this.childrenWithType.forEach(child => {
      if (typeof child.type !== "string" && child.type.typeName === PageHeader.typeName) {
        pageHeaderChildren.push(child);
      } else {
        nonPageHeaderChildren.push(child);
      }
    });
    const transparentStyle = this.props.transparent ? {
      backgroundColor: "transparent"
    } : {};
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$_.page, this.props.className, this.props.scale && styles$_.scale),
      id: this.id,
      "data-haswideheader": String(this.props.hasWideHeader)
    }, this.props.hasWideHeader && ( /*#__PURE__*/React.createElement("div", null, pageHeaderChildren)), /*#__PURE__*/React.createElement("div", {
      className: this.css("container", styles$_.container, this.props.fullHeight && styles$_.fullHeight, this.props.fullWidth && styles$_.fullWidth),
      style: transparentStyle
    }, ((_a = this.alert) === null || _a === void 0 ? void 0 : _a.message) && !Modal.openInstance && ( /*#__PURE__*/React.createElement(PageRow, {
      ref: this._alertContainerRef,
      className: this.css(styles$_.pageRow, styles$_.alertRow)
    }, /*#__PURE__*/React.createElement("div", {
      className: "col d-flex justify-content-center"
    }, /*#__PURE__*/React.createElement(Alert, {
      className: this.props.alertClassName,
      model: this.alert,
      onClose: this.onAlertCloseAsync.bind(this)
    })))), this.props.hasWideHeader ? nonPageHeaderChildren : this.props.children), this.manual.manual && ( /*#__PURE__*/React.createElement(Modal, {
      info: true,
      id: "page-help-info",
      title: this.manual.title || PageContainerLocalizer$1.pageHelp,
      content: this.manual.manual
    })), /*#__PURE__*/React.createElement(DocumentPreviewModal, {
      ref: this._documentPreviewModalRef
    }), /*#__PURE__*/React.createElement(Description, {
      ref: this._descriptionRef
    }), /*#__PURE__*/React.createElement(ConfirmationDialog, {
      ref: this._confirmationDialogRef
    }), /*#__PURE__*/React.createElement(MessageBox, {
      ref: this._messageBoxRef
    }));
  }
}
/**
 * {@link PageContainer} currently mounted on the DOM
 */
PageContainer.instance = null;
/**
 * @ts-expect-error - dare not touch the magic
 * noinspection JSUnusedLocalSymbols, JSVoidFunctionReturnValueUsed
 */
PageContainer.initialize = (() => ServiceProvider.addSingleton("IPageContainer", () => PageContainer.instance))();

//Autogenerated
class ModalLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.saveChangesLanguageItemName = `SaveChanges`;
    this.closeLanguageItemName = `Close`;
    //Initializer
    this.set(this.saveChangesLanguageItemName, {
      language: `en`,
      value: `Save changes`
    }, {
      language: `uk`,
      value: `Зберегти зміни`
    }, {
      language: `sv`,
      value: `Spara ändringar`
    }, {
      language: `ru`,
      value: `Сохранить изменения`
    }, {
      language: `pl`,
      value: `Zachowaj zmiany`
    }, {
      language: `nb`,
      value: `Lagre endringer`
    }, {
      language: `fi`,
      value: `Tallenna muutokset`
    }, {
      language: `da`,
      value: `Gem ændringer`
    });
    this.set(this.closeLanguageItemName, {
      language: `en`,
      value: `Close`
    }, {
      language: `uk`,
      value: `Закрити`
    }, {
      language: `sv`,
      value: `Stäng`
    }, {
      language: `ru`,
      value: `Закрыть`
    }, {
      language: `pl`,
      value: `Zamknij`
    }, {
      language: `nb`,
      value: `Lukke`
    }, {
      language: `fi`,
      value: `Sulje`
    }, {
      language: `da`,
      value: `Luk`
    });
  }
  /**
  /* "SaveChanges" (Save changes)
  */
  get saveChanges() {
    return this.get(this.saveChangesLanguageItemName);
  }
  /**
  /* "Close" (Close)
  */
  get close() {
    return this.get(this.closeLanguageItemName);
  }
}
//Singleton
var ModalLocalizer$1 = new ModalLocalizer();

var css_248z$11 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.modal .modal-dialog {\n  margin: 3rem auto !important;\n}\n.modal .modal-dialog .modal-content .modal-header {\n  padding: 1.75rem 2rem 1.25rem;\n  border-bottom: none;\n  align-items: center;\n  cursor: default;\n}\n.modal .modal-dialog .modal-content .modal-header .modal-header-content {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  border-bottom: 2px solid rgb(254, 80, 0);\n  width: 100%;\n  padding-bottom: 1rem;\n}\n.modal .modal-dialog .modal-content .modal-header .modal-header-content .modal-title {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n}\n.modal .modal-dialog .modal-content .modal-header .toolbar {\n  position: absolute;\n  right: 20px;\n  top: 25px;\n}\n.modal .modal-dialog .modal-content .modal-header .toolbar > i {\n  width: 44px;\n  padding: 1px;\n  text-align: center;\n  color: rgb(254, 80, 0);\n  border-radius: 2px;\n  cursor: pointer;\n  font-size: 2.25em;\n}\n.modal .modal-dialog .modal-content .modal-header .toolbar > i:hover {\n  color: #DADADA;\n}\n.modal .modal-dialog .modal-content .modal-header .toolbar > i:active {\n  color: #adadad;\n}\n.modal .modal-dialog .modal-content .modal-header .toolbar .download {\n  top: -5px;\n  position: relative;\n  font-size: 1.8em;\n}\n.modal .modal-dialog .modal-content .modal-header .mobile-toolbar > i:not(:first-child) {\n  margin-left: 8px;\n}\n.modal .modal-dialog .modal-content .modal-body {\n  padding: 0 2rem;\n  margin-bottom: 1.75rem;\n}\n.modal .modal-dialog .modal-content .modal-body .textFormatting {\n  margin-bottom: 0;\n  white-space: pre-wrap;\n}\n.modal .modal-dialog .default-maxWidth {\n  max-width: 475px;\n}\n.modal .modal-dialog.modal-dialog-bottom-left {\n  position: fixed;\n  bottom: 2rem;\n  left: 2rem;\n}\n@media screen and (max-width: 480px) {\n  .modal .modal-dialog.modal-dialog-bottom-left {\n    bottom: 3%;\n    left: unset;\n    padding-left: 5%;\n    padding-right: 5%;\n  }\n}\n.modal .modal-dialog.modal-auto {\n  margin: auto !important;\n  max-width: fit-content;\n}\n.modal .modal-dialog.modal-auto:before {\n  height: auto;\n}\n.modal .modal-dialog.mobile {\n  margin: 45px 0 0 0 !important;\n  max-width: 100%;\n  top: 100vh;\n  display: block !important;\n}\n.modal .modal-dialog.mobile:before {\n  height: auto;\n}\n.modal .modal-dialog.mobile .modal-content {\n  min-height: calc(100vh - 45px);\n  border-radius: 0;\n  border: 0;\n}\n.modal .modal-dialog.mobile.animation {\n  transition: top 0.15s ease-in-out;\n}\n.modal .modal-dialog-centered {\n  min-height: calc(100% - 6rem);\n}\n.modal .modal-dialog-scrollable {\n  max-height: calc(100% - 6rem);\n}\n\n.modal-open.mobile {\n  padding-right: 0 !important;\n}\n.modal-open.mobile .modal-backdrop.show {\n  opacity: 0;\n}\n.modal-open.mobile .modal.show .modal-dialog {\n  top: 0;\n}\n\n.modal-dialog-centered.modal-auto {\n  min-height: 100%;\n}\n.modal-dialog-centered.modal-auto:before {\n  height: auto;\n}";
styleInject(css_248z$11);

var ModalSize;
(function (ModalSize) {
  ModalSize[ModalSize["Default"] = 0] = "Default";
  ModalSize[ModalSize["Small"] = 1] = "Small";
  ModalSize[ModalSize["Large"] = 2] = "Large";
  ModalSize[ModalSize["ExtraLarge"] = 3] = "ExtraLarge";
  /*
   * Modal will resize according to content size
   */
  ModalSize[ModalSize["Auto"] = 4] = "Auto";
})(ModalSize || (ModalSize = {}));
var ModalPosition;
(function (ModalPosition) {
  ModalPosition[ModalPosition["Centered"] = 0] = "Centered";
  ModalPosition[ModalPosition["BottomLeft"] = 1] = "BottomLeft";
})(ModalPosition || (ModalPosition = {}));
class Modal extends BaseAsyncComponent {
  constructor() {
    // Fields
    super(...arguments);
    this.state = {
      isOpen: false,
      data: null,
      isLoading: false,
      openInstance: null
    };
    this._closeConfirmDialogRef = /*#__PURE__*/React.createRef();
    this._animation = true;
    this._modalRef = /*#__PURE__*/React.createRef();
    this._modalBodyRef = /*#__PURE__*/React.createRef();
    this._data = null;
    this._scrollY = 0;
    this._confirmed = false;
  }
  //  Properties
  /**
   * Get the currently open {@link Modal}
   */
  static get openInstance() {
    return this._openInstance;
  }
  get title() {
    return this.props.title || "...";
  }
  get subtitle() {
    return this.props.subtitle || "";
  }
  get content() {
    return this.props.content || "";
  }
  get modal() {
    return this._modalRef.current;
  }
  get scrollY() {
    return this._scrollY;
  }
  get sizeStyle() {
    if (this.fullWindow) {
      return this._animation ? "mobile" : "mobile animation";
    }
    switch (this.props.size) {
      case ModalSize.Small:
        return "modal-sm";
      case ModalSize.Large:
        return "modal-lg";
      case ModalSize.ExtraLarge:
        return "modal-xl";
      case ModalSize.Auto:
        return "modal-auto";
      default:
        return "default-maxWidth";
    }
  }
  get positionStyle() {
    switch (this.props.position) {
      case ModalPosition.BottomLeft:
        return "modal-dialog-bottom-left";
      case ModalPosition.Centered:
      default:
        return !this.fullWindow ? "modal-dialog-centered" : "";
    }
  }
  get scrollableStyle() {
    return this.props.isBodyScrollable ? "modal-dialog-scrollable" : "";
  }
  get data() {
    return this._data;
  }
  get isOpen() {
    return this.state.isOpen;
  }
  get isInfo() {
    return this.props.info || false;
  }
  get notResponsive() {
    return this.props.notResponsive == true;
  }
  /**
   * The modal takes the full size of the window (if mobile is true and responsive is true)
   */
  get fullWindow() {
    return !this.notResponsive && this.mobile;
  }
  get noHeader() {
    return this.props.noHeader === true;
  }
  get preventEsc() {
    return this.props.preventEsc === true;
  }
  get preventClosingOnOutsideClickValue() {
    return this.props.preventClosingOnOutsideClick ? "static" : undefined;
  }
  get body() {
    return this._modalBodyRef.current;
  }
  // Methods
  resolveCloseConfirm() {
    return this.props.closeConfirm ? typeof this.props.closeConfirm === "function" ? this.props.closeConfirm() : typeof this.props.closeConfirm === "boolean" ? "" : this.props.closeConfirm : null;
  }
  resolveCustomCloseButton() {
    return this.props.customCloseButton ? typeof this.props.customCloseButton === "boolean" ? ModalLocalizer$1.close : this.props.customCloseButton : null;
  }
  onModalBodyClick(e) {
    if (!this.isInfo) {
      return;
    }
    e.stopPropagation();
    if (this.props.preventClosingOnInsideClick) {
      return;
    }
    this.closeModal();
  }
  togglePageScroll(toggle) {
    if (this.fullWindow) {
      return;
    }
    if (toggle) {
      this.JQuery("html").addClass("prevent-scroll");
      return;
    }
    this.JQuery("html").removeClass("prevent-scroll");
  }
  setData(data = null) {
    if (data) {
      this._data = data;
    }
  }
  confirmNeededAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const confirmNeeded = !this._confirmed && this.resolveCloseConfirm() != null;
      if (confirmNeeded && this._closeConfirmDialogRef.current) {
        yield this._closeConfirmDialogRef.current.openAsync();
        return true;
      }
      return false;
    });
  }
  onOpenHandlerAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      this.togglePageScroll(true);
      if (ch.debug) {
        console.log("onOpenHandlerAsync");
      }
      const data = this.JQuery(event.relatedTarget).data("modal");
      if (data !== null && data !== undefined) {
        this.setData(this.transformData(data));
      }
      if (this.fullWindow) {
        this.JQuery("body").addClass("mobile");
      }
      yield this.setModalToOpenAsync();
    });
  }
  onCloseHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (yield this.confirmNeededAsync()) {
        this.openModal(false);
        return;
      }
      this.togglePageScroll(false);
      if (this.fullWindow) {
        this.JQuery("body").removeClass("mobile");
      }
      yield this.setModalToCloseAsync();
      this.scrollBack();
    });
  }
  onCloseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (yield this.confirmNeededAsync()) {
        return;
      }
      yield this.setModalToCloseAsync();
    });
  }
  scrollBack() {
    window.scrollTo(0, this.scrollY);
  }
  setModalToOpenAsync(animation = true) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.isOpen) {
        return;
      }
      this._confirmed = false;
      yield this.onPropBeforeOpen();
      const openInstance = this.state.openInstance || Modal._openInstance;
      yield this.setState({
        isOpen: true,
        openInstance
      });
      this.openModal(animation);
      yield this.onPropOpen();
      if (openInstance) {
        yield openInstance.closeAsync();
      }
      yield this.onPropToggle(true);
      if (ch.alert) {
        // force rerender PageContainer to make it hide the alert (now displayed in the opened Modal)
        yield (_a = PageContainer.instance) === null || _a === void 0 ? void 0 : _a.reRenderAsync();
      }
    });
  }
  setModalToCloseAsync(data = "") {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.state.isOpen) {
        return;
      }
      this._confirmed = true;
      yield this.onPropBeforeClose();
      const openInstance = this.state.openInstance;
      yield this.setState({
        isOpen: false,
        openInstance
      });
      this.closeModal();
      yield this.onPropCloseAsync(data);
      if (openInstance && !Modal._openInstance) {
        yield openInstance.openAsync();
        yield this.setState({
          openInstance: null
        });
      }
      yield this.onPropToggle(false);
    });
  }
  openModal(animation = true) {
    if (!this.modal) {
      return;
    }
    this._animation = animation;
    this.showBootstrapModal();
    Modal._openInstance = this;
  }
  closeModal() {
    var _a;
    if (!this.modal) {
      return;
    }
    this.hideBootstrapModal();
    if (Modal._openInstance === this) {
      Modal._openInstance = null;
    }
    if (ch.alert) {
      // force rerender PageContainer to make it display the alert (instead of the now hidden Modal)
      (_a = PageContainer.instance) === null || _a === void 0 ? void 0 : _a.reRender();
    }
  }
  //  Bootstrap Methods
  enableBootstrapEventHandlers() {
    if (!this.modal) {
      return;
    }
    const node = this.JQuery(this.modal);
    node.on("shown.bs.modal", event => __awaiter(this, void 0, void 0, function* () {
      return yield this.onOpenHandlerAsync(event);
    }));
    node.on("hide.bs.modal", () => __awaiter(this, void 0, void 0, function* () {
      return yield this.onCloseHandlerAsync();
    }));
  }
  disableBootstrapEventHandlers() {
    if (!this.modal) {
      return;
    }
    const node = this.JQuery(this.modal);
    node.off("shown.bs.modal");
    node.off("hide.bs.modal");
  }
  showBootstrapModal() {
    if (!this.modal) {
      return;
    }
    const modal = this.JQuery(this.modal);
    if (modal && typeof modal.modal === "function") {
      modal.modal("show");
    }
  }
  hideBootstrapModal() {
    if (!this.modal) {
      return;
    }
    const modal = this.JQuery(this.modal);
    if (modal && typeof modal.modal === "function") {
      modal.modal("hide");
    }
  }
  //  PropsMethodCallHelpers
  onPropBeforeOpen() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onBeforeOpen) {
        yield this.props.onBeforeOpen(this);
      }
    });
  }
  onPropBeforeClose() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onBeforeClose) {
        yield this.props.onBeforeClose(this);
      }
    });
  }
  onPropOpen() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onOpen) {
        yield this.props.onOpen(this);
      }
    });
  }
  onPropCloseAsync(data = "") {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onClose) {
        yield this.props.onClose(this, data);
      }
    });
  }
  onPropToggle(isOpen) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onToggle) {
        yield this.props.onToggle(this, isOpen);
      }
    });
  }
  getEndpoint() {
    return "";
  }
  transformData(data) {
    if (!this.props.transform) {
      return data;
    }
    return this.props.transform(data);
  }
  getBodyNode() {
    return this.JQuery(`#${this.id}_body`);
  }
  hasSpinner() {
    return true;
  }
  //  LifeCycleHooks
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      this.enableBootstrapEventHandlers();
    });
  }
  componentWillUnmount() {
    const _super = Object.create(null, {
      componentWillUnmount: {
        get: () => super.componentWillUnmount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this.closeModal();
      yield _super.componentWillUnmount.call(this);
      this.disableBootstrapEventHandlers();
    });
  }
  //  Interface
  openAsync(data = null, animation = true) {
    return __awaiter(this, void 0, void 0, function* () {
      this._scrollY = window.scrollY;
      this.setData(data);
      yield this.setModalToOpenAsync(animation);
    });
  }
  closeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (yield this.confirmNeededAsync()) {
        return;
      }
      yield this.setModalToCloseAsync();
    });
  }
  toggleAsync(data = null, animation = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.isOpen) {
        yield this.closeAsync();
        return;
      }
      yield this.openAsync(data, animation);
    });
  }
  //  Renders
  renderToolbar() {
    return this.props.toolbar ? this.props.toolbar(this) : null;
  }
  renderCloseElement() {
    const customCloseButton = this.resolveCustomCloseButton();
    return !customCloseButton ? ( /*#__PURE__*/React.createElement(Icon, {
      name: "fa-xmark",
      style: IconStyle.Solid,
      onClick: () => this.onCloseAsync()
    })) : ( /*#__PURE__*/React.createElement(Button, {
      label: customCloseButton,
      type: ButtonType.Orange,
      onClick: () => this.onCloseAsync()
    }));
  }
  renderModal() {
    const modalContentStyle = this.props.size === ModalSize.Auto && "w-auto";
    const infoContentStyle = this.props.keepTextFormatting && "textFormatting";
    const tabIndex = !this.preventEsc ? -1 : undefined;
    const closeConfirm = this.resolveCloseConfirm();
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      ref: this._modalRef,
      tabIndex: tabIndex,
      role: "dialog",
      className: this.css("modal", this.props.className),
      "data-backdrop": this.preventClosingOnOutsideClickValue
    }, ch.alert && ( /*#__PURE__*/React.createElement(Alert, {
      model: ch.alert,
      onClose: () => __awaiter(this, void 0, void 0, function* () {
        return yield ch.hideAlertAsync();
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: this.css("modal-dialog", this.sizeStyle, this.positionStyle, this.scrollableStyle),
      role: "document"
    }, /*#__PURE__*/React.createElement("div", {
      className: this.css("modal-content", modalContentStyle, this.props.contentClassName)
    }, !this.noHeader && ( /*#__PURE__*/React.createElement("div", {
      className: "modal-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "modal-header-content"
    }, /*#__PURE__*/React.createElement("h5", {
      className: "modal-title"
    }, this.toMultiLines(this.title)), /*#__PURE__*/React.createElement("h6", {
      className: "modal-title"
    }, this.toMultiLines(this.subtitle))), /*#__PURE__*/React.createElement("div", {
      className: "toolbar"
    }, this.renderToolbar(), !this.props.hideCloseButton && this.renderCloseElement()))), /*#__PURE__*/React.createElement("div", {
      id: `${this.id}_body`,
      ref: this._modalBodyRef,
      className: this.css("modal-body", this.props.bodyClassName),
      onClick: e => this.onModalBodyClick(e)
    }, !this.props.children && ( /*#__PURE__*/React.createElement("p", {
      className: infoContentStyle
    }, this.toMultiLines(this.content))), this.props.children),
    // If the Modal will receive children (most likely Form) instead of text content(this.props.content)
    // Modal footer does not need to be displayed therefore Form will contain it's own control buttons
    !this.props.info && !this.props.children && ( /*#__PURE__*/React.createElement("div", {
      className: "modal-footer"
    }, /*#__PURE__*/React.createElement(Button, {
      submit: true,
      label: ModalLocalizer$1.saveChanges,
      type: ButtonType.Orange
    }), /*#__PURE__*/React.createElement(Button, {
      label: ModalLocalizer$1.close,
      type: ButtonType.Default,
      onClick: () => this.onCloseAsync()
    }))), this.isSpinning() && /*#__PURE__*/React.createElement(Spinner, null), closeConfirm != null && ( /*#__PURE__*/React.createElement(ConfirmationDialog, {
      ref: this._closeConfirmDialogRef,
      title: closeConfirm,
      callback: (caller, data) => this.setModalToCloseAsync(data)
    })))));
  }
  // This needs improvement in next version
  // Needed for correctly applying blur effect without moving modals outside of Layout manually
  render() {
    return /*#__PURE__*/ReactDOM.createPortal(this.renderModal(), document.body);
  }
}
Modal._openInstance = null;

var CookieConsentType;
(function (CookieConsentType) {
  CookieConsentType[CookieConsentType["All"] = 0] = "All";
  CookieConsentType[CookieConsentType["OnlyNecessary"] = 1] = "OnlyNecessary";
})(CookieConsentType || (CookieConsentType = {}));
/**
 * A cookie-consent banner.
 */
const CookieConsent = props => {
  /**
   * Default value of {@link ICookieConsentProps.cookieName}.
   */
  const defaultCookieName = "consent";
  /**
   * Default value of {@link ICookieConsentProps.cookieExpirationInDays}.
   */
  const defaultExpirationDate = "Fri, 31 Dec 9999 23:59:59 GMT";
  const allCookiesAcceptedConsentValue = "All";
  const onlyNecessaryCookiesAcceptedConsentValue = "OnlyNecessary";
  const [cookieConsent, setCookieConsent] = useState(false);
  const consentCookieModal = /*#__PURE__*/React.createRef();
  const getCookieName = () => {
    var _a;
    return (_a = props.cookieName) !== null && _a !== void 0 ? _a : defaultCookieName;
  };
  const getAllCookiesAcceptedConsentValue = () => {
    var _a;
    return (_a = props.acceptAllConsentValue) !== null && _a !== void 0 ? _a : allCookiesAcceptedConsentValue;
  };
  const getOnlyNecessaryCookiesAcceptedConsentValue = () => {
    var _a;
    return (_a = props.acceptOnlyNecessaryConsentValue) !== null && _a !== void 0 ? _a : onlyNecessaryCookiesAcceptedConsentValue;
  };
  const getConsentCookie = () => {
    const consentCookieName = getCookieName();
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookieName = cookies[i].substring(0, cookies[i].indexOf("=")).trim();
      if (consentCookieName === cookieName) {
        return cookies[i];
      }
    }
    return null;
  };
  const getConsentCookieValue = () => {
    const consentCookie = getConsentCookie();
    if (consentCookie) {
      let value = "";
      if (consentCookie.indexOf(";") === -1) {
        value = consentCookie === null || consentCookie === void 0 ? void 0 : consentCookie.substring(consentCookie.indexOf("=") + 1);
      } else {
        value = consentCookie === null || consentCookie === void 0 ? void 0 : consentCookie.substring(consentCookie.indexOf("=") + 1, consentCookie.indexOf(";"));
      }
      return value;
    }
    return null;
  };
  const consentCookieWithValidValueExists = () => {
    const consentCookieValue = getConsentCookieValue();
    return consentCookieValue !== null && (consentCookieValue === getAllCookiesAcceptedConsentValue() || consentCookieValue === getOnlyNecessaryCookiesAcceptedConsentValue());
  };
  const onlyNecessaryCookiesAreAccepted = () => {
    const consentCookieValue = getConsentCookieValue();
    return consentCookieValue !== null && consentCookieValue === getOnlyNecessaryCookiesAcceptedConsentValue();
  };
  const removeCookie = cookie => {
    document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  };
  const removeOptionalCookies = () => {
    if (props.optionalCookiesNames && props.optionalCookiesNames.length > 0) {
      document.cookie.split(";").forEach(cookie => {
        const cookieName = cookie.substring(0, cookie.indexOf("=")).trim();
        if (props.optionalCookiesNames.includes(cookieName)) {
          removeCookie(cookie);
        }
      });
    }
  };
  const getCookieExpirationDate = () => {
    const propExpirationInDays = props.cookieExpirationInDays;
    if (typeof propExpirationInDays === "number" && propExpirationInDays > 0) {
      const expirationTimeInMilliseconds = propExpirationInDays * 24 * 60 * 60 * 1000;
      const expirationDate = new Date();
      expirationDate.setTime(expirationDate.getTime() + expirationTimeInMilliseconds);
      return expirationDate.toUTCString();
    }
    return defaultExpirationDate;
  };
  const saveCookieAsync = allCookies => __awaiter(void 0, void 0, void 0, function* () {
    const cookieConsentValue = allCookies ? getAllCookiesAcceptedConsentValue() : getOnlyNecessaryCookiesAcceptedConsentValue();
    document.cookie = getCookieName() + "=" + cookieConsentValue + ";expires=" + getCookieExpirationDate() + ";path=/";
    if (!allCookies) {
      removeOptionalCookies();
    }
    consentCookieModal.current.closeAsync().then(() => {
      if (props.onClose) {
        // inform the external component about the cookies acceptance
        props.onClose(allCookies ? CookieConsentType.All : CookieConsentType.OnlyNecessary);
      }
      setCookieConsent(true);
    });
  });
  useEffect(() => {
    if (consentCookieModal && consentCookieModal.current) {
      if (props.forceOpen) {
        consentCookieModal.current.openAsync();
      } else {
        consentCookieModal.current.closeAsync();
      }
    }
  }, [props.forceOpen]);
  useEffect(() => {
    const consent = consentCookieWithValidValueExists();
    setCookieConsent(consent);
    if (!consent || props.forceOpen) {
      consentCookieModal.current.openAsync();
    } else if (props.onClose) {
      // inform the external component about the cookies acceptance
      props.onClose(onlyNecessaryCookiesAreAccepted() ? CookieConsentType.OnlyNecessary : CookieConsentType.All);
    }
  }, []);
  useEffect(() => {
    if (onlyNecessaryCookiesAreAccepted()) {
      removeOptionalCookies();
    }
  }, []);
  return !cookieConsent || props.forceOpen ? ( /*#__PURE__*/React.createElement(Modal, {
    info: true,
    noHeader: true,
    preventEsc: true,
    notResponsive: true,
    preventClosingOnOutsideClick: true,
    preventClosingOnInsideClick: true,
    id: "cookieBannerModal",
    ref: consentCookieModal,
    size: ModalSize.Auto,
    position: ModalPosition.BottomLeft,
    className: styles$$.cookieConsentModal
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles$$.cookieConsentBanner} ${styles$$.bottom}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$$.cookieConsentBannerInner
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$$.cookieConsentBannerCopy
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$$.cookieConsentBannerHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$$.cookieConsentBannerTitle
  }, props.title)), props.description && ( /*#__PURE__*/React.createElement("div", {
    className: styles$$.cookieConsentBannerDescription
  }, props.description))), /*#__PURE__*/React.createElement("div", {
    className: styles$$.cookieConsentBannerButtons
  }, /*#__PURE__*/React.createElement(Button, {
    label: props.acceptOnlyNecessaryButtonText,
    type: ButtonType.Default,
    onClick: (sender, data) => __awaiter(void 0, void 0, void 0, function* () {
      return yield saveCookieAsync(false);
    })
  }), /*#__PURE__*/React.createElement(Button, {
    label: props.acceptAllButtonText,
    type: ButtonType.Orange,
    onClick: (sender, data) => __awaiter(void 0, void 0, void 0, function* () {
      return yield saveCookieAsync(true);
    })
  })))))) : null;
};

var css_248z$10 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-document-preview-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-document-preview-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-document-preview-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-document-preview-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-document-preview-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-document-preview-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-document-preview-documentPreview .athenaeum-document-preview-contentA4 {\n  background-color: #525659;\n  width: 35rem;\n  height: 52rem;\n}\n.athenaeum-document-preview-documentPreview iframe {\n  border: none;\n}";
var styles$U = {"font-renta":"athenaeum-document-preview-font-renta","color-schema-renta_black":"athenaeum-document-preview-color-schema-renta_black","color-schema-renta_white":"athenaeum-document-preview-color-schema-renta_white","color-schema-renta_orange":"athenaeum-document-preview-color-schema-renta_orange","color-schema-renta_green":"athenaeum-document-preview-color-schema-renta_green","color-schema-renta_blue":"athenaeum-document-preview-color-schema-renta_blue","documentPreview":"athenaeum-document-preview-documentPreview","contentA4":"athenaeum-document-preview-contentA4"};
styleInject(css_248z$10);

class DocumentPreview extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isLoading: false,
      data: null,
      documentId: this.props.documentId || ""
    };
    this._popoverRef = /*#__PURE__*/React.createRef();
  }
  onToggleAsync(isOpen) {
    return __awaiter(this, void 0, void 0, function* () {
      if (isOpen) {
        yield this.reloadAsync();
      } else {
        yield this.setState({
          data: null
        });
      }
    });
  }
  getEndpoint() {
    return this.props.endpoint || "";
  }
  fetchDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const endpoint = this.getEndpoint();
      const documentId = this.state.documentId;
      return yield this.postAsync(endpoint, documentId);
    });
  }
  toggleAsync(sender, documentId = null) {
    return __awaiter(this, void 0, void 0, function* () {
      if (documentId) {
        yield this.setState({
          documentId
        });
      }
      yield this._popoverRef.current.toggleAsync(sender.id);
    });
  }
  get isOpen() {
    return !!this._popoverRef.current && this._popoverRef.current.isOpen;
  }
  canReload() {
    return this.isOpen;
  }
  hasSpinner() {
    return true;
  }
  render() {
    return /*#__PURE__*/React.createElement(Popover, {
      ref: this._popoverRef,
      className: styles$U.documentPreview,
      onToggle: (sender, isOpen) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onToggleAsync(isOpen);
      }),
      justify: Justify.Right
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$U.contentA4
    }, this.state.data && ( /*#__PURE__*/React.createElement("iframe", {
      title: this.state.data.name,
      src: this.state.data.src,
      width: "560",
      height: "832"
    })), this.isSpinning() && ( /*#__PURE__*/React.createElement(Spinner, {
      noShading: true
    }))));
  }
}

//Autogenerated
class FooterLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.frontpageLanguageItemName = `Frontpage`;
    this.contactLanguageItemName = `Contact`;
    //Initializer
    this.set(this.frontpageLanguageItemName, {
      language: `en`,
      value: `Frontpage`
    }, {
      language: `uk`,
      value: `Головна сторінка`
    }, {
      language: `sv`,
      value: `Framsida`
    }, {
      language: `ru`,
      value: `Главная страница`
    }, {
      language: `pl`,
      value: `Strona główna`
    }, {
      language: `nb`,
      value: `Hjemmeside`
    }, {
      language: `fi`,
      value: `Etusivu`
    }, {
      language: `da`,
      value: `Forside`
    });
    this.set(this.contactLanguageItemName, {
      language: `en`,
      value: `Contact information`
    }, {
      language: `uk`,
      value: `Контактна інформація`
    }, {
      language: `sv`,
      value: `Kontakt information`
    }, {
      language: `ru`,
      value: `Контактная информация`
    }, {
      language: `pl`,
      value: `Informacje kontaktowe`
    }, {
      language: `nb`,
      value: `Kontakt informasjon`
    }, {
      language: `fi`,
      value: `Yhteystiedot`
    }, {
      language: `da`,
      value: `Kontaktinformation`
    });
  }
  /**
  /* "Frontpage" (Frontpage)
  */
  get frontpage() {
    return this.get(this.frontpageLanguageItemName);
  }
  /**
  /* "Contact" (Contact information)
  */
  get contact() {
    return this.get(this.contactLanguageItemName);
  }
}
//Singleton
var FooterLocalizer$1 = new FooterLocalizer();

var css_248z$$ = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-footer-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-footer-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-footer-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-footer-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-footer-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-footer-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-footer-footer {\n  margin-top: auto;\n}\n.athenaeum-footer-footer .athenaeum-footer-upperFooter {\n  display: flex;\n  height: 120px;\n  align-items: center;\n  justify-content: space-around;\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-footer-footer .athenaeum-footer-upperFooter img {\n  height: 42px;\n  margin: 0 12px;\n  position: absolute;\n  left: 0;\n}\n.athenaeum-footer-footer .athenaeum-footer-upperFooter .athenaeum-footer-footerLinksAndSocials {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n.athenaeum-footer-footer .athenaeum-footer-upperFooter .athenaeum-footer-footerLinksAndSocials a {\n  color: white;\n  font-family: \"DINProBold\", Arial, sans-serif;\n  margin: 0 3px;\n  transition: all 0.3s;\n}\n.athenaeum-footer-footer .athenaeum-footer-upperFooter .athenaeum-footer-footerLinksAndSocials a:hover {\n  color: black;\n  text-decoration: none;\n}\n.athenaeum-footer-footer .athenaeum-footer-upperFooter .athenaeum-footer-footerLinksAndSocials .athenaeum-footer-footerSocials {\n  font-size: 25px;\n}\n.athenaeum-footer-footer .athenaeum-footer-lowerFooter {\n  position: relative;\n  background-color: black;\n  color: white;\n  width: 100%;\n  text-align: center;\n}\n.athenaeum-footer-footer .athenaeum-footer-lowerFooter .athenaeum-footer-cookieConsentLabel {\n  cursor: pointer;\n  padding: 8px 0 4px;\n}\n.athenaeum-footer-footer .athenaeum-footer-lowerFooter .athenaeum-footer-cookieConsentLabel:after {\n  font-family: \"Font Awesome 6 Pro\", \"Font Awesome 5 Pro\";\n  font-weight: bold;\n  content: \"\\f054\";\n  padding-left: 8px;\n  color: rgb(255, 255, 255);\n  transition: width 0.3s;\n}\n.athenaeum-footer-footer .athenaeum-footer-version {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  color: rgb(65, 64, 66);\n  font-size: 10px;\n  padding-left: 4px;\n  padding-right: 4px;\n}\n@media screen and (max-width: 1024px) {\n  .athenaeum-footer-footer {\n    display: none;\n  }\n}";
var styles$T = {"font-renta":"athenaeum-footer-font-renta","color-schema-renta_black":"athenaeum-footer-color-schema-renta_black","color-schema-renta_white":"athenaeum-footer-color-schema-renta_white","color-schema-renta_orange":"athenaeum-footer-color-schema-renta_orange","color-schema-renta_green":"athenaeum-footer-color-schema-renta_green","color-schema-renta_blue":"athenaeum-footer-color-schema-renta_blue","footer":"athenaeum-footer-footer","upperFooter":"athenaeum-footer-upperFooter","footerLinksAndSocials":"athenaeum-footer-footerLinksAndSocials","footerSocials":"athenaeum-footer-footerSocials","lowerFooter":"athenaeum-footer-lowerFooter","cookieConsentLabel":"athenaeum-footer-cookieConsentLabel","version":"athenaeum-footer-version"};
styleInject(css_248z$$);

/**
 * A footer containing copyright-information, and optionally logo and links.
 */
class Footer extends BaseComponent {
  get links() {
    return this.props.links != null ? this.props.links(this) : [{
      // TODO: hardcoded finnish addresses!!
      href: "https://renta.fi/",
      label: FooterLocalizer$1.frontpage
    }, {
      href: "https://www.renta.fi/fi/yhteystiedot/",
      label: FooterLocalizer$1.contact
    }];
  }
  handleCookieConsentLabelClick() {
    if (this.props.onCookieConsentLabelClick) {
      this.props.onCookieConsentLabelClick();
    }
  }
  get name() {
    return this.props.name || Footer.defaultName;
  }
  renderCookieConsentLabel() {
    return this.props.cookieConsentLabel ? ( /*#__PURE__*/React.createElement("div", {
      className: styles$T.cookieConsentLabel,
      onClick: () => this.handleCookieConsentLabelClick()
    }, this.props.cookieConsentLabel)) : undefined;
  }
  renderCopyright() {
    const currentYear = new Date().getFullYear();
    return /*#__PURE__*/React.createElement("span", null, `© ${this.name} ${currentYear}`);
  }
  /**
   * Create a {@link React} {@link HTMLAnchorElement} from an {@link IFooterLink}.
   *
   * @param link The {@link IFooterLink} to create the element from.
   * @param key Used as the {@link React.Attributes.key} of the returned {@link React.ReactNode}.
   * @return A {@link React} {@link HTMLAnchorElement} created from the input {@link IFooterLink}.
   */
  renderLink(link, key) {
    return /*#__PURE__*/React.createElement("a", {
      key: key,
      href: link.href,
      rel: "noreferrer",
      target: "_blank"
    }, FooterLocalizer$1.get(link.label).toUpperCase());
  }
  render() {
    var _a;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/forbid-elements -- Footer component is a wrapper for the footer element.
      React.createElement("footer", {
        className: styles$T.footer
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$T.upperFooter
      }, this.props.logo && ( /*#__PURE__*/React.createElement("img", {
        src: this.props.logo,
        alt: this.name
      })), /*#__PURE__*/React.createElement("div", {
        className: styles$T.footerLinksAndSocials
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$T.footerLinks
      }, this.links.map((link, index) => this.renderLink(link, index))), this.props.socialNetworkLinks != null && ( /*#__PURE__*/React.createElement("div", {
        className: styles$T.footerSocials
      }, ((_a = this.props.socialNetworkLinks(this)) !== null && _a !== void 0 ? _a : []).map((link, index) => {
        var _a, _b;
        return /*#__PURE__*/React.createElement("a", {
          href: link.href,
          target: "_blank",
          rel: "noreferrer",
          key: (_a = link.name) !== null && _a !== void 0 ? _a : `social-${index}`
        }, /*#__PURE__*/React.createElement(Icon, {
          name: link.iconName,
          style: (_b = link.iconStyle) !== null && _b !== void 0 ? _b : IconStyle.Brands,
          size: link.iconSize,
          tooltip: link.name
        }));
      }))))), /*#__PURE__*/React.createElement("div", {
        className: styles$T.lowerFooter
      }, this.renderCookieConsentLabel(), this.renderCopyright(), this.props.version && ( /*#__PURE__*/React.createElement("span", {
        className: styles$T.version
      }, this.props.version))))
    );
  }
}
/**
 * Default value of {@link IFooterProps[name]}.
 */
Footer.defaultName = "Renta";

var css_248z$_ = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-footer-alternative-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-footer-alternative-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-footer-alternative-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-footer-alternative-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-footer-alternative-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-footer-alternative-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-footer-alternative-footer {\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  background-color: rgb(65, 64, 66);\n  position: relative;\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-columns {\n  display: grid;\n  grid-template-columns: 1fr 2fr 1fr;\n  padding: 20px 0;\n  max-width: 1140px;\n  margin: 0 auto;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-footer-alternative-footer .athenaeum-footer-alternative-columns {\n    grid-template-columns: 1fr 2fr;\n  }\n  .athenaeum-footer-alternative-footer .athenaeum-footer-alternative-columns div:nth-last-child(1) {\n    grid-row-start: 2;\n    grid-column: 1/span 3;\n  }\n}\n@media screen and (max-width: 480px) {\n  .athenaeum-footer-alternative-footer .athenaeum-footer-alternative-columns {\n    grid-template-columns: 1fr;\n  }\n  .athenaeum-footer-alternative-footer .athenaeum-footer-alternative-columns div:nth-last-child(1) {\n    grid-row-start: unset;\n    grid-column: unset;\n  }\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-leftColumn {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: start;\n  padding: 0 16px;\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-leftColumn .athenaeum-footer-alternative-logo {\n  max-height: 48px;\n  margin: 0;\n  max-width: 100%;\n}\n@media screen and (max-width: 480px) {\n  .athenaeum-footer-alternative-footer .athenaeum-footer-alternative-leftColumn .athenaeum-footer-alternative-logo {\n    max-height: 32px;\n  }\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-leftColumn .athenaeum-footer-alternative-socialNetworks {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-left: -8px;\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-leftColumn .athenaeum-footer-alternative-socialNetworks a {\n  color: rgb(255, 255, 255);\n  font-family: \"DINProBold\", Arial, sans-serif;\n  padding: 8px 12px;\n  transition: all 0.2s;\n  font-size: 20px;\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-leftColumn .athenaeum-footer-alternative-socialNetworks a:hover {\n  color: rgb(227, 227, 227);\n  text-decoration: none;\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-middleColumn {\n  width: 100%;\n  padding: 4px 16px;\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-middleColumn .athenaeum-footer-alternative-footerName {\n  color: rgb(255, 255, 255);\n  font-family: \"DINProBold\", Arial, sans-serif;\n  text-transform: uppercase;\n  border-bottom: 1px solid rgb(255, 255, 255);\n  padding: 4px 0;\n  margin-bottom: 8px;\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-middleColumn .athenaeum-footer-alternative-footerLinks {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-middleColumn .athenaeum-footer-alternative-footerLinks a {\n  color: rgb(255, 255, 255);\n  font-family: \"DINProBold\", Arial, sans-serif;\n  transition: all 0.2s;\n  text-transform: uppercase;\n  padding: 4px 0;\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-middleColumn .athenaeum-footer-alternative-footerLinks a span:after {\n  font-family: \"Font Awesome 6 Pro\", \"Font Awesome 5 Pro\";\n  font-weight: bold;\n  content: \"\\f054\";\n  padding-left: 8px;\n  color: rgb(254, 80, 0);\n  transition: width 0.3s;\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-middleColumn .athenaeum-footer-alternative-footerLinks a:hover {\n  color: rgb(227, 227, 227);\n  text-decoration: none;\n}\n@media screen and (max-width: 1024px) {\n  .athenaeum-footer-alternative-footer .athenaeum-footer-alternative-middleColumn .athenaeum-footer-alternative-footerLinks {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-rightColumn {\n  width: 100%;\n  padding: 0 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: end;\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-rightColumn .athenaeum-footer-alternative-cookieConsentLabel {\n  color: rgb(255, 255, 255);\n  font-weight: normal;\n  padding: 8px 0 8px;\n  cursor: pointer;\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-rightColumn .athenaeum-footer-alternative-cookieConsentLabel:after {\n  font-family: \"Font Awesome 6 Pro\", \"Font Awesome 5 Pro\";\n  font-weight: bold;\n  content: \"\\f054\";\n  padding-left: 8px;\n  color: rgb(255, 255, 255);\n  transition: width 0.3s;\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-rightColumn .athenaeum-footer-alternative-copyright {\n  color: rgb(255, 255, 255);\n  font-weight: normal;\n  padding: 8px 0 10px;\n}\n@media screen and (max-width: 480px) {\n  .athenaeum-footer-alternative-footer .athenaeum-footer-alternative-rightColumn {\n    align-items: start;\n  }\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-version {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  color: rgb(65, 64, 66);\n  font-size: 10px;\n  padding: 4px;\n  cursor: default;\n  transition: ease-in 0.5s;\n}\n.athenaeum-footer-alternative-footer .athenaeum-footer-alternative-version:hover {\n  color: #333;\n  transition: ease-in 1s;\n}";
var styles$S = {"font-renta":"athenaeum-footer-alternative-font-renta","color-schema-renta_black":"athenaeum-footer-alternative-color-schema-renta_black","color-schema-renta_white":"athenaeum-footer-alternative-color-schema-renta_white","color-schema-renta_orange":"athenaeum-footer-alternative-color-schema-renta_orange","color-schema-renta_green":"athenaeum-footer-alternative-color-schema-renta_green","color-schema-renta_blue":"athenaeum-footer-alternative-color-schema-renta_blue","footer":"athenaeum-footer-alternative-footer","columns":"athenaeum-footer-alternative-columns","leftColumn":"athenaeum-footer-alternative-leftColumn","logo":"athenaeum-footer-alternative-logo","socialNetworks":"athenaeum-footer-alternative-socialNetworks","middleColumn":"athenaeum-footer-alternative-middleColumn","footerName":"athenaeum-footer-alternative-footerName","footerLinks":"athenaeum-footer-alternative-footerLinks","rightColumn":"athenaeum-footer-alternative-rightColumn","cookieConsentLabel":"athenaeum-footer-alternative-cookieConsentLabel","copyright":"athenaeum-footer-alternative-copyright","version":"athenaeum-footer-alternative-version"};
styleInject(css_248z$_);

const FooterAlternative = props => {
  var _a;
  const [links, setLinks] = useState([]);
  const defaultName = "Renta";
  const handleCookieConsentLabelClick = () => {
    if (props.onCookieConsentLabelClick) {
      props.onCookieConsentLabelClick();
    }
  };
  useEffect(() => {
    let links = [];
    if (props.links) {
      links = props.links();
    }
    setLinks((links === null || links === void 0 ? void 0 : links.length) ? links : []);
  }, [props.links]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements -- Footer component is a wrapper for the footer element.
    React.createElement("footer", {
      className: styles$S.footer
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$S.columns
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$S.leftColumn
    }, props.logo && ( /*#__PURE__*/React.createElement("img", {
      src: props.logo,
      alt: props.name || defaultName,
      className: styles$S.logo
    })), props.socialNetworkLinks && ( /*#__PURE__*/React.createElement("div", {
      className: styles$S.socialNetworks
    }, ((_a = props.socialNetworkLinks()) !== null && _a !== void 0 ? _a : []).map((link, index) => {
      var _a, _b;
      return /*#__PURE__*/React.createElement("a", {
        href: link.href,
        target: "_blank",
        rel: "noreferrer",
        key: (_a = link.name) !== null && _a !== void 0 ? _a : `social-${index}`
      }, /*#__PURE__*/React.createElement(Icon, {
        name: link.iconName,
        style: (_b = link.iconStyle) !== null && _b !== void 0 ? _b : IconStyle.Brands,
        size: link.iconSize,
        tooltip: link.name,
        className: styles$S.socialIcon
      }));
    })))), /*#__PURE__*/React.createElement("div", {
      className: styles$S.middleColumn
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$S.footerName
    }, props.name || defaultName), /*#__PURE__*/React.createElement("div", {
      className: styles$S.footerLinks
    }, links.map((link, index) => {
      var _a;
      return /*#__PURE__*/React.createElement("a", {
        key: `footer_link_${(_a = link.label) !== null && _a !== void 0 ? _a : index}`,
        href: link.href,
        rel: "noreferrer",
        target: "_blank"
      }, /*#__PURE__*/React.createElement("span", null, FooterLocalizer$1.get(link.label)));
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles$S.rightColumn
    }, props.cookieConsentLabel && ( /*#__PURE__*/React.createElement("div", {
      className: styles$S.cookieConsentLabel,
      onClick: () => handleCookieConsentLabelClick()
    }, props.cookieConsentLabel)), /*#__PURE__*/React.createElement("span", {
      className: styles$S.copyright
    }, `© ${props.name || defaultName} ${new Date().getFullYear()}`))), props.version && ( /*#__PURE__*/React.createElement("span", {
      className: styles$S.version
    }, props.version)))
  );
};

/**
 /* Represents the optgroup HTML element and its attributes.
 /* In a select list, multiple groups with the same name are supported.
 /* They are compared with reference equality.
 */
class SelectListGroup {
  constructor() {
    this.__lowerName = null;
    /**
     * Gets or sets a value that indicates whether this is disabled.
     */
    this.disabled = false;
    /**
     /* Represents the value of the optgroup's label.
     */
    this.name = "";
    this.order = 0;
  }
  get isSelectListGroup() {
    return true;
  }
  get lowerName() {
    if (this.__lowerName == null) {
      return this.__lowerName = (this.name || "").toLowerCase();
    }
    return this.__lowerName;
  }
  static compare(x, y) {
    if (x === y) {
      return 0;
    }
    if (x == null && y == null) {
      return 0;
    }
    if (y == null) {
      return 1;
    }
    if (x == null) {
      return -1;
    }
    return StringUtility.compare(x.lowerName, y.lowerName);
  }
  static isEqual(x, y) {
    return this.compare(x, y) === 0;
  }
  static create(name, disabled = false) {
    const item = new SelectListGroup();
    item.name = name || "";
    item.disabled = disabled;
    return item;
  }
}
/**
 * Represent an item in a <see cref="T:Microsoft.AspNetCore.Mvc.Rendering.SelectList" /> or <see cref="T:Microsoft.AspNetCore.Mvc.Rendering.MultiSelectList" />.
 * This class is typically rendered as an HTML <code>&lt;option&gt;</code> element with the specified
 * attribute values.
 */
class SelectListItem {
  constructor(value = null, text = null, subtext = null, ref = null) {
    this.__lowerText = null;
    this.__localizedLowerText = null;
    this.__lowerSubtext = null;
    this.__localizedLowerSubtext = null;
    /**
     * Gets or sets a value that indicates whether this SelectListItem is disabled.
     * This property is typically rendered as a <code>disabled="disabled"</code> attribute in the HTML
     */
    this.disabled = false;
    /**
     * Gets or sets a value that indicates whether this SelectListItem is selected.
     * This property is typically rendered as a <code>disabled="disabled"</code> attribute in the HTML
     */
    this.selected = false;
    /**
     * Gets or sets a value that indicates the display text of this <see cref="T:Microsoft.AspNetCore.Mvc.Rendering.SelectListItem" />.
     * This property is typically rendered as the inner HTML in the HTML <code>&lt;option&gt;</code> element.
     */
    this.text = "";
    this.subtext = "";
    /**
     * Gets or sets a value that indicates the value of this <see cref="T:Microsoft.AspNetCore.Mvc.Rendering.SelectListItem" />.
     * This property is typically rendered as a <code>value="..."</code> attribute in the HTML
     */
    this.value = "";
    this.favorite = false;
    this.excludeFromFilter = false;
    /**
     * Represents the optgroup HTML element this item is wrapped into.
     * In a select list, multiple groups with the same name are supported.
     * They are compared with reference equality.
     */
    this.group = null;
    this.ref = this;
    this.isSelectListItem = true;
    this.value = value || "";
    this.text = text || "";
    this.subtext = subtext || "";
    this.ref = ref != null ? ref : this;
  }
  get lowerText() {
    if (this.__lowerText == null) {
      return this.__lowerText = (this.text || "").toLowerCase();
    }
    return this.__lowerText;
  }
  get localizedLowerText() {
    if (this.__localizedLowerText == null) {
      const localizer = ServiceProvider.findLocalizer();
      return this.__localizedLowerText = localizer ? localizer.get(this.text).toLowerCase() : this.lowerText;
    }
    return this.__localizedLowerText;
  }
  get lowerSubtext() {
    if (this.__lowerSubtext == null) {
      return this.__lowerSubtext = (this.subtext || "").toLowerCase();
    }
    return this.__lowerSubtext;
  }
  get localizedLowerSubtext() {
    if (this.__localizedLowerSubtext == null) {
      const localizer = ServiceProvider.findLocalizer();
      return this.__localizedLowerSubtext = localizer ? localizer.get(this.lowerSubtext).toLowerCase() : this.lowerSubtext;
    }
    return this.__localizedLowerSubtext;
  }
  static isEqual(x, y) {
    if (x === y) {
      return true;
    }
    if (x == null && y == null) {
      return true;
    }
    if (x == null || y == null) {
      return false;
    }
    return this.CompareByValue(x, y) === 0;
  }
  static is(item) {
    return item != null ? Array.isArray(item) ? item.length > 0 && item[0] != null && SelectListItem.is(item[0]) : item instanceof SelectListItem || item.isSelectListItem === true : false;
  }
}
SelectListItem.Group = (x, y, groupSelected = false) => {
  let result = 0;
  if (groupSelected) {
    const xSelected = x.selected;
    const ySelected = y.selected;
    result = BoolUtility.compare(xSelected, ySelected, true);
  }
  if (result === 0) {
    const xFavorite = x.favorite;
    const yFavorite = y.favorite;
    result = BoolUtility.compare(xFavorite, yFavorite, true);
    if (result === 0) {
      const xGroupOrder = x.group != null ? x.group.order : -1;
      const yGroupOrder = y.group != null ? y.group.order : -1;
      result = NumberUtility.compare(xGroupOrder, yGroupOrder);
      if (result === 0) {
        const xGroupName = x.group != null ? x.group.lowerName : "";
        const yGroupName = y.group != null ? y.group.lowerName : "";
        result = StringUtility.compare(xGroupName, yGroupName);
      }
    }
  }
  return result;
};
SelectListItem.CompareByName = (x, y, groupSelected = false) => {
  let result = SelectListItem.Group(x, y, groupSelected);
  if (result === 0) {
    result = StringUtility.compare(x.lowerText, y.lowerText);
  }
  return result;
};
SelectListItem.CompareByValue = (x, y, groupSelected = false) => {
  let result = SelectListItem.Group(x, y, groupSelected);
  if (result === 0) {
    result = StringUtility.compare(x.value, y.value);
  }
  return result;
};
SelectListItem.CompareByGroup = (x, y, groupSelected = false) => {
  return SelectListItem.Group(x, y, groupSelected);
};
class StatusListItem extends SelectListItem {
  constructor(lineThrough = false, completed = false, icon = null, value = null, text = null, subtext = null, ref = null) {
    super(value, text, subtext, ref);
    this.completed = false;
    this.icon = null;
    this.lineThrough = false;
    this.isStatusListItem = true;
    this.lineThrough = lineThrough;
    this.completed = completed;
    this.icon = icon;
  }
}
class SelectListSeparator extends SelectListItem {
  constructor() {
    super(...arguments);
    this.isSelectListSeparator = true;
  }
  SelectListSeparator() {
    this.value = "";
    this.selected = true;
  }
}

var $$3 = _export;
var uncurryThis$3 = functionUncurryThisClause;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var toLength = toLength$5;
var toString$3 = toString$d;
var notARegExp = notARegexp;
var requireObjectCoercible$1 = requireObjectCoercible$a;
var correctIsRegExpLogic = correctIsRegexpLogic;

var slice = uncurryThis$3(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$$3({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString$3(requireObjectCoercible$1(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = toString$3(searchString);
    return slice(that, end - search.length, end) === search;
  }
});

class AddressHelper {
  static toDegreesMinutesAndSeconds(coordinate) {
    const absolute = Math.abs(coordinate);
    const degrees = Math.floor(absolute);
    const minutesNotTruncated = (absolute - degrees) * 60;
    const minutes = Math.floor(minutesNotTruncated);
    const seconds = Math.floor((minutesNotTruncated - minutes) * 60);
    return `${degrees}°${minutes}'${seconds}"`;
  }
  static improveGoogleFormattedAddress(formattedAddress, address, streetNumber) {
    if (formattedAddress && address && streetNumber) {
      const parts = formattedAddress.split(",").map(item => item.trim());
      if (parts.length === 4) {
        const fullAddress = `${address} ${streetNumber}`;
        if (parts[0] !== fullAddress && parts[1] === fullAddress) {
          // for example: "Koronakatu 1 C, Koronakatu 1, 02210 Espoo, Finland" to "Koronakatu 1, 02210 Espoo, Finland"
          const index = formattedAddress.indexOf(",") + 1;
          formattedAddress = formattedAddress.substr(index).trim();
        }
      }
    }
    return formattedAddress;
  }
  static getFormattedAddress(googleFormattedAddress, lat, lon) {
    return googleFormattedAddress && lat > 0 && lon > 0 ? `${googleFormattedAddress}, #${lat}, ${lon}` : googleFormattedAddress;
  }
  static get googleApiUrl() {
    const context = ch.getContext();
    const settings = context.settings;
    if (!settings.googleMapApiKey || !settings.googleMapApiUrl) throw new Error("Application context doesn't provide Google API settings: \"googleMapApiKey\" or \"googleMapApiUrl\" are empty.");
    return `${settings.googleMapApiUrl}api/js?key=${settings.googleMapApiKey}&libraries=places,marker`;
  }
  static toGoogleLatLon(center) {
    if (center instanceof GeoLocation || center.isGeoLocation || center instanceof GeoCoordinate || center.isGeoCoordinate) {
      const coordinate = AddressHelper.getCoordinate(center) || AthenaeumComponentsConstants.defaultLocation;
      return {
        lat: coordinate.lat,
        lng: coordinate.lon
      };
    }
    return center;
  }
  static googleStaticApiUrl(center, zoom, markers) {
    const context = ch.getContext();
    const settings = context.settings;
    if (!settings.googleMapApiKey || !settings.googleMapApiUrl) throw new Error("Application context doesn't provide Google API settings: \"googleMapApiKey\" or \"googleMapApiUrl\" are empty.");
    const googleCenter = this.toGoogleLatLon(center);
    let src = `${settings.googleMapApiUrl}api/staticmap?key=${settings.googleMapApiKey}`;
    src = src + "&scale=1&size=640x480&format=PNG&maptype=roadmap";
    src = src + "&center=" + encodeURIComponent("{0},{1}".format(googleCenter.lat, googleCenter.lng));
    src = src + "&zoom=" + encodeURIComponent("{0}".format(zoom));
    const localizer = ServiceProvider.findLocalizer();
    src = src + "&language=" + encodeURIComponent("{0}".format((localizer === null || localizer === void 0 ? void 0 : localizer.language) || "en"));
    if (markers) {
      let markersSrc = "";
      for (let i = 0; i < markers.length; i++) {
        const marker = markers[i];
        if (marker.position) {
          markersSrc += "{0}/{1}".format(marker.position.lat, marker.position.lng);
        }
        if (i < markers.length - 1) {
          markersSrc += "|";
        }
      }
      src = src + "&markers=" + encodeURIComponent(markersSrc);
    }
    return src;
  }
  static loadGoogleLibrary() {
    setTimeout(() => this.loadGoogleLibraryAsync(), 0);
  }
  static loadGoogleLibraryAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isGoogleApiRegistered) {
        return Promise.resolve();
      }
      const googleMapScript = document.createElement("script");
      googleMapScript.src = this.googleApiUrl;
      googleMapScript.async = true;
      googleMapScript.defer = true;
      googleMapScript.id = "googleScript";
      return new Promise((resolve, reject) => {
        googleMapScript.addEventListener("load", () => {
          this._google = window.google;
          resolve();
        });
        googleMapScript.addEventListener("error", () => {
          reject();
          throw new Error("Google API script is not initialized, probably script is not loaded.");
        });
        window.document.body.appendChild(googleMapScript);
      });
    });
  }
  static get isGoogleApiRegistered() {
    return this._google != null;
  }
  static get google() {
    if (this._google == null) throw new Error("Google API script is not initialized, probably script is not loaded.");
    return this._google;
  }
  static get geocoder() {
    return new this.google.maps.Geocoder();
  }
  static toGoogleCoordinate(coordinate) {
    return new this.google.maps.LatLng(coordinate.lat, coordinate.lon);
  }
  static hasCoordinates(location) {
    return location.lat > 0 && location.lon > 0;
  }
  static createMapAsync(element, center, zoom, options) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!options) {
        options = {};
      }
      if (!options.zoom) {
        options.zoom = zoom || 16;
      }
      if (!options.center) {
        center = center && this.hasCoordinates(center) && center || (yield Utility.getLocationAsync()) || AthenaeumComponentsConstants.defaultLocation;
        options.center = new this.google.maps.LatLng(center.lat, center.lon);
      }
      if (!options.gestureHandling) {
        options.gestureHandling = "cooperative";
      }
      if (!options.mapId) {
        options.mapId = "MAP_ID";
      }
      return new this.google.maps.Map(element, options);
    });
  }
  static toMarker(coordinate, title, iconUrl, size, offsetY, onClick, onDoubleClick) {
    const position = {
      lat: coordinate.lat,
      lng: coordinate.lon
    };
    size = size || 40;
    let infoWindow = null;
    if (title) {
      const content = `<b>${title}</b>`;
      offsetY = offsetY || -(4 / 5 * size);
      infoWindow = {
        content,
        position,
        pixelOffset: new google.maps.Size(0, offsetY)
      };
    }
    const icon = iconUrl ? {
      url: iconUrl,
      scaledSize: new google.maps.Size(size, size)
    } : undefined;
    return {
      title: title || undefined,
      infoWindow: infoWindow || undefined,
      position,
      icon,
      onClick,
      onDoubleClick
    };
  }
  static addMarkerAsync(position, map) {
    return __awaiter(this, void 0, void 0, function* () {
      if (position instanceof GeoCoordinate) {
        position = this.toGoogleCoordinate(position);
      }
      return new this.google.maps.Marker({
        position: position,
        map: map
      });
    });
  }
  static addInfoWindow(content) {
    return __awaiter(this, void 0, void 0, function* () {
      return new this.google.maps.InfoWindow({
        content
      });
    });
  }
  static setMapCenterAsync(position, map) {
    return __awaiter(this, void 0, void 0, function* () {
      if (position instanceof GeoCoordinate) {
        position = this.toGoogleCoordinate(position);
      }
      map.setCenter(position);
    });
  }
  static findLat(place) {
    var _a;
    if ((_a = place.geometry) === null || _a === void 0 ? void 0 : _a.location) {
      return place.geometry.location.lat();
    }
    return 0;
  }
  static findLon(place) {
    var _a;
    if ((_a = place.geometry) === null || _a === void 0 ? void 0 : _a.location) {
      return place.geometry.location.lng();
    }
    return 0;
  }
  static findAddressComponent(place, componentType) {
    if (place.address_components) {
      const component = place.address_components.find(component => {
        var _a;
        return (_a = component.types) === null || _a === void 0 ? void 0 : _a.some(type => type === componentType);
      });
      if (component) {
        return component.long_name || component.short_name;
      }
    }
    return "";
  }
  static removeLatLon(addressValue) {
    const index = addressValue.indexOf("#");
    if (index > 0) {
      addressValue = addressValue.substr(0, index - 1).trim();
      if (addressValue.endsWith(",")) {
        addressValue = addressValue.substr(0, addressValue.length - 1).trim();
      }
    }
    return addressValue;
  }
  static getCountryName(countryCodeOrName) {
    if (countryCodeOrName) {
      countryCodeOrName = countryCodeOrName.trim().toLowerCase();
      switch (countryCodeOrName) {
        //"fi", "fi-fi", "Finland", "Suomi"
        case "fi":
        case "fi-fi":
        case "finland":
        case "suomi":
          return "Suomi";
        //"se", "sv", "sv-se", "Sweden", "Svenska"
        case "se":
        case "sv":
        case "sv-se":
        case "sweden":
        case "svenska":
          return "Svenska";
        //"no", "nb", "nor", "nb-no", "Norway", "Norge"
        case "no":
        case "nb":
        case "nor":
        case "nb-no":
        case "norway":
        case "norge":
          return "Norge";
        //"dk", "da", "da-dk", "Denmark", "Danmark"
        case "dk":
        case "da":
        case "da-dk":
        case "denmark":
        case "danmark":
          return "Danmark";
        //"pl", "pl-pl", "Poland", "Polska"
        case "pl":
        case "pl-pl":
        case "poland":
        case "polska":
          return "Polska";
        //"ru", "ru-ru", "Russia", "Россия"
        case "ru":
        case "ru-ru":
        case "russia":
        case "россия":
          return "Россия";
        //"ua", "uk", "uk-ua", "Ukraine", "Україна", "Украина"
        case "ua":
        case "uk":
        case "uk-ua":
        case "ukraine":
        case "україна":
        case "украина":
          return "Україна";
      }
    }
    return countryCodeOrName;
  }
  static extractCoordinate(formattedAddress) {
    if (formattedAddress) {
      const index = formattedAddress.indexOf("#");
      if (index > 0) {
        let items = formattedAddress.split("#");
        if (items.length > 1 && items[1]) {
          items = items[1].split(",");
          if (items.length > 1 && items[0] && items[1]) {
            const lat = Number(items[0]);
            const lon = Number(items[1]);
            if (!isNaN(lat) && isFinite(lat) && lat > 0 && !isNaN(lon) && isFinite(lon) && lon > 0) {
              return new GeoCoordinate(lat, lon);
            }
          }
        }
      }
    }
    return null;
  }
  static toLocation(formattedAddress) {
    if (!formattedAddress) {
      return null;
    }
    if (typeof formattedAddress !== "string") {
      return formattedAddress;
    }
    const geoLocation = new GeoLocation();
    geoLocation.formattedAddress = formattedAddress;
    //Formatted address comes in formats:
    //  "Äyritie 12, 01510 Vantaa, Finland, #60.21083359999999, 24.951597"
    //  "Äyritie 12, Vantaa, Finland, #60.21083359999999, 24.951597"
    //  "Äyritie 12, Vantaa, 01510, Finland, #60.21083359999999, 24.951597"
    //  "Äyritie 12, Vantaa, Finland, #60.21083359999999, 24.951597"
    const includesLocation = formattedAddress.includes("#");
    if (includesLocation) {
      const parts = formattedAddress.replace(/([#])/gm, "").split(",").map(item => item.trim()).filter(item => !!item);
      const length = parts.length;
      if (length > 4) {
        const lat = Number(parts[length - 2]);
        const lon = Number(parts[length - 1]);
        const cityPostalCodeParts = parts[length - 4].trim().split(" ");
        if (cityPostalCodeParts.length == 2) {
          geoLocation.postalCode = cityPostalCodeParts[0];
          geoLocation.city = cityPostalCodeParts[1];
        } else if (cityPostalCodeParts.length == 1) {
          if (parts.length > 5) {
            geoLocation.postalCode = parts[length - 4];
            geoLocation.city = parts[length - 5];
          } else {
            geoLocation.city = cityPostalCodeParts[0];
          }
        }
        if (!isNaN(lat) && isFinite(lat) && lat > 0) {
          geoLocation.lat = lat;
        }
        if (!isNaN(lon) && isFinite(lon) && lon > 0) {
          geoLocation.lon = lon;
        }
        geoLocation.address = parts[0];
        geoLocation.country = this.getCountryName(parts[length - 3]);
      }
    }
    return geoLocation;
  }
  static getCoordinate(location) {
    var _a, _b;
    if (location) {
      if (typeof location === "string") {
        return AddressHelper.extractCoordinate(location);
      }
      const position = location;
      if (((_a = position.coords) === null || _a === void 0 ? void 0 : _a.latitude) != null && ((_b = position.coords) === null || _b === void 0 ? void 0 : _b.longitude) != null) {
        return new GeoCoordinate(position.coords.latitude, position.coords.longitude);
      }
      const coordinate = location;
      return this.hasCoordinates(coordinate) ? coordinate : this.extractCoordinate(coordinate.formattedAddress);
    }
    return null;
  }
  static findLocationByLatLngAsync(latLng) {
    return __awaiter(this, void 0, void 0, function* () {
      return new Promise((resolve, reject) => {
        const request = {
          location: latLng,
          region: "fi"
        };
        this.geocoder.geocode(request, (results, status) => {
          if (status === this.google.maps.GeocoderStatus.OK) {
            resolve(this.getLocationFromGeocodeResult(results[0]));
          } else if (status === this.google.maps.GeocoderStatus.ZERO_RESULTS) {
            resolve(null);
          } else {
            reject(status);
          }
        });
      });
    });
  }
  static findAddressAsync(map, address) {
    return __awaiter(this, void 0, void 0, function* () {
      return new Promise((resolve, reject) => {
        const placesService = new this.google.maps.places.PlacesService(map);
        const request = {
          fields: ["formatted_address", "geometry"],
          query: address
        };
        placesService.findPlaceFromQuery(request, (results, status) => {
          if (status === this.google.maps.places.PlacesServiceStatus.OK) {
            resolve(this.getCoordinateFromGeocodeResult(results[0]));
          } else if (status === this.google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
            resolve(null);
          } else {
            reject(status);
          }
        });
      });
    });
  }
  static getCoordinateFromGeocodeResult(result) {
    const lat = this.findLat(result);
    const lon = this.findLon(result);
    return new GeoCoordinate(lat, lon);
  }
  static getLocationFromGeocodeResult(result) {
    const lat = this.findLat(result);
    const lon = this.findLon(result);
    let address = this.findAddressComponent(result, "route") || this.findAddressComponent(result, "establishment");
    let country = this.findAddressComponent(result, "country");
    const city = this.findAddressComponent(result, "locality") || this.findAddressComponent(result, "postal_town") || this.findAddressComponent(result, "political");
    const postalCode = this.findAddressComponent(result, "postal_code");
    const streetNumber = this.findAddressComponent(result, "street_number");
    if (!address) {
      const plusCode = this.findAddressComponent(result, "plus_code");
      if (plusCode) {
        address = plusCode;
        if (!country) {
          country = "XZ"; // Internation waters county code: ISO 3166-1 alpha-2.
        }
      }
    }
    const googleFormattedAddress = this.improveGoogleFormattedAddress(result.formatted_address || "", address, streetNumber);
    const formattedAddress = this.getFormattedAddress(googleFormattedAddress, lat, lon);
    const isValidLocation = (address.length > 0 || formattedAddress.length > 0) && lat > 0 && lon > 0;
    const geoLocation = new GeoLocation();
    if (isValidLocation) {
      geoLocation.formattedAddress = formattedAddress;
      geoLocation.address = (address + " " + streetNumber).trim();
      geoLocation.city = city;
      geoLocation.country = country;
      geoLocation.lat = lat;
      geoLocation.lon = lon;
      geoLocation.postalCode = postalCode;
    }
    return geoLocation;
  }
  static toDMS(coordinate) {
    const {
      lat: lat,
      lon: lon
    } = coordinate;
    const latitude = this.toDegreesMinutesAndSeconds(lat);
    const latitudeCardinal = lat >= 0 ? "N" : "S";
    const longitude = this.toDegreesMinutesAndSeconds(lon);
    const longitudeCardinal = lon >= 0 ? "E" : "W";
    return `${latitude}${latitudeCardinal} ${longitude}${longitudeCardinal}`;
  }
  static findCenter(x, y) {
    const xCoordinate = this.getCoordinate(x);
    const yCoordinate = this.getCoordinate(y);
    if (!xCoordinate) throw Error(`AddressHelper.distance(x, y): GEO coordinate cannot be extracted from argument "x": "${x}".`);
    if (!yCoordinate) throw Error(`AddressHelper.distance(x, y): GEO coordinate cannot be extracted from argument "y": "${y}".`);
    const lat = (xCoordinate.lat + yCoordinate.lat) / 2;
    const lon = (xCoordinate.lon + yCoordinate.lon) / 2;
    return new GeoCoordinate(lat, lon);
  }
  static distance(x, y) {
    const xCoordinate = this.getCoordinate(x);
    const yCoordinate = this.getCoordinate(y);
    if (!xCoordinate) throw Error(`AddressHelper.distance(x, y): GEO coordinate cannot be extracted from argument "x": "${x}".`);
    if (!yCoordinate) throw Error(`AddressHelper.distance(x, y): GEO coordinate cannot be extracted from argument "y": "${y}".`);
    // The math module contains a function
    // named toRadians which converts from
    // degrees to radians.
    const toRadiansK = Math.PI / 180;
    const lon1 = xCoordinate.lon * toRadiansK;
    const lon2 = yCoordinate.lon * toRadiansK;
    const lat1 = xCoordinate.lat * toRadiansK;
    const lat2 = yCoordinate.lat * toRadiansK;
    // Haversine formula
    const dLon = lon2 - lon1;
    const dLat = lat2 - lat1;
    const a = Math.pow(Math.sin(dLat / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(dLon / 2), 2);
    const c = 2 * Math.asin(Math.sqrt(a));
    // Radius of earth in kilometers. Use 3956 for miles
    const r = 6371;
    // calculate the result
    return c * r;
  }
  static findZoom(center, x, y) {
    const xDistance = AddressHelper.distance(center, x);
    const yDistance = AddressHelper.distance(center, y);
    const maxDistanceKm = Utility.max([xDistance, yDistance]);
    const maxWidth = 3 * maxDistanceKm;
    const zoomLevels = [40000, 20000, 10000, 5000, 2500, 1250, 625, 312.5, 156.25, 78.125, 39.0625, 19.53125, 9.765625, 4.8828125, 2.44140625, 1.220703125, 0.6103515625, 0.3051757813, 0.1525878906];
    for (let zoom = 0; zoom < zoomLevels.length - 1; zoom++) {
      if (maxWidth > zoomLevels[zoom + 1]) {
        return zoom;
      }
    }
    return 0;
  }
}
AddressHelper._google = null;

class Comparator {
  static isEqualGeoCoordinate(x, y) {
    return x.lat === y.lat && x.lon === y.lon;
  }
  static isEqualGeoLocation(x, y) {
    if (x.formattedAddress === y.formattedAddress) {
      return true;
    }
    const xCoordinate = AddressHelper.getCoordinate(x);
    const yCoordinate = AddressHelper.getCoordinate(y);
    if (xCoordinate && yCoordinate) {
      return this.isEqualGeoCoordinate(xCoordinate, yCoordinate);
    }
    const xAddress = AddressHelper.removeLatLon(x.formattedAddress);
    const yAddress = AddressHelper.removeLatLon(y.formattedAddress);
    return xAddress === yAddress;
  }
  static isEqualStatusListItem(x, y) {
    return x.completed === y.completed && x.icon === y.icon && x.lineThrough === y.lineThrough && x.value === y.value;
  }
  static isEqualPageRoute(x, y) {
    if (x === y) {
      return true;
    }
    if (x == null && y == null) {
      return true;
    }
    if (x == null || y == null) {
      return false;
    }
    if (x.name !== y.name) {
      return false;
    }
    if (x.index !== y.index) {
      return false;
    }
    if (x.id !== y.id) {
      return false;
    }
    // TODO: compare parameters
    return true;
  }
  static isEqual(x, y) {
    if (x === y) {
      return true;
    }
    if (x == null && y == null) {
      return true;
    }
    if (x == null || y == null) {
      return false;
    }
    if (typeof x === "object") {
      if (x instanceof StatusListItem || x.isStatusListItem) {
        return (y instanceof StatusListItem || y.isStatusListItem) && this.isEqualStatusListItem(x, y);
      }
      if (x instanceof SelectListItem || x.isSelectListItem) {
        return (y instanceof SelectListItem || y.isSelectListItem) && x.value === y.value;
      }
      if (x instanceof PageRoute || x.isPageRoute) {
        return (y instanceof PageRoute || y.isPageRoute) && this.isEqualPageRoute(x, y);
      }
      if (x instanceof GeoLocation || x.isGeoLocation) {
        return (y instanceof GeoLocation || y.isGeoLocation) && this.isEqualGeoLocation(x, y);
      }
      if (x instanceof GeoCoordinate || x.isGeoCoordinate) {
        return (y instanceof GeoCoordinate || y.isGeoCoordinate) && this.isEqualGeoCoordinate(x, y);
      }
      if (Utility.isDateType(x) || Utility.isDateType(y)) {
        const xDate = new Date(x);
        const yDate = new Date(y);
        return xDate.valueOf() === yDate.valueOf();
      }
    }
    if (typeof x === "string" && typeof y === "object") {
      return Comparator.isEqual(y, x);
    }
    if (Array.isArray(x) && Array.isArray(y)) {
      if (x.length !== y.length) {
        return false;
      }
      for (let i = 0; i < x.length; i++) {
        if (!Comparator.isEqual(x[i], y[i])) {
          return false;
        }
      }
      return true;
    }
    return x == y;
  }
  static assertIsNumber(value) {
    if (this.isNumber(value)) {
      return value;
    }
    throw new TypeError("value is not a number");
  }
  static isNumber(value) {
    return typeof value === "number";
  }
}

var tryToString = tryToString$5;

var $TypeError = TypeError;

var deletePropertyOrThrow$1 = function (O, P) {
  if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

var arraySlice = arraySlice$2;

var floor = Math.floor;

var sort = function (array, comparefn) {
  var length = array.length;

  if (length < 8) {
    // insertion sort
    var i = 1;
    var element, j;

    while (i < length) {
      j = i;
      element = array[i];
      while (j && comparefn(array[j - 1], element) > 0) {
        array[j] = array[--j];
      }
      if (j !== i++) array[j] = element;
    }
  } else {
    // merge sort
    var middle = floor(length / 2);
    var left = sort(arraySlice(array, 0, middle), comparefn);
    var right = sort(arraySlice(array, middle), comparefn);
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;

    while (lindex < llength || rindex < rlength) {
      array[lindex + rindex] = (lindex < llength && rindex < rlength)
        ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
        : lindex < llength ? left[lindex++] : right[rindex++];
    }
  }

  return array;
};

var arraySort = sort;

var fails$2 = fails$p;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$2(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var userAgent$1 = engineUserAgent;

var firefox = userAgent$1.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var UA = engineUserAgent;

var engineIsIeOrEdge = /MSIE|Trident/.test(UA);

var userAgent = engineUserAgent;

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var $$2 = _export;
var uncurryThis$2 = functionUncurryThis;
var aCallable = aCallable$9;
var toObject = toObject$5;
var lengthOfArrayLike = lengthOfArrayLike$3;
var deletePropertyOrThrow = deletePropertyOrThrow$1;
var toString$2 = toString$d;
var fails$1 = fails$p;
var internalSort = arraySort;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var FF = engineFfVersion;
var IE_OR_EDGE = engineIsIeOrEdge;
var V8 = engineV8Version;
var WEBKIT = engineWebkitVersion;

var test$1 = [];
var nativeSort = uncurryThis$2(test$1.sort);
var push = uncurryThis$2(test$1.push);

// IE8-
var FAILS_ON_UNDEFINED = fails$1(function () {
  test$1.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails$1(function () {
  test$1.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails$1(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test$1.push({ k: chr + index, v: value });
    }
  }

  test$1.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test$1.length; index++) {
    chr = test$1[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED$1 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString$2(x) > toString$2(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$$2({ target: 'Array', proto: true, forced: FORCED$1 }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});

//Autogenerated
class DropdownLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.multipleSelectedLanguageItemName = `MultipleSelected`;
    this.noItemsLanguageItemName = `NoItems`;
    this.noDataLanguageItemName = `NoData`;
    this.filterResultsLanguageItemName = `FilterResults`;
    this.getResultsLanguageItemName = `GetResults`;
    this.addLanguageItemName = `Add`;
    this.nothingSelectedLanguageItemName = `NothingSelected`;
    //Initializer
    this.set(this.multipleSelectedLanguageItemName, {
      language: `en`,
      value: `{0} selected`
    }, {
      language: `uk`,
      value: `{0} вибран(о)`
    }, {
      language: `sv`,
      value: `{0} valt`
    }, {
      language: `ru`,
      value: `{0} выбран(о)`
    }, {
      language: `pl`,
      value: `{0} wybrane`
    }, {
      language: `nb`,
      value: `{0} valgt`
    }, {
      language: `fi`,
      value: `{0} valittu`
    }, {
      language: `da`,
      value: `{0} valgt`
    });
    this.set(this.noItemsLanguageItemName, {
      language: `en`,
      value: `No items found`
    }, {
      language: `uk`,
      value: `Нічого не знайдено`
    }, {
      language: `sv`,
      value: `Inga artiklar hittades`
    }, {
      language: `ru`,
      value: `Данные не найдены`
    }, {
      language: `pl`,
      value: `Nie znaleziono przedmiotów`
    }, {
      language: `nb`,
      value: `Ingen objekter funnet`
    }, {
      language: `fi`,
      value: `Kohteita ei löytynyt`
    }, {
      language: `da`,
      value: `Ingen genstande fundet`
    });
    this.set(this.noDataLanguageItemName, {
      language: `en`,
      value: `No data`
    }, {
      language: `uk`,
      value: `Немає даних`
    }, {
      language: `sv`,
      value: `Ingen information`
    }, {
      language: `ru`,
      value: `Нет данных`
    }, {
      language: `pl`,
      value: `Brak danych`
    }, {
      language: `nb`,
      value: `Ingen data`
    }, {
      language: `fi`,
      value: `Ei tietoja`
    }, {
      language: `da`,
      value: `Ingen data`
    });
    this.set(this.filterResultsLanguageItemName, {
      language: `en`,
      value: `Filter results`
    }, {
      language: `uk`,
      value: `Відфільтрувати результати`
    }, {
      language: `sv`,
      value: `Filtrera resultat`
    }, {
      language: `ru`,
      value: `Отфильтровать результаты`
    }, {
      language: `pl`,
      value: `Filtruj wyniki`
    }, {
      language: `nb`,
      value: `Filtrer resultater`
    }, {
      language: `fi`,
      value: `Suodata tuloksia`
    }, {
      language: `da`,
      value: `Filtrer resultaterne`
    });
    this.set(this.getResultsLanguageItemName, {
      language: `en`,
      value: `Start typing to get results`
    }, {
      language: `uk`,
      value: `Почніть писати, щоб побачити дані`
    }, {
      language: `sv`,
      value: `Börja skriva för att få resultat`
    }, {
      language: `ru`,
      value: `Начните писать, чтобы увидеть данные`
    }, {
      language: `pl`,
      value: `Zacznij pisać, aby uzyskać wyniki`
    }, {
      language: `nb`,
      value: `Begynn å skrive for å få resultater`
    }, {
      language: `fi`,
      value: `Aloita kirjoittaminen saadaksesi tuloksia`
    }, {
      language: `da`,
      value: `Begynd at skrive for at få resultater`
    });
    this.set(this.addLanguageItemName, {
      language: `en`,
      value: `Add`
    }, {
      language: `uk`,
      value: `Додати`
    }, {
      language: `sv`,
      value: `Lägg till`
    }, {
      language: `ru`,
      value: `Новый`
    }, {
      language: `pl`,
      value: `Dodaj`
    }, {
      language: `nb`,
      value: `Legg til`
    }, {
      language: `fi`,
      value: `Lisää`
    }, {
      language: `da`,
      value: `Tilføj`
    });
    this.set(this.nothingSelectedLanguageItemName, {
      language: `en`,
      value: `Nothing is selected`
    }, {
      language: `uk`,
      value: `Нічого не вибрано`
    }, {
      language: `sv`,
      value: `Ingenting är valt`
    }, {
      language: `ru`,
      value: `Ничего не выбрано`
    }, {
      language: `pl`,
      value: `Wybierz`
    }, {
      language: `nb`,
      value: `Ingenting er valgt`
    }, {
      language: `fi`,
      value: `Ei mitään valittu`
    }, {
      language: `da`,
      value: `Intet er valgt`
    });
  }
  /**
  /* "MultipleSelected" ({0} selected)
  */
  get multipleSelected() {
    return this.get(this.multipleSelectedLanguageItemName);
  }
  /**
  /* "NoItems" (No items found)
  */
  get noItems() {
    return this.get(this.noItemsLanguageItemName);
  }
  /**
  /* "NoData" (No data)
  */
  get noData() {
    return this.get(this.noDataLanguageItemName);
  }
  /**
  /* "FilterResults" (Filter results)
  */
  get filterResults() {
    return this.get(this.filterResultsLanguageItemName);
  }
  /**
  /* "GetResults" (Start typing to get results)
  */
  get getResults() {
    return this.get(this.getResultsLanguageItemName);
  }
  /**
  /* "Add" (Add)
  */
  get add() {
    return this.get(this.addLanguageItemName);
  }
  /**
  /* "NothingSelected" (Nothing is selected)
  */
  get nothingSelected() {
    return this.get(this.nothingSelectedLanguageItemName);
  }
}
//Singleton
var DropdownLocalizer$1 = new DropdownLocalizer();

var css_248z$Z = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-dropdown-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-dropdown-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-dropdown-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-dropdown-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-dropdown-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-dropdown-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-dropdown-list, .athenaeum-dropdown-dropdown {\n  text-align: left;\n  border-radius: 5px;\n  font-size: 14px;\n  cursor: pointer;\n  height: 100%;\n}\n.athenaeum-dropdown-list.athenaeum-dropdown-disabled, .athenaeum-dropdown-disabled.athenaeum-dropdown-dropdown {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-selected, .athenaeum-dropdown-dropdown .athenaeum-dropdown-selected {\n  text-align: center;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer {\n  display: flex;\n  visibility: hidden;\n  height: inherit;\n  position: absolute;\n  flex-direction: column;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter {\n  padding: 4px 2px 0;\n  position: relative;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter > input, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter > input {\n  width: 100%;\n  padding-right: 18px !important;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter input::placeholder, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter input::placeholder {\n  font-style: italic;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter .athenaeum-dropdown-clean, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter .athenaeum-dropdown-clean {\n  position: absolute;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  top: 0;\n  right: 12px;\n  opacity: 0.3;\n  margin-top: 2px;\n  color: black;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter .athenaeum-dropdown-clean:hover, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter .athenaeum-dropdown-clean:hover {\n  opacity: 1;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-addButton, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-addButton {\n  padding: 0 2px;\n  display: flex;\n  align-items: center;\n  justify-content: left;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-addButton > span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-addButton > span {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-scrollableContainer, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-scrollableContainer {\n  overflow-y: auto;\n  height: inherit;\n  position: relative;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-itemsList, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-itemsList {\n  height: auto;\n  position: absolute;\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: unset;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-itemsList, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-itemsList {\n    position: unset !important;\n  }\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noWrap, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noWrap {\n  white-space: nowrap;\n  overflow-x: hidden;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-lineThrough, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-lineThrough {\n  text-decoration: line-through;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults {\n  display: flex;\n  align-items: center;\n  padding: 2px 10px;\n  margin: 2px 0;\n  border-radius: 5px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-noResults, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-noResults {\n  color: rgb(254, 80, 0);\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem:hover, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem:hover, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-noResults:hover, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-noResults:hover {\n  background-color: rgb(227, 227, 227);\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem.athenaeum-dropdown-noResults, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem.athenaeum-dropdown-noResults {\n  color: white;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem:hover, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem:hover, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem.athenaeum-dropdown-noResults:hover, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-selectedItem.athenaeum-dropdown-noResults:hover {\n  color: #337ab7;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-listItem span, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-noResults span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-listItem.athenaeum-dropdown-noResults span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults {\n  border-radius: 0;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div {\n  padding-top: 2px;\n  padding-bottom: 3px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div > span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div > span, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div > span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div > span {\n  display: inline;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div > small, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div > small, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div > small, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div > small {\n  margin-left: 0.5em;\n  font-size: 75%;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-iconContainer, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-iconContainer, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-iconContainer, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-iconContainer {\n  padding: 5px;\n  margin-right: 10px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item span, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults span {\n  display: block;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item small, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item small, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults small, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults small {\n  text-transform: capitalize;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-minus, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-minus, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-minus, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-minus {\n  font-size: 1.5em;\n  margin-right: 5px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountTitle, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountTitle, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountTitle, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountTitle {\n  width: 100%;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountTitle span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountTitle span, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountTitle span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountTitle span {\n  display: inline;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountTitle .athenaeum-dropdown-amountUnit, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountTitle .athenaeum-dropdown-amountUnit, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountTitle .athenaeum-dropdown-amountUnit, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountTitle .athenaeum-dropdown-amountUnit {\n  padding-left: 5px;\n  color: lightgray;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountDisabled, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amountDisabled, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountDisabled, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amountDisabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amount, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-amount, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amount, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-amount {\n  font-size: 1.5em;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-plus, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-plus, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-plus, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-plus {\n  font-size: 1.5em;\n  margin-left: 5px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-notCompleted, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-notCompleted, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-notCompleted, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-notCompleted {\n  margin-right: 0;\n  margin-left: auto;\n  padding-left: 8px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-icon, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-icon, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-icon, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-icon {\n  margin-right: 0;\n  margin-left: auto;\n  padding-left: 8px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-icon > img, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-icon > img, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-icon > img, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-icon > img {\n  height: 20px;\n  min-height: 16px;\n  min-width: 16px;\n  max-width: 24px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-action, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-action, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-action, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-action {\n  display: flex;\n  margin-right: 0;\n  margin-left: auto;\n  padding-left: 8px;\n  justify-content: end !important;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-action > button, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-action > button, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-action > button, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-action > button {\n  padding: 0.375rem 0.375rem !important;\n  min-height: 10px !important;\n  max-height: 20px !important;\n  min-width: 10px !important;\n  max-width: 20px !important;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-group, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-group, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-group:hover, .athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-group:active {\n  cursor: default;\n  color: #e3e3e3 !important;\n  background-color: inherit !important;\n  font-size: 12px;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-groupSeparator, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-groupSeparator {\n  margin: 6px 2px;\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-selectedItem, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-selectedItem {\n  background-color: #337ab7;\n  color: white;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-itemGroupIdent, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-itemGroupIdent {\n  padding-left: 20px !important;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer.athenaeum-dropdown-opened, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer.athenaeum-dropdown-opened {\n  visibility: visible;\n  position: initial;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults {\n  padding: 0;\n  cursor: default;\n}\n.athenaeum-dropdown-list .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults:hover, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults:hover {\n  background-color: transparent;\n}\n\n.athenaeum-dropdown-dropdown {\n  cursor: pointer;\n  position: relative;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-hovered, .athenaeum-dropdown-dropdown .athenaeum-dropdown-selected:hover {\n  background-color: rgb(227, 227, 227);\n  border-color: #adadad;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-focused {\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  white-space: nowrap;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected.athenaeum-dropdown-clearButtonVisible {\n  visibility: visible;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected .athenaeum-dropdown-toggleButtonContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected .athenaeum-dropdown-toggleButtonContainer > div {\n  margin-left: 6px;\n  align-items: center;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected .athenaeum-dropdown-toggleButtonContainer > div.athenaeum-dropdown-clearButton {\n  display: flex;\n  padding: 4px;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected .athenaeum-dropdown-toggleButtonContainer > div.athenaeum-dropdown-clearButton:not(:hover) {\n  opacity: 0.3;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-selected .athenaeum-dropdown-toggleButtonContainer > div.athenaeum-dropdown-toggleButton {\n  display: flex;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer {\n  height: auto;\n  position: absolute;\n  background-color: rgb(254, 80, 0);\n  width: auto;\n  min-width: 100%;\n  left: auto;\n  right: 0;\n  bottom: 0;\n  border-radius: 5px;\n  color: white;\n  margin: 2px 0;\n  padding: 3px 0;\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  z-index: 150;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer.athenaeum-dropdown-alignLeft {\n  left: 0;\n  right: auto;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer.athenaeum-dropdown-alignTop {\n  bottom: 35px;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer.athenaeum-dropdown-alignBottom {\n  bottom: auto;\n  top: auto;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer.athenaeum-dropdown-opened {\n  visibility: visible;\n  position: absolute;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-itemsList {\n  position: unset !important;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults {\n  color: white;\n  padding: 0 12px;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-iconContainer, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-iconContainer {\n  padding: 2px;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item .athenaeum-dropdown-checkbox, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults .athenaeum-dropdown-checkbox {\n  margin-left: auto;\n  padding-left: 10px;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item:hover, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults {\n  border-radius: 0;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div {\n  padding-top: 2px;\n  padding-bottom: 3px;\n  width: auto;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div > span, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div > span {\n  display: inline;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-item.athenaeum-dropdown-inlineSubtext > div > small, .athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-inlineSubtext.athenaeum-dropdown-noResults > div > small {\n  margin-left: 0.5em;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 75%;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter {\n  padding: 4px 8px;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-filter .athenaeum-dropdown-clean {\n  color: black !important;\n  right: 16px;\n  margin-top: 0;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-addButton {\n  padding: 0 8px;\n  display: flex;\n  align-items: center;\n  justify-content: left;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-addButton > span {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults {\n  cursor: default;\n}\n.athenaeum-dropdown-dropdown .athenaeum-dropdown-itemsContainer .athenaeum-dropdown-noResults:hover {\n  background-color: transparent;\n}\n\n.athenaeum-dropdown-dropdownWidget {\n  width: calc(100% + 24px);\n  left: -12px;\n  bottom: -36px;\n}\n\n.athenaeum-dropdown-transparent {\n  background-color: transparent;\n  border: none;\n}\n.athenaeum-dropdown-transparent:hover i.athenaeum-dropdown-transparent {\n  visibility: visible;\n}\n.athenaeum-dropdown-transparent.athenaeum-dropdown-selected:hover {\n  background-color: rgba(227, 227, 226, 0.5);\n}\n.athenaeum-dropdown-transparent:not(.athenaeum-dropdown-selected) {\n  margin: -6px 0px -6px -12px;\n}\n\ni.athenaeum-dropdown-transparent {\n  visibility: hidden;\n}\n\n.athenaeum-dropdown-small {\n  min-width: 52px;\n}\n.athenaeum-dropdown-small > div:first-child {\n  padding: 0.375rem;\n  height: auto;\n}\n.athenaeum-dropdown-small > div:first-child span {\n  font-size: 0.8rem;\n}";
var styles$R = {"font-renta":"athenaeum-dropdown-font-renta","color-schema-renta_black":"athenaeum-dropdown-color-schema-renta_black","color-schema-renta_white":"athenaeum-dropdown-color-schema-renta_white","color-schema-renta_orange":"athenaeum-dropdown-color-schema-renta_orange","color-schema-renta_green":"athenaeum-dropdown-color-schema-renta_green","color-schema-renta_blue":"athenaeum-dropdown-color-schema-renta_blue","list":"athenaeum-dropdown-list","dropdown":"athenaeum-dropdown-dropdown","disabled":"athenaeum-dropdown-disabled","selected":"athenaeum-dropdown-selected","itemsContainer":"athenaeum-dropdown-itemsContainer","filter":"athenaeum-dropdown-filter","clean":"athenaeum-dropdown-clean","addButton":"athenaeum-dropdown-addButton","scrollableContainer":"athenaeum-dropdown-scrollableContainer","itemsList":"athenaeum-dropdown-itemsList","noWrap":"athenaeum-dropdown-noWrap","lineThrough":"athenaeum-dropdown-lineThrough","item":"athenaeum-dropdown-item","noResults":"athenaeum-dropdown-noResults","listItem":"athenaeum-dropdown-listItem","selectedItem":"athenaeum-dropdown-selectedItem","inlineSubtext":"athenaeum-dropdown-inlineSubtext","iconContainer":"athenaeum-dropdown-iconContainer","minus":"athenaeum-dropdown-minus","amountTitle":"athenaeum-dropdown-amountTitle","amountUnit":"athenaeum-dropdown-amountUnit","amountDisabled":"athenaeum-dropdown-amountDisabled","amount":"athenaeum-dropdown-amount","plus":"athenaeum-dropdown-plus","notCompleted":"athenaeum-dropdown-notCompleted","icon":"athenaeum-dropdown-icon","action":"athenaeum-dropdown-action","group":"athenaeum-dropdown-group","groupSeparator":"athenaeum-dropdown-groupSeparator","itemGroupIdent":"athenaeum-dropdown-itemGroupIdent","opened":"athenaeum-dropdown-opened","hovered":"athenaeum-dropdown-hovered","focused":"athenaeum-dropdown-focused","clearButtonVisible":"athenaeum-dropdown-clearButtonVisible","toggleButtonContainer":"athenaeum-dropdown-toggleButtonContainer","clearButton":"athenaeum-dropdown-clearButton","toggleButton":"athenaeum-dropdown-toggleButton","alignLeft":"athenaeum-dropdown-alignLeft","alignTop":"athenaeum-dropdown-alignTop","alignBottom":"athenaeum-dropdown-alignBottom","checkbox":"athenaeum-dropdown-checkbox","dropdownWidget":"athenaeum-dropdown-dropdownWidget","transparent":"athenaeum-dropdown-transparent","small":"athenaeum-dropdown-small"};
styleInject(css_248z$Z);

class DropdownListItem extends BaseComponent {
  get actionIconVisible() {
    return this.props.item.selected && !!this.props.actionIcon;
  }
  get actionIcon() {
    const size = IconSize.Normal;
    return typeof this.props.actionIcon === "object" ? this.props.actionIcon : typeof this.props.actionIcon === "string" ? {
      name: this.props.actionIcon,
      size: size
    } : {
      name: "far fa-info",
      size: size
    };
  }
  canDecrease(item) {
    return item.amount >= item.step;
  }
  lastBeforeZero(item) {
    return item.amount === item.step;
  }
  decreaseAsync(e, item) {
    return __awaiter(this, void 0, void 0, function* () {
      e.stopPropagation();
      item.amount = Utility.roundE(item.amount - item.step);
      yield this.props.onChangeAmount(this, item);
      yield this.reRenderAsync();
    });
  }
  canIncrease(item) {
    return item.amount <= 1000 - item.step;
  }
  increaseAsync(e, item) {
    return __awaiter(this, void 0, void 0, function* () {
      e.stopPropagation();
      item.amount = Utility.roundE(item.amount + item.step);
      yield this.props.onChangeAmount(this, item);
      yield this.reRenderAsync();
    });
  }
  actionAsync(e, item) {
    return __awaiter(this, void 0, void 0, function* () {
      e.stopPropagation();
      yield this.props.onAction(this, item);
    });
  }
  renderAmountListItem(item) {
    const noWrapCss = this.props.noWrap && styles$R.noWrap;
    const icon = this.lastBeforeZero(item) ? "far times-circle" : "far minus-circle";
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$R.minus, !this.canDecrease(item) && styles$R.amountDisabled),
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.decreaseAsync(e, item);
      })
    }, /*#__PURE__*/React.createElement(Icon, {
      name: icon
    })), /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$R.amountTitle, noWrapCss)
    }, /*#__PURE__*/React.createElement("span", null, DropdownLocalizer$1.get(item.text)), !this.props.subtextHidden && ( /*#__PURE__*/React.createElement("small", {
      className: styles$R.amountUnit
    }, DropdownLocalizer$1.get(item.subtext)))), /*#__PURE__*/React.createElement("div", {
      className: styles$R.amount
    }, /*#__PURE__*/React.createElement("span", null, item.amountValue)), /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$R.plus, !this.canIncrease(item) && styles$R.amountDisabled),
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.increaseAsync(e, item);
      })
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "far plus-circle"
    })));
  }
  renderStatusListItem(item) {
    var _a;
    const noWrapCss = this.props.noWrap && styles$R.noWrap;
    const lineThroughCss = item.lineThrough && styles$R.lineThrough;
    const icon = (_a = item.icon) !== null && _a !== void 0 ? _a : null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: this.css(noWrapCss, lineThroughCss)
    }, /*#__PURE__*/React.createElement("span", null, DropdownLocalizer$1.get(item.text)), !this.props.subtextHidden && ( /*#__PURE__*/React.createElement("small", null, DropdownLocalizer$1.get(item.subtext)))), !item.completed && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$R.notCompleted)
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "fal exclamation-square",
      size: IconSize.Normal
    }))), icon != null && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$R.icon)
    }, Icon.renderIcon(icon, null, IconSize.Normal))));
  }
  renderListItem(item) {
    const noWrapCss = this.props.noWrap && styles$R.noWrap;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: this.css(noWrapCss)
    }, /*#__PURE__*/React.createElement("span", null, DropdownLocalizer$1.get(item.text)), !this.props.subtextHidden && ( /*#__PURE__*/React.createElement("small", null, ReactUtility.toSmalls(DropdownLocalizer$1.get(item.subtext))))), this.actionIconVisible && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$R.action),
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.actionAsync(e, item);
      })
    }, /*#__PURE__*/React.createElement(Button, {
      icon: this.actionIcon,
      type: ButtonType.Orange
    }))));
  }
  render() {
    const item = this.props.item;
    const isAmount = item.isAmountListItem;
    const isStatus = item.isStatusListItem;
    return isAmount ? this.renderAmountListItem(item) : isStatus ? this.renderStatusListItem(item) : this.renderListItem(item);
  }
}

const FILTER_MIN_LENGTH = 6;
const FILTER_MAX_LENGTH = 1000;
const SELECTED_TEXT_FORMAT = 3;
const EXPAND_TOP_PADDING = 150;
class AmountListItem extends SelectListItem {
  constructor() {
    super(...arguments);
    this.step = 1.0;
    this.amount = 0.0;
    this.isAmountListItem = true;
  }
  get amountValue() {
    return this.step >= 1 ? Utility.format(`{0:0}`, this.amount) : Utility.format(`{0:0.0}`, this.amount);
  }
}
var DropdownSchema;
(function (DropdownSchema) {
  DropdownSchema[DropdownSchema["Default"] = 0] = "Default";
  DropdownSchema[DropdownSchema["Widget"] = 1] = "Widget";
  DropdownSchema[DropdownSchema["Transparent"] = 2] = "Transparent";
})(DropdownSchema || (DropdownSchema = {}));
var DropdownType;
(function (DropdownType) {
  DropdownType["Dropdown"] = "dropdown";
  DropdownType["List"] = "list";
})(DropdownType || (DropdownType = {}));
var DropdownOrderBy;
(function (DropdownOrderBy) {
  DropdownOrderBy[DropdownOrderBy["Name"] = 0] = "Name";
  DropdownOrderBy[DropdownOrderBy["Value"] = 1] = "Value";
  DropdownOrderBy[DropdownOrderBy["None"] = 2] = "None";
})(DropdownOrderBy || (DropdownOrderBy = {}));
var DropdownAlign;
(function (DropdownAlign) {
  DropdownAlign[DropdownAlign["Right"] = 0] = "Right";
  DropdownAlign[DropdownAlign["Left"] = 1] = "Left";
})(DropdownAlign || (DropdownAlign = {}));
var DropdownVerticalAlign;
(function (DropdownVerticalAlign) {
  DropdownVerticalAlign[DropdownVerticalAlign["Bottom"] = 0] = "Bottom";
  DropdownVerticalAlign[DropdownVerticalAlign["Top"] = 1] = "Top";
  DropdownVerticalAlign[DropdownVerticalAlign["Auto"] = 2] = "Auto";
})(DropdownVerticalAlign || (DropdownVerticalAlign = {}));
var DropdownSelectType;
(function (DropdownSelectType) {
  DropdownSelectType[DropdownSelectType["Background"] = 0] = "Background";
  DropdownSelectType[DropdownSelectType["Checkbox"] = 1] = "Checkbox";
})(DropdownSelectType || (DropdownSelectType = {}));
var DropdownSubtextType;
(function (DropdownSubtextType) {
  DropdownSubtextType[DropdownSubtextType["Row"] = 0] = "Row";
  DropdownSubtextType[DropdownSubtextType["Inline"] = 1] = "Inline";
  DropdownSubtextType[DropdownSubtextType["Hidden"] = 2] = "Hidden";
})(DropdownSubtextType || (DropdownSubtextType = {}));
var DropdownRequiredType;
(function (DropdownRequiredType) {
  /**
   * No auto selection. User can un-select required item.
   */
  DropdownRequiredType[DropdownRequiredType["Manual"] = 0] = "Manual";
  /**
   * No auto selection. User cannot un-select required item.
   */
  DropdownRequiredType[DropdownRequiredType["Restricted"] = 1] = "Restricted";
  /**
   * First item will be selected automatically. User cannot un-select required item.
   */
  DropdownRequiredType[DropdownRequiredType["AutoSelect"] = 2] = "AutoSelect";
})(DropdownRequiredType || (DropdownRequiredType = {}));
class Dropdown extends BaseInput {
  constructor() {
    super(...arguments);
    this._filterInputRef = /*#__PURE__*/React.createRef();
    this._scrollableContainerRef = /*#__PURE__*/React.createRef();
    this._listContainerRef = /*#__PURE__*/React.createRef();
    this._itemsListRef = /*#__PURE__*/React.createRef();
    this._maxHeight = null;
    this._isLongList = false;
    this._autoScroll = true;
    this.state = {
      items: [],
      filteredItems: [],
      validationError: null,
      readonly: this.props.disabled || false,
      model: {
        value: null
      },
      expanded: this.props.expanded || false,
      edit: true,
      availableHeight: 0
    };
  }
  get itemsListClientHeight() {
    return this._itemsListRef.current ? this._itemsListRef.current.clientHeight : 0;
  }
  get itemsListScrollHeight() {
    return this._itemsListRef.current ? this._itemsListRef.current.scrollHeight : 0;
  }
  get scrollableContainerClientHeight() {
    return this._scrollableContainerRef.current ? this._scrollableContainerRef.current.clientHeight : 0;
  }
  get scrollableContainerScrollHeight() {
    return this._scrollableContainerRef.current ? this._scrollableContainerRef.current.scrollHeight : 0;
  }
  get autoGroupSelected() {
    return !!this.props.autoGroupSelected && (this.itemsListScrollHeight > this.itemsListClientHeight || this.scrollableContainerScrollHeight > this.scrollableContainerClientHeight);
  }
  onFilterInputClick() {
    if (this.desktop && this._filterInputRef.current) {
      this._filterInputRef.current.focus();
    }
  }
  dynamicTransform(item) {
    var _a;
    if (typeof item === "string") {
      const _selectListItem = new SelectListItem(item, item);
      _selectListItem.ref = item;
      return _selectListItem;
    }
    if (typeof item === "number") {
      const _value = item.toString();
      const _selectListItem2 = new SelectListItem(_value, _value);
      _selectListItem2.ref = item;
      return _selectListItem2;
    }
    const provider = ServiceProvider.getService("ITransformProvider");
    if (provider != null) {
      const _selectListItem3 = provider.toSelectListItem(item);
      _selectListItem3.ref = item;
      return _selectListItem3;
    }
    const anyItem = item;
    const converter = (_a = TypeConverter.getConverter(anyItem, "ISelectListItem")) !== null && _a !== void 0 ? _a : TypeConverter.getConverter(anyItem, SelectListItem);
    if (converter != null) {
      const _selectListItem4 = typeof converter === "function" ? converter(item) : converter.convert(item);
      _selectListItem4.ref = item;
      return _selectListItem4;
    }
    const id = Utility.findValueByAccessor(item, ["id", "code"]);
    const value = Utility.findStringValueByAccessor(item, ["value"]);
    const name = Utility.findStringValueByAccessor(item, ["name", "text", "label"]);
    const subtext = Utility.findStringValueByAccessor(item, ["subtext", "description"]);
    const excludeFromFilter = Utility.findValueByAccessor(item, "excludeFromFilter");
    const favorite = Utility.findStringValueByAccessor(item, "favorite") === "true";
    const groupName = Utility.findStringValueByAccessor(item, ["group", "group.name"]);
    const deleted = Utility.findValueByAccessor(item, ["delete", "isDeleted"]);
    const completed = Utility.findValueByAccessor(item, ["completed", "isCompleted", "status"]);
    const icon = Utility.findValueByAccessor(item, ["icon"]);
    const isDeleted = deleted === true || deleted == "1";
    const hasCompleted = completed != null && typeof completed === "boolean";
    const hasIcon = icon != null && (typeof icon === "string" || icon instanceof FileModel || icon.isFileModel || icon.name);
    const selectListItem = isDeleted || hasCompleted || hasIcon ? new StatusListItem(isDeleted, completed !== null && completed !== void 0 ? completed : true, hasIcon ? icon : null) : new SelectListItem();
    selectListItem.value = value ? value : id != null ? id.toString() : name ? name : Utility.getComponentId();
    selectListItem.text = name !== null && name !== void 0 ? name : "";
    selectListItem.subtext = subtext !== null && subtext !== void 0 ? subtext : "";
    selectListItem.favorite = favorite;
    selectListItem.excludeFromFilter = excludeFromFilter !== null && excludeFromFilter !== void 0 ? excludeFromFilter : false;
    selectListItem.group = groupName ? SelectListGroup.create(groupName) : null;
    selectListItem.ref = item;
    return selectListItem;
  }
  transform(item) {
    const anyItem = item;
    const listItem = anyItem.isSelectListSeparator ? anyItem : anyItem.isSelectListItem ? anyItem : this.props.transform ? this.props.transform(item) : this.dynamicTransform(item);
    if (listItem.ref == null) {
      listItem.ref = item;
    }
    return listItem;
  }
  noItemsFound() {
    return this.filterValue.length > 0 && !this._isLongList && this.filteredItems.every(item => item.favorite);
  }
  isLongList(items = null) {
    items = items || this.state.items;
    return items.length > this.filterMaxLength;
  }
  filter(items) {
    this._isLongList = this.isLongList(items);
    let filter = this.filterValue;
    if (filter) {
      filter = filter.toLowerCase();
      items = items.filter(item => item.favorite || item.excludeFromFilter || item.localizedLowerText.includes(filter) || item.localizedLowerSubtext.includes(filter) || item.group != null && item.group.lowerName.includes(filter));
      this._isLongList = this.isLongList(items);
      if (this._isLongList) {
        items = items.filter(item => item.excludeFromFilter);
      }
    } else if (this._isLongList) {
      items = items.filter(item => item.favorite || item.excludeFromFilter);
    }
    return items;
  }
  processMaxHeightProp() {
    this._maxHeight = null;
    if (this._itemsListRef.current && typeof this.props.maxHeight === "function") {
      const maxHeight = this.getMaxHeightValue();
      if (maxHeight != undefined) {
        this._maxHeight = maxHeight;
        const element = this.JQuery(this._itemsListRef.current);
        element.css("max-height", maxHeight);
      }
    }
  }
  getMaxHeightValue() {
    const filterHeight = 42;
    const defaultMaxHeight = 316;
    let maxHeight;
    const maxHeightProp = this.props.maxHeight;
    if (maxHeightProp) {
      const maxHeightType = typeof maxHeightProp;
      if (maxHeightType === "string") {
        maxHeight = maxHeightProp;
      } else if (maxHeightType === "number") {
        maxHeight = maxHeightProp;
      } else if (maxHeightType === "function") {
        maxHeight = maxHeightProp();
      }
    }
    if (this.hasFilter && maxHeight && typeof maxHeight === "number") {
      maxHeight = maxHeight - filterHeight;
    }
    return maxHeight || defaultMaxHeight;
  }
  order(items) {
    const groupSelected = !!this.props.groupSelected || this.autoGroupSelected;
    switch (this.orderBy) {
      case DropdownOrderBy.Name:
        items = items.sort((x, y) => SelectListItem.CompareByName(x, y, groupSelected));
        break;
      case DropdownOrderBy.Value:
        items = items.sort((x, y) => SelectListItem.CompareByValue(x, y, groupSelected));
        break;
      case DropdownOrderBy.None:
        if (this.grouping) {
          items = items.sort((x, y) => SelectListItem.CompareByGroup(x, y, groupSelected));
        }
        break;
    }
    return items;
  }
  updateModelValueAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const value = this.multiple ? this.selectedListItems.filter(item => item.selected).map(item => item.value) : this.selectedListItem != null ? this.selectedListItem.value : null;
      yield this.updateValueAsync(value);
    });
  }
  getVerticalAlign() {
    var _a;
    let align = (_a = this.props.verticalAlign) !== null && _a !== void 0 ? _a : DropdownVerticalAlign.Auto;
    if (align !== DropdownVerticalAlign.Auto) {
      return align;
    }
    const dropdownNode = this.getNode();
    if (!dropdownNode.length) {
      align = DropdownVerticalAlign.Bottom;
      return align;
    }
    const viewPortHeight = window.innerHeight;
    const pageYOffset = window.pageYOffset;
    const dropdownNodeTop = dropdownNode.offset().top - pageYOffset + dropdownNode.height() * 2;
    const listContainer = this._listContainerRef.current;
    const listContainerHeight = listContainer ? listContainer.clientHeight : 0;
    const availableBottomHeight = viewPortHeight - dropdownNodeTop;
    const fitBottom = availableBottomHeight > listContainerHeight;
    const fitTop = dropdownNodeTop > listContainerHeight + EXPAND_TOP_PADDING;
    if (fitBottom) {
      align = DropdownVerticalAlign.Bottom;
    } else if (fitTop) {
      align = DropdownVerticalAlign.Top;
    } else {
      align = DropdownVerticalAlign.Bottom;
    }
    return align;
  }
  getFilteredItems() {
    return this.props.groupSelected || this.autoGroupSelected ? this.order(this.state.filteredItems) : this.state.filteredItems;
  }
  getSelectedListItems(items) {
    if (SelectListItem.is(items)) {
      const selectedListItems = items.filter(item => item.selected);
      return selectedListItems.length > 0 ? selectedListItems : null;
    }
    return null;
  }
  getSelectedListItem(items) {
    if (SelectListItem.is(items)) {
      return items.find(item => item.selected) || null;
    }
    return null;
  }
  hasVisibleGroup(item) {
    return this.grouping && !item.favorite && item.group != null && item.group.name.length > 0 && (!this.groupSelected || !item.selected) && (!this.autoGroupSelected || !item.selected);
  }
  firstInGroup(item, index, hasVisibleGroup) {
    if (hasVisibleGroup) {
      const firstGroup = index == 0;
      if (firstGroup) {
        return true;
      }
      const previousItem = this.filteredItems[index - 1];
      const newGroup = !SelectListGroup.isEqual(previousItem.group, item.group);
      if (newGroup) {
        return true;
      }
      if (this.favorite) {
        const firstNotFavorite = previousItem.favorite;
        if (firstNotFavorite) {
          return true;
        }
      }
      if (this.groupSelected || this.autoGroupSelected) {
        const firstNotSelected = previousItem.selected;
        if (firstNotSelected) {
          return true;
        }
      }
    }
    return false;
  }
  invokeOnAddAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onAdd) {
        yield this.props.onAdd(this);
      }
      yield this.toggleAsync();
    });
  }
  invokeOnItemsChangeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onItemsChange) {
        yield this.props.onItemsChange(this);
      }
    });
  }
  getItem(item) {
    return item.selected ? item.ref != null ? item.ref : item : null;
  }
  invokeOnChangeAsync(item, userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        const selectedItem = this.getItem(item);
        yield this.props.onChange(this, selectedItem, userInteraction);
      }
    });
  }
  invokeOnItemClickAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onItemClick) {
        const selectedItem = this.getItem(item);
        yield this.props.onItemClick(this, selectedItem);
      }
    });
  }
  onListContainerClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.stopPropagation();
    });
  }
  onChangeAmountAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChangeAmount) {
        yield this.props.onChangeAmount(this, item.ref, item.amount);
      }
    });
  }
  onItemActionAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onItemAction) {
        yield this.props.onItemAction(this, item.ref);
      }
    });
  }
  selectDefaultAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const autoSelect = this.requiredType == DropdownRequiredType.AutoSelect;
      if (autoSelect) {
        const items = this.state.items;
        if (items.length > 0) {
          const unselected = items.every(item => !item.selected);
          if (unselected) {
            const firstItem = items[0];
            yield this.invokeSelectListItemAsync(firstItem, false);
          }
        }
      }
    });
  }
  selectItemHandler(item) {
    return __awaiter(this, void 0, void 0, function* () {
      const autoCollapse = this.autoCollapse;
      if (this.multiple) {
        const restricted = item.selected && this.requiredType != DropdownRequiredType.Manual && this.selectedItems.length === 1;
        let expanded = this.expanded;
        if (!restricted) {
          item.selected = !item.selected;
          yield this.updateModelValueAsync();
        }
        if (expanded && autoCollapse) {
          expanded = false;
          if (this.props.onToggle) {
            yield this.props.onToggle(this, expanded);
          }
        }
        if (this.isMounted) {
          const filteredItems = this.getFilteredItems();
          yield this.setState({
            filteredItems,
            expanded
          });
          yield this.invokeOnChangeAsync(item, true);
        }
      } else {
        const unselectable = this.requiredType == DropdownRequiredType.Manual;
        if (!item.selected) {
          this.selectedListItems.map(item => item.selected = false);
          item.selected = true;
          yield this.updateModelValueAsync();
          let expanded = this.expanded;
          if (autoCollapse) {
            expanded = false;
            if (this.props.onToggle) {
              yield this.props.onToggle(this, expanded);
            }
          }
          if (this.isMounted) {
            yield this.updateModelValueAsync();
            const filteredItems = this.getFilteredItems();
            yield this.setState({
              filteredItems,
              expanded
            });
            yield this.invokeOnChangeAsync(item, true);
          }
        } else if (unselectable) {
          this.selectedListItems.map(item => item.selected = false);
          item.selected = false;
          let expanded = this.expanded;
          if (autoCollapse) {
            expanded = false;
            if (this.props.onToggle) {
              yield this.props.onToggle(this, expanded);
            }
          }
          if (this.isMounted) {
            yield this.updateModelValueAsync();
            const filteredItems = this.getFilteredItems();
            yield this.setState({
              filteredItems,
              expanded
            });
            yield this.invokeOnChangeAsync(item, true);
          }
        } else {
          if (autoCollapse) {
            yield this.collapseAsync();
          }
        }
      }
      yield this.invokeOnItemClickAsync(item);
    });
  }
  clearSelectedAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.unselectAllAsync();
    });
  }
  cleanFilterAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this._filterInputRef.current.value = "";
      yield this.filterHandlerAsync();
    });
  }
  initializeItemsAsync(items, selectedItem, selectedItems) {
    return __awaiter(this, void 0, void 0, function* () {
      const prevSelectedItem = this.selectedListItem;
      const selectItems = items.map(item => this.transform(item));
      let filteredItems = this.filter(selectItems);
      filteredItems = this.order(filteredItems);
      yield this.setState({
        items: selectItems,
        filteredItems: filteredItems
      });
      if (this.multiple && selectedItems != null) {
        yield this.invokeSelectAsync(selectedItems, false);
      } else if (selectedItem != null) {
        yield this.invokeSelectAsync(selectedItem, false);
      }
      yield this.selectDefaultAsync();
      yield this.updateModelValueAsync();
      this.state.validationError = null;
      const newSelectedItem = this.selectedListItem;
      if (newSelectedItem != null) {
        const callback = prevSelectedItem == null || prevSelectedItem.value != newSelectedItem.value;
        if (callback) {
          yield this.invokeOnChangeAsync(newSelectedItem, false);
        }
      }
      yield this.invokeOnItemsChangeAsync();
    });
  }
  invokeSelectListItemsAsync(items, callback) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.multiple && items != null) {
        const itemValues = new Set();
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          const value = typeof item === "string" ? item : typeof item === "number" ? item.toString() : item.value;
          if (!itemValues.has(value)) {
            itemValues.add(value);
          }
        }
        const listItems = this.listItems;
        const updated = [];
        for (let i = 0; i < listItems.length; i++) {
          const listItem = listItems[i];
          const selected = itemValues.has(listItem.value);
          if (listItem.selected !== selected) {
            updated.push(listItem);
            listItem.selected = selected;
          }
        }
        if (updated) {
          yield this.updateModelValueAsync();
          if (callback) {
            for (let i = 0; i < updated.length; i++) {
              yield this.invokeOnChangeAsync(updated[i], false);
            }
          }
          if (this.isMounted) {
            const filteredItems = this.getFilteredItems();
            yield this.setState({
              filteredItems
            });
          }
        }
      }
    });
  }
  invokeSelectAsync(itemOrItems, callback) {
    return __awaiter(this, void 0, void 0, function* () {
      if (itemOrItems != null) {
        if (Array.isArray(itemOrItems)) {
          const listItems = [];
          for (let i = 0; i < itemOrItems.length; i++) {
            const listItem = this.find(itemOrItems[i]);
            if (listItem != null) {
              listItems.push(listItem);
            }
          }
          yield this.invokeSelectListItemsAsync(listItems, callback);
        } else {
          const listItem = this.find(itemOrItems);
          yield this.invokeSelectListItemAsync(listItem, callback);
        }
      }
    });
  }
  invokeSelectListItemAsync(item, callback) {
    return __awaiter(this, void 0, void 0, function* () {
      if (item != null) {
        const itemValue = typeof item === "string" ? item : typeof item === "number" ? item.toString() : item.value;
        const listItem = this.find(itemValue);
        if (listItem != null && !listItem.selected) {
          if (!this.multiple) {
            this.selectedListItems.map(item => item.selected = false);
          }
          listItem.selected = true;
          yield this.updateModelValueAsync();
          if (callback) {
            yield this.invokeOnChangeAsync(listItem, false);
          }
          if (this.isMounted) {
            const filteredItems = this.getFilteredItems();
            yield this.setState({
              filteredItems
            });
          }
        }
      } else if (!this.multiple && this.selectedListItem != null) {
        const listItem = this.selectedListItem;
        listItem.selected = false;
        yield this.updateModelValueAsync();
        if (callback) {
          yield this.invokeOnChangeAsync(listItem, false);
        }
        if (this.isMounted) {
          const filteredItems = this.getFilteredItems();
          yield this.setState({
            filteredItems
          });
        }
      }
    });
  }
  favoriteItemHandler(e, item) {
    return __awaiter(this, void 0, void 0, function* () {
      e.stopPropagation();
      if (this.favorite) {
        item.favorite = !item.favorite;
        if (this.props.onFavoriteChange) {
          yield this.props.onFavoriteChange(this, item.ref, item.favorite);
        }
        const filteredItems = this.order(this.state.filteredItems);
        yield this.setState({
          filteredItems
        });
      }
    });
  }
  filterHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      let filteredItems = this.filter(this.listItems);
      filteredItems = this.order(filteredItems);
      yield this.setState({
        filteredItems
      });
    });
  }
  get filterValue() {
    return this._filterInputRef.current != null ? this._filterInputRef.current.value : "";
  }
  get filteredItems() {
    return this.state.filteredItems;
  }
  get isListType() {
    return this.props.type === DropdownType.List;
  }
  get isDropdownType() {
    return !this.isListType;
  }
  get styleSchema() {
    return this.props.styleSchema || DropdownSchema.Default;
  }
  getType() {
    return BaseInputType.Dropdown;
  }
  ignoreValueProps() {
    return true;
  }
  get autoCollapse() {
    return this.isListType ? false : this.props.autoCollapse != null ? this.props.autoCollapse : !this.multiple;
  }
  get multiple() {
    return this.props.multiple || false;
  }
  get required() {
    return this.props.required || false;
  }
  get requiredType() {
    return this.required ? this.props.requiredType != null ? this.props.requiredType : DropdownRequiredType.AutoSelect : DropdownRequiredType.Manual;
  }
  get clearButton() {
    return this.props.clearButton === true && this.requiredType == DropdownRequiredType.Manual;
  }
  get favorite() {
    return this.props.favorite || false;
  }
  get grouping() {
    return this.props.noGrouping != true;
  }
  get groupSelected() {
    return this.props.groupSelected || false;
  }
  get expanded() {
    return this.state.expanded;
  }
  get collapsed() {
    return !this.expanded;
  }
  get orderBy() {
    return this.props.orderBy || DropdownOrderBy.Name;
  }
  getValidators() {
    return [];
  }
  get listItems() {
    return this.state.items;
  }
  get selectedListItems() {
    const items = this.state.items.filter(item => item.selected);
    //If no items (data) yet, return props.selectedItems if it is specified
    if (this.multiple && items.length == 0 && this.listItems.length === 0) {
      const selectedItems = this.props.selectedItems || null;
      if (selectedItems && typeof selectedItems[0] === "object") {
        return selectedItems.map(item => this.transform(item));
      }
    }
    return items;
  }
  get selectedListItem() {
    if (this.multiple) {
      return null;
    }
    const items = this.selectedListItems;
    if (items.length >= 1) {
      return items[0];
    }
    //If no items (data) yet, return props.selectedItem if it is specified
    if (this.listItems.length === 0) {
      const selectedItem = this.props.selectedItem || null;
      if (selectedItem != null && typeof selectedItem === "object") {
        return this.transform(selectedItem);
      }
      return null;
    }
    return null;
  }
  get items() {
    return this.listItems.map(item => item.ref);
  }
  get selectedItems() {
    return this.selectedListItems.map(item => item.ref);
  }
  get selectedValues() {
    return this.selectedListItems.map(item => item.value);
  }
  get selectedItem() {
    const selectedListItem = this.selectedListItem;
    return selectedListItem ? selectedListItem.ref : null;
  }
  get selectedValue() {
    const selectedListItem = this.selectedListItem;
    return selectedListItem ? selectedListItem.value : null;
  }
  get align() {
    return this.props.align || DropdownAlign.Right;
  }
  get filterMinLength() {
    return this.props.filterMinLength || FILTER_MIN_LENGTH;
  }
  get filterMaxLength() {
    return this.props.filterMaxLength || FILTER_MAX_LENGTH;
  }
  get hasFilter() {
    return !this.props.noFilter && this.listItems.length >= this.filterMinLength;
  }
  get hasAddButton() {
    return !!this.props.addButton;
  }
  get disabled() {
    return this.readonly;
  }
  get selectType() {
    return this.props.selectType || DropdownSelectType.Background;
  }
  get subtextType() {
    return this.props.subtextType || DropdownSubtextType.Row;
  }
  get selectedTextFormat() {
    return this.props.selectedTextFormat ? typeof this.props.selectedTextFormat === "number" ? this.props.selectedTextFormat : SELECTED_TEXT_FORMAT : null;
  }
  get noSubtext() {
    return this.props.noSubtext === true;
  }
  get hasSelected() {
    return this.multiple ? this.selectedListItems.length > 0 : this.selectedListItem != null;
  }
  unselectAllAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.multiple && this.selectedListItems) {
        yield this.invokeSelectListItemsAsync([], true);
      } else if (this.selectedListItem) {
        yield this.invokeSelectListItemAsync(null, true);
      }
    });
  }
  selectItemAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      const listItem = item != null ? this.transform(item) : null;
      yield this.invokeSelectListItemAsync(listItem, true);
    });
  }
  selectAsync(itemOrItems) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeSelectAsync(itemOrItems, true);
    });
  }
  selectListItemAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeSelectListItemAsync(item, true);
    });
  }
  selectListItemsAsync(items) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeSelectListItemsAsync(items, true);
    });
  }
  selectFirstAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.listItems.length > 0) {
        yield this.invokeSelectListItemAsync(this.listItems[0], true);
      }
    });
  }
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.initializeItemsAsync(this.props.items, this.props.selectedItem, this.props.selectedItems);
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const props = this.props;
      const newExpanded = props.expanded !== nextProps.expanded;
      const newDisabled = props.disabled !== nextProps.disabled;
      const newGroupSelected = props.groupSelected !== nextProps.groupSelected;
      const newAutoGroupSelected = props.autoGroupSelected !== nextProps.autoGroupSelected;
      const newFavorite = props.favorite !== nextProps.favorite;
      const newRequired = props.required !== nextProps.required;
      const newItems = !Comparator.isEqual(props.items, nextProps.items);
      const newSelectedListItem = !Comparator.isEqual(props.selectedItem, nextProps.selectedItem);
      const newSelectedListItems = !Comparator.isEqual(props.selectedItems, nextProps.selectedItems);
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (newExpanded || newDisabled) {
        this.state.expanded = nextProps.expanded || false;
        this.state.readonly = nextProps.disabled || false;
        yield this.setState(this.state);
      }
      if (newItems || newSelectedListItem || newSelectedListItems || newGroupSelected || newAutoGroupSelected || newFavorite || newRequired) {
        const selectedItem = newSelectedListItem ? nextProps.selectedItem : nextProps.selectedItem || this.getSelectedListItem(nextProps.items) || this.selectedItem;
        const selectedItems = newSelectedListItems ? nextProps.selectedItems : nextProps.selectedItems || this.getSelectedListItems(nextProps.items) || this.selectedItems;
        yield this.initializeItemsAsync(nextProps.items, selectedItem, selectedItems);
      }
    });
  }
  componentDidUpdate() {
    return __awaiter(this, void 0, void 0, function* () {
      this.processMaxHeightProp();
    });
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const expanded = !this.state.expanded;
      if (this.props.onToggle) {
        yield this.props.onToggle(this, expanded);
      }
      if (this.isMounted) {
        yield this.setState({
          expanded
        });
        if (expanded) {
          if (this._autoScroll) {
            this._autoScroll = false;
            yield this.scrollToSelected(false);
          }
          this.onFilterInputClick();
        }
      }
    });
  }
  collapseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.expanded) {
        yield this.toggleAsync();
      }
    });
  }
  expandAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.state.expanded) {
        yield this.toggleAsync();
      }
    });
  }
  reRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.initializeItemsAsync(this.props.items, this.props.selectedItem, this.props.selectedItems);
    });
  }
  reRender() {
    // reload without await
    // noinspection JSIgnoredPromiseFromCall
    this.reRenderAsync();
  }
  find(item) {
    if (item != null && this.listItems) {
      const itemValue = typeof item === "string" ? item : typeof item === "number" ? item.toString() : this.transform(item).value;
      if (itemValue) {
        return this.listItems.find(item => item.value === itemValue) || null;
      }
    }
    return null;
  }
  scrollToSelected(smooth = false) {
    if (this.expanded) {
      const maxHeightIsLimited = !!this._maxHeight;
      const scrollableContainerElement = maxHeightIsLimited ? this._itemsListRef.current : this._scrollableContainerRef.current;
      if (scrollableContainerElement) {
        const selectedListItem = this.selectedListItem;
        if (selectedListItem) {
          const selectedItemElement = scrollableContainerElement.querySelector(`.${styles$R.selectedItem}`);
          if (selectedItemElement) {
            const scrollableContainerHeight = this.JQuery(scrollableContainerElement).height() || 0;
            const top = selectedItemElement.offsetTop;
            if (top > scrollableContainerHeight) {
              const behavior = smooth ? "smooth" : "auto";
              scrollableContainerElement.scrollTo({
                top,
                behavior
              });
            }
          }
        }
      }
    }
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isDropdownType && this.expanded) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id, this.props.toggleButtonId);
        if (outside) {
          yield this.collapseAsync();
        }
      }
    });
  }
  onGlobalKeydown(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.type !== DropdownType.List) {
        if (e.keyCode === 27) {
          yield this.collapseAsync();
        }
      }
    });
  }
  renderClearIcon() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$R.clearButton)
    }, /*#__PURE__*/React.createElement(Icon, {
      stopPropagation: true,
      name: "fa fa-times",
      size: IconSize.Normal,
      onClick: () => this.clearSelectedAsync()
    }));
  }
  renderToggleIcon(clearButtonVisible, className) {
    let iconProps = {
      name: "fa-caret-down",
      style: IconStyle.Solid
    };
    if (this.styleSchema === DropdownSchema.Widget) {
      iconProps.name = "fa-bars";
      iconProps.size = IconSize.ExtraSmall;
    } else if (this.props.toggleIcon) {
      if (typeof this.props.toggleIcon == "string") {
        iconProps.name = this.props.toggleIcon;
      } else {
        iconProps = this.props.toggleIcon;
      }
    }
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$R.toggleButtonContainer, className)
    }, clearButtonVisible && this.renderClearIcon(), /*#__PURE__*/React.createElement("div", {
      className: styles$R.toggleButton
    }, /*#__PURE__*/React.createElement(Icon, Object.assign({}, iconProps, {
      size: IconSize.Normal
    }))));
  }
  renderAddButton() {
    const addButton = this.props.addButton;
    let text;
    if (typeof addButton === "function") {
      const render = addButton(this);
      // noinspection SuspiciousTypeOfGuard
      if (typeof render !== "string") {
        return render;
      }
      text = render;
    } else if (typeof addButton === "string") {
      text = DropdownLocalizer$1.get(addButton);
    } else {
      text = DropdownLocalizer$1.add;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: styles$R.addButton,
      onClick: () => this.invokeOnAddAsync()
    }, /*#__PURE__*/React.createElement(Button, {
      type: ButtonType.Orange,
      icon: {
        name: "fas plus"
      }
    }), /*#__PURE__*/React.createElement("span", null, text));
  }
  renderSelectedItem() {
    const clearButtonVisible = this.clearButton && this.hasSelected;
    const expandedStyle = this.styleSchema === DropdownSchema.Widget && this.state.expanded && this.css(styles$R.hovered, styles$R.focused);
    const transparentStyle = this.styleSchema === DropdownSchema.Transparent && styles$R.transparent;
    const clearButtonVisibleStyle = clearButtonVisible && styles$R.clearButtonVisible;
    const inlineStyles = {};
    if (this.props.textAlign) {
      inlineStyles.textAlign = StylesUtility.textAlign(this.props.textAlign);
      inlineStyles.width = "100%";
    }
    const noSubtext = this.noSubtext;
    const selectedListItem = this.selectedListItem;
    const title = selectedListItem !== null && noSubtext ? DropdownLocalizer$1.get(selectedListItem.subtext) : "";
    let text = this.props.selectedTextTransform ? this.props.selectedTextTransform(this) : "";
    if (!text) {
      text = selectedListItem !== null ? noSubtext ? DropdownLocalizer$1.get(selectedListItem.text) : `${DropdownLocalizer$1.get(selectedListItem.text)} <small>${ReactUtility.toSingleLine(DropdownLocalizer$1.get(selectedListItem.subtext))}</small>` : this.selectedListItems.length !== 0 ? this.props.multipleSelectedText ? DropdownLocalizer$1.multipleSelected : this.selectedTextFormat && this.selectedListItems.length <= this.selectedTextFormat ? noSubtext ? this.selectedListItems.take(this.selectedTextFormat).map(item => DropdownLocalizer$1.get(item.text)).join(", ") : this.selectedListItems.take(this.selectedTextFormat).map(item => item.subtext ? `${DropdownLocalizer$1.get(item.text)} <small>${DropdownLocalizer$1.get(item.subtext)}</small>` : DropdownLocalizer$1.get(item.text)).join(", ") : DropdownLocalizer$1.get(DropdownLocalizer$1.multipleSelected, this.selectedListItems.length) : this.props.nothingSelectedText ? DropdownLocalizer$1.get(this.props.nothingSelectedText) : DropdownLocalizer$1.nothingSelected;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$R.selected, "form-control", expandedStyle, transparentStyle, clearButtonVisibleStyle, "selected-item"),
      title: title,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAsync();
      })
    }, /*#__PURE__*/React.createElement("span", {
      style: inlineStyles
    }, ReactUtility.toSmalls(text)), this.renderToggleIcon(clearButtonVisible, transparentStyle));
  }
  renderSelectListItem(item, index) {
    const isSeparator = item.isSelectListSeparator;
    const hasVisibleGroup = !isSeparator && this.hasVisibleGroup(item);
    const needGroupSeparator = !isSeparator && this.firstInGroup(item, index, hasVisibleGroup);
    const selected = !isSeparator && item.selected;
    const favorite = !isSeparator && this.props.favorite === true;
    const checkbox = !isSeparator && this.selectType == DropdownSelectType.Checkbox;
    const listItemStyle = this.isListType && this.props.styleSchema !== DropdownSchema.Widget && styles$R.listItem;
    const inlineSubtextStyle = this.subtextType == DropdownSubtextType.Inline && styles$R.inlineSubtext;
    const selectedStyle = selected && !checkbox && styles$R.selectedItem;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, needGroupSeparator && ( /*#__PURE__*/React.createElement(React.Fragment, null, index > 0 && ( /*#__PURE__*/React.createElement("hr", {
      className: styles$R.groupSeparator
    })), hasVisibleGroup && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$R.item, styles$R.group)
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, DropdownLocalizer$1.get(item.group.name))))))), !isSeparator ? ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$R.item, listItemStyle, inlineSubtextStyle, selectedStyle, hasVisibleGroup && styles$R.itemGroupIdent),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.selectItemHandler(item);
      })
    }, favorite && ( /*#__PURE__*/React.createElement("div", {
      className: styles$R.iconContainer,
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.favoriteItemHandler(e, item);
      })
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "star",
      style: item.favorite ? IconStyle.Solid : IconStyle.Regular,
      size: IconSize.Large
    }))), /*#__PURE__*/React.createElement(DropdownListItem, {
      item: item,
      subtextHidden: this.subtextType == DropdownSubtextType.Hidden,
      noWrap: this.props.noWrap,
      actionIcon: this.props.itemActionIcon,
      onChangeAmount: (sender, item) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onChangeAmountAsync(item);
      }),
      onAction: (sender, item) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onItemActionAsync(item);
      })
    }), checkbox && ( /*#__PURE__*/React.createElement("div", {
      className: styles$R.checkbox
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "fas check",
      size: IconSize.Large,
      customStyle: {
        visibility: !selected ? "hidden" : undefined
      }
    }))))) : ( /*#__PURE__*/React.createElement("hr", {
      className: styles$R.groupSeparator
    })));
  }
  renderInput() {
    const hasItems = this.listItems.length > 0;
    const alignStyle = this.align === DropdownAlign.Left && styles$R.alignLeft;
    const verticalAlignStyle = this.getVerticalAlign() === DropdownVerticalAlign.Top ? `${styles$R.alignTop} alignTop` : styles$R.alignBottom;
    const toggleStyle = this.state.expanded ? this.css(styles$R.itemsContainer, styles$R.opened, alignStyle, verticalAlignStyle) : styles$R.itemsContainer;
    const dropdownStyle = this.isDropdownType ? styles$R.dropdown : styles$R.list;
    const dropdownWidgetStyle = this.styleSchema === DropdownSchema.Widget && this.isDropdownType && styles$R.dropdownWidget;
    const transparentStyle = this.styleSchema === DropdownSchema.Transparent && styles$R.transparent;
    const noWrapStyle = this.props.noWrap && styles$R.noWrap;
    const smallStyle = this.props.small && styles$R.small;
    const inlineStyles = {};
    if (this.props.minWidth) {
      inlineStyles.minWidth = this.props.minWidth;
    }
    const longListPlaceholder = this.isLongList() ? DropdownLocalizer$1.getResults : DropdownLocalizer$1.filterResults;
    const noDataText = this.props.noDataText ? DropdownLocalizer$1.get(this.props.noDataText) : DropdownLocalizer$1.noData;
    const maxHeight = this.getMaxHeightValue();
    const scrollableContainerInlineStyles = {
      maxHeight: maxHeight
    };
    const itemsListInlineStyles = {
      position: this.props.absoluteListItems ? "absolute" : "unset"
    };
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(dropdownStyle, dropdownWidgetStyle, transparentStyle, smallStyle, this.disabled && styles$R.disabled, "dropdown-container"),
      style: inlineStyles
    }, this.isDropdownType && this.styleSchema !== DropdownSchema.Widget && this.renderSelectedItem(), /*#__PURE__*/React.createElement("div", {
      className: toggleStyle,
      ref: this._listContainerRef,
      onClick: e => this.onListContainerClickAsync(e)
    }, this.hasAddButton && this.renderAddButton(), this.hasFilter && ( /*#__PURE__*/React.createElement("div", {
      className: styles$R.filter,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return this.onFilterInputClick();
      })
    }, /*#__PURE__*/React.createElement("input", {
      id: "filter_input" + this.id,
      ref: this._filterInputRef,
      className: "form-control filter",
      type: "text",
      placeholder: longListPlaceholder,
      onKeyUp: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.filterHandlerAsync();
      })
    }), this.filterValue && /*#__PURE__*/React.createElement("span", {
      className: this.css("fa fa-times", styles$R.clean),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.cleanFilterAsync();
      })
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles$R.scrollableContainer,
      ref: this._scrollableContainerRef,
      style: scrollableContainerInlineStyles
    }, /*#__PURE__*/React.createElement("div", {
      ref: this._itemsListRef,
      className: styles$R.itemsList,
      style: itemsListInlineStyles
    }, hasItems ? ( /*#__PURE__*/React.createElement(React.Fragment, null, this.filteredItems.map((item, index) => this.renderSelectListItem(item, index)), this.noItemsFound() && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$R.noResults, noWrapStyle)
    }, /*#__PURE__*/React.createElement("span", null, DropdownLocalizer$1.noItems))))) : ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$R.noResults, noWrapStyle)
    }, /*#__PURE__*/React.createElement("span", null, noDataText)))))));
  }
}

const DEFAULT_PAGE_SIZE = 100;
const MAX_PAGE_SIZE = 20;
var ColumnType;
(function (ColumnType) {
  ColumnType[ColumnType["Custom"] = 0] = "Custom";
  ColumnType[ColumnType["Text"] = 1] = "Text";
  ColumnType[ColumnType["Number"] = 2] = "Number";
  ColumnType[ColumnType["Date"] = 3] = "Date";
  ColumnType[ColumnType["Enum"] = 4] = "Enum";
  ColumnType[ColumnType["Boolean"] = 5] = "Boolean";
  ColumnType[ColumnType["Dropdown"] = 6] = "Dropdown";
  ColumnType[ColumnType["Address"] = 7] = "Address";
  ColumnType[ColumnType["Icon"] = 8] = "Icon";
})(ColumnType || (ColumnType = {}));
var ColumnActionType;
(function (ColumnActionType) {
  ColumnActionType["Details"] = "_details";
  ColumnActionType["Preview"] = "_preview";
  ColumnActionType["Download"] = "_download";
})(ColumnActionType || (ColumnActionType = {}));
var GridHoveringType;
(function (GridHoveringType) {
  GridHoveringType[GridHoveringType["Row"] = 0] = "Row";
  GridHoveringType[GridHoveringType["Cell"] = 1] = "Cell";
  GridHoveringType[GridHoveringType["EditableCell"] = 2] = "EditableCell";
  GridHoveringType[GridHoveringType["None"] = 3] = "None";
})(GridHoveringType || (GridHoveringType = {}));
var GridOddType;
(function (GridOddType) {
  GridOddType[GridOddType["Row"] = 0] = "Row";
  GridOddType[GridOddType["None"] = 1] = "None";
})(GridOddType || (GridOddType = {}));
var GridSelectableType;
(function (GridSelectableType) {
  GridSelectableType[GridSelectableType["Single"] = 0] = "Single";
  GridSelectableType[GridSelectableType["Multiple"] = 1] = "Multiple";
})(GridSelectableType || (GridSelectableType = {}));
var CellPaddingType;
(function (CellPaddingType) {
  CellPaddingType[CellPaddingType["Large"] = 0] = "Large";
  CellPaddingType[CellPaddingType["Medium"] = 1] = "Medium";
  CellPaddingType[CellPaddingType["Small"] = 2] = "Small";
})(CellPaddingType || (CellPaddingType = {}));
var BorderType;
(function (BorderType) {
  BorderType[BorderType["Default"] = 0] = "Default";
  BorderType[BorderType["DarkSeparators"] = 1] = "DarkSeparators";
})(BorderType || (BorderType = {}));
class ColumnModel {
  constructor() {
    this._lastOuterWidth = 0;
    this.name = null;
    this.index = 0;
    this.header = "";
    this.title = "";
    this.accessor = null;
    this.visible = true;
    this.responsivePriority = 0;
    this.group = null;
    this.textAlign = null;
    this.verticalAlign = null;
    this.type = ColumnType.Custom;
    this.editable = false;
    this.removable = true;
    this.reRenderRow = false;
    this.rotate = false;
    this.format = null;
    this.minWidth = null;
    this.maxWidth = null;
    this.maxHeight = null;
    this.noWrap = false;
    this.wordBreak = false;
    this.stretch = false;
    this.total = false;
    this.route = null;
    this.className = null;
    this.settings = new ColumnSettings();
    /**
     * Sort direction.
     * The grid's defaultSortDirection property will override this, so don't use both.
     */
    this.sorting = null;
    /**
     * Is the column used for default sorting?
     * The grid's defaultSortColumn property will override this, so don't use both.
     */
    this.isDefaultSorting = false;
    this.actions = [];
    this.headerCellInstance = {};
    this.collapsed = false;
    this.tag = null;
    this.grid = new GridModel();
  }
  outerWidth(visible = true) {
    return this.isVisible && this.headerCellInstance.outerWidth ? this._lastOuterWidth = this.headerCellInstance.outerWidth() : visible ? 0 : this._lastOuterWidth;
  }
  get isFirst() {
    return this.index === 0;
  }
  get isLast() {
    return this.index === this.grid.columns.length - 1;
  }
  get cells() {
    return this.grid.rows.map(row => row.cells[this.index]);
  }
  get sortable() {
    return this.sorting != null && this.sorting != false;
  }
  get isVisible() {
    return this.visible && !this.collapsed;
  }
}
class GridModel {
  constructor() {
    this.id = "";
    this.className = null;
    this.responsiveRowClassName = null;
    this.rows = [];
    this.columns = [];
    this.headerMinHeight = null;
    this.noDataNoHeader = false;
    this.minWidth = null;
    this.cellPadding = CellPaddingType.Large;
    this.noDataText = null;
    this.detailsColStart = null;
    this.detailsColEnd = null;
    this.autoToggle = false;
    this.hovering = GridHoveringType.Row;
    this.odd = GridOddType.Row;
    this.responsive = false;
    this.pagination = false;
    this.checkable = false;
    this.selectableType = null;
    this.readonly = false;
    this.borderType = BorderType.DarkSeparators;
    this.optimization = true;
    this.checked = false;
    this.instance = {};
    this.checkHeaderInstance = {};
    this.data = [];
    this.pageNumber = 1;
    this.pageSize = DEFAULT_PAGE_SIZE;
    this.sortColumn = null;
    this.sortDirection = null;
    this.totalItemCount = 0;
    this.generation = 0;
    this.tag = null;
  }
  get key() {
    return `grid_${this.id}`;
  }
  get modified() {
    return this.rows.some(item => item.modified);
  }
  get total() {
    return this.columns.some(item => item.total);
  }
  get checkedRows() {
    return this.checkable ? this.rows.filter(row => row.checked) : [];
  }
  get selectedRows() {
    return this.selectable ? this.rows.filter(row => row.selected) : [];
  }
  get selectedRow() {
    const selectedRows = this.selectedRows;
    return selectedRows.length > 0 ? selectedRows[0] : null;
  }
  get items() {
    return this.rows.map(row => row.model);
  }
  get checkedItems() {
    return this.checkedRows.map(row => row.model);
  }
  get selectedItems() {
    return this.selectedRows.map(row => row.model);
  }
  get selectedItem() {
    const selectedItems = this.selectedItems;
    return selectedItems.length > 0 ? selectedItems[0] : null;
  }
  get firstRow() {
    return this.rows[0];
  }
  get lastRow() {
    return this.rows[this.rows.length - 1];
  }
  get mobile() {
    return this.responsive && ch.mobile;
  }
  get desktop() {
    return !this.mobile;
  }
  get selectable() {
    return this.selectableType != null;
  }
  fullWidth(visible = true) {
    return this.columns.sum(column => column.outerWidth(visible));
  }
  collapsedWidth() {
    return this.columns.where(column => column.collapsed).sum(column => column.outerWidth(false));
  }
  getDump() {
    const dump = new Dictionary();
    //const cells: CellModel<TItem>[] = [];
    this.rows.filter(row => row.modified).forEach(row => row.cells.filter(cell => cell.modified).forEach(cell => dump.setValue(cell.initialKey, cell.value)));
    return dump;
  }
  setDump(dump) {
    let modified = false;
    const length = dump.size();
    if (length) {
      this.rows.forEach(row => row.cells.forEach(cell => {
        const key = cell.initialKey;
        if (dump.containsKey(key)) {
          const value = dump.getValue(key);
          cell.setValue(value);
          modified = modified || cell.modified;
        }
      }));
    }
    return modified;
  }
  setDumpAsync(dump, forceReRender = false) {
    return __awaiter(this, void 0, void 0, function* () {
      const modified = this.setDump(dump);
      if (modified || forceReRender) {
        yield this.reRenderAsync();
      }
      return modified;
    });
  }
  reloadComponentsAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const components = this.rows.selectMany(row => row.cells.where(cell => cell.asyncContentInstance != null).map(cell => cell.asyncContentInstance));
      if (components) {
        yield Utility.forEachAsync(components, component => __awaiter(this, void 0, void 0, function* () {
          return yield component.reloadAsync();
        }));
      }
    });
  }
  reloadComponents() {
    // reload without await
    // noinspection JSIgnoredPromiseFromCall
    this.reloadComponentsAsync();
  }
  reRenderInputsAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const inputs = this.rows.selectMany(row => row.cells.where(cell => cell.inputContentInstance != null).map(cell => cell.inputContentInstance));
      if (inputs) {
        yield Utility.forEachAsync(inputs, input => __awaiter(this, void 0, void 0, function* () {
          return yield input.reRenderAsync();
        }));
      }
    });
  }
  reRenderInputs() {
    // reload without await
    // noinspection JSIgnoredPromiseFromCall
    this.reRenderInputsAsync();
  }
  reloadAsync(keepState = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.instance && this.instance.reloadAsync) {
        if (keepState) {
          const dump = this.getDump();
          const expandedIds = this.rows.where(item => item.expanded).map(item => item.key);
          yield this.instance.reloadAsync();
          const rows = this.rows.where(item => expandedIds.includes(item.key));
          if (rows.length > 0) {
            rows.forEach(item => item.expanded = true);
            yield this.setDumpAsync(dump, true);
          } else {
            yield this.setDumpAsync(dump);
          }
        } else {
          yield this.instance.reloadAsync();
        }
      }
    });
  }
  reload(keepState = false) {
    // reload without await
    // noinspection JSIgnoredPromiseFromCall
    this.reloadAsync(keepState);
  }
  clearAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.instance && this.instance.clearAsync) {
        yield this.instance.clearAsync();
      }
    });
  }
  clear() {
    // clear without await
    // noinspection JSIgnoredPromiseFromCall
    this.clearAsync();
  }
  find(model, equals) {
    equals = equals !== null && equals !== void 0 ? equals : Comparator.isEqual;
    return this.rows.find(row => equals(row.model, model)) || null;
  }
  get(model, equals) {
    const row = this.find(model, equals);
    if (row == null) throw Error("Row cannot be found, unknown model.");
    return row;
  }
  getAsync(endpoint) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.instance.getAsync(endpoint);
    });
  }
  postAsync(endpoint, request) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.instance.postAsync(endpoint, request);
    });
  }
  insertAsync(index, ...items) {
    return __awaiter(this, void 0, void 0, function* () {
      const rows = this.rows;
      if (index < 0 || index > rows.length) throw Error(`Row index "${index}" out of range, can be in [0..${rows.length}]`);
      const newRows = items.map((item, itemIndex) => GridTransformer.toRow(this, item, index + itemIndex));
      rows.splice(index, 0, ...newRows);
      for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
        const row = rows[rowIndex];
        row.index = rowIndex;
        row.cells.forEach(cell => cell.clearRowSpan());
      }
      yield this.instance.reRenderAsync();
      return newRows;
    });
  }
  addAsync(model) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.insertAsync(this.rows.length, model);
    });
  }
  reRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.instance.reRenderAsync();
    });
  }
  bind() {
    return this.rows.map(row => row.bind()).some(modified => modified);
  }
  bindAsync(forceRender = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const modified = this.bind();
      if (forceRender || modified) {
        yield this.reRenderAsync();
      }
    });
  }
  saveAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this.rows.forEach(row => row.saveAsync());
    });
  }
  delete(modelOrIndex) {
    const rows = this.rows;
    let index = 0;
    if (typeof modelOrIndex === "number") {
      index = modelOrIndex;
      if (index < 0 || index >= rows.length) throw Error(`Row index "${index}" out of range, can be in [0..${rows.length}].`);
    } else {
      const row = this.find(modelOrIndex);
      if (row == null) {
        return;
      }
      index = row.index;
    }
    rows.removeAt(index);
    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
      const row = rows[rowIndex];
      row.index = rowIndex;
      row.cells.forEach(cell => cell.clearRowSpan());
    }
  }
  deleteAsync(modelOrIndex) {
    return __awaiter(this, void 0, void 0, function* () {
      this.delete(modelOrIndex);
      //await this.instance.newGenerationAsync();
      yield this.instance.reRenderAsync();
    });
  }
}
class ColumnSettingsDefinition {}
class ColumnSettings {
  constructor() {
    this.min = null;
    this.max = null;
    this.step = null;
    this.maxLength = null;
    this.hideZero = false;
    /**
     * Show additional info line below main text.
     */
    this.infoAccessor = null;
    /**
     * If number is used for infoAccessor: Option to hide value if 0
     */
    this.infoHideZero = false;
    /**
     * If infoAccessor value equals to main text: Option to hide if equal
     */
    this.infoHideEqual = false;
    /**
     * Title for infoAccessor.
     */
    this.infoTitle = null;
    /**
     * Show infoAccessor value with bold style
     */
    this.infoBold = false;
    /**
     * Show infoAccessor value with bold style if it doesn't match to main text
     */
    this.infoBoldNotEqual = false;
    this.infoFormat = null;
    /**
     * Redirects to specified PageRoute.
     */
    this.infoRoute = null;
    this.descriptionAccessor = null;
    this.descriptionTitle = null;
    this.descriptionMaxLength = null;
    this.descriptionJustify = Justify.Left;
    this.descriptionIcon = null;
    this.descriptionAlight = Align.Bottom;
    this.required = false;
    this.requiredType = DropdownRequiredType.Manual;
    this.addButton = false;
    this.nothingSelectedText = null;
    this.multiple = false;
    this.noFilter = false;
    this.autoCollapse = true;
    this.groupSelected = false;
    this.align = DropdownAlign.Right;
    this.verticalAlign = DropdownVerticalAlign.Auto;
    this.arrows = false;
    this.locationPicker = false;
  }
}
class ColumnActionDefinition {}
class ColumnAction {
  constructor() {
    this.name = null;
    this.title = null;
    this.icon = null;
    this.type = null;
    this.right = false;
    this.toggleModal = null;
    this.alwaysAvailable = false;
    this.actions = null;
    this.confirm = null;
    this.column = new ColumnModel();
  }
}
class CellAction {
  constructor() {
    this.action = new ColumnAction();
    this.visible = true;
    //public enabled: boolean = true;
    this.instance = {};
  }
}
class DescriptionCellAction extends CellAction {
  constructor() {
    super(...arguments);
    this.readonly = null;
    this.justify = Justify.Left;
    this.alight = Align.Bottom;
    this.maxLength = null;
    this.isDescription = true;
  }
}
class ColumnDefinition {
  constructor() {
    /**
     * @default 0
     */
    this.responsivePriority = 0;
  }
}
class RowModel {
  constructor() {
    this._initialKey = null;
    this._key = null;
    this._model = {};
    this.id = 0;
    this.index = 0;
    this.grid = new GridModel();
    this.cells = [];
    this.className = null;
    this.expanded = false;
    this.deleted = false;
    this.hasDetails = false;
    this.instance = {};
    this.checkable = false;
    this.selectable = false;
    this.readonly = false;
    this.checked = false;
    this.selected = false;
    this.responsiveContainerExpanded = false;
    this.tag = null;
  }
  initializeKeys() {
    if (this._key == null) {
      this._key = this.grid.optimization ? `${this.grid.key}_row_${HashCodeUtility.getHashCode(this.model)}` : `${this.grid.key}_row_${this.id}`;
      if (this._initialKey == null) {
        this._initialKey = this._key;
      }
    }
  }
  get model() {
    return this._model;
  }
  set model(value) {
    if (this._model !== value) {
      this._model = value;
      const rowIndex = this.index;
      const data = this.grid.data;
      if (data[rowIndex] !== value) {
        data[rowIndex] = value;
      }
    }
  }
  get initialKey() {
    this.initializeKeys();
    return this._initialKey;
  }
  get key() {
    this.initializeKeys();
    return this._key;
  }
  get isReadonly() {
    return this.readonly || this.grid.readonly;
  }
  get isFirst() {
    return this.index === 0;
  }
  get isLast() {
    return this.index === this.grid.rows.length - 1;
  }
  get modified() {
    return this.cells.some(item => item.modified);
  }
  get valid() {
    return this.cells.every(item => item.valid);
  }
  get hasDeleted() {
    return this.cells.some(item => item.deleted);
  }
  get spannedRows() {
    return this.cells.filter(cell => cell.spannedRow != null).map(cell => cell.spannedRow).distinct(row => row.index);
  }
  get position() {
    return (this.grid.pageNumber - 1) * this.grid.pageSize + this.index + 1;
  }
  get detailsColStart() {
    const detailsColStart = this.grid.detailsColStart || 0;
    return this.grid.checkable ? detailsColStart + 1 : detailsColStart;
  }
  get detailsColEnd() {
    if (this.grid.detailsColEnd != null) {
      const _detailsColEnd = this.grid.detailsColEnd < 0 ? this.grid.columns.length + this.grid.detailsColEnd : this.grid.detailsColEnd;
      return this.grid.checkable ? _detailsColEnd + 1 : _detailsColEnd;
    }
    for (let columnIndex = this.cells.length - 1; columnIndex >= 0; columnIndex--) {
      const cell = this.cells[columnIndex];
      if (!cell.spanned && cell.rowSpan < 1) {
        return this.grid.checkable ? columnIndex + 1 : columnIndex;
      }
    }
    const detailsColEnd = this.cells.length - 1;
    return this.grid.checkable ? detailsColEnd + 1 : detailsColEnd;
  }
  get nextRow() {
    return this.index < this.grid.rows.length - 1 ? this.grid.rows[this.index + 1] : this.grid.rows[0];
  }
  get prevRow() {
    return this.index > 0 ? this.grid.rows[this.index - 1] : this.grid.rows[this.grid.rows.length - 1];
  }
  resetKey(resetInitialKey = false) {
    this._key = null;
    if (resetInitialKey) {
      this._initialKey = null;
    }
  }
  get(columnName) {
    const cell = this.cells.find(item => item.column.name === columnName) || this.cells.find(item => item.accessor === columnName);
    if (cell == null) throw Error(`Column with name or accessor '${columnName}' cannot be found in the grid.`);
    return cell;
  }
  getIndex(columnName) {
    let index = this.cells.findIndex(item => item.column.name === columnName);
    if (index === -1) {
      index = this.cells.findIndex(item => item.accessor === columnName);
    }
    return index;
  }
  loop(inScope) {
    const rows = this.grid.rows;
    const rowIndex = this.index;
    let firstIndex = rowIndex;
    let lastIndex = rowIndex;
    const lastRowIndex = rows.length - 1;
    for (let index = rowIndex - 1; index >= 0; index--) {
      const subRow = rows[index];
      if (!inScope(subRow)) {
        break;
      }
      firstIndex = index;
    }
    for (let index = rowIndex + 1; index <= lastRowIndex; index++) {
      const subRow = rows[index];
      if (!inScope(subRow)) {
        break;
      }
      lastIndex = index;
    }
    const scope = new ArrayScope();
    scope.firstIndex = firstIndex;
    scope.lastIndex = lastIndex;
    return scope;
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this.expanded = !this.expanded;
      if (this.expanded && this.grid.autoToggle) {
        const expandedRow = this.grid.rows.find(row => row !== this && row.expanded) || null;
        if (expandedRow) {
          yield expandedRow.toggleAsync();
        }
      }
      yield this.reRenderAsync();
      //await this.instance.updateStateAsync();
      yield Utility.forEachAsync(this.spannedRows, row => __awaiter(this, void 0, void 0, function* () {
        return yield row.reRenderAsync();
      }));
    });
  }
  bind() {
    return this.cells.map(cell => cell.bind()).some(modified => modified);
  }
  bindAsync(forceRender = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const modified = this.bind();
      if (forceRender || modified) {
        yield this.reRenderAsync();
      }
    });
  }
  setModel(model) {
    let modified = false;
    const cells = this.cells;
    const columns = this.grid.columns;
    const length = columns.length;
    for (let i = 0; i < length; i++) {
      const column = columns[i];
      const cell = cells[column.index];
      if (cell.accessor) {
        const value = typeof cell.accessor === "string" ? Utility.findValueByAccessor(model, cell.accessor) : cell.accessor(model);
        cell.setValue(value);
        modified = modified || cell.modified;
      }
    }
    return modified;
  }
  setModelAsync(model, forceRender = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const modified = this.setModel(model);
      if (forceRender || modified) {
        yield this.reRenderAsync();
      }
      return modified;
    });
  }
  saveAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.modified) {
        this.cells.forEach(cell => cell.save());
        yield this.reRenderAsync();
      }
    });
  }
  cancelAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.modified) {
        yield Utility.forEachAsync(this.cells, cell => __awaiter(this, void 0, void 0, function* () {
          return yield cell.cancelAsync();
        }));
        yield this.reRenderAsync();
      }
    });
  }
  reRenderAsync(withSpannedRows = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (withSpannedRows) {
        yield Utility.forEachAsync(this.spannedRows, row => __awaiter(this, void 0, void 0, function* () {
          return row.reRenderAsync();
        }));
      }
      yield this.instance.reRenderAsync();
    });
  }
  setDeletedAsync(deleted) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.deleted !== deleted) {
        this.deleted = deleted;
        yield this.reRenderAsync();
      }
    });
  }
}
class CellModel {
  constructor() {
    this._value = null;
    this._initialValue = null;
    this._valueInitialized = false;
    this._rowSpan = 0;
    this._spannedRow = null;
    this._descriptionAction = null;
    this._description = null;
    this.id = 0;
    this.actions = [];
    this.row = new RowModel();
    this.column = new ColumnModel();
    this.grid = new GridModel();
    this.className = null;
    this.visible = true;
    this.readonly = false;
    this.valid = true;
    this.deleted = false;
    this.title = "";
    this.type = ColumnType.Custom;
    this.editable = false;
    this.accessor = null;
    this.route = null;
    this.infoRoute = null;
    this.instance = {};
    this.asyncContentInstance = null;
    this.inputContentInstance = null;
    this.tag = null;
  }
  get key() {
    return `${this.row.key}_cell_${this.columnIndex}`;
  }
  get initialKey() {
    return `${this.row.initialKey}_cell_${this.columnIndex}`;
  }
  get isFirstColumn() {
    return this.column.isFirst;
  }
  get isLastColumn() {
    return this.column.isLast;
  }
  get isFirstRow() {
    return this.row.isFirst;
  }
  get isLastRow() {
    return this.row.isLast;
  }
  get isSpanned() {
    return this.spanned || this.rowSpan > 1;
  }
  get isDeleted() {
    return this.removable && (this.deleted || this.row.deleted);
  }
  get isReadonly() {
    return this.readonly || this.row.isReadonly;
  }
  get isVisible() {
    return this.visible && this.column.isVisible;
  }
  get isSelectable() {
    return this.isVisible && !this.isDeleted && (this.isReadonly || this.type == ColumnType.Custom || this.type == ColumnType.Icon) && this.actions.length == 0;
  }
  get rowSpan() {
    return this._rowSpan;
  }
  set rowSpan(value) {
    value = value === 1 ? 0 : value;
    if (this._rowSpan !== value) {
      if (!this.spanned && value >= 0) {
        const spanned = value > 0;
        const rows = this.grid.rows;
        const rowsLength = rows.length;
        const firstIndex = this.rowIndex + 1;
        const lastIndex = firstIndex + (spanned ? value : this._rowSpan) - 2;
        for (let index = firstIndex; index <= lastIndex && index < rowsLength; index++) {
          const cell = rows[index].cells[this.columnIndex];
          cell._spannedRow = spanned ? this.row : null;
          if (spanned) {
            cell.rowSpan = 0;
          }
        }
      }
      this._rowSpan = value;
    }
  }
  get descriptionAction() {
    var _a;
    return (_a = this._descriptionAction) !== null && _a !== void 0 ? _a : this._descriptionAction = this.actions.firstOrDefault(action => action instanceof DescriptionCellAction);
  }
  get descriptionIcon() {
    return this.column.settings.descriptionIcon;
  }
  get description() {
    if (this._description === null) {
      const accessor = this.column.settings.descriptionAccessor;
      if (accessor) {
        this._description = typeof accessor === "string" ? Utility.findValueByAccessor(this.model, accessor) : accessor(this.model);
      }
    }
    return this._description || (this._description = "");
  }
  set description(value) {
    const accessor = this.column.settings.descriptionAccessor;
    if (accessor && typeof accessor === "string") {
      Utility.setValueByAccessor(this.model, accessor, value);
      this._description = null;
    }
  }
  get descriptionReadonly() {
    return this.descriptionAction && this.descriptionAction.readonly != null ? this.descriptionAction.readonly : this.isReadonly || this.isDeleted;
  }
  set descriptionReadonly(value) {
    if (this.descriptionAction) {
      this.descriptionAction.readonly = value;
    }
  }
  get spanned() {
    return this._spannedRow != null;
  }
  get spannedRow() {
    return this._spannedRow;
  }
  get spannedRows() {
    const spannedRows = [];
    if (!this.spanned) {
      const row = this.row;
      const columnIndex = this.columnIndex;
      let spannedRow = row;
      while (spannedRow != null && (spannedRow === row || spannedRow.cells[columnIndex].spannedRow === row)) {
        spannedRows.push(spannedRow);
        spannedRow = !spannedRow.isLast ? spannedRow.nextRow : null;
      }
    }
    return spannedRows;
  }
  get initialValue() {
    return this._initialValue;
  }
  get value() {
    return this._value;
  }
  set value(value) {
    if (this.accessor) {
      if (this._value !== value) {
        if (typeof this.accessor === "string") {
          Utility.setValueByAccessor(this.row.model, this.accessor, value);
          this._value = Utility.findValueByAccessor(this.row.model, this.accessor);
        } else {
          this._value = value;
        }
      }
      if (!this._valueInitialized) {
        this._initialValue = this._value;
        this._valueInitialized = true;
      }
    }
  }
  get modifiable() {
    return this._valueInitialized && this.type != ColumnType.Icon && (this.type != ColumnType.Custom || this.editable);
  }
  get modified() {
    if (this.modifiable) {
      const hideZero = this.column.settings.hideZero;
      const value = hideZero ? this._value || 0 : this._value;
      const initialValue = hideZero ? this._initialValue || 0 : this._initialValue;
      const isEqual = Comparator.isEqual(value, initialValue);
      if (!isEqual) {
        return true;
      }
    }
    return false;
  }
  get rowIndex() {
    return this.row.index;
  }
  get columnIndex() {
    return this.column.index;
  }
  get model() {
    return this.row.model;
  }
  get next() {
    return this.columnIndex < this.grid.columns.length - 1 ? this.row.cells[this.columnIndex + 1] : this.row.cells[0];
  }
  get prev() {
    return this.columnIndex > 0 ? this.row.cells[this.columnIndex - 1] : this.row.cells[this.grid.columns.length - 1];
  }
  get nextRow() {
    return this.row.nextRow;
  }
  get prevRow() {
    return this.row.prevRow;
  }
  get removable() {
    return this.column.removable;
  }
  clearRowSpan() {
    this._rowSpan = 0;
    this._spannedRow = null;
  }
  calcRowSpan() {
    let rowSpan = this._rowSpan;
    const columnIndex = this.grid.checkable ? this.columnIndex + 1 : this.columnIndex;
    if (rowSpan > 1) {
      const rows = this.grid.rows;
      const rowsLength = rows.length;
      const firstRowIndex = this.rowIndex;
      const lastRowIndex = firstRowIndex + rowSpan - 1;
      const detailsColStart = this.row.detailsColStart;
      const detailsColEnd = this.row.detailsColEnd;
      for (let index = firstRowIndex; index <= lastRowIndex && index < rowsLength; index++) {
        const row = rows[index];
        const rowExpanded = row.expanded && (columnIndex < detailsColStart || columnIndex > detailsColEnd);
        if (rowExpanded) {
          rowSpan++;
        }
      }
      return rowSpan;
    } else if (this.row.expanded) {
      const detailsColStart = this.row.detailsColStart;
      const detailsColEnd = this.row.detailsColEnd;
      const rowExpanded = columnIndex < detailsColStart || columnIndex > detailsColEnd;
      if (rowExpanded) {
        return 2;
      }
    }
    return null;
  }
  equalRowSpan(cell) {
    let equal = cell.rowIndex == this.rowIndex;
    equal = equal && cell.spanned === this.spanned && cell.rowSpan === this.rowSpan;
    return equal;
  }
  prevRows(callback) {
    const result = [];
    if (this.rowIndex > 0) {
      for (let index = this.rowIndex - 1; index >= 0; index--) {
        const row = this.grid.rows[index];
        const item = row.model;
        if (!callback(item)) {
          break;
        }
        result.push(row);
      }
    }
    return result;
  }
  nextRows(callback, start = 1) {
    const result = [];
    if (this.rowIndex <= this.grid.rows.length - 1) {
      const firstIndex = this.rowIndex + start;
      for (let index = firstIndex; index < this.grid.rows.length; index++) {
        const row = this.grid.rows[index];
        const item = row.model;
        if (!callback(item)) {
          break;
        }
        result.push(row);
      }
    }
    return result;
  }
  filterRows(callback, excludeSelf = true) {
    return this.grid.rows.filter(row => (!excludeSelf || row.index !== this.rowIndex) && callback(row.cells[this.columnIndex].model));
  }
  someRows(callback, excludeSelf = true, excludeDeleted = true) {
    const rowIndex = this.rowIndex;
    const columnIndex = this.columnIndex;
    return this.grid.rows.some(row => (!excludeDeleted || !row.deleted) && (!excludeSelf || row.index !== rowIndex) && callback(row.cells[columnIndex].model));
  }
  forEachRowsAsync(callback, excludeSelf = true, excludeDeleted = true) {
    return __awaiter(this, void 0, void 0, function* () {
      let items = this.grid.rows;
      items = excludeSelf ? items.filter(row => row.index !== this.rowIndex) : items;
      items = excludeDeleted ? items.filter(row => !row.deleted) : items;
      yield Utility.forEachAsync(items, row => callback(row.cells[this.columnIndex]));
    });
  }
  save() {
    if (this.modified) {
      this._initialValue = this.value;
      this.row.resetKey(true);
    }
  }
  saveAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.modified) {
        this._initialValue = this.value;
        this.row.resetKey(true);
        if (this.column.callback) {
          yield this.column.callback(this, null);
        }
        yield this.reRenderAsync();
      }
    });
  }
  cancel() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.modified) {
        this.value = this._initialValue;
        this.row.resetKey();
      }
    });
  }
  cancelAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.modified) {
        this.value = this._initialValue;
        this.row.resetKey();
        if (this.column.callback) {
          yield this.column.callback(this, null);
        }
        yield this.reRenderAsync();
      }
    });
  }
  setValue(value) {
    if (this.accessor) {
      if (this.value !== value) {
        const modified = this.modified;
        this.value = value;
        this.row.resetKey();
        return this.modified !== modified;
      }
    }
    return false;
  }
  setValueAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      const modified = this.setValue(value);
      if (modified) {
        yield this.row.reRenderAsync();
      } else {
        yield this.reRenderAsync();
      }
      return modified;
    });
  }
  bind() {
    if (this.accessor) {
      const value = typeof this.accessor === "string" ? Utility.findValueByAccessor(this.model, this.accessor) : this.accessor(this.model);
      this.setValue(value);
      if (this.modified) {
        this.save();
        return true;
      }
    }
    return false;
  }
  bindAsync(forceRender = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const modified = this.bind();
      if (forceRender || modified) {
        yield this.reRenderAsync();
      }
    });
  }
  setValidAsync(valid) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.valid !== valid) {
        const rowValid = this.row.valid;
        this.valid = valid;
        const rowValidModified = rowValid !== this.row.valid;
        if (rowValidModified) {
          yield this.row.reRenderAsync();
        } else {
          yield this.reRenderAsync();
        }
      }
    });
  }
  setDeletedAsync(deleted) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.removable && this.deleted !== deleted) {
        this.deleted = deleted;
        yield this.reRenderAsync();
      }
    });
  }
  setRowDeleted(deleted) {
    this.row.cells.forEach(cell => {
      if (cell != this && !cell.isSpanned) {
        cell.deleted = deleted;
      }
    });
  }
  setRowDeletedAsync(deleted) {
    return __awaiter(this, void 0, void 0, function* () {
      yield Utility.forEachAsync(this.row.cells, cell => __awaiter(this, void 0, void 0, function* () {
        if (cell != this && !cell.isSpanned) {
          yield cell.setDeletedAsync(deleted);
        }
      }));
      yield this.reRenderAsync();
    });
  }
  editAsync(select = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.editable && !this.isReadonly && this.inputContentInstance) {
        yield this.inputContentInstance.showEditAsync(select);
      }
    });
  }
  reRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isVisible) {
        yield this.instance.reRenderAsync();
      }
    });
  }
  reRender() {
    // reload without await
    // noinspection JSIgnoredPromiseFromCall
    this.reRenderAsync();
  }
  reloadAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.asyncContentInstance) {
        yield this.asyncContentInstance.reloadAsync();
      }
    });
  }
}
class GridTransformer {
  static toGrid(from, id) {
    const to = new GridModel();
    to.id = id;
    to.className = from.className || null;
    to.responsiveRowClassName = from.responsiveRowClassName || null;
    to.headerMinHeight = from.headerMinHeight || null;
    to.noDataNoHeader = from.noDataNoHeader || false;
    to.minWidth = from.minWidth || null;
    to.cellPadding = from.cellPadding || CellPaddingType.Large;
    to.noDataText = from.noDataText || null;
    to.detailsColStart = from.detailsColStart || null;
    to.detailsColEnd = from.detailsColEnd || null;
    to.hovering = from.hovering || GridHoveringType.Row;
    to.odd = from.odd || GridOddType.Row;
    to.responsive = from.responsive || false;
    to.pagination = from.pagination || false;
    to.checkable = from.checkable || false;
    to.selectableType = from.selectable == null || from.selectable === false ? null : from.selectable === true ? GridSelectableType.Single : from.selectable;
    to.readonly = from.readonly || false;
    to.borderType = from.borderType || BorderType.DarkSeparators;
    to.optimization = from.optimization !== false;
    to.autoToggle = from.autoToggle || false;
    to.onCheck = from.onCheck;
    to.onSelect = from.onSelect;
    to.renderDetails = from.renderDetails;
    to.columns = (from.columns || []).map((item, index) => this.toColumn(to, item, index));
    to.rows = [];
    to.pageNumber = 1;
    to.totalItemCount = 0;
    to.pageSize = from.pagination ? typeof from.pagination === "number" ? from.pagination : DEFAULT_PAGE_SIZE : MAX_PAGE_SIZE;
    to.sortColumn = to.columns.find(item =>
    // Sort column provided via grid's properties
    !!from.defaultSortColumn && (item.name === from.defaultSortColumn || item.accessor === from.defaultSortColumn) ||
    // Sort column provided via cell's properties
    item.sorting != null && item.sorting != false && item.isDefaultSorting) || to.columns.find(item => item.sorting != null && item.sorting != false) || null;
    to.sortDirection = to.sortColumn != null
    // Sort direction provided via grid's properties
    ? from.defaultSortDirection ? from.defaultSortDirection
    // Sort direction provided via cell's properties
    : to.sortColumn.sorting === SortDirection.Desc ? SortDirection.Desc : SortDirection.Asc : null;
    //add check for multiple isSortColumn
    return to;
  }
  static toColumn(grid, from, columnIndex) {
    const to = new ColumnModel();
    to.name = from.name || null;
    to.title = from.title || "";
    to.index = columnIndex;
    to.accessor = from.accessor || null;
    to.grid = grid;
    to.group = from.group || null;
    to.textAlign = from.textAlign || null;
    to.verticalAlign = from.verticalAlign || null;
    to.type = from.type || ColumnType.Custom;
    to.editable = from.editable || false;
    to.removable = from.removable != false;
    to.reRenderRow = from.reRenderRow || false;
    to.rotate = from.rotate || false;
    to.format = from.format || null;
    to.minWidth = from.minWidth || null;
    to.maxWidth = from.maxWidth || null;
    to.maxHeight = from.maxHeight || null;
    to.noWrap = from.noWrap || false;
    to.wordBreak = from.wordBreak || false;
    to.stretch = from.stretch || false;
    to.total = from.total || false;
    to.route = from.route || null;
    to.className = from.className || null;
    to.header = from.header || "";
    to.visible = from.visible !== false;
    to.responsivePriority = from.responsivePriority || 0;
    to.init = from.init;
    to.transform = from.transform;
    to.render = from.render;
    to.callback = from.callback;
    to.sorting = from.sorting || null;
    to.isDefaultSorting = from.isDefaultSorting || false;
    to.settings = this.toSettings(from.settings || new ColumnSettingsDefinition());
    to.actions = (from.actions || []).map(action => this.toAction(to, action));
    return to;
  }
  static toRows(grid, items) {
    return items.map((item, rowIndex) => this.toRow(grid, item, rowIndex));
  }
  static toRow(grid, model, rowIndex) {
    const to = new RowModel();
    to.id = ch.getId();
    to.grid = grid;
    to.index = rowIndex;
    to.model = model;
    to.checkable = grid.checkable;
    to.selectable = grid.selectable;
    to.cells = grid.columns.map(column => this.toCell(grid, to, column));
    return to;
  }
  static toCell(grid, row, column) {
    const to = new CellModel();
    to.id = ch.getId();
    to.grid = grid;
    to.row = row;
    to.column = column;
    to.type = column.type;
    to.editable = column.editable;
    to.accessor = column.accessor;
    to.title = column.title;
    to.actions = column.actions.map(columnAction => this.toCellAction(columnAction));
    if (column.settings.descriptionAccessor) {
      const descriptionAction = this.toDescriptionCellAction(column);
      to.actions.unshift(descriptionAction);
    }
    return to;
  }
  static toSettings(from) {
    const to = new ColumnSettings();
    to.min = from.min || null;
    to.max = from.max || null;
    to.step = from.step || null;
    to.maxLength = from.maxLength || null;
    to.hideZero = from.hideZero || false;
    to.infoHideZero = from.infoHideZero || false;
    to.infoHideEqual = from.infoHideEqual || false;
    to.infoAccessor = from.infoAccessor || null;
    to.infoTitle = from.infoTitle || null;
    to.infoBold = from.infoBold || false;
    to.infoBoldNotEqual = from.infoBoldNotEqual || false;
    to.infoFormat = from.infoFormat || null;
    to.infoRoute = from.infoRoute || null;
    to.descriptionAccessor = from.descriptionAccessor || null;
    to.descriptionJustify = from.descriptionJustify || Justify.Left;
    to.descriptionIcon = from.descriptionIcon || null;
    to.descriptionMaxLength = from.descriptionMaxLength || null;
    to.descriptionAlight = from.descriptionAlight || Align.Bottom;
    to.descriptionCallback = from.descriptionCallback;
    to.required = from.required || false;
    to.requiredType = from.requiredType || DropdownRequiredType.Manual;
    to.addButton = from.addButton || false;
    to.addCallback = from.addCallback;
    to.nothingSelectedText = from.nothingSelectedText || null;
    to.autoCollapse = from.autoCollapse || true;
    to.groupSelected = from.groupSelected || false;
    to.multiple = from.multiple || false;
    to.noFilter = from.noFilter || false;
    to.align = from.align || DropdownAlign.Right;
    to.verticalAlign = from.verticalAlign || DropdownVerticalAlign.Auto;
    to.arrows = from.arrows || false;
    to.locationPicker = from.locationPicker || false;
    to.fetchItems = from.fetchItems;
    to.selectedTextTransform = from.selectedTextTransform;
    to.infoTransform = from.infoTransform;
    return to;
  }
  static toAction(column, from) {
    const to = new ColumnAction();
    to.column = column;
    to.title = from.title || null;
    to.toggleModal = from.toggleModal || null;
    to.confirm = from.confirm || null;
    to.callback = from.callback;
    to.render = from.render;
    to.right = from.right || false;
    to.actions = from.actions;
    to.alwaysAvailable = from.alwaysAvailable || false;
    to.name = from.name || null;
    to.icon = this.toIcon(from.icon);
    if (from.type != null) {
      switch (from.type) {
        case ColumnActionType.Details:
          to.alwaysAvailable = from.alwaysAvailable !== false;
          to.name = from.name || "details";
          to.type = ActionType.Secondary;
          to.icon = this.toIcon(from.icon || "far info-square");
          break;
        case ColumnActionType.Download:
          to.alwaysAvailable = from.alwaysAvailable !== false;
          to.name = from.name || "download";
          to.type = ActionType.Create;
          to.icon = this.toIcon(from.icon || "far download");
          break;
        case ColumnActionType.Preview:
          to.alwaysAvailable = from.alwaysAvailable !== false;
          to.name = from.name || "preview";
          to.type = ActionType.Blue;
          to.icon = this.toIcon(from.icon || "far search");
          break;
        default:
          to.type = from.type || null;
      }
    }
    return to;
  }
  static toCellAction(columnAction) {
    const to = new CellAction();
    to.action = columnAction;
    return to;
  }
  static toDescriptionCellAction(column) {
    const to = new DescriptionCellAction();
    to.action.name = "description";
    to.action.type = ActionType.Grey;
    to.action.title = column.settings.descriptionTitle;
    to.action.callback = column.settings.descriptionCallback;
    to.justify = column.settings.descriptionJustify;
    to.maxLength = column.settings.descriptionMaxLength;
    to.alight = column.settings.descriptionAlight;
    return to;
  }
  static toIcon(icon, checkIconName = false) {
    if (icon != null) {
      if (typeof icon === "string") {
        if (!checkIconName || Icon.isIconName(icon)) {
          return {
            name: icon
          };
        }
        return null;
      }
      return icon;
    }
    return null;
  }
}

var css_248z$Y = "@charset \"UTF-8\";\n/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-grid-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-grid-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-grid-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-grid-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-grid-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-grid-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-grid-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-grid-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-grid-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-grid-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-grid-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-grid-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-grid-list, .athenaeum-grid-dropdown {\n  text-align: left;\n  border-radius: 5px;\n  font-size: 14px;\n  cursor: pointer;\n  height: 100%;\n}\n.athenaeum-grid-list.athenaeum-grid-disabled, .athenaeum-grid-disabled.athenaeum-grid-dropdown {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.athenaeum-grid-list .athenaeum-grid-selected, .athenaeum-grid-dropdown .athenaeum-grid-selected {\n  text-align: center;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer {\n  display: flex;\n  visibility: hidden;\n  height: inherit;\n  position: absolute;\n  flex-direction: column;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-filter, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-filter {\n  padding: 4px 2px 0;\n  position: relative;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-filter > input, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-filter > input {\n  width: 100%;\n  padding-right: 18px !important;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-filter input::placeholder, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-filter input::placeholder {\n  font-style: italic;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-filter .athenaeum-grid-clean, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-filter .athenaeum-grid-clean {\n  position: absolute;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  top: 0;\n  right: 12px;\n  opacity: 0.3;\n  margin-top: 2px;\n  color: black;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-filter .athenaeum-grid-clean:hover, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-filter .athenaeum-grid-clean:hover {\n  opacity: 1;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-addButton, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-addButton {\n  padding: 0 2px;\n  display: flex;\n  align-items: center;\n  justify-content: left;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-addButton > span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-addButton > span {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-scrollableContainer, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-scrollableContainer {\n  overflow-y: auto;\n  height: inherit;\n  position: relative;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-itemsList, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-itemsList {\n  height: auto;\n  position: absolute;\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: unset;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-itemsList, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-itemsList {\n    position: unset !important;\n  }\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noWrap, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noWrap {\n  white-space: nowrap;\n  overflow-x: hidden;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-lineThrough, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-lineThrough {\n  text-decoration: line-through;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults {\n  display: flex;\n  align-items: center;\n  padding: 2px 10px;\n  margin: 2px 0;\n  border-radius: 5px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-noResults, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-noResults {\n  color: rgb(254, 80, 0);\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem:hover, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem:hover, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-noResults:hover, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-noResults:hover {\n  background-color: rgb(227, 227, 227);\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem.athenaeum-grid-selectedItem, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem.athenaeum-grid-selectedItem, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-selectedItem.athenaeum-grid-noResults, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-selectedItem.athenaeum-grid-noResults {\n  color: white;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem.athenaeum-grid-selectedItem:hover, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem.athenaeum-grid-selectedItem:hover, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-selectedItem.athenaeum-grid-noResults:hover, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-selectedItem.athenaeum-grid-noResults:hover {\n  color: #337ab7;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-listItem span, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-noResults span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-listItem.athenaeum-grid-noResults span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults {\n  border-radius: 0;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div {\n  padding-top: 2px;\n  padding-bottom: 3px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div > span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div > span, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div > span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div > span {\n  display: inline;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div > small, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div > small, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div > small, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div > small {\n  margin-left: 0.5em;\n  font-size: 75%;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-iconContainer, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-iconContainer, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-iconContainer, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-iconContainer {\n  padding: 5px;\n  margin-right: 10px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item span, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults span {\n  display: block;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item small, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item small, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults small, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults small {\n  text-transform: capitalize;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-minus, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-minus, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-minus, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-minus {\n  font-size: 1.5em;\n  margin-right: 5px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountTitle, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountTitle, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountTitle, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountTitle {\n  width: 100%;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountTitle span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountTitle span, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountTitle span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountTitle span {\n  display: inline;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountTitle .athenaeum-grid-amountUnit, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountTitle .athenaeum-grid-amountUnit, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountTitle .athenaeum-grid-amountUnit, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountTitle .athenaeum-grid-amountUnit {\n  padding-left: 5px;\n  color: lightgray;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountDisabled, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amountDisabled, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountDisabled, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amountDisabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amount, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-amount, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amount, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-amount {\n  font-size: 1.5em;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-plus, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-plus, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-plus, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-plus {\n  font-size: 1.5em;\n  margin-left: 5px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-notCompleted, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-notCompleted, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-notCompleted, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-notCompleted {\n  margin-right: 0;\n  margin-left: auto;\n  padding-left: 8px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-icon, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-icon, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-icon, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-icon {\n  margin-right: 0;\n  margin-left: auto;\n  padding-left: 8px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-icon > img, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-icon > img, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-icon > img, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-icon > img {\n  height: 20px;\n  min-height: 16px;\n  min-width: 16px;\n  max-width: 24px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-action, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-action, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-action, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-action {\n  display: flex;\n  margin-right: 0;\n  margin-left: auto;\n  padding-left: 8px;\n  justify-content: end !important;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-action > button, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-action > button, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-action > button, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-action > button {\n  padding: 0.375rem 0.375rem !important;\n  min-height: 10px !important;\n  max-height: 20px !important;\n  min-width: 10px !important;\n  max-width: 20px !important;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-group, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-group, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-group:hover, .athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-group:active {\n  cursor: default;\n  color: #e3e3e3 !important;\n  background-color: inherit !important;\n  font-size: 12px;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-groupSeparator, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-groupSeparator {\n  margin: 6px 2px;\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-selectedItem, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-selectedItem {\n  background-color: #337ab7;\n  color: white;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-itemGroupIdent, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-itemGroupIdent {\n  padding-left: 20px !important;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer.athenaeum-grid-opened, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer.athenaeum-grid-opened {\n  visibility: visible;\n  position: initial;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults {\n  padding: 0;\n  cursor: default;\n}\n.athenaeum-grid-list .athenaeum-grid-itemsContainer .athenaeum-grid-noResults:hover, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults:hover {\n  background-color: transparent;\n}\n\n.athenaeum-grid-dropdown {\n  cursor: pointer;\n  position: relative;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-hovered, .athenaeum-grid-dropdown .athenaeum-grid-selected:hover {\n  background-color: rgb(227, 227, 227);\n  border-color: #adadad;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-focused {\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  white-space: nowrap;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected.athenaeum-grid-clearButtonVisible {\n  visibility: visible;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected .athenaeum-grid-toggleButtonContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected .athenaeum-grid-toggleButtonContainer > div {\n  margin-left: 6px;\n  align-items: center;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected .athenaeum-grid-toggleButtonContainer > div.athenaeum-grid-clearButton {\n  display: flex;\n  padding: 4px;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected .athenaeum-grid-toggleButtonContainer > div.athenaeum-grid-clearButton:not(:hover) {\n  opacity: 0.3;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-selected .athenaeum-grid-toggleButtonContainer > div.athenaeum-grid-toggleButton {\n  display: flex;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer {\n  height: auto;\n  position: absolute;\n  background-color: rgb(254, 80, 0);\n  width: auto;\n  min-width: 100%;\n  left: auto;\n  right: 0;\n  bottom: 0;\n  border-radius: 5px;\n  color: white;\n  margin: 2px 0;\n  padding: 3px 0;\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  z-index: 150;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer.athenaeum-grid-alignLeft {\n  left: 0;\n  right: auto;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer.athenaeum-grid-alignTop {\n  bottom: 35px;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer.athenaeum-grid-alignBottom {\n  bottom: auto;\n  top: auto;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer.athenaeum-grid-opened {\n  visibility: visible;\n  position: absolute;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-itemsList {\n  position: unset !important;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults {\n  color: white;\n  padding: 0 12px;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-iconContainer, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-iconContainer {\n  padding: 2px;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item .athenaeum-grid-checkbox, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults .athenaeum-grid-checkbox {\n  margin-left: auto;\n  padding-left: 10px;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item:hover, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults {\n  border-radius: 0;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div {\n  padding-top: 2px;\n  padding-bottom: 3px;\n  width: auto;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div > span, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div > span {\n  display: inline;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-item.athenaeum-grid-inlineSubtext > div > small, .athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-inlineSubtext.athenaeum-grid-noResults > div > small {\n  margin-left: 0.5em;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 75%;\n  -webkit-font-smoothing: initial;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-filter {\n  padding: 4px 8px;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-filter .athenaeum-grid-clean {\n  color: black !important;\n  right: 16px;\n  margin-top: 0;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-addButton {\n  padding: 0 8px;\n  display: flex;\n  align-items: center;\n  justify-content: left;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-addButton > span {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults {\n  cursor: default;\n}\n.athenaeum-grid-dropdown .athenaeum-grid-itemsContainer .athenaeum-grid-noResults:hover {\n  background-color: transparent;\n}\n\n.athenaeum-grid-dropdownWidget {\n  width: calc(100% + 24px);\n  left: -12px;\n  bottom: -36px;\n}\n\n.athenaeum-grid-transparent {\n  background-color: transparent;\n  border: none;\n}\n.athenaeum-grid-transparent:hover i.athenaeum-grid-transparent {\n  visibility: visible;\n}\n.athenaeum-grid-transparent.athenaeum-grid-selected:hover {\n  background-color: rgba(227, 227, 226, 0.5);\n}\n.athenaeum-grid-transparent:not(.athenaeum-grid-selected) {\n  margin: -6px 0px -6px -12px;\n}\n\ni.athenaeum-grid-transparent {\n  visibility: hidden;\n}\n\n.athenaeum-grid-small {\n  min-width: 52px;\n}\n.athenaeum-grid-small > div:first-child {\n  padding: 0.375rem;\n  height: auto;\n}\n.athenaeum-grid-small > div:first-child span {\n  font-size: 0.8rem;\n}\n\n.athenaeum-grid-grid {\n  font-size: 0.7rem !important;\n  background-color: rgba(255, 255, 255, 0.95);\n  width: auto !important;\n  min-width: 100%;\n  margin-bottom: 0;\n  position: relative;\n}\n.athenaeum-grid-grid[data-v2-styles=true] {\n  border: none;\n}\n.athenaeum-grid-grid[data-v2-styles=true] th, .athenaeum-grid-grid[data-v2-styles=true] td {\n  border: none;\n}\n.athenaeum-grid-grid[data-v2-styles=true] thead {\n  border-bottom: 2px solid black;\n}\n.athenaeum-grid-grid[data-hovering-mode=Row] tr:hover {\n  color: #212529;\n  background-color: rgba(0, 0, 0, 0.075);\n}\n.athenaeum-grid-grid:not([data-hovering-mode=Row]) tr:hover {\n  background-color: transparent;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th {\n  cursor: default;\n  min-width: 66px;\n  white-space: nowrap;\n  padding: 0.5rem 0.75rem;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th[data-is-rotated=true] > div:first-child {\n  transform: translate(0px, 0px) rotate(315deg);\n  width: 30px;\n  margin: 0 auto;\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th[data-is-rotated=true] > div:first-child .athenaeum-grid-sortIcons {\n  visibility: hidden;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th[data-sticky=true] {\n  position: sticky;\n  background: white;\n  z-index: 999;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th[data-sortable=true] {\n  cursor: pointer;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th[data-sortable=true][data-v2-styles=false]:hover {\n  border-bottom-width: 2px;\n  border-bottom-color: black;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th[data-sortable=true][data-v2-styles=false][data-sort-direction=\"0\"] > div > span, .athenaeum-grid-grid thead th.athenaeum-grid-th[data-sortable=true][data-v2-styles=false][data-sort-direction=\"1\"] > div > span {\n  text-decoration: underline;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th[data-sortable=true][data-v2-styles=true] .athenaeum-grid-headerContent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th[data-sortable=true][data-v2-styles=true] .athenaeum-grid-headerContent .athenaeum-grid-sortIcons {\n  transition: color 0.3s ease-out;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th[data-sortable=true][data-v2-styles=true][data-sort-direction=null] .athenaeum-grid-headerContent > .athenaeum-grid-sortIcons {\n  color: rgba(0, 0, 0, 0);\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th[data-sortable=true][data-v2-styles=true][data-sort-direction=null]:hover > .athenaeum-grid-headerContent > .athenaeum-grid-sortIcons {\n  color: rgb(0, 0, 0);\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th[data-sortable=true][data-v2-styles=true][data-sort-direction=\"0\"] > .athenaeum-grid-headerContent > .athenaeum-grid-sortIcons > :first-child {\n  color: rgb(0, 0, 0);\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th[data-sortable=true][data-v2-styles=true][data-sort-direction=\"0\"] > .athenaeum-grid-headerContent > .athenaeum-grid-sortIcons > :last-child {\n  color: rgba(0, 0, 0, 0.3);\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th[data-sortable=true][data-v2-styles=true][data-sort-direction=\"1\"] > .athenaeum-grid-headerContent > .athenaeum-grid-sortIcons > :first-child {\n  color: rgba(0, 0, 0, 0.3);\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th[data-sortable=true][data-v2-styles=true][data-sort-direction=\"1\"] > .athenaeum-grid-headerContent > .athenaeum-grid-sortIcons > :last-child {\n  color: rgb(0, 0, 0);\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th.athenaeum-grid-check {\n  min-width: 40px;\n  max-width: 40px;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th.athenaeum-grid-check input {\n  cursor: pointer;\n}\n.athenaeum-grid-grid thead th.athenaeum-grid-th.athenaeum-grid-check.athenaeum-grid-partially input {\n  opacity: 0.6;\n}\n.athenaeum-grid-grid thead tr:hover {\n  background-color: transparent !important;\n}\n.athenaeum-grid-grid tbody > tr {\n  height: 0;\n}\n.athenaeum-grid-grid tbody.athenaeum-grid-spinner {\n  width: 0;\n  height: 0;\n  padding: 0;\n  margin: 0;\n  border: 1px transparent;\n}\n.athenaeum-grid-grid tbody.athenaeum-grid-spinner tr {\n  width: 0;\n  height: 0;\n  padding: 0;\n  margin: 0;\n  border: none;\n}\n.athenaeum-grid-grid tbody.athenaeum-grid-spinner tr td {\n  width: 0;\n  height: 0;\n  padding: 0;\n  margin: 0;\n  border: none;\n  font-size: 0;\n  line-height: 0;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-gridRow[data-border-type=DarkSeparators] td {\n  border-bottom-color: #7f8484;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-gridRow[data-border-type=DarkSeparators]:nth-last-child(2) td {\n  border-bottom-color: inherit;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-gridRow[data-is-odd=false][data-hovering-mode=Row]:not(:hover), .athenaeum-grid-grid tbody .athenaeum-grid-gridRow[data-is-odd=false]:not([data-hovering-mode=Row]) {\n  background-color: rgba(0, 0, 0, 0.03);\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-gridRow.athenaeum-grid-selected {\n  background-color: #337ab7 !important;\n  color: white;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-gridRow.athenaeum-grid-selected:hover {\n  background-color: rgba(51, 122, 183, 0.9) !important;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-gridRow.athenaeum-grid-details {\n  display: none;\n  background-color: rgba(0, 0, 0, 0.02) !important;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-gridRow.athenaeum-grid-details > td {\n  vertical-align: top;\n  position: relative;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-gridRow.athenaeum-grid-details:hover {\n  background-color: rgba(0, 0, 0, 0.02) !important;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-gridRow.athenaeum-grid-details.athenaeum-grid-visible {\n  display: table-row;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-gridRow .athenaeum-grid-responsive {\n  min-width: 40px;\n  max-width: 40px;\n  cursor: pointer;\n  text-align: center;\n  vertical-align: middle;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-gridRow .athenaeum-grid-responsive .athenaeum-grid-responsiveIcon {\n  color: #337ab7;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-gridRow .athenaeum-grid-responsive .athenaeum-grid-responsiveIcon.athenaeum-grid-expanded {\n  color: #a94442;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-gridRow.athenaeum-grid-heightLarge {\n  height: 52px;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-gridRow.athenaeum-grid-heightMedium {\n  height: 42px;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-gridRow.athenaeum-grid-heightSmall {\n  height: 32px;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-collapsedRow:hover {\n  background-color: inherit !important;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-collapsedRow > td {\n  border: none !important;\n  padding: 0 !important;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-collapsedRow > td table {\n  width: 100%;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-collapsedRow > td table tr td:first-child {\n  width: auto;\n  text-align: left;\n  border-left: none;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-collapsedRow > td table tr td:first-child > span {\n  display: inline-block;\n  width: 100%;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-collapsedRow > td table tr td:last-child {\n  width: 100%;\n  border-right: none;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-totalRow {\n  background-color: rgba(222, 226, 230, 0.7725490196) !important;\n}\n.athenaeum-grid-grid tbody .athenaeum-grid-totalRow td {\n  text-align: center;\n  color: #337ab7;\n  cursor: default;\n}\n.athenaeum-grid-grid td {\n  vertical-align: middle !important;\n}\n.athenaeum-grid-grid td:first-of-type {\n  min-width: 40px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-rowSpan {\n  background-color: inherit;\n}\n.athenaeum-grid-grid td.athenaeum-grid-square {\n  min-width: 135px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-dropdown {\n  min-width: 190px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-cellHovering:hover {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n.athenaeum-grid-grid td.athenaeum-grid-deleted {\n  position: relative;\n}\n.athenaeum-grid-grid td.athenaeum-grid-deleted:before {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  border-bottom: 1px solid rgba(234, 60, 0, 0.9);\n  height: 0;\n  content: \"·\";\n  font-size: 1px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-deleted.athenaeum-grid-firstColumn:before {\n  left: 0.5rem;\n}\n.athenaeum-grid-grid td.athenaeum-grid-deleted.athenaeum-grid-lastColumn:before {\n  right: 0.5rem;\n}\n.athenaeum-grid-grid td.athenaeum-grid-deleted .athenaeum-grid-defaultCell span {\n  opacity: 0.25;\n}\n.athenaeum-grid-grid td.athenaeum-grid-check {\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n}\n.athenaeum-grid-grid td.athenaeum-grid-check input {\n  cursor: pointer;\n}\n.athenaeum-grid-grid td.athenaeum-grid-check.athenaeum-grid-disabled {\n  cursor: not-allowed;\n}\n.athenaeum-grid-grid td.athenaeum-grid-check.athenaeum-grid-disabled input {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n.athenaeum-grid-grid td.athenaeum-grid-noWrap {\n  white-space: nowrap;\n}\n.athenaeum-grid-grid td.athenaeum-grid-noWrap .athenaeum-grid-textCell span {\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n  display: block;\n}\n.athenaeum-grid-grid td.athenaeum-grid-wordBreak {\n  word-break: break-word;\n}\n.athenaeum-grid-grid td.athenaeum-grid-wordBreak .athenaeum-grid-textCell span {\n  word-break: break-word;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge {\n  padding: 8px 12px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div div.alignTop {\n  bottom: 24px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-defaultCell {\n  min-height: 24px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-defaultCell .athenaeum-grid-twoLines {\n  position: relative;\n  height: 23px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span {\n  position: absolute;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span:first-child {\n  top: -3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span:nth-child(2) {\n  top: 11px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-numberCell .athenaeum-grid-numberContainer.athenaeum-grid-numberInfo > div > div span {\n  height: 12px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingLarge .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div span {\n  padding: 0;\n  margin: 0;\n  height: 100%;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium {\n  padding: 3px 6px;\n  /* Default cell */\n  /* Text cell */\n  /* Date cell */\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-enumCell .athenaeum-grid-dropdown {\n  min-width: 100%;\n  width: 100%;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div {\n  padding: 0 3px !important;\n  margin: 0 -6px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div > div:first-child {\n  padding: 3px 2px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div div.alignTop {\n  bottom: 24px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-numberCell .athenaeum-grid-numberContainer.athenaeum-grid-numberInfo > div > div span {\n  height: 12px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div span {\n  padding: 0;\n  margin: 0;\n  height: 100%;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div > div {\n  padding: 0 6px !important;\n  margin: 0 -9px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div > div input {\n  padding: 3px 2px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-defaultCell {\n  min-height: 24px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-defaultCell .athenaeum-grid-twoLines {\n  position: relative;\n  height: 24px;\n  top: 1px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span {\n  position: absolute;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span:first-child {\n  top: -3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span:nth-child(2) {\n  top: 11px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-defaultCell .athenaeum-grid-actions {\n  margin-right: 0;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div {\n  padding: 0;\n  margin-left: 3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div span {\n  padding: 0;\n  line-height: 22px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div input {\n  padding: 3px 2px;\n  width: 100%;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput.athenaeum-grid-noWrap > div > div span {\n  max-height: 1px;\n  white-space: initial;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div {\n  padding: 0;\n  margin-left: 3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div span {\n  padding-left: 3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div input {\n  padding: 3px 2px;\n  width: 100%;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell .athenaeum-grid-actions {\n  margin-right: 0;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-textCell.athenaeum-grid-noActions input {\n  width: calc(100% + 6px) !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingMedium .athenaeum-grid-dateCell .athenaeum-grid-actions {\n  margin-right: -1px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall {\n  padding: 1px 3px;\n  /* Enum cell (DropDown) */\n  /* Number cell */\n  /* Default cell */\n  /* Text cell */\n  /* Date cell */\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-enumCell .athenaeum-grid-dropdown {\n  min-width: 100%;\n  width: 100%;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div {\n  padding: 3px !important;\n  margin: 0 -3px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div > div:first-child {\n  padding: 0 2px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div div.alignTop {\n  bottom: 25px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer {\n  padding-left: 3px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer > span {\n  left: 3px;\n  top: 11px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer.athenaeum-grid-numberInfo > div > div span {\n  height: 12px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div {\n  padding: 0;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div span {\n  padding: 0;\n  margin: 0;\n  height: 100%;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div > div {\n  padding: 3px !important;\n  margin: 0 -3px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div > div input {\n  padding: 0 3px !important;\n  height: 22px;\n  margin-top: -2px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput.athenaeum-grid-withArrows > div > div > div > div {\n  padding-right: 3px;\n  height: 22px;\n  top: 1px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-defaultCell {\n  min-height: 24px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-defaultCell span {\n  padding: 0 3px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-defaultCell .athenaeum-grid-twoLines {\n  position: relative;\n  height: 24px;\n  top: 1px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span {\n  position: absolute;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span:first-child {\n  top: -3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span:nth-child(2) {\n  top: 10px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-defaultCell .athenaeum-grid-actions {\n  margin-right: 1px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div {\n  padding: 0 3px;\n  margin-left: 3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div span {\n  padding: 0;\n  line-height: 22px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div input {\n  height: 22px;\n  padding: 0 2px;\n  width: calc(100% + 3px);\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div {\n  padding: 0 3px;\n  margin-left: 3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div span {\n  padding-left: 3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div input {\n  height: 22px;\n  padding: 0 2px;\n  width: calc(100% + 3px);\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput.athenaeum-grid-noWrap > div > div span {\n  max-height: 1px;\n  white-space: initial;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell .athenaeum-grid-actions {\n  margin-right: 1px;\n  padding: 0 0 0 4px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-textCell.athenaeum-grid-noActions input {\n  width: calc(100% + 6px) !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-dateCell .athenaeum-grid-twoLines span {\n  padding: 0 3px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-dateCell input {\n  padding: 0 3px !important;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-dateCell .athenaeum-grid-actions {\n  margin-right: 5px;\n}\n.athenaeum-grid-grid td.athenaeum-grid-paddingSmall .athenaeum-grid-cell .athenaeum-grid-actions > i {\n  padding: 2px 4px;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell.athenaeum-grid-fixedLineHeight {\n  line-height: 12px;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell.athenaeum-grid-noActions {\n  min-width: 100%;\n  width: auto;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell > span {\n  width: inherit;\n  cursor: default;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-center {\n  margin-left: auto;\n  margin-right: auto;\n  justify-content: center;\n  text-align: center;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions {\n  padding: 0 0 0 8px;\n  white-space: nowrap;\n  display: block;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions:first-child {\n  padding-left: 0;\n  width: 100%;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions > i {\n  cursor: pointer;\n  padding: 4px;\n  font-size: 1rem;\n  margin: 0 1px;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions > i:first-child {\n  margin-left: 0;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions > i:last-child {\n  margin-right: 0;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions > i:hover {\n  box-shadow: 0px 0px 0px 1px #adadad;\n  border-radius: 3px;\n  background-color: rgb(254, 80, 0);\n  color: white !important;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell .athenaeum-grid-actions .athenaeum-grid-actionRight {\n  float: right;\n}\n.athenaeum-grid-grid td .athenaeum-grid-cell input:not(.filter) {\n  padding: 0;\n  line-height: 1;\n  height: auto;\n  min-width: 46px;\n  color: #212529;\n}\n.athenaeum-grid-grid .athenaeum-grid-enumCell .athenaeum-grid-dropdown {\n  min-width: 100%;\n  width: 100%;\n  margin: 0 !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div {\n  padding: 0 0.375rem;\n  margin: 0 -0.75rem;\n}\n.athenaeum-grid-grid .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div > div:first-child {\n  width: 100%;\n  height: auto;\n  padding: 3px 5px;\n}\n.athenaeum-grid-grid .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div > div:first-child span {\n  font-size: 0.8em !important;\n  text-align: left;\n  min-height: 16px;\n}\n.athenaeum-grid-grid .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div > div:first-child:not(:hover) {\n  background-color: transparent;\n  border-color: transparent;\n}\n.athenaeum-grid-grid .athenaeum-grid-enumCell .athenaeum-grid-dropdown > div > div > div > div:first-child:not(:hover) i {\n  display: none;\n}\n.athenaeum-grid-grid .athenaeum-grid-enumCell.athenaeum-grid-notValid .athenaeum-grid-dropdown > div > div > div > div:first-child span {\n  color: #a94442;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell {\n  position: relative;\n  margin-bottom: 0 !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer {\n  width: 100%;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer.athenaeum-grid-numberInfo > span {\n  position: absolute;\n  left: 0;\n  top: 0.75rem;\n  color: #adadad;\n  cursor: default;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer.athenaeum-grid-numberInfo > span.athenaeum-grid-hideZero {\n  display: none;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer.athenaeum-grid-numberInfo .athenaeum-grid-numberInput span {\n  margin-top: -0.5rem;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer.athenaeum-grid-numberInfo .athenaeum-grid-numberInput.athenaeum-grid-bold span {\n  font-weight: bold;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput {\n  width: 100%;\n  margin: 0 !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput span {\n  padding-bottom: 0.5rem;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput.athenaeum-grid-hideZero span {\n  color: transparent;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div {\n  height: 24px;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div > div {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  padding: 0 0.375rem;\n  margin: 0 -0.75rem;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput > div > div > div > div {\n  padding-right: 6px;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput input {\n  width: 100%;\n  font-size: 0.8rem !important;\n  height: 24px;\n  padding: 3px 5px;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput input:focus {\n  outline: none;\n  box-shadow: none;\n  border-color: #ced4da;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell .athenaeum-grid-numberContainer .athenaeum-grid-numberInput.athenaeum-grid-withArrows input {\n  padding-right: 20px;\n}\n.athenaeum-grid-grid .athenaeum-grid-numberCell.athenaeum-grid-notValid span {\n  color: #a94442;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell > div {\n  margin: 0;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell .athenaeum-grid-twoLines {\n  height: 24px;\n  position: relative;\n  top: -2px;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell .athenaeum-grid-twoLines span {\n  color: #adadad;\n  position: relative;\n  top: -2px;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell .athenaeum-grid-shortDate input {\n  width: 42px;\n  min-width: 42px !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell input {\n  border: 0;\n  background-color: transparent !important;\n  width: 54px;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell input:focus, .athenaeum-grid-grid .athenaeum-grid-dateCell input:active {\n  box-shadow: none;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell.athenaeum-grid-notValid div input {\n  color: #a94442;\n}\n.athenaeum-grid-grid .athenaeum-grid-dateCell .athenaeum-grid-actions {\n  margin-right: 0;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell {\n  position: relative;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer {\n  width: 100%;\n  overflow-x: hidden;\n  margin-left: -6px;\n  margin-right: 0;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput {\n  width: 100%;\n  margin: 0;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div input {\n  padding: 3px 5px;\n  width: 100%;\n  font-size: 0.8rem !important;\n  box-sizing: border-box;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div input:focus {\n  outline: none;\n  box-shadow: none;\n  border-color: #ced4da;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-addressInput > div > div span {\n  padding: 0;\n  height: auto;\n  min-height: 16px;\n  line-height: 22px;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput {\n  width: 100%;\n  margin: 0 !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div input {\n  padding: 3px 5px;\n  width: 100%;\n  font-size: 0.8rem !important;\n  box-sizing: border-box;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div input:focus {\n  outline: none;\n  box-shadow: none;\n  border-color: #ced4da;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-textContainer .athenaeum-grid-textInput > div > div span {\n  height: auto;\n  min-height: 16px;\n  padding-left: 6px;\n  padding-right: 0;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell.athenaeum-grid-noActions .athenaeum-grid-textContainer {\n  width: calc(100% + 12px);\n  margin-left: -6px;\n  margin-right: -6px;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell.athenaeum-grid-noActions input {\n  width: 100% !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell.athenaeum-grid-noActions span {\n  padding-left: 6px !important;\n  padding-right: 6px !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-textCell .athenaeum-grid-actions {\n  margin-right: -6px;\n}\n.athenaeum-grid-grid .athenaeum-grid-booleanCell {\n  position: relative;\n}\n.athenaeum-grid-grid .athenaeum-grid-booleanCell label {\n  width: 100% !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  text-align: center;\n  cursor: pointer;\n}\n.athenaeum-grid-grid .athenaeum-grid-booleanCell label input {\n  cursor: pointer;\n  width: auto !important;\n  min-width: auto !important;\n  padding: 0 !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell span {\n  width: 100% !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell .athenaeum-grid-twoLines {\n  width: 100%;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span {\n  display: block;\n  width: 100% !important;\n  cursor: default;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span:last-child {\n  color: #adadad;\n  font-weight: normal;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell .athenaeum-grid-twoLines span.athenaeum-grid-bold {\n  font-weight: bold;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell .athenaeum-grid-link {\n  cursor: pointer !important;\n  width: auto !important;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell .athenaeum-grid-link:hover {\n  text-decoration: underline;\n}\n.athenaeum-grid-grid .athenaeum-grid-defaultCell .athenaeum-grid-actions {\n  margin-right: -6px;\n}\n.athenaeum-grid-grid .athenaeum-grid-emptyRow {\n  height: 34px;\n}\n.athenaeum-grid-grid .athenaeum-grid-emptyRow td {\n  font-weight: 600;\n  text-align: center;\n  cursor: default;\n  color: #adadad;\n}\n.athenaeum-grid-grid .athenaeum-grid-emptyRow:hover {\n  background-color: white !important;\n}\n\n.athenaeum-grid-pagination {\n  margin-top: 8px;\n  margin-bottom: 1rem;\n  filter: none !important;\n}";
var styles$Q = {"font-renta":"athenaeum-grid-font-renta","color-schema-renta_black":"athenaeum-grid-color-schema-renta_black","color-schema-renta_white":"athenaeum-grid-color-schema-renta_white","color-schema-renta_orange":"athenaeum-grid-color-schema-renta_orange","color-schema-renta_green":"athenaeum-grid-color-schema-renta_green","color-schema-renta_blue":"athenaeum-grid-color-schema-renta_blue","list":"athenaeum-grid-list","dropdown":"athenaeum-grid-dropdown","disabled":"athenaeum-grid-disabled","selected":"athenaeum-grid-selected","itemsContainer":"athenaeum-grid-itemsContainer","filter":"athenaeum-grid-filter","clean":"athenaeum-grid-clean","addButton":"athenaeum-grid-addButton","scrollableContainer":"athenaeum-grid-scrollableContainer","itemsList":"athenaeum-grid-itemsList","noWrap":"athenaeum-grid-noWrap","lineThrough":"athenaeum-grid-lineThrough","item":"athenaeum-grid-item","noResults":"athenaeum-grid-noResults","listItem":"athenaeum-grid-listItem","selectedItem":"athenaeum-grid-selectedItem","inlineSubtext":"athenaeum-grid-inlineSubtext","iconContainer":"athenaeum-grid-iconContainer","minus":"athenaeum-grid-minus","amountTitle":"athenaeum-grid-amountTitle","amountUnit":"athenaeum-grid-amountUnit","amountDisabled":"athenaeum-grid-amountDisabled","amount":"athenaeum-grid-amount","plus":"athenaeum-grid-plus","notCompleted":"athenaeum-grid-notCompleted","icon":"athenaeum-grid-icon","action":"athenaeum-grid-action","group":"athenaeum-grid-group","groupSeparator":"athenaeum-grid-groupSeparator","itemGroupIdent":"athenaeum-grid-itemGroupIdent","opened":"athenaeum-grid-opened","hovered":"athenaeum-grid-hovered","focused":"athenaeum-grid-focused","clearButtonVisible":"athenaeum-grid-clearButtonVisible","toggleButtonContainer":"athenaeum-grid-toggleButtonContainer","clearButton":"athenaeum-grid-clearButton","toggleButton":"athenaeum-grid-toggleButton","alignLeft":"athenaeum-grid-alignLeft","alignTop":"athenaeum-grid-alignTop","alignBottom":"athenaeum-grid-alignBottom","checkbox":"athenaeum-grid-checkbox","dropdownWidget":"athenaeum-grid-dropdownWidget","transparent":"athenaeum-grid-transparent","small":"athenaeum-grid-small","grid":"athenaeum-grid-grid","th":"athenaeum-grid-th","sortIcons":"athenaeum-grid-sortIcons","headerContent":"athenaeum-grid-headerContent","check":"athenaeum-grid-check","partially":"athenaeum-grid-partially","spinner":"athenaeum-grid-spinner","gridRow":"athenaeum-grid-gridRow","details":"athenaeum-grid-details","visible":"athenaeum-grid-visible","responsive":"athenaeum-grid-responsive","responsiveIcon":"athenaeum-grid-responsiveIcon","expanded":"athenaeum-grid-expanded","heightLarge":"athenaeum-grid-heightLarge","heightMedium":"athenaeum-grid-heightMedium","heightSmall":"athenaeum-grid-heightSmall","collapsedRow":"athenaeum-grid-collapsedRow","totalRow":"athenaeum-grid-totalRow","rowSpan":"athenaeum-grid-rowSpan","square":"athenaeum-grid-square","cellHovering":"athenaeum-grid-cellHovering","deleted":"athenaeum-grid-deleted","firstColumn":"athenaeum-grid-firstColumn","lastColumn":"athenaeum-grid-lastColumn","defaultCell":"athenaeum-grid-defaultCell","textCell":"athenaeum-grid-textCell","wordBreak":"athenaeum-grid-wordBreak","paddingLarge":"athenaeum-grid-paddingLarge","enumCell":"athenaeum-grid-enumCell","twoLines":"athenaeum-grid-twoLines","numberCell":"athenaeum-grid-numberCell","numberContainer":"athenaeum-grid-numberContainer","numberInfo":"athenaeum-grid-numberInfo","numberInput":"athenaeum-grid-numberInput","paddingMedium":"athenaeum-grid-paddingMedium","actions":"athenaeum-grid-actions","textContainer":"athenaeum-grid-textContainer","addressInput":"athenaeum-grid-addressInput","textInput":"athenaeum-grid-textInput","noActions":"athenaeum-grid-noActions","dateCell":"athenaeum-grid-dateCell","paddingSmall":"athenaeum-grid-paddingSmall","withArrows":"athenaeum-grid-withArrows","cell":"athenaeum-grid-cell","fixedLineHeight":"athenaeum-grid-fixedLineHeight","center":"athenaeum-grid-center","actionRight":"athenaeum-grid-actionRight","notValid":"athenaeum-grid-notValid","hideZero":"athenaeum-grid-hideZero","bold":"athenaeum-grid-bold","shortDate":"athenaeum-grid-shortDate","booleanCell":"athenaeum-grid-booleanCell","link":"athenaeum-grid-link","emptyRow":"athenaeum-grid-emptyRow","pagination":"athenaeum-grid-pagination"};
styleInject(css_248z$Y);

class CellActionComponent extends BaseComponent {
  invokeActionCallbackAsync(cell, action, selectedAction) {
    return __awaiter(this, void 0, void 0, function* () {
      const descriptionCellAction = this.getDescriptionCellAction();
      if (descriptionCellAction) {
        yield this.toggleDescriptionAsync(cell, descriptionCellAction);
      } else if (action.action.callback) {
        yield action.action.callback(cell, action, selectedAction);
      }
    });
  }
  getActionColor(actionType) {
    switch (actionType) {
      case ActionType.Default:
        return "text-dark";
      case ActionType.Create:
        return "text-success";
      case ActionType.Edit:
        return "text-warning";
      case ActionType.Delete:
        return "text-danger";
      case ActionType.Muted:
        return "text-muted";
      case ActionType.Secondary:
        return "text-secondary";
      case ActionType.Light:
        return "text-light";
      case ActionType.Grey:
        return "grey";
      case ActionType.Info:
        return "text-info";
      case ActionType.Blue:
        return "text-primary";
      default:
        return "text-primary";
    }
  }
  toggleDescriptionAsync(cell, action) {
    return __awaiter(this, void 0, void 0, function* () {
      const model = new DescriptionModel();
      model.description = cell.description;
      model.align = action.alight;
      model.justify = action.justify;
      model.maxLength = action.maxLength;
      model.readonly = cell.descriptionReadonly;
      model.onChange = value => __awaiter(this, void 0, void 0, function* () {
        return this.updateDescriptionAsync(cell, action, value);
      });
      yield ch.descriptionAsync(cell.instance.id, model);
    });
  }
  updateDescriptionAsync(cell, action, value) {
    return __awaiter(this, void 0, void 0, function* () {
      const hadDescription = !!cell.description;
      cell.description = value;
      if (action.action.callback) {
        yield action.action.callback(cell, action);
      }
      if (hadDescription && !cell.description) {
        yield cell.reRenderAsync();
      }
    });
  }
  get cell() {
    return this.props.cell;
  }
  get cellAction() {
    return this.props.cellAction;
  }
  getDescriptionCellAction() {
    const cellAction = this.cellAction;
    return cellAction instanceof DescriptionCellAction ? cellAction : null;
  }
  get columnAction() {
    return this.cellAction.action;
  }
  render() {
    const cellAction = this.cellAction;
    const action = this.columnAction;
    const cell = this.cell;
    cellAction.instance = this;
    const isDescription = cellAction instanceof DescriptionCellAction;
    const alwaysAvailable = isDescription || action.alwaysAvailable;
    const visible = cellAction.visible && (alwaysAvailable || !cell.grid.readonly);
    const actionColorClassName = this.getActionColor(action.type);
    const rightStyle = action.right && styles$Q.actionRight;
    const hasToggleModal = action.toggleModal != null;
    let dataModal = undefined;
    if (hasToggleModal) {
      try {
        dataModal = JSON.stringify(cell.model);
      } catch (_a) {
        // Just to solve cyclic object parsing problem
      }
    }
    let confirm = null;
    if (action.confirm) {
      if (typeof action.confirm === "function") {
        const routeCallback = action.confirm;
        confirm = routeCallback(cell, cellAction);
      } else {
        confirm = action.confirm;
      }
    }
    let icon = action.icon;
    if (isDescription) {
      icon = {
        name: cell.descriptionIcon ? cell.descriptionIcon : cell.description ? "far comment-alt-dots" : "far comment-alt"
      };
    }
    if (!action.title && !icon) {
      icon = {
        name: "fas circle"
      };
    }
    if (action.right) ;
    if (!visible) {
      return null;
    }
    return icon ? action.actions ? ( /*#__PURE__*/React.createElement(Icon, Object.assign({
      id: this.id
    }, icon, {
      tooltip: action.title || undefined,
      className: this.css(actionColorClassName, rightStyle),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return this.invokeActionCallbackAsync(cell, cellAction);
      }),
      dataTarget: action.toggleModal || undefined,
      dataModal: dataModal,
      toggleModal: !!action.toggleModal,
      confirm: confirm || undefined
    }), action.actions.map(value => {
      return /*#__PURE__*/React.createElement(Icon.Action, {
        key: value,
        title: value,
        onClick: () => __awaiter(this, void 0, void 0, function* () {
          return this.invokeActionCallbackAsync(cell, cellAction, value);
        })
      });
    }))) : ( /*#__PURE__*/React.createElement(Icon, Object.assign({
      id: this.id
    }, icon, {
      tooltip: action.title || undefined,
      className: this.css(actionColorClassName, rightStyle),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return this.invokeActionCallbackAsync(cell, cellAction);
      }),
      dataTarget: action.toggleModal || undefined,
      dataModal: dataModal,
      toggleModal: !!action.toggleModal,
      confirm: confirm || undefined
    }))) : action.actions ? ( /*#__PURE__*/React.createElement(Button, {
      id: this.id,
      label: action.title,
      className: this.css(actionColorClassName, rightStyle),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return this.invokeActionCallbackAsync(cell, cellAction);
      }),
      dataTarget: action.toggleModal || undefined,
      dataModal: dataModal,
      toggleModal: !!action.toggleModal,
      confirm: confirm || undefined
    }, action.actions.map(value => {
      return /*#__PURE__*/React.createElement(Button.Action, {
        key: value,
        title: value,
        onClick: () => __awaiter(this, void 0, void 0, function* () {
          return this.invokeActionCallbackAsync(cell, cellAction, value);
        })
      });
    }))) : ( /*#__PURE__*/React.createElement(Button, {
      id: this.id,
      label: action.title,
      className: this.css(actionColorClassName, rightStyle),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return this.invokeActionCallbackAsync(cell, cellAction);
      }),
      dataTarget: action.toggleModal || undefined,
      dataModal: dataModal,
      toggleModal: !!action.toggleModal,
      confirm: confirm || undefined
    }));
  }
}

var global$1 = global$p;
var fails = fails$p;
var uncurryThis$1 = functionUncurryThis;
var toString$1 = toString$d;
var trim = stringTrim.trim;
var whitespaces = whitespaces$3;

var $parseInt$1 = global$1.parseInt;
var Symbol$1 = global$1.Symbol;
var ITERATOR = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis$1(hex.exec);
var FORCED = $parseInt$1(whitespaces + '08') !== 8 || $parseInt$1(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseInt$1(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED ? function parseInt(string, radix) {
  var S = trim(toString$1(string));
  return $parseInt$1(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt$1;

var $$1 = _export;
var $parseInt = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$$1({ global: true, forced: parseInt !== $parseInt }, {
  parseInt: $parseInt
});

class DropdownCell extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      data: null,
      isLoading: false
    };
    this._inputRef = /*#__PURE__*/React.createRef();
  }
  onChangeAsync(sender, value, userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      const cell = this.model;
      let modelValue = value;
      if (modelValue != null && (modelValue instanceof SelectListItem || modelValue.isSelectListItem)) {
        modelValue = parseInt(modelValue.value);
      }
      if (this.settings.multiple && this.items) {
        const selectedItems = sender.selectedItems;
        modelValue = this.items.filter(item => selectedItems.some(selectedItem => Comparator.isEqual(selectedItem, item)));
      }
      const cellState = cell.modified;
      cell.setValue(modelValue);
      if (userInteraction && cell.column.callback) {
        yield cell.column.callback(cell, null);
      }
      const modified = cellState !== cell.modified;
      if (modified) {
        yield cell.row.reRenderAsync();
      } else {
        yield this.reRenderAsync();
      }
    });
  }
  selectedTextTransform(sender) {
    return !this.hasData || this.isLoading ? "" : this.settings.selectedTextTransform(sender);
  }
  get selectedTextTransformLambda() {
    return this.settings.selectedTextTransform ? sender => this.selectedTextTransform(sender) : undefined;
  }
  fetchDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.settings.fetchItems) {
        return yield this.settings.fetchItems(this.model);
      }
      return [];
    });
  }
  onAddAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.settings.addCallback) {
        yield this.settings.addCallback(this.model);
      }
    });
  }
  getEndpoint() {
    return "";
  }
  isAsync() {
    return this.settings.fetchItems != null;
  }
  get model() {
    return this.props.cell;
  }
  get settings() {
    return this.model.column.settings;
  }
  get items() {
    return this.state.data || [];
  }
  get value() {
    return this.model.value;
  }
  get selectedItem() {
    return !this.settings.multiple ? this.value : null;
  }
  get values() {
    return this.model.value;
  }
  get selectedItems() {
    return this.settings.multiple ? this.values : null;
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      this.props.cell.inputContentInstance = this._inputRef.current;
    });
  }
  render() {
    this.model.asyncContentInstance = this;
    return /*#__PURE__*/React.createElement(Dropdown, {
      ref: this._inputRef,
      noSubtext: true,
      noWrap: true,
      nothingSelectedText: this.settings.nothingSelectedText || undefined,
      autoCollapse: this.settings.autoCollapse,
      multiple: this.settings.multiple,
      align: this.settings.align,
      verticalAlign: this.settings.verticalAlign,
      required: this.settings.required,
      groupSelected: this.settings.groupSelected,
      noFilter: this.settings.noFilter,
      requiredType: this.settings.requiredType,
      className: styles$Q.dropdown,
      orderBy: DropdownOrderBy.None,
      addButton: this.settings.addButton,
      items: this.items,
      selectedItem: this.selectedItem || undefined,
      selectedItems: this.selectedItems || undefined,
      selectedTextTransform: this.selectedTextTransformLambda,
      onAdd: () => this.onAddAsync(),
      onChange: (sender, item, userInteraction) => this.onChangeAsync(sender, item, userInteraction)
    });
  }
}

var css_248z$X = ".athenaeum-location-picker-locationPicker {\n  width: 640px;\n  height: 480px;\n}\n.athenaeum-location-picker-locationPicker.athenaeum-location-picker-fullWidth {\n  width: 100%;\n}\n.athenaeum-location-picker-locationPicker > div {\n  margin-bottom: 4px;\n}\n.athenaeum-location-picker-locationPicker .athenaeum-location-picker-map {\n  width: 100%;\n  height: calc(100% - 39px);\n}";
var styles$P = {"locationPicker":"athenaeum-location-picker-locationPicker","fullWidth":"athenaeum-location-picker-fullWidth","map":"athenaeum-location-picker-map"};
styleInject(css_248z$X);

class LocationPicker extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      location: this.props.location || null,
      searchLocation: this.props.location != null ? this.props.location.formattedAddress : ""
    };
    this._addressInputRef = /*#__PURE__*/React.createRef();
    this._locationPickerRef = /*#__PURE__*/React.createRef();
    this._googleMap = null;
    this._marker = null;
    this._infoWindow = null;
  }
  get locationPicker() {
    return this._locationPickerRef.current;
  }
  get addressInput() {
    return this._addressInputRef.current;
  }
  get googleMap() {
    return this._googleMap;
  }
  get isValidLocation() {
    return this.location != null && AddressHelper.hasCoordinates(this.location);
  }
  get infoWindowContent() {
    return this.location ? `<div class="infoContent">
                    <span class="address">${AddressHelper.removeLatLon(this.location.formattedAddress)}</span>
                    <span class="dms">${AddressHelper.toDMS(this.location)}</span>
               </div>
               ` : "";
  }
  initAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this._googleMap = yield AddressHelper.createMapAsync(this.locationPicker, this.state.location, this.props.zoomLevel);
      if (!this.readonly) {
        AddressHelper.google.maps.event.addListener(this._googleMap, "click", event => __awaiter(this, void 0, void 0, function* () {
          yield this.onMapClickAsync(event.latLng);
        }));
      }
      if (this.location) {
        yield this.coordinateLocationAsync(this.location);
        yield this.setMarkerAsync(true);
      }
    });
  }
  coordinateLocationAsync(location) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!AddressHelper.hasCoordinates(location)) {
        const coordinate = yield AddressHelper.findAddressAsync(this.googleMap, location.formattedAddress);
        if (coordinate != null) {
          location.lat = coordinate.lat;
          location.lon = coordinate.lon;
          yield this.invokeOnChangeAsync();
        }
      }
    });
  }
  invokeOnChangeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange && this.location) {
        yield this.props.onChange(this, this.location);
      }
    });
  }
  setLocationAsync(location, setCenter = false) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        location: location,
        searchLocation: location.formattedAddress
      });
      yield this.setMarkerAsync(setCenter);
    });
  }
  onMapClickAsync(latLng) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.readonly) {
        const location = yield AddressHelper.findLocationByLatLngAsync(latLng);
        if (location) {
          location.lat = latLng.lat();
          location.lon = latLng.lng();
          yield this.setLocationAsync(location);
          yield this.invokeOnChangeAsync();
        }
      }
    });
  }
  setMarkerAsync(setCenter = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.location && this.isValidLocation) {
        const latLng = new AddressHelper.google.maps.LatLng(this.location.lat, this.location.lon);
        if (this._marker) {
          this._marker.setPosition(latLng);
        } else {
          this._marker = yield AddressHelper.addMarkerAsync(latLng, this.googleMap);
        }
        if (this.props.infoWindow) {
          if (this._infoWindow) {
            this._infoWindow.close();
            this._infoWindow.setContent(this.infoWindowContent);
          } else {
            this._infoWindow = yield AddressHelper.addInfoWindow(this.infoWindowContent);
          }
          this._marker.addListener("click", () => this._infoWindow.open(this._googleMap, this._marker));
        }
        if (setCenter) {
          this.googleMap.setCenter(latLng);
        }
      }
    });
  }
  onInputChange(location) {
    return __awaiter(this, void 0, void 0, function* () {
      this.state.searchLocation = location.formattedAddress;
      yield this.setLocationAsync(location, true);
      yield this.invokeOnChangeAsync();
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    return __awaiter(this, void 0, void 0, function* () {
      const nextLocation = nextProps.location || null;
      const newLocation = !Comparator.isEqual(this.state.location, nextLocation);
      if (newLocation && nextLocation) {
        this.state.searchLocation = nextLocation.formattedAddress;
        yield this.setLocationAsync(nextLocation, true);
        yield this.coordinateLocationAsync(nextLocation);
      }
    });
  }
  componentDidMount() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.initAsync();
    });
  }
  focus() {
    this.addressInput.focus();
  }
  get readonly() {
    return this.props.readonly == true;
  }
  get location() {
    return this.state.location;
  }
  get formattedAddress() {
    return this.location ? this.location.formattedAddress : "";
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$P.locationPicker, this.props.fullWidth && styles$P.fullWidth)
    }, !this.readonly && ( /*#__PURE__*/React.createElement(AddressInput, {
      id: `AddressInput_within_location_${this.id}`,
      readonly: this.readonly,
      country: this.props.countries,
      ref: this._addressInputRef,
      value: this.state.searchLocation,
      required: this.props.required,
      label: this.props.label,
      onChange: location => this.onInputChange(location)
    })), /*#__PURE__*/React.createElement("div", {
      id: this.props.id || this.id,
      ref: this._locationPickerRef,
      className: styles$P.map
    }));
  }
}

//Autogenerated
class LocationPickerModalLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.titleLanguageItemName = `Title`;
    this.subtitleLanguageItemName = `Subtitle`;
    this.setLocationLanguageItemName = `SetLocation`;
    //Initializer
    this.set(this.titleLanguageItemName, {
      language: `en`,
      value: `Location picker`
    }, {
      language: `uk`,
      value: `Вибір розташування`
    }, {
      language: `sv`,
      value: `Platsväljare`
    }, {
      language: `ru`,
      value: `Выбор местоположения`
    }, {
      language: `pl`,
      value: `Wybierz lokalizację`
    }, {
      language: `nb`,
      value: `Stedsvelger`
    }, {
      language: `fi`,
      value: `Sijaintivalitsin`
    }, {
      language: `da`,
      value: `Placeringsvælger`
    });
    this.set(this.subtitleLanguageItemName, {
      language: `en`,
      value: `Choose location on map`
    }, {
      language: `uk`,
      value: `Оберіть місце на мапі`
    }, {
      language: `sv`,
      value: `Välj plats på kartan`
    }, {
      language: `ru`,
      value: `Выбрать местоположение на карте`
    }, {
      language: `pl`,
      value: `Wybierz lokalizację na mapie`
    }, {
      language: `nb`,
      value: `Velg plassering på kartet`
    }, {
      language: `fi`,
      value: `Valitse sijainti kartalla`
    }, {
      language: `da`,
      value: `Vælg placering på kortet`
    });
    this.set(this.setLocationLanguageItemName, {
      language: `en`,
      value: `Set location`
    }, {
      language: `uk`,
      value: `Оберіть адресу`
    }, {
      language: `sv`,
      value: `Ställ in plats`
    }, {
      language: `ru`,
      value: `Установить местоположение`
    }, {
      language: `pl`,
      value: `Ustaw lokalizację`
    }, {
      language: `nb`,
      value: `Angi sted`
    }, {
      language: `fi`,
      value: `Aseta sijainti`
    }, {
      language: `da`,
      value: `Indstil placering`
    });
  }
  /**
  /* "Title" (Location picker)
  */
  get title() {
    return this.get(this.titleLanguageItemName);
  }
  /**
  /* "Subtitle" (Choose location on map)
  */
  get subtitle() {
    return this.get(this.subtitleLanguageItemName);
  }
  /**
  /* "SetLocation" (Set location)
  */
  get setLocation() {
    return this.get(this.setLocationLanguageItemName);
  }
}
//Singleton
var LocationPickerModalLocalizer$1 = new LocationPickerModalLocalizer();

var css_248z$W = ".athenaeum-location-picker-modal-locationPickerModal .modal-dialog {\n  max-width: 674px !important;\n}\n.athenaeum-location-picker-modal-locationPickerModal .infoContent {\n  display: flex;\n  flex-direction: column;\n}\n.athenaeum-location-picker-modal-locationPickerModal .infoContent .address {\n  font-weight: 600;\n}\n.athenaeum-location-picker-modal-locationPickerModal .infoContent .dms {\n  font-size: 12px;\n}\n.athenaeum-location-picker-modal-locationPickerModal .athenaeum-location-picker-modal-map {\n  padding-bottom: 1rem;\n}\n.athenaeum-location-picker-modal-locationPickerModal .athenaeum-location-picker-modal-address {\n  height: 100%;\n  width: 500px;\n  display: flex;\n  flex-direction: column;\n}\n.athenaeum-location-picker-modal-locationPickerModal .athenaeum-location-picker-modal-address .athenaeum-location-picker-modal-coordinate {\n  display: flex;\n  align-items: center;\n}\n.athenaeum-location-picker-modal-locationPickerModal .athenaeum-location-picker-modal-address .athenaeum-location-picker-modal-coordinate span {\n  font-size: 12px;\n}\n.athenaeum-location-picker-modal-locationPickerModal .athenaeum-location-picker-modal-address .athenaeum-location-picker-modal-coordinate span.athenaeum-location-picker-modal-separator {\n  margin: 0 8px;\n  display: block;\n  width: 1px;\n  height: 70%;\n  background-color: black;\n}\n.athenaeum-location-picker-modal-locationPickerModal .athenaeum-location-picker-modal-address .athenaeum-location-picker-modal-dms {\n  font-size: 12px;\n}";
var styles$O = {"locationPickerModal":"athenaeum-location-picker-modal-locationPickerModal","map":"athenaeum-location-picker-modal-map","address":"athenaeum-location-picker-modal-address","coordinate":"athenaeum-location-picker-modal-coordinate","separator":"athenaeum-location-picker-modal-separator","dms":"athenaeum-location-picker-modal-dms"};
styleInject(css_248z$W);

class LocationPickerModal extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      location: this.props.location || null
    };
    this._locationPickerRef = /*#__PURE__*/React.createRef();
    this._modalRef = /*#__PURE__*/React.createRef();
  }
  onSubmitAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.readonly && this.props.onSubmit && this.locationPicker && this.location) {
        yield this.props.onSubmit(this, this.location);
      }
      if (this.modal) {
        yield this.modal.closeAsync();
      }
    });
  }
  onOpenAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.locationPicker) {
        this.locationPicker.focus();
      }
      if (this.props.onOpen) {
        yield this.props.onOpen(this);
      }
    });
  }
  onCloseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onClose) {
        yield this.props.onClose(this);
      }
    });
  }
  onChangeAsync(location) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.locationPicker) {
        yield this.setState({
          location
        });
      }
    });
  }
  get locationPicker() {
    return this._locationPickerRef.current;
  }
  get modal() {
    return this._modalRef.current;
  }
  get location() {
    return this.state.location;
  }
  get formattedAddress() {
    if (this.locationPicker) {
      return this.locationPicker.formattedAddress;
    }
    return "";
  }
  openAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.modal) {
        yield this.modal.openAsync();
      }
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    return __awaiter(this, void 0, void 0, function* () {
      if (nextProps.location && nextProps.location !== this.state.location) {
        yield this.setState({
          location: nextProps.location
        });
      }
    });
  }
  get readonly() {
    return !!this.props.readonly;
  }
  get required() {
    return this.props.required === true;
  }
  get hasLocation() {
    return this.location != null && !!this.location.formattedAddress;
  }
  get isOpen() {
    return !!this.modal && this.modal.isOpen;
  }
  render() {
    return /*#__PURE__*/React.createElement(Modal, {
      id: this.id,
      ref: this._modalRef,
      title: this.props.title || LocationPickerModalLocalizer$1.title,
      subtitle: this.props.subtitle || LocationPickerModalLocalizer$1.subtitle,
      className: styles$O.locationPickerModal,
      notResponsive: this.props.notResponsive,
      noHeader: this.props.noHeader,
      onOpen: () => this.onOpenAsync(),
      onClose: () => this.onCloseAsync()
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$O.map
    }, /*#__PURE__*/React.createElement(LocationPicker, {
      ref: this._locationPickerRef,
      location: this.location || undefined,
      infoWindow: this.props.infoWindow,
      readonly: this.readonly,
      onChange: (sender, location) => this.onChangeAsync(location)
    })), /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement("div", {
      className: styles$O.address
    }, /*#__PURE__*/React.createElement("span", null, AddressHelper.removeLatLon(this.formattedAddress)), this.location && AddressHelper.hasCoordinates(this.location) && ( /*#__PURE__*/React.createElement("span", {
      className: styles$O.dms
    }, AddressHelper.toDMS(this.location)))), !this.readonly ? ( /*#__PURE__*/React.createElement(Button, {
      type: ButtonType.Orange,
      label: LocationPickerModalLocalizer$1.setLocation,
      disabled: this.required && !this.hasLocation,
      onClick: () => this.onSubmitAsync()
    })) : ( /*#__PURE__*/React.createElement("div", null))));
  }
}

//Autogenerated
class AddressInputLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.validatorsCustomRequiredLanguageItemName = `Validators.Custom.Required`;
    //Initializer
    this.set(this.validatorsCustomRequiredLanguageItemName, {
      language: `en`,
      value: `Type and select an address from the list`
    }, {
      language: `sv`,
      value: `Skriv och välj en adress i listan`
    }, {
      language: `pl`,
      value: `Wpisz i wybierz adres z listy`
    }, {
      language: `nb`,
      value: `Skriv inn og velg en adresse fra listen`
    }, {
      language: `fi`,
      value: `Kirjoita ja valitse osoite listasta`
    }, {
      language: `da`,
      value: `Skriv og vælg en adresse på listen`
    });
  }
  /**
  /* "Validators.Custom.Required" (Type and select an address from the list)
  */
  get validatorsCustomRequired() {
    return this.get(this.validatorsCustomRequiredLanguageItemName);
  }
}
//Singleton
var AddressInputLocalizer$1 = new AddressInputLocalizer();

var css_248z$V = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-text-input-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-text-input-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-text-input-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-text-input-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-text-input-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-text-input-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-text-input-textInputContainer {\n  position: relative;\n}\n.athenaeum-text-input-textInputContainer input.athenaeum-text-input-textInput.athenaeum-text-input-small {\n  font-size: 0.8rem;\n  padding: 0.375rem;\n  height: auto;\n  width: 5rem;\n  background-color: white;\n}\n.athenaeum-text-input-textInputContainer input.athenaeum-text-input-textInput.athenaeum-text-input-autoSuggest {\n  padding-right: 1.5rem;\n}\n.athenaeum-text-input-textInputContainer input.athenaeum-text-input-textInput.athenaeum-text-input-clearButton {\n  padding-right: 1.5rem;\n}\n.athenaeum-text-input-textInputContainer input.athenaeum-text-input-textInput.athenaeum-text-input-autoSuggest.athenaeum-text-input-clearButton {\n  padding-right: 2.5rem;\n}\n.athenaeum-text-input-textInputContainer .athenaeum-text-input-autoSuggestIcon {\n  position: absolute;\n  bottom: 9px;\n  right: 5px;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-text-input-textInputContainer .athenaeum-text-input-autoSuggestIcon > i {\n  padding: 4px;\n  cursor: pointer;\n}\n.athenaeum-text-input-textInputContainer .athenaeum-text-input-autoSuggestIcon:not(:hover) {\n  opacity: 0.3;\n}\n.athenaeum-text-input-textInputContainer .athenaeum-text-input-clearButtonIcon {\n  position: absolute;\n  bottom: 7px;\n  right: 5px;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-text-input-textInputContainer .athenaeum-text-input-clearButtonIcon:not(:hover) {\n  opacity: 0.3;\n}\n.athenaeum-text-input-textInputContainer .athenaeum-text-input-clearButtonIcon > i {\n  padding: 4px;\n  cursor: pointer;\n}\n.athenaeum-text-input-textInputContainer .athenaeum-text-input-clearButtonIcon.athenaeum-text-input-autoSuggest {\n  right: 20px;\n}";
var styles$N = {"font-renta":"athenaeum-text-input-font-renta","color-schema-renta_black":"athenaeum-text-input-color-schema-renta_black","color-schema-renta_white":"athenaeum-text-input-color-schema-renta_white","color-schema-renta_orange":"athenaeum-text-input-color-schema-renta_orange","color-schema-renta_green":"athenaeum-text-input-color-schema-renta_green","color-schema-renta_blue":"athenaeum-text-input-color-schema-renta_blue","textInputContainer":"athenaeum-text-input-textInputContainer","textInput":"athenaeum-text-input-textInput","small":"athenaeum-text-input-small","autoSuggest":"athenaeum-text-input-autoSuggest","clearButton":"athenaeum-text-input-clearButton","autoSuggestIcon":"athenaeum-text-input-autoSuggestIcon","clearButtonIcon":"athenaeum-text-input-clearButtonIcon"};
styleInject(css_248z$V);

// eslint-disable-next-line valid-typeof
const isBrowser = typeof window != null && window.document != null;
const GOOGLE_MAP_SCRIPT_BASE_URL = "https://maps.googleapis.com/maps/api/js";
const loadGoogleMapScript = (googleMapsScriptBaseUrl, googleMapsScriptUrl) => {
  if (!isBrowser) {
    return Promise.resolve();
  }
  if (typeof google !== "undefined") {
    if (google.maps && google.maps.api) {
      return Promise.resolve();
    }
  }
  const scriptElements = document.querySelectorAll(`script[src*="${googleMapsScriptBaseUrl}"]`);
  if (scriptElements && scriptElements.length) {
    return new Promise(resolve => {
      // in case we already have a script on the page and it's loaded we resolve
      if (typeof google !== "undefined") return resolve();
      // otherwise we wait until it's loaded and resolve
      scriptElements[0].addEventListener("load", () => resolve());
    });
  }
  const el = document.createElement("script");
  el.src = googleMapsScriptUrl;
  document.body.appendChild(el);
  return new Promise(resolve => {
    el.addEventListener("load", () => resolve());
  });
};

const UsePlacesWidget = props => {
  const {
      ref = undefined,
      onPlaceSelected,
      apiKey,
      libraries = "places",
      inputAutocompleteValue = "new-password"
    } = props,
    _a = props.options,
    _b = _a === void 0 ? {} : _a,
    {
      types = ["(cities)"],
      componentRestrictions = undefined,
      fields = ["address_components", "geometry.location", "place_id", "formatted_address"],
      bounds = undefined
    } = _b,
    options = __rest(_b, ["types", "componentRestrictions", "fields", "bounds"]),
    {
      googleMapsScriptBaseUrl = GOOGLE_MAP_SCRIPT_BASE_URL,
      language
    } = props;
  const inputRef = useRef(null);
  const event = useRef(null);
  const autocompleteRef = useRef(null);
  const observerHack = useRef(null);
  const languageQueryParam = language ? `&language=${language}` : "";
  const googleMapsScriptUrl = `${googleMapsScriptBaseUrl}?libraries=${libraries}&key=${apiKey}${languageQueryParam}`;
  const handleLoadScript = useCallback(() => Utility.reTryAsync(() => loadGoogleMapScript(googleMapsScriptBaseUrl, googleMapsScriptUrl)), [googleMapsScriptBaseUrl, googleMapsScriptUrl]);
  useEffect(() => {
    const config = Object.assign(Object.assign({}, options), {
      fields,
      types,
      bounds
    });
    if (componentRestrictions) {
      config.componentRestrictions = componentRestrictions;
    }
    if (autocompleteRef.current || !inputRef.current || !isBrowser) return;
    if (ref && !ref.current) ref.current = inputRef.current;
    const handleAutoComplete = () => {
      var _a;
      if (typeof google === "undefined") return console.error("Google has not been found. Make sure your provide apiKey prop.");
      if (!((_a = google.maps) === null || _a === void 0 ? void 0 : _a.places)) return console.error("Google maps places API must be loaded.");
      if (!(inputRef.current instanceof HTMLInputElement)) return console.error("Input ref must be HTMLInputElement.");
      autocompleteRef.current = new google.maps.places.Autocomplete(inputRef.current, config);
      if (autocompleteRef.current) {
        event.current = autocompleteRef.current.addListener("place_changed", () => {
          if (onPlaceSelected && autocompleteRef && autocompleteRef.current) {
            onPlaceSelected(autocompleteRef.current.getPlace(), inputRef.current, autocompleteRef.current);
          }
        });
      }
    };
    if (apiKey) {
      handleLoadScript().then(() => handleAutoComplete());
    } else {
      handleAutoComplete();
    }
    return () => event.current ? event.current.remove() : undefined;
  }, []);
  // Autofill workaround adapted from https://stackoverflow.com/questions/29931712/chrome-autofill-covers-autocomplete-for-google-maps-api-v3/49161445#49161445
  useEffect(() => {
    var _a;
    if (!((_a = React === null || React === void 0 ? void 0 : React.version) === null || _a === void 0 ? void 0 : _a.startsWith("18")) && isBrowser && window.MutationObserver && inputRef.current && inputRef.current instanceof HTMLInputElement) {
      observerHack.current = new MutationObserver(() => {
        observerHack.current.disconnect();
        if (inputRef.current) {
          inputRef.current.autocomplete = inputAutocompleteValue;
        }
      });
      observerHack.current.observe(inputRef.current, {
        attributes: true,
        attributeFilter: ["autocomplete"]
      });
    }
  }, [inputAutocompleteValue]);
  useEffect(() => {
    if (autocompleteRef.current) {
      autocompleteRef.current.setFields(fields);
    }
  }, [fields]);
  useEffect(() => {
    if (autocompleteRef.current) {
      autocompleteRef.current.setBounds(bounds);
    }
  }, [bounds]);
  useEffect(() => {
    if (autocompleteRef.current) {
      autocompleteRef.current.setComponentRestrictions(componentRestrictions);
    }
  }, [componentRestrictions]);
  useEffect(() => {
    if (autocompleteRef.current) {
      autocompleteRef.current.setOptions(options);
    }
  }, [options]);
  return {
    ref: inputRef,
    autocompleteRef
  };
};

const ReactGoogleAutocomplete = props => {
  const rest = __rest(props, ["onPlaceSelected", "apiKey", "libraries", "inputAutocompleteValue", "options", "googleMapsScriptBaseUrl", "language"]);
  const response = UsePlacesWidget({
    ref: props.ref,
    googleMapsScriptBaseUrl: props.googleMapsScriptBaseUrl,
    onPlaceSelected: props.onPlaceSelected,
    apiKey: props.apiKey,
    libraries: props.libraries,
    inputAutocompleteValue: props.inputAutocompleteValue,
    options: props.options,
    language: props.language
  });
  return /*#__PURE__*/React.createElement("input", Object.assign({
    ref: response.ref
  }, rest));
};

class AddressInput extends BaseInput {
  constructor() {
    super(...arguments);
    this.state = {
      model: {
        value: this.props.value || ""
      },
      edit: !this.props.clickToEdit,
      readonly: this.props.readonly || false,
      validationError: "",
      generation: 0,
      location: AddressHelper.toLocation(this.props.value),
      inputValue: false
    };
    this._locationPickerModalRef = /*#__PURE__*/React.createRef();
  }
  get locationPickerModal() {
    return this._locationPickerModalRef.current;
  }
  get locationPickerIsOpen() {
    return !!this.locationPickerModal && this.locationPickerModal.isOpen;
  }
  openLocationPickerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.locationPickerModal) {
        yield this.locationPickerModal.openAsync();
        yield this.reRenderAsync();
      }
    });
  }
  onInputKeyDownHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (e.keyCode === 13) {
        e.preventDefault();
      } else if (e.keyCode === 27) {
        yield this.setEditAsync(false);
      }
    });
  }
  invokeOnChangeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.location) {
        yield this.setEditAsync(false);
        if (this.props.onChange) {
          yield this.props.onChange(this.state.location);
        }
      }
    });
  }
  onPlaceSelectedAsync(place) {
    return __awaiter(this, void 0, void 0, function* () {
      if (place.formatted_address !== AddressHelper.removeLatLon(this.value)) {
        const geoLocation = AddressHelper.getLocationFromGeocodeResult(place);
        this.state.location = geoLocation;
        this.state.inputValue = true;
        yield this.updateValueAsync(geoLocation.formattedAddress);
        yield this.invokeOnChangeAsync();
        if (this.props.clickToEdit) {
          yield this.setState({
            edit: false
          });
        }
      }
    });
  }
  onLocationCloseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.reRenderAsync();
    });
  }
  onLocationSetAsync(location) {
    return __awaiter(this, void 0, void 0, function* () {
      const isEqual = Comparator.isEqual(this.state.location, location);
      if (!isEqual) {
        this.state.location = location;
        this.state.inputValue = false;
        this.onValuePropsChanged();
        yield this.updateValueAsync(location.formattedAddress);
        yield this.invokeOnChangeAsync();
      }
    });
  }
  get locationPickerId() {
    return `locationPicker_${this.id}`;
  }
  get defaultValue() {
    return this.state.inputValue ? null : this.getFormattedStr();
  }
  getType() {
    return BaseInputType.Text;
  }
  onValuePropsChanged() {
    const state = this.state;
    state.generation = state.generation + 1;
  }
  getFormattedStr() {
    return AddressHelper.removeLatLon(this.value);
  }
  getCustomRequiredValidationError() {
    return AddressInputLocalizer$1.validatorsCustomRequired;
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.clickToEdit) {
        const targetNode = e.target;
        let outside = Utility.clickedOutside(targetNode, this.id);
        if (this.props.locationPicker) {
          outside = outside && Utility.clickedOutside(targetNode, this.locationPickerId);
        }
        outside = outside && !this.JQuery(targetNode).parents(".pac-container").length;
        if (outside) {
          yield this.hideEditAsync();
        }
      }
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const nextLocation = AddressHelper.toLocation(nextProps.value);
      const newLocation = !Comparator.isEqual(this.state.location, nextLocation);
      if (newLocation) {
        this.state.inputValue = false;
        this.onValuePropsChanged();
        yield this.setState({
          location: nextLocation
        });
      }
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  get countries() {
    return this.props.country != null ? typeof this.props.country === "string" ? this.props.country ? [this.props.country] : [] : this.props.country.length > 0 ? this.props.country : [] : [ch.country];
  }
  get options() {
    const options = {
      types: ["address"],
      fields: ["address_components", "formatted_address", "geometry"]
    };
    const countries = this.countries;
    if (countries) {
      options.componentRestrictions = {
        country: countries
      };
    }
    return options;
  }
  renderLocationPicker() {
    if (this.props.locationPicker) {
      return /*#__PURE__*/React.createElement(LocationPickerModal, {
        ref: this._locationPickerModalRef,
        infoWindow: true,
        id: this.locationPickerId,
        location: this.state.location || undefined,
        required: this.props.required,
        readonly: this.readonly,
        onClose: () => this.onLocationCloseAsync(),
        onSubmit: (sender, location) => this.onLocationSetAsync(location)
      });
    }
    return null;
  }
  renderAppend() {
    if (this.props.locationPicker && this.state.edit) {
      return /*#__PURE__*/React.createElement("div", {
        className: "input-group-append cursor-pointer",
        onClick: () => this.openLocationPickerAsync()
      }, /*#__PURE__*/React.createElement("span", {
        className: this.css("input-group-text", styles$16.append, this.state.validationError && styles$16.validationError)
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "fas map-marker-alt"
      })));
    }
    if (this.state.edit) {
      return super.renderAppend();
    }
    return;
  }
  renderInput() {
    const smallStyle = this.props.small && styles$N.small;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReactGoogleAutocomplete, {
      key: `${this.getInputId()}_${this.state.generation}`,
      id: this.getInputId(),
      className: this.css(styles$N.textInput, "form-control", smallStyle),
      options: this.options,
      defaultValue: this.defaultValue || undefined,
      disabled: this.locationPickerIsOpen,
      readOnly: this.readonly,
      autoComplete: "off",
      role: "presentation",
      onKeyDown: e => this.onInputKeyDownHandlerAsync(e),
      onPlaceSelected: place => this.onPlaceSelectedAsync(place)
    }), this.renderLocationPicker());
  }
}

var css_248z$U = ".athenaeum-auto-suggest-autoSuggest {\n  display: none;\n  margin: 2px 0;\n  padding: 3px 0;\n  background-color: #fe5000;\n  border-radius: 5px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  position: absolute;\n  right: 0;\n  z-index: 150;\n}\n.athenaeum-auto-suggest-autoSuggest .athenaeum-auto-suggest-container {\n  color: white;\n}\n.athenaeum-auto-suggest-autoSuggest .athenaeum-auto-suggest-container .athenaeum-auto-suggest-group {\n  cursor: default;\n  color: #e3e3e3 !important;\n  background-color: inherit !important;\n  font-size: 12px;\n  text-transform: uppercase;\n  padding: 0 12px;\n}\n.athenaeum-auto-suggest-autoSuggest .athenaeum-auto-suggest-container .athenaeum-auto-suggest-groupItem {\n  cursor: pointer;\n  padding-left: 20px;\n  text-transform: uppercase;\n}\n.athenaeum-auto-suggest-autoSuggest .athenaeum-auto-suggest-container .athenaeum-auto-suggest-groupItem:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-auto-suggest-autoSuggest .athenaeum-auto-suggest-container .athenaeum-auto-suggest-groupSeparator {\n  margin: 6px 2px;\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.athenaeum-auto-suggest-autoSuggest.athenaeum-auto-suggest-open {\n  display: block;\n}";
var styles$M = {"autoSuggest":"athenaeum-auto-suggest-autoSuggest","container":"athenaeum-auto-suggest-container","group":"athenaeum-auto-suggest-group","groupItem":"athenaeum-auto-suggest-groupItem","groupSeparator":"athenaeum-auto-suggest-groupSeparator","open":"athenaeum-auto-suggest-open"};
styleInject(css_248z$U);

class AutoSuggestItem {
  constructor(value = null, group = null) {
    this.value = value || "";
    this.group = group || "";
    this.isAutoSuggestItem = true;
  }
}
class AutoSuggestItemGroup {
  constructor(name) {
    this.name = name;
    this.items = [];
  }
}
class AutoSuggest extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isOpen: this.props.isOpen || false
    };
  }
  get items() {
    const items = this.props.items;
    if (items.length == 0) {
      return [];
    }
    if (items[0] instanceof AutoSuggestItem) {
      return items;
    }
    return items.map(item => new AutoSuggestItem(item));
  }
  get toggleButtonId() {
    return this.props.toggleButtonId;
  }
  onSelectAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        yield this.props.onSelect(this, item.value);
        yield this.closeAsync();
      }
    });
  }
  closeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        if (this.state.isOpen) {
          yield this.setState({
            isOpen: false
          });
        }
      }
    });
  }
  openAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.state.isOpen) {
        yield this.setState({
          isOpen: true
        });
      }
    });
  }
  groupBy(data) {
    const dictionary = new Dictionary();
    data.forEach(item => {
      let group = dictionary.getValue(item.group);
      if (!group) {
        group = new AutoSuggestItemGroup(item.group);
        dictionary.setValue(item.group, group);
      }
      group.items.push(item);
    });
    return dictionary.values();
  }
  get isOpen() {
    return this.state.isOpen;
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.isOpen) {
        yield this.closeAsync();
      } else {
        yield this.openAsync();
      }
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const targetNode = e.target;
      const outside = Utility.clickedOutside(targetNode, this.id, this.toggleButtonId);
      if (outside) {
        yield this.closeAsync();
      }
    });
  }
  onGlobalKeydown(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (e.keyCode === 27) {
        yield this.closeAsync();
      }
    });
  }
  render() {
    const groups = this.groupBy(this.items);
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(this.props.className, styles$M.autoSuggest, this.isOpen && styles$M.open)
    }, this.items.length > 0 && groups.map((group, index) => ( /*#__PURE__*/React.createElement("div", {
      key: group.name,
      className: styles$M.container
    }, group.name && ( /*#__PURE__*/React.createElement("span", {
      className: styles$M.group
    }, group.name)), group.items.map(item => ( /*#__PURE__*/React.createElement("div", {
      key: item.value,
      className: styles$M.groupItem,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onSelectAsync(item);
      })
    }, item.value))), groups.length > 1 && index !== groups.length - 1 && ( /*#__PURE__*/React.createElement("hr", {
      className: styles$M.groupSeparator
    }))))));
  }
}

//Autogenerated
class TextInputLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Initializer
  }
}
//Singleton
var TextInputLocalizer$1 = new TextInputLocalizer();

class TextInput extends BaseInput {
  constructor() {
    super(...arguments);
    this._autoSuggestRef = /*#__PURE__*/React.createRef();
  }
  invokeOnChangeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(this, this.value, true, false);
      }
    });
  }
  onChangeAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.valueChangeHandlerAsync(event);
      yield this.invokeOnChangeAsync();
    });
  }
  onInputKeyDownHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const enter = e.keyCode === 13;
      if (this.props.clickToEdit) {
        if (enter || e.keyCode === 27) {
          e.preventDefault();
          yield this.hideEditAsync();
        }
      } else if (enter && this.props.onChange) {
        yield this.props.onChange(this, this.value, true, true);
      }
    });
  }
  toggleAutoSuggest() {
    return __awaiter(this, void 0, void 0, function* () {
      const autoSuggest = this._autoSuggestRef.current;
      if (autoSuggest) {
        yield autoSuggest.toggleAsync();
      }
    });
  }
  setValueFromAutoSuggest(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (value != this.str) {
        yield this.updateValueAsync(value);
        this.focus();
        yield this.invokeOnChangeAsync();
      }
    });
  }
  clearAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.str) {
        yield this.updateValueAsync("");
        this.focus();
        yield this.invokeOnChangeAsync();
      }
    });
  }
  get autoSuggestItems() {
    var _a;
    return (_a = this.props.autoSuggestItems) !== null && _a !== void 0 ? _a : [];
  }
  get toggleButtonId() {
    return `auto-suggest-toggler-${this.id}`;
  }
  getType() {
    return BaseInputType.Text;
  }
  getContainerClassName() {
    return styles$N.textInputContainer;
  }
  onHideEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(this, this.value, true, true);
      }
    });
  }
  valueBlurHandlerAsync() {
    const _super = Object.create(null, {
      validateAsync: {
        get: () => super.validateAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.validateAsync.call(this);
      if (this.props.onBlur) {
        yield this.props.onBlur(this);
      }
    });
  }
  getValidators() {
    return [];
  }
  focus(select = false) {
    const inputElement = this.inputElement;
    if (inputElement) {
      inputElement.focus();
      if (select) {
        inputElement.select();
      }
    }
  }
  get value() {
    const value = this.state.model.value || "";
    return this.props.trim ? value.trim() : value;
  }
  get str() {
    return this.state.model.value || "";
  }
  get noAutoComplete() {
    return this.props.noAutoComplete == true || this.props.autoComplete === false;
  }
  get clearButton() {
    return this.props.clearButton === true;
  }
  renderInput() {
    const value = this.str;
    const autoSuggestItems = this.autoSuggestItems;
    const hasAutoSuggestItems = autoSuggestItems.length > 0;
    const clearButton = this.clearButton && !!value;
    const smallStyle = this.props.small && styles$N.small;
    const autoSuggestStyle = hasAutoSuggestItems && styles$N.autoSuggest;
    const clearButtonStyle = clearButton && styles$N.clearButton;
    const clearButtonWithAutoSuggestStyle = clearButton && hasAutoSuggestItems && styles$N.autoSuggest;
    const inlineStyles = {};
    if (this.props.width) {
      inlineStyles.width = this.props.width;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      id: this.getInputId(),
      type: this.getType(),
      className: this.css(styles$N.textInput, "form-control", smallStyle, autoSuggestStyle, clearButtonStyle),
      style: inlineStyles,
      title: TextInputLocalizer$1.get(this.props.title),
      placeholder: TextInputLocalizer$1.get(this.props.placeholder),
      value: value,
      readOnly: this.readonly,
      size: this.props.size || 10,
      minLength: this.props.minLength || 0,
      maxLength: this.props.maxLength || 255,
      autoFocus: this.props.autoFocus,
      autoComplete: this.noAutoComplete ? "off" : "",
      role: this.noAutoComplete ? "presentation" : "",
      onChange: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onChangeAsync(e);
      }),
      onBlur: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.valueBlurHandlerAsync();
      }),
      onKeyDown: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onInputKeyDownHandlerAsync(e);
      })
    }), clearButton && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$N.clearButtonIcon, clearButtonWithAutoSuggestStyle)
    }, /*#__PURE__*/React.createElement(Icon, {
      stopPropagation: true,
      name: "fa fa-times",
      size: IconSize.Normal,
      onClick: () => this.clearAsync()
    }))), hasAutoSuggestItems && ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$N.autoSuggestIcon)
    }, /*#__PURE__*/React.createElement(Icon, {
      id: this.toggleButtonId,
      stopPropagation: true,
      name: "fa fa-caret-down",
      size: IconSize.Normal,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAutoSuggest();
      })
    })), /*#__PURE__*/React.createElement(AutoSuggest, {
      ref: this._autoSuggestRef,
      items: autoSuggestItems,
      toggleButtonId: this.toggleButtonId,
      onSelect: (_, value) => __awaiter(this, void 0, void 0, function* () {
        return yield this.setValueFromAutoSuggest(value);
      })
    }))));
  }
}

var css_248z$T = ".athenaeum-number-input-numberInput {\n  position: relative;\n}\n.athenaeum-number-input-numberInput input[type=number]::-webkit-inner-spin-button, .athenaeum-number-input-numberInput input[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.athenaeum-number-input-numberInput .athenaeum-number-input-numberInputArrow {\n  position: absolute;\n  width: 20px;\n  border-left: 1px solid #d4d4d4;\n  border-right: 1px solid transparent;\n  color: #d4d4d4;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-number-input-numberInput .athenaeum-number-input-increaseArrow {\n  right: 0;\n  top: 0;\n  bottom: unset;\n  height: 50%;\n}\n.athenaeum-number-input-numberInput .athenaeum-number-input-decreaseArrow {\n  top: unset;\n  right: 0;\n  bottom: 0;\n  height: 50%;\n}\n.athenaeum-number-input-numberInput .athenaeum-number-input-disabled {\n  cursor: default;\n}";
var styles$L = {"numberInput":"athenaeum-number-input-numberInput","numberInputArrow":"athenaeum-number-input-numberInputArrow","increaseArrow":"athenaeum-number-input-increaseArrow","decreaseArrow":"athenaeum-number-input-decreaseArrow","disabled":"athenaeum-number-input-disabled"};
styleInject(css_248z$T);

var NumberInputBehaviour;
(function (NumberInputBehaviour) {
  /*
  * Validate on input change,
  */
  NumberInputBehaviour[NumberInputBehaviour["ValidationOnChange"] = 0] = "ValidationOnChange";
  NumberInputBehaviour[NumberInputBehaviour["ValidationOnSave"] = 1] = "ValidationOnSave";
  NumberInputBehaviour[NumberInputBehaviour["Restricted"] = 2] = "Restricted";
})(NumberInputBehaviour || (NumberInputBehaviour = {}));
class NumberInput extends BaseInput {
  constructor() {
    super(...arguments);
    this._ref = null;
    this._acceptableStr = null;
  }
  onChangeAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const str = e.currentTarget.value;
      const caretPosition = e.currentTarget.selectionEnd !== null ? e.currentTarget.selectionEnd : -1;
      const parsingResult = NumberUtility.parse(str, this.allowFloat);
      const acceptableStr = parsingResult.acceptableStr !== null ? parsingResult.acceptableStr : this._acceptableStr;
      const needToRender = acceptableStr !== this._acceptableStr;
      const isNewStr = parsingResult.parsed && acceptableStr !== this.getStr();
      this._acceptableStr = acceptableStr;
      if (this.behaviour === NumberInputBehaviour.ValidationOnChange) {
        yield this.saveChangesAsync(false);
      } else if (needToRender) {
        yield this.reRenderAsync();
      }
      if (this.ref.current) {
        const newStr = this.getStr();
        let index;
        if (isNewStr) {
          const prefix = str.substr(0, caretPosition);
          index = newStr.indexOf(prefix);
          if (index !== -1) {
            index += caretPosition;
          } else {
            index = caretPosition;
          }
        } else {
          const isReplace = parsingResult.parsed && str !== acceptableStr;
          index = isReplace ? caretPosition : caretPosition - 1;
        }
        if (index !== -1) {
          this.ref.current.selectionStart = index;
          this.ref.current.selectionEnd = index;
        }
      }
    });
  }
  onInputKeyDownHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const enter = e.keyCode === 13;
      const esc = e.keyCode === 27;
      if (this.props.clickToEdit) {
        if (enter || esc) {
          e.preventDefault();
          yield this.hideEditAsync();
        }
      } else {
        if (enter) {
          yield this.saveChangesAsync();
        }
      }
    });
  }
  invokeOnChange(value, userInteraction, done) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(this, value, userInteraction, done);
      }
    });
  }
  saveChangesAsync(clearAcceptableStr = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._acceptableStr !== null) {
        const parsingResult = NumberUtility.parse(this._acceptableStr, this.allowFloat);
        if (clearAcceptableStr) {
          this._acceptableStr = null;
        }
        let updated = false;
        if (parsingResult.parsed) {
          updated = yield this.invokeSetAsync(parsingResult.value, true);
        }
        if (!updated) {
          yield this.reRenderAsync();
        }
      }
    });
  }
  invokeSetAsync(value, userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.readonly) {
        value = Utility.roundE(value);
        const acceptInvalidNumbers = this.behaviour !== NumberInputBehaviour.Restricted && userInteraction;
        if (value !== this.value && (acceptInvalidNumbers || this.canSet(value))) {
          yield this.invokeOnChange(value, userInteraction, true);
          yield this.updateValueAsync(value);
          return true;
        }
      }
      return false;
    });
  }
  getStr() {
    return this._acceptableStr !== null ? this._acceptableStr : this.str;
  }
  get ref() {
    return this._ref || (this._ref = this.props.forwardedRef || /*#__PURE__*/React.createRef());
  }
  get format() {
    const numberFormat = NumberUtility.resolveFormat(this.props.step, this.props.format);
    return numberFormat.format;
  }
  valueBlurHandlerAsync() {
    const _super = Object.create(null, {
      validateAsync: {
        get: () => super.validateAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield this.saveChangesAsync();
      yield _super.validateAsync.call(this);
      if (this.props.onBlur) {
        yield this.props.onBlur(this);
      }
    });
  }
  onShowEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this._acceptableStr = null;
      if (this.ref.current) {
        this.ref.current.focus();
        this.ref.current.select();
      }
    });
  }
  onHideEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.saveChangesAsync();
    });
  }
  parse(str) {
    return str ? Math.abs(Number(str)) : 0;
  }
  getValidators() {
    return this.behaviour !== NumberInputBehaviour.Restricted ? [NumberRangeValidator.validator(this.min, this.max)] : [];
  }
  get behaviour() {
    return this.props.clickToEdit ? NumberInputBehaviour.Restricted : this.props.behaviour || NumberInputBehaviour.ValidationOnChange;
  }
  get value() {
    return this.state.model.value || 0;
  }
  get min() {
    return this.props.min || 0;
  }
  get max() {
    return this.props.max || Number.POSITIVE_INFINITY;
  }
  get step() {
    const numberFormat = NumberUtility.resolveFormat(this.props.step, this.props.format);
    return numberFormat.step;
  }
  get canDecrease() {
    return this.canSet(this.value - this.step);
  }
  get canIncrease() {
    return this.canSet(this.value + this.step);
  }
  get increaseDisabled() {
    return !!this.props.disabled || !!this.props.disableButtonsWhenCannotChangeValue && !this.canIncrease;
  }
  get decreaseDisabled() {
    return !!this.props.disabled || !!this.props.disableButtonsWhenCannotChangeValue && !this.canDecrease;
  }
  get increaseIconProps() {
    const increaseIconProp = this.props.increaseIcon || "arrow-up";
    if (typeof increaseIconProp === "string") {
      return {
        name: increaseIconProp,
        size: IconSize.ExtraSmall
      };
    }
    return increaseIconProp;
  }
  get decreaseIconProps() {
    const decreaseIconProp = this.props.decreaseIcon || "arrow-down";
    if (typeof decreaseIconProp === "string") {
      return {
        name: decreaseIconProp,
        size: IconSize.ExtraSmall
      };
    }
    return decreaseIconProp;
  }
  get allowFloat() {
    return this.step < 1.0;
  }
  canSet(value) {
    value = Utility.roundE(value);
    return this.min <= value && value <= this.max;
  }
  setAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeSetAsync(value, false);
    });
  }
  increaseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeSetAsync(this.value + this.step, false);
    });
  }
  decreaseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeSetAsync(this.value - this.step, false);
    });
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this._acceptableStr = null;
      yield _super.initializeAsync.call(this);
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this._acceptableStr = null;
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  renderInput() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$L.numberInput
    }, /*#__PURE__*/React.createElement("input", {
      id: this.getInputId(),
      ref: this.ref,
      type: this.getType(),
      value: this.getStr(),
      readOnly: this.readonly,
      className: "form-control",
      title: this.props.title,
      placeholder: this.props.placeholder,
      onChange: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onChangeAsync(e);
      }),
      onBlur: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.valueBlurHandlerAsync();
      }),
      onKeyDown: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onInputKeyDownHandlerAsync(e);
      }),
      disabled: this.props.disabled
    }), !this.props.hideArrows && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$L.numberInputArrow, styles$L.increaseArrow, this.increaseDisabled ? styles$L.disabled : null),
      onClick: () => this.increaseDisabled || this.increaseAsync()
    }, /*#__PURE__*/React.createElement(Icon, Object.assign({}, this.increaseIconProps, {
      disabled: this.increaseDisabled
    })))), !this.props.hideArrows && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$L.numberInputArrow, styles$L.decreaseArrow, this.decreaseDisabled ? styles$L.disabled : null),
      onClick: () => this.decreaseDisabled || this.decreaseAsync()
    }, /*#__PURE__*/React.createElement(Icon, Object.assign({}, this.decreaseIconProps, {
      disabled: this.decreaseDisabled
    })))));
  }
}

//Autogenerated
class DateInputLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Initializer
  }
}
//Singleton
var DateInputLocalizer$1 = new DateInputLocalizer();

var css_248z$S = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-date-input-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-date-input-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-date-input-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-date-input-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-date-input-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-date-input-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-date-input-dateInput input:read-only {\n  background-color: white;\n}\n.athenaeum-date-input-dateInput.athenaeum-date-input-clearButton input {\n  padding-right: 1.5rem;\n}\n.athenaeum-date-input-dateInput.athenaeum-date-input-readonly input:read-only {\n  background-color: #e9ecef;\n}\n.athenaeum-date-input-dateInput.athenaeum-date-input-small input {\n  font-size: 0.8rem;\n  padding: 0.375rem;\n  height: auto;\n  width: 5rem;\n  background-color: white !important;\n}\n\n.athenaeum-date-input-clearButtonIcon {\n  position: absolute;\n  top: 5px;\n  bottom: 4px;\n  right: 5px;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-date-input-clearButtonIcon:not(:hover) {\n  opacity: 0.3;\n}\n.athenaeum-date-input-clearButtonIcon > i {\n  padding: 4px;\n  cursor: pointer;\n}";
var styles$K = {"font-renta":"athenaeum-date-input-font-renta","color-schema-renta_black":"athenaeum-date-input-color-schema-renta_black","color-schema-renta_white":"athenaeum-date-input-color-schema-renta_white","color-schema-renta_orange":"athenaeum-date-input-color-schema-renta_orange","color-schema-renta_green":"athenaeum-date-input-color-schema-renta_green","color-schema-renta_blue":"athenaeum-date-input-color-schema-renta_blue","dateInput":"athenaeum-date-input-dateInput","clearButton":"athenaeum-date-input-clearButton","readonly":"athenaeum-date-input-readonly","small":"athenaeum-date-input-small","clearButtonIcon":"athenaeum-date-input-clearButtonIcon"};
styleInject(css_248z$S);

var css_248z$R = "@charset \"UTF-8\";\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker__navigation-icon::before {\n  border-color: #ccc;\n  border-style: solid;\n  border-width: 3px 3px 0 0;\n  content: \"\";\n  display: block;\n  height: 9px;\n  position: absolute;\n  top: 6px;\n  width: 9px;\n}\n\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  margin-left: -4px;\n  position: absolute;\n  width: 0;\n}\n\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {\n  box-sizing: content-box;\n  position: absolute;\n  border: 8px solid transparent;\n  height: 0;\n  width: 1px;\n  content: \"\";\n  z-index: -1;\n  border-width: 8px;\n  left: -8px;\n}\n\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  top: 0;\n  margin-top: -8px;\n}\n\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {\n  border-top: none;\n  border-bottom-color: #f0f0f0;\n}\n\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {\n  top: 0;\n}\n\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  top: -1px;\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {\n  bottom: 0;\n  margin-bottom: -8px;\n}\n\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {\n  border-bottom: none;\n  border-top-color: #fff;\n}\n\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {\n  bottom: 0;\n}\n\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {\n  bottom: -1px;\n  border-top-color: #aeaeae;\n}\n\n.react-datepicker-wrapper {\n  display: inline-block;\n  padding: 0;\n  border: 0;\n}\n\n.react-datepicker {\n  font-family: \"Helvetica Neue\", helvetica, arial, sans-serif;\n  font-size: 0.8rem;\n  background-color: #fff;\n  color: #000;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  display: inline-block;\n  position: relative;\n}\n\n.react-datepicker--time-only .react-datepicker__triangle {\n  left: 35px;\n}\n\n.react-datepicker--time-only .react-datepicker__time-container {\n  border-left: 0;\n}\n\n.react-datepicker--time-only .react-datepicker__time,\n.react-datepicker--time-only .react-datepicker__time-box {\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__triangle {\n  position: absolute;\n  left: 50px;\n}\n\n.react-datepicker-popper {\n  z-index: 1;\n}\n\n.react-datepicker-popper[data-placement^=bottom] {\n  padding-top: 10px;\n}\n\n.react-datepicker-popper[data-placement=bottom-end] .react-datepicker__triangle, .react-datepicker-popper[data-placement=top-end] .react-datepicker__triangle {\n  left: auto;\n  right: 50px;\n}\n\n.react-datepicker-popper[data-placement^=top] {\n  padding-bottom: 10px;\n}\n\n.react-datepicker-popper[data-placement^=right] {\n  padding-left: 8px;\n}\n\n.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {\n  left: auto;\n  right: 42px;\n}\n\n.react-datepicker-popper[data-placement^=left] {\n  padding-right: 8px;\n}\n\n.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {\n  left: 42px;\n  right: auto;\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: #f0f0f0;\n  border-bottom: 1px solid #aeaeae;\n  border-top-left-radius: 0.3rem;\n  padding: 8px 0;\n  position: relative;\n}\n\n.react-datepicker__header--time {\n  padding-bottom: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.react-datepicker__header--time:not(.react-datepicker__header--time--only) {\n  border-top-left-radius: 0;\n}\n\n.react-datepicker__header:not(.react-datepicker__header--has-time-select) {\n  border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 15px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  margin-top: 0;\n  color: #000;\n  font-weight: bold;\n  font-size: 0.944rem;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  align-items: center;\n  background: none;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 2px;\n  padding: 0;\n  border: none;\n  z-index: 1;\n  height: 32px;\n  width: 32px;\n  text-indent: -999em;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation--previous {\n  left: 2px;\n}\n\n.react-datepicker__navigation--next {\n  right: 2px;\n}\n\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 85px;\n}\n\n.react-datepicker__navigation--years {\n  position: relative;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.react-datepicker__navigation--years-previous {\n  top: 4px;\n}\n\n.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n}\n\n.react-datepicker__navigation:hover *::before {\n  border-color: #a6a6a6;\n}\n\n.react-datepicker__navigation-icon {\n  position: relative;\n  top: -1px;\n  font-size: 20px;\n  width: 0;\n}\n\n.react-datepicker__navigation-icon--next {\n  left: -2px;\n}\n\n.react-datepicker__navigation-icon--next::before {\n  transform: rotate(45deg);\n  left: -7px;\n}\n\n.react-datepicker__navigation-icon--previous {\n  right: -2px;\n}\n\n.react-datepicker__navigation-icon--previous::before {\n  transform: rotate(225deg);\n  right: -7px;\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__year {\n  margin: 0.4rem;\n  text-align: center;\n}\n\n.react-datepicker__year-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 180px;\n}\n\n.react-datepicker__year .react-datepicker__year-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__month {\n  margin: 0.4rem;\n  text-align: center;\n}\n\n.react-datepicker__month .react-datepicker__month-text,\n.react-datepicker__month .react-datepicker__quarter-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__input-time-container {\n  clear: both;\n  width: 100%;\n  float: left;\n  margin: 5px 0 10px 15px;\n  text-align: left;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__caption {\n  display: inline-block;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container {\n  display: inline-block;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {\n  display: inline-block;\n  margin-left: 10px;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {\n  width: auto;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time] {\n  -moz-appearance: textfield;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {\n  margin-left: 5px;\n  display: inline-block;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid #aeaeae;\n  width: 85px;\n}\n\n.react-datepicker__time-container--with-today-button {\n  display: inline;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  position: absolute;\n  right: -87px;\n  top: 0;\n}\n\n.react-datepicker__time-container .react-datepicker__time {\n  position: relative;\n  background: white;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: 85px;\n  overflow-x: hidden;\n  margin: 0 auto;\n  text-align: center;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n  list-style: none;\n  margin: 0;\n  height: calc(195px + 0.85rem);\n  overflow-y: scroll;\n  padding-right: 0;\n  padding-left: 0;\n  width: 100%;\n  box-sizing: content-box;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  height: 30px;\n  padding: 5px 10px;\n  white-space: nowrap;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  cursor: pointer;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #216ba5;\n  color: white;\n  font-weight: bold;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #216ba5;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {\n  color: #ccc;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__week-number {\n  color: #ccc;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n  cursor: pointer;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable:not(.react-datepicker__week-number--selected,\n.react-datepicker__week-number--keyboard-selected):hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__week-number--selected {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n\n.react-datepicker__week-number--selected:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__week-number--keyboard-selected {\n  border-radius: 0.3rem;\n  background-color: #2a87d0;\n  color: #fff;\n}\n\n.react-datepicker__week-number--keyboard-selected:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day-names {\n  white-space: nowrap;\n  margin-bottom: -8px;\n}\n\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: #000;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__day,\n.react-datepicker__month-text,\n.react-datepicker__quarter-text,\n.react-datepicker__year-text {\n  cursor: pointer;\n}\n\n.react-datepicker__day:hover,\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover,\n.react-datepicker__year-text:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__day--today,\n.react-datepicker__month-text--today,\n.react-datepicker__quarter-text--today,\n.react-datepicker__year-text--today {\n  font-weight: bold;\n}\n\n.react-datepicker__day--highlighted,\n.react-datepicker__month-text--highlighted,\n.react-datepicker__quarter-text--highlighted,\n.react-datepicker__year-text--highlighted {\n  border-radius: 0.3rem;\n  background-color: #3dcc4a;\n  color: #fff;\n}\n\n.react-datepicker__day--highlighted:hover,\n.react-datepicker__month-text--highlighted:hover,\n.react-datepicker__quarter-text--highlighted:hover,\n.react-datepicker__year-text--highlighted:hover {\n  background-color: #32be3f;\n}\n\n.react-datepicker__day--highlighted-custom-1,\n.react-datepicker__month-text--highlighted-custom-1,\n.react-datepicker__quarter-text--highlighted-custom-1,\n.react-datepicker__year-text--highlighted-custom-1 {\n  color: magenta;\n}\n\n.react-datepicker__day--highlighted-custom-2,\n.react-datepicker__month-text--highlighted-custom-2,\n.react-datepicker__quarter-text--highlighted-custom-2,\n.react-datepicker__year-text--highlighted-custom-2 {\n  color: green;\n}\n\n.react-datepicker__day--holidays,\n.react-datepicker__month-text--holidays,\n.react-datepicker__quarter-text--holidays,\n.react-datepicker__year-text--holidays {\n  position: relative;\n  border-radius: 0.3rem;\n  background-color: #ff6803;\n  color: #fff;\n}\n\n.react-datepicker__day--holidays .holiday-overlay,\n.react-datepicker__month-text--holidays .holiday-overlay,\n.react-datepicker__quarter-text--holidays .holiday-overlay,\n.react-datepicker__year-text--holidays .holiday-overlay {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #333;\n  color: #fff;\n  padding: 4px;\n  border-radius: 4px;\n  white-space: nowrap;\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s, opacity 0.3s ease-in-out;\n}\n\n.react-datepicker__day--holidays:hover,\n.react-datepicker__month-text--holidays:hover,\n.react-datepicker__quarter-text--holidays:hover,\n.react-datepicker__year-text--holidays:hover {\n  background-color: #cf5300;\n}\n\n.react-datepicker__day--holidays:hover .holiday-overlay,\n.react-datepicker__month-text--holidays:hover .holiday-overlay,\n.react-datepicker__quarter-text--holidays:hover .holiday-overlay,\n.react-datepicker__year-text--holidays:hover .holiday-overlay {\n  visibility: visible;\n  opacity: 1;\n}\n\n.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n\n.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover,\n.react-datepicker__year-text--selected:hover,\n.react-datepicker__year-text--in-selecting-range:hover,\n.react-datepicker__year-text--in-range:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  border-radius: 0.3rem;\n  background-color: #bad9f1;\n  color: rgb(0, 0, 0);\n}\n\n.react-datepicker__day--keyboard-selected:hover,\n.react-datepicker__month-text--keyboard-selected:hover,\n.react-datepicker__quarter-text--keyboard-selected:hover,\n.react-datepicker__year-text--keyboard-selected:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range) {\n  background-color: rgba(33, 107, 165, 0.5);\n}\n\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range) {\n  background-color: #f0f0f0;\n  color: #000;\n}\n\n.react-datepicker__day--disabled,\n.react-datepicker__month-text--disabled,\n.react-datepicker__quarter-text--disabled,\n.react-datepicker__year-text--disabled {\n  cursor: default;\n  color: #ccc;\n}\n\n.react-datepicker__day--disabled:hover,\n.react-datepicker__month-text--disabled:hover,\n.react-datepicker__quarter-text--disabled:hover,\n.react-datepicker__year-text--disabled:hover {\n  background-color: transparent;\n}\n\n.react-datepicker__input-container {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.react-datepicker__input-container .react-datepicker__calendar-icon {\n  position: absolute;\n  padding: 0.5rem;\n  box-sizing: content-box;\n}\n\n.react-datepicker__view-calendar-icon input {\n  padding: 6px 10px 5px 25px;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: 0.3rem;\n  position: relative;\n}\n\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n  cursor: pointer;\n}\n\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  transform: rotate(135deg);\n  right: -16px;\n  top: 0;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: #f0f0f0;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.3rem;\n  border: 1px solid #aeaeae;\n}\n\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n  cursor: pointer;\n}\n\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n  height: 150px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: #ccc;\n}\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: #b3b3b3;\n}\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n  position: absolute;\n  left: 15px;\n}\n\n.react-datepicker__close-icon {\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n  padding: 0 6px 0 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.react-datepicker__close-icon::after {\n  cursor: pointer;\n  background-color: #216ba5;\n  color: #fff;\n  border-radius: 50%;\n  height: 16px;\n  width: 16px;\n  padding: 2px;\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  display: table-cell;\n  vertical-align: middle;\n  content: \"×\";\n}\n\n.react-datepicker__close-icon--disabled {\n  cursor: default;\n}\n\n.react-datepicker__close-icon--disabled::after {\n  cursor: default;\n  background-color: #ccc;\n}\n\n.react-datepicker__today-button {\n  background: #f0f0f0;\n  border-top: 1px solid #aeaeae;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.8);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  z-index: 2147483647;\n}\n\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n  width: 3rem;\n  line-height: 3rem;\n}\n\n@media (max-width: 400px), (max-height: 550px) {\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 2rem;\n    line-height: 2rem;\n  }\n}\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n  font-size: 1.44rem;\n}\n\n.react-datepicker__children-container {\n  width: 13.8rem;\n  margin: 0.4rem;\n  padding-right: 0.2rem;\n  padding-left: 0.2rem;\n  height: auto;\n}\n\n.react-datepicker__aria-live {\n  position: absolute;\n  clip-path: circle(0);\n  border: 0;\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  width: 1px;\n  white-space: nowrap;\n}\n\n.react-datepicker__calendar-icon {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.125em;\n}\n\n/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.dateInputContainer {\n  padding: 10px 0 12px 0;\n}\n\n.dateInputWidget, .datepicker.renta {\n  background-color: rgb(254, 80, 0);\n  border-color: white;\n}\n.dateInputWidget .react-datepicker__triangle, .datepicker.renta .react-datepicker__triangle {\n  border-bottom-color: #e04716;\n}\n.dateInputWidget .react-datepicker__navigation.react-datepicker__navigation--previous, .datepicker.renta .react-datepicker__navigation.react-datepicker__navigation--previous {\n  border-right-color: white;\n}\n.dateInputWidget .react-datepicker__navigation.react-datepicker__navigation--next, .datepicker.renta .react-datepicker__navigation.react-datepicker__navigation--next {\n  border-left-color: white;\n}\n.dateInputWidget .react-datepicker__header, .datepicker.renta .react-datepicker__header {\n  background-color: #e04716;\n  border-color: white;\n}\n.dateInputWidget .react-datepicker__header .react-datepicker__current-month, .datepicker.renta .react-datepicker__header .react-datepicker__current-month {\n  color: white;\n}\n.dateInputWidget .react-datepicker__header .react-datepicker__day-name, .datepicker.renta .react-datepicker__header .react-datepicker__day-name {\n  color: white;\n}\n.dateInputWidget .react-datepicker__header .react-datepicker-time__header, .datepicker.renta .react-datepicker__header .react-datepicker-time__header {\n  color: white;\n}\n.dateInputWidget .react-datepicker__day, .datepicker.renta .react-datepicker__day {\n  color: white;\n}\n.dateInputWidget .react-datepicker__day:hover, .datepicker.renta .react-datepicker__day:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.dateInputWidget .react-datepicker__day--today, .datepicker.renta .react-datepicker__day--today {\n  border: 1px solid white;\n  border-radius: 50%;\n  height: 1.7rem;\n}\n.dateInputWidget .react-datepicker__day--selected, .datepicker.renta .react-datepicker__day--selected {\n  background-color: #337ab7;\n}\n.dateInputWidget .react-datepicker__today-button, .datepicker.renta .react-datepicker__today-button {\n  background-color: #e04716;\n  color: white;\n  border-top-color: white;\n}\n.dateInputWidget .react-datepicker__day--disabled, .datepicker.renta .react-datepicker__day--disabled {\n  color: #ccc;\n}\n.dateInputWidget .react-datepicker__day--disabled:hover, .datepicker.renta .react-datepicker__day--disabled:hover {\n  background-color: transparent !important;\n}\n\n.datepicker .react-datepicker__day--selected {\n  background-color: rgb(254, 80, 0);\n}\n\n.datepicker.renta .react-datepicker__day--disabled {\n  color: #ccc;\n}\n.datepicker.renta .react-datepicker__day--disabled:hover {\n  background-color: transparent !important;\n}\n\n.react-datepicker-wrapper {\n  width: 100%;\n}\n.react-datepicker-wrapper .react-datepicker__input-container {\n  width: 100%;\n}\n\n.react-datepicker {\n  font-size: 1em;\n}\n\n.react-datepicker__header {\n  padding-top: 0.8em;\n}\n\n.react-datepicker-time__header {\n  font-size: 1em;\n}\n\n.react-datepicker__month {\n  margin: 0.4em 1em;\n}\n\n.react-datepicker__day-name, .react-datepicker__day {\n  width: 1.9em;\n  line-height: 1.9em;\n  margin: 0.166em;\n}\n\n.react-datepicker__current-month {\n  font-size: 1em;\n}\n\n.react-datepicker__navigation {\n  top: 1em;\n  line-height: 1.7em;\n  border: 0.45em solid transparent;\n}\n\n.react-datepicker__navigation--previous {\n  border-right-color: #ccc;\n  left: 1em;\n}\n\n.react-datepicker__navigation--next {\n  border-left-color: #ccc;\n  right: 1em;\n}";
styleInject(css_248z$R);

const DatePicker = DatePickerLibrary.default.default || DatePickerLibrary.default || DatePickerLibrary;
registerLocale("fi", fi);
registerLocale("en", en);
registerLocale("pl", pl);
registerLocale("da", da);
registerLocale("sv", sv);
registerLocale("nb", nb);
setDefaultLocale("fi");
class DateInput extends BaseInput {
  get todayButton() {
    return this.props.todayButton || "";
  }
  get calendarClassName() {
    const calendarStyle = this.props.rentaStyle ? "renta" : "";
    return this.props.calendarClassName || calendarStyle;
  }
  handleChangeAsync(date) {
    const _super = Object.create(null, {
      hideEditAsync: {
        get: () => super.hideEditAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield this.updateValueAsync(date);
      if (this.props.clickToEdit) {
        yield _super.hideEditAsync.call(this);
      }
      if (this.props.onChange) {
        yield this.props.onChange(this.state.model.value);
      }
    });
  }
  handleRawChange(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.preventDefault();
    });
  }
  get selected() {
    return this.state.model.value != null ? new Date(this.state.model.value) : null;
  }
  renderCustomInput() {
    return this.props.customInput ? this.props.customInput(this) : null;
  }
  get format() {
    let format = this.props.showMonthYearPicker ? this.props.shortDate ? "MM.yy" : "MM.yyyy" : this.props.shortDate ? "dd.MM.yy" : "dd.MM.yyyy";
    if (this.props.showTime) {
      format = "dd.MM.yyyy H:mm";
    }
    if (this.props.showOnlyTime) {
      format = "H:mm";
    }
    return this.props.format || format;
  }
  valueBlurHandlerAsync() {
    const _super = Object.create(null, {
      validateAsync: {
        get: () => super.validateAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.validateAsync.call(this);
      if (this.props.onBlur) {
        yield this.props.onBlur(this);
      }
    });
  }
  onLabelClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.preventDefault();
    });
  }
  get clearButton() {
    return this.props.clearButton === true;
  }
  clearAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const model = this.state.model;
      model.value = null;
      yield this.setState({
        model
      });
      if (this.props.onChange) {
        yield this.props.onChange(this.state.model.value);
      }
    });
  }
  clear() {
    // no await needed
    // noinspection JSIgnoredPromiseFromCall
    this.clearAsync();
  }
  renderValue() {
    const strValue = this.state.model.value != null ? Utility.toDateString(this.state.model.value) : "";
    return /*#__PURE__*/React.createElement("span", {
      className: styles$16.value
    }, strValue);
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      //super
      yield _super.componentDidMount.call(this);
      //set input as readonly to avoid auto complete
      this.JQuery(`#${this.getInputId()}`).prop("readonly", true);
    });
  }
  renderInput() {
    const clearButton = this.clearButton && !!this.state.model.value;
    const smallStyle = this.props.small && styles$K.small;
    const readonlyStyle = this.readonly && styles$K.readonly;
    const clearButtonStyle = clearButton && styles$K.clearButton;
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$K.dateInput, smallStyle, readonlyStyle, clearButtonStyle, this.props.className)
    }, /*#__PURE__*/React.createElement(DatePicker, {
      id: this.getInputId(),
      ref: this.props.forwardedRef,
      className: "form-control",
      title: DateInputLocalizer$1.get(this.props.title),
      placeholderText: this.props.placeholder || undefined,
      dateFormat: this.format,
      timeFormat: this.props.timeFormat || undefined,
      minDate: this.props.minDate,
      maxDate: this.props.maxDate,
      minTime: this.props.minTime || undefined,
      maxTime: this.props.maxTime || undefined,
      selected: this.selected,
      calendarClassName: this.css("datepicker", this.calendarClassName),
      todayButton: this.todayButton,
      inline: this.props.expanded,
      withPortal: this.props.popup,
      showMonthDropdown: this.props.showMonthDropdown,
      showMonthYearPicker: this.props.showMonthYearPicker,
      showYearDropdown: this.props.showYearDropdown,
      showMonthYearDropdown: this.props.showMonthYearDropdown,
      locale: DateInputLocalizer$1.language,
      readOnly: this.readonly,
      customInput: this.renderCustomInput(),
      showTimeSelect: this.props.showTime,
      showTimeSelectOnly: this.props.showOnlyTime,
      timeCaption: this.props.timeCaption || undefined,
      timeIntervals: this.props.timeIntervals,
      onChange: date => __awaiter(this, void 0, void 0, function* () {
        return yield this.handleChangeAsync(date);
      }),
      onChangeRaw: e => this.handleRawChange(e),
      onBlur: () => this.valueBlurHandlerAsync(),
      filterDate: this.props.filterDate
    }), clearButton && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$K.clearButtonIcon)
    }, /*#__PURE__*/React.createElement(Icon, {
      stopPropagation: true,
      name: "fa fa-times",
      size: IconSize.Normal,
      onClick: () => this.clearAsync()
    }))));
  }
}

//Autogenerated
class GridLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Initializer
  }
}
//Singleton
var GridLocalizer$1 = new GridLocalizer();

class Cell extends BaseComponent {
  constructor() {
    super(...arguments);
    this._inputRef = /*#__PURE__*/React.createRef();
  }
  findValueByGridAccessor(model, accessor = null) {
    return accessor ? typeof accessor === "function" ? accessor(model) : Utility.findValueByAccessor(model, accessor) : null;
  }
  invokeCallback(cell, info = false) {
    return __awaiter(this, void 0, void 0, function* () {
      const column = cell.column;
      if (!cell.isReadonly && column.callback) {
        yield column.callback(cell, null);
      }
      if (cell.route) {
        yield PageRouteProvider.redirectAsync(cell.route);
      }
      if (info && cell.infoRoute) {
        yield PageRouteProvider.redirectAsync(cell.infoRoute);
      }
    });
  }
  processNewValueAsync(cell, value, userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      const modified = cell.setValue(value);
      if (userInteraction) {
        yield this.invokeCallback(cell);
      }
      if (modified || cell.column.reRenderRow) {
        yield cell.row.reRenderAsync();
      } else {
        yield this.reRenderAsync();
      }
    });
  }
  onPlaceSelectedAsync(cell, location) {
    return __awaiter(this, void 0, void 0, function* () {
      const value = location.formattedAddress;
      yield this.processNewValueAsync(cell, value, true);
    });
  }
  onTextCellChangeAsync(cell, value, userInteraction, done) {
    return __awaiter(this, void 0, void 0, function* () {
      if (done) {
        yield this.processNewValueAsync(cell, value, userInteraction);
      }
    });
  }
  onEnumCellChangeAsync(cell, item, userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      const value = parseInt(item.value);
      yield this.processNewValueAsync(cell, value, userInteraction);
    });
  }
  onNumberCellChangeAsync(cell, value, userInteraction, done) {
    return __awaiter(this, void 0, void 0, function* () {
      if (done) {
        yield this.processNewValueAsync(cell, value, userInteraction);
      }
    });
  }
  onBooleanCellChangeAsync(cell, value) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.processNewValueAsync(cell, value, true);
    });
  }
  onDateCellChangeAsync(cell, value) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.processNewValueAsync(cell, value, true);
    });
  }
  renderDefaultCellContent(cell, settings, cellValue) {
    const hasInfo = !!settings.infoAccessor;
    let infoValue = "";
    if (hasInfo) {
      infoValue = this.findValueByGridAccessor(cell.model, settings.infoAccessor);
      const infoFormat = cell.column.settings.infoFormat != null ? cell.column.settings.infoFormat : cell.column.format;
      infoValue = settings.hideZero && !infoValue ? "" : cell.column.settings && cell.column.settings.infoTransform ? cell.column.settings.infoTransform(cell, infoValue, infoFormat) : Utility.formatValue(infoValue, infoFormat);
      const hideInfo = hasInfo && (settings.infoHideZero && !infoValue || settings.infoHideEqual && infoValue == cellValue);
      if (hideInfo) {
        infoValue = "";
      }
    }
    const hasValue = !!cellValue;
    // noinspection SuspiciousTypeOfGuard
    let hasInfoValue = !!infoValue && typeof infoValue === "string";
    if (!hasValue && hasInfoValue) {
      cellValue = infoValue;
      infoValue = "";
      //hasValue = true;
      hasInfoValue = false;
    }
    const overflowX = !!cell.column.maxWidth;
    const overflowY = !!cell.column.maxHeight;
    const overflow = overflowX || overflowY;
    const inlineStyles = {
      textAlign: StylesUtility.textAlign(cell.column.textAlign)
    };
    let title = cell.title;
    if (overflow) {
      inlineStyles.textOverflow = "ellipsis";
      if (overflowX) {
        inlineStyles.overflowX = "hidden";
      }
      if (overflowY) {
        inlineStyles.overflowY = "hidden";
      }
      if (!title) {
        title = cellValue;
      }
    }
    let infoTitle = "";
    if (hasInfoValue) {
      infoTitle = settings.infoTitle || "";
      if (overflow) {
        if (!infoTitle) {
          infoTitle = infoValue;
        }
      }
    }
    const linkStyle = cell.route && styles$Q.link || "";
    const infoLinkStyle = (cell.route || cell.infoRoute) && styles$Q.link || "";
    const valueBoldStyle = hasInfoValue && settings.infoBoldNotEqual && infoValue != cellValue && styles$Q.bold || "";
    const infoValueBold = hasInfoValue && settings.infoBold && styles$Q.bold || "";
    return hasInfoValue ? ( /*#__PURE__*/React.createElement("div", {
      className: styles$Q.twoLines
    }, /*#__PURE__*/React.createElement("span", {
      className: this.css(linkStyle, valueBoldStyle),
      style: inlineStyles,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.invokeCallback(cell);
      }),
      title: GridLocalizer$1.get(title)
    }, ReactUtility.toMultiLines(cellValue)), /*#__PURE__*/React.createElement("span", {
      style: inlineStyles,
      className: this.css(infoLinkStyle, infoValueBold),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.invokeCallback(cell, true);
      }),
      title: GridLocalizer$1.get(infoTitle)
    }, ReactUtility.toMultiLines(infoValue)))) : ( /*#__PURE__*/React.createElement("span", {
      className: this.css(infoLinkStyle),
      style: inlineStyles,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.invokeCallback(cell, true);
      }),
      title: GridLocalizer$1.get(title)
    }, ReactUtility.toMultiLines(cellValue)));
  }
  renderTextCellContent(cell, settings, cellValue) {
    const noWrapStyle = cell.column.noWrap && styles$Q.noWrap;
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$Q.textContainer)
    }, /*#__PURE__*/React.createElement(TextInput, {
      clickToEdit: true,
      ref: this._inputRef,
      className: this.css(styles$Q.textInput, noWrapStyle),
      value: cellValue || "",
      title: cell.title,
      maxLength: settings.maxLength || undefined,
      onChange: (sender, value, userInteraction, done) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onTextCellChangeAsync(cell, value, userInteraction, done);
      })
    }));
  }
  renderAddressCellContent(cell, settings, cellValue) {
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$Q.textContainer)
    }, /*#__PURE__*/React.createElement(AddressInput, {
      clickToEdit: true,
      className: this.css(styles$Q.addressInput),
      value: cellValue || "",
      locationPicker: settings.locationPicker,
      append: settings.locationPicker,
      onChange: location => this.onPlaceSelectedAsync(cell, location)
    }));
  }
  renderIconCellContent(cell, cellValue) {
    const icon = GridTransformer.toIcon(cellValue);
    const size = icon != null ? icon.size || IconSize.Large : undefined;
    const alignCenter = cell.column.textAlign == TextAlign.Center && styles$Q.center;
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(alignCenter),
      title: cell.title
    }, icon && ( /*#__PURE__*/React.createElement(Icon, Object.assign({}, icon, {
      size: size
    }))));
  }
  renderBooleanCellContent(cell, cellValue) {
    const name = `grid_${cell.grid.id}_${cell.rowIndex}_${cell.columnIndex}_input`;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/label-has-associated-control
      React.createElement("label", {
        htmlFor: name,
        title: cell.title
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: name,
        checked: cellValue,
        onChange: e => __awaiter(this, void 0, void 0, function* () {
          return yield this.onBooleanCellChangeAsync(cell, e.target.checked);
        })
      }))
    );
  }
  renderNumberCellContent(cell, settings, cellValue) {
    let hasInfo = !!settings.infoAccessor;
    let infoValue = hasInfo ? this.findValueByGridAccessor(cell.model, settings.infoAccessor) : null;
    const hideInfo = hasInfo && (settings.infoHideZero && !infoValue || settings.infoHideEqual && infoValue == cellValue);
    if (hideInfo) {
      hasInfo = false;
    }
    cellValue = settings.hideZero ? cellValue || 0 : cellValue;
    infoValue = settings.infoHideZero ? infoValue || 0 : infoValue;
    const hasInfoValue = infoValue != null;
    const hideZeroStyle = settings.hideZero && infoValue == 0 && cellValue == 0 && styles$Q.hideZero || "";
    const numberInfoStyle = hasInfo && styles$Q.numberInfo || "";
    const valueBoldStyle = hasInfoValue && settings.infoBoldNotEqual && infoValue != cellValue && styles$Q.bold || "";
    const withArrowsStyle = settings.arrows && styles$Q.withArrows || "";
    const min = typeof settings.min === "number" ? settings.min : null;
    const max = typeof settings.max === "number" ? settings.max : null;
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$Q.numberContainer, numberInfoStyle)
    }, hasInfo && ( /*#__PURE__*/React.createElement("span", {
      className: this.css(hideZeroStyle),
      title: GridLocalizer$1.get(settings.infoTitle)
    }, Utility.formatValue(infoValue || 0, cell.column.format))), /*#__PURE__*/React.createElement(NumberInput, {
      clickToEdit: true,
      title: GridLocalizer$1.get(cell.title),
      hideArrows: !settings.arrows,
      className: this.css(styles$Q.numberInput, hideZeroStyle, valueBoldStyle, withArrowsStyle),
      format: cell.column.format || undefined,
      min: min || undefined,
      max: max || undefined,
      step: settings.step || undefined,
      value: cellValue || 0,
      onChange: (sender, value, userInteraction, done) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onNumberCellChangeAsync(cell, value, userInteraction, done);
      })
    }));
  }
  renderDateCellContent(cell, settings, cellValue) {
    let hasInfo = !!settings.infoAccessor;
    let infoValue = hasInfo ? this.findValueByGridAccessor(cell.model, settings.infoAccessor) : null;
    const hideInfo = hasInfo && (settings.infoHideZero && !infoValue || settings.infoHideEqual && Comparator.isEqual(infoValue, cellValue));
    if (hideInfo) {
      hasInfo = false;
    }
    if (Utility.isDateType(infoValue)) {
      infoValue = Utility.formatValue(infoValue, cell.column.format);
    }
    const minDate = typeof settings.min !== "number" ? settings.min : null;
    const maxDate = typeof settings.max !== "number" ? settings.max : null;
    const shortDate = cell.column.format === "d" || cell.column.format === "MM.yy" || cell.column.format === "dd.MM.yy";
    const shortDateStyle = shortDate && styles$Q.shortDate || "";
    return hasInfo && infoValue ? ( /*#__PURE__*/React.createElement("div", {
      className: styles$Q.twoLines
    }, /*#__PURE__*/React.createElement(DateInput, {
      className: this.css(shortDateStyle),
      title: cell.title,
      shortDate: shortDate,
      minDate: minDate,
      maxDate: maxDate,
      value: cellValue,
      onChange: date => __awaiter(this, void 0, void 0, function* () {
        return yield this.onDateCellChangeAsync(cell, date);
      })
    }), /*#__PURE__*/React.createElement("span", {
      title: GridLocalizer$1.get(settings.infoTitle)
    }, infoValue))) : ( /*#__PURE__*/React.createElement(DateInput, {
      className: this.css(shortDateStyle),
      title: cell.title,
      shortDate: shortDate,
      minDate: minDate,
      maxDate: maxDate,
      value: cellValue,
      onChange: date => __awaiter(this, void 0, void 0, function* () {
        return yield this.onDateCellChangeAsync(cell, date);
      })
    }));
  }
  renderEnumCellContent(cell, cellValue, enumName) {
    const enumProvider = ServiceProvider.getRequiredService("IEnumProvider");
    return /*#__PURE__*/React.createElement(Dropdown, {
      required: true,
      noSubtext: true,
      noWrap: true,
      className: styles$Q.dropdown,
      orderBy: DropdownOrderBy.None,
      verticalAlign: DropdownVerticalAlign.Auto,
      align: DropdownAlign.Left,
      noFilter: cell.column.settings.noFilter,
      items: enumProvider.getEnumItems(enumName),
      selectedItem: enumProvider.getEnumItem(enumName, cellValue),
      onChange: (sender, item, userInteraction) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onEnumCellChangeAsync(cell, item, userInteraction);
      })
    });
  }
  renderDropdownCellContent(cell) {
    return /*#__PURE__*/React.createElement(DropdownCell, {
      cell: cell
    });
  }
  renderAction(cell, action, cellAction, index) {
    if (action.render) {
      return action.render(cell, cellAction);
    }
    return /*#__PURE__*/React.createElement(CellActionComponent, {
      key: index,
      cell: cell,
      cellAction: cellAction
    });
  }
  renderActions(cell) {
    const cellActions = cell.actions;
    return cellActions.length > 0 ? ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$Q.actions)
    }, cellActions.map((cellAction, index) => this.renderAction(cell, cellAction.action, cellAction, index)))) : null;
  }
  get cellPaddingClassName() {
    const cellPadding = this.grid.cellPadding;
    switch (cellPadding) {
      case CellPaddingType.Small:
        return styles$Q.paddingSmall;
      case CellPaddingType.Medium:
        return styles$Q.paddingMedium;
      default:
        return styles$Q.paddingLarge;
    }
  }
  get cell() {
    return this.props.cell;
  }
  get column() {
    return this.cell.column;
  }
  get grid() {
    return this.column.grid;
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      this.props.cell.inputContentInstance = this._inputRef.current;
    });
  }
  render() {
    const cell = this.props.cell;
    const row = cell.row;
    const column = cell.column;
    const settings = column.settings;
    cell.instance = this;
    let cellContent = null;
    let cellValue = null;
    let cellStyle = "";
    let editable = cell.editable;
    const accessor = cell.accessor;
    if (accessor) {
      cellValue = typeof accessor === "string" ? accessor === "#" ? cell.row.position : Utility.findValueByAccessor(cell.model, accessor) : accessor(cell.model);
      cell.value = cellValue;
    }
    cell.route = null;
    if (column.route) {
      if (typeof column.route === "function") {
        const routeCallback = column.route;
        cell.route = routeCallback(cell);
      } else {
        cell.route = column.route;
      }
    }
    cell.infoRoute = null;
    if (column.settings.infoRoute) {
      if (typeof column.settings.infoRoute === "function") {
        const infoRouteCallback = column.settings.infoRoute;
        cell.infoRoute = infoRouteCallback(cell);
      } else {
        cell.infoRoute = column.settings.infoRoute;
      }
    }
    if (column.init) {
      column.init(cell);
    }
    const format = column.format;
    const readonly = cell.isReadonly;
    const deleted = cell.isDeleted;
    const visible = cell.visible;
    const type = cell.type;
    if (column.render) {
      cellContent = column.render(cell);
    } else if (accessor) {
      let rendered = false;
      if (type == ColumnType.Icon) {
        cellStyle = styles$Q.defaultCell;
        cellContent = this.renderIconCellContent(cell, cellValue);
        rendered = true;
        editable = true;
      }
      if (!readonly && !deleted) {
        switch (type) {
          case ColumnType.Enum:
            {
              if (!format) throw Error("Wrong grid declaration. Format property in column definition should contain enum type name for enum cell!");
              cellStyle = styles$Q.enumCell;
              const enumName = format;
              cellContent = this.renderEnumCellContent(cell, cellValue, enumName);
              rendered = true;
              editable = true;
              break;
            }
          case ColumnType.Dropdown:
            cellStyle = styles$Q.enumCell;
            cellContent = this.renderDropdownCellContent(cell);
            rendered = true;
            editable = true;
            break;
          case ColumnType.Text:
            cellStyle = styles$Q.textCell;
            cellContent = this.renderTextCellContent(cell, settings, cellValue);
            rendered = true;
            editable = true;
            break;
          case ColumnType.Number:
            cellStyle = styles$Q.numberCell;
            cellContent = this.renderNumberCellContent(cell, settings, cellValue);
            rendered = true;
            editable = true;
            break;
          case ColumnType.Date:
            cellStyle = styles$Q.dateCell;
            cellContent = this.renderDateCellContent(cell, settings, cellValue);
            rendered = true;
            editable = true;
            break;
          case ColumnType.Boolean:
            cellStyle = styles$Q.booleanCell;
            cellContent = this.renderBooleanCellContent(cell, cellValue);
            rendered = true;
            editable = true;
            break;
          case ColumnType.Address:
            cellStyle = styles$Q.textCell;
            cellContent = this.renderAddressCellContent(cell, settings, cellValue);
            rendered = true;
            editable = true;
            break;
        }
      }
      if (!rendered) {
        cellValue = settings.hideZero && !cellValue ? "" : column.transform ? column.transform(cell, cellValue, format) : Utility.formatValue(cellValue, format);
        cellContent = this.renderDefaultCellContent(cell, settings, cellValue);
        cellStyle = styles$Q.defaultCell;
      }
    }
    const inlineStyles = {
      maxWidth: column.maxWidth || undefined,
      maxHeight: column.maxHeight || undefined
    };
    let noWrapClass = null;
    let wordBreakClass = null;
    if (column.noWrap) {
      inlineStyles.whiteSpace = "nowrap";
      noWrapClass = styles$Q.noWrap;
    }
    if (column.wordBreak) {
      inlineStyles.wordBreak = "break-word";
      wordBreakClass = styles$Q.wordBreak;
    }
    const rowSpan = cell.calcRowSpan();
    const rowSpanStyle = rowSpan && styles$Q.rowSpan;
    const noActionsStyle = !deleted && cell.actions.filter(action => action.visible).length === 0 && styles$Q.noActions;
    const notValidStyle = editable && !readonly && !cell.valid && styles$Q.notValid;
    const cellHoveringStyle = (cell.grid.hovering === GridHoveringType.Cell || cell.grid.hovering === GridHoveringType.EditableCell && editable && visible && !readonly && !deleted) && styles$Q.cellHovering;
    const checkedStyle = row.checked && styles$Q.checked;
    const selectedStyle = row.selected && styles$Q.selected;
    const deletedStyle = deleted && styles$Q.deleted;
    const deletedFirstCellStyle = deleted && (cell.isFirstColumn || !cell.prev.isDeleted || !cell.prev.equalRowSpan(cell)) && styles$Q.firstColumn || "";
    const deletedLastCellStyle = deleted && (cell.isLastColumn || !cell.next.isDeleted || !cell.next.equalRowSpan(cell)) && styles$Q.lastColumn || "";
    return !cell.spanned && ( /*#__PURE__*/React.createElement("td", {
      id: this.id,
      className: this.css(rowSpanStyle, column.className, cell.className, cellHoveringStyle, notValidStyle, deletedStyle, deletedFirstCellStyle, deletedLastCellStyle, this.cellPaddingClassName, noWrapClass, wordBreakClass, checkedStyle, selectedStyle),
      style: inlineStyles,
      rowSpan: rowSpan || undefined,
      colSpan: this.props.colSpan,
      onClick: () => {
        var _a, _b;
        return (_b = (_a = this.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, cell);
      }
    }, visible && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$Q.cell, cellStyle, noActionsStyle, notValidStyle)
    }, cellContent || this.props.children, this.renderActions(cell)))));
  }
}

class CheckHeaderCell extends BaseComponent {
  get model() {
    return this.props.model;
  }
  onCheckAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const model = this.model;
      const newChecked = model.checked === false;
      model.rows.forEach(row => {
        if (row.checkable) {
          row.checked = newChecked;
        }
      });
      model.checked = newChecked;
      yield model.reRenderAsync();
      if (model.onCheck) {
        yield model.onCheck(model);
      }
    });
  }
  render() {
    const model = this.model;
    model.checkHeaderInstance = this;
    const checked = model.checked !== false;
    const partiallyStyle = model.checked === undefined && styles$Q.partially;
    const rowSpan = this.props.hasHeaderGroups ? 2 : undefined;
    const colSpan = this.props.colSpanLeft ? 2 : undefined;
    return /*#__PURE__*/React.createElement("th", {
      rowSpan: rowSpan,
      colSpan: colSpan,
      className: this.css(styles$Q.th, styles$Q.check, partiallyStyle),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return this.onCheckAsync();
      })
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: checked,
      onChange: () => {}
    }));
  }
}

class HeaderCell extends BaseComponent {
  sortAsync(column) {
    return __awaiter(this, void 0, void 0, function* () {
      const grid = column.grid;
      grid.sortColumn = column;
      grid.sortDirection = grid.sortColumn == column ? grid.sortDirection == SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc : column.sorting == SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc;
      yield grid.reloadAsync();
    });
  }
  render() {
    var _a, _b;
    const column = this.props.column;
    const top = this.props.top;
    const grid = column.grid;
    const columnIndex = column.index;
    let render = true;
    let header;
    let rowSpan = undefined;
    let colSpan = undefined;
    let textAlign = column.textAlign || TextAlign.Left;
    let verticalAlign = VerticalAlign.Middle;
    if (column.group) {
      header = top ? column.group : column.header;
      if (top) {
        textAlign = TextAlign.Center;
        if (columnIndex > 0 && grid.columns[columnIndex - 1].group === column.group) {
          render = false;
        } else {
          colSpan = 0;
          for (let i = columnIndex; i < grid.columns.length; i++) {
            const nextColumn = grid.columns[i];
            if (nextColumn.group === column.group) {
              if (nextColumn.isVisible) {
                colSpan++;
              }
            } else {
              break;
            }
          }
        }
      }
    } else {
      textAlign = column.textAlign || textAlign;
      verticalAlign = column.verticalAlign || verticalAlign;
      if (top) {
        header = column.header;
        rowSpan = this.props.hasHeaderGroups ? 2 : undefined;
      } else {
        render = false;
      }
    }
    const groupHeaderCell = top && colSpan != null && colSpan > 1;
    const sortable = !groupHeaderCell && column.sortable;
    const sticky = !!this.props.stickyHeader;
    const version2Styles = !!this.props.version2Styles;
    const sortDirection = sortable && grid.sortColumn == column ? grid.sortDirection : null;
    //  to prevent sticky Header from going under top navbar.
    const navbarDefaultHeight = '45px';
    const topCssProperty = `calc(var(--app-navbar-height, ${navbarDefaultHeight}) + ${(((_b = (_a = this.props.tableHeadFirstRowRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.clientHeight) || 0) * (this.props.tableHeadRowIndex || 0)}px)`;
    const inlineStyles = Object.assign({
      textAlign: StylesUtility.textAlign(textAlign),
      verticalAlign: StylesUtility.verticalAlign(verticalAlign),
      height: !top && grid.headerMinHeight ? `${grid.headerMinHeight}px` : undefined,
      minWidth: column.minWidth || undefined
    }, this.props.stickyHeader ? {
      top: topCssProperty
    } : {});
    if (column.stretch) {
      inlineStyles.width = "100%";
    }
    const isRotated = column.rotate && (!top || !column.group);
    const icon = column.type === ColumnType.Icon ? GridTransformer.toIcon(header, true) : null;
    if (render) {
      column.headerCellInstance = this;
    }
    if (this.props.colSpanLeft) {
      colSpan = (colSpan || 1) + 1;
    }
    return render && ( /*#__PURE__*/React.createElement("th", {
      id: this.id,
      style: inlineStyles,
      rowSpan: rowSpan || undefined,
      colSpan: colSpan || undefined,
      "data-sortable": String(sortable),
      "data-sticky": String(sticky),
      "data-sort-direction": String(sortDirection),
      "data-v2-styles": String(version2Styles),
      "data-is-rotated": isRotated,
      className: styles$Q.th,
      onClick: () => sortable && this.sortAsync(column)
    }, /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$Q.headerContent)
    }, icon ? ( /*#__PURE__*/React.createElement(Icon, Object.assign({}, icon, {
      size: IconSize.Large
    }))) : ( /*#__PURE__*/React.createElement("span", null, this.toMultiLines(GridLocalizer$1.get(header)) || this.props.children)), sortable && this.props.version2Styles && ( /*#__PURE__*/React.createElement("div", {
      className: styles$Q.sortIcons
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "chevron-down",
      size: IconSize.Large
    }), /*#__PURE__*/React.createElement(Icon, {
      name: "chevron-up",
      size: IconSize.Large
    }))))));
  }
}

class GridSpinner extends BaseComponent {
  hasSpinner() {
    return true;
  }
  render() {
    return this.isSpinning() ? /*#__PURE__*/React.createElement(Spinner, null) : null;
  }
}

class CollapsedRow extends BaseComponent {
  get grid() {
    return this.props.grid;
  }
  get row() {
    return this.props.row;
  }
  get cells() {
    return this.props.cells;
  }
  renderCell(cell) {
    const column = cell.column;
    const hasHeader = !!column.group || !!column.header;
    return /*#__PURE__*/React.createElement("tr", {
      key: cell.key
    }, hasHeader && ( /*#__PURE__*/React.createElement("td", null, column.group && ( /*#__PURE__*/React.createElement("span", null, this.toMultiLines(GridLocalizer$1.get(column.group)))), column.header && ( /*#__PURE__*/React.createElement("span", null, this.toMultiLines(GridLocalizer$1.get(column.header)))))), /*#__PURE__*/React.createElement(Cell, {
      key: cell.key,
      cell: cell,
      colSpan: hasHeader ? 1 : 2
    }));
  }
  render() {
    const grid = this.grid;
    const row = this.row;
    const cells = this.cells;
    const className = grid.responsiveRowClassName;
    const collapsedCells = grid.responsive ? row.cells.where(item => item.column.collapsed) : [];
    if (collapsedCells.length == 0 || !row.responsiveContainerExpanded) {
      return null;
    }
    return /*#__PURE__*/React.createElement("tr", {
      className: this.css(styles$Q.collapsedRow, className)
    }, /*#__PURE__*/React.createElement("td", {
      colSpan: cells.length + 1
    }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, collapsedCells.map(cell => this.renderCell(cell))))));
  }
}

class Row extends BaseComponent {
  onSelectAsync(cell) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function* () {
      if (this.model.selectable && cell.isSelectable) {
        if (this.grid.selectableType == GridSelectableType.Single) {
          if (!this.model.selected) {
            const selectedRow = this.grid.selectedRow;
            this.model.selected = true;
            if (selectedRow != null) {
              selectedRow.selected = false;
              yield selectedRow.reRenderAsync();
            }
            yield this.reRenderAsync();
            yield (_b = (_a = this.props).onSelect) === null || _b === void 0 ? void 0 : _b.call(_a, this.model);
          }
        } else {
          this.model.selected = !this.model.selected;
          yield this.reRenderAsync();
          yield (_d = (_c = this.props).onSelect) === null || _d === void 0 ? void 0 : _d.call(_c, this.model);
        }
      }
    });
  }
  onCheckAsync(e) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
      if (this.model.checkable) {
        this.model.checked = !this.model.checked;
        yield this.reRenderAsync();
        yield (_b = (_a = this.props).onCheck) === null || _b === void 0 ? void 0 : _b.call(_a, this.model);
      }
      e.preventDefault();
    });
  }
  onToggleAsync(row) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
      row.responsiveContainerExpanded = !row.responsiveContainerExpanded;
      yield this.reRenderAsync();
      yield (_b = (_a = this.props).onToggle) === null || _b === void 0 ? void 0 : _b.call(_a, this.model);
    });
  }
  get grid() {
    return this.model.grid;
  }
  get model() {
    return this.props.row;
  }
  get isLoading() {
    return this.grid.instance.isLoading;
  }
  shouldComponentUpdate(nextProps) {
    return !this.isLoading && this.isMounted;
  }
  render() {
    const grid = this.grid;
    const row = this.model;
    row.instance = this;
    const renderDetails = row.grid.renderDetails != null && (row.hasDetails || row.expanded);
    row.hasDetails = renderDetails;
    if (this.props.init) {
      this.props.init(row);
    }
    const isOdd = row.index % 2 === 0;
    const hoveringMode = Object.values(GridHoveringType)[grid.hovering];
    const borderType = Object.values(BorderType)[this.grid.borderType];
    const detailsVisibleStyle = row.expanded && styles$Q.visible;
    const colSpan = row.detailsColEnd - row.detailsColStart + 1;
    const checkRowSpan = row.expanded ? 2 : 1;
    const checkDisabledStyle = grid.checkable && !row.checkable && styles$Q.disabled;
    const cells = row.cells.where(item => item.column.isVisible);
    const collapsedCells = grid.responsive ? row.cells.where(item => item.column.collapsed && item.column.responsivePriority >= 0) : [];
    const responsive = collapsedCells.length > 0;
    const responsiveContainerExpanded = responsive && row.responsiveContainerExpanded;
    const responsiveIconName = responsiveContainerExpanded ? "fas minus-circle" : "fas plus-circle";
    const responsiveExpandedStyle = responsiveContainerExpanded && styles$Q.expanded;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
      className: this.css(styles$Q.gridRow, row.className),
      "data-is-odd": String(isOdd),
      "data-hovering-mode": hoveringMode,
      "data-border-type": borderType
    }, responsive && ( /*#__PURE__*/React.createElement("td", {
      className: this.css(styles$Q.responsive),
      onClick: () => this.onToggleAsync(row)
    }, /*#__PURE__*/React.createElement(Icon, {
      className: this.css(styles$Q.responsiveIcon, responsiveExpandedStyle),
      name: responsiveIconName,
      size: IconSize.Large
    }))), grid.checkable && ( /*#__PURE__*/React.createElement("td", {
      className: this.css(styles$Q.check, checkDisabledStyle),
      rowSpan: checkRowSpan,
      onClick: e => this.onCheckAsync(e)
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: row.checked,
      disabled: !this.model.checkable,
      onChange: () => {}
    }))), cells.map(cell => ( /*#__PURE__*/React.createElement(Cell, {
      key: cell.key,
      cell: cell,
      onClick: cell => this.onSelectAsync(cell)
    })))), /*#__PURE__*/React.createElement("tr", {
      className: this.css(styles$Q.gridRow, styles$Q.details, detailsVisibleStyle),
      "data-is-odd": String(isOdd),
      "data-hovering-mode": hoveringMode
    }, /*#__PURE__*/React.createElement("td", {
      colSpan: colSpan
    }, renderDetails && ( /*#__PURE__*/React.createElement(React.Fragment, null, row.grid.renderDetails(row))))), /*#__PURE__*/React.createElement(CollapsedRow, {
      grid: grid,
      row: row,
      cells: cells
    }));
  }
}

class TotalRow extends BaseComponent {
  get grid() {
    return this.props.grid;
  }
  render() {
    const grid = this.grid;
    const totals = [grid.columns.length];
    for (let i = 0; i < grid.columns.length; i++) {
      const column = grid.columns[i];
      totals[i] = column.total ? Utility.sum(column.cells, cell => cell.value) : null;
    }
    return /*#__PURE__*/React.createElement("tr", {
      className: this.css(styles$Q.totalRow)
    }, totals.map((value, index) => (
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key -- totals values might not be unique.
    React.createElement("td", {
      key: `${value}_${index}`
    }, value != null && ( /*#__PURE__*/React.createElement("span", null, Utility.format("{0:0.00}", value)))))));
  }
}

var css_248z$Q = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.page-link {\n  color: #337ab7;\n}\n\n@media screen and (max-width: 768px) {\n  .page-link:hover {\n    background-color: #ffffff !important;\n  }\n}";
styleInject(css_248z$Q);

var css_248z$P = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-pagination-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-pagination-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-pagination-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-pagination-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-pagination-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-pagination-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-pagination-pagination .athenaeum-pagination-pageDropdownWrap {\n  min-width: 116px;\n}\n.athenaeum-pagination-pagination .athenaeum-pagination-pageDropdownWrap > div {\n  width: auto;\n}\n.athenaeum-pagination-pagination .athenaeum-pagination-total {\n  margin-left: 1rem;\n  width: 86px;\n  color: rgb(227, 227, 227);\n  cursor: default;\n  white-space: nowrap;\n}";
var styles$J = {"font-renta":"athenaeum-pagination-font-renta","color-schema-renta_black":"athenaeum-pagination-color-schema-renta_black","color-schema-renta_white":"athenaeum-pagination-color-schema-renta_white","color-schema-renta_orange":"athenaeum-pagination-color-schema-renta_orange","color-schema-renta_green":"athenaeum-pagination-color-schema-renta_green","color-schema-renta_blue":"athenaeum-pagination-color-schema-renta_blue","pagination":"athenaeum-pagination-pagination","pageDropdownWrap":"athenaeum-pagination-pageDropdownWrap","total":"athenaeum-pagination-total"};
styleInject(css_248z$P);

class Pagination extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      pageSize: this.props.pageSize,
      pageNumber: this.props.pageNumber
    };
    this._dataPerPageVariants = null;
  }
  processAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(this, this.pageNumber, this.pageSize);
      }
    });
  }
  onChangePageNumber(event, button) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      if (!button.disabled) {
        const pageNumber = button.pageNumber;
        if (this.pageNumber != pageNumber) {
          yield this.setState({
            pageNumber
          });
          yield this.processAsync();
        }
      }
    });
  }
  onChangePageSizeAsync(pageSize, userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      if (userInteraction && this.pageSize != pageSize) {
        const currentFirstRowIndex = (this.pageNumber - 1) * this.pageSize;
        const pageNumber = Math.trunc(currentFirstRowIndex / pageSize) + 1;
        yield this.setState({
          pageSize,
          pageNumber
        });
        yield this.processAsync();
      }
    });
  }
  get paginationButtons() {
    const isMobile = this.mobile;
    const firstPageNumber = 1;
    const currentPageNumber = this.pageNumber;
    const totalItemCount = this.totalItemCount;
    const pageSize = this.pageSize;
    const prevPrevPrevPageNumber = currentPageNumber - 3;
    const prevPrevPageNumber = currentPageNumber - 2;
    const prevPageNumber = currentPageNumber - 1;
    const nextPageNumber = currentPageNumber + 1;
    const nextNextPageNumber = currentPageNumber + 2;
    const nextNextNextPageNumber = currentPageNumber + 3;
    const lastPageNumber = totalItemCount > 0 ? Math.ceil(totalItemCount / pageSize) : 1;
    let pages = [];
    if (isMobile) {
      const firstPageVisible = firstPageNumber <= prevPrevPageNumber;
      const prevPrevPrevPageVisible = prevPrevPrevPageNumber > 0 && prevPrevPrevPageNumber + 3 === lastPageNumber && prevPrevPrevPageNumber !== firstPageNumber;
      const prevPrevPageVisible = prevPrevPageNumber > 0 && prevPrevPageNumber + 2 === lastPageNumber && prevPrevPageNumber !== firstPageNumber || prevPrevPageNumber > 0 && nextPageNumber >= lastPageNumber && prevPrevPageNumber !== firstPageNumber;
      const lastPageVisible = lastPageNumber >= nextNextPageNumber;
      const nextNextNextPageVisible = nextNextNextPageNumber - 3 === firstPageNumber && lastPageNumber > 4;
      const nextNextPageVisible = lastPageNumber > 4 && (nextNextPageNumber - 2 === firstPageNumber || prevPageNumber === firstPageNumber);
      pages = [
      //We always want to show 5 numbers on mobile view.
      //Examples, where [] marks the selected number.
      //A: < [1], 2, 3, 4, 10 >
      //B: < 1, [2], 3, 4, 10 >
      //C: < 1, 2, [3], 4, 10 >
      //D: < 1, 3, [4], 5, 10 >
      //E: < 1, 4, [5], 6, 10 >
      //F: < 1, [7], 8, 9, 10 >
      //G: < 1, 7, [8], 9, 10 >
      //H: < 1, 7, 8, [9], 10 >
      //I: < 1, 7, 8, 9, [10] >
      //Always show prev arrow. Disable if no previous page
      {
        pageNumber: prevPageNumber,
        current: false,
        visible: true,
        disabled: prevPageNumber < firstPageNumber,
        label: "‹"
      },
      //First page. Hide when currentPage is 3, since then line below will render "1"
      {
        pageNumber: firstPageNumber,
        current: false,
        visible: firstPageVisible,
        disabled: firstPageNumber === currentPageNumber,
        label: firstPageNumber.toString()
      },
      //Case I
      {
        pageNumber: prevPrevPrevPageNumber,
        current: false,
        visible: prevPrevPrevPageVisible,
        disabled: false,
        label: prevPrevPrevPageNumber.toString()
      },
      //Case H
      {
        pageNumber: prevPrevPageNumber,
        current: false,
        visible: prevPrevPageVisible,
        disabled: false,
        label: prevPrevPageNumber.toString()
      },
      //Always show next prev page number unless prev is last
      {
        pageNumber: prevPageNumber,
        current: false,
        visible: prevPageNumber >= firstPageNumber,
        disabled: false,
        label: prevPageNumber.toString()
      },
      //Always show currentPage
      {
        pageNumber: currentPageNumber,
        current: true,
        visible: true,
        disabled: true,
        label: currentPageNumber.toString()
      },
      //Always show next page number unless next is last
      {
        pageNumber: nextPageNumber,
        current: false,
        visible: nextPageNumber <= lastPageNumber,
        disabled: false,
        label: nextPageNumber.toString()
      },
      //Case B
      {
        pageNumber: nextNextPageNumber,
        current: false,
        visible: nextNextPageVisible,
        disabled: false,
        label: nextNextPageNumber.toString()
      },
      //Case A
      {
        pageNumber: nextNextNextPageNumber,
        current: false,
        visible: nextNextNextPageVisible,
        disabled: false,
        label: nextNextNextPageNumber.toString()
      }, {
        pageNumber: lastPageNumber,
        current: false,
        visible: lastPageVisible,
        disabled: lastPageNumber === currentPageNumber,
        label: lastPageNumber.toString()
      }, {
        pageNumber: nextPageNumber,
        current: false,
        visible: true,
        disabled: nextPageNumber > lastPageNumber,
        label: "›"
      }];
    } else {
      pages = [{
        pageNumber: prevPageNumber,
        current: false,
        visible: true,
        disabled: prevPageNumber < firstPageNumber,
        label: "‹"
      }, {
        pageNumber: firstPageNumber,
        current: false,
        visible: firstPageNumber < prevPrevPageNumber,
        disabled: firstPageNumber === currentPageNumber,
        label: firstPageNumber.toString()
      }, {
        pageNumber: prevPrevPageNumber,
        current: false,
        visible: prevPageNumber - firstPageNumber > 2,
        disabled: true,
        label: "..."
      }, {
        pageNumber: prevPrevPageNumber,
        current: false,
        visible: prevPrevPageNumber >= firstPageNumber,
        disabled: false,
        label: prevPrevPageNumber.toString()
      }, {
        pageNumber: prevPageNumber,
        current: false,
        visible: prevPageNumber >= firstPageNumber,
        disabled: false,
        label: prevPageNumber.toString()
      }, {
        pageNumber: currentPageNumber,
        current: true,
        visible: true,
        disabled: true,
        label: currentPageNumber.toString()
      }, {
        pageNumber: nextPageNumber,
        current: false,
        visible: nextPageNumber <= lastPageNumber,
        disabled: false,
        label: nextPageNumber.toString()
      }, {
        pageNumber: nextNextPageNumber,
        current: false,
        visible: nextNextPageNumber <= lastPageNumber,
        disabled: false,
        label: nextNextPageNumber.toString()
      }, {
        pageNumber: nextNextPageNumber,
        current: false,
        visible: lastPageNumber - nextPageNumber > 2,
        disabled: true,
        label: "..."
      }, {
        pageNumber: lastPageNumber,
        current: false,
        visible: lastPageNumber > nextNextPageNumber,
        disabled: lastPageNumber === currentPageNumber,
        label: lastPageNumber.toString()
      }, {
        pageNumber: nextPageNumber,
        current: false,
        visible: true,
        disabled: nextPageNumber > lastPageNumber,
        label: "›"
      }];
    }
    return pages;
  }
  get dataPerPageVariants() {
    if (this._dataPerPageVariants == null) {
      const variants = this.props.dataPerPageVariants || [10, 25, 50, 100];
      if (!variants.includes(this.pageSize)) {
        variants.push(this.pageSize);
        variants.sort((x, y) => x - y);
      }
      this._dataPerPageVariants = variants;
    }
    return this._dataPerPageVariants;
  }
  get classNames() {
    return this.props.classNames || {};
  }
  get pageNumber() {
    return this.state.pageNumber;
  }
  get pageSize() {
    return this.state.pageSize;
  }
  get itemCount() {
    return this.props.itemCount;
  }
  get totalItemCount() {
    return this.props.totalItemCount;
  }
  renderPaginationButton(button, index) {
    const activeStyle = button.current && this.css("active", this.classNames.buttonActive);
    const disabledStyle = button.disabled && this.css("disabled", this.classNames.buttonDisabled);
    return button.visible && ( /*#__PURE__*/React.createElement("li", {
      key: index,
      className: this.css("page-item", this.classNames.pageItem, activeStyle, disabledStyle)
    }, /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: this.css("page-link shadow-none", this.classNames.pageLink),
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onChangePageNumber(e, button);
      })
    }, button.label)));
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentWillReceiveProps.call(this, nextProps);
      const newProps = nextProps.pageNumber != this.pageNumber || nextProps.pageSize != this.pageSize;
      if (newProps) {
        yield this.setState({
          pageNumber: nextProps.pageNumber,
          pageSize: nextProps.pageSize
        });
      }
    });
  }
  render() {
    return /*#__PURE__*/React.createElement("nav", {
      className: this.css(styles$J.pagination, "d-flex align-items-center", this.props.className)
    }, /*#__PURE__*/React.createElement("ul", {
      className: this.css("pagination mb-0", this.classNames.pagination)
    }, this.paginationButtons.map((button, index) => this.renderPaginationButton(button, index))), /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$J.pageDropdownWrap, "ml-3 d-flex align-items-center justify-content-between", this.classNames.pageDropdownWrap)
    }, /*#__PURE__*/React.createElement(Dropdown, {
      inline: true,
      small: true,
      required: true,
      noFilter: true,
      items: this.dataPerPageVariants,
      selectedItem: this.props.pageSize,
      orderBy: DropdownOrderBy.None,
      onChange: (sender, item, userInteraction) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onChangePageSizeAsync(item, userInteraction);
      })
    }), this.totalItemCount > 0 && ( /*#__PURE__*/React.createElement("span", {
      className: this.css(styles$J.total, this.classNames.total)
    }, this.itemCount, " / ", this.totalItemCount))));
  }
}

class Grid extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isLoading: false,
      data: null
    };
    //  stickyHeader prop functionality related. (to get height of first row of tr in thead for setting "top" of second row of th in thead in stick mode)
    this._tableHeadFirstRowRef = /*#__PURE__*/React.createRef();
    this._spinnerRef = /*#__PURE__*/React.createRef();
    this._overflowData = null;
    this._language = GridLocalizer$1.language;
    this._grid = null;
    this._rows = null;
  }
  paginateAsync(pageNumber, pageSize) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.pageNumber != pageNumber || this.pageSize != pageSize) {
        this.model.pageNumber = pageNumber;
        this.model.pageSize = pageSize;
        yield this.reloadAsync();
      }
    });
  }
  setDataAsync(data) {
    return __awaiter(this, void 0, void 0, function* () {
      const state = this.state;
      yield this.processDataAsync(state, data);
      if (this.isMounted) {
        yield this.setState(state);
      }
    });
  }
  buildModelAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const data = {
        items: this.model.data,
        pageNumber: this.model.pageNumber,
        pageSize: this.model.pageSize,
        totalItemCount: this.model.totalItemCount,
        pageCount: 0
      };
      this._language = GridLocalizer$1.language;
      this._grid = null;
      this._rows = null;
      yield this.setDataAsync(data);
    });
  }
  onCheckRowAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const count = this.rows.length;
      const selected = Utility.count(this.rows, row => row.checked);
      const newChecked = selected == 0 ? false : selected === count ? true : undefined;
      if (newChecked !== this.model.checked) {
        this.model.checked = newChecked;
        yield this.model.checkHeaderInstance.reRenderAsync();
      }
      if (this.model.onCheck) {
        yield this.model.onCheck(this.model);
      }
    });
  }
  width() {
    const gridNode = this.JQuery(`#table_${this.id}`);
    const width = gridNode.width();
    return width != null ? width + 1 : 0;
  }
  getNode() {
    return this.JQuery(`#table_${this.id}`);
  }
  containerWidth() {
    const gridNode = this.getNode();
    const parentNode = gridNode.parent();
    return parentNode.innerWidth() || gridNode.outerWidth() || 0;
  }
  getOverflowData() {
    const gridContainerWidth = Math.round(this.containerWidth());
    const gridWidth = Math.round(this.model.fullWidth());
    const gridFullWidth = Math.round(this.model.fullWidth(false));
    return {
      containerWidth: gridContainerWidth,
      gridWidth: gridWidth,
      gridFullWidth: gridFullWidth
    };
  }
  processResponsiveAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.model.responsive) {
        const overflowData = this.getOverflowData();
        let columns = this.model.columns;
        const needToHide = overflowData.containerWidth < overflowData.gridWidth;
        if (needToHide) {
          let widthToCompensate = overflowData.gridWidth - overflowData.containerWidth;
          const gridCollapsed = this.model.columns.some(row => row.collapsed);
          if (gridCollapsed) {
            // Expand/Collapse TD width (hardcoded in styles)
            widthToCompensate -= 40;
          }
          // eslint-disable-next-line no-constant-condition -- infinite loop is wanted here.
          while (true) {
            columns = columns.where(column => column.isVisible);
            if (columns.length <= 1) {
              return;
            }
            columns.order(column => column.responsivePriority);
            const lastColumn = columns[columns.length - 1];
            const columnWidth = lastColumn.outerWidth();
            widthToCompensate -= columnWidth;
            lastColumn.collapsed = true;
            if (widthToCompensate <= 0) {
              break;
            }
          }
          this._overflowData = overflowData;
          yield this.reRenderAsync();
          return;
        }
        const lastContainerWidth = this._overflowData ? this._overflowData.containerWidth : overflowData.containerWidth;
        const needToShow = lastContainerWidth < overflowData.containerWidth && columns.some(column => column.collapsed);
        if (needToShow) {
          columns.map(column => column.collapsed = false);
          yield this.reRenderAsync();
          this._overflowData = overflowData;
          yield this.processResponsiveAsync();
          return;
        }
      }
    });
  }
  sort(items, sortColumn, sortDirection) {
    if (sortColumn && sortColumn.accessor && items && sortDirection != null) {
      const accessor = sortColumn.accessor;
      const getter = model => typeof accessor === "string" ? Utility.findValueByAccessor(model, accessor) : accessor(model);
      items = items.sort((x, y) => {
        const xValue = getter(x);
        const yValue = getter(y);
        return xValue == yValue ? 0 : xValue > yValue ? sortDirection == SortDirection.Desc ? -1 : 1 : sortDirection == SortDirection.Desc ? 1 : -1;
      });
    }
    return items;
  }
  processDataAsync(state, data) {
    return __awaiter(this, void 0, void 0, function* () {
      const model = this.model;
      let items = [];
      let totalItemCount = 0;
      let pageNumber = model.pageNumber;
      let pageSize = model.pageSize;
      const sortColumn = model.sortColumn;
      const sortDirection = model.sortDirection;
      if (data) {
        let pagedData = data;
        if (pagedData.items) {
          items = pagedData.items;
          totalItemCount = pagedData.totalItemCount;
          pageNumber = pagedData.pageNumber;
          pageSize = pagedData.pageSize;
        } else {
          items = data;
          items = this.sort(items, sortColumn, sortDirection);
          if (model.pagination) {
            pagedData = Utility.toPagedList(items, model.pageNumber, model.pageSize);
            items = pagedData.items;
            totalItemCount = pagedData.totalItemCount;
            pageNumber = pagedData.pageNumber;
          } else {
            pageNumber = 1;
            totalItemCount = items.length;
          }
        }
      }
      model.data = items;
      model.checked = false;
      model.pageNumber = pageNumber;
      model.pageSize = pageSize;
      model.totalItemCount = totalItemCount;
      model.sortColumn = sortColumn;
      model.sortDirection = sortDirection;
      model.generation++;
      this._rows = null;
    });
  }
  fetchDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.fetchData) {
        const model = this.model;
        const pageNumber = model.pageNumber;
        const pageSize = model.pageSize;
        const sortColumn = model.sortColumn;
        const sortColumnName = sortColumn != null ? sortColumn.name ? sortColumn.name : sortColumn.accessor && typeof sortColumn.accessor === "string" ? sortColumn.accessor : sortColumn.index.toString() : null;
        const sortDirection = sortColumnName ? model.sortDirection || SortDirection.Asc : null;
        return yield this.props.fetchData(this, pageNumber, pageSize, sortColumnName, sortDirection);
      }
      return [];
    });
  }
  getEndpoint() {
    return "";
  }
  isAsync() {
    return this.props.fetchData != null;
  }
  hasSpinner() {
    return true;
  }
  setSpinnerAsync(isSpinning) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._spinnerRef.current) {
        yield this._spinnerRef.current.setSpinnerAsync(isSpinning);
      }
    });
  }
  reloadAsync() {
    const _super = Object.create(null, {
      reloadAsync: {
        get: () => super.reloadAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.reloadAsync.call(this);
      yield this.processResponsiveAsync();
    });
  }
  get columns() {
    return this.model.columns;
  }
  get rows() {
    return this._rows || (this._rows = this.model.rows = GridTransformer.toRows(this.model, this.model.data || []));
  }
  get model() {
    return this._grid || (this._grid = GridTransformer.toGrid(this.props, this.id));
  }
  get pageNumber() {
    return this.model.pageNumber;
  }
  get pageSize() {
    return this.model.pageSize;
  }
  get itemCount() {
    return this.model.items.length;
  }
  get totalItemCount() {
    return this.model.totalItemCount;
  }
  get colSpan() {
    return this.model.checkable ? this.model.columns.length + 1 : this.model.columns.length;
  }
  get classNames() {
    return this.props.classNames || {};
  }
  clearAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setDataAsync([]);
    });
  }
  onGlobalResize(e) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.processResponsiveAsync();
    });
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.initializeAsync.call(this);
      if (this.props.data != null) {
        yield this.setDataAsync(this.props.data);
      }
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const newData = !Comparator.isEqual(this.props.data, nextProps.data);
      if (newData) {
        const data = nextProps.data || [];
        yield this.setDataAsync(data);
      }
      const newReadonly = this.props.readonly !== nextProps.readonly;
      const newResponsive = this.props.responsive !== nextProps.responsive;
      const newLanguage = this._language !== GridLocalizer$1.language;
      const newCheckable = this.props.checkable !== nextProps.checkable;
      const newSelectable = this.props.selectable !== nextProps.selectable;
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (newReadonly || newLanguage || newResponsive || newCheckable || newSelectable) {
        yield this.buildModelAsync();
      }
      yield this.processResponsiveAsync();
    });
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      yield this.processResponsiveAsync();
      yield this.processResponsiveAsync();
    });
  }
  renderHeader(column, hasHeaderGroups, top, colSpanLeft, tableHeadRowIndex) {
    return /*#__PURE__*/React.createElement(HeaderCell, {
      key: `grid_header_${column.index}_${top}`,
      column: column,
      hasHeaderGroups: hasHeaderGroups,
      top: top,
      colSpanLeft: colSpanLeft,
      tableHeadFirstRowRef: this._tableHeadFirstRowRef,
      stickyHeader: this.props.stickyHeader,
      tableHeadRowIndex: tableHeadRowIndex,
      version2Styles: this.props.version2Styles
    });
  }
  renderDataRow(row) {
    return /*#__PURE__*/React.createElement(Row, {
      key: row.key,
      row: row,
      init: this.props.initRow,
      onCheck: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onCheckRowAsync();
      }),
      onSelect: row => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        return yield (_b = (_a = this.props).onSelect) === null || _b === void 0 ? void 0 : _b.call(_a, this.model, row);
      }),
      onToggle: row => __awaiter(this, void 0, void 0, function* () {
        var _c, _d;
        return yield (_d = (_c = this.props).onRowToggle) === null || _d === void 0 ? void 0 : _d.call(_c, row);
      })
    });
  }
  renderEmptyRow() {
    return /*#__PURE__*/React.createElement("tr", {
      className: styles$Q.emptyRow
    }, /*#__PURE__*/React.createElement("td", {
      colSpan: this.colSpan
    }, GridLocalizer$1.get(this.model.noDataText)));
  }
  render() {
    const model = this.model;
    const rows = this.rows;
    this.model.instance = this;
    const visible = this.hasData || !model.noDataNoHeader;
    const outerSpinner = model.noDataNoHeader;
    const hoveringMode = Object.values(GridHoveringType)[model.hovering];
    const inlineStyles = {};
    if (model.minWidth) {
      inlineStyles.minWidth = model.minWidth;
    }
    const columns = model.columns.where(item => item.isVisible);
    const collapsedColumns = model.responsive ? model.columns.where(item => item.collapsed) : [];
    const responsive = collapsedColumns.length > 0;
    const hasHeaderGroups = visible && columns.some(column => !!column.group);
    return /*#__PURE__*/React.createElement(React.Fragment, null, visible && ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("table", {
      id: "table_" + this.id,
      key: model.key,
      style: inlineStyles,
      "data-v2-styles": String(!!this.props.version2Styles),
      "data-hovering-mode": hoveringMode,
      className: this.css("table table-bordered", styles$Q.grid, this.props.className)
    }, columns.length > 0 && ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
      ref: this._tableHeadFirstRowRef,
      className: "table-hover"
    }, model.checkable && ( /*#__PURE__*/React.createElement(CheckHeaderCell, {
      model: model,
      hasHeaderGroups: hasHeaderGroups,
      colSpanLeft: responsive
    })), columns.map((column, index) => this.renderHeader(column, hasHeaderGroups, true, responsive && index == 0, 0))), hasHeaderGroups && ( /*#__PURE__*/React.createElement("tr", null, columns.map((column, index) => this.renderHeader(column, hasHeaderGroups, false, responsive && index == 0, 1)))))), /*#__PURE__*/React.createElement("tbody", null, model.noDataText && rows.length === 0 ? this.renderEmptyRow() : rows.map((item, rowIndex) => this.renderDataRow(rows[rowIndex])), rows.length > 0 && model.total && ( /*#__PURE__*/React.createElement(TotalRow, {
      grid: model
    }))))), !outerSpinner && ( /*#__PURE__*/React.createElement("tbody", {
      className: styles$Q.spinner
    }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      colSpan: this.colSpan
    }, /*#__PURE__*/React.createElement(GridSpinner, {
      ref: this._spinnerRef
    })))))), model.pagination && ( /*#__PURE__*/React.createElement(Pagination, {
      className: styles$Q.pagination,
      classNames: this.classNames.pagination,
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
      itemCount: this.itemCount,
      totalItemCount: this.totalItemCount,
      onChange: (sender, pageNumber, pageSize) => __awaiter(this, void 0, void 0, function* () {
        return yield this.paginateAsync(pageNumber, pageSize);
      })
    })))), outerSpinner && ( /*#__PURE__*/React.createElement(GridSpinner, {
      ref: this._spinnerRef
    })));
  }
}

var css_248z$O = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-layout-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-layout-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-layout-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-layout-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-layout-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-layout-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-layout-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-layout-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-layout-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-layout-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-layout-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-layout-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-layout-page {\n  height: 100%;\n}\n.athenaeum-layout-page[data-haswideheader=false] {\n  padding: 15px 8px;\n}\n.athenaeum-layout-page[data-haswideheader=true] {\n  background: white;\n}\n.athenaeum-layout-page .athenaeum-layout-container {\n  padding: 15px;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 6px;\n}\n.athenaeum-layout-page .athenaeum-layout-container.athenaeum-layout-fullHeight {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.athenaeum-layout-page .athenaeum-layout-container.athenaeum-layout-fullWidth {\n  max-width: unset !important;\n  min-width: 100% !important;\n}\n.athenaeum-layout-page.athenaeum-layout-scale {\n  padding: 0;\n}\n.athenaeum-layout-page.athenaeum-layout-scale .athenaeum-layout-container {\n  max-width: unset !important;\n  min-width: 100% !important;\n  height: 100%;\n  border-radius: 0;\n  padding-bottom: 0;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n.athenaeum-layout-page.athenaeum-layout-scale .athenaeum-layout-container > div {\n  margin-top: 0 !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.athenaeum-layout-page .athenaeum-layout-row {\n  flex-grow: 2;\n  margin: 15px 15px 25px;\n}\n.athenaeum-layout-page .athenaeum-layout-row:last-of-type {\n  margin-bottom: 15px;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-layout-page .athenaeum-layout-row {\n    margin: 0 -15px 15px !important;\n  }\n  .athenaeum-layout-page .athenaeum-layout-row:last-of-type {\n    margin-bottom: 0 !important;\n  }\n}\n.athenaeum-layout-page .athenaeum-layout-pageRow {\n  margin-bottom: 0;\n  flex-grow: 0;\n}\n.athenaeum-layout-page .athenaeum-layout-pageRow.athenaeum-layout-alertRow {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n.athenaeum-layout-page .athenaeum-layout-header {\n  flex-grow: 0;\n  margin-bottom: 16px;\n  padding: 0 15px;\n  overflow: unset;\n}\n.athenaeum-layout-page .athenaeum-layout-header[data-wideheader=false] {\n  padding: 0 15px;\n}\n.athenaeum-layout-page .athenaeum-layout-header[data-wideheader=true] {\n  background-position: center;\n  background-size: cover;\n  color: white;\n  margin: 0;\n  max-height: 25vh;\n  min-height: 10vh;\n  height: 225px;\n  margin-bottom: 1rem;\n  display: flex;\n}\n.athenaeum-layout-page .athenaeum-layout-header[data-wideheader=true] .athenaeum-layout-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-layout-page .athenaeum-layout-header[data-wideheader=true] .athenaeum-layout-content h1 {\n  font-size: clamp(1.2rem, 5vw, 2rem);\n  font-weight: bold;\n  text-align: center;\n}\n.athenaeum-layout-page .athenaeum-layout-header[data-wideheader=true] .athenaeum-layout-content h2 {\n  font-size: 24px;\n}\n.athenaeum-layout-page .athenaeum-layout-header .athenaeum-layout-content {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.athenaeum-layout-page .athenaeum-layout-header .athenaeum-layout-content h1 {\n  font-size: 18px;\n}\n.athenaeum-layout-page .athenaeum-layout-header .athenaeum-layout-content h2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-family: Arial, sans-serif;\n  margin-bottom: 8px;\n}\n.athenaeum-layout-page .athenaeum-layout-header .athenaeum-layout-content.athenaeum-layout-noMargin {\n  margin-bottom: 0;\n}\n.athenaeum-layout-page .athenaeum-layout-header hr {\n  border: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  margin: 8px 0 0 0;\n  width: 100%;\n}\n\n.athenaeum-layout-layout {\n  display: flex;\n  flex-direction: column;\n  height: inherit;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-layout-layout {\n    overflow-x: hidden;\n  }\n}\n.athenaeum-layout-layout .athenaeum-layout-main {\n  background-color: inherit;\n  margin-top: 45px;\n  flex-grow: 2;\n  flex-basis: 0;\n}\n.athenaeum-layout-layout .athenaeum-layout-main.athenaeum-layout-leftNav {\n  display: flex;\n  position: relative;\n}\n.athenaeum-layout-layout .athenaeum-layout-main.athenaeum-layout-leftNav > div {\n  flex-grow: 2;\n}\n.athenaeum-layout-layout .athenaeum-layout-main.athenaeum-layout-info {\n  margin-top: 90px;\n}\n.athenaeum-layout-layout .athenaeum-layout-main .athenaeum-layout-leftNav {\n  z-index: 1000;\n}\n.athenaeum-layout-layout .athenaeum-layout-swipeRight {\n  margin-left: 99%;\n  margin-right: -99%;\n  transition: all 0.2s ease-out;\n}\n.athenaeum-layout-layout .athenaeum-layout-swipeLeft {\n  margin-right: 99%;\n  margin-left: -99%;\n  transition: all 0.2s ease-out;\n}\n.athenaeum-layout-layout .athenaeum-layout-christmas {\n  pointer-events: none;\n  position: absolute;\n  left: 0;\n  right: auto;\n  top: -24px;\n  height: 160px;\n  width: 100%;\n  background: url(images/christmas-lights.png) repeat-x center;\n  background-size: auto 100%;\n  z-index: 999999;\n  animation-duration: 60s;\n  animation-name: athenaeum-layout-hide;\n  animation-fill-mode: forwards;\n}\n.athenaeum-layout-layout .athenaeum-layout-christmas.athenaeum-layout-mobile {\n  top: 3px;\n  height: 95px;\n}\n@keyframes athenaeum-layout-hide {\n  to {\n    opacity: 0;\n  }\n}";
var styles$I = {"font-renta":"athenaeum-layout-font-renta","color-schema-renta_black":"athenaeum-layout-color-schema-renta_black","color-schema-renta_white":"athenaeum-layout-color-schema-renta_white","color-schema-renta_orange":"athenaeum-layout-color-schema-renta_orange","color-schema-renta_green":"athenaeum-layout-color-schema-renta_green","color-schema-renta_blue":"athenaeum-layout-color-schema-renta_blue","page":"athenaeum-layout-page","container":"athenaeum-layout-container","fullHeight":"athenaeum-layout-fullHeight","fullWidth":"athenaeum-layout-fullWidth","scale":"athenaeum-layout-scale","row":"athenaeum-layout-row","pageRow":"athenaeum-layout-pageRow","alertRow":"athenaeum-layout-alertRow","header":"athenaeum-layout-header","content":"athenaeum-layout-content","noMargin":"athenaeum-layout-noMargin","layout":"athenaeum-layout-layout","main":"athenaeum-layout-main","leftNav":"athenaeum-layout-leftNav","info":"athenaeum-layout-info","swipeRight":"athenaeum-layout-swipeRight","swipeLeft":"athenaeum-layout-swipeLeft","christmas":"athenaeum-layout-christmas","hide":"athenaeum-layout-hide","mobile":"athenaeum-layout-mobile"};
styleInject(css_248z$O);

class OneColumn extends BaseComponent {
  renderRow(index, item) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: this.css(styles$I.row, "row")
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-12"
    }, item));
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.props.className
    }, this.props.children && this.children.length > 0 && this.children.map((item, index) => this.renderRow(index, item)));
  }
}

class TwoColumns extends BaseComponent {
  get leftClassName() {
    return this.props.leftClassName || "col-md-6";
  }
  get rightClassName() {
    return this.props.rightClassName || "col-md-6";
  }
  renderRow(left, right) {
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$I.row, this.props.className, "row")
    }, /*#__PURE__*/React.createElement("div", {
      className: this.leftClassName
    }, left), /*#__PURE__*/React.createElement("div", {
      className: this.rightClassName
    }, right));
  }
  render() {
    return this.props.children && this.children.length > 0 ? this.renderRow(this.children[0], this.children[1]) : null;
  }
}

//Autogenerated
class AddressDividerLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.addressLanguageItemName = `Address`;
    this.streetLanguageItemName = `Street`;
    this.cityLanguageItemName = `City`;
    this.postalCodeLanguageItemName = `PostalCode`;
    //Initializer
    this.set(this.addressLanguageItemName, {
      language: `en`,
      value: `Address`
    }, {
      language: `uk`,
      value: `Адреса`
    }, {
      language: `sv`,
      value: `Adress`
    }, {
      language: `ru`,
      value: `Адрес`
    }, {
      language: `pl`,
      value: `Adres`
    }, {
      language: `nb`,
      value: `Addresse`
    }, {
      language: `fi`,
      value: `Osoite`
    }, {
      language: `da`,
      value: `Adresse`
    });
    this.set(this.streetLanguageItemName, {
      language: `en`,
      value: `Street`
    }, {
      language: `uk`,
      value: `Вулиця`
    }, {
      language: `sv`,
      value: `Gata`
    }, {
      language: `ru`,
      value: `Улица`
    }, {
      language: `pl`,
      value: `Ulica`
    }, {
      language: `nb`,
      value: `Gate`
    }, {
      language: `fi`,
      value: `Katu`
    }, {
      language: `da`,
      value: `Gade`
    });
    this.set(this.cityLanguageItemName, {
      language: `en`,
      value: `City`
    }, {
      language: `uk`,
      value: `Місто`
    }, {
      language: `sv`,
      value: `Stad`
    }, {
      language: `ru`,
      value: `Город`
    }, {
      language: `pl`,
      value: `Miasto`
    }, {
      language: `nb`,
      value: `By`
    }, {
      language: `fi`,
      value: `Kaupunki`
    }, {
      language: `da`,
      value: `By`
    });
    this.set(this.postalCodeLanguageItemName, {
      language: `en`,
      value: `Postal code`
    }, {
      language: `uk`,
      value: `Поштовий індекс`
    }, {
      language: `sv`,
      value: `Postnummer`
    }, {
      language: `ru`,
      value: `Почтовый индекс`
    }, {
      language: `pl`,
      value: `Kod pocztowy`
    }, {
      language: `nb`,
      value: `Postnummer`
    }, {
      language: `fi`,
      value: `Postinumero`
    }, {
      language: `da`,
      value: `Postnummer`
    });
  }
  /**
  /* "Address" (Address)
  */
  get address() {
    return this.get(this.addressLanguageItemName);
  }
  /**
  /* "Street" (Street)
  */
  get street() {
    return this.get(this.streetLanguageItemName);
  }
  /**
  /* "City" (City)
  */
  get city() {
    return this.get(this.cityLanguageItemName);
  }
  /**
  /* "PostalCode" (Postal code)
  */
  get postalCode() {
    return this.get(this.postalCodeLanguageItemName);
  }
}
//Singleton
var AddressDividerLocalizer$1 = new AddressDividerLocalizer();

var AddressDividerColumns;
(function (AddressDividerColumns) {
  AddressDividerColumns[AddressDividerColumns["Two"] = 0] = "Two";
  AddressDividerColumns[AddressDividerColumns["One"] = 1] = "One";
})(AddressDividerColumns || (AddressDividerColumns = {}));
class AddressDivider extends BaseComponent {
  constructor() {
    var _a, _b;
    super(...arguments);
    this.state = {
      location: (_a = AddressHelper.toLocation(this.props.location)) !== null && _a !== void 0 ? _a : new GeoLocation(),
      readonly: (_b = this.props.readonly) !== null && _b !== void 0 ? _b : false
    };
    this._containerRef = /*#__PURE__*/React.createRef();
    this._addressInputRef = /*#__PURE__*/React.createRef();
  }
  get location() {
    return this.state.location;
  }
  get addressInput() {
    const container = this._containerRef.current;
    return container.findComponent(`${this.id}_formattedAddress`);
  }
  onPlaceSelectedAsync(location) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        location
      });
      if (this.props.onChange) {
        yield this.props.onChange(this, location);
      }
    });
  }
  isInput() {
    return true;
  }
  isValid() {
    return !this.addressInput.state.validationError;
  }
  getName() {
    return this.id;
  }
  getValue() {
    return this.addressInput.getValue();
  }
  get readonly() {
    return this.state.readonly;
  }
  get columns() {
    switch (this.props.columns) {
      case AddressDividerColumns.One:
        return AddressDividerColumns.One;
      default:
        return AddressDividerColumns.Two;
    }
  }
  setReadonlyAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (value !== this.state.readonly) {
        yield this.setState({
          readonly: value
        });
        yield this._addressInputRef.current.setReadonlyAsync(value);
      }
    });
  }
  validateAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.addressInput.validateAsync();
    });
  }
  hideEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.addressInput.hideEditAsync();
    });
  }
  showEditAsync(select) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.addressInput.showEditAsync(select);
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
      const newReadonly = this.props.readonly != nextProps.readonly;
      const newLocation = !Comparator.isEqual(this.props.location, nextProps.location);
      const newState = newReadonly || newLocation;
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (newState) {
        if (newReadonly) {
          this.state.readonly = (_a = this.props.readonly) !== null && _a !== void 0 ? _a : false;
        }
        if (newLocation) {
          this.state.location = (_b = AddressHelper.toLocation(nextProps.location)) !== null && _b !== void 0 ? _b : new GeoLocation();
        }
        yield this.setState(this.state);
      }
    });
  }
  renderAddressInput() {
    return /*#__PURE__*/React.createElement(AddressInput, {
      id: `${this.id}_formattedAddress`,
      ref: this._addressInputRef,
      label: AddressDividerLocalizer$1.address,
      required: this.props.required,
      readonly: this.readonly,
      value: this.location.formattedAddress,
      locationPicker: this.props.locationPicker,
      append: this.props.locationPicker,
      country: this.props.country,
      onChange: location => __awaiter(this, void 0, void 0, function* () {
        return yield this.onPlaceSelectedAsync(location);
      })
    });
  }
  renderAddress() {
    return /*#__PURE__*/React.createElement(TextInput, {
      readonly: true,
      id: `${this.id}_address`,
      label: AddressDividerLocalizer$1.street,
      value: this.location.address
    });
  }
  renderCity() {
    return /*#__PURE__*/React.createElement(TextInput, {
      readonly: true,
      id: `${this.id}_city`,
      label: AddressDividerLocalizer$1.city,
      value: this.location.city
    });
  }
  renderPostalCode() {
    return /*#__PURE__*/React.createElement(TextInput, {
      readonly: true,
      id: `${this.id}_postalCode`,
      label: AddressDividerLocalizer$1.postalCode,
      value: this.location.postalCode
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.columns === AddressDividerColumns.Two && ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TwoColumns, {
      ref: this._containerRef,
      className: this.props.className
    }, this.renderAddressInput(), this.renderAddress()), /*#__PURE__*/React.createElement(TwoColumns, null, this.renderCity(), this.renderPostalCode()))), this.columns === AddressDividerColumns.One && ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OneColumn, {
      ref: this._containerRef,
      className: this.props.className
    }, this.renderAddressInput()), /*#__PURE__*/React.createElement(OneColumn, null, this.renderAddress()), /*#__PURE__*/React.createElement(OneColumn, null, this.renderCity()), /*#__PURE__*/React.createElement(OneColumn, null, this.renderPostalCode()))));
  }
}

//Autogenerated
class VirtualAddressDividerLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.streetLanguageItemName = `Street`;
    this.cityLanguageItemName = `City`;
    this.postalcodeLanguageItemName = `Postalcode`;
    //Initializer
    this.set(this.streetLanguageItemName, {
      language: `en`,
      value: `Street`
    }, {
      language: `uk`,
      value: `Вулиця`
    }, {
      language: `sv`,
      value: `Gata`
    }, {
      language: `ru`,
      value: `Улица`
    }, {
      language: `pl`,
      value: `Ulica`
    }, {
      language: `nb`,
      value: `Gate`
    }, {
      language: `fi`,
      value: `Katu`
    }, {
      language: `da`,
      value: `Gade`
    });
    this.set(this.cityLanguageItemName, {
      language: `en`,
      value: `City`
    }, {
      language: `uk`,
      value: `Місто`
    }, {
      language: `sv`,
      value: `Stad`
    }, {
      language: `ru`,
      value: `Город`
    }, {
      language: `pl`,
      value: `Miasto`
    }, {
      language: `nb`,
      value: `By`
    }, {
      language: `fi`,
      value: `Kaupunki`
    }, {
      language: `da`,
      value: `By`
    });
    this.set(this.postalcodeLanguageItemName, {
      language: `en`,
      value: `Postal code`
    }, {
      language: `uk`,
      value: `Поштовий індекс`
    }, {
      language: `sv`,
      value: `Postnummer`
    }, {
      language: `ru`,
      value: `Почтовый индекс`
    }, {
      language: `pl`,
      value: `Kod pocztowy`
    }, {
      language: `nb`,
      value: `Postnummer`
    }, {
      language: `fi`,
      value: `Postinumero`
    }, {
      language: `da`,
      value: `Postnummer`
    });
  }
  /**
  /* "Street" (Street)
  */
  get street() {
    return this.get(this.streetLanguageItemName);
  }
  /**
  /* "City" (City)
  */
  get city() {
    return this.get(this.cityLanguageItemName);
  }
  /**
  /* "Postalcode" (Postal code)
  */
  get postalcode() {
    return this.get(this.postalcodeLanguageItemName);
  }
}
//Singleton
var VirtualAddressDividerLocalizer$1 = new VirtualAddressDividerLocalizer();

class VirtualAddressDivider extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      readonly: this.props.readonly || false,
      city: "",
      postalCode: "",
      address: ""
    };
    this._addressInputRef = /*#__PURE__*/React.createRef();
    this._cityInputRef = /*#__PURE__*/React.createRef();
    this._postalCodeInputRef = /*#__PURE__*/React.createRef();
  }
  get virtualAddress() {
    return `${this.state.city}, ${this.state.postalCode}, ${this.state.address}`;
  }
  setVirtualAddressAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      const items = value.split(",");
      if (items.length >= 3) {
        const city = value.split(",")[0].trim();
        const postalCode = value.split(",")[1].trim();
        const address = value.split(",")[2].trim();
        yield this.setState({
          city,
          postalCode,
          address
        });
      }
    });
  }
  onCityChangeAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        city: value
      });
    });
  }
  onPostalCodeChangeAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        postalCode: value
      });
    });
  }
  onAddressChangeAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        address: value
      });
    });
  }
  isInput() {
    return true;
  }
  isValid() {
    return !!(this.state.address && this.state.city && this.state.postalCode);
  }
  getName() {
    return this.id;
  }
  getValue() {
    return this.virtualAddress;
  }
  get readonly() {
    return this.state.readonly;
  }
  setReadonlyAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (value !== this.state.readonly) {
        yield this.setState({
          readonly: value
        });
        yield this._addressInputRef.current.setReadonlyAsync(value);
      }
    });
  }
  validateAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this._addressInputRef.current.validateAsync();
      yield this._cityInputRef.current.validateAsync();
      yield this._postalCodeInputRef.current.validateAsync();
    });
  }
  hideEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      // do nothing
    });
  }
  showEditAsync(select) {
    return __awaiter(this, void 0, void 0, function* () {
      // do nothing
    });
  }
  componentDidMount() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.value) {
        yield this.setVirtualAddressAsync(this.props.value);
      }
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OneColumn, null, /*#__PURE__*/React.createElement(TextInput, {
      ref: this._addressInputRef,
      id: `${this.id}_address`,
      required: true,
      label: VirtualAddressDividerLocalizer$1.street,
      value: this.state.address,
      onChange: (sender, value) => this.onAddressChangeAsync(value)
    })), /*#__PURE__*/React.createElement(TwoColumns, null, /*#__PURE__*/React.createElement(TextInput, {
      ref: this._cityInputRef,
      id: `${this.id}_city`,
      required: true,
      label: VirtualAddressDividerLocalizer$1.city,
      value: this.state.city,
      onChange: (sender, value) => this.onCityChangeAsync(value)
    }), /*#__PURE__*/React.createElement(TextInput, {
      ref: this._postalCodeInputRef,
      id: `${this.id}_postalCode`,
      required: true,
      label: VirtualAddressDividerLocalizer$1.postalcode,
      value: this.state.postalCode,
      onChange: (sender, value) => this.onPostalCodeChangeAsync(value)
    })));
  }
}

class ColorInput extends BaseInput {
  constructor() {
    super(...arguments);
    this.state = {
      readonly: this.props.disabled || false,
      model: {
        value: this.props.value || (this.props.model ? this.props.model.value : "#6d6d6d")
      },
      edit: true,
      validationError: null
    };
  }
  setColorAsync(changeEvent) {
    return __awaiter(this, void 0, void 0, function* () {
      this.state.model.value = changeEvent.target.value;
      if (this.props.onChange) {
        yield this.props.onChange(this, changeEvent.target.value);
      }
      yield this.reRenderAsync();
    });
  }
  renderInput() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.props.className
    }, /*#__PURE__*/React.createElement("input", {
      type: "color",
      value: this.props.value,
      disabled: this.readonly,
      onChange: value => this.setColorAsync(value)
    }));
  }
}

var css_248z$N = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-checkbox-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-checkbox-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-checkbox-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-checkbox-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-checkbox-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-checkbox-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-checkbox-checkbox {\n  cursor: pointer;\n  position: relative;\n  color: rgb(254, 80, 0);\n}\n.athenaeum-checkbox-checkbox.athenaeum-checkbox-readonly {\n  color: #adadad;\n}\n.athenaeum-checkbox-checkbox i {\n  vertical-align: middle;\n}\n.athenaeum-checkbox-checkbox .athenaeum-checkbox-square {\n  display: block;\n  position: absolute;\n  top: 6px;\n  left: 4px;\n  width: 16.4px;\n  height: 15.4px;\n  border-radius: 2px;\n  background-color: #fe5000;\n}\n\n.athenaeum-checkbox-checked {\n  cursor: pointer;\n}\n\n.athenaeum-checkbox-unchecked {\n  cursor: pointer;\n}\n\n.athenaeum-checkbox-inlineRight {\n  align-items: center;\n  height: 100%;\n}\n.athenaeum-checkbox-inlineRight .base-input-label {\n  order: 2;\n  margin-left: 0.5rem;\n}\n.athenaeum-checkbox-inlineRight label {\n  cursor: pointer;\n}\n.athenaeum-checkbox-inlineRight div:nth-child(2) {\n  align-items: center;\n  order: 1;\n}";
var styles$H = {"font-renta":"athenaeum-checkbox-font-renta","color-schema-renta_black":"athenaeum-checkbox-color-schema-renta_black","color-schema-renta_white":"athenaeum-checkbox-color-schema-renta_white","color-schema-renta_orange":"athenaeum-checkbox-color-schema-renta_orange","color-schema-renta_green":"athenaeum-checkbox-color-schema-renta_green","color-schema-renta_blue":"athenaeum-checkbox-color-schema-renta_blue","checkbox":"athenaeum-checkbox-checkbox","readonly":"athenaeum-checkbox-readonly","square":"athenaeum-checkbox-square","checked":"athenaeum-checkbox-checked","unchecked":"athenaeum-checkbox-unchecked","inlineRight":"athenaeum-checkbox-inlineRight"};
styleInject(css_248z$N);

var InlineType;
(function (InlineType) {
  InlineType[InlineType["Left"] = 0] = "Left";
  InlineType[InlineType["Right"] = 1] = "Right";
})(InlineType || (InlineType = {}));
class Checkbox extends BaseInput {
  constructor() {
    super(...arguments);
    this.state = {
      validationError: null,
      edit: true,
      readonly: !!this.props.readonly,
      model: {
        value: !!this.props.value
      }
    };
  }
  setAsync(checked) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.checked !== checked) {
        yield this.updateValueAsync(checked);
        if (this.props.onChange) {
          yield this.props.onChange(this, checked);
        }
      }
    });
  }
  onLabelClick() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.toggleAsync();
    });
  }
  getContainerClassName() {
    return this.props.inline && this.props.inlineType && this.props.inlineType === InlineType.Right ? styles$H.inlineRight : "";
  }
  get checked() {
    return this.value;
  }
  get radio() {
    return this.props.radio === true;
  }
  getValidators() {
    return [];
  }
  get value() {
    return this.state.model.value || false;
  }
  getType() {
    return BaseInputType.Checkbox;
  }
  toggleAsync(event = null) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.readonly) {
        yield this.setAsync(!this.checked);
      }
    });
  }
  checkAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.checked) {
        yield this.toggleAsync();
      }
    });
  }
  uncheckAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.checked) {
        yield this.toggleAsync();
      }
    });
  }
  renderInput() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$H.checkbox, this.readonly && styles$H.readonly, this.checked ? styles$H.checked : styles$H.unchecked)
    }, /*#__PURE__*/React.createElement("div", {
      onClick: event => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAsync(event);
      })
    }, this.checked ? this.radio ? ( /*#__PURE__*/React.createElement(Icon, {
      name: "fas check-circle",
      size: IconSize.X2
    })) : ( /*#__PURE__*/React.createElement(Icon, {
      name: "fas check-square",
      size: IconSize.X2
    })) : this.radio ? ( /*#__PURE__*/React.createElement(Icon, {
      name: "far circle",
      size: IconSize.X2
    })) : ( /*#__PURE__*/React.createElement(Icon, {
      name: "far square",
      size: IconSize.X2
    }))));
  }
}

class CheckboxNullable extends BaseInput {
  constructor() {
    super(...arguments);
    this.state = {
      validationError: null,
      edit: true,
      readonly: !!this.props.readonly,
      model: {
        value: this.props.value
      }
    };
  }
  setAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.readonly && this.value !== value) {
        yield this.updateValueAsync(value);
        if (this.props.onChange) {
          yield this.props.onChange(this, value);
        }
      }
    });
  }
  onLabelClick() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.toggleAsync();
    });
  }
  getValidators() {
    return [];
  }
  get value() {
    return this.state.model.value;
  }
  get excludeNull() {
    return !!this.props.excludeNull;
  }
  getType() {
    return BaseInputType.Checkbox;
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      switch (this.value) {
        case true:
          yield this.setAsync(false);
          break;
        case false:
          if (this.excludeNull) {
            yield this.setAsync(true);
          } else {
            yield this.setAsync(null);
          }
          break;
        case null:
          yield this.setAsync(true);
          break;
      }
    });
  }
  checkAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setAsync(true);
    });
  }
  uncheckAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setAsync(false);
    });
  }
  setNullAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.excludeNull) {
        yield this.toggleAsync();
      } else {
        yield this.setAsync(null);
      }
    });
  }
  renderCheckedIcon() {
    if (this.value === null || !this.value) {
      return /*#__PURE__*/React.createElement(Icon, {
        name: "far square",
        size: IconSize.X2
      });
    }
    return /*#__PURE__*/React.createElement(Icon, {
      name: "fas check-square",
      size: IconSize.X2
    });
  }
  renderInput() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$H.checkbox, this.readonly && styles$H.readonly)
    }, /*#__PURE__*/React.createElement("div", {
      className: "position-relative",
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAsync();
      })
    }, this.renderCheckedIcon(), this.value === null && ( /*#__PURE__*/React.createElement("span", {
      className: styles$H.square
    }))));
  }
}

class EmailInput extends TextInput {
  getType() {
    return BaseInputType.Email;
  }
  getValidators() {
    return [EmailValidator.validator];
  }
}

class UrlInput extends TextInput {
  getType() {
    return BaseInputType.Url;
  }
  getValidators() {
    return [UrlValidator.validator];
  }
}

//Autogenerated
class FileInputLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.dragAndDropLanguageItemName = `DragAndDrop`;
    this.readonlyLanguageItemName = `Readonly`;
    this.chooseFileLanguageItemName = `ChooseFile`;
    this.previewLanguageItemName = `Preview`;
    //Initializer
    this.set(this.dragAndDropLanguageItemName, {
      language: `en`,
      value: `Drag'n'drop file here, or click to select`
    }, {
      language: `uk`,
      value: `Перетягніть файл, або оберіть його`
    }, {
      language: `sv`,
      value: `Släpp filen här eller välj genom att trycka`
    }, {
      language: `ru`,
      value: `Перетащите файл сюда или щелкните, чтобы выбрать`
    }, {
      language: `pl`,
      value: `Przeciągnij pliki tutaj i upuść albo kliknij aby wybrać`
    }, {
      language: `nb`,
      value: `Dra og drop filen hit, eller klikk for å velge`
    }, {
      language: `fi`,
      value: `Pudota tiedosto tähän tai valitse klikkaamalla`
    }, {
      language: `da`,
      value: `Placer filen her, eller vælg ved at klikke`
    });
    this.set(this.readonlyLanguageItemName, {
      language: `en`,
      value: `File is readonly`
    }, {
      language: `uk`,
      value: `Файл доступний лише для читання`
    }, {
      language: `sv`,
      value: `Filen är bara läsbar`
    }, {
      language: `ru`,
      value: `Файл доступен только для чтения`
    }, {
      language: `pl`,
      value: `Plik tylko do odczytu`
    }, {
      language: `nb`,
      value: `Filen er skrivebeskyttet`
    }, {
      language: `fi`,
      value: `Tämä tiedosto on vain luettavissa`
    }, {
      language: `da`,
      value: `Fil er readonly`
    });
    this.set(this.chooseFileLanguageItemName, {
      language: `en`,
      value: `Choose file`
    }, {
      language: `uk`,
      value: `Оберіть файл`
    }, {
      language: `sv`,
      value: `Välj fil`
    }, {
      language: `ru`,
      value: `Выберите файл`
    }, {
      language: `pl`,
      value: `Wybierz plik`
    }, {
      language: `nb`,
      value: `Velg fil`
    }, {
      language: `fi`,
      value: `Valitse tiedosto`
    }, {
      language: `da`,
      value: `Vælg fil`
    });
    this.set(this.previewLanguageItemName, {
      language: `en`,
      value: `Preview`
    }, {
      language: `uk`,
      value: `Переглянути`
    }, {
      language: `sv`,
      value: `Förhandsvisning`
    }, {
      language: `ru`,
      value: `Предпросмотр`
    }, {
      language: `pl`,
      value: `Podgląd`
    }, {
      language: `nb`,
      value: `Forhåndsvisning`
    }, {
      language: `fi`,
      value: `Esikatselu`
    }, {
      language: `da`,
      value: `Eksempel`
    });
  }
  /**
  /* "DragAndDrop" (Drag'n'drop file here, or click to select)
  */
  get dragAndDrop() {
    return this.get(this.dragAndDropLanguageItemName);
  }
  /**
  /* "Readonly" (File is readonly)
  */
  get readonly() {
    return this.get(this.readonlyLanguageItemName);
  }
  /**
  /* "ChooseFile" (Choose file)
  */
  get chooseFile() {
    return this.get(this.chooseFileLanguageItemName);
  }
  /**
  /* "Preview" (Preview)
  */
  get preview() {
    return this.get(this.previewLanguageItemName);
  }
}
//Singleton
var FileInputLocalizer$1 = new FileInputLocalizer();

var css_248z$M = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-file-input-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-file-input-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-file-input-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-file-input-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-file-input-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-file-input-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-file-input-file .athenaeum-file-input-dropZone {\n  height: 200px;\n  background-color: aliceblue;\n  border: 2px dashed #ccc;\n  border-radius: 5px;\n  margin-bottom: 10px;\n}\n.athenaeum-file-input-file .athenaeum-file-input-dropZone label {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: copy;\n}\n.athenaeum-file-input-file .athenaeum-file-input-dropZone label .athenaeum-file-input-preview {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n}\n.athenaeum-file-input-file .athenaeum-file-input-dropZone label .athenaeum-file-input-preview .athenaeum-file-input-image {\n  height: 85%;\n  width: 85%;\n  margin: 0 auto;\n  background-position: center !important;\n  background-repeat: no-repeat !important;\n  background-size: contain !important;\n}\n.athenaeum-file-input-file .athenaeum-file-input-selectedFile {\n  font-size: 1em;\n  margin-top: 5px;\n}\n.athenaeum-file-input-file .athenaeum-file-input-selectedFile i {\n  color: #a94442;\n  margin-left: 8px;\n  cursor: pointer;\n}\n.athenaeum-file-input-file .athenaeum-file-input-selectedFile .athenaeum-file-input-clickable {\n  cursor: pointer;\n}\n.athenaeum-file-input-file.athenaeum-file-input-readonly {\n  pointer-events: none;\n}\n.athenaeum-file-input-file.athenaeum-file-input-readonly label {\n  opacity: 0.65;\n}\n.athenaeum-file-input-file.athenaeum-file-input-readonly .athenaeum-file-input-selectedFile {\n  pointer-events: auto;\n}\n.athenaeum-file-input-file.athenaeum-file-input-readonly .athenaeum-file-input-selectedFile i {\n  display: none;\n}";
var styles$G = {"font-renta":"athenaeum-file-input-font-renta","color-schema-renta_black":"athenaeum-file-input-color-schema-renta_black","color-schema-renta_white":"athenaeum-file-input-color-schema-renta_white","color-schema-renta_orange":"athenaeum-file-input-color-schema-renta_orange","color-schema-renta_green":"athenaeum-file-input-color-schema-renta_green","color-schema-renta_blue":"athenaeum-file-input-color-schema-renta_blue","file":"athenaeum-file-input-file","dropZone":"athenaeum-file-input-dropZone","preview":"athenaeum-file-input-preview","image":"athenaeum-file-input-image","selectedFile":"athenaeum-file-input-selectedFile","clickable":"athenaeum-file-input-clickable","readonly":"athenaeum-file-input-readonly"};
styleInject(css_248z$M);

class FileInput extends BaseInput {
  constructor() {
    super(...arguments);
    this.state = {
      readonly: this.props.disabled || false,
      model: {
        value: this.props.value || (this.props.model ? this.props.model.value : null)
      },
      edit: true,
      validationError: null
    };
  }
  get hidden() {
    return this.props.hidden === true;
  }
  getValidators() {
    return [FileSizeValidator.validator(this.props.maxSize), FileTypeValidator.validator(this.props.fileTypes), FilesSizeValidator.validator(this.props.maxTotalSize)];
  }
  openAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.inputElement) {
        this.inputElement.click();
      }
    });
  }
  getType() {
    return BaseInputType.File;
  }
  valueBlurHandlerAsync() {
    const _super = Object.create(null, {
      validateAsync: {
        get: () => super.validateAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.validateAsync.call(this);
      if (this.props.onBlur) {
        yield this.props.onBlur(this);
      }
    });
  }
  getFileReferences(fileList) {
    const fileReferences = [];
    if (fileList) {
      const length = fileList.length;
      for (let i = 0; i < length; i++) {
        fileReferences.push(fileList[i]);
      }
    }
    return fileReferences;
  }
  valueChangeHandlerAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      const changeEvent = event;
      const fileReferences = changeEvent.target.files;
      yield this.fileChangeAsync(fileReferences);
    });
  }
  onDropHandlerAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      this.preventEventDefaultBehavior(event);
      const fileReferences = event.nativeEvent.dataTransfer.files;
      yield this.fileChangeAsync(fileReferences);
    });
  }
  fileChangeAsync(fileList) {
    return __awaiter(this, void 0, void 0, function* () {
      const fileReferences = this.getFileReferences(fileList);
      if (this.props.multiple) {
        const files = [];
        for (let i = 0; i < fileReferences.length; i++) {
          const file = yield Utility.transformFileAsync(fileReferences[i]);
          if (file) {
            files.push(file);
          }
        }
        if (files.length) {
          const existingFiles = this.value || [];
          const newFiles = files.where(file => !existingFiles.some(item => item.name == file.name));
          if (newFiles.length > 0) {
            const newValue = existingFiles.concat(newFiles);
            yield this.updateValueAsync(newValue);
            if (this.props.onChange) {
              yield this.props.onChange(this, newFiles);
            }
          }
        }
      } else {
        const fileReference = fileReferences.firstOrDefault();
        const file = yield Utility.transformFileAsync(fileReference);
        yield this.updateValueAsync(file);
        if (this.props.onChange) {
          yield this.props.onChange(this, this.state.model.value || []);
        }
      }
    });
  }
  removeSelectedFileAsync(index = null) {
    return __awaiter(this, void 0, void 0, function* () {
      let value;
      let removedValue;
      if (index !== null && this.value instanceof Array && this.value.length > 0) {
        const copyValue = [...this.value];
        removedValue = copyValue.splice(index, 1)[0];
        value = copyValue;
      } else {
        removedValue = this.value;
        value = null;
      }
      yield this.updateValueAsync(value);
      if (this.props.onRemove && removedValue != null) {
        yield this.props.onRemove(removedValue);
      }
    });
  }
  onClickHandlerAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onClick) {
        yield this.props.onClick(this, value);
      }
    });
  }
  preventEventDefaultBehavior(e) {
    e.preventDefault();
    e.stopPropagation();
  }
  onDragOverHandler(e) {
    this.preventEventDefaultBehavior(e);
  }
  get acceptedTypes() {
    return this.props.fileTypes && this.props.fileTypes.length ? this.props.fileTypes.join(",") : "";
  }
  get placeholder() {
    return this.readonly ? FileInputLocalizer$1.readonly : this.props.placeholder || FileInputLocalizer$1.dragAndDrop;
  }
  renderPreview() {
    let imagePreviewStyle = {};
    if (!this.props.multiple) {
      imagePreviewStyle = this.state.model.value ? {
        background: `url(${this.state.model.value.src})`
      } : {};
    }
    return /*#__PURE__*/React.createElement("div", {
      className: styles$G.preview
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$G.image,
      style: imagePreviewStyle
    }), FileInputLocalizer$1.preview);
  }
  renderFile() {
    if (this.value instanceof Array) {
      return this.value.length > 0 && this.value.map((file, index) => /*#__PURE__*/React.createElement("div", {
        key: file.name,
        className: styles$G.selectedFile
      }, /*#__PURE__*/React.createElement("span", {
        className: this.css(this.props.onClick && styles$G.clickable),
        onClick: () => this.onClickHandlerAsync(file)
      }, file.name), /*#__PURE__*/React.createElement(Icon, {
        name: "trash-alt",
        onClick: () => __awaiter(this, void 0, void 0, function* () {
          return yield this.removeSelectedFileAsync(index);
        }),
        confirm: file.id && this.props.removeConfirmation
      })));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$G.selectedFile
      }, /*#__PURE__*/React.createElement("span", {
        className: this.css(this.props.onClick && styles$G.clickable),
        onClick: () => this.onClickHandlerAsync(this.value)
      }, this.value.name), /*#__PURE__*/React.createElement(Icon, {
        name: "trash-alt",
        onClick: () => __awaiter(this, void 0, void 0, function* () {
          return yield this.removeSelectedFileAsync();
        }),
        confirm: this.value.id && this.props.removeConfirmation
      }));
    }
  }
  renderInput() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$G.file, this.readonly && styles$G.readonly)
    }, this.props.dropZone && !this.hidden && ( /*#__PURE__*/React.createElement("div", {
      className: styles$G.dropZone,
      onDrop: e => this.onDropHandlerAsync(e),
      onDragOver: e => this.onDragOverHandler(e)
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: this.getInputId()
    }, /*#__PURE__*/React.createElement("span", null, this.placeholder), this.state.model.value && this.props.dropZone && !this.props.multiple && this.state.model.value.src.startsWith("data:image") && this.renderPreview()))), !this.props.dropZone && !this.hidden && ( /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center"
    }, /*#__PURE__*/React.createElement("label", {
      className: this.css("btn m-0", this.props.labelClassName ? this.props.labelClassName : "btn-info"),
      htmlFor: this.getInputId()
    }, FileInputLocalizer$1.chooseFile, " ", this.value && this.value.length > 0 && `(${this.value.length})`))), /*#__PURE__*/React.createElement("input", {
      id: this.getInputId(),
      hidden: true,
      type: this.getType(),
      value: "",
      multiple: this.props.multiple,
      className: "form-control-file",
      ref: this.props.forwardedRef,
      style: this.props.dropZone ? {
        display: "none"
      } : {},
      disabled: this.readonly,
      accept: this.acceptedTypes,
      onChange: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.valueChangeHandlerAsync(e);
      }),
      onBlur: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.valueBlurHandlerAsync();
      }),
      capture: this.props.capture
    }), this.value && this.renderFile());
  }
}

class PasswordInput extends TextInput {
  getType() {
    return BaseInputType.Password;
  }
}

class PhoneInput extends TextInput {
  getType() {
    return BaseInputType.Text;
  }
  getValidators() {
    return [PhoneValidator.validator];
  }
}

var css_248z$L = ".rc-slider-tooltip {\n  z-index: 10000;\n}";
styleInject(css_248z$L);

class Slider extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      defaultValue: this.props.defaultValue || 0,
      value: this.props.defaultValue || 0
    };
    this._sliderWithTooltip = createSliderWithTooltip(SliderComponent);
  }
  handleChangeAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        const newSliderValue = this.props.minimumAllowed <= value && value <= this.props.maximumAllowed ? value : this.state.defaultValue;
        yield this.setState({
          value: newSliderValue
        });
        if (this.props.onChange) {
          yield this.props.onChange(this, newSliderValue);
        }
      }
    });
  }
  get sliderId() {
    return this.props.id || this.id;
  }
  callbackAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      // if(this.props.onChange) {
      //     await this.props.onChange(this);
      // }
    });
  }
  get min() {
    return this.props.min || 0;
  }
  get max() {
    return this.props.max || 100;
  }
  get step() {
    return this.props.step || 1;
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (nextProps.defaultValue !== undefined && this.state.defaultValue !== nextProps.defaultValue) {
        this.setState({
          defaultValue: nextProps.defaultValue,
          value: nextProps.defaultValue
        });
      }
    });
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$16.slider,
      id: this.sliderId
    }, /*#__PURE__*/React.createElement(this._sliderWithTooltip, {
      min: this.min,
      max: this.max,
      step: this.step,
      onChange: values => this.handleChangeAsync(values),
      trackStyle: {
        backgroundColor: "#fe5000"
      },
      handleStyle: {
        borderColor: "#fe5000"
      },
      onAfterChange: () => this.callbackAsync(),
      value: this.state.value,
      disabled: this.props.disabled
    }));
  }
}
Slider.defaultProps = {
  maximumAllowed: 100,
  minimumAllowed: 0
};

class Range extends BaseInput {
  constructor(props) {
    super(props);
    this._rangeWithTooltip = createSliderWithTooltip(Range$1);
  }
  handleChangeAsync(values) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        if (this.props.onChange) {
          yield this.props.onChange(this, this.state.model.value);
        }
        yield this.setState({
          model: {
            value: values
          }
        });
      }
    });
  }
  get min() {
    return this.props.min || 0;
  }
  get max() {
    return this.props.max || 100;
  }
  get step() {
    return this.props.step || 1;
  }
  get count() {
    return this.props.count || 2;
  }
  get defaultValue() {
    return this.props.defaultValue || [this.min, this.max];
  }
  renderInput() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$16.slider
    }, /*#__PURE__*/React.createElement(this._rangeWithTooltip, {
      allowCross: true,
      min: this.min,
      max: this.max,
      step: this.step,
      count: this.count,
      defaultValue: this.defaultValue,
      onChange: values => this.handleChangeAsync(values),
      trackStyle: [{
        backgroundColor: "#fe5000"
      }],
      handleStyle: [{
        borderColor: "#fe5000"
      }]
    }));
  }
}

var css_248z$K = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-switch-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-switch-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-switch-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-switch-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-switch-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-switch-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-switch-switch, .athenaeum-switch-container .athenaeum-switch-nullableSwitch, .athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked, .athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked, .athenaeum-switch-checked {\n  width: 56px;\n  height: 32px;\n  border: 1px solid lightgrey;\n  border-radius: 5px;\n  background-color: white;\n  position: relative;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n.athenaeum-switch-switch .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitch .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked .athenaeum-switch-toggler, .athenaeum-switch-checked .athenaeum-switch-toggler {\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  height: inherit;\n  width: 20px;\n  border: inherit;\n  border-radius: 5px;\n  background-color: white;\n  transition: all 0.3s ease;\n}\n.athenaeum-switch-switch.athenaeum-switch-readonly, .athenaeum-switch-container .athenaeum-switch-readonly.athenaeum-switch-nullableSwitch, .athenaeum-switch-container .athenaeum-switch-readonly.athenaeum-switch-nullableSwitchUnchecked, .athenaeum-switch-container .athenaeum-switch-readonly.athenaeum-switch-nullableSwitchChecked, .athenaeum-switch-readonly.athenaeum-switch-checked {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.athenaeum-switch-checked {\n  background-color: rgb(254, 80, 0);\n}\n.athenaeum-switch-checked .athenaeum-switch-toggler, .athenaeum-switch-checked .athenaeum-switch-container .athenaeum-switch-nullableSwitch .athenaeum-switch-toggler, .athenaeum-switch-checked .athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked .athenaeum-switch-toggler, .athenaeum-switch-checked .athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitch .athenaeum-switch-checked .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked .athenaeum-switch-checked .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked .athenaeum-switch-checked .athenaeum-switch-toggler {\n  background-color: white;\n  left: 35px;\n}\n\n.athenaeum-switch-container {\n  display: flex;\n  align-items: center;\n}\n.athenaeum-switch-container .athenaeum-switch-nullableSwitch, .athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked, .athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked {\n  background-color: lightgrey;\n  width: 84px;\n  display: flex;\n}\n.athenaeum-switch-container .athenaeum-switch-nullableSwitch .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked .athenaeum-switch-toggler, .athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked .athenaeum-switch-toggler {\n  left: calc(50% - 10px);\n}\n.athenaeum-switch-container .athenaeum-switch-nullableSwitch .athenaeum-switch-zone, .athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked .athenaeum-switch-zone, .athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked .athenaeum-switch-zone {\n  width: 100%;\n}\n.athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked {\n  background-color: #28a745;\n}\n.athenaeum-switch-container .athenaeum-switch-nullableSwitchChecked .athenaeum-switch-toggler {\n  background-color: white;\n  left: calc(100% - 19px);\n}\n.athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked {\n  background-color: #dc3545;\n}\n.athenaeum-switch-container .athenaeum-switch-nullableSwitchUnchecked .athenaeum-switch-toggler {\n  background-color: white;\n  left: -1px;\n}\n.athenaeum-switch-container .athenaeum-switch-label:first-of-type {\n  margin-right: 4px;\n}\n.athenaeum-switch-container .athenaeum-switch-label:last-of-type {\n  margin-left: 4px;\n}";
var styles$F = {"font-renta":"athenaeum-switch-font-renta","color-schema-renta_black":"athenaeum-switch-color-schema-renta_black","color-schema-renta_white":"athenaeum-switch-color-schema-renta_white","color-schema-renta_orange":"athenaeum-switch-color-schema-renta_orange","color-schema-renta_green":"athenaeum-switch-color-schema-renta_green","color-schema-renta_blue":"athenaeum-switch-color-schema-renta_blue","switch":"athenaeum-switch-switch","container":"athenaeum-switch-container","nullableSwitch":"athenaeum-switch-nullableSwitch","nullableSwitchUnchecked":"athenaeum-switch-nullableSwitchUnchecked","nullableSwitchChecked":"athenaeum-switch-nullableSwitchChecked","checked":"athenaeum-switch-checked","toggler":"athenaeum-switch-toggler","readonly":"athenaeum-switch-readonly","zone":"athenaeum-switch-zone","label":"athenaeum-switch-label"};
styleInject(css_248z$K);

class Switch extends Checkbox {
  renderInput() {
    const toggleStyles = this.checked ? styles$F.checked : styles$F.switch;
    return /*#__PURE__*/React.createElement("div", {
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAsync();
      }),
      className: this.css(toggleStyles, this.readonly && styles$F.readonly)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$F.toggler
    }));
  }
}

var TabRenderType;
(function (TabRenderType) {
  /**
   * Tab content will be always rendered
   */
  TabRenderType[TabRenderType["Always"] = 0] = "Always";
  /**
   * Only active tab content will be rendered
   */
  TabRenderType[TabRenderType["ActiveOnly"] = 1] = "ActiveOnly";
  /**
   * Tab content will be rendered once during tab activation
   */
  TabRenderType[TabRenderType["Once"] = 2] = "Once";
})(TabRenderType || (TabRenderType = {}));
class TabContainerModel {
  constructor() {
    this.id = "";
    this.className = null;
    this.scale = false;
    this.dataStorageType = DataStorageType.Page;
    this.renderType = TabRenderType.Always;
    this.tabs = [];
    this.instance = {};
  }
  restoreActiveTabIndex() {
    const lastActiveIndex = UserInteractionDataStorage.get(this.id, -1, this.dataStorageType);
    if (lastActiveIndex >= 0 && lastActiveIndex < this.tabs.length) {
      const tab = this.tabs[lastActiveIndex];
      if (!tab.closed && !tab.ignorable) {
        return lastActiveIndex;
      }
    }
    return this.tabs.findIndex(tab => !tab.closed && !tab.ignorable);
  }
  saveActiveTabIndex() {
    UserInteractionDataStorage.set(this.id, this.activeIndex, this.dataStorageType);
  }
  get activeIndex() {
    return this.tabs.findIndex(item => item.active && !item.closed);
  }
  getActiveTab() {
    return this.tabs.find(tab => tab.active) || null;
  }
  getTabIds() {
    return this.tabs.map(tab => tab.id);
  }
  activateDefault(prevActiveIndex = null) {
    if (this.tabs.length > 0) {
      let newActiveIndex = this.tabs.findIndex(tab => !tab.closed && !tab.ignorable && tab.active);
      if (newActiveIndex === -1) {
        if (prevActiveIndex != null && prevActiveIndex >= 0 && prevActiveIndex < this.tabs.length && !this.tabs[prevActiveIndex].closed && !this.tabs[prevActiveIndex].ignorable) {
          newActiveIndex = prevActiveIndex;
        } else {
          newActiveIndex = this.restoreActiveTabIndex();
        }
      }
      this.tabs.forEach(tab => tab.active = tab.index === newActiveIndex);
      this.saveActiveTabIndex();
    }
  }
  activateTabAsync(tabOrIndexOrId) {
    return __awaiter(this, void 0, void 0, function* () {
      const tab = typeof tabOrIndexOrId == "number" ? tabOrIndexOrId >= 0 && tabOrIndexOrId < this.tabs.length ? this.tabs[tabOrIndexOrId] : null : typeof tabOrIndexOrId == "string" ? this.tabs.find(tab => tab.id == tabOrIndexOrId) || null : tabOrIndexOrId;
      if (tab && !tab.active && !tab.closed) {
        if (!tab.ignorable) {
          const activeTab = this.getActiveTab();
          if (activeTab) {
            activeTab.active = false;
            yield activeTab.reRenderAsync();
          }
          tab.active = true;
          this.saveActiveTabIndex();
          yield tab.reRenderAsync();
        }
        if (tab.onSelect) {
          yield tab.onSelect(tab);
        }
        if (this.onSelect) {
          yield this.onSelect(tab);
        }
      }
    });
  }
  closeTabAsync(tab, confirmed, data) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!tab.closed) {
        const confirmNeeded = !!tab.closeConfirm && !confirmed;
        if (confirmNeeded && tab.closeConfirmDialogRef.current) {
          yield tab.closeConfirmDialogRef.current.openAsync();
          return;
        }
        // Close the tab:
        tab.closed = true;
        if (tab.active) {
          tab.active = false;
          if (tab.index > 0) {
            const prevTab = this.tabs[tab.index - 1];
            prevTab.active = true;
            yield prevTab.reRenderAsync();
          }
        }
        this.saveActiveTabIndex();
        yield tab.reRenderAsync();
        if (tab.onClose) {
          yield tab.onClose(tab, data);
        }
        if (this.onClose) {
          yield this.onClose(tab);
        }
      }
    });
  }
}
class TabModel {
  constructor() {
    this.id = "";
    this.title = "";
    this.tooltip = "";
    /** Text to display in the tab's badge. Typically a number indicating the count of something interesting. */
    this.badge = "";
    /** Back ground color of tab's badge. e.g. rgb(254,80,0). Defaults to Blue rgb(13,110,253). Enabled only with badge. */
    this.badgeBackgroundColor = "";
    /**  The Shape of tab's badge. Defaults to the shape Pill. Enabled only with badge. */
    this.tabBadgeShape = TabBadgeShape.Pill;
    this.className = null;
    this.activeClassName = null;
    this.icon = null;
    this.ignorable = false;
    this.active = false;
    this.closed = false;
    this.index = 0;
    this.container = new TabContainerModel();
    this.instance = {};
    this.headerInstance = {};
    this.closeConfirm = null;
    this.closeConfirmDialogRef = /*#__PURE__*/React.createRef();
  }
  reRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.headerInstance.reRenderAsync) {
        yield this.headerInstance.reRenderAsync();
      }
      if (this.instance.reRenderAsync) {
        yield this.instance.reRenderAsync();
      }
    });
  }
}
class TabTransformer {
  static toTab(from, id) {
    const to = new TabModel();
    to.id = id;
    to.active = from.active || false;
    to.className = from.className || null;
    to.activeClassName = from.activeClassName || null;
    to.icon = from.icon || null;
    to.ignorable = from.ignorable || false;
    to.title = from.title || "";
    to.tooltip = from.tooltip || "";
    to.badge = from.badge || "";
    to.badgeBackgroundColor = from.badgeBackgroundColor || "";
    to.tabBadgeShape = from.tabBadgeShape || TabBadgeShape.Pill;
    to.closeConfirm = from.closeConfirm || null;
    to.onSelect = from.onSelect;
    to.onClose = from.onClose;
    return to;
  }
  static toTabContainer(from, id) {
    const to = new TabContainerModel();
    to.id = id;
    to.className = from.className || null;
    to.scale = from.scale || false;
    to.dataStorageType = from.dataStorageType || DataStorageType.Page;
    to.renderType = from.renderType || TabRenderType.Always;
    to.tabs = [];
    to.onSelect = from.onSelect;
    to.onClose = from.onClose;
    return to;
  }
}

//Autogenerated
class TabContainerLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Initializer
  }
}
//Singleton
var TabContainerLocalizer$1 = new TabContainerLocalizer();

var css_248z$J = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-tab-container-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-tab-container-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-tab-container-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-tab-container-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-tab-container-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-tab-container-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-tab-container-row {\n  flex-direction: row;\n}\n.athenaeum-tab-container-row .athenaeum-tab-container-scrollableContainer {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  overflow-y: auto;\n  max-height: 50vh;\n}\n.athenaeum-tab-container-row .athenaeum-tab-container-scrollableContainer ul {\n  display: flex;\n  flex-direction: column;\n}\n.athenaeum-tab-container-row .athenaeum-tab-container-tabContent {\n  overflow: auto;\n  width: 100%;\n}\n\n.athenaeum-tab-container-column {\n  flex-direction: column;\n}\n.athenaeum-tab-container-column .athenaeum-tab-container-scrollableContainer {\n  display: flex;\n  flex-direction: row;\n  height: 64px;\n  overflow: hidden;\n  overflow-x: auto;\n}\n.athenaeum-tab-container-column .athenaeum-tab-container-scrollableContainer ul {\n  white-space: nowrap;\n  flex-wrap: nowrap;\n}\n\n.athenaeum-tab-container-tabContainer {\n  height: 100%;\n  display: flex;\n  width: auto;\n  min-width: 100%;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-underlineTabStyle, .athenaeum-tab-container-tabContainer span .athenaeum-tab-container-underlineTabStyleInactive::after, .athenaeum-tab-container-tabContainer span .athenaeum-tab-container-underlineTabStyleInactive, .athenaeum-tab-container-tabContainer span .athenaeum-tab-container-underlineTabStyleActive::after, .athenaeum-tab-container-tabContainer span .athenaeum-tab-container-underlineTabStyleActive {\n  font-size: 20px;\n  box-shadow: none !important;\n  background-color: transparent !important;\n  border: 0;\n}\n.athenaeum-tab-container-tabContainer span .athenaeum-tab-container-underlineTabStyleActive {\n  color: #333 !important;\n}\n.athenaeum-tab-container-tabContainer span .athenaeum-tab-container-underlineTabStyleActive::after {\n  content: \"\";\n  height: 7px;\n  background: rgb(254, 80, 0) !important;\n  border-radius: 5px;\n  display: block;\n  color: #333 !important;\n}\n.athenaeum-tab-container-tabContainer span .athenaeum-tab-container-underlineTabStyleInactive {\n  color: #333 !important;\n}\n.athenaeum-tab-container-tabContainer span .athenaeum-tab-container-underlineTabStyleInactive::after {\n  content: \"\";\n  height: 7px;\n  background: #adadad !important;\n  border-radius: 5px;\n  display: block;\n  color: #333 !important;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-navigationContainer {\n  position: relative;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-navigationContainer .athenaeum-tab-container-navigationIcon {\n  padding: 10px 4px;\n  top: 0;\n  position: absolute;\n  cursor: pointer;\n  z-index: 1;\n  border-radius: 5px;\n  color: rgb(254, 80, 0);\n  display: none;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-navigationContainer .athenaeum-tab-container-navigationIcon.athenaeum-tab-container-left {\n  left: -16px;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-navigationContainer .athenaeum-tab-container-navigationIcon.athenaeum-tab-container-right {\n  right: -16px;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-navigationContainer .athenaeum-tab-container-scrollableContainer {\n  position: relative;\n  scroll-behavior: smooth;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-navigationContainer .athenaeum-tab-container-scrollableContainer ul {\n  position: relative;\n  white-space: nowrap;\n  flex-wrap: nowrap;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-tab .athenaeum-tab-container-closed {\n  display: none;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-tab .athenaeum-tab-container-icon.athenaeum-tab-container-hasText {\n  margin-left: -4px;\n  margin-right: 4px;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-tab .athenaeum-tab-container-close {\n  margin-left: 8px;\n  cursor: pointer;\n  opacity: 0.3;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-tab .athenaeum-tab-container-close:hover {\n  opacity: 1;\n}\n.athenaeum-tab-container-tabContainer .athenaeum-tab-container-badge {\n  margin-left: 5px;\n}";
var styles$E = {"font-renta":"athenaeum-tab-container-font-renta","color-schema-renta_black":"athenaeum-tab-container-color-schema-renta_black","color-schema-renta_white":"athenaeum-tab-container-color-schema-renta_white","color-schema-renta_orange":"athenaeum-tab-container-color-schema-renta_orange","color-schema-renta_green":"athenaeum-tab-container-color-schema-renta_green","color-schema-renta_blue":"athenaeum-tab-container-color-schema-renta_blue","row":"athenaeum-tab-container-row","scrollableContainer":"athenaeum-tab-container-scrollableContainer","tabContent":"athenaeum-tab-container-tabContent","column":"athenaeum-tab-container-column","tabContainer":"athenaeum-tab-container-tabContainer","underlineTabStyle":"athenaeum-tab-container-underlineTabStyle","underlineTabStyleInactive":"athenaeum-tab-container-underlineTabStyleInactive","underlineTabStyleActive":"athenaeum-tab-container-underlineTabStyleActive","navigationContainer":"athenaeum-tab-container-navigationContainer","navigationIcon":"athenaeum-tab-container-navigationIcon","left":"athenaeum-tab-container-left","right":"athenaeum-tab-container-right","tab":"athenaeum-tab-container-tab","closed":"athenaeum-tab-container-closed","icon":"athenaeum-tab-container-icon","hasText":"athenaeum-tab-container-hasText","close":"athenaeum-tab-container-close","badge":"athenaeum-tab-container-badge"};
styleInject(css_248z$J);

/**
 * Enum used to describe header style. Values:
 * > {@linkcode TabContainerHeaderStyleType.Default} <br />
 * > {@linkcode TabContainerHeaderStyleType.Underline}
 */
var TabContainerHeaderStyleType;
(function (TabContainerHeaderStyleType) {
  /**
   * Renders tab headers in default (button) appearance.
   */
  TabContainerHeaderStyleType[TabContainerHeaderStyleType["Default"] = 0] = "Default";
  /**
   * Renders tab headers as underlined text, where selected is highlighted with orange.
   */
  TabContainerHeaderStyleType[TabContainerHeaderStyleType["Underline"] = 1] = "Underline";
})(TabContainerHeaderStyleType || (TabContainerHeaderStyleType = {}));
class TabHeader extends BaseComponent {
  onClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.model.container.activateTabAsync(this.model);
    });
  }
  onCloseAsync(confirmed = false, data = "") {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.model.container.closeTabAsync(this.model, confirmed, data);
    });
  }
  get model() {
    return this.props.model;
  }
  get classNames() {
    var _a;
    const classNamesCopy = (_a = Object.assign({}, this.props.classNames)) !== null && _a !== void 0 ? _a : {};
    Object.keys(styles$E).forEach(key => !classNamesCopy[key] ? classNamesCopy[key] = styles$E[key] : classNamesCopy[key]);
    return classNamesCopy;
  }
  renderLink() {
    const model = this.model;
    model.headerInstance = this;
    const activeStyle = model.active && "active" || "";
    const iconStyle = !!model.title && styles$E.hasText || "";
    const typedHeaderStyle = this.props.headerStyleType == TabContainerHeaderStyleType.Underline ? model.active ? this.css(styles$E.underlineTabStyleActive) : styles$E.underlineTabStyleInactive : "";
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    return /*#__PURE__*/React.createElement("a", {
      className: this.css("nav-link", activeStyle, this.classNames.headerLink, typedHeaderStyle),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onClickAsync();
      })
    }, model.icon && ( /*#__PURE__*/React.createElement(Icon, Object.assign({
      className: this.css(styles$E.icon, iconStyle, this.classNames.headerIcon)
    }, model.icon))), TabContainerLocalizer$1.get(model.title), model.onClose && ( /*#__PURE__*/React.createElement(Icon, {
      className: this.css(styles$E.close, this.classNames.headerClose),
      name: "fa fa-times",
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onCloseAsync();
      })
    })), model.closeConfirm && ( /*#__PURE__*/React.createElement(ConfirmationDialog, {
      ref: model.closeConfirmDialogRef,
      title: model.closeConfirm,
      callback: (caller, data) => this.onCloseAsync(true, data)
    })), model.badge && this.renderBadge(model));
  }
  renderBadge(model) {
    if (model.badgeBackgroundColor) {
      return /*#__PURE__*/React.createElement(Badge$1, {
        pill: model.tabBadgeShape === TabBadgeShape.Pill,
        className: styles$E.badge,
        style: {
          backgroundColor: model.badgeBackgroundColor
        },
        bg: model.badgeBackgroundColor
      }, model.badge);
    }
    return /*#__PURE__*/React.createElement(Badge$1, {
      pill: model.tabBadgeShape === TabBadgeShape.Pill,
      className: styles$E.badge
    }, model.badge);
  }
  render() {
    const model = this.model;
    model.headerInstance = this;
    const closedStyle = model.closed && styles$E.closed || "";
    const activeCustomStyle = model.active && model.activeClassName || "";
    return /*#__PURE__*/React.createElement("li", {
      id: this.props.id,
      className: this.css("nav-item", styles$E.tab, closedStyle, model.className, activeCustomStyle, this.classNames.headerTab),
      title: TabContainerLocalizer$1.get(model.tooltip)
    }, this.props.headerStyleType == TabContainerHeaderStyleType.Underline ? ( /*#__PURE__*/React.createElement("span", null, this.renderLink())) : this.renderLink());
  }
}

var css_248z$I = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.tabContainer .nav-tabs {\n  margin-bottom: 16px;\n  padding-bottom: 8px;\n  border-bottom: none;\n}\n.tabContainer .nav-tabs .nav-item {\n  margin-bottom: 8px;\n}\n.tabContainer .nav-tabs .nav-item:not(:last-child) {\n  margin-right: 8px;\n}\n.tabContainer .nav-tabs .nav-item .nav-link {\n  color: #495057;\n  cursor: pointer;\n  border-radius: 4px;\n  border-color: #ccc;\n  padding: 6px 12px;\n}\n.tabContainer .nav-tabs .nav-item .nav-link.active {\n  color: white;\n  cursor: default;\n  background-color: rgb(254, 80, 0);\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);\n}\n.tabContainer .nav-tabs .nav-item .nav-link:hover:not(.active) {\n  background-color: rgba(227, 227, 226, 0.5);\n}\n.tabContainer .tab-content {\n  height: 100%;\n}\n.tabContainer .tab-content .tab-pane {\n  flex-direction: column;\n}\n.tabContainer .tab-content .tab-pane.active {\n  display: flex;\n}";
styleInject(css_248z$I);

class TabContainer extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      generation: 0
    };
    this._model = null;
  }
  getTabs() {
    return this.childComponents.filter(item => item.isTab).map(item => item);
  }
  forcedReRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        generation: this.state.generation + 1
      });
    });
  }
  initialized() {
    let initialized = false;
    if (this._model != null) {
      const modelTabIds = this._model.getTabIds();
      if (modelTabIds.length == this.children.length) {
        const tabIds = this.getTabs().map(tab => tab.id);
        initialized = tabIds.length === modelTabIds.length && tabIds.every((id, index) => id === modelTabIds[index]);
      }
    }
    return initialized;
  }
  componentDidMount() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.initialized()) {
        yield this.forcedReRenderAsync();
        if (this.model.onSelect) {
          const activeTab = this.model.getActiveTab();
          if (activeTab) {
            yield this.model.onSelect(activeTab);
          }
        }
      }
    });
  }
  get model() {
    const model = this._model || (this._model = TabTransformer.toTabContainer(this.props, this.id));
    if (!this.initialized()) {
      const activeIndex = model.activeIndex;
      const tabs = this.getTabs();
      model.tabs = [];
      tabs.forEach((tab, index) => {
        tab.initialize(model, index);
        const tabModel = tab.model;
        model.tabs.push(tabModel);
      });
      model.activateDefault(activeIndex);
    }
    return model;
  }
  get tabContainerStyleType() {
    var _a;
    return (_a = this.props.headerStyleType) !== null && _a !== void 0 ? _a : TabContainerHeaderStyleType.Default;
  }
  get classNames() {
    var _a;
    const classNamesCopy = (_a = Object.assign({}, this.props.classNames)) !== null && _a !== void 0 ? _a : {};
    Object.keys(styles$E).forEach(key => !classNamesCopy[key] ? classNamesCopy[key] = styles$E[key] : classNamesCopy[key]);
    return classNamesCopy;
  }
  render() {
    const model = this.model;
    model.instance = this;
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(styles$E.tabContainer, "tabContainer", this.props.className, this.classNames.tabContainer, this.props.tabsOnSide ? styles$E.row : styles$E.column)
    }, /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$E.navigationContainer, this.classNames.navigationContainer)
    }, /*#__PURE__*/React.createElement(NoSwipeNavigation, {
      className: this.css(styles$E.scrollableContainer, this.classNames.scrollableContainer)
    }, /*#__PURE__*/React.createElement("ul", {
      className: this.css("nav nav-tabs", styles$E.navTabs, this.classNames.navTabs)
    }, model.tabs.map(tab => ( /*#__PURE__*/React.createElement(TabHeader, {
      id: "tab_" + tab.id,
      model: tab,
      key: "tab_header_" + tab.id,
      classNames: this.classNames,
      headerStyleType: this.tabContainerStyleType
    })))))), /*#__PURE__*/React.createElement("div", {
      className: this.css("tab-content", this.classNames.tabContent, styles$E.tabContent)
    }, this.children));
  }
}

class Tab extends BaseComponent {
  constructor() {
    super(...arguments);
    this._initialized = false;
    this._rendered = false;
    this._model = null;
    this.isTab = true;
  }
  get model() {
    return this._model || (this._model = TabTransformer.toTab(this.props, this.id));
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentWillReceiveProps.call(this, nextProps);
      const newClose = nextProps.onClose !== this.model.onClose;
      const newIcon = nextProps.icon !== this.model.icon;
      const newClassName = nextProps.className !== this.model.className;
      const newTitle = nextProps.title !== this.model.title;
      const newTooltip = nextProps.tooltip !== this.model.tooltip;
      const newBadge = nextProps.badge !== this.model.badge;
      const newBadgePill = nextProps.tabBadgeShape !== this.model.tabBadgeShape;
      const newBadgeBackgroundColor = nextProps.badgeBackgroundColor !== this.model.badgeBackgroundColor;
      if (newClose || newIcon || newClassName || newTitle || newTooltip || newBadge || newBadgePill || newBadgeBackgroundColor) {
        this.model.onClose = nextProps.onClose;
        this.model.icon = nextProps.icon || null;
        this.model.className = nextProps.className || null;
        this.model.title = nextProps.title || "";
        this.model.tooltip = nextProps.tooltip || "";
        this.model.badge = nextProps.badge || "";
        this.model.tabBadgeShape = nextProps.tabBadgeShape || TabBadgeShape.Pill;
        this.model.badgeBackgroundColor = nextProps.badgeBackgroundColor || "";
        yield this.model.reRenderAsync();
      }
    });
  }
  initialize(container, index) {
    this._model = null;
    this.model.container = container;
    this.model.index = index;
    this._initialized = true;
  }
  render() {
    const model = this.model;
    const container = model.container;
    model.instance = this;
    const activeStyle = model.active && "active";
    const scaleStyle = container.scale && "h-100";
    this._rendered = this._initialized && (model.active || container.renderType === TabRenderType.Always || container.renderType === TabRenderType.Once && this._rendered);
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css("tab-pane", styles$E.tab, activeStyle, scaleStyle)
    }, this._rendered && this.children);
  }
}

class FourColumns extends BaseComponent {
  renderRow(left, left2, right, right2) {
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$I.row, this.props.className, "row")
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-3"
    }, left), /*#__PURE__*/React.createElement("div", {
      className: "col-md-3"
    }, left2), /*#__PURE__*/React.createElement("div", {
      className: "col-md-3"
    }, right), /*#__PURE__*/React.createElement("div", {
      className: "col-md-3"
    }, right2));
  }
  render() {
    const children = this.children;
    return children.length > 0 ? this.renderRow(children[0], children[1], children[2], children[3]) : null;
  }
}

class FiveColumns extends BaseComponent {
  renderRow(left, left2, center, right, right2) {
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$I.row, this.props.className, "row")
    }, /*#__PURE__*/React.createElement("div", {
      className: "col"
    }, left), /*#__PURE__*/React.createElement("div", {
      className: "col"
    }, left2), /*#__PURE__*/React.createElement("div", {
      className: "col"
    }, center), /*#__PURE__*/React.createElement("div", {
      className: "col"
    }, right), /*#__PURE__*/React.createElement("div", {
      className: "col"
    }, right2));
  }
  render() {
    const children = this.children;
    return children.length > 0 ? this.renderRow(children[0], children[1], children[2], children[3], children[4]) : null;
  }
}

class ThreeColumns extends BaseComponent {
  renderRow(left, middle, right) {
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$I.row, "row")
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-4"
    }, left), /*#__PURE__*/React.createElement("div", {
      className: "col-md-4"
    }, middle), /*#__PURE__*/React.createElement("div", {
      className: "col-md-4"
    }, right));
  }
  render() {
    return this.props.children && this.children.length > 0 ? this.renderRow(this.children[0], this.children[1], this.children[2]) : null;
  }
}

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};

var call = functionCall;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$g;
var isNullOrUndefined = isNullOrUndefined$7;
var requireObjectCoercible = requireObjectCoercible$a;
var sameValue = sameValue$1;
var toString = toString$d;
var getMethod = getMethod$6;
var regExpExec = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

var css_248z$H = ".athenaeum-link-link {\n  color: white;\n  font-family: \"DINProBold\", Arial, sans-serif;\n}\n.athenaeum-link-link:hover {\n  color: white;\n  text-decoration: none;\n}";
var styles$D = {"link":"athenaeum-link-link"};
styleInject(css_248z$H);

class Link extends BaseComponent {
  handleClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.preventDefault();
      if (this.route) {
        if (typeof this.route === "function") {
          yield this.route(this);
        } else {
          yield PageRouteProvider.redirectAsync(this.route);
        }
      }
      return false;
    });
  }
  get route() {
    var _a;
    return (_a = this.props.route) !== null && _a !== void 0 ? _a : null;
  }
  get href() {
    return this.route == null || typeof this.route === "function" ? "#" : this.useRouting ? PageRoute.toRelativePath(this.route) : this.route.name;
  }
  static toRoute(menuItem) {
    if (menuItem.route) {
      const route = menuItem.route;
      return typeof route === "function" ? () => __awaiter(this, void 0, void 0, function* () {
        return route(menuItem);
      }) : route;
    }
    return null;
  }
  render() {
    return /*#__PURE__*/React.createElement("a", {
      className: this.css(styles$D.link, this.props.className),
      href: this.href,
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.handleClickAsync(e);
      })
    }, this.props.children);
  }
}

//Autogenerated
class TopNavLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.searchButtonLanguageItemName = `Search.Button`;
    this.searchForLabelLanguageItemName = `SearchFor.Label`;
    this.searchInLabelLanguageItemName = `SearchIn.Label`;
    this.searchNoResultsLabelLanguageItemName = `SearchNoResults.Label`;
    this.searchMoreLabelLanguageItemName = `SearchMore.Label`;
    this.searchClearLanguageItemName = `Search.Clear`;
    this.searchBackLanguageItemName = `Search.Back`;
    this.searchSearchingLabelLanguageItemName = `Search.Searching.Label`;
    //Initializer
    this.set(this.searchButtonLanguageItemName, {
      language: `en`,
      value: `Search`
    }, {
      language: `uk`,
      value: `Пошук`
    }, {
      language: `sv`,
      value: `Sök`
    }, {
      language: `ru`,
      value: `найти`
    }, {
      language: `pl`,
      value: `Szukaj`
    }, {
      language: `nb`,
      value: `Søg`
    }, {
      language: `fi`,
      value: `Etsi`
    }, {
      language: `da`,
      value: `Søg`
    });
    this.set(this.searchForLabelLanguageItemName, {
      language: `en`,
      value: `Search for:`
    }, {
      language: `uk`,
      value: `Пошук:`
    }, {
      language: `sv`,
      value: `Söka efter:`
    }, {
      language: `ru`,
      value: `найти`
    }, {
      language: `pl`,
      value: `Szukaj:`
    }, {
      language: `nb`,
      value: `Søg etter:`
    }, {
      language: `fi`,
      value: `Etsiä:`
    }, {
      language: `da`,
      value: `Søge efter:`
    });
    this.set(this.searchInLabelLanguageItemName, {
      language: `en`,
      value: `Search in:`
    }, {
      language: `uk`,
      value: `Пошук в:`
    }, {
      language: `sv`,
      value: `Sök i:`
    }, {
      language: `ru`,
      value: `найти в:`
    }, {
      language: `pl`,
      value: `Szukaj w:`
    }, {
      language: `nb`,
      value: `Søg inn:`
    }, {
      language: `fi`,
      value: `Etsi:`
    }, {
      language: `da`,
      value: `Søg ind:`
    });
    this.set(this.searchNoResultsLabelLanguageItemName, {
      language: `en`,
      value: `No results found`
    }, {
      language: `uk`,
      value: `Нічого не знайдено`
    }, {
      language: `sv`,
      value: `Inga resultat funna`
    }, {
      language: `ru`,
      value: `результатов не найдено`
    }, {
      language: `pl`,
      value: `Brak wyników`
    }, {
      language: `nb`,
      value: `Ingen resultater`
    }, {
      language: `fi`,
      value: `Ei tuloksia`
    }, {
      language: `da`,
      value: `Ingen resultater fundet`
    });
    this.set(this.searchMoreLabelLanguageItemName, {
      language: `en`,
      value: `More`
    }, {
      language: `uk`,
      value: `більше`
    }, {
      language: `sv`,
      value: `Mer`
    }, {
      language: `ru`,
      value: `более`
    }, {
      language: `pl`,
      value: `Więcej`
    }, {
      language: `nb`,
      value: `Mer`
    }, {
      language: `fi`,
      value: `Lisää`
    }, {
      language: `da`,
      value: `Mere`
    });
    this.set(this.searchClearLanguageItemName, {
      language: `en`,
      value: `Clear`
    }, {
      language: `uk`,
      value: `Очистити`
    }, {
      language: `sv`,
      value: `Töm`
    }, {
      language: `ru`,
      value: `Очистить`
    }, {
      language: `pl`,
      value: `Wyczyść`
    }, {
      language: `nb`,
      value: `Tøm`
    }, {
      language: `fi`,
      value: `Tyhjennä`
    }, {
      language: `da`,
      value: `Klar`
    });
    this.set(this.searchBackLanguageItemName, {
      language: `en`,
      value: `Back`
    }, {
      language: `uk`,
      value: `Назад`
    }, {
      language: `sv`,
      value: `Tillbaka`
    }, {
      language: `ru`,
      value: `Назад`
    }, {
      language: `pl`,
      value: `Wróć`
    }, {
      language: `nb`,
      value: `Tilbake`
    }, {
      language: `fi`,
      value: `Takaisin`
    }, {
      language: `da`,
      value: `Tilbage`
    });
    this.set(this.searchSearchingLabelLanguageItemName, {
      language: `en`,
      value: `Searching...`
    }, {
      language: `uk`,
      value: `Пошук...`
    }, {
      language: `sv`,
      value: `Söker...`
    }, {
      language: `ru`,
      value: `Поиск...`
    }, {
      language: `pl`,
      value: `Szukanie...`
    }, {
      language: `nb`,
      value: `Søker...`
    }, {
      language: `fi`,
      value: `Etsii...`
    }, {
      language: `da`,
      value: `Søger...`
    });
  }
  /**
  /* "Search.Button" (Search)
  */
  get searchButton() {
    return this.get(this.searchButtonLanguageItemName);
  }
  /**
  /* "SearchFor.Label" (Search for:)
  */
  get searchForLabel() {
    return this.get(this.searchForLabelLanguageItemName);
  }
  /**
  /* "SearchIn.Label" (Search in:)
  */
  get searchInLabel() {
    return this.get(this.searchInLabelLanguageItemName);
  }
  /**
  /* "SearchNoResults.Label" (No results found)
  */
  get searchNoResultsLabel() {
    return this.get(this.searchNoResultsLabelLanguageItemName);
  }
  /**
  /* "SearchMore.Label" (More)
  */
  get searchMoreLabel() {
    return this.get(this.searchMoreLabelLanguageItemName);
  }
  /**
  /* "Search.Clear" (Clear)
  */
  get searchClear() {
    return this.get(this.searchClearLanguageItemName);
  }
  /**
  /* "Search.Back" (Back)
  */
  get searchBack() {
    return this.get(this.searchBackLanguageItemName);
  }
  /**
  /* "Search.Searching.Label" (Searching...)
  */
  get searchSearchingLabel() {
    return this.get(this.searchSearchingLabelLanguageItemName);
  }
}
//Singleton
var TopNavLocalizer$1 = new TopNavLocalizer();

var css_248z$G = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-hamburger-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-hamburger-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-hamburger-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-hamburger-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-hamburger-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-hamburger-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-hamburger-hamburger {\n  background-color: #929292;\n  position: absolute;\n  top: 45px;\n  list-style: none;\n  margin: 0;\n  padding: 0 12px;\n  text-align: left;\n  width: 100%;\n  height: auto;\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease-in-out;\n  z-index: 10;\n}\n.athenaeum-hamburger-hamburger li {\n  border-bottom: 1px #bcbcbc solid;\n}\n.athenaeum-hamburger-hamburger li:last-of-type {\n  border-bottom: none;\n}\n.athenaeum-hamburger-hamburger .athenaeum-hamburger-link {\n  display: block;\n  padding: 8px;\n  transition: all 0.3s;\n}\n.athenaeum-hamburger-hamburger .athenaeum-hamburger-link:hover {\n  color: black;\n}\n.athenaeum-hamburger-hamburger_open {\n  max-height: 100vh;\n}\n.athenaeum-hamburger-hamburger_open li {\n  display: block;\n}";
var styles$C = {"font-renta":"athenaeum-hamburger-font-renta","color-schema-renta_black":"athenaeum-hamburger-color-schema-renta_black","color-schema-renta_white":"athenaeum-hamburger-color-schema-renta_white","color-schema-renta_orange":"athenaeum-hamburger-color-schema-renta_orange","color-schema-renta_green":"athenaeum-hamburger-color-schema-renta_green","color-schema-renta_blue":"athenaeum-hamburger-color-schema-renta_blue","hamburger":"athenaeum-hamburger-hamburger","link":"athenaeum-hamburger-link","hamburger_open":"athenaeum-hamburger-hamburger_open athenaeum-hamburger-hamburger"};
styleInject(css_248z$G);

class Hamburger extends BaseComponent {
  render() {
    const className = this.props.open ? styles$C.hamburger_open : styles$C.hamburger;
    return /*#__PURE__*/React.createElement("ul", {
      className: className
    }, this.props.menuItems.length && this.props.menuItems.map(item => ( /*#__PURE__*/React.createElement("li", {
      key: item.label
    }, /*#__PURE__*/React.createElement(Link, {
      className: styles$C.link,
      route: Link.toRoute(item)
    }, TopNavLocalizer$1.get(item.label))))));
  }
}

var css_248z$F = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-language-dropdown-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-language-dropdown-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-language-dropdown-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-language-dropdown-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-language-dropdown-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-language-dropdown-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-language-dropdown-dropdown {\n  position: relative;\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-flag {\n  display: flex;\n  align-items: center;\n  padding: 8px 6px;\n  cursor: pointer;\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-flag img {\n  height: 20px;\n}\n@media screen and (max-width: 480px) {\n  .athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-flag {\n    margin-left: 6px;\n    margin-right: 6px;\n  }\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-languages {\n  list-style: none;\n  color: white;\n  font-weight: 600;\n  position: absolute;\n  right: 0;\n  top: 32px;\n  margin: 0;\n  padding: 5px 0;\n  background-color: #ee5300;\n  border-radius: 5px;\n  height: auto;\n  z-index: 11;\n  display: none;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-languages li {\n  display: flex;\n  padding: 4px 20px 4px 8px;\n  cursor: pointer;\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-languages li:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-languages li img {\n  height: 16px;\n}\n.athenaeum-language-dropdown-dropdown .athenaeum-language-dropdown-languages li label {\n  white-space: nowrap;\n  cursor: pointer;\n  font-family: \"DINProBold\", Arial, sans-serif;\n  margin-bottom: 0;\n}\n.athenaeum-language-dropdown-dropdown_open {\n  display: block !important;\n}";
var styles$B = {"font-renta":"athenaeum-language-dropdown-font-renta","color-schema-renta_black":"athenaeum-language-dropdown-color-schema-renta_black","color-schema-renta_white":"athenaeum-language-dropdown-color-schema-renta_white","color-schema-renta_orange":"athenaeum-language-dropdown-color-schema-renta_orange","color-schema-renta_green":"athenaeum-language-dropdown-color-schema-renta_green","color-schema-renta_blue":"athenaeum-language-dropdown-color-schema-renta_blue","dropdown":"athenaeum-language-dropdown-dropdown","flag":"athenaeum-language-dropdown-flag","languages":"athenaeum-language-dropdown-languages","dropdown_open":"athenaeum-language-dropdown-dropdown_open athenaeum-language-dropdown-languages"};
styleInject(css_248z$F);

var img$a = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAASFBMVEXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWX////1FI+BAAAAFnRSTlMACAlGR0hNTqOoqaqtrq+w5+jr7P3+K1uBLAAAAH5JREFUSMft1jESgkAQRNHvIgrqwiLQ3P+mJhqYqduBVcwPJ3jZVDVAO5RVr7Zn+qy1DC0Ah/7t/iUjSX0COtUy6qBRPaOGm4PJ3B1MQQ5m8TAKJphgzMxmKZi9MfFTwQTzl4xl+81kB5M9u/joWumkSy1zTQCcxul3ZhrPwAN1ahrILylPwQAAAABJRU5ErkJggg==";

var img$9 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAASFBMVEXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWX////1FI+BAAAAFnRSTlMACAlGR0hNTqOoqaqtrq+w5+jr7P3+K1uBLAAAAH5JREFUSMft1jESgkAQRNHvIgrqwiLQ3P+mJhqYqduBVcwPJ3jZVDVAO5RVr7Zn+qy1DC0Ah/7t/iUjSX0COtUy6qBRPaOGm4PJ3B1MQQ5m8TAKJphgzMxmKZi9MfFTwQTzl4xl+81kB5M9u/joWumkSy1zTQCcxul3ZhrPwAN1ahrILylPwQAAAABJRU5ErkJggg==";

var img$8 = "data:image/png;base64,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";

var img$7 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAASFBMVEX19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/r19/pHWKn19/qK1Gr8AAAAFnRSTlMACAlGR0hNTqOoqaqtrq+w5+jr7P3+K1uBLAAAAH5JREFUSMft1rsSgkAQRNHrIgrqwiKP/v8/NdHATN0OrGJuOMHJpqoB2qGserU902etZWgBOPRv9y8ZSeoT0KmWUQeN6hk13BxM5u5gCnIwi4dRMMEEY2Y2S8HsjYmfCiaYv2Qs228mO5js2cVH10onXWqZawLgNE6/M9N4Bh6m8SCXu4eywgAAAABJRU5ErkJggg==";

var img$6 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAAS1BMVEXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWVHWKntVWX////+jxOAAAAAFnRSTlMACAlGR0hNTqOoqaqtrq+w5+jr7P3+K1uBLAAAAIxJREFUSMft1rEOgkAQRdHrIgoqsKjsm///UisLYyPsFMTMLbc4xSSbPIB2zIvemVkpZqbfWvLYAnDoP95XMpLUJ6BTLaMOGtUzarh5MAN3DyYjD+bpwyiYYIJxZuy7UmxtO2OKS17MX544/lQwweyScdl+DwYPZvDZxUevlU661DLXBMBpmrcz83QGXg+eJZulq75nAAAAAElFTkSuQmCC";

var img$5 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAAS1BMVEXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWXtVWVHWKntVWX////+jxOAAAAAFnRSTlMACAlGR0hNTqOoqaqtrq+w5+jr7P3+K1uBLAAAAIxJREFUSMft1rEOgkAQRdHrIgoqsKjsm///UisLYyPsFMTMLbc4xSSbPIB2zIvemVkpZqbfWvLYAnDoP95XMpLUJ6BTLaMOGtUzarh5MAN3DyYjD+bpwyiYYIJxZuy7UmxtO2OKS17MX544/lQwweyScdl+DwYPZvDZxUevlU661DLXBMBpmrcz83QGXg+eJZulq75nAAAAAElFTkSuQmCC";

var img$4 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAYAAABe1bwWAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAHYYAAB2GAV2iE4EAAAE/SURBVGhD7dsxS8NAGIfxu0sdIgpdiuAgfhmFOrg5OLj53RzcHPwcfgTpIAgiBQWR1Jx54wUOvb9usdDnBy8kl0LDQ5MGSn1s2xgdcr6bQJSfrEn42sR3hBEII/jYSdtrxU7Le7sN/o8+jJ2EYif323Ez1mvGfB8upQKLRhiBMAJhBMIIhBEII/CAJ/CAJ3ApCYQRCCMQRiCMQBgh/PW1tan8+/NTDJOttLs+qp1d9/H6kvbG1TaN83eXF/FtcZ+WYOqDw+5SWjX97yhqTGk9H1Naz8eU1vMxpfVhTGk9H1Naz8eU1oexTww3X4EwAmEEwgiEEQgjEEYgjEAYgTACYQTCCIQRCCMQRiCMQBiBMEKo6u20iUFV1y7MjuZpF4PZ8dz1/z55uL5yj7c3brVcpkObaTKdur2TU7d/du4+AbaWs7BlIxrEAAAAAElFTkSuQmCC";

var img$3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAMAAABpC0wkAAAASFBMVEVKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidxKidz/zlSF6cyWAAAAFnRSTlMACAlGR0hNTqOoqaqtrq+w5+jr7P3+K1uBLAAAAH5JREFUSMft1jESgkAQRNHvIgrqwiLQ3P+mJhqYqduBVcwPJ3jZVDVAO5RVr7Zn+qy1DC0Ah/7t/iUjSX0COtUy6qBRPaOGm4PJ3B1MQQ5m8TAKJphgzMxmKZi9MfFTwQTzl4xl+81kB5M9u/joWumkSy1zTQCcxul3ZhrPwAN1ahrILylPwQAAAABJRU5ErkJggg==";

var img$2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAYAAABe1bwWAAAAAXNSR0IArs4c6QAAAdVJREFUaEPtm79LAmEYx5+3JFRECDkiBBtaOhKEcBENqkXRudlGF0WE/gK3ApEmoSX/idBNKHFR4aA4KIISouKQQNJzsC408gd65bt635sO7pbnc5/nuZeH52E0dnk8HqfP5/ObzWaHpmls/Nmi3jPGtG6326xUKmVJkp5/4xwELwiCLZfLZUOhUJSITIsK4Z+4eoVCIR+LxZKKonz0waxUq9WiKIp7BgUyEbYsyyWv1xtk6XQ6nkqlzgBlRCCTySSYLMs1l8u1AzAjAo1Go87a7XaHiCwAM0FA7YPRAGWaAMDoWAEwAMNXMGAMjIExfARgDB8v1Bg9Y+7uX3t8LI3xNtsPnuPkO+NbA4xeKsGY2WRgDIzh+2nAGBgDY/gIwBg+XqgxMAbG8BGAMXy8UGNgDKcxjXAU/ZhZbQctcoh+DMDMn04Mxuj0YwAGYObPIyJCKumdY5BKSCWkEheBP1IJM3jTcFT2eBCpbVismNocg/OkdursZMsdP94UMec7Bub0QU4MJsNvdoPFbbsdk+FEdNtqldxXxeDPLgGR7cIbyIbX1g29S3D59pI/ql4nFaLBLsHw8lgczoCw6realh1fZIztkyViWqf32bxW3suS2hxun3wDqSDI7dQwlQgAAAAASUVORK5CYII=";

var img$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAvCAYAAABe1bwWAAAAAXNSR0IArs4c6QAAAfJJREFUaEPtmz9IAlEcx3/vCEuRgk6HMooIXIyMoMFssCGCWqKhocWWaEqEaInGplykpjZdG5oqiIYcLIdQKnIRooysQS8oRCvkLk6yztTibWXfm+4vd+/D530P3vs9RppNL1otrR39TqFBJ5IgMO21ut2XZUUuvEoPt6dHeSmRKrXzvfFmY9/Uil/sHnYTUUPdQvi+YQXpKhw83171EqWzKhjdoHtr32jqcf1TIGXNzmYuQyfB6THWM+RZ6HS41wHlk8BNJOhhjrmdaFNz2wDAfBJ4frqPsZHFaI6I9ABTRiCvglEApZIAwNSwAmAAhi8wYAyMgTF8BGAMHy9kDIyBMXwEYAwfL2QMjIExfARgDB8vZEwtYwJbGwqRdqZEO2719bx6rF4vndfuq28oHVcb+/ppNqb0zO/4FqYkZzCCV8UagKnVlWBMdTIwBsZw/q7RldCVuJRBxiBjuIQhGANjYAwfARjDxwsZA2NgDB8BGMPHS80Y1OBVMsuz6+PJaJfFgKpNDZxkKhdja8v2haV5G+p8NWB8m3FPsTL84mBi32ZtQWU4EcUTj6He0d2x4pC82UzGgM/lHx9p/9drCfYO74KzSyFvOk3FtQQfm90qWoYdJqehURBlpWxOhS/S/9DdAiMl9yJL4Ujm6Cwhfaw+eQOsa9bCTNoW2AAAAABJRU5ErkJggg==";

var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAuCAMAAACiV5+BAAAA1VBMVEUAAMz///8AAMcAAMkAAMv9/f8AAMXy8vsuLs4gIM319fz5+f4ZGc0rK80MDMwHB8z39/01Nc+oqOQiIs0UFMwAAMLv7/rZ2fNvb9g7O88QEMy6uul1ddgxMc4mJs7r6/nn5/fd3fTV1fLLy+7Hx+2/v+soKM77+/7o6Pjk5PbOzvCenuKAgNtqatcbG82Vld+Pj95LS9Lg4PXExO22tuixseiKit2GhtxfX9VYWNSamuCCgtuuruaiouNQUNNGRtFBQdHt7fnq6vhkZNeqquR9fdqqquYYMQvHAAAC5UlEQVRIx+2Vx7abQBBEp7pnhixAEiCUc845vPxs//8nWVp5C/LCG9eGw4J7qOquGfFf/1i+Xyi7brng++J5FcpVyXQXy2q18CzFFUzy7edqNb8IYuE+58diOh+2I6iRCraHC7PlP2HIorAWAEZtdkgABHuTSoXclBJVWuiM0e0EI9t2RkB7QaW8mCHNR3E7dhB3f6yP9dVoMoGa0zAfpckVB1sDgFF805Fmuyj2QCUfp8ymgRYAe9dRaL2ID7xGXHcMj60cmCX18NKGsw2OtChOMO7Zb8NQL9CjZvaYXaqj2Hd26pLERCSPHdjvOmzoIurkZcaUqNsu4lYz9E/MqGFFL7BHN2pIaXTJrWb9GX5zpk4/+pwSJ4Yw6YjacHIHmtTDhrNO3aQZVEsOVZF4gR/REYkknuKVuIYVZQ3Zoz4wi+rqRKnuGb/QEWxK6mOt+xhwxpIWqrzFWERHddasV8BOsiUsSQnOHSRCVrNNWy5bj2+vavOxSjAyymRKX5RYxM5nexxyORPG4tRAAidWXw7sl4UakCmEL4ZUR1K033NgVON794XO4CRID7Dh5h3jUQXd7JilLMRBSNFaiYhkKkOnT6WC9B6m4nY7q6lCmSeBlfJaVWTqCosOOHPZ8ynBd46IhUc99SF5gRMtHx7dYEppnoH/Wb86380Utfd41UVUtMy9fi5v1J5Sbk3pgXFl1e6GjzJ4ucrwqKbBDerF7N8T99J72oFzo5Kfq5piSXXstb5iwWmZiecT2Bta5j0ohEt91JpsDCLizWsb44Ga0wedMaWmnwPDYQxjatiH3hgYzwS1x0zvtt1kK9eRTnUHxidgbPcVJpdOWKcBKtTMe8HcVOv7oCp3W03PZ90NAszzUsSjQTYGtrEgJiJxmqCV63r5s4RiB0DVbvProHV/WmSKJ2SyvtQ6AaCgvvYXYlM8pVKDtDjPr9fTRWoyS+JZmQ0m0lqTbJjib2SZjTAMTUv81z/Wb2MbRYdHdIP6AAAAAElFTkSuQmCC";

const flags = {
  da: img$a,
  de: img$9,
  en: img$8,
  fi: img$7,
  nb: img$6,
  no: img$5,
  pl: img$4,
  sv: img$3,
  ru: img$2,
  uk: img$1,
  default: img
};
class LanguageDropdown extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      currentLanguage: this.props.languages.find(language => language.code === this.props.currentLanguage),
      isOpen: false
    };
  }
  dropdownToggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const isOpen = !this.state.isOpen;
      yield this.setState({
        isOpen
      });
    });
  }
  closeDropdownAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        isOpen: false
      });
    });
  }
  onLanguageChangeAsync(language) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      if (((_a = this.state.currentLanguage) === null || _a === void 0 ? void 0 : _a.code) !== language.code) {
        yield this.setState({
          currentLanguage: language
        });
        if (this.props.changeLanguageCallback) {
          this.props.changeLanguageCallback(language.code);
        }
      }
      yield this.closeDropdownAsync();
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      const container = document.querySelector(`.${styles$B.dropdown}`);
      const outside = container != null && !container.contains(target);
      if (outside) {
        yield this.closeDropdownAsync();
      }
    });
  }
  render() {
    const {
      currentLanguage,
      isOpen
    } = this.state;
    const className = isOpen ? styles$B.dropdown_open : styles$B.languages;
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$B.dropdown, this.props.className)
    }, currentLanguage && /*#__PURE__*/React.createElement("div", {
      className: styles$B.flag,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.dropdownToggleAsync();
      })
    }, /*#__PURE__*/React.createElement("img", {
      src: flags[currentLanguage.code],
      alt: currentLanguage.label
    })), !currentLanguage && /*#__PURE__*/React.createElement("div", {
      className: styles$B.flag,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.dropdownToggleAsync();
      })
    }, /*#__PURE__*/React.createElement("img", {
      src: flags["default"],
      alt: "flag"
    })), /*#__PURE__*/React.createElement("ul", {
      className: className
    }, this.props.languages.map(language => ( /*#__PURE__*/React.createElement("li", {
      key: language.code,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onLanguageChangeAsync(language);
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$B.flag
    }, /*#__PURE__*/React.createElement("img", {
      src: flags[language.code],
      alt: language.label
    })), /*#__PURE__*/React.createElement("label", null, language.label))))));
  }
}

var css_248z$E = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-search-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-search-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-search-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-search-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-search-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-search-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-search-dropdown {\n  position: relative;\n  color: #ffffff;\n}\n.athenaeum-search-dropdown .athenaeum-search-mainIconWapper {\n  padding: 8px 6px;\n  cursor: pointer;\n}\n.athenaeum-search-dropdown .athenaeum-search-searchInput {\n  margin-bottom: 0 !important;\n}\n.athenaeum-search-dropdown .athenaeum-search-searchContainer {\n  color: white;\n  font-weight: 600;\n  position: absolute;\n  right: 0;\n  top: 37px;\n  margin: 0;\n  padding: 5px 5px;\n  background-color: #ee5300;\n  border-radius: 5px;\n  height: auto;\n  z-index: 11;\n  display: none;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n}\n@media screen and (max-width: 640px) {\n  .athenaeum-search-dropdown .athenaeum-search-searchContainer {\n    right: -65px;\n  }\n}\n.athenaeum-search-dropdown_open {\n  display: block !important;\n}";
var styles$A = {"font-renta":"athenaeum-search-font-renta","color-schema-renta_black":"athenaeum-search-color-schema-renta_black","color-schema-renta_white":"athenaeum-search-color-schema-renta_white","color-schema-renta_orange":"athenaeum-search-color-schema-renta_orange","color-schema-renta_green":"athenaeum-search-color-schema-renta_green","color-schema-renta_blue":"athenaeum-search-color-schema-renta_blue","dropdown":"athenaeum-search-dropdown","mainIconWapper":"athenaeum-search-mainIconWapper","searchInput":"athenaeum-search-searchInput","searchContainer":"athenaeum-search-searchContainer","dropdown_open":"athenaeum-search-dropdown_open athenaeum-search-searchContainer"};
styleInject(css_248z$E);

class Search extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isOpen: false
    };
    this._searchInputModel = {
      value: ""
    };
    this._searchInputRef = /*#__PURE__*/React.createRef();
  }
  dropdownToggleAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      this.setState({
        isOpen: !this.state.isOpen
      });
    });
  }
  onSearchButtonCLickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._searchInputModel.value.length >= 3) {
        if (this.props.onSearch) {
          this.props.onSearch(this._searchInputModel.value);
        }
      }
      this._searchInputModel.value = "";
      this.setState({
        isOpen: false
      });
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const outside = this.isClickedOutsideAsync(e, `.${styles$A.dropdown}`);
      if (outside) {
        this.setState({
          isOpen: false
        });
      }
    });
  }
  render() {
    const className = this.state.isOpen ? styles$A.dropdown_open : styles$A.searchContainer;
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$A.dropdown, this.props.className)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$A.mainIconWapper,
      onClick: event => __awaiter(this, void 0, void 0, function* () {
        return yield this.dropdownToggleAsync(event);
      })
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "search",
      size: IconSize.X2,
      className: this.props.className
    })), /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement(Form, {
      inline: true,
      submitOnEnter: true,
      onSubmit: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onSearchButtonCLickAsync();
      })
    }, /*#__PURE__*/React.createElement(TextInput, {
      ref: this._searchInputRef,
      placeholder: this.props.searchPlaceHolder,
      className: styles$A.searchInput,
      width: "250px",
      model: this._searchInputModel
    }), /*#__PURE__*/React.createElement(Button, {
      submit: true,
      label: TopNavLocalizer$1.searchButton
    }))));
  }
}

var css_248z$D = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-menu-item-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-menu-item-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-menu-item-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-menu-item-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-menu-item-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-menu-item-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-menu-item-menuItem .athenaeum-menu-item-content {\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-menu-item-menuItem .athenaeum-menu-item-content.athenaeum-menu-item-separator {\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n.athenaeum-menu-item-menuItem .athenaeum-menu-item-content:not(.athenaeum-menu-item-separator) {\n  cursor: pointer;\n  padding: 8px 16px;\n}\n.athenaeum-menu-item-menuItem .athenaeum-menu-item-content:hover:not(.athenaeum-menu-item-separator) {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-menu-item-menuItem .athenaeum-menu-item-content .athenaeum-menu-item-element:not(:last-child) {\n  padding-right: 12px;\n}\n.athenaeum-menu-item-menuItem .athenaeum-menu-item-content .athenaeum-menu-item-element.athenaeum-menu-item-count {\n  font-size: 12px;\n  background: #000000;\n  color: #fff;\n  vertical-align: top;\n  margin-left: -10px;\n  margin-top: -15px;\n  padding-left: 9px;\n  padding-right: 9px;\n  border-radius: 9px;\n  -webkit-border-radius: 9px;\n  -moz-border-radius: 9px;\n}\n.athenaeum-menu-item-menuItem .athenaeum-menu-item-content .athenaeum-menu-item-element.athenaeum-menu-item-count.athenaeum-menu-item-inline {\n  margin: 0;\n}";
var styles$z = {"font-renta":"athenaeum-menu-item-font-renta","color-schema-renta_black":"athenaeum-menu-item-color-schema-renta_black","color-schema-renta_white":"athenaeum-menu-item-color-schema-renta_white","color-schema-renta_orange":"athenaeum-menu-item-color-schema-renta_orange","color-schema-renta_green":"athenaeum-menu-item-color-schema-renta_green","color-schema-renta_blue":"athenaeum-menu-item-color-schema-renta_blue","menuItem":"athenaeum-menu-item-menuItem","content":"athenaeum-menu-item-content","separator":"athenaeum-menu-item-separator","element":"athenaeum-menu-item-element","count":"athenaeum-menu-item-count","inline":"athenaeum-menu-item-inline"};
styleInject(css_248z$D);

class MenuItem extends BaseComponent {
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.preventDefault();
      if (this.route) {
        if (typeof this.route === "function") {
          yield this.route(this.props);
        } else {
          yield PageRouteProvider.redirectAsync(this.route);
        }
      }
      if (this.props.onClick) {
        yield this.props.onClick(this);
      }
      return false;
    });
  }
  getCount() {
    return this.props.count != null ? typeof this.props.count === "function" ? this.props.count() : this.props.count : null;
  }
  get route() {
    var _a;
    return (_a = this.props.route) !== null && _a !== void 0 ? _a : null;
  }
  get isSeparator() {
    return this.label === "-";
  }
  get label() {
    return this.props.label;
  }
  get icon() {
    var _a;
    return (_a = this.props.icon) !== null && _a !== void 0 ? _a : null;
  }
  get count() {
    return this.getCount();
  }
  render() {
    const count = this.getCount();
    const separatorStyle = this.isSeparator && styles$z.separator;
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(styles$z.menuItem, this.props.className, separatorStyle)
    }, this.isSeparator ? ( /*#__PURE__*/React.createElement("hr", {
      className: this.css(styles$z.content, separatorStyle)
    })) : ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$z.content),
      onClick: e => this.onClickAsync(e)
    }, this.icon && Icon.renderIcon(this.icon, this.css(styles$z.element, styles$z.icon), IconSize.X2), this.label && ( /*#__PURE__*/React.createElement("span", {
      className: this.css(styles$z.element, styles$z.label)
    }, TopNavLocalizer$1.get(this.label))), count != null && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$z.element, styles$z.count, styles$z.inline, this.props.countClassName)
    }, /*#__PURE__*/React.createElement("span", null, count))))));
  }
}

var css_248z$C = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-user-profile-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-user-profile-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-user-profile-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-user-profile-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-user-profile-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-user-profile-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-user-profile-userProfile {\n  padding: 32px;\n  background-color: rgb(65, 64, 66);\n  display: flex;\n  align-items: center;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-avatar img {\n  border-radius: 50%;\n  border: 1px solid white;\n  max-width: 70px;\n  max-height: 70px;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-info {\n  margin-left: 24px;\n  display: flex;\n  flex-direction: column;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-info .athenaeum-user-profile-label {\n  color: #adadad;\n  white-space: nowrap;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-info .athenaeum-user-profile-label.athenaeum-user-profile-fullName {\n  font-size: 1.3em;\n  font-weight: bold;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-info .athenaeum-user-profile-label.athenaeum-user-profile-roleName {\n  font-size: 0.9em;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-info .athenaeum-user-profile-rating {\n  padding-top: 8px;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-info .athenaeum-user-profile-rating .athenaeum-user-profile-star {\n  color: #adadad;\n}\n.athenaeum-user-profile-userProfile .athenaeum-user-profile-info .athenaeum-user-profile-rating .athenaeum-user-profile-star:not(:first-child) {\n  margin-left: 8px;\n}";
var styles$y = {"font-renta":"athenaeum-user-profile-font-renta","color-schema-renta_black":"athenaeum-user-profile-color-schema-renta_black","color-schema-renta_white":"athenaeum-user-profile-color-schema-renta_white","color-schema-renta_orange":"athenaeum-user-profile-color-schema-renta_orange","color-schema-renta_green":"athenaeum-user-profile-color-schema-renta_green","color-schema-renta_blue":"athenaeum-user-profile-color-schema-renta_blue","userProfile":"athenaeum-user-profile-userProfile","avatar":"athenaeum-user-profile-avatar","info":"athenaeum-user-profile-info","label":"athenaeum-user-profile-label","fullName":"athenaeum-user-profile-fullName","roleName":"athenaeum-user-profile-roleName","rating":"athenaeum-user-profile-rating","star":"athenaeum-user-profile-star"};
styleInject(css_248z$C);

class UserProfile extends BaseComponent {
  get profile() {
    return this.props;
  }
  get rating() {
    var _a;
    const rating = [];
    for (let i = 0; i < ((_a = this.profile.rating) !== null && _a !== void 0 ? _a : 0); i++) {
      rating[i] = i;
    }
    return rating;
  }
  render() {
    var _a;
    if (this.profile.render) {
      return this.profile.render(this.props);
    }
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(this.props.className, styles$y.userProfile)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$y.avatar
    }, Icon.renderIcon((_a = this.profile.avatar) !== null && _a !== void 0 ? _a : "fa fa-user-circle", styles$y.avatar, IconSize.X5)), /*#__PURE__*/React.createElement("div", {
      className: styles$y.info
    }, /*#__PURE__*/React.createElement("span", {
      className: this.css(styles$y.label, styles$y.fullName)
    }, this.profile.userFullName), /*#__PURE__*/React.createElement("span", {
      className: this.css(styles$y.label, styles$y.roleName)
    }, TopNavLocalizer$1.get(this.profile.roleName)), /*#__PURE__*/React.createElement("div", {
      className: styles$y.rating
    }, this.rating.map(index => ( /*#__PURE__*/React.createElement(Icon, {
      key: index,
      className: styles$y.star,
      name: "fas fa-star",
      size: IconSize.Normal
    }))))));
  }
}

var css_248z$B = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-profile-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-profile-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-profile-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-profile-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-profile-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-profile-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-profile-profile {\n  position: relative;\n}\n.athenaeum-profile-profile .athenaeum-profile-icon {\n  cursor: pointer;\n  color: white;\n  padding: 8px 6px;\n}\n.athenaeum-profile-profile .athenaeum-profile-container {\n  background-color: rgb(254, 80, 0);\n  border-radius: 6px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  color: white;\n  top: 37px;\n  right: 0;\n  margin-right: -35px;\n  min-width: 35px;\n  height: auto;\n  font-weight: 600;\n  position: absolute;\n  z-index: 11;\n  display: none;\n  user-select: none;\n  overflow: hidden;\n}\n.athenaeum-profile-profile .athenaeum-profile-container .athenaeum-profile-itemsContainer {\n  padding: 8px 0;\n}\n.athenaeum-profile-profile .athenaeum-profile-container.athenaeum-profile-expanded {\n  display: block !important;\n}";
var styles$x = {"font-renta":"athenaeum-profile-font-renta","color-schema-renta_black":"athenaeum-profile-color-schema-renta_black","color-schema-renta_white":"athenaeum-profile-color-schema-renta_white","color-schema-renta_orange":"athenaeum-profile-color-schema-renta_orange","color-schema-renta_green":"athenaeum-profile-color-schema-renta_green","color-schema-renta_blue":"athenaeum-profile-color-schema-renta_blue","profile":"athenaeum-profile-profile","icon":"athenaeum-profile-icon","container":"athenaeum-profile-container","itemsContainer":"athenaeum-profile-itemsContainer","expanded":"athenaeum-profile-expanded"};
styleInject(css_248z$B);

class Profile extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      expanded: false
    };
  }
  get containerId() {
    return `${this.id}_container`;
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const expanded = !this.state.expanded;
      yield this.setState({
        expanded
      });
    });
  }
  closeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expanded) {
        yield this.setState({
          expanded: false
        });
      }
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expanded) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id);
        if (outside) {
          yield this.closeAsync();
        }
      }
    });
  }
  onGlobalKeydown(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expanded && e.keyCode == 27) {
        yield this.closeAsync();
      }
    });
  }
  static findUserProfile() {
    const user = ch.findUser();
    if (user) {
      const transformProvider = ServiceProvider.findTransformProvider();
      const userFullName = (transformProvider === null || transformProvider === void 0 ? void 0 : transformProvider.toString(user)) || Utility.findStringValueByAccessor(user, ["fullName", "username", "login"]);
      if (userFullName) {
        const role = Utility.findValueByAccessor(user, "role");
        const roleName = (transformProvider === null || transformProvider === void 0 ? void 0 : transformProvider.toString(role)) || Utility.findStringValueByAccessor(user, ["role.Name", "role.roleName", "roleName"]);
        const rating = Utility.findValueByAccessor(user, "rating");
        const avatar = Utility.findValueByAccessor(user, "avatar");
        return {
          userFullName,
          roleName,
          rating,
          avatar
        };
      }
    }
    return null;
  }
  static resolveUserProfile(resolver, userProfile) {
    return userProfile != null ? typeof userProfile === "function" ? userProfile(resolver) : typeof userProfile === "boolean" ? userProfile ? Profile.findUserProfile() : null : userProfile : null;
  }
  getUserProfile() {
    return Profile.resolveUserProfile(this, this.props.userProfile);
  }
  get items() {
    var _a;
    return (_a = this.props.items) !== null && _a !== void 0 ? _a : [];
  }
  get expanded() {
    return this.state.expanded;
  }
  render() {
    const userProfile = this.getUserProfile();
    const expandedStyle = this.state.expanded && styles$x.expanded;
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(styles$x.profile, this.props.className, expandedStyle)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$x.icon,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAsync();
      })
    }, Icon.renderIcon(this.props.icon || "far user-circle", null, IconSize.X2)), this.items && ( /*#__PURE__*/React.createElement("div", {
      id: this.containerId,
      className: this.css(styles$x.container, expandedStyle)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$x.userProfileContainer
    }, userProfile && ( /*#__PURE__*/React.createElement(UserProfile, Object.assign({}, userProfile)))), /*#__PURE__*/React.createElement("div", {
      className: styles$x.itemsContainer
    }, this.items.map(item => ( /*#__PURE__*/React.createElement(MenuItem, Object.assign({
      key: item.label
    }, item, {
      onClick: () => this.closeAsync()
    }))))))));
  }
}

var css_248z$A = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-badge-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-badge-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-badge-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-badge-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-badge-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-badge-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-badge-badgeWrapper {\n  position: relative;\n  width: fit-content;\n  height: fit-content;\n}\n\n.athenaeum-badge-badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  z-index: 100;\n  border-radius: 50%;\n  line-height: 1;\n}\n\n.athenaeum-badge-badgeDefault {\n  font-size: 12px;\n  padding: 2px 4px;\n  min-width: 16px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.athenaeum-badge-badgeSmall {\n  width: 8px;\n  height: 8px;\n}";
var styles$w = {"font-renta":"athenaeum-badge-font-renta","color-schema-renta_black":"athenaeum-badge-color-schema-renta_black","color-schema-renta_white":"athenaeum-badge-color-schema-renta_white","color-schema-renta_orange":"athenaeum-badge-color-schema-renta_orange","color-schema-renta_green":"athenaeum-badge-color-schema-renta_green","color-schema-renta_blue":"athenaeum-badge-color-schema-renta_blue","badgeWrapper":"athenaeum-badge-badgeWrapper","badge":"athenaeum-badge-badge","badgeDefault":"athenaeum-badge-badgeDefault","badgeSmall":"athenaeum-badge-badgeSmall"};
styleInject(css_248z$A);

const Badge = props => {
  var _a;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$w.badgeWrapper
  }, props.children, !!props.value && ( /*#__PURE__*/React.createElement("span", {
    className: `${styles$w.badge} ${props.value === true ? styles$w.badgeSmall : styles$w.badgeDefault} ${(_a = props.schema) !== null && _a !== void 0 ? _a : ''}`
  }, props.value)));
};

var css_248z$z = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-top-nav-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-top-nav-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-top-nav-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-top-nav-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-top-nav-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-top-nav-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-top-nav-wrapper {\n  height: 75px;\n  box-sizing: border-box;\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-info {\n  background-color: rgb(254, 198, 172);\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  height: 45px;\n  min-height: 45px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  z-index: 1000;\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-info .athenaeum-top-nav-text {\n  text-align: center;\n  margin-left: 3px;\n  margin-right: 3px;\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation {\n  background-color: rgb(254, 80, 0);\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  height: 45px;\n  min-height: 45px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  z-index: 1000;\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-left {\n  display: flex;\n  height: inherit;\n  align-items: center;\n  position: absolute;\n  left: 0;\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-left_backIcon {\n  color: white;\n  cursor: pointer;\n  padding: 0 12px;\n  margin-right: -8px;\n  height: inherit;\n  display: none;\n  align-items: center;\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-left_backIcon i {\n  font-size: 1.6em;\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-left_backIcon:hover {\n  background-color: rgb(234, 60, 0);\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-left_backIcon {\n    display: flex;\n  }\n}\n@media screen and (max-width: 480px) {\n  .athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-left_backIcon {\n    margin: 0;\n    padding: 0 6px;\n  }\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-left_leftNav {\n  color: white;\n  cursor: pointer;\n  text-align: center;\n  min-width: 25px;\n}\n@media screen and (min-width: 480px) {\n  .athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-left_leftNav {\n    min-width: 32px;\n  }\n  .athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-left_leftNav:not(:first-child) {\n    padding-left: 6px;\n  }\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-left img {\n  max-height: 100%;\n  padding: 6.5px 12px;\n  cursor: pointer;\n}\n@media screen and (max-width: 480px) {\n  .athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-left img {\n    max-height: 100%;\n    padding: 10.5px 6px;\n  }\n}\n@media screen and (max-width: 310px) {\n  .athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-left img {\n    max-height: 100%;\n    padding: 14.5px 0px;\n  }\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-left span {\n  font-size: 1.8em;\n  color: white;\n  opacity: 0.9;\n  margin-bottom: -4px;\n  white-space: nowrap;\n}\n@media screen and (max-width: 310px) {\n  .athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-left span {\n    font-size: 1.4em;\n  }\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-middle {\n  display: flex;\n  height: inherit;\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-middle_link {\n  padding: 0 16px;\n  height: inherit;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-middle_link:hover {\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-middle_link.athenaeum-top-nav-active {\n  text-decoration: underline;\n}\n@media screen and (max-width: 1460px) {\n  .athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-middle_link {\n    display: none;\n  }\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-right {\n  display: flex;\n  align-items: center;\n  position: absolute;\n  right: 0;\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-right_search {\n  margin-left: 6px;\n  margin-right: 6px;\n  color: #ffffff;\n  cursor: pointer;\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-right_shoppingCartContainer {\n  padding: 8px 6px;\n  cursor: pointer;\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-right_shoppingCart {\n  color: #ffffff;\n  cursor: pointer;\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-right_shoppingCartCount {\n  font-size: 12px;\n  background: #000000;\n  color: #fff;\n  vertical-align: top;\n  margin-left: -10px;\n  margin-top: -15px;\n  padding-left: 9px;\n  padding-right: 9px;\n  -webkit-border-radius: 9px;\n  -moz-border-radius: 9px;\n  border-radius: 9px;\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-right_infoIcon {\n  color: white;\n  padding: 8px 6px;\n  cursor: pointer;\n}\n.athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-right_hamburgerIcon {\n  display: none;\n  cursor: pointer;\n  color: white;\n  padding: 8px 6px;\n  z-index: 1;\n}\n@media screen and (max-width: 1460px) {\n  .athenaeum-top-nav-wrapper .athenaeum-top-nav-navigation .athenaeum-top-nav-right_hamburgerIcon {\n    display: flex;\n  }\n}";
var styles$v = {"font-renta":"athenaeum-top-nav-font-renta","color-schema-renta_black":"athenaeum-top-nav-color-schema-renta_black","color-schema-renta_white":"athenaeum-top-nav-color-schema-renta_white","color-schema-renta_orange":"athenaeum-top-nav-color-schema-renta_orange","color-schema-renta_green":"athenaeum-top-nav-color-schema-renta_green","color-schema-renta_blue":"athenaeum-top-nav-color-schema-renta_blue","wrapper":"athenaeum-top-nav-wrapper","info":"athenaeum-top-nav-info","text":"athenaeum-top-nav-text","navigation":"athenaeum-top-nav-navigation","left":"athenaeum-top-nav-left","left_backIcon":"athenaeum-top-nav-left_backIcon","left_leftNav":"athenaeum-top-nav-left_leftNav","middle":"athenaeum-top-nav-middle","middle_link":"athenaeum-top-nav-middle_link","active":"athenaeum-top-nav-active","right":"athenaeum-top-nav-right","right_search":"athenaeum-top-nav-right_search","right_shoppingCartContainer":"athenaeum-top-nav-right_shoppingCartContainer","right_shoppingCart":"athenaeum-top-nav-right_shoppingCart","right_shoppingCartCount":"athenaeum-top-nav-right_shoppingCartCount","right_infoIcon":"athenaeum-top-nav-right_infoIcon","right_hamburgerIcon":"athenaeum-top-nav-right_hamburgerIcon"};
styleInject(css_248z$z);

class TopNav extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isHamburgerOpen: false,
      data: null,
      isLoading: false,
      shoppingCart: null
    };
    this._profile = null;
  }
  backAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      PageRouteProvider.back();
    });
  }
  toggleLeftNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const leftNav = this.leftNav;
      if (leftNav) {
        yield leftNav.toggleAsync();
        if (this.props.onLeftNavToggle) {
          yield this.props.onLeftNavToggle(this);
        }
      }
    });
  }
  onShoppingCartClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onShoppingCartClick) {
        yield this.props.onShoppingCartClick(this);
      }
    });
  }
  toggleHamburgerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const isHamburgerOpen = !this.state.isHamburgerOpen;
      this.setState({
        isHamburgerOpen
      });
    });
  }
  closeHamburgerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this.setState({
        isHamburgerOpen: false
      });
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      const container = document.querySelector(`.${styles$v.right_hamburgerIcon}`);
      const outsideHamburgerIcon = container != null && !container.contains(target);
      if (outsideHamburgerIcon) {
        yield this.closeHamburgerAsync();
      }
    });
  }
  onLogoClick() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onLogoClick) {
        yield this.props.onLogoClick(this);
      }
    });
  }
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      TopNav.mountedInstance = this;
      yield _super.componentDidMount.call(this);
    });
  }
  componentWillUnmount() {
    const _super = Object.create(null, {
      componentWillUnmount: {
        get: () => super.componentWillUnmount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      TopNav.mountedInstance = null;
      yield _super.componentWillUnmount.call(this);
    });
  }
  onLanguageChangeAsync(language) {
    return __awaiter(this, void 0, void 0, function* () {
      yield ch.setLanguageAsync(language);
    });
  }
  fetchDataAsync() {
    const _super = Object.create(null, {
      fetchDataAsync: {
        get: () => super.fetchDataAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.fetchShoppingCart) {
        const shoppingCart = yield this.props.fetchShoppingCart(this);
        this.setState({
          shoppingCart
        });
      }
      if (this.props.fetchItems) {
        return yield this.props.fetchItems(this);
      }
      return _super.fetchDataAsync.call(this);
    });
  }
  processDataAsync(state, data) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onFetchItems) {
        yield this.props.onFetchItems(this);
      }
    });
  }
  get searchPlaceHolder() {
    if (this.props.searchPlaceHolder) {
      return this.props.searchPlaceHolder();
    }
    return "";
  }
  get languages() {
    if (this.props.languages) {
      return this.props.languages();
    }
    return TopNavLocalizer$1.supportedLanguages;
  }
  get leftNav() {
    var _a, _b;
    return (_b = (_a = this.props.leftNavRef) === null || _a === void 0 ? void 0 : _a.current) !== null && _b !== void 0 ? _b : null;
  }
  getEndpoint() {
    return "/api/Application/GetTopNavItems";
  }
  get items() {
    return this.state.data || [];
  }
  get shoppingCart() {
    return this.state.shoppingCart;
  }
  static resolveProfile(profile) {
    return profile ? typeof profile === "function" ? profile() : profile : null;
  }
  get profile() {
    var _a;
    return (_a = this._profile) !== null && _a !== void 0 ? _a : this._profile = TopNav.resolveProfile(this.props.profile);
  }
  get manual() {
    const page = ch.findPage();
    return page ? page.getManualProps() : {};
  }
  render() {
    var _a;
    if (this.props.searchElement !== undefined && this.props.onSearchClick !== undefined) {
      throw new Error("searchElement overrides onSeachClick. Please use only one of them.");
    }
    const leftNav = this.leftNav;
    const hasLeftNav = leftNav != null;
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$v.wrapper)
    }, /*#__PURE__*/React.createElement("nav", {
      className: this.css(styles$v.navigation, this.props.className)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$v.left
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$v.left_backIcon,
      onClick: () => this.backAsync()
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-chevron-circle-left"
    })), leftNav && ( /*#__PURE__*/React.createElement(Icon, {
      id: leftNav.toggleButtonId,
      name: leftNav.expanded ? "fal fa-times" : "fal fa-bars",
      size: IconSize.X2,
      className: styles$v.left_leftNav,
      onClick: () => this.toggleLeftNavAsync()
    })), this.props.logo && ( /*#__PURE__*/React.createElement("img", {
      src: this.props.logo,
      alt: this.props.logoText || "renta",
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onLogoClick();
      })
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles$v.middle
    }, !hasLeftNav && this.items.map(item => ( /*#__PURE__*/React.createElement(Link, {
      key: item.label,
      className: this.css(styles$v.middle_link),
      route: Link.toRoute(item)
    }, TopNavLocalizer$1.get(item.label))))), /*#__PURE__*/React.createElement("div", {
      className: styles$v.right
    }, (this.manual.manual || this.manual.onClick) && ( /*#__PURE__*/React.createElement(Icon, {
      name: this.manual.icon || "question-circle",
      className: this.css(styles$v.right_infoIcon),
      style: IconStyle.Regular,
      size: IconSize.X2,
      toggleModal: !this.manual.onClick,
      dataTarget: "page-help-info",
      onClick: this.manual.onClick
    })), this.shoppingCart && ( /*#__PURE__*/React.createElement("div", {
      className: styles$v.right_shoppingCartContainer,
      onClick: () => this.onShoppingCartClickAsync()
    }, /*#__PURE__*/React.createElement(Badge, {
      value: this.shoppingCart.productsCount,
      schema: "color-schema-renta_black"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "shopping-cart",
      size: IconSize.X2,
      className: this.css(this.props.shoppingCardClassName, (_a = this.props.className) !== null && _a !== void 0 ? _a : styles$v.right_shoppingCart)
    })))), this.props.searchElement ? this.props.searchElement : this.props.onSearchClick && ( /*#__PURE__*/React.createElement(Search, {
      searchPlaceHolder: this.searchPlaceHolder,
      onSearch: searchTerm => this.props.onSearchClick(searchTerm)
    })), this.profile && ( /*#__PURE__*/React.createElement(Profile, Object.assign({}, this.profile))), !hasLeftNav && this.items.length > 0 && ( /*#__PURE__*/React.createElement("div", {
      className: styles$v.right_hamburgerIcon,
      onClick: () => this.toggleHamburgerAsync()
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-2x fa-bars"
    }))), /*#__PURE__*/React.createElement(LanguageDropdown, {
      className: this.props.languageClassName,
      languages: this.languages,
      currentLanguage: TopNavLocalizer$1.language,
      changeLanguageCallback: language => __awaiter(this, void 0, void 0, function* () {
        return yield this.onLanguageChangeAsync(language);
      })
    })), /*#__PURE__*/React.createElement(Hamburger, {
      menuItems: this.items,
      open: this.state.isHamburgerOpen
    })), this.props.showTopNavInfo === true && ( /*#__PURE__*/React.createElement("nav", {
      className: this.css(styles$v.info, this.props.className)
    }, /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$v.text)
    }, this.props.topNavInfoText))));
  }
}
TopNav.mountedInstance = null;

var css_248z$y = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-left-nav-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-left-nav-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-left-nav-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-left-nav-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-left-nav-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-left-nav-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-left-nav-leftNav {\n  display: flex;\n  width: fit-content;\n  background-color: rgb(254, 80, 0);\n  color: white;\n}\n.athenaeum-left-nav-leftNav.athenaeum-left-nav-absolute {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: auto;\n}\n.athenaeum-left-nav-leftNav.athenaeum-left-nav-collapsed {\n  width: 0;\n}\n.athenaeum-left-nav-leftNav .athenaeum-left-nav-container {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.athenaeum-left-nav-leftNav .athenaeum-left-nav-container .athenaeum-left-nav-itemsContainer {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.athenaeum-left-nav-leftNav .athenaeum-left-nav-container .athenaeum-left-nav-itemsContainer .athenaeum-left-nav-expander {\n  flex-grow: 1;\n}";
var styles$u = {"font-renta":"athenaeum-left-nav-font-renta","color-schema-renta_black":"athenaeum-left-nav-color-schema-renta_black","color-schema-renta_white":"athenaeum-left-nav-color-schema-renta_white","color-schema-renta_orange":"athenaeum-left-nav-color-schema-renta_orange","color-schema-renta_green":"athenaeum-left-nav-color-schema-renta_green","color-schema-renta_blue":"athenaeum-left-nav-color-schema-renta_blue","leftNav":"athenaeum-left-nav-leftNav","absolute":"athenaeum-left-nav-absolute","collapsed":"athenaeum-left-nav-collapsed","container":"athenaeum-left-nav-container","itemsContainer":"athenaeum-left-nav-itemsContainer","expander":"athenaeum-left-nav-expander"};
styleInject(css_248z$y);

class LeftNav extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      data: null,
      isLoading: false,
      expanded: this.fixed,
      maxWidth: null,
      toggling: false
    };
  }
  getUserProfile() {
    return this.props.userProfile != null ? typeof this.props.userProfile === "function" ? this.props.userProfile(this) : typeof this.props.userProfile === "boolean" ? this.props.userProfile ? Profile.findUserProfile() : null : this.props.userProfile : null;
  }
  onItemClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.autoCollapse && this.expandable) {
        yield this.collapseAsync(false);
      }
    });
  }
  getEndpoint() {
    return "";
  }
  fetchDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.props.items != null ? typeof this.props.items === "function" ? yield this.props.items(this) : this.props.items : [];
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expanded && this.expandable && this.autoCollapse) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id, this.toggleButtonId);
        if (outside) {
          yield this.collapseAsync();
        }
      }
    });
  }
  onGlobalKeydown(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expanded && this.expandable && this.autoCollapse && e.keyCode == 27) {
        yield this.collapseAsync();
      }
    });
  }
  isAsync() {
    return this.props.items != null && typeof this.props.items === "function";
  }
  get expandable() {
    return this.props.expandable !== false;
  }
  get fixed() {
    return this.props.fixed === true;
  }
  get absolute() {
    return !this.fixed;
  }
  get autoCollapse() {
    return this.props.autoCollapse === true || this.props.autoCollapse !== false && this.absolute;
  }
  get expanded() {
    return this.state.expanded;
  }
  get toggleButtonId() {
    var _a;
    return (_a = this.props.toggleButtonId) !== null && _a !== void 0 ? _a : `${this.id}_toggleButton`;
  }
  get toggling() {
    return this.state.toggling;
  }
  get collapsed() {
    return !this.expanded;
  }
  get items() {
    return this.state.data || [];
  }
  get topItems() {
    return this.items.where(item => !item.bottom);
  }
  get bottomItems() {
    return this.items.where(item => !!item.bottom);
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.items != null && typeof this.props.items !== "function") {
        this.state.data = this.props.items;
      }
      yield _super.initializeAsync.call(this);
    });
  }
  collapseAsync(animation = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expandable && this.expanded) {
        yield this.toggleAsync(animation);
      }
    });
  }
  expandAsync(animation = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expandable && this.collapsed) {
        yield this.toggleAsync(animation);
      }
    });
  }
  toggleAsync(animation = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expandable && !this.toggling) {
        if (animation) {
          const expanding = !this.expanded;
          const collapsing = !expanding;
          const node = this.getNode();
          // check current state
          const originalMaxWidth = node.css("max-width");
          const originalWhiteSpace = node.css("white-space");
          let maxWidth = 0;
          if (collapsing) {
            maxWidth = node.width();
          }
          // override state
          node.css("max-width", maxWidth);
          node.css("white-space", "nowrap");
          this.state.toggling = true;
          if (expanding) {
            yield this.setState({
              expanded: true
            });
          }
          const step = 15;
          const delay = 5;
          // eslint-disable-next-line no-constant-condition -- infinite loop is wanted here.
          while (true) {
            if (expanding) {
              maxWidth += step;
              node.css("max-width", maxWidth);
              const newWidth = node.width();
              if (newWidth < maxWidth) {
                break;
              }
            } else {
              maxWidth -= step;
              if (maxWidth <= 0) {
                break;
              }
              node.css("max-width", maxWidth);
            }
            yield Utility.wait(delay);
          }
          // restore state
          node.css("max-width", originalMaxWidth);
          node.css("white-space", originalWhiteSpace);
          this.state.toggling = false;
          if (collapsing) {
            yield this.setState({
              expanded: false
            });
          }
        } else {
          yield this.setState({
            expanded: !this.expanded
          });
        }
        if (this.props.onToggle) {
          yield this.props.onToggle(this, this.expanded);
        }
      }
    });
  }
  renderItems() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.topItems.map(item => ( /*#__PURE__*/React.createElement(MenuItem, Object.assign({
      key: item.label
    }, item, {
      onClick: () => this.onItemClickAsync()
    })))), /*#__PURE__*/React.createElement("div", {
      className: styles$u.expander
    }), this.bottomItems.map(item => ( /*#__PURE__*/React.createElement(MenuItem, Object.assign({
      key: item.label
    }, item, {
      onClick: () => this.onItemClickAsync()
    })))));
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const newItems = !Comparator.isEqual(this.props.items, nextProps.items);
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (newItems) {
        yield this.reloadAsync();
      } else {
        yield this.reRenderAsync();
      }
    });
  }
  render() {
    const userProfile = this.getUserProfile();
    const inlineStyles = {
      height: this.props.height || undefined,
      minHeight: this.props.minHeight || undefined,
      width: this.props.width || undefined,
      minWidth: this.props.minWidth || undefined
    };
    const expandedStyle = this.expanded && styles$u.expanded;
    const collapsedStyle = this.collapsed && styles$u.collapsed;
    const fixedStyle = this.fixed && styles$u.fixed;
    const absoluteStyle = this.absolute && styles$u.absolute;
    return /*#__PURE__*/React.createElement("nav", {
      id: this.id,
      className: this.css(styles$u.leftNav, this.props.className, expandedStyle, collapsedStyle, fixedStyle, absoluteStyle),
      style: inlineStyles
    }, this.expanded && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$u.container, expandedStyle, collapsedStyle)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$u.userProfileContainer
    }, userProfile && ( /*#__PURE__*/React.createElement(UserProfile, Object.assign({}, userProfile)))), /*#__PURE__*/React.createElement("div", {
      className: styles$u.itemsContainer
    }, this.items && this.renderItems()))));
  }
}

/**
 * A base layout containing an {@link IBasePage}.
 */
class Layout extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isLoading: false,
      isSpinning: false,
      data: null,
      page: null,
      error: false,
      noTopNav: this.props.noTopNav === true,
      noFooter: this.props.noFooter === true
    };
    this._pageRef = /*#__PURE__*/React.createRef();
    this._topNavRef = /*#__PURE__*/React.createRef();
    this._leftNavRef = /*#__PURE__*/React.createRef();
    this._mobile = this.mobile;
    this._touch = null;
    this._startTouch = null;
    this._swiping = false;
    this._alert = null;
    this._leftNav = null;
  }
  onTouchStartHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      this._touch = e.touches[0];
      this._startTouch = e.touches[0];
    });
  }
  onTouchEndHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._startTouch && this._touch) {
        const x = this._startTouch.clientX;
        const y = this._startTouch.clientY;
        const xDiff = this._touch.clientX - x;
        const yDiff = this._touch.clientY - y;
        const minSwipe = window.innerWidth / 3.0;
        if (Math.abs(xDiff) > Math.abs(yDiff)) {
          /*most significant*/
          if (xDiff > minSwipe) {
            // right swipe
            yield this.onSwipeHandlerAsync(SwipeDirection.Right);
          } else if (xDiff < -minSwipe) {
            // left swipe
            yield this.onSwipeHandlerAsync(SwipeDirection.Left);
          }
        } else {
          if (yDiff > minSwipe) {
            //down swipe
            yield this.onSwipeHandlerAsync(SwipeDirection.Down);
          } else if (yDiff < -minSwipe) {
            //up swipe
            yield this.onSwipeHandlerAsync(SwipeDirection.Up);
          }
        }
        this._startTouch = null;
        this._touch = null;
      }
    });
  }
  onTouchMoveHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      this._touch = e.touches[0];
    });
  }
  onSwipeHandlerAsync(direction) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.state.isSpinning && !this.state.isLoading) {
        const page = this._pageRef.current || this.state.page;
        let defaultHandling = true;
        if (page) {
          defaultHandling = yield page.onSwipeHandlerAsync(direction);
        }
        if (defaultHandling) {
          if (direction === SwipeDirection.Right) {
            yield this.swipeRightAsync();
            PageRouteProvider.back();
          }
        }
      }
    });
  }
  swipe(styleName) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._swiping) {
        try {
          this._swiping = true;
          const main = document.querySelector(`.${styles$I.main}`);
          main.classList.add(styleName);
          yield Utility.wait(500);
          main.classList.remove(styleName);
        } finally {
          this._swiping = false;
        }
      }
    });
  }
  onTopNavFetchItemsAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.reloadLeftNavAsync();
    });
  }
  static processUrlRouteAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const pathname = window.location.pathname;
      if (!!pathname && pathname !== "/") {
        const pageRoute = PageRouteProvider.resolveRoute(pathname);
        if (pageRoute) {
          yield PageRouteProvider.redirectAsync(pageRoute);
        }
      }
    });
  }
  processTokenAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const parsed = queryString.parse(window.location.search);
      let token = parsed.token;
      if (!token) {
        const pathname = window.location.pathname.substr(1);
        if (pathname && pathname.length == 32 && /^[0-9a-fA-F]+$/.test(pathname)) {
          token = pathname;
        }
      }
      if (token) {
        if (this.props.tokenLogin) {
          yield this.props.tokenLogin(this, token);
        } else {
          yield this.postAsync("/api/Application/TokenLogin", token);
        }
        if (this.useRouting) {
          yield PageRouteProvider.changeUrlWithoutReload();
        }
      }
    });
  }
  isMobileApp() {
    const href = document.location.href.toLowerCase();
    return href.endsWith("/mobile") || href.endsWith("/mobile/") || href.endsWith("/mobilehome") || href.endsWith("/mobilehome/");
  }
  isPwaApp() {
    return window.matchMedia("(display-mode: standalone)").matches ||
    //(window.matchMedia('(display-mode: fullscreen)').matches) ||
    //(window.matchMedia('(display-mode: minimal-ui)').matches) ||
    window.navigator.standalone || document.referrer.includes("android-app://");
  }
  getApplicationType() {
    return this.isMobileApp() ? WebApplicationType.MobileApp : this.isPwaApp() ? WebApplicationType.PwaApp : this.mobile ? WebApplicationType.MobileBrowser : WebApplicationType.DesktopBrowser;
  }
  removeTooltip() {
    this.JQuery('.tooltip').remove();
  }
  displayVersionUpdateMessageAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.props.displayVersionUpdateMessage || !this.props.versionUpdateMessage) {
        return;
      }
      const storageId = "previousApplicationVersion";
      const currentVersion = ch.version;
      const previousVersion = UserInteractionDataStorage.get(storageId);
      if (previousVersion && currentVersion !== previousVersion) {
        yield ch.alertMessageAsync(this.props.versionUpdateMessage(), false);
      }
      UserInteractionDataStorage.set(storageId, currentVersion);
    });
  }
  /**
   * Do not delete - needed for REACT error handling
   * @return \{error: true}
   */
  // noinspection JSUnusedGlobalSymbols
  static getDerivedStateFromError() {
    return {
      error: true
    };
  }
  /**
   * @return {@link ApplicationContext.applicationName}
   */
  get applicationName() {
    return this.state.data != null ? this.state.data.applicationName : "";
  }
  // React.Component
  componentDidCatch(error, errorInfo) {
    return __awaiter(this, void 0, void 0, function* () {
      // noinspection JSVoidFunctionReturnValueUsed,TypeScriptValidateJSTypes
      const processed = yield PageRouteProvider.exception(error, errorInfo);
      if (processed && this.state.error) {
        this.setState({
          error: false
        });
      }
    });
  }
  componentDidUpdate() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._alert) {
        yield this.alertAsync(this._alert);
      }
    });
  }
  // ISpinner
  /**
   * @inheritDoc
   *
   * NOTE: only works if the {@link Layout} is mounted.
   */
  setSpinnerAsync(isSpinning) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.isSpinning !== isSpinning && this.isMounted) {
        this.setState({
          isSpinning: isSpinning
        });
      }
    });
  }
  isSpinning() {
    return this.state.isSpinning;
  }
  // BaseAsyncComponent
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      if (this.mobile) {
        this.initializeTooltips();
      }
      yield this.processTokenAsync();
      if (this.useRouting) {
        yield Layout.processUrlRouteAsync();
      }
      yield this.displayVersionUpdateMessageAsync();
      if (this.props.onDidMount) {
        yield this.props.onDidMount(this);
      }
    });
  }
  fetchDataAsync() {
    const _super = Object.create(null, {
      fetchDataAsync: {
        get: () => super.fetchDataAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.fetchContext) {
        const timezoneOffset = Utility.timezoneOffset;
        const applicationType = this.getApplicationType();
        const context = yield this.props.fetchContext(this, timezoneOffset, applicationType);
        yield ch.setContextAsync(context);
        if (context.currentPage) {
          yield PageRouteProvider.redirectAsync(context.currentPage, true);
        }
        return context;
      }
      return _super.fetchDataAsync.call(this);
    });
  }
  getEndpoint() {
    const timezoneOffset = Utility.timezoneOffset;
    const applicationType = this.getApplicationType();
    return "/api/Application/GetContext?timezoneOffset=" + timezoneOffset + "&applicationType=" + applicationType;
  }
  // IGlobalResize
  onGlobalResize(_e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.mobile !== this._mobile) {
        this._mobile = this.mobile;
        yield this.reRenderAsync();
      }
    });
  }
  // ILayoutPage
  contextChangedAsync(oldContext, newContext) {
    return __awaiter(this, void 0, void 0, function* () {
      const localizer = ServiceProvider.findLocalizer();
      const newLanguage = !!newContext && !!localizer && localizer.setLanguage(newContext.language);
      const newCountry = !!newContext && (!oldContext || oldContext.country !== newContext.country);
      if (newCountry || newLanguage) {
        //reload layout
        yield this.reRenderAsync();
      } else {
        //reload top nav only
        yield this.reloadTopNavAsync();
      }
      if (this.props.onContextChanged) yield this.props.onContextChanged(oldContext, newContext);
    });
  }
  setPageAsync(page) {
    return __awaiter(this, void 0, void 0, function* () {
      this.setState({
        page: page
      });
      if (this.mobile) {
        this.removeTooltip();
        this.initializeTooltips();
      }
    });
  }
  reRenderTopNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const topNav = TopNav.mountedInstance;
      if (topNav != null) {
        yield topNav.reRenderAsync();
      }
    });
  }
  reloadTopNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this._leftNav = null;
      const topNav = TopNav.mountedInstance;
      if (topNav != null) {
        yield topNav.reloadAsync();
        yield this.reRenderLeftNavAsync();
      }
    });
  }
  reRenderLeftNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._leftNavRef.current != null) {
        yield this._leftNavRef.current.reRenderAsync();
      }
    });
  }
  reloadLeftNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.hasLeftNav) {
        if (this._leftNavRef.current != null) {
          yield this._leftNavRef.current.reloadAsync();
        }
        yield this.reRenderAsync();
        yield this.reRenderTopNavAsync();
      }
    });
  }
  /**
   * @inheritDoc
   *
   * Only works if {@link mobile} is true.
   */
  swipeLeftAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.mobile) {
        this.removeTooltip();
        yield this.swipe(styles$I.swipeLeft);
      }
    });
  }
  /**
   * @inheritDoc
   *
   * Only works if {@link mobile} is true.
   */
  swipeRightAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.mobile) {
        this.removeTooltip();
        yield this.swipe(styles$I.swipeRight);
      }
    });
  }
  alertAsync(alert) {
    return __awaiter(this, void 0, void 0, function* () {
      const pageContainer = ServiceProvider.getService("IPageContainer");
      if (pageContainer) {
        this._alert = null;
        yield pageContainer.alertAsync(alert);
      } else {
        this._alert = alert;
      }
    });
  }
  hideAlertAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this._alert = null;
      const pageContainer = ServiceProvider.getService("IPageContainer");
      if (pageContainer) {
        yield pageContainer.hideAlertAsync();
      }
    });
  }
  setFooterVisibilityAsync(isVisible) {
    return __awaiter(this, void 0, void 0, function* () {
      this.setState({
        noFooter: !isVisible
      });
    });
  }
  setHeaderVisibilityAsync(isVisible) {
    return __awaiter(this, void 0, void 0, function* () {
      this.setState({
        noTopNav: !isVisible
      });
    });
  }
  /**
   * @inheritDoc
   * @return true
   */
  isLayout() {
    return true;
  }
  /**
   * @inheritDoc
   *
   * NOTE: handles only Bootstrap tooltips.
   */
  initializeTooltips() {
    const tooltip = this.JQuery('[data-toggle="tooltip"]');
    if (tooltip.length > 0) {
      tooltip.tooltip({
        trigger: "click",
        placement: "top"
      });
      tooltip.on("show.bs.tooltip", () => {
        this.JQuery(".tooltip").not(tooltip).remove();
      });
    }
  }
  /**
   * @inheritDoc
   *
   * NOTE: handles only Bootstrap tooltips.
   */
  reinitializeTooltips() {
    this.JQuery('[data-toggle="tooltip"]').tooltip("dispose");
    this.initializeTooltips();
  }
  download(file) {
    let src = file.src;
    // Remove prefix (e.g. "data:application/pdf;base64,") from 'src' if contains.
    if (src.toUpperCase().includes(";BASE64,")) {
      src = src.split(",")[1].trim();
    }
    const link = document.createElement("a");
    link.href = Utility.isStrDecodable(src) ? Utility.toObjectUrl(file) : src;
    link.download = file.name;
    link.target = "_self";
    link.type = file.type;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  downloadUrl(url) {
    const link = document.createElement('a');
    link.href = url;
    link.target = "_self";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  get leftNav() {
    const leftNav = this.props.leftNav ? typeof this.props.leftNav === "function" ? this.props.leftNav() : this.props.leftNav : null;
    if (leftNav != null) {
      // initialize items:
      if (leftNav.items == null) {
        const fetchTopNavItems = this.props.fetchTopNavItems;
        if (fetchTopNavItems != null) {
          leftNav.items = () => fetchTopNavItems(this);
        } else {
          leftNav.items = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            return ((_a = this._topNavRef.current) === null || _a === void 0 ? void 0 : _a.items) || [];
          });
        }
      }
      // initialize userProfile
      if (leftNav.userProfile == null) {
        //return Profile.resolveUserProfile(this, this.props.userProfile);
        const profile = TopNav.resolveProfile(this.props.profile);
        leftNav.userProfile = profile === null || profile === void 0 ? void 0 : profile.userProfile;
      }
      this._leftNav = leftNav;
    }
    return this._leftNav;
  }
  get hasTopNav() {
    return !this.state.noTopNav && this.hasData && this.state.page != null && this.state.page.hasTopNav;
  }
  get hasLeftNav() {
    return this.leftNav !== null && this.hasData && this.state.page != null && this.state.page.hasLeftNav;
  }
  get hasFooter() {
    return !this.state.noFooter && this.hasData && this.state.page != null && this.state.page.hasFooter;
  }
  /**
   * @inheritDoc
   * @see IPageContainer.alert
   */
  get alert() {
    var _a;
    const pageContainer = ServiceProvider.getService("IPageContainer");
    return (_a = pageContainer === null || pageContainer === void 0 ? void 0 : pageContainer.alert) !== null && _a !== void 0 ? _a : this._alert;
  }
  get useRouting() {
    return this.props.useRouting === true;
  }
  get christmasLightsEnabled() {
    return this.props.christmasLightsEnabled === true;
  }
  get cookieConsentLabel() {
    return this.props !== undefined && this.props.cookieConsent !== undefined ? this.props.cookieConsent().title : undefined;
  }
  handleCookieConsentLabelClick() {
    if (this.props.onCookieConsentLabelClick) {
      this.props.onCookieConsentLabelClick();
    }
  }
  // IReactComponent
  render() {
    var _a;
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$I.layout, this.props.className),
      onTouchStart: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onTouchStartHandlerAsync(e);
      }),
      onTouchEnd: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onTouchEndHandlerAsync();
      }),
      onTouchMove: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onTouchMoveHandlerAsync(e);
      })
    }, this.hasTopNav && ( /*#__PURE__*/React.createElement(TopNav, {
      ref: this._topNavRef,
      className: this.props.topNavClassName,
      applicationName: this.applicationName,
      leftNavRef: this._leftNavRef,
      fetchItems: this.props.fetchTopNavItems,
      languages: this.props.languages,
      logo: this.props.topNavLogo,
      fetchShoppingCart: this.props.fetchShoppingCartAsync,
      onShoppingCartClick: this.props.onShoppingCartClick,
      onSearchClick: this.props.onSearchClick,
      searchPlaceHolder: this.props.searchPlaceHolder,
      searchElement: this.props.searchElement,
      logoText: this.props.topNavLogoText,
      profile: this.props.profile,
      onLogoClick: this.props.onLogoClick,
      onFetchItems: () => this.onTopNavFetchItemsAsync(),
      showTopNavInfo: this.props.showTopNavInfo,
      topNavInfoText: this.props.topNavInfoText
    })), /*#__PURE__*/React.createElement("main", {
      className: this.css(styles$I.main, this.hasLeftNav && styles$I.leftNav, this.hasTopNav && this.props.showTopNavInfo && styles$I.info)
    }, this.hasLeftNav && ( /*#__PURE__*/React.createElement(LeftNav, Object.assign({
      ref: this._leftNavRef
    }, this.leftNav, {
      className: this.css(styles$I.leftNav, (_a = this.leftNav) === null || _a === void 0 ? void 0 : _a.className),
      onToggle: () => this.reRenderTopNavAsync()
    }))), !this.state.error && !this.isLoading && this.state.page != null && PageRouteProvider.render(this.state.page, this._pageRef)), this.hasFooter && !this.state.error && !this.isLoading && (this.props.useAlternativeFooter ? /*#__PURE__*/React.createElement(FooterAlternative, {
      version: ch.version,
      links: this.props.footerLinks,
      logo: this.props.footerLogo,
      name: this.props.footerName,
      socialNetworkLinks: this.props.footerSocialNetworkLinks,
      cookieConsentLabel: this.cookieConsentLabel,
      onCookieConsentLabelClick: () => this.handleCookieConsentLabelClick()
    }) : /*#__PURE__*/React.createElement(Footer, {
      version: ch.version,
      links: this.props.footerLinks,
      logo: this.props.footerLogo,
      name: this.props.footerName,
      socialNetworkLinks: this.props.footerSocialNetworkLinks,
      cookieConsentLabel: this.cookieConsentLabel,
      onCookieConsentLabelClick: () => this.handleCookieConsentLabelClick()
    })), (this.state.error || this.state.isSpinning) && ( /*#__PURE__*/React.createElement(Spinner, {
      global: true
    })), !this.isLoading && this.props.cookieConsent && ( /*#__PURE__*/React.createElement(CookieConsent, {
      description: this.props.cookieConsent().description,
      title: this.props.cookieConsent().title,
      acceptAllButtonText: this.props.cookieConsent().acceptAllButtonText,
      acceptOnlyNecessaryButtonText: this.props.cookieConsent().acceptOnlyNecessaryButtonText,
      acceptAllConsentValue: this.props.cookieConsent().acceptAllConsentValue,
      acceptOnlyNecessaryConsentValue: this.props.cookieConsent().acceptOnlyNecessaryConsentValue,
      cookieName: this.props.cookieConsent().cookieName,
      optionalCookiesNames: this.props.cookieConsent().optionalCookiesNames,
      cookieExpirationInDays: this.props.cookieConsent().cookieExpirationInDays,
      forceOpen: this.props.cookieConsent().forceOpen,
      onClose: acceptedType => {
        if (this.props.onCookieConsentClick) {
          this.props.onCookieConsentClick(acceptedType);
        }
      }
    })), this.christmasLightsEnabled && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$I.christmas, this.mobile && styles$I.mobile)
    })));
  }
}

//Autogenerated
class ListLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.loadingLanguageItemName = `Loading`;
    //Initializer
    this.set(this.loadingLanguageItemName, {
      language: `en`,
      value: `Loading...`
    }, {
      language: `uk`,
      value: `Завантаження...`
    }, {
      language: `sv`,
      value: `Laddar...`
    }, {
      language: `ru`,
      value: `Загрузка...`
    }, {
      language: `pl`,
      value: `Ładowanie...`
    }, {
      language: `nb`,
      value: `Loading...`
    }, {
      language: `fi`,
      value: `Ladataan...`
    }, {
      language: `da`,
      value: `Indlæser...`
    });
  }
  /**
  /* "Loading" (Loading...)
  */
  get loading() {
    return this.get(this.loadingLanguageItemName);
  }
}
//Singleton
var ListLocalizer$1 = new ListLocalizer();

var css_248z$x = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-list-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-list-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-list-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-list-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-list-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-list-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-list-listWrapper {\n  height: 100%;\n}\n.athenaeum-list-listWrapper .athenaeum-list-list {\n  height: 100%;\n}\n.athenaeum-list-listWrapper .athenaeum-list-list > div > label {\n  margin-bottom: 0;\n}\n.athenaeum-list-listWrapper .athenaeum-list-list div span {\n  text-transform: initial !important;\n}\n.athenaeum-list-listWrapper .athenaeum-list-list div input {\n  font-size: 0.8rem !important;\n  padding: 0.35rem !important;\n}";
var styles$t = {"font-renta":"athenaeum-list-font-renta","color-schema-renta_black":"athenaeum-list-color-schema-renta_black","color-schema-renta_white":"athenaeum-list-color-schema-renta_white","color-schema-renta_orange":"athenaeum-list-color-schema-renta_orange","color-schema-renta_green":"athenaeum-list-color-schema-renta_green","color-schema-renta_blue":"athenaeum-list-color-schema-renta_blue","listWrapper":"athenaeum-list-listWrapper","list":"athenaeum-list-list"};
styleInject(css_248z$x);

class List extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      data: null,
      isLoading: false
    };
    this._dropdownRef = /*#__PURE__*/React.createRef();
  }
  onChangeAsync(value, userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(this, value, userInteraction);
      }
    });
  }
  onItemActionAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onItemAction) {
        yield this.props.onItemAction(this, value);
      }
    });
  }
  fetchDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.fetchItems) {
        return yield this.props.fetchItems(this);
      }
      return [];
    });
  }
  getEndpoint() {
    return "";
  }
  get dropdown() {
    return this._dropdownRef.current;
  }
  get maxWidth() {
    return this.props.maxWidth || "none";
  }
  get noDataOrLoadingText() {
    return this.isLoading ? ListLocalizer$1.loading : this.props.noDataText || null;
  }
  get listItems() {
    return this.dropdown.listItems;
  }
  get selectedListItems() {
    return this.dropdown.selectedListItems;
  }
  get selectedListItem() {
    return this.dropdown.selectedListItem;
  }
  get selectedItems() {
    return this.dropdown.selectedItems;
  }
  get selectedValues() {
    return this.dropdown.selectedValues;
  }
  get selectedItem() {
    return this.dropdown.selectedItem;
  }
  get selectedValue() {
    return this.dropdown.selectedValue;
  }
  find(item) {
    return this.dropdown.find(item);
  }
  unselectAllAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.dropdown.unselectAllAsync();
    });
  }
  selectItemAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.dropdown.selectItemAsync(item);
    });
  }
  selectAsync(itemOrItems) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.dropdown.selectAsync(itemOrItems);
    });
  }
  selectListItemAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.dropdown.selectListItemAsync(item);
    });
  }
  selectListItemsAsync(items) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.dropdown.selectListItemsAsync(items);
    });
  }
  hasSpinner() {
    return true;
  }
  isAsync() {
    return this.props.fetchItems != null;
  }
  scrollToSelected(smooth = false) {
    this.dropdown.scrollToSelected(smooth);
  }
  reRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.dropdown.reRenderAsync();
    });
  }
  get items() {
    return this.state.data || [];
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$t.listWrapper,
      style: {
        maxWidth: this.maxWidth
      }
    }, /*#__PURE__*/React.createElement(Dropdown, {
      expanded: true,
      id: `${this.id}_dropdown`,
      ref: this._dropdownRef,
      absoluteListItems: this.props.absoluteListItems,
      noSubtext: true,
      noWrap: true,
      noDataText: this.noDataOrLoadingText || undefined,
      noGrouping: this.props.noGrouping,
      maxHeight: this.props.maxHeight,
      multiple: this.props.multiple,
      filterMinLength: this.props.filterMinLength,
      filterMaxLength: this.props.filterMaxLength,
      label: this.props.label,
      disabled: this.props.disabled || this.isLoading,
      type: DropdownType.List,
      required: this.props.required,
      className: this.css(styles$t.list, this.props.className),
      orderBy: this.props.orderBy,
      subtextType: this.props.subtextType,
      itemActionIcon: this.props.itemActionIcon,
      items: this.items,
      selectedItem: this.props.selectedItem,
      selectedItems: this.props.selectedItems,
      transform: this.props.transform,
      onChange: (sender, item, userInteraction) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onChangeAsync(item, userInteraction);
      }),
      onItemAction: (sender, item) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onItemActionAsync(item);
      })
    }));
  }
}

var css_248z$w = "@charset \"UTF-8\";\n/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-widget-container-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-widget-container-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-widget-container-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-widget-container-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-widget-container-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-widget-container-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-widget-container-widgetContainer {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n  max-width: 640px;\n  width: 100%;\n  margin: 0 auto;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget {\n  padding: 4px 6px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget.athenaeum-widget-container-readonly {\n  opacity: 0.8;\n  pointer-events: none;\n  cursor: not-allowed;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget.athenaeum-widget-container-approved {\n  opacity: 1;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget.athenaeum-widget-container-approved a {\n  background-color: #28a745;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget.athenaeum-widget-container-approved a:hover {\n  background-color: #28a745;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content {\n  text-decoration: none;\n  color: white;\n  background: rgb(254, 80, 0);\n  border-radius: 5px;\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 12px;\n  width: 100%;\n  cursor: pointer;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-icon, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-icon,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-icon,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-icon {\n  padding: 10px 10px 14px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-icon_hidden,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-icon_hidden {\n  visibility: hidden;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-number, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-number, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-date, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-date,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-number,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-number,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-date,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-date {\n  padding: 10px 10px 14px;\n  font-size: 4em;\n  line-height: 42px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-number span:empty:before, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-date span:empty:before,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-number span:empty:before,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-date span:empty:before {\n  content: \"​\";\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-number, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-number, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-date, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-date,\n  .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-number,\n  .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-number,\n  .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-date,\n  .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-date {\n    font-size: 3em;\n  }\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-smallNumbers span > small,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-smallNumbers span > small {\n  font-size: 50%;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-date,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-date {\n  font-size: 2rem;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-description, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-description,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-description,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-description {\n  border-top: 1px solid;\n  font-size: 0.85em;\n  padding-top: 0.5em;\n  display: flex;\n  flex-grow: 0;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-description span:empty:before, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-description span:empty:before,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-description span:empty:before {\n  content: \"​\";\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  flex-grow: 1;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n  padding: 10px 0 14px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-edit input,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-edit input {\n  width: 100px;\n  margin-bottom: 3px;\n  margin-top: 4px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-readonly,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-readonly {\n  opacity: 0.5;\n  cursor: default;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-disabled,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-number, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-date,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-number,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-date {\n  width: 100px;\n  padding: 0;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-qr,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-qr {\n  display: flex;\n  justify-content: center;\n  padding: 10px 0 14px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature {\n  padding: 8px 0 12px 0;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-signaturePad,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-signaturePad {\n  background-color: #ff7e51;\n  border-radius: 5px;\n  width: 100%;\n  height: 200px;\n  cursor: pointer;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-buttonContainer,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-buttonContainer {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 8px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-buttonContainer button,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-buttonContainer button {\n  display: block;\n  width: 100%;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-buttonContainer button:first-child,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-contentContainer .athenaeum-widget-container-signature .athenaeum-widget-container-buttonContainer button:first-child {\n  margin-right: 8px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer {\n  display: none;\n  align-items: center;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-status,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-status {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-dropdownWidget,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-dropdownWidget {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-edit input,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-edit input {\n  width: 74px;\n  margin-right: 10px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-readonly,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget.athenaeum-widget-container-readonly {\n  opacity: 0.5;\n  cursor: default;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-number, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-date,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-number,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-date {\n  padding: 0 10px 0 0;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-disabled,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget .athenaeum-widget-container-disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget i,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-numberWidget i {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-icon,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-icon {\n  padding: 0 10px 0 0;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-number, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-date,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-number,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-date {\n  padding: 0 10px 0 0;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription {\n  width: 100%;\n  word-break: break-word;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-description,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-description {\n  display: block;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-label,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-label {\n  display: block;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a:hover,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact .athenaeum-widget-container-contentContainer {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact .athenaeum-widget-container-description, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-description, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-compact .athenaeum-widget-container-description,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-description,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-compact .athenaeum-widget-container-description {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact .athenaeum-widget-container-label, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-label, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget a .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-compact .athenaeum-widget-container-label,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-label,\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-content .athenaeum-widget-container-compactContainer .athenaeum-widget-container-labelAndDescription .athenaeum-widget-container-compact .athenaeum-widget-container-label {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-compact .athenaeum-widget-container-compactContainer {\n  display: flex;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-transparent {\n  background: rgba(234, 60, 0, 0.5);\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-transparent:hover {\n  background: rgba(234, 60, 0, 0.6);\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  padding: 10px 10px 14px;\n  line-height: 42px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent .athenaeum-widget-container-status {\n  width: 76px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent .athenaeum-widget-container-switch, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent .athenaeum-widget-container-checked {\n  width: 56px;\n  height: 32px;\n  border: 1px solid lightgrey;\n  border-radius: 5px;\n  background-color: white;\n  position: relative;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent .athenaeum-widget-container-switch .athenaeum-widget-container-toggler, .athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent .athenaeum-widget-container-checked .athenaeum-widget-container-toggler {\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  height: inherit;\n  width: 20px;\n  border: inherit;\n  border-radius: 5px;\n  transition: all 0.3s ease;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent .athenaeum-widget-container-checked {\n  background-color: rgb(254, 80, 0);\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-switchContent .athenaeum-widget-container-checked .athenaeum-widget-container-toggler {\n  background-color: white;\n  left: 35px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-textInput .athenaeum-widget-container-inputContainer {\n  padding: 10px 10px 14px;\n  margin: 2px 0;\n  text-align: left;\n  position: relative;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-textInput .athenaeum-widget-container-inputContainer > input {\n  margin-top: 1px;\n  margin-bottom: 2px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-textInput .athenaeum-widget-container-inputContainer .athenaeum-widget-container-autoCompleteToggler {\n  position: absolute;\n  color: black;\n  right: 1.3rem;\n  top: 1.3rem;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-textInput .athenaeum-widget-container-inputContainer .athenaeum-widget-container-autoCompleteContainer {\n  padding: 0 10px;\n  position: relative;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-textInput .athenaeum-widget-container-inputContainer .athenaeum-widget-container-autoCompleteContainer.athenaeum-widget-container-mobile {\n  padding: 0;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-textInput .athenaeum-widget-container-inputContainer .athenaeum-widget-container-autoCompleteContainer.athenaeum-widget-container-mobile .athenaeum-widget-container-autoComplete {\n  position: unset;\n  border: none;\n  box-shadow: none;\n  background-color: inherit;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-textInput .athenaeum-widget-container-valueContainer {\n  height: 66px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  word-break: break-word;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-products {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget .athenaeum-widget-container-products .athenaeum-widget-container-category {\n  width: 100px;\n  height: 100px;\n  margin: auto;\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget.athenaeum-widget-container-checkStepContainer {\n  background: rgb(254, 80, 0);\n  padding: 15px;\n  border-radius: 10px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget.athenaeum-widget-container-checkStepContainer > a {\n  background: transparent;\n  box-shadow: none;\n  border-radius: 0;\n  padding: 0;\n  text-align: left;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-widget.athenaeum-widget-container-checkStepContainer .athenaeum-widget-container-checkStep i {\n  color: white;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar {\n  height: 143px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  display: flex;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-labels {\n  text-align: left;\n  width: auto;\n  min-width: 180px;\n  left: 0;\n  align-self: flex-start;\n  float: left;\n  padding: 8px;\n  border-radius: 5px;\n  background-color: #ea3c00;\n  opacity: 0.7;\n  margin-left: -6px;\n  margin-top: -6px;\n  font-size: 0.8em;\n  position: absolute;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-labels .athenaeum-widget-container-labelsContainer {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-labels span {\n  display: block;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-sets {\n  width: 100%;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-sets .athenaeum-widget-container-setsContainer {\n  display: flex;\n  height: calc(100% - 18px);\n  border-right: 1px dashed #ffd1bb;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-sets .athenaeum-widget-container-setsContainer span {\n  min-width: 4px;\n  width: 100%;\n  align-self: flex-end;\n  margin: 0 2px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-sets .athenaeum-widget-container-setsContainer span.athenaeum-widget-container-color1 {\n  background-color: #dd3162;\n  border: 1px solid #ff6384;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-sets .athenaeum-widget-container-setsContainer span.athenaeum-widget-container-color2 {\n  background-color: rgba(49, 175, 212, 0.5);\n  border: 1px solid #31afd4;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer .athenaeum-widget-container-sets .athenaeum-widget-container-setsContainer.athenaeum-widget-container-borderLeft {\n  border-left: 1px dashed #ffd1bb;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer.athenaeum-widget-container-hideLabels .athenaeum-widget-container-labels {\n  display: none;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer:hover .athenaeum-widget-container-labels {\n  opacity: 1;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-bar .athenaeum-widget-container-barContainer:hover .athenaeum-widget-container-labelsContainer {\n  display: block;\n}\n.athenaeum-widget-container-widgetContainer > button {\n  margin: 4px 6px;\n  height: 80px;\n}\n.athenaeum-widget-container-widgetContainer .athenaeum-widget-container-dropdownWidget .athenaeum-widget-container-noDescription .dropdown-container {\n  bottom: -12px;\n}";
var widgetStyles = {"font-renta":"athenaeum-widget-container-font-renta","color-schema-renta_black":"athenaeum-widget-container-color-schema-renta_black","color-schema-renta_white":"athenaeum-widget-container-color-schema-renta_white","color-schema-renta_orange":"athenaeum-widget-container-color-schema-renta_orange","color-schema-renta_green":"athenaeum-widget-container-color-schema-renta_green","color-schema-renta_blue":"athenaeum-widget-container-color-schema-renta_blue","widgetContainer":"athenaeum-widget-container-widgetContainer","widget":"athenaeum-widget-container-widget","readonly":"athenaeum-widget-container-readonly","approved":"athenaeum-widget-container-approved","content":"athenaeum-widget-container-content","icon":"athenaeum-widget-container-icon","compactContainer":"athenaeum-widget-container-compactContainer","icon_hidden":"athenaeum-widget-container-icon_hidden","number":"athenaeum-widget-container-number","date":"athenaeum-widget-container-date","smallNumbers":"athenaeum-widget-container-smallNumbers","description":"athenaeum-widget-container-description","labelAndDescription":"athenaeum-widget-container-labelAndDescription","contentContainer":"athenaeum-widget-container-contentContainer","numberWidget":"athenaeum-widget-container-numberWidget","edit":"athenaeum-widget-container-edit","disabled":"athenaeum-widget-container-disabled","qr":"athenaeum-widget-container-qr","signature":"athenaeum-widget-container-signature","signaturePad":"athenaeum-widget-container-signaturePad","buttonContainer":"athenaeum-widget-container-buttonContainer","status":"athenaeum-widget-container-status","dropdownWidget":"athenaeum-widget-container-dropdownWidget","label":"athenaeum-widget-container-label","compact":"athenaeum-widget-container-compact","transparent":"athenaeum-widget-container-transparent","switchContent":"athenaeum-widget-container-switchContent","switch":"athenaeum-widget-container-switch","checked":"athenaeum-widget-container-checked","toggler":"athenaeum-widget-container-toggler","textInput":"athenaeum-widget-container-textInput","inputContainer":"athenaeum-widget-container-inputContainer","autoCompleteToggler":"athenaeum-widget-container-autoCompleteToggler","autoCompleteContainer":"athenaeum-widget-container-autoCompleteContainer","mobile":"athenaeum-widget-container-mobile","autoComplete":"athenaeum-widget-container-autoComplete","valueContainer":"athenaeum-widget-container-valueContainer","products":"athenaeum-widget-container-products","category":"athenaeum-widget-container-category","checkStepContainer":"athenaeum-widget-container-checkStepContainer","checkStep":"athenaeum-widget-container-checkStep","bar":"athenaeum-widget-container-bar","barContainer":"athenaeum-widget-container-barContainer","labels":"athenaeum-widget-container-labels","labelsContainer":"athenaeum-widget-container-labelsContainer","sets":"athenaeum-widget-container-sets","setsContainer":"athenaeum-widget-container-setsContainer","color1":"athenaeum-widget-container-color1","color2":"athenaeum-widget-container-color2","borderLeft":"athenaeum-widget-container-borderLeft","hideLabels":"athenaeum-widget-container-hideLabels","noDescription":"athenaeum-widget-container-noDescription"};
styleInject(css_248z$w);

class BaseWidgetContainer extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      data: null,
      isLoading: false
    };
    this._widgetToggleStates = new Dictionary();
    this._pageId = null;
  }
  onDropdownWidgetToggleHandlerAsync(sender, expanded) {
    return __awaiter(this, void 0, void 0, function* () {
      const toggle = expanded;
      if (toggle) {
        this._widgetToggleStates.clear();
      }
      if (this.mobile) {
        const widgets = this.childComponents.filter(component => component !== sender && component.isWidget).map(component => component);
        yield Utility.forEachAsync(widgets, widget => __awaiter(this, void 0, void 0, function* () {
          const widgetId = widget.id;
          if (toggle) {
            const maximized = !widget.minimized;
            this._widgetToggleStates.setValue(widgetId, maximized);
            yield widget.minimizeAsync();
          } else {
            const maximized = this._widgetToggleStates.getValue(widgetId) || null;
            if (maximized) {
              yield widget.maximizeAsync();
            }
          }
        }));
      }
    });
  }
  extendChildProps(element) {
    if (!this.noToggle && element.props.onToggle == null) {
      return {
        onToggle: (sender, expanded) => __awaiter(this, void 0, void 0, function* () {
          return sender.siblingsAutoToggle && (yield this.onDropdownWidgetToggleHandlerAsync(sender, expanded));
        })
      };
    }
    return null;
  }
  get widgetIds() {
    return this.state.data;
  }
  get widgets() {
    let widgets = this.children;
    if (this.isAsync()) {
      widgets = widgets.filter(item => !item.props.id || item.props.id.startsWith("_") || this.widgetIds != null && this.widgetIds.includes(item.props.id));
    }
    return widgets;
  }
  get noToggle() {
    return this.props.noToggle === true;
  }
  get controller() {
    return this.props.controller;
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      BaseWidgetContainer.mountedInstance = this;
      yield _super.initializeAsync.call(this);
    });
  }
  componentWillUnmount() {
    const _super = Object.create(null, {
      componentWillUnmount: {
        get: () => super.componentWillUnmount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentWillUnmount.call(this);
      if (BaseWidgetContainer.mountedInstance === this) {
        BaseWidgetContainer.mountedInstance = null;
      }
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      //update props
      this.props = nextProps;
      //check page state
      const pageId = ch.findPageId();
      const reload = this._pageId !== pageId;
      this._pageId = pageId;
      //reload data async if needed
      yield this.invokeReloadDataAsync(reload);
      //call base class
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  getEndpoint() {
    return `api/${this.props.controller}/getWidgets`;
  }
  isAsync() {
    return !!this.props.controller && this.props.async === true;
  }
  renderContent(renderHidden = false) {
    return this.widgets;
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(this.props.className, widgetStyles.widgetContainer)
    }, this.renderContent());
  }
}
BaseWidgetContainer.mountedInstance = null;

class WidgetContainer extends BaseWidgetContainer {}

//Autogenerated
class WidgetContainerLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Initializer
  }
}
//Singleton
var WidgetContainerLocalizer$1 = new WidgetContainerLocalizer();

class BaseWidget extends BaseAsyncComponent {
  constructor() {
    super(...arguments);
    this.state = {
      text: this.props.text,
      number: null,
      date: null,
      label: this.props.label,
      description: this.props.description,
      icon: this.props.icon,
      isLoading: false,
      data: null,
      spinnerVisible: false,
      minimized: this.props.minimized === true,
      transparent: this.props.transparent === true
    };
  }
  onSpinnerDelayHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isSpinning()) {
        yield this.setState({
          spinnerVisible: true
        });
      }
    });
  }
  get numberFormat() {
    return "0";
  }
  get dateFormat() {
    return "D";
  }
  getDescription() {
    return this.state.description;
  }
  getLabel() {
    return this.state.label;
  }
  getNumber() {
    return this.state.date != null ? Utility.formatValue(this.state.date, this.dateFormat) : this.state.number != null ? Utility.formatValue(this.state.number, this.numberFormat) : this.state.text || "";
  }
  isAsync() {
    return !!this.props.id && this.props.async === true;
  }
  get transparent() {
    return this.state.transparent;
  }
  toggleTransparentAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const transparent = !this.transparent;
      yield this.setState({
        transparent
      });
    });
  }
  processDataAsync(state, data) {
    return __awaiter(this, void 0, void 0, function* () {
      const date = Utility.isDateType(data) ? new Date(data) : null;
      const number = data != null && typeof data === "number" ? data : null;
      state.text = data;
      state.number = number != null ? number : null;
      state.date = date;
      state.spinnerVisible = false;
    });
  }
  get number() {
    return !this.isSpinning() ? this.getNumber() : "\u00A0";
  }
  get label() {
    return WidgetContainerLocalizer$1.get(this.getLabel());
  }
  get description() {
    const description = this.getDescription();
    return WidgetContainerLocalizer$1.get(description, this.state.number);
  }
  get icon() {
    const icon = this.state.icon;
    if (icon != null) {
      icon.size = this.state.minimized ? IconSize.X2 : IconSize.X3;
    }
    return icon;
  }
  get wide() {
    return this.props.wide === true;
  }
  get contentFlexStyle() {
    return {
      flexGrow: `${this.props.stretchContent ? 1 : 0}`
    };
  }
  get descriptionFlexStyle() {
    return {
      flexGrow: `${!this.props.stretchContent ? 1 : 0}`
    };
  }
  hasDescription() {
    return !!this.description;
  }
  getActionEndpoint(action) {
    const controller = BaseWidgetContainer.mountedInstance && BaseWidgetContainer.mountedInstance.controller ? BaseWidgetContainer.mountedInstance.controller : "Dashboard";
    return `api/${controller}/${action}`;
  }
  getEndpoint() {
    const action = `get${this.props.id}Data`;
    return this.getActionEndpoint(action);
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      // do nothing
    });
  }
  onMouseDownAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      // do nothing
    });
  }
  getTarget() {
    return LinkTarget.Self;
  }
  getHref() {
    return "javascript:void(0)";
  }
  getInnerClassName() {
    return "";
  }
  get classNames() {
    var _a;
    const classNamesCopy = (_a = Object.assign({}, this.props.classNames)) !== null && _a !== void 0 ? _a : {};
    Object.keys(widgetStyles).forEach(key => !classNamesCopy[key] ? classNamesCopy[key] = widgetStyles[key] : classNamesCopy[key]);
    return classNamesCopy;
  }
  isWidget() {
    return true;
  }
  hasSpinner() {
    return true;
  }
  isSpinning() {
    return this.isAsync() && this.state.data == null;
  }
  get minimized() {
    return this.state.minimized;
  }
  get containsTagSmall() {
    return this.number.includes("<small>");
  }
  toggleMinimized() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.minimized) {
        yield this.maximizeAsync();
      } else {
        yield this.minimizeAsync();
      }
    });
  }
  minimizeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.state.minimized) {
        yield this.setState({
          minimized: true
        });
      }
    });
  }
  maximizeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.state.minimized) {
        yield this.setState({
          minimized: false
        });
      }
    });
  }
  renderLabel() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.label, this.classNames.label)
    }, /*#__PURE__*/React.createElement("span", null, this.toMultiLines(this.label)));
  }
  renderContent(renderHidden = false) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.icon && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.icon, this.state.spinnerVisible && widgetStyles.icon_hidden, renderHidden && widgetStyles.icon_hidden)
    }, /*#__PURE__*/React.createElement(Icon, Object.assign({}, this.icon)))), !this.icon && this.number && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.number, this.containsTagSmall && widgetStyles.smallNumbers)
    }, /*#__PURE__*/React.createElement("span", null, ReactUtility.toSmalls(this.number)))));
  }
  renderDescription() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.description, this.classNames.description),
      style: this.descriptionFlexStyle
    }, /*#__PURE__*/React.createElement("span", null, this.toMultiLines(this.description)));
  }
  renderExtendedContent() {
    return null;
  }
  renderMinimized() {
    const minimized = this.minimized;
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.compactContainer, this.classNames.compactContainer)
    }, minimized && this.renderContent(), /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.labelAndDescription, this.classNames.labelAndDescription)
    }, this.label && /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.label, this.classNames.label)
    }, /*#__PURE__*/React.createElement("span", null, this.label)), this.description && /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.description, this.classNames.description)
    }, /*#__PURE__*/React.createElement("span", null, this.description))), minimized && this.renderContent(true));
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      let newState = null;
      if (this.props.description !== nextProps.description) {
        newState = newState || {};
        newState.description = nextProps.description;
      }
      if (this.props.label !== nextProps.label) {
        newState = newState || {};
        newState.label = nextProps.label;
      }
      if (this.props.icon !== nextProps.icon) {
        newState = newState || {};
        newState.icon = nextProps.icon;
      }
      if (this.props.text !== nextProps.text) {
        newState = newState || {};
        newState.text = nextProps.text;
      }
      if (this.props.minimized !== nextProps.minimized) {
        newState = newState || {};
        newState.minimized = nextProps.minimized;
      }
      if (newState != null) {
        yield this.setState(newState);
      }
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  render() {
    const minimized = this.minimized;
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(widgetStyles.widget, this.props.className, this.getInnerClassName(), this.wide ? "col-md-12" : "col-md-6", this.classNames.widget)
    }, /*#__PURE__*/React.createElement("a", {
      href: this.getHref(),
      rel: "noreferrer",
      title: this.toSingleLine(this.description || this.label),
      target: this.getTarget(),
      className: this.css(minimized && widgetStyles.compact, this.transparent && widgetStyles.transparent),
      draggable: false,
      onMouseDown: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onMouseDownAsync(e);
      }),
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onClickAsync(e);
      })
    }, !minimized && this.renderLabel(), /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.contentContainer, this.classNames.contentContainer),
      style: this.contentFlexStyle
    }, !minimized && this.renderContent(), this.renderExtendedContent()), !minimized && this.hasDescription() && this.renderDescription(), this.renderMinimized()), this.isSpinning() && ( /*#__PURE__*/React.createElement(Spinner, {
      noShading: true,
      onDelay: () => this.onSpinnerDelayHandlerAsync()
    })));
  }
}

//Autogenerated
class DropdownWidgetLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Initializer
  }
}
//Singleton
var DropdownWidgetLocalizer$1 = new DropdownWidgetLocalizer();

class DropdownWidget extends BaseWidget {
  constructor() {
    // Fields
    super(...arguments);
    this._dropdownRef = /*#__PURE__*/React.createRef();
  }
  // Properties
  get dropdown() {
    return this._dropdownRef.current;
  }
  get favorite() {
    return this.props.favorite || false;
  }
  get items() {
    return this.dropdown ? this.dropdown.items : [];
  }
  get selectedItems() {
    return this.dropdown ? this.dropdown.selectedItems : [];
  }
  get selectedItem() {
    return this.dropdown ? this.dropdown.selectedItem : null;
  }
  get selectedValue() {
    return this.dropdown ? this.dropdown.selectedValue : null;
  }
  get listItems() {
    return this.dropdown ? this.dropdown.listItems : [];
  }
  get selectedListItems() {
    return this.dropdown ? this.dropdown.selectedListItems : [];
  }
  get selectedListItem() {
    return this.dropdown ? this.dropdown.selectedListItem : null;
  }
  get selectedValues() {
    return this.dropdown ? this.dropdown.selectedValues : [];
  }
  get siblingsAutoToggle() {
    return this.props.siblingsAutoToggle !== false;
  }
  get disabled() {
    return this.props.disabled === true;
  }
  // Methods
  calcDropdownAvailableHeight() {
    let availableHeight = 0;
    if (this.mobile) {
      const widgetContainer = WidgetContainer.mountedInstance;
      const pageContainer = PageContainer.instance;
      if (widgetContainer && pageContainer) {
        const pageContainerHeight = pageContainer.height();
        const widgetContainerOuterHeight = widgetContainer.outerHeight(true);
        const dropdownOuterHeight = this.dropdown ? this.dropdown.outerHeight() : 0;
        availableHeight = pageContainerHeight - widgetContainerOuterHeight + dropdownOuterHeight;
      }
    }
    if (this.props.minHeight && availableHeight < this.props.minHeight) {
      return this.props.minHeight;
    }
    return availableHeight > 0 ? availableHeight : undefined;
  }
  updateDescriptionAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        const description = yield this.getDescription();
        if (this.state.description !== description) {
          yield this.setState({
            description: description
          });
        }
      }
    });
  }
  getDescription() {
    const showSubtext = !this.props.noSubtext;
    if (this.props.noDescription) {
      return "";
    }
    if (!this.selectedListItem) {
      return this.props.description ? DropdownWidgetLocalizer$1.get(this.props.description) : "";
    }
    if (showSubtext && this.selectedListItem.subtext) {
      return `${DropdownWidgetLocalizer$1.get(this.selectedListItem.text)}, ${DropdownWidgetLocalizer$1.get(this.selectedListItem.subtext)}`;
    }
    return DropdownWidgetLocalizer$1.get(this.selectedListItem.text);
  }
  getStyleSchema() {
    return DropdownSchema.Widget;
  }
  processDataAsync(state, data) {
    const _super = Object.create(null, {
      processDataAsync: {
        get: () => super.processDataAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.processDataAsync.call(this, state, data);
    });
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.stopPropagation();
      if (!this.disabled && this.isMounted && this.dropdown) {
        if (this.dropdown.collapsed && this.state.minimized) {
          yield this.setState({
            minimized: false
          });
        } else if (this.props.minimized) {
          yield this.setState({
            minimized: true
          });
        }
        yield this.dropdown.toggleAsync();
      }
    });
  }
  onFavoriteChangeAsync(sender, item, favorite) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onFavoriteChange) {
        yield this.props.onFavoriteChange(this, item, favorite);
      }
    });
  }
  onChangeHandlerAsync(sender, item, userInteraction) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.updateDescriptionAsync();
      if (userInteraction && this.props.autoCollapse) {
        yield this.collapseAsync();
      }
      if (this.props.onChange) {
        yield this.props.onChange(this, item, userInteraction);
      }
    });
  }
  onChangeAmountHandlerAsync(sender, item, amount) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChangeAmount) {
        yield this.props.onChangeAmount(this, item, amount);
      }
    });
  }
  onToggleHandlerAsync(sender, expanded) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onToggle) {
        yield this.props.onToggle(this, expanded);
      }
    });
  }
  onItemsChangeHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.updateDescriptionAsync();
    });
  }
  onItemClickHandlerAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onItemClick) {
        yield this.props.onItemClick(this, item);
      }
    });
  }
  onAddHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onAdd) {
        yield this.props.onAdd(this);
      }
    });
  }
  fetchDataAsync() {
    const _super = Object.create(null, {
      fetchDataAsync: {
        get: () => super.fetchDataAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.fetchDataAsync) {
        return yield this.props.fetchDataAsync(this, this.getEndpoint());
      }
      return yield _super.fetchDataAsync.call(this);
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      const outside = Utility.clickedOutside(target, this.id);
      if (outside) {
        yield this.collapseAsync();
      }
    });
  }
  collapseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted && this.dropdown && this.dropdown.expanded) {
        if (this.props.minimized) {
          yield this.setState({
            minimized: true
          });
        }
        yield this.dropdown.collapseAsync();
      }
    });
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.initializeAsync.call(this);
      if (this.props.items) {
        this.state.data = this.props.items;
        yield this.reRenderAsync();
      }
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.isAsync()) {
        const newItems = !Comparator.isEqual(this.props.items, nextProps.items);
        if (newItems) {
          this.state.data = nextProps.items || [];
        }
      }
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  isAsync() {
    return this.props.fetchDataAsync != null || super.isAsync();
  }
  isWidget() {
    return true;
  }
  hasSpinner() {
    return true;
  }
  find(item) {
    return this.dropdown ? this.dropdown.find(item) : null;
  }
  unselectAllAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.dropdown) {
        yield this.dropdown.unselectAllAsync();
      }
    });
  }
  selectItemAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.dropdown) {
        yield this.dropdown.selectItemAsync(item);
      }
    });
  }
  selectAsync(itemOrItems) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.dropdown) {
        yield this.dropdown.selectAsync(itemOrItems);
      }
    });
  }
  selectListItemAsync(item) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.dropdown) {
        yield this.dropdown.selectListItemAsync(item);
      }
    });
  }
  selectListItemsAsync(items) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.dropdown) {
        yield this.dropdown.selectListItemsAsync(items);
      }
    });
  }
  renderExtendedContent() {
    const dropdownType = this.mobile ? DropdownType.List : DropdownType.Dropdown;
    const dropdownStyles = !this.description && widgetStyles.noDescription;
    return /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.dropdownWidget
    }, this.state.data && ( /*#__PURE__*/React.createElement(Dropdown, {
      id: `dropdown_${this.id}`,
      ref: this._dropdownRef,
      className: this.css(widgetStyles.dropdown, dropdownStyles),
      type: dropdownType,
      styleSchema: this.getStyleSchema(),
      maxHeight: () => this.calcDropdownAvailableHeight(),
      favorite: this.favorite,
      autoCollapse: this.props.autoCollapse,
      expanded: this.props.expanded && this.mobile,
      required: this.props.required,
      requiredType: this.props.requiredType,
      multiple: this.props.multiple,
      orderBy: this.props.orderBy,
      subtextType: this.props.subtextType,
      autoGroupSelected: this.props.autoGroupSelected,
      groupSelected: this.props.groupSelected,
      selectedItem: this.props.selectedItem,
      selectedItems: this.props.selectedItems,
      addButton: this.props.addButton,
      items: this.state.data || [],
      toggleButtonId: this.id,
      disabled: this.props.disabled,
      transform: this.props.transform,
      onAdd: () => this.onAddHandlerAsync(),
      onChange: (sender, item, userInteraction) => this.onChangeHandlerAsync(sender, item, userInteraction),
      onChangeAmount: (sender, item, amount) => this.onChangeAmountHandlerAsync(sender, item, amount),
      onFavoriteChange: (sender, item, favorite) => this.onFavoriteChangeAsync(sender, item, favorite),
      onToggle: (sender, expanded) => this.onToggleHandlerAsync(sender, expanded),
      onItemsChange: () => this.onItemsChangeHandlerAsync(),
      onItemClick: (sender, item) => this.onItemClickHandlerAsync(item)
    })));
  }
}

class SwitchNullable extends CheckboxNullable {
  renderInput() {
    const toggleStyles = this.value === false ? styles$F.nullableSwitchUnchecked : this.value === true ? styles$F.nullableSwitchChecked : styles$F.nullableSwitch;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$F.container
    }, this.props.leftLabel && /*#__PURE__*/React.createElement("span", {
      className: styles$F.label
    }, this.props.leftLabel), /*#__PURE__*/React.createElement("div", {
      className: this.css(toggleStyles, this.readonly && styles$F.readonly)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$F.zone,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.uncheckAsync();
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$F.zone,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.setNullAsync();
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$F.zone,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.checkAsync();
      })
    }), /*#__PURE__*/React.createElement("span", {
      className: styles$F.toggler
    })), this.props.rightLabel && /*#__PURE__*/React.createElement("span", {
      className: styles$F.label
    }, this.props.rightLabel));
  }
}

class BaseRouteWidget extends BaseWidget {
  getRoute() {
    const propsRoute = this.props.route;
    return typeof propsRoute === "function" ? propsRoute() : propsRoute ? propsRoute : null;
  }
  getHref() {
    const route = this.getRoute();
    return this.useRouting && route ? PageRoute.toRelativePath(route) : super.getHref();
  }
  onNavigateAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      // do nothing
    });
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        e.stopPropagation();
        if (this.useRouting) {
          // e.stopPropagation does not stop the browser from navigating to the page the widget URL points to, this does.
          // If routing is not enabled, then the URL is javascript, which does not lead to navigation anyway.
          e.preventDefault();
        }
        yield this.onNavigateAsync();
        const route = this.getRoute();
        if (route) {
          yield PageRouteProvider.redirectAsync(route);
        }
      }
    });
  }
}

class TimeWidget extends BaseRouteWidget {
  onNavigateAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onClick) {
        yield this.props.onClick();
      }
    });
  }
  setTimer() {
    setTimeout(() => __awaiter(this, void 0, void 0, function* () {
      return yield this.refreshDescriptionAsync();
    }), 1000);
  }
  refreshDescriptionAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        yield this.reRenderAsync();
      }
      this.setTimer();
    });
  }
  get description() {
    let description = "";
    const now = Utility.now();
    if (this.props.checkout) {
      if (this.state.data != null) {
        const beginAt = new Date(this.state.data);
        const diff = Utility.diff(now, beginAt);
        description = diff.toTimeString();
      }
    } else {
      description = Utility.format("{0:dd.MM.yyyy} {0:dddd} {0:HH:mm:ss}", now);
    }
    return description;
  }
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.date != null) {
        this.state.data = this.props.date;
      }
      this.setTimer();
    });
  }
}

class BaseCheckboxWidget extends BaseWidget {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChangeAsync(checked) {
    return __awaiter(this, void 0, void 0, function* () {
      // do nothing
    });
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.enabled) {
        const checked = !this.checked;
        const state = this.state;
        state.data = checked;
        if (this.isMounted) {
          e.stopPropagation();
          yield this.onChangeAsync(checked);
          yield this.setState(state);
        }
      }
    });
  }
  get icon() {
    const icon = this.checked ? {
      name: "check-circle",
      style: IconStyle.Solid
    } : {
      name: "circle",
      style: IconStyle.Regular
    };
    icon.size = this.minimized ? IconSize.X2 : IconSize.X3;
    return icon;
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (nextProps.checked !== this.props.checked) {
        this.state.data = nextProps.checked === true;
      }
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const state = this.state;
      state.data = this.props.checked ? this.props.checked : false;
    });
  }
  get checked() {
    return this.state.data === true;
  }
  get disabled() {
    return this.props.disabled === true;
  }
  get enabled() {
    return !this.disabled;
  }
  isWidget() {
    return true;
  }
  hasSpinner() {
    return true;
  }
}

class CheckboxWidget extends BaseCheckboxWidget {
  get minimized() {
    return this.mobile || this.state.minimized;
  }
  onChangeAsync(checked) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(this, checked);
      }
    });
  }
}

class CheckStepWidget extends BaseCheckboxWidget {
  get minimized() {
    return false;
  }
  onChangeAsync(checked) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(this, checked);
      }
    });
  }
  get icon() {
    return null;
  }
  renderLabel() {
    return null;
  }
  renderDescription() {
    return null;
  }
  renderMinimized() {
    return null;
  }
  get wide() {
    return true;
  }
  getInnerClassName() {
    return widgetStyles.checkStepContainer;
  }
  renderContent(renderHidden = false) {
    return /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.checkStep
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-between"
    }, this.label && ( /*#__PURE__*/React.createElement("span", null, this.label)), /*#__PURE__*/React.createElement(Checkbox, {
      className: widgetStyles.checkbox,
      value: this.checked,
      onChange: (sender, value) => __awaiter(this, void 0, void 0, function* () {
        return yield this.onChangeAsync(value);
      })
    })), this.description && ( /*#__PURE__*/React.createElement("span", null, this.description)));
  }
}

class BaseExpandableWidget extends BaseWidget {
  constructor() {
    super(...arguments);
    this._contentVisible = false;
  }
  setContentAsync(visible) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._contentVisible !== visible) {
        this._contentVisible = visible;
        const minimized = this.props.minimized == true ? !visible : false;
        yield this.setState({
          minimized: minimized
        });
      }
    });
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.isSpinning()) {
        yield this.toggleContentAsync();
      }
    });
  }
  toggleContentAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setContentAsync(!this.contentVisible);
    });
  }
  showContentAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setContentAsync(true);
    });
  }
  hideContentAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setContentAsync(false);
    });
  }
  get contentVisible() {
    return this._contentVisible;
  }
  isAsync() {
    return false;
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.isSpinning()) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id);
        if (outside) {
          yield this.hideContentAsync();
        }
      }
    });
  }
  renderContent(renderHidden = false) {
    return this.contentVisible ? ( /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.expandableContent
    }, this.renderExpanded())) : super.renderContent(renderHidden);
  }
}

//Autogenerated
class DateInputWidgetLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Initializer
  }
}
//Singleton
var DateInputWidgetLocalizer$1 = new DateInputWidgetLocalizer();

var css_248z$v = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.dateInputContainer {\n  padding: 10px 0 12px 0;\n}\n\n.dateInputWidget {\n  background-color: rgb(254, 80, 0);\n  border-color: white;\n}\n.dateInputWidget .react-datepicker__triangle {\n  border-bottom-color: #e04716;\n}\n.dateInputWidget .react-datepicker__navigation.react-datepicker__navigation--previous {\n  border-right-color: white;\n}\n.dateInputWidget .react-datepicker__navigation.react-datepicker__navigation--next {\n  border-left-color: white;\n}\n.dateInputWidget .react-datepicker__header {\n  background-color: #e04716;\n  border-color: white;\n}\n.dateInputWidget .react-datepicker__header .react-datepicker__current-month {\n  color: white;\n}\n.dateInputWidget .react-datepicker__header .react-datepicker__day-name {\n  color: white;\n}\n.dateInputWidget .react-datepicker__header .react-datepicker-time__header {\n  color: white;\n}\n.dateInputWidget .react-datepicker__day {\n  color: white;\n}\n.dateInputWidget .react-datepicker__day:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.dateInputWidget .react-datepicker__day--today {\n  border: 1px solid white;\n  border-radius: 50%;\n  height: 1.7rem;\n}\n.dateInputWidget .react-datepicker__day--selected {\n  background-color: #337ab7;\n}\n.dateInputWidget .react-datepicker__today-button {\n  background-color: #e04716;\n  color: white;\n  border-top-color: white;\n}\n.dateInputWidget .react-datepicker__day--disabled {\n  color: #ccc;\n}\n.dateInputWidget .react-datepicker__day--disabled:hover {\n  background-color: transparent !important;\n}";
styleInject(css_248z$v);

class DateInputWidget extends BaseExpandableWidget {
  handleChangeAsync(date) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(date);
      }
      yield this.hideContentAsync();
    });
  }
  onClickAsync(e) {
    const _super = Object.create(null, {
      toggleContentAsync: {
        get: () => super.toggleContentAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      if (target.parentElement) {
        if (target.parentElement.className.startsWith("react-datepicker")) {
          return;
        }
      }
      yield _super.toggleContentAsync.call(this);
    });
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this.state.icon = {
        name: "far calendar-day"
      };
      yield _super.initializeAsync.call(this);
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentWillReceiveProps.call(this, nextProps);
      yield this.setState({
        icon: {
          name: "far calendar-day"
        }
      });
    });
  }
  renderDate(date) {
    if (ch.debug) {
      console.log("DateInputWidget on renderDate():");
      console.log(this);
      console.log("---------------------:");
      console.log("date on renderDate():");
      console.log(date);
      console.log("---------------------:");
    }
    return /*#__PURE__*/React.createElement("span", {
      className: widgetStyles.date
    }, this.props.showTime ? this.props.showOnlyTime ? Utility.toShortTimeString(date) : `${Utility.toDateString(date)} ${Utility.toShortTimeString(date)}` : Utility.toDateString(date));
  }
  renderExpanded() {
    if (ch.debug) {
      console.log("DateInputWidget on renderExpanded():");
      console.log(this);
      console.log("---------------------:");
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "dateInputContainer"
    }, /*#__PURE__*/React.createElement(DatePickerLibrary__default, {
      inline: true,
      selected: this.props.value || new Date(),
      minDate: this.props.minDate,
      maxDate: this.props.maxDate,
      minTime: this.props.minTime,
      maxTime: this.props.maxTime,
      onChange: date => this.handleChangeAsync(date),
      className: "form-control",
      calendarClassName: "datepicker dateInputWidget",
      todayButton: this.props.todayButton,
      locale: DateInputWidgetLocalizer$1.language,
      showTimeSelect: this.props.showTime,
      showTimeSelectOnly: this.props.showOnlyTime,
      timeCaption: this.props.timeCaption,
      timeIntervals: this.props.timeIntervalMinutes,
      timeFormat: "HH:mm"
    }));
  }
  renderContent(renderHidden = false) {
    if (ch.debug) {
      console.log("DateInputWidget on renderContent():");
      console.log(this);
      console.log("---------------------:");
    }
    return this.contentVisible ? ( /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.expandableContent
    }, this.renderExpanded())) : this.props.value ? this.renderDate(this.props.value) : this.renderContent();
  }
}

class LinkWidget extends BaseWidget {
  getHref() {
    return this.props.url;
  }
  getTarget() {
    var _a;
    return (_a = this.props.target) !== null && _a !== void 0 ? _a : LinkTarget.Blank;
  }
}

var css_248z$u = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-navigation-widget-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-navigation-widget-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-navigation-widget-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-navigation-widget-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-navigation-widget-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-navigation-widget-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-navigation-widget-navigation .athenaeum-navigation-widget-widget.athenaeum-navigation-widget-middle {\n  text-align: center;\n}\n.athenaeum-navigation-widget-navigation .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content.athenaeum-navigation-widget-disabled i {\n  opacity: 0.5;\n}\n.athenaeum-navigation-widget-navigation .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content .athenaeum-navigation-widget-compactContainer {\n  padding: 0 !important;\n}\n.athenaeum-navigation-widget-navigation .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content .athenaeum-navigation-widget-compactContainer.athenaeum-navigation-widget-left i {\n  padding-right: 10px;\n}\n.athenaeum-navigation-widget-navigation .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content .athenaeum-navigation-widget-compactContainer.athenaeum-navigation-widget-middle i {\n  padding-right: 10px;\n}\n.athenaeum-navigation-widget-navigation .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content .athenaeum-navigation-widget-compactContainer.athenaeum-navigation-widget-right i {\n  padding-left: 10px;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle > div {\n  margin: 0;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle > div div:first-child {\n  text-align: left;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle > div div:last-child {\n  text-align: right;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content {\n  background-color: transparent;\n  box-shadow: none;\n  padding: 0;\n  display: inline-block;\n  width: auto;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content .athenaeum-navigation-widget-compactContainer {\n  display: inline !important;\n  color: rgb(254, 80, 0);\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content .athenaeum-navigation-widget-compactContainer i {\n  padding: 1px;\n  border-radius: 50%;\n  background-color: white;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content .athenaeum-navigation-widget-compactContainer.athenaeum-navigation-widget-left {\n  display: inline-block !important;\n  text-align: left;\n}\n.athenaeum-navigation-widget-navigation.athenaeum-navigation-widget-mobileStyle .athenaeum-navigation-widget-widget .athenaeum-navigation-widget-content .athenaeum-navigation-widget-compactContainer.athenaeum-navigation-widget-right {\n  display: inline-block !important;\n  text-align: right;\n}";
var styles$s = {"font-renta":"athenaeum-navigation-widget-font-renta","color-schema-renta_black":"athenaeum-navigation-widget-color-schema-renta_black","color-schema-renta_white":"athenaeum-navigation-widget-color-schema-renta_white","color-schema-renta_orange":"athenaeum-navigation-widget-color-schema-renta_orange","color-schema-renta_green":"athenaeum-navigation-widget-color-schema-renta_green","color-schema-renta_blue":"athenaeum-navigation-widget-color-schema-renta_blue","navigation":"athenaeum-navigation-widget-navigation","widget":"athenaeum-navigation-widget-widget","middle":"athenaeum-navigation-widget-middle","content":"athenaeum-navigation-widget-content","disabled":"athenaeum-navigation-widget-disabled","compactContainer":"athenaeum-navigation-widget-compactContainer","left":"athenaeum-navigation-widget-left","right":"athenaeum-navigation-widget-right","mobileStyle":"athenaeum-navigation-widget-mobileStyle"};
styleInject(css_248z$u);

//Autogenerated
class NavigationWidgetLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.previousLanguageItemName = `Previous`;
    this.returnToPreviousLanguageItemName = `ReturnToPrevious`;
    this.nextLanguageItemName = `Next`;
    this.goToNextLanguageItemName = `GoToNext`;
    //Initializer
    this.set(this.previousLanguageItemName, {
      language: `en`,
      value: `Previous`
    }, {
      language: `uk`,
      value: `Назад`
    }, {
      language: `sv`,
      value: `Föregående`
    }, {
      language: `ru`,
      value: `Предыдущий`
    }, {
      language: `pl`,
      value: `Poprzedni`
    }, {
      language: `nb`,
      value: `Forrige`
    }, {
      language: `fi`,
      value: `Edellinen`
    }, {
      language: `da`,
      value: `Forrige`
    });
    this.set(this.returnToPreviousLanguageItemName, {
      language: `en`,
      value: `Return to previous step`
    }, {
      language: `uk`,
      value: `Повернутися до попереднього кроку`
    }, {
      language: `sv`,
      value: `Återgå till föregående steg`
    }, {
      language: `ru`,
      value: `Вернуться на предыдущий шаг`
    }, {
      language: `pl`,
      value: `Powrót do poprzedniego kroku`
    }, {
      language: `nb`,
      value: `Gå tilbake til forrige trinn`
    }, {
      language: `fi`,
      value: `Palaa edelliseen vaiheeseen`
    }, {
      language: `da`,
      value: `Vend tilbage til forrige trin`
    });
    this.set(this.nextLanguageItemName, {
      language: `en`,
      value: `Next`
    }, {
      language: `uk`,
      value: `Далі`
    }, {
      language: `sv`,
      value: `Nästa`
    }, {
      language: `ru`,
      value: `Далее`
    }, {
      language: `pl`,
      value: `Następny`
    }, {
      language: `nb`,
      value: `Neste`
    }, {
      language: `fi`,
      value: `Seuraava`
    }, {
      language: `da`,
      value: `Næste`
    });
    this.set(this.goToNextLanguageItemName, {
      language: `en`,
      value: `Go to next step`
    }, {
      language: `uk`,
      value: `Перейти до наступного кроку`
    }, {
      language: `sv`,
      value: `Gå till nästa steg`
    }, {
      language: `ru`,
      value: `Перейти к следующему шагу`
    }, {
      language: `pl`,
      value: `Następny krok`
    }, {
      language: `nb`,
      value: `Gå til neste trinn`
    }, {
      language: `fi`,
      value: `Siirry seuraavaan vaiheeseen`
    }, {
      language: `da`,
      value: `Gå til næste trin`
    });
  }
  /**
  /* "Previous" (Previous)
  */
  get previous() {
    return this.get(this.previousLanguageItemName);
  }
  /**
  /* "ReturnToPrevious" (Return to previous step)
  */
  get returnToPrevious() {
    return this.get(this.returnToPreviousLanguageItemName);
  }
  /**
  /* "Next" (Next)
  */
  get next() {
    return this.get(this.nextLanguageItemName);
  }
  /**
  /* "GoToNext" (Go to next step)
  */
  get goToNext() {
    return this.get(this.goToNextLanguageItemName);
  }
}
//Singleton
var NavigationWidgetLocalizer$1 = new NavigationWidgetLocalizer();

class NavigationWidget extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      transparent: this.props.transparent || false
    };
  }
  onPrevClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted && this.canPrev) {
        e.stopPropagation();
        if (this.props.onPrevClick) {
          yield this.props.onPrevClick();
        } else if (this.props.prevRoute) {
          yield ch.swipeRightAsync();
          yield PageRouteProvider.redirectAsync(this.props.prevRoute);
        } else {
          yield ch.swipeRightAsync();
          yield PageRouteProvider.back();
        }
      }
    });
  }
  onMiddleClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted && this.canMiddle) {
        e.stopPropagation();
        if (this.props.onMiddleClick) {
          yield this.props.onMiddleClick();
        }
      }
    });
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted && this.canNext) {
        e.stopPropagation();
        if (this.props.onClick) {
          yield this.props.onClick();
        } else if (this.props.route) {
          yield ch.swipeLeftAsync();
          yield PageRouteProvider.redirectAsync(this.props.route);
        }
      }
    });
  }
  get canPrev() {
    return this.props.canPrev !== false;
  }
  get canMiddle() {
    return this.props.canMiddle !== false;
  }
  get canNext() {
    return this.props.can !== false;
  }
  get prevIcon() {
    return this.mobileStyle ? this.props.prevIcon || {
      name: "chevron-circle-left",
      style: IconStyle.Solid,
      size: IconSize.X3
    } : this.props.prevIcon || {
      name: "arrow-alt-circle-left",
      style: IconStyle.Regular,
      size: IconSize.X2
    };
  }
  get middleIcon() {
    return this.mobileStyle ? this.props.middleIcon || {
      name: "chevron-circle-down",
      style: IconStyle.Solid,
      size: IconSize.X3
    } : this.props.middleIcon || {
      name: "arrow-alt-circle-down",
      style: IconStyle.Regular,
      size: IconSize.X2
    };
  }
  get nextIcon() {
    return this.mobileStyle ? this.props.prevIcon || {
      name: "chevron-circle-right",
      style: IconStyle.Solid,
      size: IconSize.X3
    } : this.props.prevIcon || {
      name: "arrow-alt-circle-right",
      style: IconStyle.Regular,
      size: IconSize.X2
    };
  }
  get prevLabel() {
    return this.props.prevLabel || NavigationWidgetLocalizer$1.previous;
  }
  get middleLabel() {
    return this.props.middleLabel || "";
  }
  get prevDescription() {
    return this.props.prevDescription || NavigationWidgetLocalizer$1.returnToPrevious;
  }
  get middleDescription() {
    return this.props.middleDescription || "";
  }
  get label() {
    return this.props.label || NavigationWidgetLocalizer$1.next;
  }
  get description() {
    return this.props.description || NavigationWidgetLocalizer$1.goToNext;
  }
  get hidePrev() {
    return this.props.hidePrev != null && this.props.hidePrev;
  }
  get hideMiddle() {
    return this.props.showMiddle == null || !this.props.showMiddle;
  }
  get hideNext() {
    return this.props.hideNext != null && this.props.hideNext;
  }
  get wide() {
    return true;
  }
  get mobileStyle() {
    return this.responsive && this.mobile;
  }
  get desktopStyle() {
    return !this.mobileStyle;
  }
  minimizeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      // do nothing
    });
  }
  maximizeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      // do nothing
    });
  }
  get minimized() {
    return false;
  }
  get responsive() {
    return this.props.responsive == true;
  }
  isWidget() {
    return true;
  }
  get transparent() {
    return this.state.transparent;
  }
  get displayContent() {
    return !this.hideNext || !this.hidePrev || !this.hideMiddle;
  }
  get columnClass() {
    let buttonCount = 0;
    if (!this.hidePrev) {
      buttonCount++;
    }
    if (!this.hideMiddle) {
      buttonCount++;
    }
    if (!this.hideNext) {
      buttonCount++;
    }
    switch (buttonCount) {
      case 1:
        return "col-12";
      case 2:
        return "col-6";
      case 3:
        return "col-4";
      default:
        return "col-4";
    }
  }
  render() {
    const mobileStyle = this.mobileStyle && styles$s.mobileStyle;
    const disabledPrevStyle = !this.canPrev && styles$s.disabled;
    const disabledMiddleStyle = !this.canMiddle && styles$s.disabled;
    const disabledNextStyle = !this.canNext && styles$s.disabled;
    if (!this.displayContent) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(this.props.className, styles$s.navigation, mobileStyle, "col-md-12")
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, !this.hidePrev && ( /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(styles$s.widget, widgetStyles.widget, this.props.className, this.columnClass)
    }, /*#__PURE__*/React.createElement("div", {
      title: this.toSingleLine(this.prevDescription || this.props.label),
      className: this.css(styles$s.content, widgetStyles.compact, this.transparent && widgetStyles.transparent, widgetStyles.content, disabledPrevStyle, "float-left"),
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onPrevClickAsync(e);
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.compactContainer, styles$s.compactContainer, styles$s.left)
    }, /*#__PURE__*/React.createElement(Icon, Object.assign({}, this.prevIcon)), this.desktopStyle && ( /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.labelAndDescription
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, this.prevLabel)), /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.description
    }, /*#__PURE__*/React.createElement("span", null, this.toSingleLine(this.prevDescription))))))))), !this.hideMiddle && ( /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(styles$s.widget, widgetStyles.widget, this.props.className, this.columnClass, styles$s.middle)
    }, /*#__PURE__*/React.createElement("div", {
      title: this.toSingleLine(this.middleDescription || this.props.label),
      className: this.css(styles$s.content, widgetStyles.compact, this.transparent && widgetStyles.transparent, widgetStyles.content, disabledMiddleStyle),
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onMiddleClickAsync(e);
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.compactContainer, styles$s.compactContainer, styles$s.middle)
    }, /*#__PURE__*/React.createElement(Icon, Object.assign({}, this.middleIcon)), this.desktopStyle && ( /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.labelAndDescription
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, this.middleLabel)), /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.description
    }, /*#__PURE__*/React.createElement("span", null, this.toSingleLine(this.middleDescription))))))))), !this.hideNext && ( /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(styles$s.widget, widgetStyles.widget, this.props.className, this.columnClass)
    }, /*#__PURE__*/React.createElement("div", {
      title: this.toSingleLine(this.description || this.props.label),
      className: this.css(styles$s.content, widgetStyles.compact, this.transparent && widgetStyles.transparent, widgetStyles.content, disabledNextStyle, "float-right"),
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onClickAsync(e);
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.compactContainer, styles$s.compactContainer, styles$s.right)
    }, this.desktopStyle && ( /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.labelAndDescription
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, this.label)), /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.description
    }, /*#__PURE__*/React.createElement("span", null, this.toSingleLine(this.description))))), /*#__PURE__*/React.createElement(Icon, Object.assign({}, this.nextIcon))))))));
  }
}

var classof = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$1 = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};

var $ = _export;
var uncurryThis = functionUncurryThis;
var isArray = isArray$1;

var nativeReverse = uncurryThis([].reverse);
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse(this);
  }
});

class NumberWidget extends BaseWidget {
  constructor() {
    super(...arguments);
    this._inputRef = /*#__PURE__*/React.createRef();
    this._acceptableStr = null;
  }
  onInputChangeHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const str = e.currentTarget.value;
      const parsingResult = NumberUtility.parse(str, this.allowFloat);
      const acceptableStr = parsingResult.acceptableStr !== null ? parsingResult.acceptableStr : this._acceptableStr;
      const needToRender = acceptableStr !== this._acceptableStr;
      this._acceptableStr = acceptableStr;
      if (needToRender) {
        yield this.reRenderAsync();
      }
    });
  }
  onInputKeyUpHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const enter = e.keyCode === 13;
      const esc = e.keyCode === 27;
      if (enter || esc) {
        yield this.stopEditAsync(enter);
      }
    });
  }
  onWheelHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const step = e.deltaY < 0 ? this.step : -this.step;
      yield this.setAsync(this.value + step);
    });
  }
  saveChangesAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._acceptableStr != null) {
        const parsingResult = NumberUtility.parse(this._acceptableStr, this.allowFloat);
        this._acceptableStr = null;
        if (parsingResult.parsed) {
          yield this.setAsync(parsingResult.value);
        }
      }
    });
  }
  getStr() {
    return this._acceptableStr != null ? this._acceptableStr : this.state.number != null ? this.state.number.toString() : "";
  }
  getInnerClassName() {
    if (this.readonly) {
      return widgetStyles.readonly;
    }
    return super.getInnerClassName();
  }
  setAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      value = Utility.roundE(value);
      if (value !== this.value && this.canSet(value)) {
        if (this.props.onChange) {
          yield this.props.onChange(this, value);
        }
        yield this.setState({
          number: value
        });
        return true;
      }
      return false;
    });
  }
  increaseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      let nextValue = this.value + this.step;
      if (nextValue > this.max) {
        nextValue = this.max;
      }
      yield this.setAsync(nextValue);
    });
  }
  decreaseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      let nextValue = this.value - this.step;
      if (nextValue < this.min) {
        nextValue = this.min;
      }
      yield this.setAsync(nextValue);
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this._acceptableStr = null;
      if (nextProps.value !== this.props.value) {
        this.state.number = nextProps.value != null ? nextProps.value : this.min;
      }
      yield _super.componentWillReceiveProps.call(this, nextProps);
    });
  }
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this._acceptableStr = null;
      const state = this.state;
      state.number = this.props.value || this.min;
      state.data = {
        edit: false
      };
    });
  }
  get edit() {
    return !this.readonly && this.props.strict !== true && this.state.data != null && this.state.data.edit;
  }
  setEditAsync(edit) {
    return __awaiter(this, void 0, void 0, function* () {
      edit = edit && !this.readonly;
      if (this.edit !== edit) {
        this._acceptableStr = null;
        const data = {
          edit: edit
        };
        yield this.setState({
          data
        });
        if (edit && this._inputRef.current != null) {
          this._inputRef.current.focus();
        }
      }
    });
  }
  startEditAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setEditAsync(true);
    });
  }
  stopEditAsync(save = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (save) {
        yield this.saveChangesAsync();
      }
      this._acceptableStr = null;
      yield this.setEditAsync(false);
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      const outsideInput = Utility.clickedOutside(target, this.inputId);
      if (outsideInput) {
        yield this.stopEditAsync();
      }
      if (this.canMinimize) {
        const outsideWidget = Utility.clickedOutside(target, this.id);
        if (outsideWidget && !this.minimized) {
          yield this.minimizeAsync();
        }
      }
    });
  }
  get reverse() {
    return !!this.props.reverse;
  }
  get readonly() {
    return !!this.props.readonly;
  }
  get value() {
    return this.state.number || 0;
  }
  get min() {
    return this.props.min || 0;
  }
  get max() {
    return this.props.max || Number.POSITIVE_INFINITY;
  }
  get step() {
    const numberFormat = NumberUtility.resolveFormat(this.props.step, this.props.format);
    return numberFormat.step;
  }
  get canDecrease() {
    return this.value > this.min;
  }
  get canIncrease() {
    return this.value < this.max;
  }
  canSet(value) {
    value = Utility.roundE(value);
    return !this.readonly && this.min <= value && value <= this.max;
  }
  isWidget() {
    return true;
  }
  hasSpinner() {
    return true;
  }
  getIconName(iconPosition) {
    if (this.reverse) {
      return iconPosition == 1 ? "plus-circle" : "minus-circle";
    } else {
      return iconPosition == 1 ? "minus-circle" : "plus-circle";
    }
  }
  getIconStyle(iconPosition) {
    if (this.reverse) {
      return iconPosition == 1 ? this.css(!this.canIncrease && widgetStyles.disabled) : this.css(!this.canDecrease && widgetStyles.disabled);
    } else {
      return iconPosition == 1 ? this.css(!this.canDecrease && widgetStyles.disabled) : this.css(!this.canIncrease && widgetStyles.disabled);
    }
  }
  getIconOnClick(iconPosition) {
    if (this.reverse) {
      return iconPosition == 1 ? () => __awaiter(this, void 0, void 0, function* () {
        return yield this.increaseAsync();
      }) : () => __awaiter(this, void 0, void 0, function* () {
        return yield this.decreaseAsync();
      });
    } else {
      return iconPosition == 1 ? () => __awaiter(this, void 0, void 0, function* () {
        return yield this.decreaseAsync();
      }) : () => __awaiter(this, void 0, void 0, function* () {
        return yield this.increaseAsync();
      });
    }
  }
  get inputId() {
    return `input${this.id}`;
  }
  get numberFormat() {
    const numberFormat = NumberUtility.resolveFormat(this.props.step, this.props.format);
    return numberFormat.format;
  }
  get allowFloat() {
    return this.step < 1.0;
  }
  get canMinimize() {
    return !!this.props.canMinimize;
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.canMinimize) {
        if (this.minimized) {
          yield this.maximizeAsync();
        } else {
          const target = e.target;
          const outsideWidgetBody = Utility.clickedOutside(target, `number-widget-body_${this.id}`);
          if (outsideWidgetBody) {
            yield this.toggleMinimized();
          }
        }
      }
    });
  }
  renderContent(renderHidden = false) {
    return /*#__PURE__*/React.createElement("div", {
      id: `number-widget-body_${this.id}`,
      className: this.css(widgetStyles.numberWidget, this.edit && widgetStyles.edit, this.readonly && widgetStyles.readonly)
    }, /*#__PURE__*/React.createElement("div", {
      onClick: this.getIconOnClick(1),
      className: this.getIconStyle(1)
    }, /*#__PURE__*/React.createElement(Icon, {
      name: this.getIconName(1),
      size: IconSize.X2,
      style: IconStyle.Regular
    })), this.edit ? ( /*#__PURE__*/React.createElement("input", {
      id: this.inputId,
      ref: this._inputRef,
      type: "text",
      className: "form-control",
      readOnly: this.readonly,
      value: this.getStr(),
      onChange: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onInputChangeHandlerAsync(e);
      }),
      onKeyUp: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onInputKeyUpHandlerAsync(e);
      }),
      onWheel: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onWheelHandlerAsync(e);
      })
    })) : ( /*#__PURE__*/React.createElement("div", {
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.startEditAsync();
      })
    }, super.renderContent(renderHidden))), /*#__PURE__*/React.createElement("div", {
      onClick: this.getIconOnClick(2),
      className: this.getIconStyle(2)
    }, /*#__PURE__*/React.createElement(Icon, {
      name: this.getIconName(2),
      size: IconSize.X2,
      style: IconStyle.Regular
    })));
  }
}

//Autogenerated
class QrWidgetLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.scanErrorLanguageItemName = `Scan.Error`;
    //Initializer
    this.set(this.scanErrorLanguageItemName, {
      language: `en`,
      value: `QR code scanner is not available, probably no permissions to camera on your mobile device.`
    }, {
      language: `uk`,
      value: `Сканер QR-коду недоступний, можливо, на вашому мобільному пристрої не отримано дозволу на використання камери.`
    }, {
      language: `sv`,
      value: `QR-kodskanner inte tillgänglig, förmodligen inga behörigheter för kameran på din mobila enhet.`
    }, {
      language: `ru`,
      value: `Сканер QR-кода недоступен, возможно, на вашем мобильном устройстве не получено разрешение на использование камеры.`
    }, {
      language: `pl`,
      value: `Skaner kodów QR niedostępny, prawdopodobnie brak uprawnień do kamery na Twoim urządzeniu mobilnym.`
    }, {
      language: `nb`,
      value: `QR-kodeskanner er ikke tilgjengelig, det er sannsynligvis ingen tillatelser til bruk av kamera på mobilenheten din.`
    }, {
      language: `fi`,
      value: `QR koodi skanneri ei käytössä. Mahdollisesti kameran käyttöoikeudet puuttuvat laitteeltasi.`
    }, {
      language: `da`,
      value: `QR-kodescanner er ikke tilgængelig, sandsynligvis ingen tilladelser til kameraet på din mobile enhed.`
    });
  }
  /**
  /* "Scan.Error" (QR code scanner is not available, probably no permissions to camera on your mobile device.)
  */
  get scanError() {
    return this.get(this.scanErrorLanguageItemName);
  }
}
//Singleton
var QrWidgetLocalizer$1 = new QrWidgetLocalizer();

class QrWidget extends BaseExpandableWidget {
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.initializeAsync.call(this);
      this.setState({
        icon: {
          name: "far camera"
        }
      });
    });
  }
  onScanAsync(code) {
    const _super = Object.create(null, {
      hideContentAsync: {
        get: () => super.hideContentAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (code) {
        if (this.props.onQr) {
          yield this.props.onQr(code);
        }
        yield _super.hideContentAsync.call(this);
      }
    });
  }
  onScanErrorAsync() {
    const _super = Object.create(null, {
      hideContentAsync: {
        get: () => super.hideContentAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield ch.alertErrorAsync(QrWidgetLocalizer$1.scanError, true);
      yield _super.hideContentAsync.call(this);
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentWillReceiveProps.call(this, nextProps);
      yield this.setState({
        icon: {
          name: "far camera"
        }
      });
    });
  }
  renderExpanded() {
    return /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.qr
    }, /*#__PURE__*/React.createElement(QrScanner, {
      onDecode: result => __awaiter(this, void 0, void 0, function* () {
        return yield this.onScanAsync(result);
      }),
      onError: error => __awaiter(this, void 0, void 0, function* () {
        return yield this.onScanErrorAsync();
      })
    }));
  }
}

class RouteWidget extends BaseRouteWidget {
  onNavigateAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onClick) {
        yield this.props.onClick();
      }
    });
  }
}

//Autogenerated
class SignatureWidgetLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.clearLanguageItemName = `Clear`;
    this.doneLanguageItemName = `Done`;
    //Initializer
    this.set(this.clearLanguageItemName, {
      language: `en`,
      value: `Clear`
    }, {
      language: `uk`,
      value: `Очистити`
    }, {
      language: `sv`,
      value: `Töm`
    }, {
      language: `ru`,
      value: `Очистить`
    }, {
      language: `pl`,
      value: `Wyczyść`
    }, {
      language: `nb`,
      value: `Tøm`
    }, {
      language: `fi`,
      value: `Tyhjennä`
    }, {
      language: `da`,
      value: `Klar`
    });
    this.set(this.doneLanguageItemName, {
      language: `en`,
      value: `Done`
    }, {
      language: `uk`,
      value: `Завершити`
    }, {
      language: `sv`,
      value: `Färdig`
    }, {
      language: `ru`,
      value: `Завершить`
    }, {
      language: `pl`,
      value: `Gotowe`
    }, {
      language: `nb`,
      value: `Ferdig`
    }, {
      language: `fi`,
      value: `Valmis`
    }, {
      language: `da`,
      value: `Udført`
    });
  }
  /**
  /* "Clear" (Clear)
  */
  get clear() {
    return this.get(this.clearLanguageItemName);
  }
  /**
  /* "Done" (Done)
  */
  get done() {
    return this.get(this.doneLanguageItemName);
  }
}
//Singleton
var SignatureWidgetLocalizer$1 = new SignatureWidgetLocalizer();

class SignatureWidget extends BaseExpandableWidget {
  constructor() {
    super(...arguments);
    this._canvasRef = /*#__PURE__*/React.createRef();
    this._emptyCanvasValue = null;
    this.state = Object.assign(Object.assign({}, this.state), {
      signatureDataBucket: this.props.initialSignatureData || null
    });
  }
  initializeCanvas() {
    var _a;
    const signatureCanvas = this._canvasRef.current;
    if (signatureCanvas) {
      const canvas = signatureCanvas.getCanvas();
      const ctx = canvas.getContext("2d");
      const width = canvas.scrollWidth;
      const height = canvas.scrollHeight;
      const bottom = height - 0.20 * height;
      ctx.beginPath();
      ctx.moveTo(10, bottom);
      ctx.lineTo(width - 11, bottom);
      ctx.strokeStyle = "white";
      ctx.stroke();
      this._emptyCanvasValue = (_a = this._emptyCanvasValue) !== null && _a !== void 0 ? _a : signatureCanvas.toDataURL();
      if (this.state.signatureDataBucket) {
        signatureCanvas.fromDataURL(this.state.signatureDataBucket);
      }
    }
  }
  clearCanvas() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._canvasRef.current) {
        this._canvasRef.current.clear();
        yield this.setSignatureDataBucket(null);
        this.initializeCanvas();
      }
    });
  }
  saveSignature() {
    const _super = Object.create(null, {
      hideContentAsync: {
        get: () => super.hideContentAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (this._canvasRef.current) {
        const canvasData = this.canvasData;
        if (this.props.preserveSignature) {
          yield this.setSignatureDataBucket(canvasData);
        }
        if (this.props.onSign) {
          yield this.props.onSign(canvasData);
        }
      }
      yield _super.hideContentAsync.call(this);
    });
  }
  onClickAsync(e) {
    const _super = Object.create(null, {
      toggleContentAsync: {
        get: () => super.toggleContentAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      if (target.parentElement !== null) {
        if (target.parentElement.className === widgetStyles.signature && target.className !== widgetStyles.icon || target.parentElement.className === widgetStyles.buttonContainer) {
          return;
        }
      }
      yield _super.toggleContentAsync.call(this);
      if (this.contentVisible) {
        this.initializeCanvas();
      }
    });
  }
  onMouseDownAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.preventDefault();
    });
  }
  preventSwipe(e) {
    e.stopPropagation();
  }
  setSignatureDataBucket(value) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        signatureDataBucket: value
      });
    });
  }
  get canvasData() {
    const canvas = this._canvasRef.current || null;
    if (canvas) {
      const canvasData = canvas.toDataURL();
      if (canvasData !== this._emptyCanvasValue) {
        return canvasData;
      }
    }
    return null;
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.initializeAsync.call(this);
      yield this.setState({
        icon: {
          name: "far file-contract"
        }
      });
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentWillReceiveProps.call(this, nextProps);
      yield this.setState({
        icon: {
          name: "far file-contract"
        }
      });
    });
  }
  renderExpanded() {
    return /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.signature,
      onTouchStart: e => this.preventSwipe(e)
    }, /*#__PURE__*/React.createElement(SignatureCanvas, {
      penColor: '#007bff',
      canvasProps: {
        className: widgetStyles.signaturePad
      },
      ref: this._canvasRef
    }), /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      type: ButtonType.Orange,
      onClick: () => this.clearCanvas(),
      label: SignatureWidgetLocalizer$1.clear
    }), /*#__PURE__*/React.createElement(Button, {
      type: ButtonType.Blue,
      onClick: () => this.saveSignature(),
      label: SignatureWidgetLocalizer$1.done
    })));
  }
}

var css_248z$t = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-steps-widget-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-steps-widget-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-steps-widget-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-steps-widget-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-steps-widget-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-steps-widget-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-content {\n  cursor: default !important;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-content:hover {\n  background-color: rgb(254, 80, 0) !important;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 12px;\n}\n@media screen and (max-width: 768px) {\n  .athenaeum-steps-widget-steps .athenaeum-steps-widget-container {\n    margin-top: 0;\n  }\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-iconContainer {\n  display: flex;\n  position: relative;\n  color: white;\n  opacity: 0.5;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-iconContainer .athenaeum-steps-widget-icon {\n  font-size: 1.5em;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-iconContainer .athenaeum-steps-widget-number {\n  font-size: 0.8em;\n  position: absolute;\n  padding-bottom: 1px;\n  width: 100%;\n  display: inline;\n  align-self: center;\n  text-align: center;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-iconContainer.athenaeum-steps-widget-completed {\n  opacity: 1;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-separator {\n  height: 2px;\n  flex-grow: 1;\n  background-color: white;\n  opacity: 0.5;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-separator.athenaeum-steps-widget-completed {\n  opacity: 1;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-title {\n  position: absolute;\n  font-size: 11px;\n  width: 80px;\n  left: -28px;\n  top: -21px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-title.athenaeum-steps-widget-first {\n  left: -3px;\n  text-align: left;\n}\n.athenaeum-steps-widget-steps .athenaeum-steps-widget-container .athenaeum-steps-widget-title.athenaeum-steps-widget-last {\n  left: -58px;\n  text-align: right;\n}";
var styles$r = {"font-renta":"athenaeum-steps-widget-font-renta","color-schema-renta_black":"athenaeum-steps-widget-color-schema-renta_black","color-schema-renta_white":"athenaeum-steps-widget-color-schema-renta_white","color-schema-renta_orange":"athenaeum-steps-widget-color-schema-renta_orange","color-schema-renta_green":"athenaeum-steps-widget-color-schema-renta_green","color-schema-renta_blue":"athenaeum-steps-widget-color-schema-renta_blue","steps":"athenaeum-steps-widget-steps","content":"athenaeum-steps-widget-content","container":"athenaeum-steps-widget-container","iconContainer":"athenaeum-steps-widget-iconContainer","icon":"athenaeum-steps-widget-icon","number":"athenaeum-steps-widget-number","completed":"athenaeum-steps-widget-completed","separator":"athenaeum-steps-widget-separator","title":"athenaeum-steps-widget-title","first":"athenaeum-steps-widget-first","last":"athenaeum-steps-widget-last"};
styleInject(css_248z$t);

class Step extends BaseComponent {
  render() {
    const firstStyle = this.props.first && this.desktop && styles$r.first;
    const lastStyle = this.props.last && this.desktop && styles$r.last;
    return /*#__PURE__*/React.createElement("div", {
      id: `tooltip_${this.id}`,
      className: this.css(styles$r.iconContainer, this.props.completed && styles$r.completed),
      title: this.props.title || "",
      "data-toggle": this.mobile ? "tooltip" : ""
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "far circle",
      className: styles$r.icon
    }), /*#__PURE__*/React.createElement("span", {
      className: styles$r.number
    }, this.props.index), !this.mobile && /*#__PURE__*/React.createElement("span", {
      className: this.css(styles$r.title, firstStyle, lastStyle)
    }, this.props.title));
  }
}

class StepsWidget extends BaseWidget {
  getCurrentIndex() {
    const page = this.getPage();
    const route = page.route;
    return this.props.steps.findIndex(step => Comparator.isEqual(step.route, route));
  }
  get steps() {
    return this.props.steps.filter(step => !step.hidden);
  }
  componentDidUpdate() {
    ch.getLayout().reinitializeTooltips();
  }
  render() {
    const currentIndex = this.getCurrentIndex();
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(widgetStyles.widget, this.props.className, "col-md-12", styles$r.steps)
    }, /*#__PURE__*/React.createElement("div", {
      title: this.toSingleLine(this.description || this.props.label),
      className: this.css(widgetStyles.compact, this.transparent && widgetStyles.transparent, widgetStyles.content, styles$r.content)
    }, /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.compactContainer, styles$r.container)
    }, this.steps.map((step, stepIndex) => ( /*#__PURE__*/React.createElement(React.Fragment, {
      key: step.title
    }, stepIndex > 0 && /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$r.separator, stepIndex <= currentIndex && styles$r.completed)
    }), /*#__PURE__*/React.createElement(Step, {
      index: stepIndex + 1,
      title: step.title,
      completed: stepIndex <= currentIndex,
      first: stepIndex === 0,
      last: stepIndex === this.steps.length - 1
    })))))));
  }
}

class SwitchWidget extends BaseCheckboxWidget {
  onChangeAsync(checked) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.props.onChange) {
        yield this.props.onChange(this, checked);
      }
    });
  }
  renderContent(renderHidden = false) {
    const toggleStyles = this.checked ? widgetStyles.checked : widgetStyles.switch;
    const toggleExternalStyles = this.checked ? this.props.checkedClassName : "";
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.switchContent, toggleExternalStyles)
    }, /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.status
    }, /*#__PURE__*/React.createElement("span", null, this.props.leftLabel)), /*#__PURE__*/React.createElement("div", {
      className: toggleStyles
    }, /*#__PURE__*/React.createElement("span", {
      className: widgetStyles.toggler
    })), /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.status
    }, /*#__PURE__*/React.createElement("span", null, this.props.rightLabel)));
  }
}

class BaseInputWidget extends BaseWidget {
  constructor() {
    super(...arguments);
    this.refObject = {
      _inputRef: /*#__PURE__*/React.createRef()
    };
  }
  onInputChangeHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const value = e.currentTarget.value;
      const caretPosition = Number(e.currentTarget.selectionEnd);
      yield this.setAsync(value);
      const input = this.refObject._inputRef.current;
      if (input) {
        const prefix = value.substr(0, caretPosition);
        const index = value.indexOf(prefix) + caretPosition;
        input.selectionStart = index;
        input.selectionEnd = index;
      }
    });
  }
  onInputKeyUpHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      // Enter or Escape
      if (e.keyCode === 13 || e.keyCode === 27) {
        yield this.setInputVisibleAsync(false);
      }
    });
  }
  setAsync(value) {
    return __awaiter(this, void 0, void 0, function* () {
      if (value !== this.value) {
        if (this.props.onChange) {
          yield this.props.onChange(this, value);
        }
        yield this.setState({
          text: value
        });
      }
    });
  }
  setInputVisibleAsync(visible) {
    return __awaiter(this, void 0, void 0, function* () {
      if (visible !== this.inputVisible) {
        const data = {
          visible: visible
        };
        yield this.setState({
          data
        });
        if (this.inputVisible && this.refObject._inputRef.current != null) {
          this.refObject._inputRef.current.focus();
        }
      }
    });
  }
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const value = this.props.value;
      const state = this.state;
      state.text = value || "";
      state.data = {
        visible: false
      };
    });
  }
  get value() {
    return this.state.text || "";
  }
  isWidget() {
    return true;
  }
  hasSpinner() {
    return true;
  }
  get inputId() {
    return `input${this.id}`;
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      if (target.parentElement !== null) {
        if (target.parentElement.className === widgetStyles.inputContainer) {
          if (this.refObject._inputRef.current) {
            this.refObject._inputRef.current.focus();
          }
          return;
        }
      }
      yield this.toggleInputAsync();
    });
  }
  toggleInputAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setInputVisibleAsync(!this.inputVisible);
    });
  }
  showInputAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setInputVisibleAsync(true);
    });
  }
  hideInputAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setInputVisibleAsync(false);
    });
  }
  get inputVisible() {
    return this.state.data != null && this.state.data.visible;
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      const outside = Utility.clickedOutside(target, this.id);
      if (outside) {
        yield this.hideInputAsync();
      }
    });
  }
  get icon() {
    const icon = {
      name: "keyboard",
      style: IconStyle.Regular
    };
    icon.size = this.state.minimized ? IconSize.X2 : IconSize.X3;
    return icon;
  }
}

class TextAreaWidget extends BaseInputWidget {
  constructor() {
    super(...arguments);
    this.refObject = {
      _inputRef: /*#__PURE__*/React.createRef()
    };
  }
  get readonly() {
    return this.props.readonly === true;
  }
  onInputKeyUpHandlerAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      // Enter or Escape
      if (!this.props.keepFocusOnEnter && e.keyCode === 13 || e.keyCode === 27) {
        yield this.setInputVisibleAsync(false);
      }
    });
  }
  getInnerClassName() {
    if (this.readonly) {
      return widgetStyles.readonly;
    }
    return super.getInnerClassName();
  }
  renderContent(renderHidden = false) {
    let fontSize = {
      fontSize: "2em"
    };
    if (this.value.length > 17) {
      fontSize = {
        fontSize: "1.5em"
      };
    }
    if (this.value.length > 44) {
      fontSize = {
        fontSize: "1em"
      };
    }
    return /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.textInput
    }, this.inputVisible ? ( /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.inputContainer
    }, /*#__PURE__*/React.createElement("textarea", {
      id: this.inputId,
      ref: this.refObject._inputRef,
      value: this.value,
      maxLength: this.props.maxLength,
      onChange: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onInputChangeHandlerAsync(e);
      }),
      onKeyUp: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onInputKeyUpHandlerAsync(e);
      }),
      className: "form-control",
      rows: this.props.rows || 3,
      readOnly: this.readonly
    }))) : ( /*#__PURE__*/React.createElement("div", null, this.value ? ( /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.valueContainer
    }, /*#__PURE__*/React.createElement("span", {
      style: fontSize
    }, this.value))) : super.renderContent(renderHidden))));
  }
}

class TextInputWidget extends BaseInputWidget {
  constructor() {
    super(...arguments);
    this._autoSuggestRef = /*#__PURE__*/React.createRef();
    this.refObject = {
      _inputRef: /*#__PURE__*/React.createRef()
    };
  }
  setValueFromAutoSuggest(value) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setAsync(value);
    });
  }
  get autoSuggestItems() {
    return this.props.autoSuggestItems ? this.props.autoSuggestItems : [];
  }
  get toggleButtonId() {
    return `auto-suggest-toggler-${this.id}`;
  }
  get readonly() {
    return this.props.readonly === true;
  }
  get input() {
    return this.refObject._inputRef.current;
  }
  getInnerClassName() {
    if (this.readonly) {
      return widgetStyles.readonly;
    }
    return super.getInnerClassName();
  }
  renderContent(renderHidden = false) {
    let fontSize = {
      fontSize: "2em"
    };
    if (this.value.length > 17) {
      fontSize = {
        fontSize: "1.5em"
      };
    }
    if (this.value.length > 44) {
      fontSize = {
        fontSize: "1em"
      };
    }
    return /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.textInput
    }, this.inputVisible ? ( /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.inputContainer
    }, /*#__PURE__*/React.createElement("input", {
      id: this.inputId,
      type: "text",
      ref: this.refObject._inputRef,
      value: this.value,
      onChange: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onInputChangeHandlerAsync(e);
      }),
      onKeyUp: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onInputKeyUpHandlerAsync(e);
      }),
      className: "form-control",
      autoComplete: this.props.autoComplete === false ? "off" : "",
      readOnly: this.readonly
    }), this.autoSuggestItems.length > 0 && !this.readonly && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.autoCompleteContainer, this.mobile && widgetStyles.mobile)
    }, /*#__PURE__*/React.createElement(AutoSuggest, {
      ref: this._autoSuggestRef,
      className: widgetStyles.autoComplete,
      items: this.autoSuggestItems,
      isOpen: this.inputVisible,
      toggleButtonId: this.toggleButtonId,
      onSelect: (_, value) => __awaiter(this, void 0, void 0, function* () {
        return yield this.setValueFromAutoSuggest(value);
      })
    }))))) : ( /*#__PURE__*/React.createElement("div", null, this.value ? /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.valueContainer
    }, /*#__PURE__*/React.createElement("span", {
      style: fontSize
    }, this.value)) : super.renderContent(renderHidden))));
  }
}

//Autogenerated
class TitleWidgetLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Initializer
  }
}
//Singleton
var TitleWidgetLocalizer$1 = new TitleWidgetLocalizer();

var css_248z$s = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-title-widget-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-title-widget-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-title-widget-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-title-widget-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-title-widget-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-title-widget-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-title-widget-title .athenaeum-title-widget-shrink {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 100%;\n  width: calc(100vw - 120px);\n  display: inline-block;\n  white-space: nowrap;\n}";
var styles$q = {"font-renta":"athenaeum-title-widget-font-renta","color-schema-renta_black":"athenaeum-title-widget-color-schema-renta_black","color-schema-renta_white":"athenaeum-title-widget-color-schema-renta_white","color-schema-renta_orange":"athenaeum-title-widget-color-schema-renta_orange","color-schema-renta_green":"athenaeum-title-widget-color-schema-renta_green","color-schema-renta_blue":"athenaeum-title-widget-color-schema-renta_blue","title":"athenaeum-title-widget-title","shrink":"athenaeum-title-widget-shrink"};
styleInject(css_248z$s);

class TitleWidget extends BaseWidget {
  constructor() {
    super(...arguments);
    this._containerRef = /*#__PURE__*/React.createRef();
  }
  get icon() {
    const icon = this.state.icon;
    if (icon != null) {
      icon.size = this.expanded ? IconSize.X3 : IconSize.X2;
    }
    return icon;
  }
  getLabelWidthStyle() {
    const container = this._containerRef.current;
    if (container && !this.expanded) {
      return {
        maxWidth: container.offsetWidth - 80
      };
    }
    return {};
  }
  windowResizeHandlerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.mobile) {
        yield this.reRenderAsync();
      }
    });
  }
  onClickAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.minimized) {
        yield this.maximizeAsync();
      } else {
        yield this.minimizeAsync();
      }
    });
  }
  processDataAsync(state, data) {
    return __awaiter(this, void 0, void 0, function* () {
      if (data != null) {
        const title = TypeConverter.convert(data, "ITitleModel");
        if (title != null) {
          state.description = title.description;
          state.label = title.label;
          state.icon = title.icon || state.icon;
        }
      }
    });
  }
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this.state.minimized = true;
      if (this.props.model != null) {
        this.state.label = this.props.model.label;
        this.state.description = this.props.model.description;
        this.state.icon = this.props.model.icon || this.props.icon;
      }
    });
  }
  get expanded() {
    return !!this.description && (this.desktop || !this.minimized);
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      ref: this._containerRef,
      className: this.css(styles$q.title, widgetStyles.widget, this.props.className, this.getInnerClassName(), this.props.wide ? "col-md-12" : "col-md-6")
    }, /*#__PURE__*/React.createElement("div", {
      className: this.css(widgetStyles.compact, this.transparent && widgetStyles.transparent, widgetStyles.content),
      title: this.toSingleLine(TitleWidgetLocalizer$1.get(this.description || this.label)),
      onClick: e => __awaiter(this, void 0, void 0, function* () {
        return yield this.onClickAsync(e);
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.compactContainer
    }, this.renderContent(), /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.labelAndDescription
    }, this.label && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: this.css(!this.expanded && styles$q.shrink),
      style: this.getLabelWidthStyle()
    }, this.label)), this.expanded && /*#__PURE__*/React.createElement("div", {
      className: widgetStyles.description
    }, /*#__PURE__*/React.createElement("span", null, this.toMultiLines(this.description)))))));
  }
}

class WizardContainer extends BaseWidgetContainer {
  prevAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const page = this.getPage();
      yield page.prevAsync();
    });
  }
  nextAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const page = this.getPage();
      yield page.nextAsync();
    });
  }
  get responsive() {
    return this.props.responsive == true;
  }
  get displayNavigationWidgets() {
    return this.props.hideNext == null || !this.props.hideNext || this.props.hidePrev == null || !this.props.hidePrev;
  }
  getPage() {
    return super.getPage();
  }
  renderContent(renderHidden = false) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.steps && this.props.steps.steps.length > 1 && /*#__PURE__*/React.createElement(StepsWidget, {
      steps: this.props.steps.steps
    }), this.widgets, this.displayNavigationWidgets && (this.responsive || this.desktop) && ( /*#__PURE__*/React.createElement(NavigationWidget, {
      responsive: this.responsive,
      className: this.props.navigationClassName,
      canPrev: this.props.canPrev,
      prevIcon: this.props.prevIcon,
      prevLabel: this.props.prevLabel,
      prevDescription: this.props.prevDescription,
      canMiddle: this.props.canMiddle,
      middleIcon: this.props.middleIcon,
      middleDescription: this.props.middleDescription,
      middleLabel: this.props.middleLabel,
      showMiddle: this.props.showMiddle,
      can: this.props.canNext,
      icon: this.props.nextIcon,
      label: this.props.nextLabel,
      description: this.props.nextDescription,
      hidePrev: this.props.hidePrev,
      hideNext: this.props.hideNext,
      onMiddleClick: this.props.onMiddleClick,
      onPrevClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.prevAsync();
      }),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.nextAsync();
      })
    })));
  }
}

//Autogenerated
class PasswordFormLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.helpTextUpperCaseLanguageItemName = `HelpText.UpperCase`;
    this.helpTextLowerCaseLanguageItemName = `HelpText.LowerCase`;
    this.helpTextNumberLanguageItemName = `HelpText.Number`;
    this.helpTextSpecialCharacterLanguageItemName = `HelpText.SpecialCharacter`;
    this.resetPasswordPasswordsDontMatchMessageLanguageItemName = `ResetPassword.PasswordsDontMatchMessage`;
    this.changePasswordCurrentPasswordLanguageItemName = `ChangePassword.CurrentPassword`;
    this.loginPagePasswordInputLanguageItemName = `LoginPage.PasswordInput`;
    this.resetPasswordConfirmPasswordInputLanguageItemName = `ResetPassword.ConfirmPasswordInput`;
    this.saveLanguageItemName = `Save`;
    //Initializer
    this.set(this.helpTextUpperCaseLanguageItemName, {
      language: `en`,
      value: `one uppercase ('A'-'Z') character`
    }, {
      language: `uk`,
      value: `одна велика літера ('A'-'Z')`
    }, {
      language: `sv`,
      value: `en stor bokstav ('A'-'Z')`
    }, {
      language: `ru`,
      value: `одна прописная буква ('A'-'Z')`
    }, {
      language: `pl`,
      value: `jedną dużą literę (A-Z)`
    }, {
      language: `nb`,
      value: `En stor bokstav ('A' - 'Z')`
    }, {
      language: `fi`,
      value: `yksi iso kirjain ('A'-'Z')`
    }, {
      language: `da`,
      value: `Et stort ('A' - 'Z') tegn`
    });
    this.set(this.helpTextLowerCaseLanguageItemName, {
      language: `en`,
      value: `one lowercase ('a'-'z') character`
    }, {
      language: `uk`,
      value: `одна мала буква ('a'-'z')`
    }, {
      language: `sv`,
      value: `en liten bokstav ('a'-'z')`
    }, {
      language: `ru`,
      value: `одна строчная буква ('a'-'z')`
    }, {
      language: `pl`,
      value: `jedną małą literę (a-z)`
    }, {
      language: `nb`,
      value: `En liten bokstav ('a' - 'z')`
    }, {
      language: `fi`,
      value: `yksi pieni kirjain ('a'-'z')`
    }, {
      language: `da`,
      value: `En lille bogstav ('a' - 'z')`
    });
    this.set(this.helpTextNumberLanguageItemName, {
      language: `en`,
      value: `one number`
    }, {
      language: `uk`,
      value: `одна цифра`
    }, {
      language: `sv`,
      value: `en nummer`
    }, {
      language: `ru`,
      value: `одна цифра`
    }, {
      language: `pl`,
      value: `jedną cyfrę`
    }, {
      language: `nb`,
      value: `Ett nummer`
    }, {
      language: `fi`,
      value: `yksi numero`
    }, {
      language: `da`,
      value: `Et nummer`
    });
    this.set(this.helpTextSpecialCharacterLanguageItemName, {
      language: `en`,
      value: `one special character`
    }, {
      language: `uk`,
      value: `один буквено-цифровий символ`
    }, {
      language: `sv`,
      value: `ett special tecken`
    }, {
      language: `ru`,
      value: `один  буквенно-цифровой символ`
    }, {
      language: `pl`,
      value: `jeden znak specjalny`
    }, {
      language: `nb`,
      value: `En spesiell karakter`
    }, {
      language: `fi`,
      value: `yksi erikoismerkki`
    }, {
      language: `da`,
      value: `En speciel karakter`
    });
    this.set(this.resetPasswordPasswordsDontMatchMessageLanguageItemName, {
      language: `en`,
      value: `Passwords don't match`
    }, {
      language: `uk`,
      value: `Паролі не співпадають`
    }, {
      language: `sv`,
      value: `Lösenorden matchar inte`
    }, {
      language: `ru`,
      value: `Пароли не совпадают`
    }, {
      language: `pl`,
      value: `Hasła niejednakowe`
    }, {
      language: `nb`,
      value: `Passord er ulike`
    }, {
      language: `fi`,
      value: `Salasanat eivät täsmää`
    }, {
      language: `da`,
      value: `Adgangskoderne matcher ikke`
    });
    this.set(this.changePasswordCurrentPasswordLanguageItemName, {
      language: `en`,
      value: `Current password`
    }, {
      language: `uk`,
      value: `Поточний пароль`
    }, {
      language: `sv`,
      value: `Nuvarande lösenord`
    }, {
      language: `ru`,
      value: `Текущий пароль`
    }, {
      language: `pl`,
      value: `Aktualne hasło`
    }, {
      language: `nb`,
      value: `Nåverende passord`
    }, {
      language: `fi`,
      value: `Nykyinen salasana`
    }, {
      language: `da`,
      value: `Nuværende adgangskode`
    });
    this.set(this.loginPagePasswordInputLanguageItemName, {
      language: `en`,
      value: `Password`
    }, {
      language: `uk`,
      value: `Пароль`
    }, {
      language: `sv`,
      value: `Lösenord`
    }, {
      language: `ru`,
      value: `Пароль`
    }, {
      language: `pl`,
      value: `Hasło`
    }, {
      language: `nb`,
      value: `Passord`
    }, {
      language: `fi`,
      value: `Salasana`
    }, {
      language: `da`,
      value: `Adgangskode`
    });
    this.set(this.resetPasswordConfirmPasswordInputLanguageItemName, {
      language: `en`,
      value: `Confirm password`
    }, {
      language: `uk`,
      value: `Підтвердити пароль`
    }, {
      language: `sv`,
      value: `Bekräfta lösenord`
    }, {
      language: `ru`,
      value: `Подтвердить пароль`
    }, {
      language: `pl`,
      value: `Potwiedż hasło`
    }, {
      language: `nb`,
      value: `Bekreft passord`
    }, {
      language: `fi`,
      value: `Vahvista salasana`
    }, {
      language: `da`,
      value: `Bekræft adgangskode`
    });
    this.set(this.saveLanguageItemName, {
      language: `en`,
      value: `Save`
    }, {
      language: `uk`,
      value: `Зберегти`
    }, {
      language: `sv`,
      value: `Spara`
    }, {
      language: `ru`,
      value: `Сохранить`
    }, {
      language: `pl`,
      value: `Zapisz`
    }, {
      language: `nb`,
      value: `Lagre`
    }, {
      language: `fi`,
      value: `Tallenna`
    }, {
      language: `da`,
      value: `Gem`
    });
  }
  /**
  /* "HelpText.UpperCase" (one uppercase ('A'-'Z') character)
  */
  get helpTextUpperCase() {
    return this.get(this.helpTextUpperCaseLanguageItemName);
  }
  /**
  /* "HelpText.LowerCase" (one lowercase ('a'-'z') character)
  */
  get helpTextLowerCase() {
    return this.get(this.helpTextLowerCaseLanguageItemName);
  }
  /**
  /* "HelpText.Number" (one number)
  */
  get helpTextNumber() {
    return this.get(this.helpTextNumberLanguageItemName);
  }
  /**
  /* "HelpText.SpecialCharacter" (one special character)
  */
  get helpTextSpecialCharacter() {
    return this.get(this.helpTextSpecialCharacterLanguageItemName);
  }
  /**
  /* "ResetPassword.PasswordsDontMatchMessage" (Passwords don't match)
  */
  get resetPasswordPasswordsDontMatchMessage() {
    return this.get(this.resetPasswordPasswordsDontMatchMessageLanguageItemName);
  }
  /**
  /* "ChangePassword.CurrentPassword" (Current password)
  */
  get changePasswordCurrentPassword() {
    return this.get(this.changePasswordCurrentPasswordLanguageItemName);
  }
  /**
  /* "LoginPage.PasswordInput" (Password)
  */
  get loginPagePasswordInput() {
    return this.get(this.loginPagePasswordInputLanguageItemName);
  }
  /**
  /* "ResetPassword.ConfirmPasswordInput" (Confirm password)
  */
  get resetPasswordConfirmPasswordInput() {
    return this.get(this.resetPasswordConfirmPasswordInputLanguageItemName);
  }
  /**
  /* "Save" (Save)
  */
  get save() {
    return this.get(this.saveLanguageItemName);
  }
}
//Singleton
var PasswordFormLocalizer$1 = new PasswordFormLocalizer();

var PasswordFormType;
(function (PasswordFormType) {
  PasswordFormType[PasswordFormType["SetPassword"] = 0] = "SetPassword";
  PasswordFormType[PasswordFormType["ChangePassword"] = 1] = "ChangePassword";
})(PasswordFormType || (PasswordFormType = {}));
class PasswordForm extends BaseComponent {
  constructor() {
    super(...arguments);
    this.currentPassword = {
      value: ""
    };
    this.password = {
      value: ""
    };
    this.passwordConfirmation = {
      value: ""
    };
    this._formRef = /*#__PURE__*/React.createRef();
    this.validationRows = [new ValidationRow(PasswordValidationRule.UpperCaseCharacter, PasswordFormLocalizer$1.helpTextUpperCase), new ValidationRow(PasswordValidationRule.LowerCaseCharacter, PasswordFormLocalizer$1.helpTextLowerCase), new ValidationRow(PasswordValidationRule.NumberCharacter, PasswordFormLocalizer$1.helpTextNumber), new ValidationRow(PasswordValidationRule.SpecialCharacter, PasswordFormLocalizer$1.helpTextSpecialCharacter)];
  }
  handleSubmitAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.password.value != this.passwordConfirmation.value) {
        const form = this._formRef.current;
        const validationError = PasswordFormLocalizer$1.resetPasswordPasswordsDontMatchMessage;
        yield form.setValidationErrorsAsync(validationError);
      } else {
        if (this.props.type == PasswordFormType.SetPassword) {
          yield this.props.onSubmit(this.password.value, "");
        }
        if (this.props.type == PasswordFormType.ChangePassword) {
          yield this.props.onSubmit(this.passwordConfirmation.value, this.currentPassword.value);
        }
      }
    });
  }
  render() {
    const changePassword = this.props.type == PasswordFormType.ChangePassword;
    return /*#__PURE__*/React.createElement(Form, {
      id: "form",
      ref: this._formRef,
      onSubmit: () => this.handleSubmitAsync()
    }, changePassword && ( /*#__PURE__*/React.createElement(PasswordInput, {
      required: true,
      autoFocus: true,
      label: PasswordFormLocalizer$1.changePasswordCurrentPassword,
      model: this.currentPassword
    })), /*#__PURE__*/React.createElement(PasswordInput, {
      required: true,
      autoFocus: !changePassword,
      validLength: 8,
      label: PasswordFormLocalizer$1.loginPagePasswordInput,
      model: this.password,
      liveValidator: this.validationRows
    }), /*#__PURE__*/React.createElement(PasswordInput, {
      required: true,
      label: PasswordFormLocalizer$1.resetPasswordConfirmPasswordInput,
      model: this.passwordConfirmation
    }), /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
      submit: true,
      type: ButtonType.Orange,
      label: PasswordFormLocalizer$1.save
    })));
  }
}

var css_248z$r = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-toolbar-container-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-toolbar-container-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-toolbar-container-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-toolbar-container-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-toolbar-container-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-toolbar-container-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-toolbar-container-toolbarContainer {\n  flex-direction: column;\n  justify-content: flex-end !important;\n  position: relative;\n  margin-bottom: 4px;\n}\n.athenaeum-toolbar-container-toolbarContainer .athenaeum-toolbar-container-toggleButton:focus {\n  box-shadow: none !important;\n  outline: none !important;\n}\n.athenaeum-toolbar-container-toolbarContainer .athenaeum-toolbar-container-toggleButton:hover {\n  background-color: unset !important;\n}";
var styles$p = {"font-renta":"athenaeum-toolbar-container-font-renta","color-schema-renta_black":"athenaeum-toolbar-container-color-schema-renta_black","color-schema-renta_white":"athenaeum-toolbar-container-color-schema-renta_white","color-schema-renta_orange":"athenaeum-toolbar-container-color-schema-renta_orange","color-schema-renta_green":"athenaeum-toolbar-container-color-schema-renta_green","color-schema-renta_blue":"athenaeum-toolbar-container-color-schema-renta_blue","toolbarContainer":"athenaeum-toolbar-container-toolbarContainer","toggleButton":"athenaeum-toolbar-container-toggleButton"};
styleInject(css_248z$r);

class ToolbarContainer extends BaseComponent {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      style: this.props.style,
      className: this.css(styles$p.toolbarContainer, "d-flex justify-content-between", this.props.className)
    }, this.children);
  }
}

var css_248z$q = ".athenaeum-toolbar-row-toolbarRow {\n  min-height: 41px;\n}";
var styles$o = {"toolbarRow":"athenaeum-toolbar-row-toolbarRow"};
styleInject(css_248z$q);

class ToolbarRow extends BaseComponent {
  render() {
    return /*#__PURE__*/React.createElement(Inline, {
      className: this.css(styles$o.toolbarRow, this.props.className),
      justify: this.props.justify
    }, this.props.children);
  }
}

//Autogenerated
class ToolbarContainerLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Initializer
  }
}
//Singleton
var ToolbarContainerLocalizer$1 = new ToolbarContainerLocalizer();

var css_248z$p = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-toolbar-button-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-toolbar-button-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-toolbar-button-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-toolbar-button-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-toolbar-button-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-toolbar-button-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-toolbar-button-toolbarButton span {\n  cursor: default;\n}";
var styles$n = {"font-renta":"athenaeum-toolbar-button-font-renta","color-schema-renta_black":"athenaeum-toolbar-button-color-schema-renta_black","color-schema-renta_white":"athenaeum-toolbar-button-color-schema-renta_white","color-schema-renta_orange":"athenaeum-toolbar-button-color-schema-renta_orange","color-schema-renta_green":"athenaeum-toolbar-button-color-schema-renta_green","color-schema-renta_blue":"athenaeum-toolbar-button-color-schema-renta_blue","toolbarButton":"athenaeum-toolbar-button-toolbarButton"};
styleInject(css_248z$p);

class ToolbarButton extends BaseComponent {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.css("d-flex", styles$n.toolbarButton, this.props.className)
    }, /*#__PURE__*/React.createElement(Inline, null, /*#__PURE__*/React.createElement("span", null, ToolbarContainerLocalizer$1.get(this.props.label)), /*#__PURE__*/React.createElement(Button, Object.assign({}, this.props, {
      small: true,
      label: undefined
    }))));
  }
}

var css_248z$o = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-panel-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-panel-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-panel-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-panel-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-panel-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-panel-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-panel-panel {\n  border: 1px solid lightgrey;\n  border-radius: 5px;\n  padding: 16px 0;\n  margin: 0 16px 16px 16px;\n  width: 100%;\n  max-width: 100%;\n  position: relative;\n  transition: max-width 0.2s ease, height 0.2s ease;\n}\n.athenaeum-panel-panel .athenaeum-panel-heading {\n  margin-bottom: 16px;\n}\n.athenaeum-panel-panel .athenaeum-panel-title {\n  margin-bottom: 0;\n  align-self: center;\n}\n.athenaeum-panel-panel .athenaeum-panel-content {\n  display: block;\n}\n.athenaeum-panel-panel .athenaeum-panel-collapsedContent {\n  cursor: pointer;\n  height: 100%;\n  display: flex;\n  align-content: center;\n}\n.athenaeum-panel-panel:hover .athenaeum-panel-minimize {\n  display: block;\n}\n.athenaeum-panel-panel .athenaeum-panel-minimize {\n  display: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  cursor: pointer;\n  color: #337ab7;\n  opacity: 0.3;\n  padding: 6px 3px;\n}\n.athenaeum-panel-panel .athenaeum-panel-minimize:hover {\n  opacity: 1;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseHorizontally {\n  max-width: 24px;\n  overflow: hidden;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseHorizontally .athenaeum-panel-minimize {\n  display: block;\n  opacity: 1;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseHorizontally .athenaeum-panel-heading {\n  display: none;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseHorizontally .athenaeum-panel-content {\n  visibility: hidden;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseHorizontally .athenaeum-panel-collapsedContent {\n  display: none;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseVertically {\n  height: 48px !important;\n  overflow: hidden;\n  padding: 0;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseVertically .athenaeum-panel-heading {\n  display: none;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseVertically .athenaeum-panel-minimize {\n  display: block;\n  opacity: 1;\n}\n.athenaeum-panel-panel.athenaeum-panel-collapseVertically .athenaeum-panel-content {\n  display: none;\n}";
var styles$m = {"font-renta":"athenaeum-panel-font-renta","color-schema-renta_black":"athenaeum-panel-color-schema-renta_black","color-schema-renta_white":"athenaeum-panel-color-schema-renta_white","color-schema-renta_orange":"athenaeum-panel-color-schema-renta_orange","color-schema-renta_green":"athenaeum-panel-color-schema-renta_green","color-schema-renta_blue":"athenaeum-panel-color-schema-renta_blue","panel":"athenaeum-panel-panel","heading":"athenaeum-panel-heading","title":"athenaeum-panel-title","content":"athenaeum-panel-content","collapsedContent":"athenaeum-panel-collapsedContent","minimize":"athenaeum-panel-minimize","collapseHorizontally":"athenaeum-panel-collapseHorizontally","collapseVertically":"athenaeum-panel-collapseVertically"};
styleInject(css_248z$o);

var PanelCollapseType;
(function (PanelCollapseType) {
  PanelCollapseType[PanelCollapseType["Vertical"] = 0] = "Vertical";
  PanelCollapseType[PanelCollapseType["Horizontal"] = 1] = "Horizontal";
})(PanelCollapseType || (PanelCollapseType = {}));
class Panel extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      collapsed: this.props.collapsed || UserInteractionDataStorage.get(this.id, false, this.dataStorageType)
    };
  }
  saveCollapsed() {
    if (this.props.id) {
      UserInteractionDataStorage.set(this.id, this.collapsed, this.dataStorageType);
    }
  }
  get collapsed() {
    return this.state.collapsed;
  }
  get collapseType() {
    return this.props.collapsible !== undefined ? this.props.collapsible : null;
  }
  get collapseClass() {
    if (this.collapseType !== null) {
      if (this.collapseType === PanelCollapseType.Horizontal) {
        return styles$m.collapseHorizontally;
      } else {
        return styles$m.collapseVertically;
      }
    }
    return "";
  }
  get dataStorageType() {
    return this.props.dataStorageType || DataStorageType.Page;
  }
  get customHeading() {
    return this.props.customHeading;
  }
  get title() {
    return this.props.title || "";
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.collapsed) {
        yield this.expandAsync();
      } else {
        yield this.collapseAsync();
      }
    });
  }
  expandAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.collapsed) {
        yield this.setState({
          collapsed: false
        });
        this.saveCollapsed();
      }
    });
  }
  collapseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.collapsed) {
        yield this.setState({
          collapsed: true
        });
        this.saveCollapsed();
      }
    });
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(styles$m.panel, this.collapsed && this.collapseClass, this.props.className)
    }, (this.customHeading || this.title) && ( /*#__PURE__*/React.createElement("div", {
      className: styles$m.heading
    }, !this.customHeading && /*#__PURE__*/React.createElement("h3", {
      className: this.css(styles$m.title, "col"),
      title: this.title
    }, this.title), this.customHeading)), this.collapsed && ( /*#__PURE__*/React.createElement("div", {
      className: styles$m.collapsedContent,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAsync();
      })
    }, /*#__PURE__*/React.createElement("h3", {
      className: this.css(styles$m.title, "col")
    }, this.title))), this.collapseType !== null && (this.collapseType === PanelCollapseType.Horizontal ? /*#__PURE__*/React.createElement("i", {
      className: this.css(styles$m.minimize, `${this.collapsed ? "fa fa-lg fa-caret-square-right" : "fa fa-lg fa-caret-square-left"}`),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAsync();
      })
    }) : this.collapseType === PanelCollapseType.Vertical ? /*#__PURE__*/React.createElement("i", {
      className: this.css(styles$m.minimize, `${this.collapsed ? "fa fa-lg fa-caret-square-down" : "fa fa-lg fa-caret-square-up"}`),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAsync();
      })
    }) : null), /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$m.content)
    }, this.props.children));
  }
}

//Autogenerated
class ImageModalLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.previewNotSupportedLanguageItemName = `PreviewNotSupported`;
    this.downloadLanguageItemName = `Download`;
    //Initializer
    this.set(this.previewNotSupportedLanguageItemName, {
      language: `en`,
      value: `Preview is not supported for this type of file, but you can download it instead`
    }, {
      language: `uk`,
      value: `Попередній перегляд не підтримується для файлів цього типу, але ви можете завантажити його замість цього.`
    }, {
      language: `sv`,
      value: `Förhandsgranskning stöds inte för denna typ av fil, men du kan ladda ner den istället`
    }, {
      language: `ru`,
      value: `Предварительный просмотр не поддерживается для файлов этого типа, но вы можете скачать его вместо этого.`
    }, {
      language: `pl`,
      value: `Podgląd dokumentu niemożliwy`
    }, {
      language: `nb`,
      value: `Forhåndsvisning støttes ikke for denne typen filer, men du kan laste den ned i stedet`
    }, {
      language: `fi`,
      value: `Tiedosto ei tue esikatselua. Voit ladata tiedoston katselua varten`
    }, {
      language: `da`,
      value: `Preview understøttes ikke for denne type fil, men du kan downloade den i stedet`
    });
    this.set(this.downloadLanguageItemName, {
      language: `en`,
      value: `Download`
    }, {
      language: `uk`,
      value: `Завантажити`
    }, {
      language: `sv`,
      value: `Ladda ner`
    }, {
      language: `ru`,
      value: `Загрузить`
    }, {
      language: `pl`,
      value: `Pobierz`
    }, {
      language: `nb`,
      value: `Last ned`
    }, {
      language: `fi`,
      value: `Lataa`
    }, {
      language: `da`,
      value: `Hent`
    });
  }
  /**
  /* "PreviewNotSupported" (Preview is not supported for this type of file, but you can download it instead)
  */
  get previewNotSupported() {
    return this.get(this.previewNotSupportedLanguageItemName);
  }
  /**
  /* "Download" (Download)
  */
  get download() {
    return this.get(this.downloadLanguageItemName);
  }
}
//Singleton
var ImageModalLocalizer$1 = new ImageModalLocalizer();

var css_248z$n = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-image-modal-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-image-modal-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-image-modal-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-image-modal-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-image-modal-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-image-modal-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-image-modal-imageModal > div {\n  width: 100%;\n  height: 100%;\n  margin-bottom: 16px;\n}\n.athenaeum-image-modal-imageModal > div > div {\n  width: 100%;\n  height: 100%;\n  background-size: contain !important;\n  background-repeat: no-repeat !important;\n  background-position: center !important;\n  background-color: white !important;\n}\n.athenaeum-image-modal-imageModal .athenaeum-image-modal-image {\n  height: 50vh;\n}\n.athenaeum-image-modal-imageModal .athenaeum-image-modal-image.athenaeum-image-modal-mobile {\n  padding: 50% 50% 50% 50%;\n  height: 100%;\n}\n.athenaeum-image-modal-imageModal .athenaeum-image-modal-image.athenaeum-image-modal-bigger {\n  height: 70vh;\n}";
var styles$l = {"font-renta":"athenaeum-image-modal-font-renta","color-schema-renta_black":"athenaeum-image-modal-color-schema-renta_black","color-schema-renta_white":"athenaeum-image-modal-color-schema-renta_white","color-schema-renta_orange":"athenaeum-image-modal-color-schema-renta_orange","color-schema-renta_green":"athenaeum-image-modal-color-schema-renta_green","color-schema-renta_blue":"athenaeum-image-modal-color-schema-renta_blue","imageModal":"athenaeum-image-modal-imageModal","image":"athenaeum-image-modal-image","mobile":"athenaeum-image-modal-mobile","bigger":"athenaeum-image-modal-bigger"};
styleInject(css_248z$n);

class ImageProvider {
  static getImageUrl(image) {
    return image.src ? image.src : `/files/images/${image.id}`;
  }
  static getImageStyle(image) {
    const url = typeof image === "string" ? image : ImageProvider.getImageUrl(image);
    return {
      background: `url(${url})`
    };
  }
}
class ImageModal extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      picture: this.props.picture || null
    };
    this._modalRef = /*#__PURE__*/React.createRef();
  }
  getImageUrl(image) {
    return this.props.imageUrl ? this.props.imageUrl(image) : ImageProvider.getImageUrl(image);
  }
  getImageStyle(image) {
    const url = this.getImageUrl(image);
    return ImageProvider.getImageStyle(url);
  }
  get picture() {
    return this.state.picture;
  }
  get subtitle() {
    return this.props.subtitle ? this.props.subtitle : this.picture ? this.picture.name : "";
  }
  get previewSupported() {
    return this.picture ? AthenaeumComponentsConstants.imageFileTypes.includes(this.picture.type) : false;
  }
  download() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.picture) {
        if (!this.picture.src) {
          this.picture.src = `/files/images/${this.picture.id}`;
        }
        if (this.props.downloadOriginal) {
          this.picture.src += `?downloadOriginal=` + this.props.downloadOriginal;
        }
        ch.download(this.picture);
      }
    });
  }
  openAsync(picture = null) {
    return __awaiter(this, void 0, void 0, function* () {
      if (picture) {
        yield this.setState({
          picture
        });
      }
      yield this._modalRef.current.openAsync();
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    return __awaiter(this, void 0, void 0, function* () {
      if (nextProps.picture && nextProps.picture !== this.props.picture) {
        yield this.setState({
          picture: nextProps.picture
        });
      }
    });
  }
  render() {
    const mobileStyle = this.mobile && styles$l.mobile;
    const biggerStyle = this.props.size !== undefined && this.props.size !== ModalSize.Default && this.props.size !== ModalSize.Small && styles$l.bigger;
    return /*#__PURE__*/React.createElement(Modal, {
      id: this.id,
      ref: this._modalRef,
      bodyClassName: styles$l.imageModal,
      title: this.props.title,
      subtitle: this.subtitle,
      size: this.props.size
    }, /*#__PURE__*/React.createElement("div", null, this.picture && this.previewSupported && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$l.image, mobileStyle, biggerStyle),
      style: this.getImageStyle(this.picture)
    })), this.picture && !this.previewSupported && ( /*#__PURE__*/React.createElement("span", null, ImageModalLocalizer$1.previewNotSupported))), this.props.download && this.picture && ( /*#__PURE__*/React.createElement(Button, {
      type: ButtonType.Orange,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.download();
      }),
      label: ImageModalLocalizer$1.download
    })));
  }
}

var css_248z$m = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-accordion-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-accordion-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-accordion-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-accordion-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-accordion-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-accordion-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-accordion-accordion {\n  overflow: hidden;\n  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n  border-radius: 4px;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-headerContainer {\n  display: flex;\n  justify-content: space-between;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-headerContainer .athenaeum-accordion-header {\n  flex: 1;\n  align-self: center;\n  padding: 16px 12px;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-headerContainer .athenaeum-accordion-header h3 {\n  margin: 0;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-contentContainer {\n  height: auto;\n  transition: max-height 0.2s ease-in-out;\n  overflow: hidden;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-contentContainer .athenaeum-accordion-separator {\n  margin: 0 !important;\n  border-color: grey;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-contentContainer.athenaeum-accordion-collapsed {\n  max-height: 0 !important;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-contentContainer .athenaeum-accordion-content {\n  padding: 16px 12px;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-expansionInfo {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: 48px;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-expansionInfo .athenaeum-accordion-expansionInfoIcon {\n  transition: transform 0.2s ease-in-out;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-expansionInfo .athenaeum-accordion-expansionInfoIcon.athenaeum-accordion-expanded {\n  transform: rotate(180deg);\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-toggler {\n  width: 48px;\n  background-color: rgb(254, 80, 0);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  cursor: pointer;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-toggler .athenaeum-accordion-icon {\n  transition: transform 0.2s ease-in-out;\n}\n.athenaeum-accordion-accordion .athenaeum-accordion-toggler .athenaeum-accordion-icon.athenaeum-accordion-expanded {\n  transform: rotate(180deg);\n}";
var styles$k = {"font-renta":"athenaeum-accordion-font-renta","color-schema-renta_black":"athenaeum-accordion-color-schema-renta_black","color-schema-renta_white":"athenaeum-accordion-color-schema-renta_white","color-schema-renta_orange":"athenaeum-accordion-color-schema-renta_orange","color-schema-renta_green":"athenaeum-accordion-color-schema-renta_green","color-schema-renta_blue":"athenaeum-accordion-color-schema-renta_blue","accordion":"athenaeum-accordion-accordion","headerContainer":"athenaeum-accordion-headerContainer","header":"athenaeum-accordion-header","contentContainer":"athenaeum-accordion-contentContainer","separator":"athenaeum-accordion-separator","collapsed":"athenaeum-accordion-collapsed","content":"athenaeum-accordion-content","expansionInfo":"athenaeum-accordion-expansionInfo","expansionInfoIcon":"athenaeum-accordion-expansionInfoIcon","expanded":"athenaeum-accordion-expanded","toggler":"athenaeum-accordion-toggler","icon":"athenaeum-accordion-icon"};
styleInject(css_248z$m);

var TogglerPosition;
(function (TogglerPosition) {
  TogglerPosition[TogglerPosition["Header"] = 0] = "Header";
  TogglerPosition[TogglerPosition["Bottom"] = 1] = "Bottom";
})(TogglerPosition || (TogglerPosition = {}));
class Accordion extends BaseComponent {
  constructor() {
    // Inherited
    super(...arguments);
    this.state = {
      expanded: !!this.props.expanded,
      maxHeight: 0
    };
    // Fields
    this._contentRef = /*#__PURE__*/React.createRef();
  }
  // Getters
  get autoCollapse() {
    switch (this.props.autoCollapse) {
      case false:
        return false;
      default:
        return true;
    }
  }
  get classNames() {
    const classNamesCopy = Object.assign({}, this.props.classNames);
    Object.keys(styles$k).forEach(key => !classNamesCopy[key] ? classNamesCopy[key] = styles$k[key] : classNamesCopy[key]);
    return classNamesCopy;
  }
  get contentNode() {
    return this._contentRef.current;
  }
  get collapsed() {
    return !this.expanded;
  }
  get expanded() {
    return this.state.expanded;
  }
  get hasToggle() {
    return !!this.props.toggler;
  }
  get maxHeightOffset() {
    var _a;
    return (_a = this.props.maxHeightOffset) !== null && _a !== void 0 ? _a : 0;
  }
  // Async-methods
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      if (this.expanded) {
        yield this.recalculateContentHeight();
      }
    });
  }
  setExpanded(expanded) {
    return __awaiter(this, void 0, void 0, function* () {
      if (expanded !== this.expanded) {
        yield this.recalculateContentHeight();
        yield this.setState({
          expanded
        });
        if (this.props.onToggle) {
          yield this.props.onToggle(this, expanded);
        }
      }
    });
  }
  getHeader() {
    const headerIsComponent = /*#__PURE__*/React.isValidElement(this.props.header);
    if (headerIsComponent) {
      return this.props.header;
    }
    return /*#__PURE__*/React.createElement("h3", null, this.props.header);
  }
  getToggler() {
    var _a, _b;
    if (this.hasToggle) {
      const togglerIsComponent = /*#__PURE__*/React.isValidElement(this.props.toggler);
      if (togglerIsComponent) {
        return this.props.toggler;
      }
      return /*#__PURE__*/React.createElement(Icon, {
        className: this.css(styles$k.icon, this.expanded && styles$k.expanded),
        name: (_a = this.props.togglerIcon) !== null && _a !== void 0 ? _a : "caret-down",
        size: (_b = this.props.togglerSize) !== null && _b !== void 0 ? _b : IconSize.X2
      });
    }
    return null;
  }
  get togglerPosition() {
    return this.props.togglerPosition !== undefined && this.props.togglerPosition !== null ? this.props.togglerPosition : TogglerPosition.Header;
  }
  expandAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setExpanded(true);
    });
  }
  collapseAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setExpanded(false);
    });
  }
  toggleAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.expanded ? yield this.collapseAsync() : yield this.expandAsync();
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.expanded && this.autoCollapse) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id);
        if (outside) {
          yield this.collapseAsync();
        }
      }
    });
  }
  /**
   * If content is added dynamically to the {@link Accordion} while it is open, it will not resize itself automatically, causing the content to overflow and clip.
   * Calling this method will make the {@link Accordion} readjust itself, so all content is visible.
   */
  recalculateContentHeight() {
    return __awaiter(this, void 0, void 0, function* () {
      const contentNode = this.contentNode;
      if (contentNode) {
        const maxHeight = contentNode.getBoundingClientRect().height;
        yield this.setState({
          maxHeight
        });
      }
    });
  }
  render() {
    const expandedStyles = this.expanded && styles$k.expanded;
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(this.classNames.accordion, this.props.className, styles$k.accordion, expandedStyles)
    }, /*#__PURE__*/React.createElement("div", {
      className: this.css(this.classNames.headerContainer, styles$k.headerContainer, !this.hasToggle && "cursor-pointer"),
      onClick: !this.hasToggle ? () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleAsync();
      }) : undefined
    }, /*#__PURE__*/React.createElement("div", {
      className: this.css(this.classNames.header, styles$k.header)
    }, this.getHeader()), !this.hasToggle && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$k.expansionInfo)
    }, /*#__PURE__*/React.createElement(Icon, {
      className: this.css(styles$k.expansionInfoIcon, this.expanded && styles$k.expanded),
      name: "angle-down",
      size: IconSize.X2
    }))), this.hasToggle && this.togglerPosition === TogglerPosition.Header && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(this.classNames.toggler, styles$k.toggler),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return this.toggleAsync();
      })
    }, this.getToggler()))), /*#__PURE__*/React.createElement("div", {
      className: this.css(this.classNames.contentContainer, styles$k.contentContainer, this.collapsed && this.css(this.classNames.collapsed, styles$k.collapsed)),
      style: {
        maxHeight: this.state.maxHeight + this.maxHeightOffset
      }
    }, /*#__PURE__*/React.createElement("hr", {
      className: this.css(this.classNames.separator, styles$k.separator)
    }), /*#__PURE__*/React.createElement("div", {
      ref: this._contentRef,
      className: this.css(this.classNames.content, styles$k.content)
    }, this.props.children)), this.togglerPosition === TogglerPosition.Bottom && this.hasToggle && ( /*#__PURE__*/React.createElement("div", {
      className: this.css(this.classNames.toggler, styles$k.toggler),
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return this.toggleAsync();
      })
    }, this.getToggler())));
  }
}

var css_248z$l = ".athenaeum-google-map-googleMap a:focus {\n  outline: none;\n  text-decoration: none;\n}";
var styles$j = {"googleMap":"athenaeum-google-map-googleMap"};
styleInject(css_248z$l);

/**
 * A generic Google Maps component.
 */
class GoogleMap extends BaseComponent {
  constructor() {
    // Fields
    super(...arguments);
    this._googleMapDiv = /*#__PURE__*/React.createRef();
    this._markerClusterer = new MarkerClusterer({});
    this._googleMap = null;
    this._mapClickEventListener = null;
    this._markers = [];
    this._circles = [];
    this._infoWindows = [];
    this._polyline = null;
  }
  // Properties
  get autoCloseInfoWindows() {
    return !!this.props.autoCloseInfoWindows;
  }
  get clusterMarkers() {
    return !!this.props.clusterMarkers;
  }
  get googleMap() {
    return this._googleMap;
  }
  get polylinePath() {
    return this.props.polyLinePath || null;
  }
  get initialCenter() {
    return AddressHelper.toGoogleLatLon(this.props.initialCenter);
  }
  // Methods
  handlePropsAsync(newEvent = true, newMarkers = true, newPolyLine = true, newZoom = false, newCenter = false) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
      if (newMarkers) {
        this._markers.forEach(internalMarker => internalMarker.map = null);
        this._circles.forEach(internalCircle => internalCircle.setMap(null));
        this._circles = [];
        this._markerClusterer.clearMarkers();
        this._infoWindows.forEach(internalInfoWindow => internalInfoWindow.close());
        this._infoWindows = [];
        const markers = (_a = this.props.markers) !== null && _a !== void 0 ? _a : [];
        this._markers = markers.map(newMarker => {
          const internalMarker = new google.maps.marker.AdvancedMarkerElement({
            map: this.googleMap,
            position: newMarker.position,
            title: newMarker.title,
            collisionBehavior: newMarker.collisionBehavior,
            content: newMarker.content,
            gmpClickable: newMarker.gmpClickable,
            gmpDraggable: newMarker.gmpDraggable,
            zIndex: newMarker.zIndex
          });
          let internalInfoWindow = null;
          let internalCircle = null;
          if (newMarker.infoWindow) {
            internalInfoWindow = new google.maps.InfoWindow(newMarker.infoWindow);
            internalInfoWindow.addListener("closeclick", () => {
              if (internalInfoWindow) {
                internalInfoWindow.isVisible = false;
              }
            });
            this._infoWindows.push(internalInfoWindow);
          }
          if (newMarker.circle) {
            internalCircle = new google.maps.Circle(newMarker.circle);
            this._circles.push(internalCircle);
          }
          internalMarker.addListener("click", event => {
            if (internalInfoWindow) {
              internalInfoWindow.isVisible = !internalInfoWindow.isVisible;
              if (internalInfoWindow.isVisible) {
                internalInfoWindow.open(this.googleMap);
                if (this.autoCloseInfoWindows) {
                  this.closeInfoWindows(internalInfoWindow);
                }
              } else {
                internalInfoWindow.close();
              }
            }
            if (newMarker.onClick) {
              const lon = event.latLng.lng();
              const lat = event.latLng.lat();
              const coordinate = new GeoCoordinate(lat, lon);
              newMarker.onClick(this, newMarker, coordinate);
            }
          });
          internalMarker.addListener("dblclick", event => {
            if (newMarker.onDoubleClick) {
              const lon = event.latLng.lng();
              const lat = event.latLng.lat();
              const coordinate = new GeoCoordinate(lat, lon);
              newMarker.onDoubleClick(this, newMarker, coordinate);
            }
          });
          return internalMarker;
        });
        if (this.clusterMarkers) {
          this._markerClusterer.setMap(this.googleMap);
          this._markerClusterer.addMarkers(this._markers);
        } else {
          this._markerClusterer.setMap(null);
        }
        if (this._circles) {
          this._circles.forEach(internalCircle => internalCircle.setMap(this.googleMap));
        }
      }
      if (newPolyLine) {
        (_b = this._polyline) === null || _b === void 0 ? void 0 : _b.setMap(null);
        this.setPolyline();
      }
      if (newEvent) {
        (_c = this._mapClickEventListener) === null || _c === void 0 ? void 0 : _c.remove();
        this._mapClickEventListener = this.googleMap.addListener("click", event => this.onMapClickAsync(event));
      }
      if (newZoom) {
        this.googleMap.setZoom(this.props.initialZoom);
      }
      if (newCenter) {
        this.googleMap.setCenter(this.initialCenter);
      }
    });
  }
  onMapClickAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.autoCloseInfoWindows) {
        this.closeInfoWindows();
      }
      if (this.props.onClick) {
        const lon = event.latLng.lng();
        const lat = event.latLng.lat();
        const coordinate = new GeoCoordinate(lat, lon);
        yield this.props.onClick(this, coordinate);
      }
    });
  }
  /**
   * Close all {@link IGoogleMapInternalInfoWindow}'s, except one if specified.
   *
   * @param except {@link IGoogleMapInternalInfoWindow} to keep open.
   */
  closeInfoWindows(except) {
    this._infoWindows.forEach(internalInfoWindow => {
      if (except !== internalInfoWindow) {
        internalInfoWindow.isVisible = false;
        internalInfoWindow.close();
      }
    });
  }
  setPolyline() {
    if (this._googleMap && this.polylinePath) {
      const lineSymbol = {
        path: google.maps.SymbolPath.CIRCLE,
        fillOpacity: 1,
        strokeOpacity: 1,
        strokeWeight: 2,
        fillColor: "#173443",
        strokeColor: "#98c8e5",
        scale: 5
      };
      this._polyline = new google.maps.Polyline({
        path: this.polylinePath,
        map: this._googleMap,
        clickable: false,
        geodesic: true,
        strokeColor: "black",
        strokeOpacity: 0.1,
        strokeWeight: 5,
        icons: [{
          icon: lineSymbol,
          offset: "0",
          repeat: "20px"
        }]
      });
    }
  }
  initializeAsync() {
    const _super = Object.create(null, {
      initializeAsync: {
        get: () => super.initializeAsync
      }
    });
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.initializeAsync.call(this);
      const options = {
        streetViewControl: (_a = this.props.streetViewControl) !== null && _a !== void 0 ? _a : true,
        fullscreenControl: (_b = this.props.fullscreenControl) !== null && _b !== void 0 ? _b : true,
        mapTypeControl: (_c = this.props.mapTypeControl) !== null && _c !== void 0 ? _c : true,
        center: this.initialCenter,
        zoom: this.props.initialZoom,
        mapId: this.props.mapId,
        gestureHandling: "cooperative",
        draggable: this.props.draggable,
        scrollwheel: this.props.scrollWheel
      };
      this._googleMap = yield AddressHelper.createMapAsync(this._googleMapDiv.current, null, null, options);
      yield this.handlePropsAsync();
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const newMarkers = !Comparator.isEqual(nextProps.markers, this.props.markers);
      const newCenter = !Comparator.isEqual(nextProps.initialCenter, this.props.initialCenter);
      const newZoom = nextProps.initialZoom != this.props.initialZoom;
      const newPolyLinePath = !Comparator.isEqual(nextProps.polyLinePath, this.props.polyLinePath);
      yield _super.componentWillReceiveProps.call(this, nextProps);
      yield this.handlePropsAsync(false, newMarkers, newPolyLinePath, newZoom, newCenter);
    });
  }
  /**
   * Center the map on the given coordinates.
   * @param center New center coordinates of the map.
   */
  setCenterAsync(center) {
    return __awaiter(this, void 0, void 0, function* () {
      this.googleMap.setCenter(center);
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentWillReceiveProps.call(this, nextProps);
      yield this.handlePropsAsync();
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(NoSwipeNavigation, {
      id: this.id,
      innerRef: this._googleMapDiv,
      className: this.css(styles$j.googleMap, this.props.className),
      style: {
        height: this.props.height
      }
    });
  }
}

var css_248z$k = ".athenaeum-qr-input-qrInputContainer {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n.athenaeum-qr-input-qrInputContainer .athenaeum-qr-input-qrInputButton {\n  height: 60px;\n  white-space: normal !important;\n  outline: none !important;\n  box-shadow: none !important;\n  text-transform: uppercase;\n}";
var styles$i = {"qrInputContainer":"athenaeum-qr-input-qrInputContainer","qrInputButton":"athenaeum-qr-input-qrInputButton"};
styleInject(css_248z$k);

//Autogenerated
class QrInputLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.buttonCloseLanguageItemName = `Button.Close`;
    this.buttonLabelLanguageItemName = `Button.Label`;
    //Initializer
    this.set(this.buttonCloseLanguageItemName, {
      language: `en`,
      value: `Close`
    }, {
      language: `uk`,
      value: `\nЗакрити`
    }, {
      language: `sv`,
      value: `\nStänga`
    }, {
      language: `ru`,
      value: `Закрывать`
    }, {
      language: `pl`,
      value: `\nBlisko`
    }, {
      language: `nb`,
      value: `Lukk`
    }, {
      language: `fi`,
      value: `Sulje`
    }, {
      language: `da`,
      value: `Tæt`
    });
    this.set(this.buttonLabelLanguageItemName, {
      language: `en`,
      value: `Qr code`
    }, {
      language: `sv`,
      value: `Qr-kod`
    }, {
      language: `pl`,
      value: `Kod Qr`
    }, {
      language: `nb`,
      value: `QR kode`
    }, {
      language: `fi`,
      value: `Qr-koodi`
    }, {
      language: `da`,
      value: `Qr-kode`
    });
  }
  /**
  /* "Button.Close" (Close)
  */
  get buttonClose() {
    return this.get(this.buttonCloseLanguageItemName);
  }
  /**
  /* "Button.Label" (Qr code)
  */
  get buttonLabel() {
    return this.get(this.buttonLabelLanguageItemName);
  }
}
//Singleton
var QrInputLocalizer$1 = new QrInputLocalizer();

/**
 * Qr input that can be used without {@link WidgetContainer}.
 */
class QrInput extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      showQrReader: false
    };
  }
  get IsQrReaderVisible() {
    return this.state.showQrReader;
  }
  onScanAsync(code) {
    return __awaiter(this, void 0, void 0, function* () {
      if (code && this.props.onQr) {
        if (this.props.closeOnQr) {
          yield this.setState({
            showQrReader: false
          });
        }
        yield this.props.onQr(code);
      }
    });
  }
  static onScanErrorAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield ch.alertErrorAsync(QrWidgetLocalizer$1.scanError, true, true);
    });
  }
  toggleQrReaderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        showQrReader: !this.state.showQrReader
      });
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.IsQrReaderVisible && this.props.autoClose) {
        const target = e.target;
        const outside = Utility.clickedOutside(target, this.id);
        if (outside) {
          yield this.setState({
            showQrReader: false
          });
        }
      }
    });
  }
  render() {
    var _a, _b, _c;
    return /*#__PURE__*/React.createElement("div", {
      id: this.id,
      className: this.css(styles$i.qrInputContainer, this.props.className)
    }, /*#__PURE__*/React.createElement(Button, {
      block: true,
      icon: (_a = this.props.icon) !== null && _a !== void 0 ? _a : {
        name: "fa-qrcode"
      },
      className: (_b = this.props.buttonClassName) !== null && _b !== void 0 ? _b : styles$i.qrInputButton,
      type: this.props.buttonType,
      label: !this.IsQrReaderVisible ? (_c = this.props.label) !== null && _c !== void 0 ? _c : QrInputLocalizer$1.buttonLabel : QrInputLocalizer$1.buttonClose,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.toggleQrReaderAsync();
      })
    }), this.IsQrReaderVisible && ( /*#__PURE__*/React.createElement(QrScanner, {
      onDecode: result => __awaiter(this, void 0, void 0, function* () {
        return yield this.onScanAsync(result);
      }),
      onError: error => __awaiter(this, void 0, void 0, function* () {
        return yield QrInput.onScanErrorAsync();
      })
    })));
  }
}

/**
 * {@link Timeline} items selection status
 */
var TimelineItemSelectionStatus;
(function (TimelineItemSelectionStatus) {
  /**
   * The item is not {@link Linked} or {@link Selected}
   */
  TimelineItemSelectionStatus[TimelineItemSelectionStatus["Default"] = 0] = "Default";
  /**
   * The item is linked to another, currently {@link Selected} item
   */
  TimelineItemSelectionStatus[TimelineItemSelectionStatus["Linked"] = 1] = "Linked";
  /**
   * The item is currently selected
   */
  TimelineItemSelectionStatus[TimelineItemSelectionStatus["Selected"] = 2] = "Selected";
})(TimelineItemSelectionStatus || (TimelineItemSelectionStatus = {}));

var css_248z$j = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-timeline-row-header-column-header-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-timeline-row-header-column-header-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-timeline-row-header-column-header-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-timeline-row-header-column-header-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-timeline-row-header-column-header-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-timeline-row-header-column-header-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-timeline-row-header-column-header-timelineRowHeaderColumnHeaderWrapper {\n  box-sizing: border-box;\n  border: 1px solid black;\n  border-left: none;\n  border-top: none;\n  overflow: hidden;\n}\n.athenaeum-timeline-row-header-column-header-timelineRowHeaderColumnHeaderWrapper > * {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.athenaeum-timeline-row-header-column-header-timelineRowHeaderColumnHeaderWrapper .athenaeum-timeline-row-header-column-header-defaultHeader {\n  text-align: center;\n}";
var styles$h = {"font-renta":"athenaeum-timeline-row-header-column-header-font-renta","color-schema-renta_black":"athenaeum-timeline-row-header-column-header-color-schema-renta_black","color-schema-renta_white":"athenaeum-timeline-row-header-column-header-color-schema-renta_white","color-schema-renta_orange":"athenaeum-timeline-row-header-column-header-color-schema-renta_orange","color-schema-renta_green":"athenaeum-timeline-row-header-column-header-color-schema-renta_green","color-schema-renta_blue":"athenaeum-timeline-row-header-column-header-color-schema-renta_blue","timelineRowHeaderColumnHeaderWrapper":"athenaeum-timeline-row-header-column-header-timelineRowHeaderColumnHeaderWrapper","defaultHeader":"athenaeum-timeline-row-header-column-header-defaultHeader"};
styleInject(css_248z$j);

/** @internal */
class TimelineRowHeaderColumnHeader extends React.Component {
  // Properties
  get publicProps() {
    return {
      rowHeaderColumn: this.rowHeaderColumn
    };
  }
  get rowHeaderColumn() {
    return this.rowHeaderColumnCache.rowHeaderColumn;
  }
  get rowHeaderColumnCache() {
    return this.props.rowHeaderColumnCache;
  }
  get wrapperStyle() {
    const width = this.rowHeaderColumnCache.width;
    return {
      flex: `0 0 ${width}px`
    };
  }
  // Methods
  render() {
    var _a;
    const CustomHeader = (_a = this.rowHeaderColumn.headerRenderer) !== null && _a !== void 0 ? _a : this.props.customRenderer;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$h.timelineRowHeaderColumnHeaderWrapper,
      style: this.wrapperStyle
    }, !CustomHeader ? ( /*#__PURE__*/React.createElement("div", {
      className: Utility.css(styles$h.defaultHeader, this.rowHeaderColumn.headerClassName),
      style: this.rowHeaderColumn.headerStyle
    }, this.rowHeaderColumn.headerLabel)) : ( /*#__PURE__*/React.isValidElement(CustomHeader)) ? CustomHeader : ( /*#__PURE__*/React.createElement(CustomHeader, Object.assign({}, this.publicProps))));
  }
}

var css_248z$i = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-timeline-header-timebar-increment-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-timeline-header-timebar-increment-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-timeline-header-timebar-increment-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-timeline-header-timebar-increment-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-timeline-header-timebar-increment-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-timeline-header-timebar-increment-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-timeline-header-timebar-increment-timelineHeaderTimebarIncrement {\n  display: inline-block;\n  box-sizing: border-box;\n  white-space: nowrap;\n  text-align: center;\n  border-left: 1px solid black;\n}\n.athenaeum-timeline-header-timebar-increment-timelineHeaderTimebarIncrement:first-child {\n  border-left: none;\n}";
var styles$g = {"font-renta":"athenaeum-timeline-header-timebar-increment-font-renta","color-schema-renta_black":"athenaeum-timeline-header-timebar-increment-color-schema-renta_black","color-schema-renta_white":"athenaeum-timeline-header-timebar-increment-color-schema-renta_white","color-schema-renta_orange":"athenaeum-timeline-header-timebar-increment-color-schema-renta_orange","color-schema-renta_green":"athenaeum-timeline-header-timebar-increment-color-schema-renta_green","color-schema-renta_blue":"athenaeum-timeline-header-timebar-increment-color-schema-renta_blue","timelineHeaderTimebarIncrement":"athenaeum-timeline-header-timebar-increment-timelineHeaderTimebarIncrement"};
styleInject(css_248z$i);

/** @internal */
class TimelineHeaderTimebarIncrement extends React.Component {
  // Properties
  get increment() {
    return this.props.increment;
  }
  get label() {
    var _a;
    return (_a = this.increment.cursorTimeString) !== null && _a !== void 0 ? _a : this.increment.label;
  }
  // Methods
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$g.timelineHeaderTimebarIncrement,
      style: {
        width: this.increment.width
      }
    }, this.label);
  }
}

var css_248z$h = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-timeline-header-timebar-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-timeline-header-timebar-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-timeline-header-timebar-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-timeline-header-timebar-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-timeline-header-timebar-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-timeline-header-timebar-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-timeline-header-timebar-timelineHeaderTimebar {\n  height: 30px;\n  white-space: nowrap;\n  overflow: hidden;\n}";
var styles$f = {"font-renta":"athenaeum-timeline-header-timebar-font-renta","color-schema-renta_black":"athenaeum-timeline-header-timebar-color-schema-renta_black","color-schema-renta_white":"athenaeum-timeline-header-timebar-color-schema-renta_white","color-schema-renta_orange":"athenaeum-timeline-header-timebar-color-schema-renta_orange","color-schema-renta_green":"athenaeum-timeline-header-timebar-color-schema-renta_green","color-schema-renta_blue":"athenaeum-timeline-header-timebar-color-schema-renta_blue","timelineHeaderTimebar":"athenaeum-timeline-header-timebar-timelineHeaderTimebar"};
styleInject(css_248z$h);

/** @internal */
const TimelineHeaderTimebar = props => {
  const {
    increments
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$f.timelineHeaderTimebar
  }, increments.map(increment => ( /*#__PURE__*/React.createElement(TimelineHeaderTimebarIncrement, {
    key: increment.id,
    increment: increment
  }))));
};

var css_248z$g = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-timeline-header-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-timeline-header-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-timeline-header-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-timeline-header-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-timeline-header-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-timeline-header-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-timeline-header-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-timeline-header-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-timeline-header-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-timeline-header-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-timeline-header-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-timeline-header-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-timeline-header-timeline {\n  position: relative;\n  overflow: auto;\n  box-sizing: border-box;\n  border: 1px solid lightgray;\n  border-right: none;\n  background-color: white;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.athenaeum-timeline-header-timeline .ReactVirtualized__Grid {\n  overflow-x: hidden;\n  box-sizing: border-box;\n  border-right: 1px solid lightgray;\n}\n\n.athenaeum-timeline-header-timelineHeaderWrapper {\n  display: flex;\n  height: 60px;\n}\n.athenaeum-timeline-header-timelineHeaderWrapper .athenaeum-timeline-header-timeBars {\n  box-sizing: border-box;\n  border-right: 1px solid lightgray;\n  border-bottom: 1px solid black;\n}";
var styles$e = {"font-renta":"athenaeum-timeline-header-font-renta","color-schema-renta_black":"athenaeum-timeline-header-color-schema-renta_black","color-schema-renta_white":"athenaeum-timeline-header-color-schema-renta_white","color-schema-renta_orange":"athenaeum-timeline-header-color-schema-renta_orange","color-schema-renta_green":"athenaeum-timeline-header-color-schema-renta_green","color-schema-renta_blue":"athenaeum-timeline-header-color-schema-renta_blue","timeline":"athenaeum-timeline-header-timeline","timelineHeaderWrapper":"athenaeum-timeline-header-timelineHeaderWrapper","timeBars":"athenaeum-timeline-header-timeBars"};
styleInject(css_248z$g);

/**
 * Default value of {@link ITimelineProps.headerFormats}
 */
const defaultTimelineHeaderFormats = {
  major: {
    year: {
      //2018
      short: 'YYYY',
      //2018
      long: 'YYYY'
    },
    month: {
      //Jan
      short: 'MMM',
      //January 2018
      long: 'MMMM YYYY'
    },
    day: {
      //1st
      short: 'Do',
      //Sun, July 3, 2018
      long: 'ddd, LL'
    },
    hour: {
      //13
      short: 'HH',
      //13:00
      long: 'HH:mm'
    },
    minute: {
      //01
      short: 'mm',
      //12:01
      long: 'HH:mm'
    },
    second: {
      //10
      short: 'ss',
      //01:10
      long: 'HH:mm:ss'
    },
    millisecond: {
      //001
      short: 'SSS',
      //01:10.001
      long: 'mm:ss.SSS'
    }
  },
  minor: {
    year: {
      //2018
      short: 'YYYY',
      //2018
      long: 'YYYY'
    },
    month: {
      //Jan
      short: 'MMM',
      //January
      long: 'MMMM'
    },
    day: {
      //1
      short: 'D',
      //Sun 1st
      long: 'ddd Do'
    },
    hour: {
      //13
      short: 'HH',
      //13:00
      long: 'HH:mm'
    },
    minute: {
      //01
      short: 'mm',
      //12:01
      long: 'HH:mm'
    },
    second: {
      //10
      short: 'ss',
      //01:10
      long: 'HH:mm:ss'
    },
    millisecond: {
      //001
      short: 'SSS',
      //01:10.001
      long: 'mm:ss.SSS'
    }
  }
};
/** @internal */
class TimelineHeader extends React.PureComponent {
  // Properties
  get bottomIncrements() {
    return this.getTimebarIncrements(this.cache.headerBottomResolution, "minor");
  }
  get cache() {
    return this.props.cache;
  }
  get cursorTimeString() {
    return this.props.cursorTimeString;
  }
  get timebarsStyle() {
    return {
      width: this.timebarWidth
    };
  }
  get timebarWidth() {
    return this.props.itemContainerWidth;
  }
  get topIncrements() {
    return this.getTimebarIncrements(this.cache.headerTopResolution, "major");
  }
  // Methods
  getTimebarIncrements(resolution, type) {
    var _a, _b, _c;
    const currentTime = moment(this.cache.startTime);
    const offsetResolution = resolution === 'year' || resolution === 'month' ? 'day' : resolution === 'day' ? 'hour' : resolution === 'hour' ? 'minute' : resolution;
    const timeIncrements = [];
    let availableWidth = this.timebarWidth;
    while (currentTime.valueOf() < this.cache.endTime && availableWidth > 0) {
      // first increment might be "cut" from the middle
      const incrementOffset = availableWidth === this.timebarWidth ? moment.duration(currentTime.diff(currentTime.clone().startOf(resolution))).as(offsetResolution) : 0;
      const incrementWidth = Math.min(availableWidth, this.timebarWidth, this.getTimebarIncrementWidth(currentTime, resolution, incrementOffset));
      const timeFormatLength = type === "major" && incrementWidth < TimelineHeader.majorIncrementLongLabelWidth || type === "minor" && incrementWidth < TimelineHeader.minorIncrementLongLabelWidth ? 'short' : 'long';
      const timeFormat = (_c = (_b = (_a = this.props.incrementTimeFormats) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b[resolution]) !== null && _c !== void 0 ? _c : defaultTimelineHeaderFormats[type][resolution];
      const incrementLabel = currentTime.format(timeFormat[timeFormatLength]);
      timeIncrements.push({
        id: currentTime.valueOf().toString(),
        label: incrementLabel,
        width: incrementWidth
      });
      availableWidth -= incrementWidth;
      currentTime.subtract(incrementOffset, offsetResolution).add(1, resolution);
    }
    if (type === "major" && this.cursorTimeString) {
      if (timeIncrements.length > 1 && timeIncrements[1].width > timeIncrements[0].width) {
        timeIncrements[1].cursorTimeString = this.cursorTimeString;
      } else if (timeIncrements.length > 0) {
        timeIncrements[0].cursorTimeString = this.cursorTimeString;
      }
    }
    return timeIncrements;
  }
  getTimebarIncrementWidth(currentTime, resolution, incrementOffset = 0) {
    const pixelsPerMillisecond = this.props.itemContainerPixelsPerMillisecond;
    switch (resolution) {
      case 'year':
        return pixelsPerMillisecond * 1000 * 60 * 60 * 24 * ((currentTime.isLeapYear() ? 366 : 365) - incrementOffset);
      case 'month':
        return pixelsPerMillisecond * 1000 * 60 * 60 * 24 * (currentTime.daysInMonth() - incrementOffset);
      case 'day':
        return pixelsPerMillisecond * 1000 * 60 * 60 * (24 - incrementOffset);
      case 'hour':
        return pixelsPerMillisecond * 1000 * 60 * (60 - incrementOffset);
      case 'minute':
        return pixelsPerMillisecond * 1000 * 60 - incrementOffset;
      case 'second':
        return pixelsPerMillisecond * 1000 - incrementOffset;
      case 'millisecond':
        return pixelsPerMillisecond - incrementOffset;
      default:
        throw new TypeError(`Unsupported resolution '${resolution}'`);
    }
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$e.timelineHeaderWrapper
    }, this.cache.rowHeaderColumnsCache.rowHeaderColumnCachesByIndex.map(rowHeaderColumnCache => /*#__PURE__*/React.createElement(TimelineRowHeaderColumnHeader, {
      key: rowHeaderColumnCache.rowHeaderColumn.headerLabel,
      rowHeaderColumnCache: rowHeaderColumnCache,
      customRenderer: this.props.rowHeaderColumnHeaderRenderer
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$e.timeBars,
      style: this.timebarsStyle
    }, /*#__PURE__*/React.createElement(TimelineHeaderTimebar, {
      increments: this.topIncrements
    }), /*#__PURE__*/React.createElement(TimelineHeaderTimebar, {
      increments: this.bottomIncrements
    })));
  }
}
// Fields
// Pixels
TimelineHeader.majorIncrementLongLabelWidth = 120;
// Pixels
TimelineHeader.minorIncrementLongLabelWidth = 80;

/** @internal */
class TimelineBody extends React.Component {
  // Methods
  componentDidMount() {
    this.forceUpdate();
  }
  shouldComponentUpdate(nextProps) {
    // This method is the source of the Timelines good performance
    const currentProps = this.props;
    // shallow update check
    return currentProps.gridId !== nextProps.gridId || currentProps.gridWidth !== nextProps.gridWidth || currentProps.gridHeight !== nextProps.gridHeight || currentProps.gridColumnCount !== nextProps.gridColumnCount || currentProps.gridRowCount !== nextProps.gridRowCount;
  }
  render() {
    return /*#__PURE__*/React.createElement(Grid$1, {
      autoContainerWidth: true,
      id: this.props.gridId,
      ref: this.props.gridRefCallback,
      width: this.props.gridWidth,
      height: this.props.gridHeight,
      columnCount: this.props.gridColumnCount,
      rowCount: this.props.gridRowCount,
      columnWidth: columnIndex => this.props.getGridColumnWidth(columnIndex.index),
      rowHeight: rowIndex => this.props.getGridRowHeight(rowIndex.index),
      cellRenderer: this.props.gridCellRenderer
    });
  }
}

var css_248z$f = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-timeline-marker-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-timeline-marker-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-timeline-marker-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-timeline-marker-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-timeline-marker-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-timeline-marker-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-timeline-marker-timelineMarker {\n  position: absolute;\n  top: 0;\n  width: 3px;\n  height: 100%;\n  z-index: 2;\n  background: limegreen;\n  pointer-events: none;\n}";
var styles$d = {"font-renta":"athenaeum-timeline-marker-font-renta","color-schema-renta_black":"athenaeum-timeline-marker-color-schema-renta_black","color-schema-renta_white":"athenaeum-timeline-marker-color-schema-renta_white","color-schema-renta_orange":"athenaeum-timeline-marker-color-schema-renta_orange","color-schema-renta_green":"athenaeum-timeline-marker-color-schema-renta_green","color-schema-renta_blue":"athenaeum-timeline-marker-color-schema-renta_blue","timelineMarker":"athenaeum-timeline-marker-timelineMarker"};
styleInject(css_248z$f);

/** @internal */
class TimelineMarker extends React.Component {
  // Properties
  get marker() {
    return this.props.marker;
  }
  get style() {
    return Object.assign(Object.assign({}, this.marker.style), {
      // -1 to exactly center the marker on its time
      left: this.props.leftX - 1
    });
  }
  // Methods
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: Utility.css(styles$d.timelineMarker, this.marker.className),
      style: this.style
    });
  }
}

var css_248z$e = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-timeline-item-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-timeline-item-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-timeline-item-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-timeline-item-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-timeline-item-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-timeline-item-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-timeline-item-timelineItemWrapper {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  padding: 3px;\n  z-index: 3;\n  background-color: transparent;\n}\n.athenaeum-timeline-item-timelineItemWrapper.athenaeum-timeline-item-dragged {\n  z-index: 4;\n}\n.athenaeum-timeline-item-timelineItemWrapper.athenaeum-timeline-item-resized {\n  z-index: 4;\n}\n.athenaeum-timeline-item-timelineItemWrapper > * {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  border: 1px solid black;\n}\n.athenaeum-timeline-item-timelineItemWrapper .athenaeum-timeline-item-defaultItem {\n  padding-left: 3px;\n  background-color: white;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-timeline-item-timelineItemWrapper .athenaeum-timeline-item-defaultItem.athenaeum-timeline-item-linked {\n  background-color: rgb(254, 198, 172);\n}\n.athenaeum-timeline-item-timelineItemWrapper .athenaeum-timeline-item-defaultItem.athenaeum-timeline-item-selected {\n  background-color: rgb(254, 80, 0);\n}";
var itemStyles = {"font-renta":"athenaeum-timeline-item-font-renta","color-schema-renta_black":"athenaeum-timeline-item-color-schema-renta_black","color-schema-renta_white":"athenaeum-timeline-item-color-schema-renta_white","color-schema-renta_orange":"athenaeum-timeline-item-color-schema-renta_orange","color-schema-renta_green":"athenaeum-timeline-item-color-schema-renta_green","color-schema-renta_blue":"athenaeum-timeline-item-color-schema-renta_blue","timelineItemWrapper":"athenaeum-timeline-item-timelineItemWrapper","dragged":"athenaeum-timeline-item-dragged","resized":"athenaeum-timeline-item-resized","defaultItem":"athenaeum-timeline-item-defaultItem","linked":"athenaeum-timeline-item-linked","selected":"athenaeum-timeline-item-selected"};
styleInject(css_248z$e);

/** @internal */
class TimelineItem extends React.Component {
  // Properties
  get defaultItemClassName() {
    return Utility.css(itemStyles.defaultItem, this.item.className, this.selectionStatus === TimelineItemSelectionStatus.Linked && itemStyles.linked, this.selectionStatus === TimelineItemSelectionStatus.Selected && itemStyles.selected);
  }
  get item() {
    return this.itemCache.item;
  }
  get itemCache() {
    return this.rowItemCache.itemCache;
  }
  get rowCache() {
    return this.rowItemCache.rowCache;
  }
  get rowItemCache() {
    return this.props.rowItemCache;
  }
  get publicProps() {
    return {
      item: this.item,
      row: this.row,
      selectionStatus: this.selectionStatus,
      pixelsPerMillisecond: this.props.pixelsPerMillisecond,
      millisecondsFromStart: this.itemCache.millisecondsFromStart,
      defaultClassItemName: this.defaultItemClassName
    };
  }
  get selectionStatus() {
    return this.rowItemCache.selectionStatus;
  }
  get row() {
    return this.rowCache.row;
  }
  get wrapperClassName() {
    return Utility.css(itemStyles.timelineItemWrapper, this.selectionStatus === TimelineItemSelectionStatus.Linked && TimelineItem.wrapperLinkedClass, this.selectionStatus === TimelineItemSelectionStatus.Selected && TimelineItem.wrapperSelectedClass);
  }
  get wrapperStyle() {
    const pixelsPerMillisecond = this.props.pixelsPerMillisecond;
    const left = Math.round(this.itemCache.millisecondsFromStart * pixelsPerMillisecond);
    const width = Math.round(this.itemCache.durationMilliseconds * pixelsPerMillisecond);
    return {
      left,
      width,
      top: this.rowItemCache.top,
      height: this.itemCache.height
    };
  }
  get itemContentStyle() {
    const pixelsPerMillisecond = this.props.pixelsPerMillisecond;
    const left = Math.round(this.itemCache.millisecondsFromStart * pixelsPerMillisecond);
    return {
      // If item start is not visible (is in the past), move content right to the start of visible timeline.
      paddingLeft: left < 0 ? -left : 0
    };
  }
  // Methods
  render() {
    var _a;
    const CustomItem = (_a = this.item.customRenderer) !== null && _a !== void 0 ? _a : this.props.customRenderer;
    const CustomTooltip = this.props.itemTooltipRenderer;
    const renderTooltip = props => ( /*#__PURE__*/React.createElement(Tooltip$1, Object.assign({
      id: "timeline-item-tooltip"
    }, props), CustomTooltip ? ( /*#__PURE__*/React.isValidElement(CustomTooltip)) ? CustomTooltip : ( /*#__PURE__*/React.createElement(CustomTooltip, {
      item: this.item
    })) : ( /*#__PURE__*/React.createElement("span", null, this.item.text))));
    return /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "auto",
      delay: {
        show: 250,
        hide: 200
      },
      overlay: renderTooltip
    }, /*#__PURE__*/React.createElement("div", {
      id: `timeline-item-${this.item.id.replace(/\s/g, '')}-${this.row.id.replace(/\s/g, '')}`,
      "data-item-id": this.item.id,
      "data-item-row-id": this.row.id,
      className: this.wrapperClassName,
      style: this.wrapperStyle,
      onClick: this.props.onClick.bind(this, this.row, this.item),
      onDoubleClick: this.props.onDoubleClick.bind(this, this.row, this.item),
      onContextMenu: this.props.onContextMenu.bind(this, this.row, this.item),
      onMouseEnter: this.props.onMouseEnter.bind(this, this.row, this.item),
      onMouseLeave: this.props.onMouseLeave.bind(this, this.row, this.item)
    }, !CustomItem ? ( /*#__PURE__*/React.createElement("div", {
      className: this.defaultItemClassName,
      style: this.item.style
    }, /*#__PURE__*/React.createElement("span", {
      style: this.itemContentStyle
    }, this.item.text))) : ( /*#__PURE__*/React.isValidElement(CustomItem)) ? CustomItem : ( /*#__PURE__*/React.createElement(CustomItem, Object.assign({}, this.publicProps)))));
  }
}
// Fields
TimelineItem.wrapperLinkedClass = Utility.getComponentId();
TimelineItem.wrapperSelectedClass = Utility.getComponentId();

var css_248z$d = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-timeline-row-header-column-cell-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-timeline-row-header-column-cell-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-timeline-row-header-column-cell-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-timeline-row-header-column-cell-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-timeline-row-header-column-cell-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-timeline-row-header-column-cell-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-timeline-row-header-column-cell-timelineRowHeaderColumnCellWrapper {\n  box-sizing: border-box;\n  border: 1px solid black;\n  border-left: none;\n  border-top: none;\n  z-index: 6;\n}\n.athenaeum-timeline-row-header-column-cell-timelineRowHeaderColumnCellWrapper.athenaeum-timeline-row-header-column-cell-last {\n  border-bottom: none;\n}\n.athenaeum-timeline-row-header-column-cell-timelineRowHeaderColumnCellWrapper > * {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.athenaeum-timeline-row-header-column-cell-timelineRowHeaderColumnCellWrapper .athenaeum-timeline-row-header-column-cell-defaultCell {\n  text-align: center;\n  background-color: white;\n}";
var styles$c = {"font-renta":"athenaeum-timeline-row-header-column-cell-font-renta","color-schema-renta_black":"athenaeum-timeline-row-header-column-cell-color-schema-renta_black","color-schema-renta_white":"athenaeum-timeline-row-header-column-cell-color-schema-renta_white","color-schema-renta_orange":"athenaeum-timeline-row-header-column-cell-color-schema-renta_orange","color-schema-renta_green":"athenaeum-timeline-row-header-column-cell-color-schema-renta_green","color-schema-renta_blue":"athenaeum-timeline-row-header-column-cell-color-schema-renta_blue","timelineRowHeaderColumnCellWrapper":"athenaeum-timeline-row-header-column-cell-timelineRowHeaderColumnCellWrapper","last":"athenaeum-timeline-row-header-column-cell-last","defaultCell":"athenaeum-timeline-row-header-column-cell-defaultCell"};
styleInject(css_248z$d);

/** @internal */
class TimelineRowHeaderColumnCell extends React.Component {
  // Properties
  get label() {
    const labelProperty = this.rowHeaderColumn.cellLabelProperty;
    if (labelProperty) {
      return this.row[labelProperty];
    }
    return undefined;
  }
  get publicProps() {
    return {
      row: this.row,
      rowHeaderColumn: this.rowHeaderColumn
    };
  }
  get row() {
    return this.rowCache.row;
  }
  get rowCache() {
    return this.props.rowCache;
  }
  get rowHeaderColumn() {
    return this.rowHeaderColumnCache.rowHeaderColumn;
  }
  get rowHeaderColumnCache() {
    return this.props.rowHeaderColumnCache;
  }
  get wrapperStyle() {
    return this.props.wrapperStyle;
  }
  // Methods
  render() {
    var _a;
    const CustomCell = (_a = this.rowHeaderColumn.cellRenderer) !== null && _a !== void 0 ? _a : this.props.customRenderer;
    return /*#__PURE__*/React.createElement("div", {
      className: Utility.css(styles$c.timelineRowHeaderColumnCellWrapper, this.props.isLastRow && styles$c.last),
      style: this.wrapperStyle
    }, !CustomCell ? ( /*#__PURE__*/React.createElement("div", {
      className: Utility.css(styles$c.defaultCell, this.rowHeaderColumn.cellClassName),
      style: this.rowHeaderColumn.cellStyle
    }, this.label)) : ( /*#__PURE__*/React.isValidElement(CustomCell)) ? CustomCell : ( /*#__PURE__*/React.createElement(CustomCell, Object.assign({}, this.publicProps))));
  }
}

var css_248z$c = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-timeline-row-stripe-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-timeline-row-stripe-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-timeline-row-stripe-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-timeline-row-stripe-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-timeline-row-stripe-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-timeline-row-stripe-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-timeline-row-stripe-timelineRowStripe {\n  position: absolute;\n  pointer-events: none;\n  z-index: 1;\n}";
var styles$b = {"font-renta":"athenaeum-timeline-row-stripe-font-renta","color-schema-renta_black":"athenaeum-timeline-row-stripe-color-schema-renta_black","color-schema-renta_white":"athenaeum-timeline-row-stripe-color-schema-renta_white","color-schema-renta_orange":"athenaeum-timeline-row-stripe-color-schema-renta_orange","color-schema-renta_green":"athenaeum-timeline-row-stripe-color-schema-renta_green","color-schema-renta_blue":"athenaeum-timeline-row-stripe-color-schema-renta_blue","timelineRowStripe":"athenaeum-timeline-row-stripe-timelineRowStripe"};
styleInject(css_248z$c);

/** @internal */
class TimelineRowStripe extends React.Component {
  // Properties
  get rowStripe() {
    return this.rowStripeCache.rowStripe;
  }
  get rowStripeCache() {
    return this.props.rowStripeCache;
  }
  get style() {
    const pixelsPerMillisecond = this.props.pixelsPerMillisecond;
    const left = Math.round(this.rowStripeCache.millisecondsFromStart * pixelsPerMillisecond);
    const width = Math.round(this.rowStripeCache.durationMilliseconds * pixelsPerMillisecond);
    return Object.assign(Object.assign({}, this.rowStripe.style), {
      width,
      height: this.props.height,
      left
    });
  }
  // Methods
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: Utility.css(styles$b.timelineRowStripe, this.rowStripe.className),
      style: this.style
    });
  }
}

var css_248z$b = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-timeline-row-items-column-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-timeline-row-items-column-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-timeline-row-items-column-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-timeline-row-items-column-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-timeline-row-items-column-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-timeline-row-items-column-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-timeline-row-items-column-timelineRowItemColumn {\n  box-sizing: border-box;\n  border-bottom: 1px solid black;\n}\n.athenaeum-timeline-row-items-column-timelineRowItemColumn:last-child {\n  border-bottom: none;\n}";
var styles$a = {"font-renta":"athenaeum-timeline-row-items-column-font-renta","color-schema-renta_black":"athenaeum-timeline-row-items-column-color-schema-renta_black","color-schema-renta_white":"athenaeum-timeline-row-items-column-color-schema-renta_white","color-schema-renta_orange":"athenaeum-timeline-row-items-column-color-schema-renta_orange","color-schema-renta_green":"athenaeum-timeline-row-items-column-color-schema-renta_green","color-schema-renta_blue":"athenaeum-timeline-row-items-column-color-schema-renta_blue","timelineRowItemColumn":"athenaeum-timeline-row-items-column-timelineRowItemColumn"};
styleInject(css_248z$b);

/** @internal */
class TimelineRowItemsColumn extends React.PureComponent {
  // Properties
  get pixelsPerMillisecond() {
    return this.props.pixelsPerMillisecond;
  }
  get row() {
    return this.rowCache.row;
  }
  get rowCache() {
    return this.props.rowCache;
  }
  // Methods
  render() {
    return /*#__PURE__*/React.createElement("div", {
      "data-row-id": this.row.id,
      className: styles$a.timelineRowItemColumn,
      style: this.props.wrapperStyle,
      onClick: this.props.onRowClick.bind(this, this.row),
      onDoubleClick: this.props.onRowDoubleClick.bind(this, this.row),
      onContextMenu: this.props.onRowContextMenu.bind(this, this.row),
      onMouseEnter: this.props.onRowMouseEnter.bind(this, this.row),
      onMouseLeave: this.props.onRowMouseLeave.bind(this, this.row),
      onMouseDown: this.props.onRowMouseDown,
      onMouseMove: this.props.onRowMouseMove
    }, this.rowCache.rowItemCachesByIndex.map(rowItemCache => {
      return /*#__PURE__*/React.createElement(TimelineItem, {
        key: rowItemCache.itemCache.item.id,
        rowItemCache: rowItemCache,
        pixelsPerMillisecond: this.pixelsPerMillisecond,
        customRenderer: this.props.itemRenderer,
        itemTooltipRenderer: this.props.itemTooltipRenderer,
        onClick: this.props.onItemClick,
        onDoubleClick: this.props.onItemDoubleClick,
        onContextMenu: this.props.onItemContextMenu,
        onMouseEnter: this.props.onItemMouseEnter,
        onMouseLeave: this.props.onItemMouseLeave
      });
    }), this.rowCache.rowStripeCaches.map(rowStripeCache => {
      // -1 for border
      const height = this.props.isLastRow ? this.rowCache.height : this.rowCache.height - 1;
      return /*#__PURE__*/React.createElement(TimelineRowStripe, {
        key: rowStripeCache.rowStripe.start.valueOf(),
        pixelsPerMillisecond: this.pixelsPerMillisecond,
        height: height,
        rowStripeCache: rowStripeCache
      });
    }));
  }
}

/**
 * Immutable cache created from an {@link ITimelineRowHeaderColumn}
 *
 * @internal
 */
class TimelineRowHeaderColumnCache {
  // Constructor
  /**
   * @throws {@link defaultWidth} is less than one (1)
   * @throws {@link rowHeaderColumn}s {@link ITimelineRowHeaderColumn.width} is defined and is less than one (1)
   */
  constructor(rowHeaderColumn, defaultWidth) {
    if (defaultWidth < 1) {
      throw new Error(`Default width '${defaultWidth}' cannot be less than one (1)`);
    }
    if (typeof rowHeaderColumn.width === "number" && rowHeaderColumn.width < 1) {
      throw new Error(`Row header column width '${rowHeaderColumn.width}' cannot be less than one (1)`);
    }
    this.rowHeaderColumn = rowHeaderColumn;
    this.width = typeof rowHeaderColumn.width === "number" ? rowHeaderColumn.width : defaultWidth;
    Object.freeze(this);
  }
}

/**
 * Immutable cache created from {@link ITimelineRowHeaderColumn}s
 *
 * @internal
 */
class TimelineRowHeaderColumnsCache {
  // Constructor
  /**
   * @throws {@link defaultWidth} is less than one (1)
   */
  constructor(defaultWidth, rowHeaderColumns) {
    if (defaultWidth < 1) {
      throw new Error(`Default width '${defaultWidth}' cannot be less than one (1)`);
    }
    const rowHeaderColumnsByIndex = [];
    let rowHeaderColumnsTotalWidth = 0;
    rowHeaderColumns === null || rowHeaderColumns === void 0 ? void 0 : rowHeaderColumns.forEach(rowHeaderColumn => {
      const rowHeaderColumnCache = new TimelineRowHeaderColumnCache(rowHeaderColumn, defaultWidth);
      rowHeaderColumnsByIndex.push(rowHeaderColumnCache);
      rowHeaderColumnsTotalWidth += rowHeaderColumnCache.width;
    });
    this.rowHeaderColumnCachesByIndex = Object.freeze(rowHeaderColumnsByIndex);
    this.totalWidth = rowHeaderColumnsTotalWidth;
    Object.freeze(this);
  }
}

/**
 * Immutable cache created from an {@link ITimelineRowStripe}
 *
 * @internal
 */
class TimelineRowStripeCache {
  // Constructor
  constructor(rowStripe, startTime) {
    if (!Number.isInteger(rowStripe.start.valueOf())) {
      throw new Error(`Invalid row stripe start time '${rowStripe.start}'`);
    }
    if (!Number.isInteger(rowStripe.end.valueOf())) {
      throw new Error(`Invalid row stripe end time '${rowStripe.end}'`);
    }
    this.rowStripe = rowStripe;
    this.durationMilliseconds = rowStripe.end.valueOf() - rowStripe.start.valueOf();
    this.millisecondsFromStart = rowStripe.start.valueOf() - startTime;
    Object.freeze(this);
  }
}

/**
 * (Eventually) immutable cache created from an {@link ITimelineRow}
 *
 * @internal
 */
class TimelineRowCache {
  // Constructor
  constructor(row, rowStripeCaches, index) {
    if (index < 0) {
      throw new Error(`Index '${index}' cannot be negative`);
    }
    this.index = index;
    this.row = row;
    this.rowStripeCaches = rowStripeCaches;
    // set later
    this.height = 0;
    this.rowItemCachesByIndex = [];
  }
  finalize(itemHeight) {
    if (itemHeight < 1) {
      throw new Error(`Item height '${itemHeight}' cannot be less than one (1)`);
    }
    const orderedRowItemCaches = _.sortBy(this.rowItemCachesByIndex, rowItemCache => -rowItemCache.itemCache.item.start.valueOf());
    let maxOverlappingRowItems = 0;
    while (orderedRowItemCaches.length > 0) {
      let lastRowItemEndTime = null;
      for (let lastRowItemIndex = orderedRowItemCaches.length - 1; lastRowItemIndex >= 0; lastRowItemIndex--) {
        const lastRowItemCache = orderedRowItemCaches[lastRowItemIndex];
        const lastRowItem = lastRowItemCache.itemCache.item;
        lastRowItemCache.top = itemHeight * maxOverlappingRowItems;
        if (!lastRowItemEndTime || lastRowItem.start >= lastRowItemEndTime) {
          lastRowItemEndTime = lastRowItem.end;
          orderedRowItemCaches.splice(lastRowItemIndex, 1);
        }
      }
      maxOverlappingRowItems++;
    }
    // @ts-expect-error - ignore readonly during creation
    this["height"] = Math.max(maxOverlappingRowItems, 1) * itemHeight;
    Object.freeze(this);
  }
}

/**
 * Immutable cache created from {@link ITimelineRow}s and {@link ITimelineItem}s
 *
 * @internal
 */
class TimelineRowsItemsCache {
  // Constructor
  constructor(startTime, endTime, headerBottomResolution, rows, items, selectedItemsIds, itemHeight) {
    // Rows
    const defaultRowStripeCaches = TimelineRowsItemsCache.createDefaultRowStripeCaches(startTime, endTime, headerBottomResolution);
    const rowCachesById = {};
    const rowCachesByIndex = [];
    rows.forEach((row, rowIndex) => {
      const rowId = row.id;
      if (rowCachesById[rowId]) {
        throw new Error(`Duplicate row id '${rowId}'`);
      }
      if (rowCachesByIndex[rowIndex]) {
        throw new Error(`Duplicate assignment to row index '${rowIndex}'`);
      }
      const rowStripeCaches = Array.isArray(row.stripes) ? row.stripes.map(rowStripe => new TimelineRowStripeCache(rowStripe, startTime)) : defaultRowStripeCaches;
      const cacheRow = new TimelineRowCache(row, rowStripeCaches, rowIndex);
      rowCachesById[rowId] = cacheRow;
      rowCachesByIndex[rowIndex] = cacheRow;
    });
    // Items
    const itemCachesById = {};
    const itemCachesByIndex = [];
    const selectedItemCachesById = {};
    const selectedItemCachesByIndex = [];
    items.forEach((item, itemIndex) => {
      const itemId = item.id;
      if (!Number.isInteger(item.start.valueOf())) {
        throw new Error(`Invalid start time '${item.start}' on item id '${itemId}'`);
      }
      if (!Number.isInteger(item.end.valueOf())) {
        throw new Error(`Invalid end time '${item.end}' on item id '${itemId}'`);
      }
      if (item.end < item.start) {
        throw new Error(`Item id '${itemId}' start time '${item.start.toISOString()}' is after end time '${item.end.toISOString()}'`);
      }
      if (item.end.valueOf() < startTime || item.start.valueOf() > endTime) {
        // static start/end, the item is not visible
        return;
      }
      if (itemCachesById[itemId]) {
        throw new Error(`Duplicate item id '${itemId}'`);
      }
      if (itemCachesByIndex[itemIndex]) {
        throw new Error(`Duplicate assignment to item index '${itemIndex}'`);
      }
      const rowItemCachesByIndex = [];
      const rowItemCachesByRowId = {};
      const itemCache = {
        item,
        millisecondsFromStart: item.start.valueOf() - startTime,
        durationMilliseconds: item.end.valueOf() - item.start.valueOf(),
        height: itemHeight,
        // set later
        rowItemCachesByIndex,
        rowItemCachesByRowId,
        selectionStatus: TimelineItemSelectionStatus.Default
      };
      itemCachesById[itemId] = itemCache;
      itemCachesByIndex[itemIndex] = itemCache;
      item.rowIds.forEach(rowId => {
        const rowCache = rowCachesById[rowId];
        if (!rowCache) {
          throw new Error(`No row with id '${rowId}'`);
        }
        const rowItemCache = {
          itemCache,
          rowCache,
          // set later
          top: 0,
          selectionStatus: TimelineItemSelectionStatus.Default
        };
        rowItemCachesByIndex.push(rowItemCache);
        rowItemCachesByRowId[rowId] = rowItemCache;
        rowCachesById[rowId].rowItemCachesByIndex
        // @ts-expect-error - ignore readonly during creation
        .push(rowItemCache);
      });
      Object.freeze(rowItemCachesByIndex);
      Object.freeze(rowItemCachesByRowId);
    });
    // RowItems
    let rowsTotalHeight = 0;
    rowCachesByIndex.forEach(rowCache => {
      rowCache.finalize(itemHeight);
      rowsTotalHeight += rowCache.height;
    });
    selectedItemsIds.forEach(selectedItemIds => {
      const itemId = selectedItemIds.itemId;
      if (selectedItemCachesById[itemId]) {
        throw new Error(`Duplicate selected item id '${itemId}'`);
      }
      const itemCache = itemCachesById[itemId];
      if (!itemCache) {
        throw new Error(`Item id '${itemId}' does not exist`);
      }
      itemCache.selectionStatus = TimelineItemSelectionStatus.Selected;
      selectedItemIds.rowIds.forEach(rowId => {
        const rowItemCache = itemCache.rowItemCachesByRowId[rowId];
        if (!rowItemCache) {
          throw new Error(`Item id '${itemId}' is not on selected row id '${rowId}'`);
        }
        rowItemCache.selectionStatus = TimelineItemSelectionStatus.Selected;
      });
      itemCache.rowItemCachesByIndex.forEach(rowItemCache => {
        if (rowItemCache.selectionStatus !== TimelineItemSelectionStatus.Selected) {
          rowItemCache.selectionStatus = TimelineItemSelectionStatus.Linked;
        }
      });
      selectedItemCachesById[itemId] = itemCache;
      selectedItemCachesByIndex.push(itemCache);
    });
    // Finalization
    this.rowsTotalHeight = rowsTotalHeight;
    this.rowCachesById = Object.freeze(rowCachesById);
    this.rowCachesByIndex = Object.freeze(rowCachesByIndex);
    this.selectedItemCachesById = Object.freeze(selectedItemCachesById);
    this.selectedItemCachesByIndex = Object.freeze(selectedItemCachesByIndex);
    Object.freeze(this);
  }
  // Methods
  static createDefaultRowStripeCaches(startTime, endTime, headerBottomResolution) {
    const rowStripeCaches = [];
    const currentTime = moment(startTime);
    const lightColor = "white";
    const mediumColor = "whitesmoke";
    const darkColor = "gainsboro";
    const workingDayStripes = headerBottomResolution === "day" && moment(endTime).diff(currentTime, "weeks") <= 4;
    const weekendStripes = headerBottomResolution === "month" && moment(endTime).diff(currentTime, "months") <= 4;
    const stripeDurationResolution = weekendStripes ? "day" : headerBottomResolution;
    let tick = true;
    while (currentTime.valueOf() <= endTime) {
      const stripeStart = currentTime.clone();
      // first stripe might be "cut" from the middle
      if (currentTime.valueOf() === startTime) {
        currentTime.startOf(stripeDurationResolution);
      }
      let stripeDuration;
      let backgroundColor;
      if (workingDayStripes || weekendStripes) {
        // 1 -> 7
        // Mon -> Sun
        const dayOfWeek = currentTime.isoWeekday();
        const isSaturday = dayOfWeek === 6;
        const isWeekend = isSaturday || dayOfWeek === 7;
        stripeDuration = isSaturday ? 2 : workingDayStripes ? 1 : 6 - dayOfWeek;
        backgroundColor = isWeekend ? darkColor : workingDayStripes && dayOfWeek % 2 === 0 ? mediumColor : lightColor;
      } else {
        stripeDuration = 1;
        backgroundColor = tick ? lightColor : darkColor;
        tick = !tick;
      }
      currentTime.add(stripeDuration, stripeDurationResolution);
      const stripeEnd = currentTime.toDate();
      const rowStripe = {
        start: stripeStart.toDate(),
        end: stripeEnd,
        style: {
          backgroundColor
        }
      };
      const rowStripeCache = new TimelineRowStripeCache(rowStripe, startTime);
      rowStripeCaches.push(rowStripeCache);
    }
    return Object.freeze(rowStripeCaches);
  }
}

/**
 * Immutable {@link Timeline} cache
 *
 * @internal
 */
class TimelineCache {
  // Constructor
  constructor(props) {
    var _a, _b, _c, _d, _e, _f;
    const {
      startTime,
      endTime
    } = TimelineCache.getStartEndTimes(props.items, props.startTime, props.endTime);
    const durationMilliseconds = endTime - startTime;
    const snapMilliseconds = ((_a = props.snapSeconds) !== null && _a !== void 0 ? _a : Timeline.defaultSnapSeconds) * 1000;
    const headerTopResolution = (_b = props.headerTopResolution) !== null && _b !== void 0 ? _b : TimelineCache.getHeaderResolution("top", durationMilliseconds);
    const headerBottomResolution = (_c = props.headerBottomResolution) !== null && _c !== void 0 ? _c : TimelineCache.getHeaderResolution("bottom", durationMilliseconds);
    const rowHeaderColumnWidth = (_d = props.rowHeaderColumnWidth) !== null && _d !== void 0 ? _d : Timeline.defaultRowHeaderColumnWidth;
    const rowHeaderColumnsCache = new TimelineRowHeaderColumnsCache(rowHeaderColumnWidth, props.rowHeaderColumns);
    const itemHeight = (_e = props.itemHeight) !== null && _e !== void 0 ? _e : Timeline.defaultItemHeight;
    const selectedItemsIds = props.canSelect ? (_f = props.selectedItemsIds) !== null && _f !== void 0 ? _f : [] : [];
    const rowsItemsCache = new TimelineRowsItemsCache(startTime, endTime, headerBottomResolution, props.rows, props.items, selectedItemsIds, itemHeight);
    // Finalization
    this.startTime = startTime;
    this.endTime = endTime;
    this.durationMilliseconds = durationMilliseconds;
    this.snapMilliseconds = snapMilliseconds;
    this.headerTopResolution = headerTopResolution;
    this.headerBottomResolution = headerBottomResolution;
    this.rowHeaderColumnsCache = rowHeaderColumnsCache;
    this.rowsItemsCache = rowsItemsCache;
    Object.freeze(this);
  }
  // Methods
  /**
   * Calculates and returns resolution for header (top or bottom).
   * Top header is one step higher than bottom: year / month, day / hour, etc.
   */
  static getHeaderResolution(type, durationMilliseconds) {
    /// <= 1s
    if (durationMilliseconds <= 1000) {
      return type === "top" ? "second" : "millisecond";
    }
    // <= 2m
    if (durationMilliseconds <= 1000 * 60 * 2) {
      return type === "top" ? "minute" : "second";
    }
    // <= 2h
    if (durationMilliseconds <= 1000 * 60 * 60 * 2) {
      return type === "top" ? "hour" : "minute";
    }
    // <= 3d
    if (durationMilliseconds <= 1000 * 60 * 60 * 24 * 3) {
      return type === "top" ? "day" : "hour";
    }
    // <= 31d (When transitioning from daylight saving time to normal time, the month is one hour longer)
    const fullMonthMilliseconds = 1000 * 60 * 60 * 24 * 31;
    const isTransitionToNormalTime = durationMilliseconds === fullMonthMilliseconds + 1000 * 60 * 60;
    if (durationMilliseconds <= fullMonthMilliseconds || isTransitionToNormalTime) {
      return type === "top" ? "month" : "day";
    }
    if (type === "top") {
      return "year";
    }
    return durationMilliseconds <= 1000 * 60 * 60 * 24 * 365 * 2 ? "month" // <= 2y
    : "year"; // > 2y
  }
  static getStartEndTimes(items, propStartTime, propEndTime) {
    if (propStartTime && !Number.isInteger(propStartTime.valueOf())) {
      throw new Error("Invalid start time");
    }
    if (propEndTime && !Number.isInteger(propEndTime.valueOf())) {
      throw new Error("Invalid end time");
    }
    let startTime;
    let endTime;
    if (propStartTime && propEndTime) {
      if (propStartTime >= propEndTime) {
        throw new Error("Start time cannot be same or after end time");
      }
      startTime = propStartTime.valueOf();
      endTime = propEndTime.valueOf();
    } else if (items.length <= 0) {
      throw new Error("Cannot determine start and end times: prop start and end times are undefined, and no items to get start/end time dynamically from");
    } else {
      if (propStartTime) {
        startTime = propStartTime.valueOf();
      }
      if (propEndTime) {
        endTime = propEndTime.valueOf();
      }
      items.forEach(item => {
        if (!Number.isInteger(item.start.valueOf())) {
          throw new Error(`Invalid start time on item id '${item.id}'`);
        }
        if (!Number.isInteger(item.end.valueOf())) {
          throw new Error(`Invalid end time on item id '${item.id}'`);
        }
        if (!propStartTime && (!startTime || item.start.valueOf() < startTime)) {
          startTime = moment(item.start.valueOf()).startOf('day').valueOf();
        }
        if (!propEndTime && (!endTime || item.end.valueOf() > endTime)) {
          endTime = moment(item.end.valueOf()).endOf('day').valueOf();
        }
      });
    }
    return Object.freeze({
      startTime: startTime,
      endTime: endTime
    });
  }
}

var css_248z$a = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-timeline-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-timeline-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-timeline-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-timeline-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-timeline-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-timeline-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-timeline-timeline {\n  position: relative;\n  overflow: auto;\n  box-sizing: border-box;\n  border: 1px solid lightgray;\n  border-right: none;\n  background-color: white;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.athenaeum-timeline-timeline .ReactVirtualized__Grid {\n  overflow-x: hidden;\n  box-sizing: border-box;\n  border-right: 1px solid lightgray;\n}";
var styles$9 = {"font-renta":"athenaeum-timeline-font-renta","color-schema-renta_black":"athenaeum-timeline-color-schema-renta_black","color-schema-renta_white":"athenaeum-timeline-color-schema-renta_white","color-schema-renta_orange":"athenaeum-timeline-color-schema-renta_orange","color-schema-renta_green":"athenaeum-timeline-color-schema-renta_green","color-schema-renta_blue":"athenaeum-timeline-color-schema-renta_blue","timeline":"athenaeum-timeline-timeline"};
styleInject(css_248z$a);

/**
 * Timeline component
 */
class Timeline extends React.Component {
  constructor() {
    // Fields
    super(...arguments);
    this._componentId = `Timeline${ch.getComponentId()}`;
    this._gridId = `${this._componentId}_grid`;
    this._utcOffsetMilliseconds = new Date().getTimezoneOffset() * 60 * 1000;
    this._preventRowItemEvents = false;
    // Methods
    this.timelineContainerRefCallback = container => {
      this._timelineContainerElement = container;
    };
    this.gridContainerCallback = element => {
      this._gridContainer = element;
    };
    this.gridRefCallback = instance => {
      this._grid = instance;
    };
    /**
     * Event handler for {@link onMouseMoveAsync}. Only calls back if a new snap time is reached
     */
    this.onThrottledMouseMoveAsync = _.throttle(event => __awaiter(this, void 0, void 0, function* () {
      var _a, _b;
      const gridLeftX = this._gridContainer.getBoundingClientRect().left;
      const itemContainerLeftX = gridLeftX + this.cache.rowHeaderColumnsCache.totalWidth;
      const cursorItemContainerX = event.clientX - itemContainerLeftX;
      const cursorSnappedTime = this.getSnappedTimeAtItemContainerX(cursorItemContainerX);
      const setCursorTime = this.cursorSnappedTime !== cursorSnappedTime && cursorSnappedTime >= this.startTime && cursorSnappedTime <= this.endTime;
      if (setCursorTime) {
        yield this.setState({
          cursorSnappedTime
        });
        yield (_b = (_a = this.props).onMouseMove) === null || _b === void 0 ? void 0 : _b.call(_a, new Date(cursorSnappedTime));
        if (this._resizeCache) {
          yield this.onItemResizeMoveAsync();
        }
      }
    }), 20);
    this.onWindowResize = () => {
      window.clearTimeout(this._onWindowResizeTimeout);
      this._onWindowResizeTimeout = window.setTimeout(() => {
        this.forceUpdate();
        this.grid.recomputeGridSize();
      }, 100);
    };
    this.scrollHorizontally = _.throttle(options => {
      var _a;
      return (_a = this._timelineContainerElement) === null || _a === void 0 ? void 0 : _a.scrollBy(options);
    }, 20);
  }
  // Constructor & Lifecycle
  componentDidMount() {
    window.addEventListener('resize', this.onWindowResize);
    this.recreateInteractables();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    var _a;
    this._cache = new TimelineCache(nextProps);
    (_a = this.grid) === null || _a === void 0 ? void 0 : _a.recomputeGridSize();
  }
  componentDidUpdate(prevProps, prevState) {
    const selectedItemsIdsChanged = !_.isEqual(prevProps.selectedItemsIds, this.props.selectedItemsIds);
    const timelineModeChanged = prevProps.canDrag !== this.props.canDrag || prevProps.canResize !== this.props.canResize || prevProps.canSelect !== this.props.canSelect;
    const recreateInteractables = selectedItemsIdsChanged || timelineModeChanged;
    if (recreateInteractables) {
      this.recreateInteractables();
    }
  }
  componentWillUnmount() {
    if (this._itemInteractable) {
      this._itemInteractable.unset();
    }
    if (this._selectRectangleInteractable) {
      this._selectRectangleInteractable.unset();
    }
    window.removeEventListener('resize', this.onWindowResize);
  }
  // Properties
  get cache() {
    return this._cache;
  }
  /**
   * Get {@link cursorTime} as milliseconds since the Unix epoch
   */
  get cursorSnappedTime() {
    var _a;
    return (_a = this.state) === null || _a === void 0 ? void 0 : _a.cursorSnappedTime;
  }
  /**
   * Current time value at the cursors position, snapped to {@link snapMilliseconds}; null if the cursor is not currently hovering the {@link Timeline}
   */
  get cursorTime() {
    return typeof this.cursorSnappedTime === "number" ? new Date(this.cursorSnappedTime) : null;
  }
  get cursorTimeString() {
    var _a, _b;
    return ((_a = this.props.showCursorTime) !== null && _a !== void 0 ? _a : Timeline.defaultShowCursorTime) && typeof this.cursorSnappedTime === "number" ? new Date(this.cursorSnappedTime).format((_b = this.props.cursorTimeFormat) !== null && _b !== void 0 ? _b : Timeline.defaultCursorTimeFormat) : undefined;
  }
  /**
   * @see TimelineCache.endTime
   */
  get endTime() {
    return this.cache.endTime;
  }
  get grid() {
    return this._grid;
  }
  /**
   * Item container width in pixels (total timeline width - total row header columns width)
   *
   * @see totalWidth
   */
  get itemContainerWidth() {
    return this.totalWidth - this.cache.rowHeaderColumnsCache.totalWidth;
  }
  /**
   * Amount of pixels a millisecond takes on the item container
   */
  get itemContainerPixelsPerMillisecond() {
    return this.itemContainerWidth / this.cache.durationMilliseconds;
  }
  get markers() {
    var _a, _b, _c;
    // prop markers
    const visibleMarkers = ((_a = this.props.markers) !== null && _a !== void 0 ? _a : []).filter(marker => marker.time.valueOf() >= this.startTime && marker.time.valueOf() <= this.endTime);
    // cursor time marker
    const cursorTime = this.cursorTime;
    if (((_b = this.props.showCursorMarker) !== null && _b !== void 0 ? _b : Timeline.defaultShowCursorMarker) && cursorTime) {
      visibleMarkers.push({
        time: cursorTime
      });
    }
    // current time marker
    if ((_c = this.props.showCurrentTimeMarker) !== null && _c !== void 0 ? _c : Timeline.defaultShowCurrentTimeMarker) {
      const now = new Date();
      if (now.valueOf() >= this.startTime && now.valueOf() <= this.endTime) {
        visibleMarkers.push({
          time: now,
          style: {
            backgroundColor: "red"
          }
        });
      }
    }
    return visibleMarkers;
  }
  /**
   * @see TimelineCache.snapMilliseconds
   */
  get snapMilliseconds() {
    return this.cache.snapMilliseconds;
  }
  /**
   * @see TimelineCache.endTime
   */
  get startTime() {
    return this.cache.startTime;
  }
  /**
   * Total width of the {@link Timeline} in pixels
   *
   * @see itemContainerWidth
   */
  get totalWidth() {
    var _a, _b;
    const timelineContainerRect = (_a = this._timelineContainerElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    if (!timelineContainerRect) {
      return 0;
    }
    // -1 for border
    return Math.max(timelineContainerRect.width - 1, this.cache.rowHeaderColumnsCache.totalWidth + ((_b = this.props.minWidth) !== null && _b !== void 0 ? _b : Timeline.defaultMinWidth));
  }
  createDebugPointer(left, top, text, color) {
    const pointer = document.createElement("div");
    pointer.className = Timeline.debugPointerClass;
    pointer.append(document.createTextNode(text));
    pointer.style.position = "fixed";
    pointer.style.top = `${top}px`;
    pointer.style.left = `${left}px`;
    pointer.style.padding = "5px";
    pointer.style.borderRadius = "0 5px 5px 5px";
    pointer.style.backgroundColor = color;
    pointer.style.opacity = "0.8";
    document.body.append(pointer);
  }
  flushDebugPointers() {
    const pointers = document.querySelectorAll(`.${Timeline.debugPointerClass}`);
    pointers.forEach(pointer => {
      pointer.remove();
    });
  }
  /**
   * @returns All elements of the item with the given id
   */
  getItemElements(itemId) {
    return this._gridContainer.querySelectorAll(`[${Timeline.itemIdAttribute}='${itemId}']`);
  }
  /**
   * @returns The element of the item with the given id on the row with the given id
   */
  getRowItemElement(rowId, itemId) {
    return this._gridContainer.querySelector(`[${Timeline.itemIdAttribute}='${itemId}'][${Timeline.itemRowIdAttribute}='${rowId}']`);
  }
  getRowAt(x, y) {
    const rowElementAt = document.elementsFromPoint(x, y).find(elementAtPoint => elementAtPoint.hasAttribute(Timeline.rowIdAttribute));
    return rowElementAt ? this.cache.rowsItemsCache.rowCachesById[rowElementAt.getAttribute(Timeline.rowIdAttribute)].row : null;
  }
  /**
   * @param x Distance in pixels from the left border of the item container
   * @returns Time as milliseconds since the Unix epoch at {@link x}, snapped to {@link snapMilliseconds}
   */
  getSnappedTimeAtItemContainerX(x) {
    const millisecondsFromStartAtX = x / this.itemContainerPixelsPerMillisecond;
    const millisecondsAtX = this.startTime + millisecondsFromStartAtX - this._utcOffsetMilliseconds;
    const snapMilliseconds = this.snapMilliseconds > 0 ? this.snapMilliseconds : 1;
    return Math.round(millisecondsAtX / snapMilliseconds) * snapMilliseconds + this._utcOffsetMilliseconds;
  }
  /**
   * @param time Time as milliseconds since the Unix epoch
   * @return Distance from left border of the item container at {@link time} in pixels
   */
  getItemContanerXAtTime(time) {
    const millisecondsFromStartAtTime = time - this.startTime;
    const itemContainerPixelsAtTime = millisecondsFromStartAtTime * this.itemContainerPixelsPerMillisecond;
    return itemContainerPixelsAtTime + this.cache.rowHeaderColumnsCache.totalWidth;
  }
  /**
   * @returns Should the {@link callback} be invoked
   */
  handleItemRowEvent(event, callback, newPreventRowItemEvents) {
    if (typeof newPreventRowItemEvents === "boolean") {
      this._preventRowItemEvents = newPreventRowItemEvents;
    }
    event.stopPropagation();
    event.preventDefault();
    return !!callback && !this._preventRowItemEvents && !this._dragCache && !this._resizeCache;
  }
  handleItemEvent(callback, newPreventRowItemEvents, row, item, event) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.handleItemRowEvent(event, callback, newPreventRowItemEvents)) {
        return;
      }
      yield callback(event, this, row, item);
    });
  }
  handleRowEvent(callback, newPreventRowItemEvents, row, event) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.handleItemRowEvent(event, callback, newPreventRowItemEvents)) {
        return;
      }
      yield callback(event, this, row);
    });
  }
  onItemDragStartAsync(event) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
      const selectedItems = this.cache.rowsItemsCache.selectedItemCachesByIndex.map(itemCache => itemCache.item);
      const draggedItems = (_c = yield (_b = (_a = this.props).onItemDragStart) === null || _b === void 0 ? void 0 : _b.call(_a, selectedItems)) !== null && _c !== void 0 ? _c : selectedItems;
      if (draggedItems.length <= 0) {
        return;
      }
      const itemDragCaches = [];
      draggedItems.forEach(draggedItem => {
        const itemId = draggedItem.id;
        const itemCache = this.cache.rowsItemsCache.selectedItemCachesById[itemId];
        if (!itemCache) {
          throw new Error(`No selected item id '${itemId}'`);
        }
        if (itemCache.selectionStatus !== TimelineItemSelectionStatus.Selected) {
          throw new Error(`Cannot drag non-selected item id '${itemId}'`);
        }
        const rowItemDragCaches = itemCache.rowItemCachesByIndex.map(rowItemCache => {
          const rowId = rowItemCache.rowCache.row.id;
          const rowItemElement = this.getRowItemElement(rowId, itemId);
          if (!rowItemElement) {
            throw new Error(`No element for item id '${itemId}' row id '${rowId}'!`);
          }
          rowItemElement.classList.add(itemStyles.dragged);
          return Object.freeze({
            rowItemCache,
            element: rowItemElement
          });
        });
        itemDragCaches.push(Object.freeze({
          itemCache,
          rowItemDragCaches: Object.freeze(rowItemDragCaches)
        }));
      });
      if (this.props.debug) {
        // debug event locations
        this.flushDebugPointers();
        this.createDebugPointer(event.clientX, event.clientY, "START", "aqua");
      }
      this._dragCache = {
        currentCursorTime: this.cursorSnappedTime,
        deltaY: 0,
        initialCursorTime: this.cursorSnappedTime,
        itemDragCaches: Object.freeze(itemDragCaches)
      };
    });
  }
  onItemDragMoveAsync(event) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      const dragCache = this._dragCache;
      if (!dragCache) {
        // onItemDragStart needs to be called before onItemDragMove (which it of course is not)
        return;
      }
      // user could have dragged the items outside the Timeline, in which case use the previous cursor time for deltaX
      const currentCursorTime = (_a = this.cursorSnappedTime) !== null && _a !== void 0 ? _a : dragCache.currentCursorTime;
      const deltaY = dragCache.deltaY + event.dy;
      dragCache.currentCursorTime = currentCursorTime;
      dragCache.deltaY = deltaY;
      const deltaX = this.getItemContanerXAtTime(currentCursorTime) - this.getItemContanerXAtTime(dragCache.initialCursorTime);
      dragCache.itemDragCaches.forEach(itemDragCache => {
        itemDragCache.rowItemDragCaches.forEach(rowItemDragCache => {
          const draggedItemElement = rowItemDragCache.element;
          // Only hard-selected items move vertically (between rows)
          const itemDeltaY = rowItemDragCache.rowItemCache.selectionStatus === TimelineItemSelectionStatus.Selected ? deltaY : 0;
          draggedItemElement.style.webkitTransform = draggedItemElement.style.transform = `translate(${deltaX}px, ${itemDeltaY}px)`;
        });
      });
      const cursorY = event.clientY;
      const isTopOfDisplay = cursorY < window.innerHeight / 10;
      const isBottomOfDisplay = cursorY > window.innerHeight / 10 * 9;
      const cursorX = event.clientX;
      const timelineRect = this._timelineContainerElement.getBoundingClientRect();
      const isLeftOfContainer = cursorX < timelineRect.left + this.cache.rowHeaderColumnsCache.totalWidth + timelineRect.width / 10;
      const isRightOfContainer = cursorX > timelineRect.right - timelineRect.width / 10;
      if (isBottomOfDisplay) {
        window.scrollBy({
          top: 10
        });
      } else if (isTopOfDisplay) {
        window.scrollBy({
          top: -10
        });
      }
      if (isLeftOfContainer) {
        this.scrollHorizontally({
          left: -10
        });
      } else if (isRightOfContainer) {
        this.scrollHorizontally({
          left: 10
        });
      }
    });
  }
  onItemDragEndAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      const dragCache = this._dragCache;
      if (!dragCache) {
        // user reverted drag
        return;
      }
      const timeDeltaMilliseconds = dragCache.currentCursorTime - dragCache.initialCursorTime;
      const timelineContainerRect = this._timelineContainerElement.getBoundingClientRect();
      /**
       *      ---------------------
       *      |    |              |  x
       *      |    |     x        |
       *      |    |              |
       *  x   |    |              |
       *      ---------------------
       */
      // Try to get x so that it always hits a visible part of a row, if exists.
      // Center of the visible area should be a pretty safe guess.
      const x = window.innerWidth / 2;
      const y = event.clientY;
      // if no rows visible on time of event, target row won't be found even with clamping. don't update items rowId in that case
      const newRow = this.getRowAt(x, y);
      if (this.props.debug) {
        // debug event locations
        this.createDebugPointer(x, y, "SELECT", "red");
        this.createDebugPointer(timelineContainerRect.x, y - 40, "timeline.x", "fuchsia");
        this.createDebugPointer(timelineContainerRect.left, y - 40, "timeline.left", "fuchsia");
        this.createDebugPointer(timelineContainerRect.right, y - 40, "timeline.right", "fuchsia");
        this.createDebugPointer(event.x0, event.y0, "event.0", "aqua");
        this.createDebugPointer(event.clientX0, event.clientY0, "event.client0", "aqua");
        this.createDebugPointer(event.clientX, event.clientY, "event.client", "lime");
      }
      const draggedItems = dragCache.itemDragCaches.map(itemDragCache => {
        const draggedItem = itemDragCache.itemCache.item;
        const preservedRowIds = itemDragCache.rowItemDragCaches.filter(rowItemDragCache => rowItemDragCache.rowItemCache.selectionStatus === TimelineItemSelectionStatus.Linked).map(rowItemDragCache => rowItemDragCache.rowItemCache.rowCache.row.id);
        const newStartTime = draggedItem.start.addMilliseconds(timeDeltaMilliseconds);
        const newEndTime = draggedItem.end.addMilliseconds(timeDeltaMilliseconds);
        const newRowIds = (newRow === null || newRow === void 0 ? void 0 : newRow.id) ? [...preservedRowIds, newRow.id].distinct(id => id) : draggedItem.rowIds;
        const returnItem = Object.assign(Object.assign({}, draggedItem), {
          start: newStartTime,
          end: newEndTime,
          rowIds: newRowIds
        });
        return returnItem;
      });
      this.cancelDrag();
      yield this.props.onItemDragEnd(draggedItems, timeDeltaMilliseconds, newRow);
      this.grid.recomputeGridSize({
        rowIndex: 0
      });
    });
  }
  onItemResizeStartAsync(event) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
      const isStartTimeResize = event.edges.left === true;
      const selectedItems = this.cache.rowsItemsCache.selectedItemCachesByIndex.map(itemCache => itemCache.item);
      const resizedItems = (_c = yield (_b = (_a = this.props).onItemResizeStart) === null || _b === void 0 ? void 0 : _b.call(_a, selectedItems, isStartTimeResize)) !== null && _c !== void 0 ? _c : selectedItems;
      if (resizedItems.length <= 0) {
        return;
      }
      const itemResizeCaches = [];
      resizedItems.forEach(resizedItem => {
        const itemId = resizedItem.id;
        const itemCache = this.cache.rowsItemsCache.selectedItemCachesById[itemId];
        if (!itemCache) {
          throw new Error(`No selected item id '${itemId}'`);
        }
        const resizedItemElements = this.getItemElements(itemId);
        if (resizedItemElements.length <= 0) {
          throw new Error(`No elements found for dragged items!`);
        }
        resizedItemElements.forEach(resizedItemElement => {
          resizedItemElement.classList.add(itemStyles.resized);
        });
        itemResizeCaches.push({
          currentEndTime: itemCache.item.end.valueOf(),
          currentStartTime: itemCache.item.start.valueOf(),
          elements: resizedItemElements,
          itemCache
        });
      });
      this._resizeCache = {
        currentCursorTime: this.cursorSnappedTime,
        initialCursorTime: this.cursorSnappedTime,
        itemResizeCaches: Object.freeze(itemResizeCaches),
        isStartTimeResize
      };
    });
  }
  onItemResizeMoveAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const resizeCache = this._resizeCache;
      if (!this._resizeCache) {
        // onItemResizeStart needs to be called before onItemResizeMove (which it of course is not)
        return;
      }
      const pixelsPerMillisecond = this.itemContainerPixelsPerMillisecond;
      const millisecondsPerPixel = this.cache.durationMilliseconds / this.itemContainerWidth;
      const currentCursorTime = this.cursorSnappedTime;
      const initialCursorTime = resizeCache.initialCursorTime;
      const cursorDeltaMilliseconds = currentCursorTime - initialCursorTime;
      const cursorDeltaPixels = cursorDeltaMilliseconds * pixelsPerMillisecond;
      const isStartTimeResize = resizeCache.isStartTimeResize;
      const snapMilliseconds = this.snapMilliseconds;
      resizeCache.currentCursorTime = currentCursorTime;
      resizeCache.itemResizeCaches.forEach(itemResizeCache => {
        const itemInitialStart = itemResizeCache.itemCache.item.start.valueOf();
        const itemInitialEnd = itemResizeCache.itemCache.item.end.valueOf();
        const itemInitialLengthMilliseconds = itemInitialEnd - itemInitialStart;
        const itemNewStart = isStartTimeResize ? itemInitialStart + cursorDeltaMilliseconds : itemInitialStart;
        const itemNewEnd = isStartTimeResize ? itemInitialEnd : itemInitialEnd + cursorDeltaMilliseconds;
        const itemNewLengthMilliseconds = itemNewEnd - itemNewStart;
        const itemMinimumLengthMilliseconds = Math.min(itemInitialLengthMilliseconds, snapMilliseconds + 10 * millisecondsPerPixel);
        const overResized = itemNewStart >= itemNewEnd || itemNewLengthMilliseconds <= itemMinimumLengthMilliseconds;
        let newItemLengthPixels;
        let newItemX;
        if (overResized) {
          const minimumDeltaMilliseconds = itemMinimumLengthMilliseconds - itemInitialLengthMilliseconds;
          itemResizeCache.currentStartTime = isStartTimeResize ? itemInitialStart - minimumDeltaMilliseconds : itemInitialStart;
          itemResizeCache.currentEndTime = isStartTimeResize ? itemInitialEnd : itemInitialEnd + minimumDeltaMilliseconds;
          newItemLengthPixels = itemMinimumLengthMilliseconds * pixelsPerMillisecond;
          newItemX = -minimumDeltaMilliseconds * pixelsPerMillisecond;
        } else {
          itemResizeCache.currentStartTime = itemNewStart;
          itemResizeCache.currentEndTime = itemNewEnd;
          newItemLengthPixels = itemNewLengthMilliseconds * pixelsPerMillisecond;
          newItemX = cursorDeltaPixels;
        }
        itemResizeCache.elements.forEach(resizedItemElement => {
          resizedItemElement.style.width = `${newItemLengthPixels}px`;
          if (isStartTimeResize) {
            resizedItemElement.style.webkitTransform = resizedItemElement.style.transform = `translate(${newItemX}px, 0px)`;
          }
        });
      });
    });
  }
  onItemResizeEndAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const resizeCache = this._resizeCache;
      if (!resizeCache) {
        // user reverted resize
        return;
      }
      const resizedItems = [];
      let minimumRowNumber = Infinity;
      resizeCache.itemResizeCaches.forEach(itemResizeCache => {
        const resizedItem = itemResizeCache.itemCache.item;
        const newResizedItem = Object.assign(Object.assign({}, resizedItem), {
          start: new Date(itemResizeCache.currentStartTime),
          end: new Date(itemResizeCache.currentEndTime)
        });
        resizedItems.push(newResizedItem);
        minimumRowNumber = Math.min(minimumRowNumber, ...resizedItem.rowIds.map(rowId => this.cache.rowsItemsCache.rowCachesById[rowId].index));
      });
      this.cancelResize();
      yield this.props.onItemResizeEnd(resizedItems, resizeCache.isStartTimeResize);
      this.grid.recomputeGridSize({
        rowIndex: minimumRowNumber
      });
    });
  }
  onMouseMoveAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      event.persist();
      yield this.onThrottledMouseMoveAsync(event);
    });
  }
  onMouseLeaveAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      event.stopPropagation();
      this.onThrottledMouseMoveAsync.cancel();
      yield this.setState({
        cursorSnappedTime: undefined
      });
    });
  }
  recreateInteractables() {
    const componentId = `#${this._componentId}`;
    const selectedItemClass = `.${TimelineItem.wrapperSelectedClass}`;
    if (this._itemInteractable) {
      this._itemInteractable.unset();
    }
    if (this._selectRectangleInteractable) {
      this._selectRectangleInteractable.unset();
    }
    this._itemInteractable = interact(`${componentId} .${itemStyles.timelineItemWrapper}`);
    this._selectRectangleInteractable = interact(`#${this._gridId}`);
    if (this.props.canDrag === true) {
      if (!this.props.onItemDragEnd) {
        throw new Error(`onItemDragEnd is required if canDrag is true`);
      }
      this._itemInteractable.draggable({
        enabled: true,
        allowFrom: selectedItemClass,
        modifiers: [interact.modifiers.restrict({
          restriction: componentId,
          elementRect: {
            left: 0,
            right: 1,
            top: 0,
            bottom: 1
          }
        })]
      }).on('dragstart', this.onItemDragStartAsync.bind(this)).on('dragmove', this.onItemDragMoveAsync.bind(this)).on('dragend', this.onItemDragEndAsync.bind(this));
    }
    if (this.props.canResize === true) {
      if (!this.props.onItemResizeEnd) {
        throw new Error(`onItemResizeEnd is required if canResize is true`);
      }
      this._itemInteractable.resizable({
        allowFrom: `${selectedItemClass}, .${TimelineItem.wrapperLinkedClass}`,
        edges: {
          left: true,
          right: true,
          bottom: false,
          top: false
        }
      }).on('resizestart', this.onItemResizeStartAsync.bind(this)).on('resizeend', this.onItemResizeEndAsync.bind(this));
    }
  }
  cellRenderer(props) {
    const {
      columnIndex,
      key,
      rowIndex,
      style
    } = props;
    const rowCache = this.cache.rowsItemsCache.rowCachesByIndex[rowIndex];
    const isLastRow = rowIndex === this.cache.rowsItemsCache.rowCachesByIndex.length - 1;
    const isLastColumn = columnIndex === this.cache.rowHeaderColumnsCache.rowHeaderColumnCachesByIndex.length;
    if (isLastColumn) {
      return /*#__PURE__*/React.createElement(TimelineRowItemsColumn, {
        key: key,
        rowCache: rowCache,
        isLastRow: isLastRow,
        itemRenderer: this.props.itemRenderer,
        itemTooltipRenderer: this.props.itemTooltipRenderer,
        pixelsPerMillisecond: this.itemContainerPixelsPerMillisecond,
        wrapperStyle: style,
        onItemClick: this.handleItemEvent.bind(this, this.props.onItemClick, undefined),
        onItemDoubleClick: this.handleItemEvent.bind(this, this.props.onItemDoubleClick, undefined),
        onItemContextMenu: this.handleItemEvent.bind(this, this.props.onItemContextMenu, undefined),
        onItemMouseEnter: this.handleItemEvent.bind(this, this.props.onItemMouseEnter, false),
        onItemMouseLeave: this.handleItemEvent.bind(this, this.props.onItemMouseLeave, false),
        onRowClick: this.handleRowEvent.bind(this, this.props.onRowClick, undefined),
        onRowDoubleClick: this.handleRowEvent.bind(this, this.props.onRowDoubleClick, undefined),
        onRowContextMenu: this.handleRowEvent.bind(this, this.props.onRowContextMenu, undefined),
        onRowMouseEnter: this.handleRowEvent.bind(this, this.props.onRowMouseEnter, false),
        onRowMouseLeave: this.handleRowEvent.bind(this, this.props.onRowMouseLeave, false),
        onRowMouseDown: () => this._preventRowItemEvents = false,
        onRowMouseMove: () => this._preventRowItemEvents = true
      });
    }
    return /*#__PURE__*/React.createElement(TimelineRowHeaderColumnCell, {
      key: key,
      rowCache: rowCache,
      rowHeaderColumnCache: this.cache.rowHeaderColumnsCache.rowHeaderColumnCachesByIndex[columnIndex],
      customRenderer: this.props.rowHeaderColumnCellRenderer,
      wrapperStyle: style,
      isLastRow: isLastRow
    });
  }
  /**
   * Cancel drag and revert dragged items to their initial values
   */
  cancelDrag() {
    if (!this._dragCache) {
      return;
    }
    this._dragCache.itemDragCaches.forEach(itemDragCache => {
      itemDragCache.rowItemDragCaches.forEach(rowItemDragCache => {
        const draggedItemElement = rowItemDragCache.element;
        draggedItemElement.style.webkitTransform = draggedItemElement.style.transform = "";
        draggedItemElement.classList.remove(itemStyles.dragged);
      });
    });
    delete this._dragCache;
    this.recreateInteractables();
  }
  /**
   * Cancel resize and revert resized items to their initial values
   */
  cancelResize() {
    if (!this._resizeCache) {
      return;
    }
    this._resizeCache.itemResizeCaches.forEach(itemResizeCache => {
      const initialWidth = Math.round((itemResizeCache.itemCache.item.end.valueOf() - itemResizeCache.itemCache.item.start.valueOf()) * this.itemContainerPixelsPerMillisecond);
      itemResizeCache.elements.forEach(resizedItemElement => {
        resizedItemElement.style.width = `${initialWidth}px`;
        resizedItemElement.classList.remove(itemStyles.resized);
        resizedItemElement.style.webkitTransform = resizedItemElement.style.transform = "";
      });
    });
    delete this._resizeCache;
    this.recreateInteractables();
  }
  render() {
    if (!this.cache) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      ref: this.timelineContainerRefCallback,
      id: this._componentId,
      className: styles$9.timeline,
      onMouseMove: this.onMouseMoveAsync.bind(this),
      onMouseLeave: this.onMouseLeaveAsync.bind(this)
    }, /*#__PURE__*/React.createElement(TimelineHeader, {
      cache: this.cache,
      incrementTimeFormats: this.props.headerFormats,
      cursorTimeString: this.cursorTimeString,
      itemContainerWidth: this.itemContainerWidth,
      itemContainerPixelsPerMillisecond: this.itemContainerPixelsPerMillisecond,
      rowHeaderColumnHeaderRenderer: this.props.rowHeaderColumnHeaderRenderer
    }), this.markers.map(marker => /*#__PURE__*/React.createElement(TimelineMarker, {
      key: marker.time.valueOf(),
      marker: marker,
      leftX: this.getItemContanerXAtTime(marker.time.valueOf())
    })), /*#__PURE__*/React.createElement("div", {
      ref: this.gridContainerCallback
    }, /*#__PURE__*/React.createElement(TimelineBody, {
      gridRefCallback: this.gridRefCallback,
      gridId: this._gridId,
      gridRowCount: this.cache.rowsItemsCache.rowCachesByIndex.length,
      gridColumnCount: this.cache.rowHeaderColumnsCache.rowHeaderColumnCachesByIndex.length + 1,
      gridWidth: this.totalWidth,
      gridHeight: this.cache.rowsItemsCache.rowsTotalHeight,
      getGridColumnWidth: columnIndex => {
        var _a, _b;
        return (_b = (_a = this.cache.rowHeaderColumnsCache.rowHeaderColumnCachesByIndex[columnIndex]) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : this.itemContainerWidth;
      },
      getGridRowHeight: rowIndex => this.cache.rowsItemsCache.rowCachesByIndex[rowIndex].height,
      gridCellRenderer: this.cellRenderer.bind(this)
    })));
  }
}
/**
 * Default value of {@link ITimelineProps.cursorTimeFormat}
 * For supported formats {@see Utility.format}
 */
Timeline.defaultCursorTimeFormat = 'gt';
/**
 * Default value of {@link ITimelineProps.headerFormats}
 */
Timeline.defaultHeaderFormats = defaultTimelineHeaderFormats;
/**
 * Default value of {@link ITimelineProps.itemHeight}
 */
Timeline.defaultItemHeight = 40;
/**
 * Default value of {@link ITimelineProps.minWidth}
 */
Timeline.defaultMinWidth = 1000;
/**
 * Default value of {@link ITimelineProps.rowHeaderColumnWidth}
 */
Timeline.defaultRowHeaderColumnWidth = 150;
/**
 * Default value of {@link ITimelineProps.showCurrentTimeMarker}
 */
Timeline.defaultShowCurrentTimeMarker = false;
/**
 * Default value of {@link ITimelineProps.showCursorMarker}
 */
Timeline.defaultShowCursorMarker = true;
/**
 * Default value of {@link ITimelineProps.showCursorTime}
 */
Timeline.defaultShowCursorTime = true;
/**
 * Default value of {@link ITimelineProps.snapSeconds}. 15 minutes
 */
Timeline.defaultSnapSeconds = 900;
Timeline.itemIdAttribute = 'data-item-id';
Timeline.itemRowIdAttribute = 'data-item-row-id';
Timeline.rowIdAttribute = 'data-row-id';
Timeline.debugPointerClass = 'timeline-debug-pointer';

//Autogenerated
class DateRangeInputLocalizer extends BaseComponentLocalizer {
  //Constants
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Initializer
  }
}
//Singleton
var DateRangeInputLocalizer$1 = new DateRangeInputLocalizer();

var css_248z$9 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-date-range-input-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-date-range-input-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-date-range-input-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-date-range-input-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-date-range-input-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-date-range-input-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-date-range-input-dateRangeInputExpanded {\n  position: absolute;\n}\n\n.athenaeum-date-range-input-dateRangeInput {\n  max-width: calc(30px * 7 + 0px * 6 + 0px * 2 + 0.5rem * 2);\n  display: grid;\n  grid-gap: 5px 0px;\n  background: white;\n  padding: 0.5rem 0.5rem;\n  grid-template-columns: repeat(7, 1fr);\n  border: 1px solid #ffffff;\n  border-radius: 0.25rem;\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  z-index: 100;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-monthName {\n  grid-column: 1/6;\n  display: flex;\n  align-items: center;\n  background: #ffffff;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-monthAction {\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #ffffff;\n  cursor: pointer;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-weekDayName {\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #ffffff;\n  width: 30px;\n  height: 30px;\n  overflow: hidden;\n  font-size: 0.7rem;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-isToday span {\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-radius: 100%;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-disabledDayHint {\n  grid-column-start: 1;\n  grid-column-end: 7;\n  color: red;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-monthViewGridDay {\n  width: 30px;\n  height: 30px;\n  font-size: 0.8rem;\n  background: #ffffff;\n  display: flex;\n  transition: 50ms all;\n  cursor: pointer;\n  padding: 3px;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-monthViewGridDay span {\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-monthViewGridDay:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n  color: white;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-gridDayDisabled {\n  background-color: rgb(227, 227, 227);\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-gridDayDisabled:hover {\n  background-color: rgb(227, 227, 227);\n  color: #212529;\n  cursor: default;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-isInRange {\n  background-color: rgba(234, 60, 0, 0.5);\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-isOutOfRange {\n  color: rgba(0, 0, 0, 0.1);\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-isInRangeAndNotSelected {\n  background-color: rgba(234, 60, 0, 0.1);\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-isInRangeAndSelected {\n  background-color: #FBA587;\n  color: white;\n}\n.athenaeum-date-range-input-dateRangeInput .athenaeum-date-range-input-isSelected {\n  background-color: rgb(254, 80, 0);\n  color: white;\n}\n\n.athenaeum-date-range-input-icon {\n  margin-right: 5px;\n}\n\n.athenaeum-date-range-input-input {\n  cursor: pointer;\n}\n.athenaeum-date-range-input-input .athenaeum-date-range-input-dateSeparator {\n  padding: 0 0.5rem;\n}";
var styles$8 = {"font-renta":"athenaeum-date-range-input-font-renta","color-schema-renta_black":"athenaeum-date-range-input-color-schema-renta_black","color-schema-renta_white":"athenaeum-date-range-input-color-schema-renta_white","color-schema-renta_orange":"athenaeum-date-range-input-color-schema-renta_orange","color-schema-renta_green":"athenaeum-date-range-input-color-schema-renta_green","color-schema-renta_blue":"athenaeum-date-range-input-color-schema-renta_blue","dateRangeInputExpanded":"athenaeum-date-range-input-dateRangeInputExpanded","dateRangeInput":"athenaeum-date-range-input-dateRangeInput","monthName":"athenaeum-date-range-input-monthName","monthAction":"athenaeum-date-range-input-monthAction","weekDayName":"athenaeum-date-range-input-weekDayName","isToday":"athenaeum-date-range-input-isToday","disabledDayHint":"athenaeum-date-range-input-disabledDayHint","monthViewGridDay":"athenaeum-date-range-input-monthViewGridDay","gridDayDisabled":"athenaeum-date-range-input-gridDayDisabled","isInRange":"athenaeum-date-range-input-isInRange","isOutOfRange":"athenaeum-date-range-input-isOutOfRange","isInRangeAndNotSelected":"athenaeum-date-range-input-isInRangeAndNotSelected","isInRangeAndSelected":"athenaeum-date-range-input-isInRangeAndSelected","isSelected":"athenaeum-date-range-input-isSelected","icon":"athenaeum-date-range-input-icon","input":"athenaeum-date-range-input-input","dateSeparator":"athenaeum-date-range-input-dateSeparator"};
styleInject(css_248z$9);

var WeekDaysEnum;
(function (WeekDaysEnum) {
  WeekDaysEnum[WeekDaysEnum["Sunday"] = 0] = "Sunday";
  WeekDaysEnum[WeekDaysEnum["Monday"] = 1] = "Monday";
  WeekDaysEnum[WeekDaysEnum["TuesDay"] = 2] = "TuesDay";
  WeekDaysEnum[WeekDaysEnum["Wednesday"] = 3] = "Wednesday";
  WeekDaysEnum[WeekDaysEnum["Thursday"] = 4] = "Thursday";
  WeekDaysEnum[WeekDaysEnum["Friday"] = 5] = "Friday";
  WeekDaysEnum[WeekDaysEnum["Saturday"] = 6] = "Saturday";
})(WeekDaysEnum || (WeekDaysEnum = {}));
class DateRangeInput extends BaseInput {
  constructor() {
    super(...arguments);
    this._absolutePositionPaddingPx = 20;
    this._monthGridLongCount = 42;
    this._monthGridCount = 35;
    this._weekDaysCount = 7;
    this._inputRef = /*#__PURE__*/React.createRef();
    this._datePickerRef = /*#__PURE__*/React.createRef();
    this.state = {
      readonly: false,
      model: {
        value: [null, null]
      },
      edit: true,
      validationError: null,
      //...super.state,
      absolutePositionTop: 0,
      activeMonthView: this.defaultActiveMonthView(),
      lastHoveredDayGrid: null,
      showDatePicker: false,
      displayDisabledDaysHint: false
    };
  }
  get startDate() {
    const value = this.state.model.value;
    if (value === null || value === undefined) return null;
    if (!Array.isArray(value)) return null;
    if (value.length !== 2) return null;
    if (value[0] === null) return null;
    return DateRangeInput.getStartOfDay(value[0]);
  }
  get endDate() {
    const value = this.state.model.value;
    if (value === null || value === undefined) return null;
    if (!Array.isArray(value)) return null;
    if (value.length !== 2) return null;
    if (value[1] === null) return null;
    return DateRangeInput.getStartOfDay(value[1]);
  }
  get sameDayAllowed() {
    var _a;
    return (_a = this.props.sameDay) !== null && _a !== void 0 ? _a : false;
  }
  defaultActiveMonthView() {
    var _a;
    if (DateRangeInput.isValidDateRangeInputValue(this.props.value)) {
      return (_a = this.startDate) !== null && _a !== void 0 ? _a : DateRangeInput.getStartOfDay(new Date());
    }
    return new Date();
  }
  get gridDays() {
    const year = this.state.activeMonthView.getFullYear();
    const month = this.state.activeMonthView.getMonth();
    const firstDayOfNextMonth = 1;
    const previousMonth = month - 1;
    const nextMonth = month + 1;
    const currentMonthDayCount = DateRangeInput.daysInMonth(year, month);
    const firstDay = new Date(this.state.activeMonthView.setDate(1));
    const firstDayWeekDay = firstDay.getDay();
    const introDaysCount = firstDayWeekDay === WeekDaysEnum.Sunday ? this._weekDaysCount - 1 : firstDayWeekDay - 1;
    const isLongMonth = introDaysCount + currentMonthDayCount > this._monthGridCount;
    const gridCount = isLongMonth ? this._monthGridLongCount : this._monthGridCount;
    const outroDaysCount = gridCount - introDaysCount - currentMonthDayCount;
    const lastDayOfPreviousMonth = DateRangeInput.lastDayInMonth(year, previousMonth);
    const currentMonthGridDays = new Array(currentMonthDayCount).fill(0).map((val, index) => {
      const day = index + 1;
      return DateRangeInput.getStartOfDay(new Date(year, month, day));
    });
    const introMonthGridDays = new Array(introDaysCount).fill(0).map((val, index) => {
      const day = lastDayOfPreviousMonth - index;
      return DateRangeInput.getStartOfDay(new Date(year, previousMonth, day));
    }).reverse();
    const outroMonthGridDays = new Array(outroDaysCount).fill(0).map((val, index) => {
      const day = firstDayOfNextMonth + index;
      return DateRangeInput.getStartOfDay(new Date(year, nextMonth, day));
    });
    return [...introMonthGridDays, ...currentMonthGridDays, ...outroMonthGridDays];
  }
  get minDate() {
    if (!this.props.minDate) return null;
    return DateRangeInput.getStartOfDay(this.props.minDate);
  }
  get maxDate() {
    if (!this.props.maxDate) return null;
    return DateRangeInput.getStartOfDay(this.props.maxDate);
  }
  get hasDisabledDays() {
    return !!this.props.disabledDays && this.props.disabledDays.length > 0;
  }
  get disabledDays() {
    var _a;
    return (_a = this.props.disabledDays) !== null && _a !== void 0 ? _a : [];
  }
  get disabledDaysHint() {
    var _a;
    return (_a = this.props.disabledDaysHint) !== null && _a !== void 0 ? _a : "";
  }
  get displayDisabledDaysHint() {
    return this.state.displayDisabledDaysHint;
  }
  setValueAsync(dateRangeInputValue) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!DateRangeInput.isValidDateRangeInputValue(dateRangeInputValue)) {
        return;
      }
      const sortedValue = DateRangeInput.sortDates(dateRangeInputValue);
      yield this.updateValueAsync(sortedValue, false);
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const target = e.target;
      if (!this._inputRef.current || !this._datePickerRef.current) {
        return;
      }
      const isInsideOfDatePicker = this._inputRef.current.contains(target);
      const isInsideOfInput = this._datePickerRef.current.contains(target);
      if (isInsideOfDatePicker || isInsideOfInput) {
        return;
      }
      this.setState({
        showDatePicker: false
      });
    });
  }
  onDayGridClickAsync(clickedDate) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isOutOfRange(clickedDate)) {
        return;
      }
      if (this.isDisabledDay(clickedDate)) {
        this.setState(Object.assign(Object.assign({}, this.state), {
          displayDisabledDaysHint: true
        }));
        return;
      }
      //  No date is selected. set it to start
      if (!this.startDate && !this.endDate) {
        yield this.setValueAsync([clickedDate, null]);
        yield this.emitOnChange();
        return;
      }
      //  both are selected. reset end and set to start
      if (this.startDate && this.endDate) {
        yield this.setValueAsync([clickedDate, null]);
        yield this.emitOnChange();
        return;
      }
      //  only start is selected.
      if (this.startDate && !this.endDate) {
        //  sameDayAllowed is enabled and selected is same as start then do It!.
        if (this.sameDayAllowed && DateRangeInput.isSameDate(this.startDate, clickedDate)) {
          yield this.setValueAsync([this.startDate, clickedDate]);
          yield this.setState(() => ({
            showDatePicker: false
          }));
          yield this.emitOnChange();
          return;
        }
        //  sameDayAllowed is disabled and selected is same as start then reset both.
        if (DateRangeInput.isSameDate(this.startDate, clickedDate)) {
          yield this.setValueAsync([null, null]);
          return;
        }
        //  sameDayAllowed is disabled. clicked date is different than start then set to end
        yield this.setValueAsync([this.startDate, clickedDate]);
        yield this.emitOnChange();
        yield this.setState(() => ({
          showDatePicker: false
        }));
        return;
      }
      //  end is selected. set to start. this path should not happen usually.
      yield this.setValueAsync([clickedDate, this.endDate]);
      yield this.emitOnChange();
    });
  }
  onDayGridMouseEnterAsync(dayGridValue) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.setState({
        lastHoveredDayGrid: dayGridValue
      });
    });
  }
  onNextMonthClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const nextMonth = this.state.activeMonthView.addMonths(1);
      yield this.setState({
        activeMonthView: nextMonth
      });
    });
  }
  onPreviousMonthClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const prevMonth = this.state.activeMonthView.addMonths(-1);
      yield this.setState({
        activeMonthView: prevMonth
      });
    });
  }
  emitOnChange() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.props.onChange) {
        return;
      }
      yield this.props.onChange(this.value);
    });
  }
  isDayGridSelected(dayGridValue) {
    return DateRangeInput.isSameDate(dayGridValue, this.startDate) || DateRangeInput.isSameDate(dayGridValue, this.endDate);
  }
  isDayGridInRange(dayGridValue) {
    if (this.isOutOfRange(dayGridValue)) {
      return false;
    }
    const isSmallerThanHoveredGrid = this.state.lastHoveredDayGrid ? dayGridValue.getTime() < this.state.lastHoveredDayGrid.getTime() : false;
    const isBiggerThanLastHoveredGrid = this.state.lastHoveredDayGrid ? dayGridValue.getTime() > this.state.lastHoveredDayGrid.getTime() : false;
    const isBiggerThanFirstClickedGrid = this.startDate ? dayGridValue.getTime() > this.startDate.getTime() : false;
    const isBiggerThanLastClickedGrid = this.endDate ? dayGridValue.getTime() > this.endDate.getTime() : false;
    const isSmallerThanFirstClickedGrid = this.startDate ? dayGridValue.getTime() < this.startDate.getTime() : false;
    const isSmallerThanLastClickedGrid = this.endDate ? dayGridValue.getTime() < this.endDate.getTime() : false;
    if (this.startDate && this.endDate) {
      return isBiggerThanFirstClickedGrid && isSmallerThanLastClickedGrid || isSmallerThanFirstClickedGrid && isBiggerThanLastClickedGrid;
    }
    if (this.startDate && !this.endDate) {
      return isSmallerThanHoveredGrid && isBiggerThanFirstClickedGrid || isSmallerThanFirstClickedGrid && isBiggerThanLastHoveredGrid;
    }
    return false;
  }
  isOutOfRange(dayGridValue) {
    if (!this.minDate && !this.maxDate) {
      return false;
    }
    if (this.minDate && this.maxDate) {
      const minDateUnixTime = this.minDate.getTime();
      const maxDateUnixTime = this.maxDate.getTime();
      const gridValueUnixTime = dayGridValue.getTime();
      return minDateUnixTime > gridValueUnixTime || maxDateUnixTime < gridValueUnixTime;
    }
    if (this.minDate) {
      const minDateUnixTime = this.minDate.getTime();
      const gridValueUnixTime = dayGridValue.getTime();
      return minDateUnixTime > gridValueUnixTime;
    }
    if (this.maxDate) {
      const maxDateUnixTime = this.maxDate.getTime();
      const gridValueUnixTime = dayGridValue.getTime();
      return maxDateUnixTime > gridValueUnixTime;
    }
    return false;
  }
  isDisabledDay(dayGridValue) {
    const day = dayGridValue.getDay();
    return this.disabledDays.includes(day);
  }
  toggleDatePickerAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._inputRef.current) {
        return;
      }
      const showDatePicker = !this.state.showDatePicker;
      const absolutePositionTop = this._inputRef.current.getBoundingClientRect().height + this._absolutePositionPaddingPx;
      yield this.setState({
        showDatePicker,
        absolutePositionTop
      });
    });
  }
  renderWeekDays() {
    const weekDays = [WeekDaysEnum.Monday, WeekDaysEnum.TuesDay, WeekDaysEnum.Wednesday, WeekDaysEnum.Thursday, WeekDaysEnum.Friday, WeekDaysEnum.Saturday, WeekDaysEnum.Sunday];
    return weekDays.map(weekDay => ( /*#__PURE__*/React.createElement("div", {
      key: weekDay,
      className: styles$8.weekDayName
    }, Utility.getShortDayOfWeek(weekDay))));
  }
  renderDayGrid(gridDay) {
    const disabledStyle = this.hasDisabledDays && this.isDisabledDay(gridDay) ? styles$8.gridDayDisabled : "";
    const isOutOfRangeStyle = this.isOutOfRange(gridDay) ? styles$8.isOutOfRange : "";
    const isSelectedStyle = this.isDayGridSelected(gridDay) && styles$8.isSelected || "";
    const isTodayStyle = DateRangeInput.todayInUnixTime() === gridDay.getTime() ? styles$8.isToday : "";
    const isInRangeAndSelectedStyle = this.startDate && this.endDate && this.isDayGridInRange(gridDay) ? styles$8.isInRangeAndSelected : "";
    const isInRangeAndNotSelectedStyle = this.startDate && !this.endDate && this.isDayGridInRange(gridDay) ? styles$8.isInRangeAndNotSelected : "";
    const className = this.css(styles$8.monthViewGridDay, isInRangeAndSelectedStyle, isInRangeAndNotSelectedStyle, isSelectedStyle, isTodayStyle, isOutOfRangeStyle, disabledStyle);
    const onClick = () => __awaiter(this, void 0, void 0, function* () {
      return yield this.onDayGridClickAsync(gridDay);
    });
    const onMouseEnter = () => __awaiter(this, void 0, void 0, function* () {
      return yield this.onDayGridMouseEnterAsync(gridDay);
    });
    return /*#__PURE__*/React.createElement("div", {
      key: String(gridDay.getTime()),
      className: className,
      onMouseEnter: onMouseEnter,
      onClick: onClick
    }, /*#__PURE__*/React.createElement("span", null, DateRangeInput.getDayOfMonth(gridDay.getTime())));
  }
  renderDateRangePicker() {
    const style = this.props.expanded ? {
      top: `${this.state.absolutePositionTop}px`
    } : {};
    const monthName = new Intl.DateTimeFormat(DateRangeInputLocalizer$1.language, {
      month: "long"
    }).format(this.state.activeMonthView);
    const year = this.state.activeMonthView.getFullYear();
    const expandedStyle = this.props.expanded ? "" : styles$8.dateRangeInputExpanded;
    return /*#__PURE__*/React.createElement("div", {
      ref: this._datePickerRef,
      className: this.css(styles$8.dateRangeInput, this.props.className, expandedStyle),
      style: style
    }, this.displayDisabledDaysHint && /*#__PURE__*/React.createElement("div", {
      className: styles$8.disabledDayHint
    }, /*#__PURE__*/React.createElement("label", null, this.disabledDaysHint)), /*#__PURE__*/React.createElement("span", {
      className: styles$8.monthName
    }, monthName, " ", year), /*#__PURE__*/React.createElement("div", {
      className: styles$8.monthAction,
      onClick: () => this.onPreviousMonthClickAsync()
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "chevron-up",
      size: IconSize.Normal
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$8.monthAction,
      onClick: () => this.onNextMonthClickAsync()
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "chevron-down",
      size: IconSize.Normal
    })), this.renderWeekDays(), this.gridDays.map(gridDay => this.renderDayGrid(gridDay)));
  }
  renderInput() {
    var _a, _b;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      ref: this._inputRef,
      className: this.css("form-control", styles$8.input),
      onClick: () => this.toggleDatePickerAsync()
    }, this.props.icon && /*#__PURE__*/React.createElement(Icon, Object.assign({}, this.props.icon, {
      className: styles$8.icon
    })), /*#__PURE__*/React.createElement("span", null, ((_a = this.startDate) === null || _a === void 0 ? void 0 : _a.toISODateString()) || "-"), /*#__PURE__*/React.createElement("span", {
      className: styles$8.dateSeparator
    }, "-"), /*#__PURE__*/React.createElement("span", null, ((_b = this.endDate) === null || _b === void 0 ? void 0 : _b.toISODateString()) || "-")), this.state.showDatePicker && this.renderDateRangePicker());
  }
  static daysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
  }
  static lastDayInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
  }
  static getStartOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
  }
  static getDayOfMonth(unixTime) {
    return new Date(unixTime).getDate();
  }
  static isValidDateRangeInputValue(dateRangeInputValue) {
    return !!dateRangeInputValue && Array.isArray(dateRangeInputValue) && dateRangeInputValue.length === 2;
  }
  static todayInUnixTime() {
    const now = new Date();
    return DateRangeInput.getStartOfDay(now).getTime();
  }
  static sortDates(value) {
    if (!value) {
      return [null, null];
    }
    const [date1, date2] = value;
    if (date1 && date2) {
      const sorter = (a, b) => a.getTime() - b.getTime();
      return [date1, date2].sort(sorter).map(date => DateRangeInput.getStartOfDay(date));
    }
    if (date1) {
      return [DateRangeInput.getStartOfDay(date1), null];
    }
    if (date2) {
      return [DateRangeInput.getStartOfDay(date2), null];
    }
    return [null, null];
  }
  static isSameDate(d1, d2) {
    if (!d1 || !d2) {
      return false;
    }
    return DateRangeInput.getStartOfDay(d1).getTime() === DateRangeInput.getStartOfDay(d2).getTime();
  }
}

class ReactCropperHelpers {
  constructor(cropperOrRefObject) {
    this.cropperOrRefObject = cropperOrRefObject;
  }
  get cropper() {
    var _a;
    if (this.cropperOrRefObject instanceof CropperJs) {
      return this.cropperOrRefObject;
    }
    if (!((_a = this.cropperOrRefObject.current) === null || _a === void 0 ? void 0 : _a.cropper)) {
      throw new TypeError("Passed reference React.RefObject<ReactCropperElement> is null or undefined");
    }
    return this.cropperOrRefObject.current.cropper;
  }
  get containerWidth() {
    return this.cropper.getContainerData().width;
  }
  get containerHeight() {
    return this.cropper.getContainerData().height;
  }
  get canvasWidth() {
    return this.cropper.getCanvasData().width;
  }
  get canvasHeight() {
    return this.cropper.getCanvasData().height;
  }
  get canvasImageWidth() {
    return this.cropper.getCanvasData().naturalWidth;
  }
  get canvasImageHeight() {
    return this.cropper.getCanvasData().naturalHeight;
  }
  get isImagePortrait() {
    return this.canvasImageHeight >= this.canvasImageWidth;
  }
  get isImageLandscape() {
    return !this.isImagePortrait;
  }
  get isImageHorizontallyOverflowed() {
    return this.canvasWidth > this.containerWidth;
  }
  get isImageHorizontallySmaller() {
    return this.containerWidth > this.canvasWidth;
  }
  get isImageVerticallyOverflowed() {
    return this.canvasHeight > this.containerHeight;
  }
  get isImageVerticallySmaller() {
    return this.containerHeight > this.canvasHeight;
  }
  /**
   * @description this will try to set the cropping area to center
   * of container but if image is not covering the center it
   * will be set to the closest corner to the center
   */
  setCroppingAreaToCenterOfContainerAndMinimize() {
    this.cropper.setCropBoxData({
      left: this.containerWidth / 2,
      top: this.containerHeight / 2,
      width: 0,
      height: 0
    });
  }
  /**
   * @description It will set the location of image based on container.
   * Will not effect in viewMode 1 if cropping area is blocking it.
   * When viewMode is on 1 it will set the location of image based on cropping area.
   * height and width dont effect
   */
  setImageToCenterOfContainer() {
    const left = this.containerWidth / 2 - this.canvasWidth / 2;
    const top = this.containerHeight / 2 - this.canvasHeight / 2;
    this.cropper.setCanvasData({
      left,
      top
    });
  }
  /**
   * @description When viewMode is on 1  and cropping area is covering the image it will be blocked
   */
  setZoomToFit() {
    if (this.isImageLandscape) {
      if (this.isImageHorizontallyOverflowed) {
        const ratio = this.containerWidth / this.canvasImageWidth;
        this.cropper.zoomTo(ratio);
      } else if (this.isImageHorizontallySmaller) {
        const ratio = this.canvasImageWidth / this.containerWidth;
        this.cropper.zoomTo(ratio);
      }
      return;
    }
    if (this.isImageVerticallyOverflowed) {
      const ratio = this.containerHeight / this.canvasImageHeight;
      this.cropper.zoomTo(ratio);
    } else if (this.isImageVerticallySmaller) {
      const ratio = this.canvasImageHeight / this.containerHeight;
      this.cropper.zoomTo(ratio);
    }
    return;
  }
  setCropAreaToImageFullSize() {
    if (!this.cropper) {
      return;
    }
    const canvasData = this.cropper.getCanvasData();
    this.cropper.setCropBoxData({
      left: canvasData.left,
      top: canvasData.top,
      width: this.canvasWidth,
      height: this.canvasHeight
    });
  }
  rotateAndFitToScreen(degree) {
    this.cropper.rotate(degree);
    this.setZoomToFit();
    this.setCroppingAreaToCenterOfContainerAndMinimize();
    this.setImageToCenterOfContainer();
    this.setZoomToFit();
    this.setCropAreaToImageFullSize();
  }
  /**
   * @description this is for situations where image rotation is needed without opening the editor
   * it will create a cropperjs instance and attach it to root element (hidden) and after rotation will return the data
   *
   * @param image image to rotate. Checks for src and if it doesnt exists uses cropperSource param
   * @param degree rotation degree
   * @param cropperSource url for the image, convert the image.id to url and pass it here
   */
  static rotate(image, degree, cropperSource = '') {
    return __awaiter(this, void 0, void 0, function* () {
      return new Promise(resolve => {
        const instaCropperWrapper = document.createElement('div');
        const instaCropper = document.createElement('img');
        instaCropper.style.display = 'block';
        instaCropper.style.maxWidth = '100%';
        instaCropper.style.maxHeight = '100%';
        instaCropperWrapper.style.opacity = "0";
        instaCropperWrapper.style.zIndex = '-1000';
        instaCropperWrapper.style.pointerEvents = 'none';
        instaCropperWrapper.style.position = 'fixed';
        document.getElementById("root").appendChild(instaCropperWrapper);
        instaCropperWrapper.appendChild(instaCropper);
        instaCropper.src = image.src || cropperSource;
        const cropper = new CropperJs(instaCropper, {
          viewMode: 1,
          scalable: false,
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          ready(event) {
            const helper = new ReactCropperHelpers(cropper);
            helper.rotateAndFitToScreen(degree);
            const src = cropper.getCroppedCanvas().toDataURL(image.type) || "";
            cropper.destroy();
            instaCropperWrapper.remove();
            resolve(Object.assign(Object.assign({}, image), {
              src
            }));
          }
        });
      });
    });
  }
}

//Autogenerated
class ImageInputLocalizer extends BaseComponentLocalizer {
  constructor() {
    super([{
      code: "en",
      label: "English"
    }, {
      code: "nb",
      label: "Norsk bokmål"
    }, {
      code: "pl",
      label: "Polski"
    }, {
      code: "sv",
      label: "Svenska"
    }, {
      code: "fi",
      label: "Suomi"
    }, {
      code: "da",
      label: "Dansk"
    }, {
      code: "uk",
      label: "Українська"
    }, {
      code: "ru",
      label: "Русский"
    }], "en");
    //Constants
    this.documentTypeNotSupportedLanguageItemName = `DocumentTypeNotSupported`;
    this.documentTooBigLanguageItemName = `DocumentTooBig`;
    this.saveLanguageItemName = `Save`;
    this.browseLanguageItemName = `Browse`;
    this.rotateLeftLanguageItemName = `RotateLeft`;
    this.rotateRightLanguageItemName = `RotateRight`;
    this.deleteLanguageItemName = `Delete`;
    this.editLanguageItemName = `Edit`;
    this.cameraLanguageItemName = `Camera`;
    this.backLanguageItemName = `Back`;
    this.previewLanguageItemName = `Preview`;
    this.dropItLanguageItemName = `DropIt`;
    this.moveToTopLanguageItemName = `MoveToTop`;
    this.moveUpLanguageItemName = `MoveUp`;
    this.moveDownLanguageItemName = `MoveDown`;
    this.downloadLanguageItemName = `Download`;
    //Initializer
    this.set(this.documentTypeNotSupportedLanguageItemName, {
      language: `en`,
      value: `Document type is not supported, choose file with extension {0}`
    }, {
      language: `uk`,
      value: `Тип документа не підтримується, виберіть файл з розширенням {0}`
    }, {
      language: `sv`,
      value: `Dokumenttyp stöds inte. Välj dokument som är {0}.`
    }, {
      language: `ru`,
      value: `Тип документа не поддерживается, выберите файл с расширением {0}`
    }, {
      language: `pl`,
      value: `Format dokumentu nieprawidłowy. Wybierz dokument {0}`
    }, {
      language: `nb`,
      value: `Dokumenttype støttes ikke. Velg fil med filtypen {0}`
    }, {
      language: `fi`,
      value: `Dokumentin tyyppi ei ole tuettu. Valitse tiedosto, joka on {0}`
    }, {
      language: `da`,
      value: `Dokumenttype understøttes ikke. Vælg fil med udvidelse {0}`
    });
    this.set(this.documentTooBigLanguageItemName, {
      language: `en`,
      value: `Document file is too big`
    }, {
      language: `uk`,
      value: `Файл документа занадто великий`
    }, {
      language: `sv`,
      value: `Dokument filen är för stor`
    }, {
      language: `ru`,
      value: `Файл документа слишком большой`
    }, {
      language: `pl`,
      value: `Dokument jest za duży`
    }, {
      language: `nb`,
      value: `Dokumentfilen er for stor`
    }, {
      language: `fi`,
      value: `Dokumentti tiedosto liian iso`
    }, {
      language: `da`,
      value: `Dokumentfilen er for stor`
    });
    this.set(this.saveLanguageItemName, {
      language: `en`,
      value: `Save`
    }, {
      language: `uk`,
      value: `Зберегти`
    }, {
      language: `sv`,
      value: `Spara`
    }, {
      language: `ru`,
      value: `Сохранить`
    }, {
      language: `pl`,
      value: `Zapisać`
    }, {
      language: `nb`,
      value: `Lagre`
    }, {
      language: `fi`,
      value: `Tallenna`
    }, {
      language: `da`,
      value: `Gemme`
    });
    this.set(this.browseLanguageItemName, {
      language: `en`,
      value: `Browse`
    }, {
      language: `uk`,
      value: `Перегляд`
    }, {
      language: `sv`,
      value: `Bläddra`
    }, {
      language: `ru`,
      value: `Просмотр`
    }, {
      language: `pl`,
      value: `Przeglądaj`
    }, {
      language: `nb`,
      value: `Bla gjennom`
    }, {
      language: `fi`,
      value: `Selaa`
    }, {
      language: `da`,
      value: `Gennemse`
    });
    this.set(this.rotateLeftLanguageItemName, {
      language: `en`,
      value: `Rotate left`
    }, {
      language: `uk`,
      value: `Повернути наліво`
    }, {
      language: `sv`,
      value: `Rotera vänster`
    }, {
      language: `ru`,
      value: `Повернуть налево`
    }, {
      language: `pl`,
      value: `Obrót w lewo`
    }, {
      language: `nb`,
      value: `Rotér mot venstre`
    }, {
      language: `fi`,
      value: `Kierrä vasemmalle`
    }, {
      language: `da`,
      value: `Rotere venstre`
    });
    this.set(this.rotateRightLanguageItemName, {
      language: `en`,
      value: `Rotate right`
    }, {
      language: `uk`,
      value: `Повернути праворуч`
    }, {
      language: `sv`,
      value: `Vrid höger`
    }, {
      language: `ru`,
      value: `Повернуть вправо`
    }, {
      language: `pl`,
      value: `Obróć w prawo`
    }, {
      language: `nb`,
      value: `Roter til høyre`
    }, {
      language: `fi`,
      value: `Kierrä oikealle`
    }, {
      language: `da`,
      value: `Drej til højre`
    });
    this.set(this.deleteLanguageItemName, {
      language: `en`,
      value: `Delete`
    }, {
      language: `uk`,
      value: `Видалити`
    }, {
      language: `sv`,
      value: `Radera`
    }, {
      language: `ru`,
      value: `Удалить`
    }, {
      language: `pl`,
      value: `Kasować`
    }, {
      language: `nb`,
      value: `Slett`
    }, {
      language: `fi`,
      value: `Poista`
    }, {
      language: `da`,
      value: `Slet`
    });
    this.set(this.editLanguageItemName, {
      language: `en`,
      value: `Edit`
    }, {
      language: `uk`,
      value: `Змінити`
    }, {
      language: `sv`,
      value: `Redigera`
    }, {
      language: `ru`,
      value: `Изменить`
    }, {
      language: `pl`,
      value: `Edytować`
    }, {
      language: `nb`,
      value: `Redigere`
    }, {
      language: `fi`,
      value: `Muokkaa`
    }, {
      language: `da`,
      value: `Redigere`
    });
    this.set(this.cameraLanguageItemName, {
      language: `en`,
      value: `Camera`
    }, {
      language: `uk`,
      value: `Камера`
    }, {
      language: `sv`,
      value: `Kamera`
    }, {
      language: `ru`,
      value: `Камера`
    }, {
      language: `pl`,
      value: `Kamera`
    }, {
      language: `nb`,
      value: `Kamera`
    }, {
      language: `fi`,
      value: `Kamera`
    }, {
      language: `da`,
      value: `Kamera`
    });
    this.set(this.backLanguageItemName, {
      language: `en`,
      value: `Back`
    }, {
      language: `uk`,
      value: `Назад`
    }, {
      language: `sv`,
      value: `Tillbaka`
    }, {
      language: `ru`,
      value: `Назад`
    }, {
      language: `pl`,
      value: `Wróć`
    }, {
      language: `nb`,
      value: `Tilbake`
    }, {
      language: `fi`,
      value: `Takaisin`
    }, {
      language: `da`,
      value: `Tilbage`
    });
    this.set(this.previewLanguageItemName, {
      language: `en`,
      value: `Preview`
    }, {
      language: `uk`,
      value: `Переглянути`
    }, {
      language: `sv`,
      value: `Förhandsvisning`
    }, {
      language: `ru`,
      value: `Предпросмотр`
    }, {
      language: `pl`,
      value: `Zapowiedź`
    }, {
      language: `nb`,
      value: `Forhåndsvisning`
    }, {
      language: `fi`,
      value: `Esikatsele`
    }, {
      language: `da`,
      value: `Forhåndsvisning`
    });
    this.set(this.dropItLanguageItemName, {
      language: `en`,
      value: `Drop it`
    }, {
      language: `uk`,
      value: `Перетягніть сюди`
    }, {
      language: `sv`,
      value: `Släppa`
    }, {
      language: `ru`,
      value: `Перетащите сюда`
    }, {
      language: `pl`,
      value: `Upuszczać`
    }, {
      language: `nb`,
      value: `Miste`
    }, {
      language: `fi`,
      value: `Pudota`
    }, {
      language: `da`,
      value: `Dråbe`
    });
    this.set(this.moveToTopLanguageItemName, {
      language: `en`,
      value: `Move to top`
    }, {
      language: `uk`,
      value: `На початок`
    }, {
      language: `sv`,
      value: `Flytta upp`
    }, {
      language: `ru`,
      value: `В начало`
    }, {
      language: `pl`,
      value: `Podnieść`
    }, {
      language: `nb`,
      value: `Flytte opp`
    }, {
      language: `fi`,
      value: `Siirrä huipulle`
    }, {
      language: `da`,
      value: `Flyt til toppen`
    });
    this.set(this.moveUpLanguageItemName, {
      language: `en`,
      value: `Move up`
    }, {
      language: `uk`,
      value: `Піднятися`
    }, {
      language: `sv`,
      value: `Flytta till toppen`
    }, {
      language: `ru`,
      value: `Подняться`
    }, {
      language: `pl`,
      value: `Przejdź do góry`
    }, {
      language: `nb`,
      value: `Flytt til toppen`
    }, {
      language: `fi`,
      value: `Siirrä ylös`
    }, {
      language: `da`,
      value: `Flytte op`
    });
    this.set(this.moveDownLanguageItemName, {
      language: `en`,
      value: `Move below`
    }, {
      language: `uk`,
      value: `Опуститись нижче`
    }, {
      language: `sv`,
      value: `Flytta ner`
    }, {
      language: `ru`,
      value: `Опуститься ниже`
    }, {
      language: `pl`,
      value: `Padnij`
    }, {
      language: `nb`,
      value: `Flytte ned`
    }, {
      language: `fi`,
      value: `Siirrä alas`
    }, {
      language: `da`,
      value: `Flyt ned`
    });
    this.set(this.downloadLanguageItemName, {
      language: `en`,
      value: `Download`
    }, {
      language: `uk`,
      value: `Завантажити`
    }, {
      language: `sv`,
      value: `Ladda ner`
    }, {
      language: `ru`,
      value: `Загрузить`
    }, {
      language: `pl`,
      value: `Pobierz`
    }, {
      language: `nb`,
      value: `Last ned`
    }, {
      language: `fi`,
      value: `Lataa`
    }, {
      language: `da`,
      value: `Hent`
    });
  }
  /**
  /* "DocumentTypeNotSupported" (Document type is not supported, choose file with extension {0})
  */
  get documentTypeNotSupported() {
    return this.get(this.documentTypeNotSupportedLanguageItemName);
  }
  /**
  /* "DocumentTooBig" (Document file is too big)
  */
  get documentTooBig() {
    return this.get(this.documentTooBigLanguageItemName);
  }
  /**
  /* "Save" (Save)
  */
  get save() {
    return this.get(this.saveLanguageItemName);
  }
  /**
  /* "Browse" (Browse)
  */
  get browse() {
    return this.get(this.browseLanguageItemName);
  }
  /**
  /* "RotateLeft" (Rotate left)
  */
  get rotateLeft() {
    return this.get(this.rotateLeftLanguageItemName);
  }
  /**
  /* "RotateRight" (Rotate right)
  */
  get rotateRight() {
    return this.get(this.rotateRightLanguageItemName);
  }
  /**
  /* "Delete" (Delete)
  */
  get delete() {
    return this.get(this.deleteLanguageItemName);
  }
  /**
  /* "Edit" (Edit)
  */
  get edit() {
    return this.get(this.editLanguageItemName);
  }
  /**
  /* "Camera" (Camera)
  */
  get camera() {
    return this.get(this.cameraLanguageItemName);
  }
  /**
  /* "Back" (Back)
  */
  get back() {
    return this.get(this.backLanguageItemName);
  }
  /**
  /* "Preview" (Preview)
  */
  get preview() {
    return this.get(this.previewLanguageItemName);
  }
  /**
  /* "DropIt" (Drop it)
  */
  get dropIt() {
    return this.get(this.dropItLanguageItemName);
  }
  /**
  /* "MoveToTop" (Move to top)
  */
  get moveToTop() {
    return this.get(this.moveToTopLanguageItemName);
  }
  /**
  /* "MoveUp" (Move up)
  */
  get moveUp() {
    return this.get(this.moveUpLanguageItemName);
  }
  /**
  /* "MoveDown" (Move below)
  */
  get moveDown() {
    return this.get(this.moveDownLanguageItemName);
  }
  /**
  /* "Download" (Download)
  */
  get download() {
    return this.get(this.downloadLanguageItemName);
  }
}
//Singleton
var ImageInputLocalizer$1 = new ImageInputLocalizer();

var css_248z$8 = ".cropper-point {\n  width: 10px !important;\n  height: 10px !important;\n  background: white;\n}";
styleInject(css_248z$8);

var css_248z$7 = ".athenaeum-image-input-ImageInput {\n  position: relative;\n  display: flex;\n  flex-direction: column-reverse;\n  padding: 0.5rem;\n  gap: 0.5rem;\n  height: 400px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-fileInput {\n  display: none;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-controlPanel {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-controlPanel .athenaeum-image-input-controlPanelMiniButtonWrap {\n  flex: 1;\n  min-width: 120px;\n  max-width: 150px;\n  display: flex;\n  justify-content: center;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-controlPanel .athenaeum-image-input-controlPanelMiniButtonWrap button:first-child {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  flex: 1;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-controlPanel .athenaeum-image-input-controlPanelMiniButtonWrap button:last-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  flex: 1;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-controlPanel .athenaeum-image-input-controlPanelButton {\n  flex: 1;\n  min-width: 120px;\n  max-width: 150px;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel {\n  flex-grow: 1;\n  display: flex;\n  overflow: hidden;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-dragDropArea {\n  transition: 0.4s all;\n  opacity: 0;\n  pointer-events: none;\n  border: 2px dashed black;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.9);\n  z-index: 100;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-dragDropArea .athenaeum-image-input-dragDropAreaStaticText {\n  pointer-events: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-dragDropArea .athenaeum-image-input-dragDropAreaOverlay {\n  background: rgba(0, 0, 0, 0.1);\n  pointer-events: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-dragDropAreaActive {\n  opacity: 1;\n  pointer-events: fill;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-cropper {\n  flex-grow: 1;\n  overflow: hidden;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-cropper .athenaeum-image-input-reactCropper .athenaeum-image-input-cropper-container .athenaeum-image-input-cropper-crop-box .athenaeum-image-input-cropper-point {\n  width: 10px !important;\n  height: 10px !important;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-listView {\n  flex-grow: 1;\n  overflow-y: auto;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-listView .athenaeum-image-input-listViewContainer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-listView .athenaeum-image-input-listViewItem {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n  padding: 0 0.5rem;\n  margin: 0.5rem;\n  border: 1px solid transparent;\n  overflow-wrap: anywhere;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-listView .athenaeum-image-input-listViewItem:hover {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-listView .athenaeum-image-input-listViewItem .athenaeum-image-input-listViewItemThumbnail {\n  width: 100px;\n  height: 100px;\n  min-width: 100px;\n  min-height: 100px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-listView .athenaeum-image-input-listViewItem .athenaeum-image-input-listViewItemThumbnail img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-listView .athenaeum-image-input-activeListViewItem {\n  border: 1px solid rgba(0, 0, 0, 0.3) !important;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-preview {\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-preview img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.athenaeum-image-input-ImageInput.athenaeum-image-input-fullScreen {\n  background-color: darkgray;\n  z-index: 999;\n  position: fixed;\n  top: 45px;\n  left: 0;\n  margin: 0;\n  padding: 0 0 0.5rem 0;\n  width: 100%;\n  height: calc(100% - 45px);\n}\n.athenaeum-image-input-ImageInput.athenaeum-image-input-fullScreen .athenaeum-image-input-viewPanel .athenaeum-image-input-cropper .athenaeum-image-input-reactCropper .athenaeum-image-input-cropper-container {\n  margin: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.athenaeum-image-input-fillAbsolute, .athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-dragDropArea, .athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-dragDropArea .athenaeum-image-input-dragDropAreaStaticText, .athenaeum-image-input-ImageInput .athenaeum-image-input-viewPanel .athenaeum-image-input-dragDropArea .athenaeum-image-input-dragDropAreaOverlay {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n}\n\n.athenaeum-image-input-minimize {\n  height: 200px;\n}\n\n.athenaeum-image-input-ldsEllipsis {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n.athenaeum-image-input-ldsEllipsis div {\n  position: absolute;\n  top: 33px;\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  background: orange;\n  animation-timing-function: cubic-bezier(0, 1, 1, 0);\n}\n.athenaeum-image-input-ldsEllipsis div:nth-child(1) {\n  left: 8px;\n  animation: athenaeum-image-input-ldsEllipsis1 0.6s infinite;\n}\n.athenaeum-image-input-ldsEllipsis div:nth-child(2) {\n  left: 8px;\n  animation: athenaeum-image-input-ldsEllipsis2 0.6s infinite;\n}\n.athenaeum-image-input-ldsEllipsis div:nth-child(3) {\n  left: 32px;\n  animation: athenaeum-image-input-ldsEllipsis2 0.6s infinite;\n}\n.athenaeum-image-input-ldsEllipsis div:nth-child(4) {\n  left: 56px;\n  animation: athenaeum-image-input-ldsEllipsis3 0.6s infinite;\n}\n@keyframes athenaeum-image-input-ldsEllipsis1 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes athenaeum-image-input-ldsEllipsis3 {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0);\n  }\n}\n@keyframes athenaeum-image-input-ldsEllipsis2 {\n  0% {\n    transform: translate(0, 0);\n  }\n  100% {\n    transform: translate(24px, 0);\n  }\n}\n\n.athenaeum-image-input-uploadingProgress {\n  position: absolute;\n  right: 10px;\n}";
var styles$7 = {"ImageInput":"athenaeum-image-input-ImageInput","fileInput":"athenaeum-image-input-fileInput","controlPanel":"athenaeum-image-input-controlPanel","controlPanelMiniButtonWrap":"athenaeum-image-input-controlPanelMiniButtonWrap","controlPanelButton":"athenaeum-image-input-controlPanelButton","viewPanel":"athenaeum-image-input-viewPanel","dragDropArea":"athenaeum-image-input-dragDropArea","dragDropAreaStaticText":"athenaeum-image-input-dragDropAreaStaticText","dragDropAreaOverlay":"athenaeum-image-input-dragDropAreaOverlay","dragDropAreaActive":"athenaeum-image-input-dragDropAreaActive","cropper":"athenaeum-image-input-cropper","reactCropper":"athenaeum-image-input-reactCropper","cropper-container":"athenaeum-image-input-cropper-container","cropper-crop-box":"athenaeum-image-input-cropper-crop-box","cropper-point":"athenaeum-image-input-cropper-point","listView":"athenaeum-image-input-listView","listViewContainer":"athenaeum-image-input-listViewContainer","listViewItem":"athenaeum-image-input-listViewItem","listViewItemThumbnail":"athenaeum-image-input-listViewItemThumbnail","activeListViewItem":"athenaeum-image-input-activeListViewItem","preview":"athenaeum-image-input-preview","fullScreen":"athenaeum-image-input-fullScreen","fillAbsolute":"athenaeum-image-input-fillAbsolute","minimize":"athenaeum-image-input-minimize","ldsEllipsis":"athenaeum-image-input-ldsEllipsis","ldsEllipsis1":"athenaeum-image-input-ldsEllipsis1","ldsEllipsis2":"athenaeum-image-input-ldsEllipsis2","ldsEllipsis3":"athenaeum-image-input-ldsEllipsis3","uploadingProgress":"athenaeum-image-input-uploadingProgress"};
styleInject(css_248z$7);

var ImageInputView;
(function (ImageInputView) {
  /**
   * If no uploaded files, display nothing.
   * If single-input and uploaded picture, display small preview of the picture.
   * If multi-input and uploaded picture(s), display list of pictures.
   */
  ImageInputView[ImageInputView["Default"] = 0] = "Default";
  /**
   * Display full-screen preview of the selected picture.
   */
  ImageInputView[ImageInputView["Preview"] = 1] = "Preview";
  /**
   * Display full-screen editor of the selected picture.
   */
  ImageInputView[ImageInputView["Edit"] = 2] = "Edit";
})(ImageInputView || (ImageInputView = {}));
class ImageInput extends BaseComponent {
  constructor() {
    super(...arguments);
    this.fileInputRef = /*#__PURE__*/React.createRef();
    this.cameraFileInputRef = /*#__PURE__*/React.createRef();
    this.cropperRef = /*#__PURE__*/React.createRef();
    this.cropperHelper = new ReactCropperHelpers(this.cropperRef);
    this.state = {
      currentView: ImageInputView.Default,
      isDragOver: false,
      previousView: ImageInputView.Default,
      selectedPictureIndex: null,
      pictures: []
    };
  }
  //  Getters
  get hasSelectedPictureIndex() {
    return Comparator.isNumber(this.state.selectedPictureIndex);
  }
  get selectedPictureIndex() {
    return this.state.selectedPictureIndex;
  }
  get currentView() {
    return ImageInput.assertIsImageInputView(this.state.currentView);
  }
  get previousView() {
    return ImageInput.assertIsImageInputView(this.state.previousView);
  }
  get isDragOver() {
    return this.state.isDragOver;
  }
  get editOnAddInSingleMode() {
    return this.props.editOnAddInSingleMode === true;
  }
  get isFullscreen() {
    return this.currentView === ImageInputView.Preview || this.currentView === ImageInputView.Edit;
  }
  get minimizeOnEmpty() {
    return this.props.minimizeOnEmpty === true;
  }
  get multi() {
    return this.props.multi === true;
  }
  get pictures() {
    return this.state.pictures;
  }
  get activePicture() {
    return this.hasSelectedPictureIndex ? this.pictures[this.selectedPictureIndex] : null;
  }
  get cropperSource() {
    if (!this.hasSelectedPictureIndex || !this.activePicture) {
      return "";
    }
    if (this.activePicture.id) {
      if (this.props.imageUrl) {
        return this.props.imageUrl(this.activePicture);
      }
      return this.getImageUrl(this.activePicture);
    }
    return this.activePicture.src;
  }
  get readonly() {
    return this.props.readonly === true;
  }
  getImageUrl(image) {
    return this.props.imageUrl ? this.props.imageUrl(image) : ImageProvider.getImageUrl(image);
  }
  getPreviewName(index) {
    const picture = this.pictures[index];
    if (!picture) {
      return "";
    }
    return picture.name;
  }
  getPreviewSource(index) {
    const picture = this.pictures[index];
    if (!picture) {
      return "";
    }
    if (picture.id) {
      if (this.props.imageUrl) {
        return this.props.imageUrl(picture);
      }
      return this.getImageUrl(picture);
    }
    return picture.src;
  }
  get maxImageRequestSizeInBytes() {
    return this.props.maxImageRequestSizeInBytes || AthenaeumComponentsConstants.maxImageRequestSizeInBytes;
  }
  get acceptedTypes() {
    return this.props.fileTypes && this.props.fileTypes.length ? this.props.fileTypes.join(",") : "image/*";
  }
  //  ViewIfStatements
  get toolbar() {
    var _a, _b, _c, _d;
    switch (this.currentView) {
      case ImageInputView.Default:
        return this.hasSelectedPictureIndex ? (_a = this.props.selectionToolbar) !== null && _a !== void 0 ? _a : ImageInput.defaultSelectionToolbar : (_b = this.props.noSelectionToolbar) !== null && _b !== void 0 ? _b : ImageInput.defaultNoSelectionToolbar;
      case ImageInputView.Preview:
        return (_c = this.props.previewToolbar) !== null && _c !== void 0 ? _c : ImageInput.defaultPreviewToolbar;
      case ImageInputView.Edit:
        return (_d = this.props.editToolbar) !== null && _d !== void 0 ? _d : ImageInput.defaultEditToolbar;
      default:
        throw new TypeError(`Non-existing enum value '${this.currentView}'`);
    }
  }
  get showBackButton() {
    return this.isFullscreen;
  }
  get showSaveButton() {
    return this.currentView === ImageInputView.Edit;
  }
  get miniRotateButtons() {
    // TODO: get from props?
    return this.hasSelectedPictureIndex && this.currentView === ImageInputView.Default;
  }
  //  Control panel button Click Events
  onBrowseButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.fileInputRef) {
        return;
      }
      const ref = this.fileInputRef;
      if (!ref.current) {
        return;
      }
      ref.current.click();
    });
  }
  onCameraButtonClick() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.cameraFileInputRef) {
        return;
      }
      const ref = this.cameraFileInputRef;
      if (!ref.current) {
        return;
      }
      ref.current.click();
    });
  }
  onSaveButtonClickAsync() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.cropperRef.current || this.currentView !== ImageInputView.Edit) {
        return;
      }
      if (!this.hasSelectedPictureIndex || !this.activePicture) {
        return;
      }
      const currentPicture = this.activePicture;
      const newFileModel = Object.assign({}, currentPicture);
      newFileModel.src = ((_a = this.cropperRef.current) === null || _a === void 0 ? void 0 : _a.cropper.getCroppedCanvas().toDataURL()) || "";
      yield this.convertImage(newFileModel, currentPicture);
      yield this.updatePictureAsync(newFileModel, this.selectedPictureIndex);
      yield this.setCurrentViewAsync(this.previousView);
    });
  }
  onEditButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasSelectedPictureIndex) {
        return;
      }
      yield this.setCurrentViewAsync(ImageInputView.Edit);
    });
  }
  onBackButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const newView = this.currentView === ImageInputView.Edit ? this.previousView : ImageInputView.Default;
      yield this.setCurrentViewAsync(newView);
    });
  }
  onPreviewButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasSelectedPictureIndex) {
        return;
      }
      yield this.setCurrentViewAsync(ImageInputView.Preview);
    });
  }
  onDeleteButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasSelectedPictureIndex) {
        return;
      }
      yield this.removePictureAsync(this.selectedPictureIndex);
    });
  }
  onRotateButtonClickAsync(degrees) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.cropperRef.current) {
        return;
      }
      this.cropperHelper.rotateAndFitToScreen(degrees);
    });
  }
  onRotateMiniButtonClickAsync(degrees) {
    return __awaiter(this, void 0, void 0, function* () {
      const selectedPicture = this.pictures[this.selectedPictureIndex];
      const currentIndex = this.selectedPictureIndex;
      const rotated = yield ReactCropperHelpers.rotate(selectedPicture, degrees, this.getPreviewSource(this.selectedPictureIndex));
      yield this.convertImage(rotated, selectedPicture);
      yield this.updatePictureAsync(rotated, currentIndex);
    });
  }
  onMoveToTopButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasSelectedPictureIndex || this.selectedPictureIndex <= 0) {
        return;
      }
      yield this.moveSelectedImageToTopAsync();
    });
  }
  onMoveUpButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasSelectedPictureIndex || this.selectedPictureIndex <= 0) {
        return;
      }
      yield this.moveSelectedImageUpDownAsync(true);
    });
  }
  onMoveDownButtonClickAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.hasSelectedPictureIndex || this.selectedPictureIndex >= this.pictures.length) {
        return;
      }
      yield this.moveSelectedImageUpDownAsync(false);
    });
  }
  onListViewItemClick(index, fileModel) {
    if (!fileModel.isUploading) {
      this.setState({
        selectedPictureIndex: this.hasSelectedPictureIndex && this.selectedPictureIndex === index ? null : index
      });
    }
  }
  //  DragAndDrop Functionality Events
  onImageInputDragEnterAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      if (!this.isDragOver) {
        yield this.setState({
          isDragOver: true
        });
      }
    });
  }
  onDropDownAreaDragEnterAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      if (!this.isDragOver) {
        yield this.setState({
          isDragOver: true
        });
      }
    });
  }
  onDropDownAreaDragOverAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
    });
  }
  onDropDownAreaDragLeaveAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      if (this.isDragOver) {
        yield this.setState({
          isDragOver: false
        });
      }
    });
  }
  onDropDownAreaDropAsync(event) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      event.persist();
      if (this.isDragOver) {
        yield this.setState({
          isDragOver: false
        });
      }
      if (!((_a = event === null || event === void 0 ? void 0 : event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files)) {
        return;
      }
      yield this.addFileListAsync(event.dataTransfer.files);
    });
  }
  onFileInputChangeAsync(event) {
    return __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      if (!event.target.files) {
        return;
      }
      yield this.addFileListAsync(event.target.files);
    });
  }
  initializePicturesAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      let pictures;
      let selectedPictureIndex;
      if (Array.isArray(this.props.pictures) && this.props.pictures.length > 0) {
        pictures = this.props.pictures;
        selectedPictureIndex = typeof this.selectedPictureIndex === "number" ? this.selectedPictureIndex : 0;
      } else if (typeof this.props.pictures === "string") {
        pictures = [new FileModel(this.props.pictures)];
        selectedPictureIndex = 0;
      } else {
        pictures = [];
        selectedPictureIndex = null;
      }
      if (this.props.noAutoSelect) {
        selectedPictureIndex = null;
      }
      yield this.setState({
        pictures: pictures,
        selectedPictureIndex
      });
    });
  }
  //  Logic
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillReceiveProps(nextProps) {
    const _super = Object.create(null, {
      componentWillReceiveProps: {
        get: () => super.componentWillReceiveProps
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const newPictures = !Comparator.isEqual(this.props.pictures, nextProps.pictures);
      yield _super.componentWillReceiveProps.call(this, nextProps);
      if (newPictures) {
        yield this.initializePicturesAsync();
      }
    });
  }
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.initializePicturesAsync();
    });
  }
  setCurrentViewAsync(currentView) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.currentView !== ImageInput.assertIsImageInputView(currentView)) {
        yield this.setState({
          previousView: this.currentView,
          currentView
        });
      }
    });
  }
  handleUncompletedUpload(fileModel) {
    return __awaiter(this, void 0, void 0, function* () {
      const filesState = [...this.state.pictures];
      filesState.remove(fileModel);
      yield this.setState({
        pictures: filesState
      });
    });
  }
  handleCompletedUpload(originalFile, converted) {
    return __awaiter(this, void 0, void 0, function* () {
      const filesState = [...this.state.pictures];
      const index = filesState.indexOf(originalFile);
      if (index > -1) {
        const pictureToReplace = converted !== null && converted !== void 0 ? converted : originalFile;
        pictureToReplace.isUploading = false;
        filesState[index] = pictureToReplace;
        yield this.setState({
          pictures: filesState
        });
      }
    });
  }
  addFileListAsync(fileList) {
    return __awaiter(this, void 0, void 0, function* () {
      let fileListAsArray = Array.from(fileList);
      const ref = this.fileInputRef;
      if (ref.current) {
        ref.current.value = "";
      }
      if (fileListAsArray.length === 0) {
        return;
      }
      if (!this.multi && fileListAsArray.length > 1) {
        fileListAsArray = [fileListAsArray[0]];
      }
      let fileModels = yield Promise.all(fileListAsArray.map(file => __awaiter(this, void 0, void 0, function* () {
        return yield ImageInput.fileToFileModel(file);
      })));
      fileModels = fileModels.filter(fileModel => {
        if (fileModel.size < this.maxImageRequestSizeInBytes) {
          return true;
        }
        ch.alertErrorAsync(ImageInputLocalizer$1.documentTooBig, true);
        return false;
      });
      yield Promise.all(fileModels.map(fileModel => __awaiter(this, void 0, void 0, function* () {
        yield this.convertImage(fileModel);
      })));
      if (this.state.pictures.length > 0) {
        yield this.addPicturesAsync();
      }
    });
  }
  convertImage(fileModel, originalFile = null) {
    return __awaiter(this, void 0, void 0, function* () {
      const filesState = [...this.state.pictures];
      const index = originalFile ? filesState.indexOf(originalFile) : -1;
      fileModel.isUploading = true;
      if (index > -1) {
        filesState[index] = fileModel;
      } else {
        if (this.multi) {
          filesState.push(fileModel);
        } else {
          filesState.splice(0, 1, fileModel);
        }
      }
      yield this.setState({
        pictures: filesState
      });
      let converted = null;
      if (this.props.convertImage) {
        converted = yield this.props.convertImage(fileModel);
        if (converted === null) {
          yield this.handleUncompletedUpload(fileModel);
          return;
        }
      }
      yield this.handleCompletedUpload(fileModel, converted);
    });
  }
  addPicturesAsync() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      if (this.readonly) {
        throw new Error(`Cannot add pictures to readonly ImageInput`);
      }
      if (this.props.onChange) {
        if (this.multi) {
          yield this.setState({
            selectedPictureIndex: (_a = this.selectedPictureIndex) !== null && _a !== void 0 ? _a : 0
          });
          yield this.setCurrentViewAsync(ImageInputView.Default);
          yield this.props.onChange(this, [...this.state.pictures]);
        } else {
          yield this.setState({
            selectedPictureIndex: 0
          });
          const selectedView = this.editOnAddInSingleMode ? ImageInputView.Edit : ImageInputView.Default;
          yield this.setCurrentViewAsync(selectedView);
          yield this.props.onChange(this, this.state.pictures.slice(0, 1));
        }
      }
    });
  }
  updatePictureAsync(fileModel, index) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.readonly) {
        throw new Error(`Cannot update pictures of readonly ImageInput`);
      }
      const pictures = this.pictures.map((picture, i) => {
        if (index === i) {
          return fileModel;
        }
        return picture;
      });
      if (this.props.onChange) {
        yield this.props.onChange(this, pictures);
      }
    });
  }
  changeImageEnabledAsync(enabled, index) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.readonly) {
        throw new Error(`Cannot change enabled state of pictures in readonly ImageInput`);
      }
      if (index < 0 || index >= this.pictures.length) {
        throw new Error(`Invalid index: ${index}`);
      }
      // Update the enabled property
      this.pictures[index].enabled = enabled;
      yield this.setState({
        pictures: [...this.pictures]
      });
      if (this.props.onChange) {
        yield this.props.onChange(this, this.pictures);
      }
    });
  }
  moveSelectedImageToTopAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.readonly) {
        throw new Error(`Cannot move pictures of readonly ImageInput`);
      }
      if (!this.hasSelectedPictureIndex || this.selectedPictureIndex === 0) {
        return;
      }
      const oldImage = this.pictures[this.selectedPictureIndex];
      const imagesAfter = this.pictures.slice();
      imagesAfter.remove(oldImage);
      yield this.setState({
        pictures: [oldImage, ...imagesAfter],
        selectedPictureIndex: 0
      });
      if (this.props.onChange) {
        yield this.props.onChange(this, this.pictures);
      }
    });
  }
  moveSelectedImageUpDownAsync(up) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.readonly) {
        throw new Error(`Cannot move pictures of readonly ImageInput`);
      }
      if (!this.hasSelectedPictureIndex || up && this.selectedPictureIndex === 0 || !up && this.selectedPictureIndex === this.pictures.length - 1) {
        return;
      }
      const oldIndex = this.selectedPictureIndex;
      const oldImage = this.pictures[oldIndex];
      const newIndex = up ? oldIndex - 1 : oldIndex + 1;
      this.pictures[oldIndex] = this.pictures[newIndex];
      this.pictures[newIndex] = oldImage;
      if (this.props.onChange) {
        yield this.props.onChange(this, this.pictures);
      }
      yield this.setState({
        selectedPictureIndex: newIndex
      });
    });
  }
  removePictureAsync(index) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.readonly) {
        throw new Error(`Cannot remove pictures of readonly ImageInput`);
      }
      const pictures = [...this.pictures];
      pictures.splice(index, 1);
      let newIndex = pictures.length <= 0 ? null : index <= 0 ? 0 : index - 1;
      if (newIndex) {
        newIndex = pictures[newIndex].isUploading ? null : newIndex;
      }
      yield this.setState({
        selectedPictureIndex: newIndex
      });
      yield this.setCurrentViewAsync(ImageInputView.Default);
      if (this.props.onChange) {
        yield this.props.onChange(this, pictures);
      }
    });
  }
  //  Renders
  renderControlPanel() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, !this.readonly && (this.toolbar.rotateLeftButton || this.toolbar.rotateRightButton) && (this.miniRotateButtons ? ( /*#__PURE__*/React.createElement("div", {
      className: styles$7.controlPanelMiniButtonWrap
    }, this.toolbar.rotateLeftButton && ( /*#__PURE__*/React.createElement(Button, {
      small: true,
      icon: {
        name: "undo"
      },
      type: ButtonType.Info,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onRotateMiniButtonClickAsync(-90);
      })
    })), this.toolbar.rotateRightButton && ( /*#__PURE__*/React.createElement(Button, {
      small: true,
      icon: {
        name: "redo"
      },
      type: ButtonType.Info,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onRotateMiniButtonClickAsync(90);
      })
    })))) : ( /*#__PURE__*/React.createElement(React.Fragment, null, this.toolbar.rotateLeftButton && ( /*#__PURE__*/React.createElement(Button, {
      small: true,
      className: styles$7.controlPanelButton,
      icon: {
        name: "undo"
      },
      type: ButtonType.Light,
      label: ImageInputLocalizer$1.rotateLeft,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onRotateButtonClickAsync(-90);
      })
    })), this.toolbar.rotateRightButton && ( /*#__PURE__*/React.createElement(Button, {
      small: true,
      className: styles$7.controlPanelButton,
      icon: {
        name: "redo"
      },
      type: ButtonType.Light,
      label: ImageInputLocalizer$1.rotateRight,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onRotateButtonClickAsync(90);
      })
    }))))), !this.readonly && this.toolbar.moveToTopButton && ( /*#__PURE__*/React.createElement(Button, {
      small: true,
      className: styles$7.controlPanelButton,
      icon: {
        name: "level-up"
      },
      type: ButtonType.Info,
      label: ImageInputLocalizer$1.moveToTop,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onMoveToTopButtonClickAsync();
      })
    })), !this.readonly && this.toolbar.moveUpButton && ( /*#__PURE__*/React.createElement(Button, {
      small: true,
      className: styles$7.controlPanelButton,
      icon: {
        name: "arrow-up"
      },
      type: ButtonType.Info,
      label: ImageInputLocalizer$1.moveUp,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onMoveUpButtonClickAsync();
      })
    })), !this.readonly && this.toolbar.moveDownButton && ( /*#__PURE__*/React.createElement(Button, {
      small: true,
      className: styles$7.controlPanelButton,
      icon: {
        name: "arrow-down"
      },
      type: ButtonType.Info,
      label: ImageInputLocalizer$1.moveDown,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onMoveDownButtonClickAsync();
      })
    })), !this.readonly && this.toolbar.editButton && ( /*#__PURE__*/React.createElement(Button, {
      small: true,
      className: styles$7.controlPanelButton,
      icon: {
        name: "crop"
      },
      type: ButtonType.Info,
      label: ImageInputLocalizer$1.edit,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onEditButtonClickAsync();
      })
    })), this.toolbar.previewButton && (!!this.activePicture && this.toolbar.previewInNewTab ? ( /*#__PURE__*/React.createElement("a", {
      href: this.activePicture.src,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React.createElement(Button, {
      small: true,
      className: styles$7.controlPanelButton,
      icon: {
        name: "eye"
      },
      type: ButtonType.Info,
      label: ImageInputLocalizer$1.preview
    }))) : ( /*#__PURE__*/React.createElement(Button, {
      small: true,
      className: styles$7.controlPanelButton,
      icon: {
        name: "eye"
      },
      type: ButtonType.Info,
      label: ImageInputLocalizer$1.preview,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onPreviewButtonClickAsync();
      })
    }))), !!this.activePicture && this.toolbar.downloadButton && ( /*#__PURE__*/React.createElement("a", {
      href: this.activePicture.src,
      download: true
    }, /*#__PURE__*/React.createElement(Button, {
      small: true,
      className: styles$7.controlPanelButton,
      icon: {
        name: "download"
      },
      type: ButtonType.Info,
      label: ImageInputLocalizer$1.download
    }))), !this.readonly && this.toolbar.uploadButton && ( /*#__PURE__*/React.createElement(Button, {
      small: true,
      right: true,
      className: styles$7.controlPanelButton,
      icon: {
        name: "file-import"
      },
      type: ButtonType.Orange,
      label: ImageInputLocalizer$1.browse,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onBrowseButtonClickAsync();
      })
    })), !this.readonly && this.toolbar.takePictureButton && ( /*#__PURE__*/React.createElement(Button, {
      small: true,
      right: true,
      className: styles$7.controlPanelButton,
      icon: {
        name: "camera"
      },
      type: ButtonType.Orange,
      label: ImageInputLocalizer$1.camera,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onCameraButtonClick();
      })
    })), !this.readonly && this.showSaveButton && ( /*#__PURE__*/React.createElement(Button, {
      small: true,
      right: true,
      className: styles$7.controlPanelButton,
      icon: {
        name: "save"
      },
      type: ButtonType.Success,
      label: ImageInputLocalizer$1.save,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onSaveButtonClickAsync();
      })
    })), this.showBackButton && ( /*#__PURE__*/React.createElement(Button, {
      small: true,
      className: styles$7.controlPanelButton,
      icon: {
        name: "arrow-left"
      },
      type: ButtonType.Info,
      label: ImageInputLocalizer$1.back,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onBackButtonClickAsync();
      })
    })), !this.readonly && this.toolbar.deleteButton && ( /*#__PURE__*/React.createElement(Button, {
      small: true,
      className: styles$7.controlPanelButton,
      icon: {
        name: "trash"
      },
      type: ButtonType.Warning,
      label: ImageInputLocalizer$1.delete,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.onDeleteButtonClickAsync();
      })
    })));
  }
  renderListViewItem(fileModel, index) {
    const activeListViewItemStyle = this.hasSelectedPictureIndex && this.selectedPictureIndex === index && styles$7.activeListViewItem;
    const key = `${index}_${fileModel.id}_${fileModel.name}`;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$7.listViewContainer,
      key: key
    }, this.props.enableImageCheckbox && index !== 0 && ( /*#__PURE__*/React.createElement(Checkbox, {
      value: fileModel.enabled,
      onChange: (_, enabled) => __awaiter(this, void 0, void 0, function* () {
        return yield this.changeImageEnabledAsync(enabled, index);
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$7.listViewItem, activeListViewItemStyle),
      onClick: () => this.onListViewItemClick(index, fileModel)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$7.listViewItemThumbnail
    }, /*#__PURE__*/React.createElement("img", {
      src: this.getPreviewSource(index),
      alt: this.getPreviewName(index)
    })), this.getPreviewName(index), fileModel.isUploading && ( /*#__PURE__*/React.createElement("div", {
      className: styles$7.uploadingProgress
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$7.ldsEllipsis
    }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null))))));
  }
  renderListView() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$7.listView
    }, this.pictures.map((picture, index) => this.renderListViewItem(picture, index)));
  }
  renderPreviewPanel() {
    var _a;
    const index = (_a = this.selectedPictureIndex) !== null && _a !== void 0 ? _a : 0;
    const src = this.getPreviewSource(index);
    const alt = this.getPreviewName(index);
    return /*#__PURE__*/React.createElement("div", {
      className: styles$7.preview
    }, /*#__PURE__*/React.createElement("img", {
      src: src,
      alt: alt
    }));
  }
  renderCropperPanel() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$7.cropper
    }, /*#__PURE__*/React.createElement(Cropper, {
      ref: this.cropperRef,
      className: styles$7.reactCropper,
      style: {
        height: "100%",
        width: "100%"
      },
      src: this.cropperSource,
      viewMode: 1,
      guides: false,
      ready: () => this.cropperHelper.setCropAreaToImageFullSize()
    }));
  }
  render() {
    const minimizeStyle = this.minimizeOnEmpty && this.pictures.length <= 0 ? styles$7.minimize : null;
    const fullScreenStyle = this.isFullscreen ? styles$7.fullScreen : null;
    return /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$7.ImageInput, minimizeStyle, fullScreenStyle, this.props.className),
      onDragEnter: event => this.onImageInputDragEnterAsync(event)
    }, /*#__PURE__*/React.createElement("input", {
      ref: this.fileInputRef,
      className: styles$7.fileInput,
      type: "file",
      accept: this.acceptedTypes,
      multiple: this.multi,
      onChange: event => this.onFileInputChangeAsync(event)
    }), /*#__PURE__*/React.createElement("input", {
      ref: this.cameraFileInputRef,
      className: styles$7.fileInput,
      type: "file",
      accept: this.acceptedTypes,
      capture: "environment",
      multiple: this.multi,
      onChange: event => this.onFileInputChangeAsync(event)
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$7.controlPanel
    }, this.renderControlPanel()), /*#__PURE__*/React.createElement(NoSwipeNavigation, {
      className: styles$7.viewPanel
    }, /*#__PURE__*/React.createElement("div", {
      className: this.css(styles$7.dragDropArea, this.isDragOver && styles$7.dragDropAreaActive),
      onDrop: event => this.onDropDownAreaDropAsync(event),
      onDragOver: event => this.onDropDownAreaDragOverAsync(event),
      onDragEnter: event => this.onDropDownAreaDragEnterAsync(event),
      onDragLeave: event => this.onDropDownAreaDragLeaveAsync(event)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$7.dragDropAreaOverlay
    }, ImageInputLocalizer$1.dropIt)), this.currentView === ImageInputView.Edit && this.renderCropperPanel(), this.multi && this.currentView === ImageInputView.Default && this.renderListView(), (this.currentView === ImageInputView.Preview || !this.multi && this.currentView === ImageInputView.Default && this.hasSelectedPictureIndex) && this.renderPreviewPanel()));
  }
  //  Statics
  /**
   * Following functionality is enabled:
   * {@link IIMageInputToolbar.uploadButton}
   * {@link IIMageInputToolbar.takePictureButton}
   */
  static get defaultNoSelectionToolbar() {
    return {
      takePictureButton: true,
      uploadButton: true
    };
  }
  /**
   * Following functionality is enabled:
   * {@link IIMageInputToolbar.rotateLeftButton}
   * {@link IIMageInputToolbar.rotateRightButton}
   * {@link IIMageInputToolbar.editButton}
   * {@link IIMageInputToolbar.previewButton}
   * {@link IIMageInputToolbar.uploadButton}
   * {@link IIMageInputToolbar.takePictureButton}
   * {@link IIMageInputToolbar.deleteButton}
   */
  static get defaultSelectionToolbar() {
    return {
      deleteButton: true,
      editButton: true,
      previewButton: true,
      rotateLeftButton: true,
      rotateRightButton: true,
      takePictureButton: true,
      uploadButton: true
    };
  }
  /**
   * Following functionality is enabled:
   * {@link IIMageInputToolbar.editButton}
   * {@link IIMageInputToolbar.uploadButton}
   * {@link IIMageInputToolbar.takePictureButton}
   * {@link IIMageInputToolbar.deleteButton}.
   *
   * A "Back"-button which returns the user back to the previous view is also displayed.
   */
  static get defaultPreviewToolbar() {
    return {
      deleteButton: true,
      editButton: true,
      uploadButton: true,
      takePictureButton: true
    };
  }
  /**
   * Following functionality is enabled:
   * {@link IIMageInputToolbar.rotateLeftButton}
   * {@link IIMageInputToolbar.rotateRightButton}
   * {@link IIMageInputToolbar.deleteButton}.
   *
   * A "Save"-button which saves the changes and a "Back"-button which returns the user back to the previous view are also displayed.
   */
  static get defaultEditToolbar() {
    return {
      rotateLeftButton: true,
      rotateRightButton: true,
      deleteButton: true
    };
  }
  static fileToFileModel(file) {
    return __awaiter(this, void 0, void 0, function* () {
      const fileData = yield ImageInput.readFile(file);
      const fileModel = new FileModel(fileData);
      fileModel.type = file.type;
      fileModel.name = file.name;
      fileModel.lastModified = new Date(file.lastModified);
      fileModel.size = file.size;
      return fileModel;
    });
  }
  static readFile(file) {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        var _a, _b;
        if ((_a = e.target) === null || _a === void 0 ? void 0 : _a.result) {
          resolve((_b = e.target) === null || _b === void 0 ? void 0 : _b.result);
        }
      };
      reader.onerror = function () {
        resolve(null);
      };
    });
  }
  static assertIsImageInputView(value) {
    switch (value) {
      case ImageInputView.Default:
        return ImageInputView.Default;
      case ImageInputView.Preview:
        return ImageInputView.Preview;
      case ImageInputView.Edit:
        return ImageInputView.Edit;
      default:
        throw new TypeError("value is not of type ImageInputView");
    }
  }
}

var css_248z$6 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-global-search-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-global-search-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-global-search-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-global-search-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-global-search-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-global-search-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-global-search-scrollable {\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 100%;\n  width: 100%;\n  position: relative;\n  padding: 0;\n  margin: 0;\n  border: none;\n  background-color: transparent;\n}\n\n.athenaeum-global-search-searchMainWrapper {\n  position: relative;\n  color: white;\n}\n.athenaeum-global-search-searchMainWrapper .athenaeum-global-search-mainIconWapper {\n  padding: 8px 6px;\n  cursor: pointer;\n}\n.athenaeum-global-search-searchMainWrapper .athenaeum-global-search-searchFormWrapper {\n  color: white;\n  font-weight: 600;\n  position: absolute;\n  right: 0;\n  top: 37px;\n  margin: 0;\n  background-color: rgb(254, 80, 0);\n  border-radius: 5px;\n  height: auto;\n  z-index: 11;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n  min-width: 300px;\n  max-width: 400px;\n  max-height: 60vh;\n}\n@media screen and (max-width: 480px) {\n  .athenaeum-global-search-searchMainWrapper .athenaeum-global-search-searchFormWrapper {\n    position: fixed;\n    top: 45px;\n    left: 0;\n    width: 100%;\n  }\n}\n.athenaeum-global-search-searchMainWrapper .athenaeum-global-search-footerButtons {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 10px;\n}";
var styles$6 = {"font-renta":"athenaeum-global-search-font-renta","color-schema-renta_black":"athenaeum-global-search-color-schema-renta_black","color-schema-renta_white":"athenaeum-global-search-color-schema-renta_white","color-schema-renta_orange":"athenaeum-global-search-color-schema-renta_orange","color-schema-renta_green":"athenaeum-global-search-color-schema-renta_green","color-schema-renta_blue":"athenaeum-global-search-color-schema-renta_blue","scrollable":"athenaeum-global-search-scrollable","searchMainWrapper":"athenaeum-global-search-searchMainWrapper","mainIconWapper":"athenaeum-global-search-mainIconWapper","searchFormWrapper":"athenaeum-global-search-searchFormWrapper","footerButtons":"athenaeum-global-search-footerButtons"};
styleInject(css_248z$6);

var css_248z$5 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-global-search-form-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-global-search-form-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-global-search-form-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-global-search-form-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-global-search-form-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-global-search-form-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-global-search-form-searchFormWrapper {\n  width: 100%;\n}\n.athenaeum-global-search-form-searchFormWrapper .athenaeum-global-search-form-searchForm {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  width: 100%;\n}\n.athenaeum-global-search-form-searchFormWrapper .athenaeum-global-search-form-searchForm .athenaeum-global-search-form-searchProvidersList {\n  color: white;\n}\n.athenaeum-global-search-form-searchFormWrapper .athenaeum-global-search-form-searchForm .athenaeum-global-search-form-searchButtonsContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: stretch;\n}\n.athenaeum-global-search-form-searchFormWrapper .athenaeum-global-search-form-searchForm .athenaeum-global-search-form-searchButtonsContainer .athenaeum-global-search-form-searchButton {\n  flex: 1;\n}";
var styles$5 = {"font-renta":"athenaeum-global-search-form-font-renta","color-schema-renta_black":"athenaeum-global-search-form-color-schema-renta_black","color-schema-renta_white":"athenaeum-global-search-form-color-schema-renta_white","color-schema-renta_orange":"athenaeum-global-search-form-color-schema-renta_orange","color-schema-renta_green":"athenaeum-global-search-form-color-schema-renta_green","color-schema-renta_blue":"athenaeum-global-search-form-color-schema-renta_blue","searchFormWrapper":"athenaeum-global-search-form-searchFormWrapper","searchForm":"athenaeum-global-search-form-searchForm","searchProvidersList":"athenaeum-global-search-form-searchProvidersList","searchButtonsContainer":"athenaeum-global-search-form-searchButtonsContainer","searchButton":"athenaeum-global-search-form-searchButton"};
styleInject(css_248z$5);

const GlobalSearchForm = props => {
  const [currentSearchTerm, setSearchTerm] = useState(props.searchTerm || "");
  const [currentSelectedProviders, setSelectedProviders] = useState(props.selectedProviders || []);
  const [searchProvidersList, setSearchProvidersList] = useState([]);
  const onSearchSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
    if (currentSearchTerm.length >= 3) {
      props.onSearch(currentSearchTerm, currentSelectedProviders);
    }
  });
  const onClearClicked = () => __awaiter(void 0, void 0, void 0, function* () {
    setSearchTerm("");
    setSelectedProviders([]);
    props.onClear && (yield props.onClear());
  });
  useEffect(() => {
    setSearchTerm(props.searchTerm || "");
    setSelectedProviders(props.selectedProviders || []);
  }, [props.searchTerm, props.selectedProviders]);
  useEffect(() => {
    var _a;
    const options = (_a = props.searchProviders) === null || _a === void 0 ? void 0 : _a.map(provider => {
      return {
        id: provider.id,
        name: provider.name
      };
    });
    setSearchProvidersList(options);
  }, [props.searchProviders]);
  return /*#__PURE__*/React.createElement("div", {
    id: "global-search-form",
    className: styles$5.searchFormWrapper
  }, /*#__PURE__*/React.createElement(Form, {
    submitOnEnter: true,
    onSubmit: () => __awaiter(void 0, void 0, void 0, function* () {
      return yield onSearchSubmit();
    }),
    className: styles$5.searchFormWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$5.searchForm
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: TopNavLocalizer$1.searchForLabel,
    placeholder: props.searchPlaceHolder,
    className: styles$5.searchInput,
    model: {
      value: currentSearchTerm
    },
    onChange: (_, value) => __awaiter(void 0, void 0, void 0, function* () {
      return setSearchTerm(value);
    })
  }), searchProvidersList.length > 0 && /*#__PURE__*/React.createElement(Dropdown, {
    noSubtext: true,
    noWrap: true,
    multiple: true,
    filterMinLength: 10,
    type: DropdownType.List,
    styleSchema: DropdownSchema.Widget,
    label: TopNavLocalizer$1.searchInLabel,
    expanded: true,
    selectedItems: currentSelectedProviders,
    items: searchProvidersList,
    onChange: (sender, item) => __awaiter(void 0, void 0, void 0, function* () {
      setSelectedProviders(sender.selectedItems.map(item => item.id));
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$5.searchButtonsContainer
  }, /*#__PURE__*/React.createElement(Button, {
    submit: true,
    className: styles$5.searchButton,
    icon: {
      name: "search"
    },
    label: TopNavLocalizer$1.searchButton
  }), /*#__PURE__*/React.createElement(Button, {
    className: styles$5.clearButton,
    icon: {
      name: "times"
    },
    label: TopNavLocalizer$1.searchClear,
    onClick: () => __awaiter(void 0, void 0, void 0, function* () {
      return yield onClearClicked();
    })
  })))));
};

const GlobalSearchContext = /*#__PURE__*/React.createContext({
  searchOptions: [],
  searchTerm: "",
  searchProviders: [],
  resultsLimit: 0,
  results: {},
  isLoading: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setContext: newContext => {
    throw new Error("setContext function must be overridden");
  }
});

var css_248z$4 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-details-overlay-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-details-overlay-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-details-overlay-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-details-overlay-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-details-overlay-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-details-overlay-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n@keyframes athenaeum-details-overlay-fadeInKeyframes {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes athenaeum-details-overlay-fadeOutKeyframes {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n.athenaeum-details-overlay-fadeIn {\n  animation: athenaeum-details-overlay-fadeInKeyframes 0.3s forwards;\n  animation-timing-function: ease-in-out;\n}\n\n.athenaeum-details-overlay-fadeOut {\n  animation: athenaeum-details-overlay-fadeOutKeyframes 0.3s forwards;\n  animation-fill-mode: forwards;\n  animation-timing-function: ease-in-out;\n}\n\n.athenaeum-details-overlay-hidden {\n  display: none;\n}";
var styles$4 = {"font-renta":"athenaeum-details-overlay-font-renta","color-schema-renta_black":"athenaeum-details-overlay-color-schema-renta_black","color-schema-renta_white":"athenaeum-details-overlay-color-schema-renta_white","color-schema-renta_orange":"athenaeum-details-overlay-color-schema-renta_orange","color-schema-renta_green":"athenaeum-details-overlay-color-schema-renta_green","color-schema-renta_blue":"athenaeum-details-overlay-color-schema-renta_blue","fadeIn":"athenaeum-details-overlay-fadeIn","fadeInKeyframes":"athenaeum-details-overlay-fadeInKeyframes","fadeOut":"athenaeum-details-overlay-fadeOut","fadeOutKeyframes":"athenaeum-details-overlay-fadeOutKeyframes","hidden":"athenaeum-details-overlay-hidden"};
styleInject(css_248z$4);

const DetailsOverlay = props => {
  const [animationEnd, setAnimationEnd] = useState(false);
  const handleAnimationEnd = () => {
    setAnimationEnd(true);
  };
  return /*#__PURE__*/React.createElement("div", null, (props.overlayOpen || !props.overlayOpen && animationEnd) && ( /*#__PURE__*/React.createElement("div", {
    className: `${props.overlayOpen ? styles$4.fadeIn : styles$4.fadeOut} ${!props.overlayOpen && animationEnd ? styles$4.hidden : ''}`,
    onAnimationEnd: () => handleAnimationEnd()
  }, props.overlayContent)), (!props.overlayOpen || props.overlayOpen && animationEnd) && ( /*#__PURE__*/React.createElement("div", {
    className: `${!props.overlayOpen ? styles$4.fadeIn : styles$4.fadeOut} ${props.overlayOpen && animationEnd ? styles$4.hidden : ''}`,
    onAnimationEnd: () => handleAnimationEnd()
  }, props.mainContent)));
};

var css_248z$3 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-global-search-results-item-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-global-search-results-item-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-global-search-results-item-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-global-search-results-item-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-global-search-results-item-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-global-search-results-item-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-global-search-results-item-globaSearchResultsItem {\n  display: flex;\n  flex-direction: column;\n  margin: 5px 20px;\n  flex-wrap: wrap;\n  cursor: pointer;\n}\n.athenaeum-global-search-results-item-globaSearchResultsItem .athenaeum-global-search-results-item-resultLabel {\n  border-bottom: 1px solid rgba(234, 60, 0, 0.9);\n  padding: 5px;\n}\n.athenaeum-global-search-results-item-globaSearchResultsItem .athenaeum-global-search-results-item-resultMatches {\n  padding: 5px 20px;\n}\n.athenaeum-global-search-results-item-globaSearchResultsItem .athenaeum-global-search-results-item-resultMatches .athenaeum-global-search-results-item-matchLabel {\n  color: rgb(65, 64, 66);\n  font-size: 0.8em;\n  margin-right: 10px;\n}\n.athenaeum-global-search-results-item-globaSearchResultsItem .athenaeum-global-search-results-item-resultMatches .athenaeum-global-search-results-item-highlight {\n  font-weight: bold;\n}";
var styles$3 = {"font-renta":"athenaeum-global-search-results-item-font-renta","color-schema-renta_black":"athenaeum-global-search-results-item-color-schema-renta_black","color-schema-renta_white":"athenaeum-global-search-results-item-color-schema-renta_white","color-schema-renta_orange":"athenaeum-global-search-results-item-color-schema-renta_orange","color-schema-renta_green":"athenaeum-global-search-results-item-color-schema-renta_green","color-schema-renta_blue":"athenaeum-global-search-results-item-color-schema-renta_blue","globaSearchResultsItem":"athenaeum-global-search-results-item-globaSearchResultsItem","resultLabel":"athenaeum-global-search-results-item-resultLabel","resultMatches":"athenaeum-global-search-results-item-resultMatches","matchLabel":"athenaeum-global-search-results-item-matchLabel","highlight":"athenaeum-global-search-results-item-highlight"};
styleInject(css_248z$3);

/**
 * [Note]
 * This is just a sample component to show how the search results can be rendered.
 * It includes basic logic for highlighting of the search term in the results.
 *
 * [ToDo]
 * Improve and extend the component to correctly support the role of default renderer for the search results for as many data types as possible/needed.
 */
const GlobalSearchResultsItem = props => {
  const marginCharacters = 20;
  const [match, setMatch] = useState({});
  const flattenObject = inputObj => {
    const output = {};
    Object.keys(inputObj).forEach(key => {
      if (typeof inputObj[key] == 'object' && inputObj[key] !== null) {
        const flattened = flattenObject(inputObj[key]);
        Object.keys(flattened).forEach(flattenedKey => {
          output[`${key}.${flattenedKey}`] = flattened[flattenedKey];
        });
      } else {
        output[key] = inputObj[key];
      }
    });
    return output;
  };
  const showTitle = item => {
    for (const key of ["title", "name", "fullName", "email"]) {
      const value = item[key];
      if (Object.hasOwnProperty.call(item, key) && value && value.length > 0) {
        return value;
      }
    }
    return "  N/A  ";
  };
  const showValue = value => {
    const index = value.toLowerCase().indexOf(props.searchTerm.toLowerCase());
    const start = index - marginCharacters;
    const end = index + props.searchTerm.length + marginCharacters;
    let before = value.substring(start, index);
    const match = value.substring(index, index + props.searchTerm.length);
    let after = value.substring(index + props.searchTerm.length, end);
    before = start > 0 ? "..." + before : before;
    after = end < value.length ? after + "..." : after;
    return /*#__PURE__*/React.createElement("span", null, before, /*#__PURE__*/React.createElement("span", {
      className: styles$3.highlight
    }, match), after);
  };
  useEffect(() => {
    if (props.compact) return;
    const matches = {};
    const flatItem = flattenObject(props.item);
    const keysToCheck = props.searchFields && props.searchFields.length > 0 ? props.searchFields : Object.keys(flatItem);
    keysToCheck.forEach(key => {
      const value = flatItem[key];
      if (typeof value === 'string' && value.toLowerCase().includes(props.searchTerm.toLowerCase())) {
        matches[key] = value;
      }
    });
    setMatch(matches);
  }, [props.compact, props.searchFields, props.searchTerm, props.item]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles$3.globaSearchResultsItem,
    onClick: () => props.onClick(props.type, props.item)
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles$3.resultLabel} ${props.compact ? styles$3.compact : ''}`
  }, showTitle(props.item)), !props.compact && Object.keys(match).map(key => {
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: styles$3.resultMatches
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$3.matchLabel
    }, key), /*#__PURE__*/React.createElement("span", {
      className: styles$3.matchValue
    }, showValue(match[key])));
  }));
};

var css_248z$2 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-global-search-results-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-global-search-results-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-global-search-results-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-global-search-results-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-global-search-results-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-global-search-results-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-global-search-results-globalSearchResults {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: auto;\n}\n.athenaeum-global-search-results-globalSearchResults .athenaeum-global-search-results-noResults {\n  padding: 20px;\n  text-align: center;\n}\n.athenaeum-global-search-results-globalSearchResults .athenaeum-global-search-results-isLoading {\n  padding: 20px;\n  text-align: center;\n}\n.athenaeum-global-search-results-globalSearchResults .athenaeum-global-search-results-globalSearchResultsProvider .athenaeum-global-search-results-providerHeader {\n  color: white;\n  background: rgba(254, 80, 0, 0.9);\n  border-bottom: 1px solid rgba(234, 60, 0, 0.9);\n  padding: 5px 10px;\n  cursor: default;\n  display: flex;\n  justify-content: space-between;\n}\n.athenaeum-global-search-results-globalSearchResults .athenaeum-global-search-results-globalSearchResultsProvider .athenaeum-global-search-results-providerName {\n  margin-right: 8px;\n}\n.athenaeum-global-search-results-globalSearchResults .athenaeum-global-search-results-globalSearchResultsProvider .athenaeum-global-search-results-resultsCount {\n  border-radius: 10px;\n  background: rgb(234, 60, 0);\n  color: white;\n  padding: 0px 8px;\n  min-width: 32px;\n  text-align: center;\n}\n.athenaeum-global-search-results-globalSearchResults .athenaeum-global-search-results-globalSearchResultsProvider .athenaeum-global-search-results-providerResults {\n  display: flex;\n  flex-direction: column;\n}\n\n.athenaeum-global-search-results-moreResultsButton {\n  width: 100%;\n}";
var styles$2 = {"font-renta":"athenaeum-global-search-results-font-renta","color-schema-renta_black":"athenaeum-global-search-results-color-schema-renta_black","color-schema-renta_white":"athenaeum-global-search-results-color-schema-renta_white","color-schema-renta_orange":"athenaeum-global-search-results-color-schema-renta_orange","color-schema-renta_green":"athenaeum-global-search-results-color-schema-renta_green","color-schema-renta_blue":"athenaeum-global-search-results-color-schema-renta_blue","globalSearchResults":"athenaeum-global-search-results-globalSearchResults","noResults":"athenaeum-global-search-results-noResults","isLoading":"athenaeum-global-search-results-isLoading","globalSearchResultsProvider":"athenaeum-global-search-results-globalSearchResultsProvider","providerHeader":"athenaeum-global-search-results-providerHeader","providerName":"athenaeum-global-search-results-providerName","resultsCount":"athenaeum-global-search-results-resultsCount","providerResults":"athenaeum-global-search-results-providerResults","moreResultsButton":"athenaeum-global-search-results-moreResultsButton"};
styleInject(css_248z$2);

const GlobalSearchResults = props => {
  var _a, _b, _c;
  const [resultProviders, setResultProviders] = useState([]);
  const getProviderDetails = provider => {
    return props.searchProviders.find(searchProvider => searchProvider.id === provider);
  };
  const getProviderFields = provider => {
    var _a;
    return ((_a = props.searchProviders.find(searchProvider => searchProvider.id === provider)) === null || _a === void 0 ? void 0 : _a.searchFields) || [];
  };
  const handleItemClick = (type, item) => {
    props.onClicks(type, item);
  };
  const renderResultItem = (type, item, providerName, index) => {
    if (props.itemRenderer) {
      return props.itemRenderer(type, item);
    }
    return /*#__PURE__*/React.createElement(GlobalSearchResultsItem, {
      searchTerm: props.response.searchTerm,
      type: providerName,
      item: item,
      key: index,
      searchFields: getProviderFields(providerName),
      onClick: (type, item) => handleItemClick(type, item),
      compact: props.compact
    });
  };
  const buildProviderHeader = (provider, providerResults = []) => {
    var _a;
    const providerName = ((_a = getProviderDetails(provider)) === null || _a === void 0 ? void 0 : _a.name) || provider;
    if (props.showCount && props.resultsLimit) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$2.providerHeader
      }, /*#__PURE__*/React.createElement("span", {
        className: styles$2.providerName
      }, providerName), /*#__PURE__*/React.createElement("span", {
        className: styles$2.resultsCount
      }, `${Math.min(providerResults.length, props.resultsLimit)} /
                        ${providerResults.length}${props.response.resultsLimit === providerResults.length ? '+' : ''}`));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: styles$2.providerHeader
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$2.providerName
    }, providerName), props.showCount && /*#__PURE__*/React.createElement("span", {
      className: styles$2.resultsCount
    }, providerResults.length));
  };
  useEffect(() => {
    const newArray = new Array();
    props.searchProviders.map(provider => provider.id).forEach(key => {
      const value = props.response.results[key];
      if (Array.isArray(value) && value.length > 0) {
        newArray.push(key);
      }
    });
    setResultProviders(newArray);
  }, [props.response, props.searchProviders]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles$2.globalSearchResults
  }, props.isLoading && ( /*#__PURE__*/React.createElement("div", {
    className: styles$2.isLoading
  }, TopNavLocalizer$1.searchSearchingLabel, /*#__PURE__*/React.createElement(Spinner, {
    delay: 10
  }))), !props.isLoading && (!((_a = props.response) === null || _a === void 0 ? void 0 : _a.results) || resultProviders.length === 0) && ( /*#__PURE__*/React.createElement("div", {
    className: styles$2.noResults
  }, TopNavLocalizer$1.searchNoResultsLabel)), ((_b = props.response) === null || _b === void 0 ? void 0 : _b.results) && resultProviders.map(provider => {
    const providerResults = props.response.results[provider];
    return /*#__PURE__*/React.createElement("div", {
      key: provider,
      className: styles$2.globalSearchResultsProvider
    }, buildProviderHeader(provider, providerResults), /*#__PURE__*/React.createElement("div", {
      className: styles$2.providerResults
    }, providerResults === null || providerResults === void 0 ? void 0 : providerResults.slice(0, props.resultsLimit ? Math.min(props.resultsLimit, providerResults.length) : providerResults.length).map((item, index) => {
      return renderResultItem(provider, item, provider, index);
    })));
  }), ((_c = props.response) === null || _c === void 0 ? void 0 : _c.results) && resultProviders.length > 0 && props.onMoreClick && ( /*#__PURE__*/React.createElement("div", {
    className: styles$2.moreResults
  }, /*#__PURE__*/React.createElement(Button, {
    label: TopNavLocalizer$1.searchMoreLabel,
    onClick: () => __awaiter(void 0, void 0, void 0, function* () {
      if (props.onMoreClick) yield props.onMoreClick();
    }),
    type: ButtonType.Orange,
    className: styles$2.moreResultsButton
  }))));
};

class GlobalSearch extends BaseComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isOpen: false,
      isPreviewOpen: false
    };
  }
  dropdownToggleAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      this.setState({
        isOpen: !this.state.isOpen
      });
    });
  }
  onSearchButtonClickAsync(searchTerm, searchProviders) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      if (searchTerm.length >= 3) {
        const newContext = {
          searchTerm: searchTerm,
          searchProviders: searchProviders,
          resultsLimit: this.context.resultsLimit,
          // Use an existing value or a default
          results: this.context.results || {}
        };
        (_a = this.context) === null || _a === void 0 ? void 0 : _a.setContext(newContext);
        if (this.props.onSearch) {
          this.props.onSearch(searchTerm, searchProviders);
        }
        this.setState({
          isPreviewOpen: true
        });
      }
    });
  }
  onGlobalClick(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const outside = this.isClickedOutsideAsync(e, `.${styles$6.searchMainWrapper}`, true);
      if (outside) {
        this.setState({
          isOpen: false
        });
      }
    });
  }
  onClearClicked() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      const newContext = {
        searchTerm: "",
        searchProviders: [],
        resultsLimit: this.context.resultsLimit,
        // Use an existing value or a default
        results: this.context.results || {}
      };
      (_a = this.context) === null || _a === void 0 ? void 0 : _a.setContext(newContext);
      this.props.onSearchClear && this.props.onSearchClear();
    });
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$6.searchMainWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$6.mainIconWapper,
      onClick: event => __awaiter(this, void 0, void 0, function* () {
        return yield this.dropdownToggleAsync(event);
      })
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "search",
      size: IconSize.X2,
      "data-cy": "global-search-main-icon"
    })), this.state.isOpen && ( /*#__PURE__*/React.createElement("div", {
      className: Utility.css(styles$6.searchFormWrapper, this.state.isOpen && styles$6.dropdownOpen)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$6.scrollable
    }, /*#__PURE__*/React.createElement(DetailsOverlay, {
      mainContent: /*#__PURE__*/React.createElement(GlobalSearchForm, {
        searchPlaceHolder: this.props.searchPlaceHolder,
        searchProviders: (_a = this.context) === null || _a === void 0 ? void 0 : _a.searchOptions,
        searchTerm: (_b = this.context) === null || _b === void 0 ? void 0 : _b.searchTerm,
        selectedProviders: (_d = (_c = this.context) === null || _c === void 0 ? void 0 : _c.searchProviders) !== null && _d !== void 0 ? _d : [],
        onSearch: (searchTerm, providers) => __awaiter(this, void 0, void 0, function* () {
          return yield this.onSearchButtonClickAsync(searchTerm, providers);
        }),
        onClear: () => __awaiter(this, void 0, void 0, function* () {
          return this.onClearClicked();
        })
      }),
      overlayContent: /*#__PURE__*/React.createElement(GlobalSearchResults, {
        response: this.context,
        searchProviders: (_e = this.context) === null || _e === void 0 ? void 0 : _e.searchOptions,
        resultsLimit: this.props.previewResultsLimit,
        compact: true,
        showCount: true,
        isLoading: (_f = this.context) === null || _f === void 0 ? void 0 : _f.isLoading,
        onClicks: (type, item) => __awaiter(this, void 0, void 0, function* () {
          return this.props.onResultsItemClick && (yield this.props.onResultsItemClick(type, item));
        })
      }),
      overlayOpen: this.state.isPreviewOpen,
      onCloseClick: () => this.setState({
        isPreviewOpen: false
      })
    })), this.state.isPreviewOpen && ( /*#__PURE__*/React.createElement("div", {
      className: styles$6.footerButtons
    }, /*#__PURE__*/React.createElement(Button, {
      label: TopNavLocalizer$1.searchBack,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        return yield this.setState({
          isPreviewOpen: false
        });
      }),
      type: ButtonType.Orange,
      className: styles$6.backButton,
      icon: {
        name: "arrow-left",
        size: IconSize.Normal
      },
      "data-cy": "global-search-back-button"
    }), this.context.results && ((_h = Object.keys((_g = this.context) === null || _g === void 0 ? void 0 : _g.results)) !== null && _h !== void 0 ? _h : []).some(key => this.context.results[key] && this.context.results[key].length > 0) && ( /*#__PURE__*/React.createElement(Button, {
      label: TopNavLocalizer$1.searchMoreLabel,
      onClick: () => __awaiter(this, void 0, void 0, function* () {
        this.props.onResultsMoreClick && (yield this.props.onResultsMoreClick());
      }),
      type: ButtonType.Orange,
      className: styles$6.moreResultsButton,
      "data-cy": "global-search-more-results-button"
    })))))));
  }
}
GlobalSearch.contextType = GlobalSearchContext;

var css_248z$1 = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-tooltip-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-tooltip-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-tooltip-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-tooltip-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-tooltip-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-tooltip-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-tooltip-tooltipContainer {\n  position: relative;\n  display: inline-block;\n}\n\n/* Tooltip style including position */\n.athenaeum-tooltip-tooltip {\n  position: absolute;\n  background-color: rgb(255, 255, 255);\n  color: #333;\n  padding: 8px;\n  border-radius: 6px;\n  font-size: 14px;\n  white-space: nowrap;\n  width: max-content;\n  text-align: center;\n  pointer-events: none;\n  z-index: 100;\n  margin: 0;\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.25);\n}\n\n.athenaeum-tooltip-tooltipTop {\n  left: 50%;\n  bottom: calc(100% + 8px - 6px);\n  transform: translate(-50%, 0%);\n}\n\n.athenaeum-tooltip-tooltipBottom {\n  left: 50%;\n  top: calc(100% + 8px - 6px);\n  transform: translate(-50%, 0%);\n}\n\n.athenaeum-tooltip-tooltipRight {\n  top: 50%;\n  left: calc(100% + 8px - 6px);\n  transform: translate(0%, -50%);\n}\n\n.athenaeum-tooltip-tooltipLeft {\n  top: 50%;\n  right: calc(100% + 8px - 6px);\n  transform: translate(0%, -50%);\n}\n\n/* Tooltip arrow including position */\n.athenaeum-tooltip-tooltip::after, .athenaeum-tooltip-tooltip::before {\n  content: \" \";\n  position: absolute;\n  margin-left: -8px;\n  border-width: 8px;\n  border-style: solid;\n  border-color: transparent;\n}\n\n.athenaeum-tooltip-tooltipTop::after {\n  top: 100%;\n  left: 50%;\n  border-top-color: rgb(255, 255, 255);\n}\n\n.athenaeum-tooltip-tooltipBottom::before {\n  bottom: 100%;\n  left: 50%;\n  border-bottom-color: rgb(255, 255, 255);\n}\n\n.athenaeum-tooltip-tooltipRight::before {\n  top: calc(50% - 8px);\n  right: 100%;\n  border-right-color: rgb(255, 255, 255);\n}\n\n.athenaeum-tooltip-tooltipLeft::after {\n  top: calc(50% - 8px);\n  left: calc(100% + 8px);\n  border-left-color: rgb(255, 255, 255);\n}\n\n/* Tooltip box shift to the side leaving arrow in place */\n.athenaeum-tooltip-shiftTop {\n  transform: translateY(calc(-100% + 6px + 8px));\n}\n\n.athenaeum-tooltip-shiftBottom {\n  transform: translateY(calc(0% - 6px - 8px));\n}\n\n.athenaeum-tooltip-shiftRight {\n  transform: translateX(calc(0% - 6px - 8px));\n}\n\n.athenaeum-tooltip-shiftLeft {\n  transform: translateX(calc(-100% + 6px + 8px));\n}\n\n.athenaeum-tooltip-shiftTop::after, .athenaeum-tooltip-shiftTop::before {\n  top: calc(100% - 16px - 6px);\n}\n\n.athenaeum-tooltip-shiftBottom::after, .athenaeum-tooltip-shiftBottom::before {\n  top: 6px;\n}\n\n.athenaeum-tooltip-shiftRight::after, .athenaeum-tooltip-shiftRight::before {\n  left: 14px;\n}\n\n.athenaeum-tooltip-shiftLeft::after, .athenaeum-tooltip-shiftLeft::before {\n  left: calc(100% - 6px - 8px);\n}";
var styles$1 = {"font-renta":"athenaeum-tooltip-font-renta","color-schema-renta_black":"athenaeum-tooltip-color-schema-renta_black","color-schema-renta_white":"athenaeum-tooltip-color-schema-renta_white","color-schema-renta_orange":"athenaeum-tooltip-color-schema-renta_orange","color-schema-renta_green":"athenaeum-tooltip-color-schema-renta_green","color-schema-renta_blue":"athenaeum-tooltip-color-schema-renta_blue","tooltipContainer":"athenaeum-tooltip-tooltipContainer","tooltip":"athenaeum-tooltip-tooltip","tooltipTop":"athenaeum-tooltip-tooltipTop","tooltipBottom":"athenaeum-tooltip-tooltipBottom","tooltipRight":"athenaeum-tooltip-tooltipRight","tooltipLeft":"athenaeum-tooltip-tooltipLeft","shiftTop":"athenaeum-tooltip-shiftTop","shiftBottom":"athenaeum-tooltip-shiftBottom","shiftRight":"athenaeum-tooltip-shiftRight","shiftLeft":"athenaeum-tooltip-shiftLeft"};
styleInject(css_248z$1);

var TooltipPosition;
(function (TooltipPosition) {
  TooltipPosition["TOP"] = "top";
  TooltipPosition["BOTTOM"] = "bottom";
  TooltipPosition["LEFT"] = "left";
  TooltipPosition["RIGHT"] = "right";
})(TooltipPosition || (TooltipPosition = {}));
const PositionStyles = {
  [TooltipPosition.TOP]: styles$1.tooltipTop,
  [TooltipPosition.BOTTOM]: styles$1.tooltipBottom,
  [TooltipPosition.LEFT]: styles$1.tooltipLeft,
  [TooltipPosition.RIGHT]: styles$1.tooltipRight
};
const ShiftStyles = {
  [TooltipPosition.TOP]: styles$1.shiftTop,
  [TooltipPosition.BOTTOM]: styles$1.shiftBottom,
  [TooltipPosition.LEFT]: styles$1.shiftLeft,
  [TooltipPosition.RIGHT]: styles$1.shiftRight
};
const Tooltip = props => {
  var _a, _b;
  const [show, setShow] = useState(false);
  const getPositionStyle = () => {
    return props.position ? PositionStyles[props.position] : PositionStyles[TooltipPosition.BOTTOM];
  };
  const getShiftStyle = () => {
    if (props.position === TooltipPosition.BOTTOM || props.position === TooltipPosition.TOP) {
      return props.shift === TooltipPosition.LEFT || props.shift === TooltipPosition.RIGHT ? ShiftStyles[props.shift] : "";
    } else if (props.position === TooltipPosition.LEFT || props.position === TooltipPosition.RIGHT) {
      return props.shift === TooltipPosition.TOP || props.shift === TooltipPosition.BOTTOM ? ShiftStyles[props.shift] : "";
    }
    return "";
  };
  const handleMouseEnter = () => !props.disabled && setShow(true);
  const handleMouseLeave = () => setShow(false);
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles$1.tooltipContainer} ${(_a = props.className) !== null && _a !== void 0 ? _a : ''}`,
    onMouseEnter: () => handleMouseEnter(),
    onMouseLeave: () => handleMouseLeave()
  }, props.children, (show || props.forceOpen) &&
  /*#__PURE__*/
  // TODO: cosider using portals to render the tooltip outside of the current DOM hierarchy
  React.createElement("div", {
    className: `${styles$1.tooltip} ${getPositionStyle()} ${getShiftStyle()} ${(_b = props.tooltipClassName) !== null && _b !== void 0 ? _b : ''}`
  }, props.text || props.content));
};

var css_248z = "/* Breakpoints */\n/* Sizes */\n/* Colors */\n/* Hover colors */\n/* Shadows */\n/* Renta border */\n/* Transition */\n.athenaeum-tags-font-renta {\n  font-family: \"DINProMedium\";\n}\n\n.athenaeum-tags-color-schema-renta_black {\n  color: rgb(255, 255, 255);\n  background-color: rgb(65, 64, 66);\n}\n.athenaeum-tags-color-schema-renta_white {\n  color: #333;\n  background-color: rgb(255, 255, 255);\n}\n.athenaeum-tags-color-schema-renta_orange {\n  color: rgb(255, 255, 255);\n  background-color: rgb(234, 60, 0);\n}\n.athenaeum-tags-color-schema-renta_green {\n  color: rgb(255, 255, 255);\n  background-color: #33b77a;\n}\n.athenaeum-tags-color-schema-renta_blue {\n  color: rgb(255, 255, 255);\n  background-color: #337ab7;\n}\n\n.athenaeum-tags-tagsWrapper {\n  margin: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.athenaeum-tags-tagsWrapper .athenaeum-tags-label {\n  margin-bottom: 8px;\n}\n.athenaeum-tags-tagsWrapper .athenaeum-tags-tagsContainer {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: flex-start;\n  gap: 8px;\n}\n.athenaeum-tags-tagsWrapper .athenaeum-tags-tagContainer {\n  height: 32px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  background-color: rgb(234, 60, 0);\n  color: rgb(255, 255, 255);\n  cursor: pointer;\n  text-align: center;\n  line-height: 1;\n}\n.athenaeum-tags-tagsWrapper .athenaeum-tags-tagContainer:hover {\n  background-color: rgba(234, 60, 0, 0.9);\n}\n.athenaeum-tags-tagsWrapper .athenaeum-tags-tagContainer .athenaeum-tags-deleteButton {\n  width: 16px;\n  height: 16px;\n  margin-left: 8px;\n  padding: 0;\n  border-radius: 8px;\n  color: rgb(254, 198, 172);\n  font-size: 16px;\n  cursor: pointer;\n}\n.athenaeum-tags-tagsWrapper .athenaeum-tags-tagContainer .athenaeum-tags-deleteButton:hover {\n  color: rgb(255, 255, 255);\n}\n.athenaeum-tags-tagsWrapper .athenaeum-tags-addTagContainer {\n  display: flex;\n  flex-direction: column;\n}\n.athenaeum-tags-tagsWrapper .athenaeum-tags-addTagContainer .athenaeum-tags-addTagInput {\n  display: inline-block;\n  width: auto;\n  height: 32px;\n  border-radius: 6px 0 0 6px;\n  padding: 0 8px;\n}\n.athenaeum-tags-tagsWrapper .athenaeum-tags-addTagContainer .athenaeum-tags-submitButton {\n  border-radius: 0 6px 6px 0;\n}\n.athenaeum-tags-tagsWrapper .athenaeum-tags-addTagContainer .athenaeum-tags-addResultMessage {\n  color: #a94442;\n  clear: both;\n}\n.athenaeum-tags-tagsWrapper .athenaeum-tags-inlineAddTagContainer {\n  width: auto;\n}\n.athenaeum-tags-tagsWrapper .athenaeum-tags-blockAddTagContainer {\n  width: 100%;\n}";
var styles = {"font-renta":"athenaeum-tags-font-renta","color-schema-renta_black":"athenaeum-tags-color-schema-renta_black","color-schema-renta_white":"athenaeum-tags-color-schema-renta_white","color-schema-renta_orange":"athenaeum-tags-color-schema-renta_orange","color-schema-renta_green":"athenaeum-tags-color-schema-renta_green","color-schema-renta_blue":"athenaeum-tags-color-schema-renta_blue","tagsWrapper":"athenaeum-tags-tagsWrapper","label":"athenaeum-tags-label","tagsContainer":"athenaeum-tags-tagsContainer","tagContainer":"athenaeum-tags-tagContainer","deleteButton":"athenaeum-tags-deleteButton","addTagContainer":"athenaeum-tags-addTagContainer","addTagInput":"athenaeum-tags-addTagInput","submitButton":"athenaeum-tags-submitButton","addResultMessage":"athenaeum-tags-addResultMessage","inlineAddTagContainer":"athenaeum-tags-inlineAddTagContainer","blockAddTagContainer":"athenaeum-tags-blockAddTagContainer"};
styleInject(css_248z);

var InputActionResultType;
(function (InputActionResultType) {
  InputActionResultType["SUCCESS"] = "success";
  InputActionResultType["ERROR"] = "error";
  InputActionResultType["INVALID"] = "invalid";
})(InputActionResultType || (InputActionResultType = {}));
const Tags = props => {
  var _a, _b, _c, _d, _e, _f, _g;
  const [newTag, setNewTag] = useState(null);
  const [addOpen, setAddOpen] = useState(false);
  const [addResult, setAddResult] = useState({
    status: InputActionResultType.SUCCESS
  });
  const handleTagClick = (event, item) => {
    event.stopPropagation();
    if (props.onClick) props.onClick(item);
  };
  const handleTagDelete = (event, item) => {
    event.stopPropagation();
    if (props.onDelete) props.onDelete(item);
  };
  const handleGetTags = () => {
    if (props.onGetTags) props.onGetTags(props.items);
  };
  const handleAddClicked = () => __awaiter(void 0, void 0, void 0, function* () {
    if (newTag && props.onAdd) {
      const result = yield props.onAdd(newTag);
      if (result.status === InputActionResultType.SUCCESS) {
        setAddOpen(false);
        setNewTag(null);
        setAddResult(null);
      } else {
        setAddResult(result);
      }
    }
  });
  const handleInputKeys = event => {
    if (event.key === "Enter") {
      handleAddClicked();
    }
    if (event.key === "Escape") {
      setAddOpen(false);
      setNewTag(null);
      setAddResult(null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.tagsWrapper,
    id: (_a = props.id) !== null && _a !== void 0 ? _a : "tags"
  }, props.label && /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, props.label), /*#__PURE__*/React.createElement("div", {
    className: styles.tagsContainer
  }, props.onGetTags && /*#__PURE__*/React.createElement("span", {
    className: styles.tagContainer,
    "data-cy": "getTagsButton",
    onClick: () => handleGetTags(),
    title: (_c = (_b = props.localizations) === null || _b === void 0 ? void 0 : _b.copyTagsTitle) !== null && _c !== void 0 ? _c : "Copy Tags"
  }, /*#__PURE__*/React.createElement("i", {
    className: `fa fa-copy`
  })), props.items.map(item => {
    var _a, _b;
    return /*#__PURE__*/React.createElement("span", {
      className: styles.tagContainer,
      "data-cy": "tagItem",
      onClick: event => handleTagClick(event, item),
      key: item.label
    }, item.label, props.onDelete && /*#__PURE__*/React.createElement("i", {
      className: `fa fa-times ${styles.deleteButton}`,
      title: (_b = (_a = props.localizations) === null || _a === void 0 ? void 0 : _a.deleteTagTitle) !== null && _b !== void 0 ? _b : "Delete Tag",
      "data-cy": "deleteTagButton",
      onClick: event => handleTagDelete(event, item)
    }));
  }), props.onAdd && /*#__PURE__*/React.createElement(React.Fragment, null, addOpen && /*#__PURE__*/React.createElement("div", {
    className: `${styles.addTagContainer} ${props.inlineInput ? styles.inlineAddTagContainer : styles.blockAddTagContainer}`
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: `${styles.addTagInput} form-control `,
    "data-cy": "addTagInput",
    onChange: event => setNewTag(event.target.value),
    onKeyDown: event => handleInputKeys(event)
  }), /*#__PURE__*/React.createElement("span", {
    className: `${styles.tagContainer} ${styles.submitButton}`,
    title: (_e = (_d = props.localizations) === null || _d === void 0 ? void 0 : _d.submitAddNewTagTitle) !== null && _e !== void 0 ? _e : "Add new Tag",
    "data-cy": "submitAddTagButton",
    onClick: () => handleAddClicked()
  }, /*#__PURE__*/React.createElement("i", {
    className: `fa fa-plus`
  }))), addResult && (addResult.status === InputActionResultType.ERROR || addResult.status === InputActionResultType.INVALID) && /*#__PURE__*/React.createElement("span", {
    className: styles.addResultMessage,
    "data-cy": "addTaggErrorMessage"
  }, addResult === null || addResult === void 0 ? void 0 : addResult.message)), !addOpen && /*#__PURE__*/React.createElement("span", {
    className: styles.tagContainer,
    title: (_g = (_f = props.localizations) === null || _f === void 0 ? void 0 : _f.addNewTagTitle) !== null && _g !== void 0 ? _g : "Add new Tag",
    "data-cy": "addTagButton",
    onClick: () => setAddOpen(true)
  }, /*#__PURE__*/React.createElement("i", {
    className: `fa fa-plus`
  })))));
};

export { Accordion, AddressDivider, AddressDividerColumns, AddressHelper, AddressInput, Alert, AmountListItem, AthenaeumComponentsConstants, AutoSuggest, AutoSuggestItem, Badge, BaseExpandableWidget, BaseFileValidator, BaseInput, BaseInputWidget, BaseRegexValidator, BaseRegexValidatorErrorMessage, BaseRouteWidget, BaseValidator, BaseWidget, BaseWidgetContainer, BorderType, Button, ButtonAction, ButtonContainer, ButtonType, Carousel, CarouselNavigation, CarouselPagination, Cell, CellAction, CellActionComponent, CellModel, CellPaddingType, CheckHeaderCell, CheckStepWidget, Checkbox, CheckboxNullable, CheckboxWidget, ColorInput, ColumnAction, ColumnActionDefinition, ColumnActionType, ColumnDefinition, ColumnModel, ColumnSettings, ColumnSettingsDefinition, ColumnType, ConfirmationDialog, CookieConsent, CookieConsentType, DateInput, DateInputWidget, DateRangeInput, Description, DescriptionCellAction, DetailsOverlay, DocumentPreview, DocumentPreviewModal, Dropdown, DropdownAlign, DropdownCell, DropdownListItem, DropdownOrderBy, DropdownRequiredType, DropdownSchema, DropdownSelectType, DropdownSubtextType, DropdownType, DropdownVerticalAlign, DropdownWidget, EmailInput, EmailValidator, FileInput, FileSizeValidator, FileTypeValidator, FilesSizeValidator, FiveColumns, Footer, FooterAlternative, FooterLocalizer$1 as FooterLocalizer, Form, FourColumns, GlobalSearch, GlobalSearchContext, GlobalSearchForm, GlobalSearchResults, GoogleMap, Grid, GridHoveringType, GridModel, GridOddType, GridSelectableType, GridSpinner, GridTransformer, Hamburger, HeaderCell, Icon, IconSize, IconStyle, ImageInput, ImageModal, ImageProvider, Inline, InlineType, InputActionResultType, JustifyContent, LanguageDropdown, Layout, LeftNav, LengthValidator, Link, LinkWidget, List, LiveValidator, LocationPicker, LocationPickerModal, MessageBox, Modal, ModalPosition, ModalSize, NavigationWidget, NoSwipeNavigation, NumberInput, NumberInputBehaviour, NumberRangeValidator, NumberWidget, OneColumn, PageContainer, PageHeader, PageRow, Pagination, Panel, PanelCollapseType, PasswordForm, PasswordFormLocalizer$1 as PasswordFormLocalizer, PasswordFormType, PasswordInput, PasswordValidator, PhoneInput, PhoneValidator, Popover, QrInput, QrWidget, Range, RegexValidator, RequiredValidator, RouteWidget, Row, RowModel, Search, SelectListGroup, SelectListItem, SelectListSeparator, SignatureWidget, Slider, Spinner, StatusListItem, StepsWidget, Switch, SwitchNullable, SwitchWidget, Tab, TabContainer, TabContainerHeaderStyleType, TabContainerModel, TabHeader, TabModel, TabRenderType, TabTransformer, Tags, TextAreaInput, TextAreaWidget, TextInput, TextInputWidget, ThreeColumns, TimeWidget, Timeline, TimelineItemSelectionStatus, TitleWidget, TogglerPosition, ToolbarButton, ToolbarContainer, ToolbarRow, Tooltip, TooltipPosition, TopNav, TotalRow, TwoColumns, UrlInput, UrlValidator, ValidationRow, VirtualAddressDivider, WeekDaysEnum, WidgetContainer, WizardContainer, defaultTimelineHeaderFormats };
